var KB = Object.defineProperty, ZB = Object.defineProperties;
var qB = Object.getOwnPropertyDescriptors;
var Wv = Object.getOwnPropertySymbols;
var UT = Object.prototype.hasOwnProperty, VT = Object.prototype.propertyIsEnumerable;
var BT = (e, r, t) => r in e ? KB(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Xt = (e, r) => {
  for (var t in r || (r = {}))
    UT.call(r, t) && BT(e, t, r[t]);
  if (Wv)
    for (var t of Wv(r))
      VT.call(r, t) && BT(e, t, r[t]);
  return e;
}, wi = (e, r) => ZB(e, qB(r));
var Hv = (e, r) => {
  var t = {};
  for (var n in e)
    UT.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && Wv)
    for (var n of Wv(e))
      r.indexOf(n) < 0 && VT.call(e, n) && (t[n] = e[n]);
  return t;
};
var Xr = (e, r, t) => new Promise((n, a) => {
  var i = (c) => {
    try {
      u(t.next(c));
    } catch (f) {
      a(f);
    }
  }, l = (c) => {
    try {
      u(t.throw(c));
    } catch (f) {
      a(f);
    }
  }, u = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(i, l);
  u((t = t.apply(e, r)).next());
});
import * as I from "react";
import xo, { forwardRef as W0, useContext as zr, createContext as On, createElement as ji, Fragment as M2, useRef as Qe, useState as Ye, useMemo as Rt, useLayoutEffect as $O, useEffect as ar, useCallback as Ne, cloneElement as QB, Children as XB, isValidElement as JB, PureComponent as eU, useReducer as rU, useImperativeHandle as tU } from "react";
import nU from "react-dom";
var Ri = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function H0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var wO = { exports: {} }, Rf = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aU = xo, _O = 60103;
Rf.Fragment = 60107;
if (typeof Symbol == "function" && Symbol.for) {
  var WT = Symbol.for;
  _O = WT("react.element"), Rf.Fragment = WT("react.fragment");
}
var oU = aU.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, iU = Object.prototype.hasOwnProperty, sU = { key: !0, ref: !0, __self: !0, __source: !0 };
function TO(e, r, t) {
  var n, a = {}, i = null, l = null;
  t !== void 0 && (i = "" + t), r.key !== void 0 && (i = "" + r.key), r.ref !== void 0 && (l = r.ref);
  for (n in r)
    iU.call(r, n) && !sU.hasOwnProperty(n) && (a[n] = r[n]);
  if (e && e.defaultProps)
    for (n in r = e.defaultProps, r)
      a[n] === void 0 && (a[n] = r[n]);
  return { $$typeof: _O, type: e, key: i, ref: l, props: a, _owner: oU.current };
}
Rf.jsx = TO;
Rf.jsxs = TO;
wO.exports = Rf;
var T = wO.exports;
function lU(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function uU(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var cU = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(a) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, i), n.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? !0 : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(uU(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = lU(a);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch (l) {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Sn = "-ms-", Hp = "-moz-", Cr = "-webkit-", CO = "comm", R2 = "rule", P2 = "decl", dU = "@import", EO = "@keyframes", fU = "@layer", vU = Math.abs, G0 = String.fromCharCode, hU = Object.assign;
function pU(e, r) {
  return tn(e, 0) ^ 45 ? (((r << 2 ^ tn(e, 0)) << 2 ^ tn(e, 1)) << 2 ^ tn(e, 2)) << 2 ^ tn(e, 3) : 0;
}
function AO(e) {
  return e.trim();
}
function gU(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function Ar(e, r, t) {
  return e.replace(r, t);
}
function fS(e, r) {
  return e.indexOf(r);
}
function tn(e, r) {
  return e.charCodeAt(r) | 0;
}
function qd(e, r, t) {
  return e.slice(r, t);
}
function Ko(e) {
  return e.length;
}
function k2(e) {
  return e.length;
}
function Gv(e, r) {
  return r.push(e), e;
}
function mU(e, r) {
  return e.map(r).join("");
}
var Y0 = 1, vc = 1, IO = 0, Kn = 0, Pt = 0, wc = "";
function K0(e, r, t, n, a, i, l) {
  return { value: e, root: r, parent: t, type: n, props: a, children: i, line: Y0, column: vc, length: l, return: "" };
}
function ed(e, r) {
  return hU(K0("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function bU() {
  return Pt;
}
function yU() {
  return Pt = Kn > 0 ? tn(wc, --Kn) : 0, vc--, Pt === 10 && (vc = 1, Y0--), Pt;
}
function ha() {
  return Pt = Kn < IO ? tn(wc, Kn++) : 0, vc++, Pt === 10 && (vc = 1, Y0++), Pt;
}
function Jo() {
  return tn(wc, Kn);
}
function gp() {
  return Kn;
}
function Pf(e, r) {
  return qd(wc, e, r);
}
function Qd(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function OO(e) {
  return Y0 = vc = 1, IO = Ko(wc = e), Kn = 0, [];
}
function MO(e) {
  return wc = "", e;
}
function mp(e) {
  return AO(Pf(Kn - 1, vS(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function SU(e) {
  for (; (Pt = Jo()) && Pt < 33; )
    ha();
  return Qd(e) > 2 || Qd(Pt) > 3 ? "" : " ";
}
function xU(e, r) {
  for (; --r && ha() && !(Pt < 48 || Pt > 102 || Pt > 57 && Pt < 65 || Pt > 70 && Pt < 97); )
    ;
  return Pf(e, gp() + (r < 6 && Jo() == 32 && ha() == 32));
}
function vS(e) {
  for (; ha(); )
    switch (Pt) {
      case e:
        return Kn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && vS(Pt);
        break;
      case 40:
        e === 41 && vS(e);
        break;
      case 92:
        ha();
        break;
    }
  return Kn;
}
function $U(e, r) {
  for (; ha() && e + Pt !== 47 + 10; )
    if (e + Pt === 42 + 42 && Jo() === 47)
      break;
  return "/*" + Pf(r, Kn - 1) + "*" + G0(e === 47 ? e : ha());
}
function wU(e) {
  for (; !Qd(Jo()); )
    ha();
  return Pf(e, Kn);
}
function _U(e) {
  return MO(bp("", null, null, null, [""], e = OO(e), 0, [0], e));
}
function bp(e, r, t, n, a, i, l, u, c) {
  for (var f = 0, h = 0, p = l, g = 0, y = 0, S = 0, x = 1, _ = 1, A = 1, O = 0, P = "", j = a, k = i, L = n, M = P; _; )
    switch (S = O, O = ha()) {
      case 40:
        if (S != 108 && tn(M, p - 1) == 58) {
          fS(M += Ar(mp(O), "&", "&\f"), "&\f") != -1 && (A = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        M += mp(O);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        M += SU(S);
        break;
      case 92:
        M += xU(gp() - 1, 7);
        continue;
      case 47:
        switch (Jo()) {
          case 42:
          case 47:
            Gv(TU($U(ha(), gp()), r, t), c);
            break;
          default:
            M += "/";
        }
        break;
      case 123 * x:
        u[f++] = Ko(M) * A;
      case 125 * x:
      case 59:
      case 0:
        switch (O) {
          case 0:
          case 125:
            _ = 0;
          case 59 + h:
            A == -1 && (M = Ar(M, /\f/g, "")), y > 0 && Ko(M) - p && Gv(y > 32 ? GT(M + ";", n, t, p - 1) : GT(Ar(M, " ", "") + ";", n, t, p - 2), c);
            break;
          case 59:
            M += ";";
          default:
            if (Gv(L = HT(M, r, t, f, h, a, u, P, j = [], k = [], p), i), O === 123)
              if (h === 0)
                bp(M, r, L, L, j, i, p, u, k);
              else
                switch (g === 99 && tn(M, 3) === 110 ? 100 : g) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    bp(e, L, L, n && Gv(HT(e, L, L, 0, 0, a, u, P, a, j = [], p), k), a, k, p, u, n ? j : k);
                    break;
                  default:
                    bp(M, L, L, L, [""], k, 0, u, k);
                }
        }
        f = h = y = 0, x = A = 1, P = M = "", p = l;
        break;
      case 58:
        p = 1 + Ko(M), y = S;
      default:
        if (x < 1) {
          if (O == 123)
            --x;
          else if (O == 125 && x++ == 0 && yU() == 125)
            continue;
        }
        switch (M += G0(O), O * x) {
          case 38:
            A = h > 0 ? 1 : (M += "\f", -1);
            break;
          case 44:
            u[f++] = (Ko(M) - 1) * A, A = 1;
            break;
          case 64:
            Jo() === 45 && (M += mp(ha())), g = Jo(), h = p = Ko(P = M += wU(gp())), O++;
            break;
          case 45:
            S === 45 && Ko(M) == 2 && (x = 0);
        }
    }
  return i;
}
function HT(e, r, t, n, a, i, l, u, c, f, h) {
  for (var p = a - 1, g = a === 0 ? i : [""], y = k2(g), S = 0, x = 0, _ = 0; S < n; ++S)
    for (var A = 0, O = qd(e, p + 1, p = vU(x = l[S])), P = e; A < y; ++A)
      (P = AO(x > 0 ? g[A] + " " + O : Ar(O, /&\f/g, g[A]))) && (c[_++] = P);
  return K0(e, r, t, a === 0 ? R2 : u, c, f, h);
}
function TU(e, r, t) {
  return K0(e, r, t, CO, G0(bU()), qd(e, 2, -2), 0);
}
function GT(e, r, t, n) {
  return K0(e, r, t, P2, qd(e, 0, n), qd(e, n + 1, -1), n);
}
function rc(e, r) {
  for (var t = "", n = k2(e), a = 0; a < n; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function CU(e, r, t, n) {
  switch (e.type) {
    case fU:
      if (e.children.length)
        break;
    case dU:
    case P2:
      return e.return = e.return || e.value;
    case CO:
      return "";
    case EO:
      return e.return = e.value + "{" + rc(e.children, n) + "}";
    case R2:
      e.value = e.props.join(",");
  }
  return Ko(t = rc(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function EU(e) {
  var r = k2(e);
  return function(t, n, a, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](t, n, a, i) || "";
    return l;
  };
}
function AU(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
var YT = function(r) {
  var t = /* @__PURE__ */ new WeakMap();
  return function(n) {
    if (t.has(n))
      return t.get(n);
    var a = r(n);
    return t.set(n, a), a;
  };
};
function RO(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var IU = function(r, t, n) {
  for (var a = 0, i = 0; a = i, i = Jo(), a === 38 && i === 12 && (t[n] = 1), !Qd(i); )
    ha();
  return Pf(r, Kn);
}, OU = function(r, t) {
  var n = -1, a = 44;
  do
    switch (Qd(a)) {
      case 0:
        a === 38 && Jo() === 12 && (t[n] = 1), r[n] += IU(Kn - 1, t, n);
        break;
      case 2:
        r[n] += mp(a);
        break;
      case 4:
        if (a === 44) {
          r[++n] = Jo() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += G0(a);
    }
  while (a = ha());
  return r;
}, MU = function(r, t) {
  return MO(OU(OO(r), t));
}, KT = /* @__PURE__ */ new WeakMap(), RU = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, a = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !KT.get(n)) && !a) {
      KT.set(r, !0);
      for (var i = [], l = MU(t, i), u = n.props, c = 0, f = 0; c < l.length; c++)
        for (var h = 0; h < u.length; h++, f++)
          r.props[f] = i[c] ? l[c].replace(/&\f/g, u[h]) : u[h] + " " + l[c];
    }
  }
}, PU = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function PO(e, r) {
  switch (pU(e, r)) {
    case 5103:
      return Cr + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Cr + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Cr + e + Hp + e + Sn + e + e;
    case 6828:
    case 4268:
      return Cr + e + Sn + e + e;
    case 6165:
      return Cr + e + Sn + "flex-" + e + e;
    case 5187:
      return Cr + e + Ar(e, /(\w+).+(:[^]+)/, Cr + "box-$1$2" + Sn + "flex-$1$2") + e;
    case 5443:
      return Cr + e + Sn + "flex-item-" + Ar(e, /flex-|-self/, "") + e;
    case 4675:
      return Cr + e + Sn + "flex-line-pack" + Ar(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Cr + e + Sn + Ar(e, "shrink", "negative") + e;
    case 5292:
      return Cr + e + Sn + Ar(e, "basis", "preferred-size") + e;
    case 6060:
      return Cr + "box-" + Ar(e, "-grow", "") + Cr + e + Sn + Ar(e, "grow", "positive") + e;
    case 4554:
      return Cr + Ar(e, /([^-])(transform)/g, "$1" + Cr + "$2") + e;
    case 6187:
      return Ar(Ar(Ar(e, /(zoom-|grab)/, Cr + "$1"), /(image-set)/, Cr + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Ar(e, /(image-set\([^]*)/, Cr + "$1$`$1");
    case 4968:
      return Ar(Ar(e, /(.+:)(flex-)?(.*)/, Cr + "box-pack:$3" + Sn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Cr + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ar(e, /(.+)-inline(.+)/, Cr + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ko(e) - 1 - r > 6)
        switch (tn(e, r + 1)) {
          case 109:
            if (tn(e, r + 4) !== 45)
              break;
          case 102:
            return Ar(e, /(.+:)(.+)-([^]+)/, "$1" + Cr + "$2-$3$1" + Hp + (tn(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~fS(e, "stretch") ? PO(Ar(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (tn(e, r + 1) !== 115)
        break;
    case 6444:
      switch (tn(e, Ko(e) - 3 - (~fS(e, "!important") && 10))) {
        case 107:
          return Ar(e, ":", ":" + Cr) + e;
        case 101:
          return Ar(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Cr + (tn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Cr + "$2$3$1" + Sn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (tn(e, r + 11)) {
        case 114:
          return Cr + e + Sn + Ar(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Cr + e + Sn + Ar(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Cr + e + Sn + Ar(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Cr + e + Sn + e + e;
  }
  return e;
}
var kU = function(r, t, n, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case P2:
        r.return = PO(r.value, r.length);
        break;
      case EO:
        return rc([ed(r, {
          value: Ar(r.value, "@", "@" + Cr)
        })], a);
      case R2:
        if (r.length)
          return mU(r.props, function(i) {
            switch (gU(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return rc([ed(r, {
                  props: [Ar(i, /:(read-\w+)/, ":" + Hp + "$1")]
                })], a);
              case "::placeholder":
                return rc([ed(r, {
                  props: [Ar(i, /:(plac\w+)/, ":" + Cr + "input-$1")]
                }), ed(r, {
                  props: [Ar(i, /:(plac\w+)/, ":" + Hp + "$1")]
                }), ed(r, {
                  props: [Ar(i, /:(plac\w+)/, Sn + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, jU = [kU], DU = function(r) {
  var t = r.key;
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(x) {
      var _ = x.getAttribute("data-emotion");
      _.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || jU, i = {}, l, u = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(x) {
      for (var _ = x.getAttribute("data-emotion").split(" "), A = 1; A < _.length; A++)
        i[_[A]] = !0;
      u.push(x);
    }
  );
  var c, f = [RU, PU];
  {
    var h, p = [CU, AU(function(x) {
      h.insert(x);
    })], g = EU(f.concat(a, p)), y = function(_) {
      return rc(_U(_), g);
    };
    c = function(_, A, O, P) {
      h = O, y(_ ? _ + "{" + A.styles + "}" : A.styles), P && (S.inserted[A.name] = !0);
    };
  }
  var S = {
    key: t,
    sheet: new cU({
      key: t,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return S.sheet.hydrate(u), S;
};
function Gp() {
  return Gp = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Gp.apply(this, arguments);
}
var kO = { exports: {} }, Br = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gt = typeof Symbol == "function" && Symbol.for, j2 = Gt ? Symbol.for("react.element") : 60103, D2 = Gt ? Symbol.for("react.portal") : 60106, Z0 = Gt ? Symbol.for("react.fragment") : 60107, q0 = Gt ? Symbol.for("react.strict_mode") : 60108, Q0 = Gt ? Symbol.for("react.profiler") : 60114, X0 = Gt ? Symbol.for("react.provider") : 60109, J0 = Gt ? Symbol.for("react.context") : 60110, N2 = Gt ? Symbol.for("react.async_mode") : 60111, eg = Gt ? Symbol.for("react.concurrent_mode") : 60111, rg = Gt ? Symbol.for("react.forward_ref") : 60112, tg = Gt ? Symbol.for("react.suspense") : 60113, NU = Gt ? Symbol.for("react.suspense_list") : 60120, ng = Gt ? Symbol.for("react.memo") : 60115, ag = Gt ? Symbol.for("react.lazy") : 60116, LU = Gt ? Symbol.for("react.block") : 60121, FU = Gt ? Symbol.for("react.fundamental") : 60117, zU = Gt ? Symbol.for("react.responder") : 60118, BU = Gt ? Symbol.for("react.scope") : 60119;
function ba(e) {
  if (typeof e == "object" && e !== null) {
    var r = e.$$typeof;
    switch (r) {
      case j2:
        switch (e = e.type, e) {
          case N2:
          case eg:
          case Z0:
          case Q0:
          case q0:
          case tg:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case J0:
              case rg:
              case ag:
              case ng:
              case X0:
                return e;
              default:
                return r;
            }
        }
      case D2:
        return r;
    }
  }
}
function jO(e) {
  return ba(e) === eg;
}
Br.AsyncMode = N2;
Br.ConcurrentMode = eg;
Br.ContextConsumer = J0;
Br.ContextProvider = X0;
Br.Element = j2;
Br.ForwardRef = rg;
Br.Fragment = Z0;
Br.Lazy = ag;
Br.Memo = ng;
Br.Portal = D2;
Br.Profiler = Q0;
Br.StrictMode = q0;
Br.Suspense = tg;
Br.isAsyncMode = function(e) {
  return jO(e) || ba(e) === N2;
};
Br.isConcurrentMode = jO;
Br.isContextConsumer = function(e) {
  return ba(e) === J0;
};
Br.isContextProvider = function(e) {
  return ba(e) === X0;
};
Br.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === j2;
};
Br.isForwardRef = function(e) {
  return ba(e) === rg;
};
Br.isFragment = function(e) {
  return ba(e) === Z0;
};
Br.isLazy = function(e) {
  return ba(e) === ag;
};
Br.isMemo = function(e) {
  return ba(e) === ng;
};
Br.isPortal = function(e) {
  return ba(e) === D2;
};
Br.isProfiler = function(e) {
  return ba(e) === Q0;
};
Br.isStrictMode = function(e) {
  return ba(e) === q0;
};
Br.isSuspense = function(e) {
  return ba(e) === tg;
};
Br.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Z0 || e === eg || e === Q0 || e === q0 || e === tg || e === NU || typeof e == "object" && e !== null && (e.$$typeof === ag || e.$$typeof === ng || e.$$typeof === X0 || e.$$typeof === J0 || e.$$typeof === rg || e.$$typeof === FU || e.$$typeof === zU || e.$$typeof === BU || e.$$typeof === LU);
};
Br.typeOf = ba;
kO.exports = Br;
var UU = kO.exports, DO = UU, VU = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, WU = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, NO = {};
NO[DO.ForwardRef] = VU;
NO[DO.Memo] = WU;
var HU = !0;
function LO(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : n += a + " ";
  }), n;
}
var L2 = function(r, t, n) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  HU === !1) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, F2 = function(r, t, n) {
  L2(r, t, n);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + a : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function GU(e) {
  for (var r = 0, t, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var YU = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, KU = /[A-Z]|^ms/g, ZU = /_EMO_([^_]+?)_([^]*?)_EMO_/g, FO = function(r) {
  return r.charCodeAt(1) === 45;
}, ZT = function(r) {
  return r != null && typeof r != "boolean";
}, Ab = /* @__PURE__ */ RO(function(e) {
  return FO(e) ? e : e.replace(KU, "-$&").toLowerCase();
}), qT = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(ZU, function(n, a, i) {
          return Zo = {
            name: a,
            styles: i,
            next: Zo
          }, a;
        });
  }
  return YU[r] !== 1 && !FO(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function Xd(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0)
    return t;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Zo = {
          name: t.name,
          styles: t.styles,
          next: Zo
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Zo = {
              name: n.name,
              styles: n.styles,
              next: Zo
            }, n = n.next;
        var a = t.styles + ";";
        return a;
      }
      return qU(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = Zo, l = t(e);
        return Zo = i, Xd(e, r, l);
      }
      break;
    }
  }
  if (r == null)
    return t;
  var u = r[t];
  return u !== void 0 ? u : t;
}
function qU(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      n += Xd(e, r, t[a]) + ";";
  else
    for (var i in t) {
      var l = t[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? n += i + "{" + r[l] + "}" : ZT(l) && (n += Ab(i) + ":" + qT(i, l) + ";");
      else if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
        for (var u = 0; u < l.length; u++)
          ZT(l[u]) && (n += Ab(i) + ":" + qT(i, l[u]) + ";");
      else {
        var c = Xd(e, r, l);
        switch (i) {
          case "animation":
          case "animationName": {
            n += Ab(i) + ":" + c + ";";
            break;
          }
          default:
            n += i + "{" + c + "}";
        }
      }
    }
  return n;
}
var QT = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Zo, og = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, i = "";
  Zo = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (a = !1, i += Xd(n, t, l)) : i += l[0];
  for (var u = 1; u < r.length; u++)
    i += Xd(n, t, r[u]), a && (i += l[u]);
  QT.lastIndex = 0;
  for (var c = "", f; (f = QT.exec(i)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    f[1];
  var h = GU(i) + c;
  return {
    name: h,
    styles: i,
    next: Zo
  };
}, QU = function(r) {
  return r();
}, zO = I["useInsertionEffect"] ? I["useInsertionEffect"] : !1, BO = zO || QU, XT = zO || I.useLayoutEffect, ig = {}.hasOwnProperty, UO = /* @__PURE__ */ On(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ DU({
    key: "css"
  }) : null
);
UO.Provider;
var z2 = function(r) {
  return /* @__PURE__ */ W0(function(t, n) {
    var a = zr(UO);
    return r(t, a, n);
  });
}, ru = /* @__PURE__ */ On({}), XU = function(r, t) {
  if (typeof t == "function") {
    var n = t(r);
    return n;
  }
  return Gp({}, r, t);
}, JU = /* @__PURE__ */ YT(function(e) {
  return YT(function(r) {
    return XU(e, r);
  });
}), eV = function(r) {
  var t = zr(ru);
  return r.theme !== t && (t = JU(t)(r.theme)), /* @__PURE__ */ ji(ru.Provider, {
    value: t
  }, r.children);
}, hS = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", VO = function(r, t) {
  var n = {};
  for (var a in t)
    ig.call(t, a) && (n[a] = t[a]);
  return n[hS] = r, n;
}, rV = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  return L2(t, n, a), BO(function() {
    return F2(t, n, a);
  }), null;
}, WO = /* @__PURE__ */ z2(function(e, r, t) {
  var n = e.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var a = e[hS], i = [n], l = "";
  typeof e.className == "string" ? l = LO(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var u = og(i, void 0, zr(ru));
  l += r.key + "-" + u.name;
  var c = {};
  for (var f in e)
    ig.call(e, f) && f !== "css" && f !== hS && (c[f] = e[f]);
  return c.ref = t, c.className = l, /* @__PURE__ */ ji(M2, null, /* @__PURE__ */ ji(rV, {
    cache: r,
    serialized: u,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ ji(a, c));
}), B2 = /* @__PURE__ */ z2(function(e, r) {
  var t = e.styles, n = og([t], void 0, zr(ru)), a = Qe();
  return XT(function() {
    var i = r.key + "-global", l = new r.sheet.constructor({
      key: i,
      nonce: r.sheet.nonce,
      container: r.sheet.container,
      speedy: r.sheet.isSpeedy
    }), u = !1, c = document.querySelector('style[data-emotion="' + i + " " + n.name + '"]');
    return r.sheet.tags.length && (l.before = r.sheet.tags[0]), c !== null && (u = !0, c.setAttribute("data-emotion", i), l.hydrate([c])), a.current = [l, u], function() {
      l.flush();
    };
  }, [r]), XT(function() {
    var i = a.current, l = i[0], u = i[1];
    if (u) {
      i[1] = !1;
      return;
    }
    if (n.next !== void 0 && F2(r, n.next, !0), l.tags.length) {
      var c = l.tags[l.tags.length - 1].nextElementSibling;
      l.before = c, l.flush();
    }
    r.insert("", n, l, !1);
  }, [r, n.name]), null;
});
function tV() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return og(r);
}
var HO = function() {
  var r = tV.apply(void 0, arguments), t = "animation-" + r.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + r.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, nV = function() {
  return /* @__PURE__ */ I.createElement(B2, {
    styles: `
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        font-feature-settings: 'kern';
      }

      *,
      *::before,
      *::after {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
      }

      main {
        display: block;
      }

      hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      pre,
      code,
      kbd,
      samp {
        font-family: SFMono-Regular,  Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      b,
      strong {
        font-weight: bold;
      }

      small {
        font-size: 80%;
      }

      sub,
      sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      sub {
        bottom: -0.25em;
      }

      sup {
        top: -0.5em;
      }

      img {
        border-style: none;
      }

      button,
      input,
      optgroup,
      select,
      textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      button,
      input {
        overflow: visible;
      }

      button,
      select {
        text-transform: none;
      }

      button::-moz-focus-inner,
      [type="button"]::-moz-focus-inner,
      [type="reset"]::-moz-focus-inner,
      [type="submit"]::-moz-focus-inner {
        border-style: none;
        padding: 0;
      }

      fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      progress {
        vertical-align: baseline;
      }

      textarea {
        overflow: auto;
      }

      [type="checkbox"],
      [type="radio"] {
        box-sizing: border-box;
        padding: 0;
      }

      [type="number"]::-webkit-inner-spin-button,
      [type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      [type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      [type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      details {
        display: block;
      }

      summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      body,
      blockquote,
      dl,
      dd,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      hr,
      figure,
      p,
      pre {
        margin: 0;
      }

      button {
        background: transparent;
        padding: 0;
      }

      fieldset {
        margin: 0;
        padding: 0;
      }

      ol,
      ul {
        margin: 0;
        padding: 0;
      }

      textarea {
        resize: vertical;
      }

      button,
      [role="button"] {
        cursor: pointer;
      }

      button::-moz-focus-inner {
        border: 0 !important;
      }

      table {
        border-collapse: collapse;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: inherit;
        font-weight: inherit;
      }

      button,
      input,
      optgroup,
      select,
      textarea {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      img,
      svg,
      video,
      canvas,
      audio,
      iframe,
      embed,
      object {
        display: block;
      }

      img,
      video {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible] :focus:not([data-focus-visible-added]) {
        outline: none;
        box-shadow: none;
      }

      select::-ms-expand {
        display: none;
      }
    `
  });
}, aV = nV, Yp = { exports: {} };
Yp.exports;
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", a = 800, i = 16, l = 9007199254740991, u = "[object Arguments]", c = "[object Array]", f = "[object AsyncFunction]", h = "[object Boolean]", p = "[object Date]", g = "[object Error]", y = "[object Function]", S = "[object GeneratorFunction]", x = "[object Map]", _ = "[object Number]", A = "[object Null]", O = "[object Object]", P = "[object Proxy]", j = "[object RegExp]", k = "[object Set]", L = "[object String]", M = "[object Undefined]", W = "[object WeakMap]", Z = "[object ArrayBuffer]", oe = "[object DataView]", Ie = "[object Float32Array]", Te = "[object Float64Array]", Ee = "[object Int8Array]", Me = "[object Int16Array]", Fe = "[object Int32Array]", Ge = "[object Uint8Array]", ze = "[object Uint8ClampedArray]", le = "[object Uint16Array]", ce = "[object Uint32Array]", he = /[\\^$.*+?()[\]{}|]/g, be = /^\[object .+?Constructor\]$/, ye = /^(?:0|[1-9]\d*)$/, q = {};
  q[Ie] = q[Te] = q[Ee] = q[Me] = q[Fe] = q[Ge] = q[ze] = q[le] = q[ce] = !0, q[u] = q[c] = q[Z] = q[h] = q[oe] = q[p] = q[g] = q[y] = q[x] = q[_] = q[O] = q[j] = q[k] = q[L] = q[W] = !1;
  var ae = typeof Ri == "object" && Ri && Ri.Object === Object && Ri, ue = typeof self == "object" && self && self.Object === Object && self, $e = ae || ue || Function("return this")(), Ze = r && !r.nodeType && r, _e = Ze && !0 && e && !e.nodeType && e, or = _e && _e.exports === Ze, Yr = or && ae.process, mr = function() {
    try {
      var v = _e && _e.require && _e.require("util").types;
      return v || Yr && Yr.binding && Yr.binding("util");
    } catch (b) {
    }
  }(), rt = mr && mr.isTypedArray;
  function Je(v, b, $) {
    switch ($.length) {
      case 0:
        return v.call(b);
      case 1:
        return v.call(b, $[0]);
      case 2:
        return v.call(b, $[0], $[1]);
      case 3:
        return v.call(b, $[0], $[1], $[2]);
    }
    return v.apply(b, $);
  }
  function Ir(v, b) {
    for (var $ = -1, N = Array(v); ++$ < v; )
      N[$] = b($);
    return N;
  }
  function wt(v) {
    return function(b) {
      return v(b);
    };
  }
  function Kr(v, b) {
    return v == null ? void 0 : v[b];
  }
  function jr(v, b) {
    return function($) {
      return v(b($));
    };
  }
  var jt = Array.prototype, gt = Function.prototype, pr = Object.prototype, br = $e["__core-js_shared__"], G = gt.toString, te = pr.hasOwnProperty, Y = function() {
    var v = /[^.]+$/.exec(br && br.keys && br.keys.IE_PROTO || "");
    return v ? "Symbol(src)_1." + v : "";
  }(), Q = pr.toString, Ce = G.call(Object), me = RegExp(
    "^" + G.call(te).replace(he, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Re = or ? $e.Buffer : void 0, ur = $e.Symbol, Sr = $e.Uint8Array, lr = Re ? Re.allocUnsafe : void 0, ct = jr(Object.getPrototypeOf, Object), at = Object.create, mt = pr.propertyIsEnumerable, Ct = jt.splice, dr = ur ? ur.toStringTag : void 0, Zr = function() {
    try {
      var v = Nn(Object, "defineProperty");
      return v({}, "", {}), v;
    } catch (b) {
    }
  }(), cn = Re ? Re.isBuffer : void 0, dn = Math.max, Ka = Date.now, wn = Nn($e, "Map"), pe = Nn(Object, "create"), je = function() {
    function v() {
    }
    return function(b) {
      if (!qr(b))
        return {};
      if (at)
        return at(b);
      v.prototype = b;
      var $ = new v();
      return v.prototype = void 0, $;
    };
  }();
  function er(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Dt() {
    this.__data__ = pe ? pe(null) : {}, this.size = 0;
  }
  function ot(v) {
    var b = this.has(v) && delete this.__data__[v];
    return this.size -= b ? 1 : 0, b;
  }
  function Dn(v) {
    var b = this.__data__;
    if (pe) {
      var $ = b[v];
      return $ === n ? void 0 : $;
    }
    return te.call(b, v) ? b[v] : void 0;
  }
  function xe(v) {
    var b = this.__data__;
    return pe ? b[v] !== void 0 : te.call(b, v);
  }
  function Ae(v, b) {
    var $ = this.__data__;
    return this.size += this.has(v) ? 0 : 1, $[v] = pe && b === void 0 ? n : b, this;
  }
  er.prototype.clear = Dt, er.prototype.delete = ot, er.prototype.get = Dn, er.prototype.has = xe, er.prototype.set = Ae;
  function Se(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Pe() {
    this.__data__ = [], this.size = 0;
  }
  function rr(v) {
    var b = this.__data__, $ = Nt(b, v);
    if ($ < 0)
      return !1;
    var N = b.length - 1;
    return $ == N ? b.pop() : Ct.call(b, $, 1), --this.size, !0;
  }
  function Vr(v) {
    var b = this.__data__, $ = Nt(b, v);
    return $ < 0 ? void 0 : b[$][1];
  }
  function Zt(v) {
    return Nt(this.__data__, v) > -1;
  }
  function qt(v, b) {
    var $ = this.__data__, N = Nt($, v);
    return N < 0 ? (++this.size, $.push([v, b])) : $[N][1] = b, this;
  }
  Se.prototype.clear = Pe, Se.prototype.delete = rr, Se.prototype.get = Vr, Se.prototype.has = Zt, Se.prototype.set = qt;
  function Or(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Za() {
    this.size = 0, this.__data__ = {
      hash: new er(),
      map: new (wn || Se)(),
      string: new er()
    };
  }
  function Ys(v) {
    var b = hn(this, v).delete(v);
    return this.size -= b ? 1 : 0, b;
  }
  function Ks(v) {
    return hn(this, v).get(v);
  }
  function Zs(v) {
    return hn(this, v).has(v);
  }
  function qs(v, b) {
    var $ = hn(this, v), N = $.size;
    return $.set(v, b), this.size += $.size == N ? 0 : 1, this;
  }
  Or.prototype.clear = Za, Or.prototype.delete = Ys, Or.prototype.get = Ks, Or.prototype.has = Zs, Or.prototype.set = qs;
  function bt(v) {
    var b = this.__data__ = new Se(v);
    this.size = b.size;
  }
  function Qs() {
    this.__data__ = new Se(), this.size = 0;
  }
  function Xs(v) {
    var b = this.__data__, $ = b.delete(v);
    return this.size = b.size, $;
  }
  function Js(v) {
    return this.__data__.get(v);
  }
  function el(v) {
    return this.__data__.has(v);
  }
  function rl(v, b) {
    var $ = this.__data__;
    if ($ instanceof Se) {
      var N = $.__data__;
      if (!wn || N.length < t - 1)
        return N.push([v, b]), this.size = ++$.size, this;
      $ = this.__data__ = new Or(N);
    }
    return $.set(v, b), this.size = $.size, this;
  }
  bt.prototype.clear = Qs, bt.prototype.delete = Xs, bt.prototype.get = Js, bt.prototype.has = el, bt.prototype.set = rl;
  function tl(v, b) {
    var $ = ea(v), N = !$ && Jn(v), ie = !$ && !N && Oo(v), ve = !$ && !N && !ie && Ro(v), de = $ || N || ie || ve, ne = de ? Ir(v.length, String) : [], ge = ne.length;
    for (var tr in v)
      (b || te.call(v, tr)) && !(de && // Safari 9 has enumerable `arguments.length` in strict mode.
      (tr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ie && (tr == "offset" || tr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      ve && (tr == "buffer" || tr == "byteLength" || tr == "byteOffset") || // Skip index properties.
      Io(tr, ge))) && ne.push(tr);
    return ne;
  }
  function fn(v, b, $) {
    ($ !== void 0 && !pn(v[b], $) || $ === void 0 && !(b in v)) && Xn(v, b, $);
  }
  function nl(v, b, $) {
    var N = v[b];
    (!(te.call(v, b) && pn(N, $)) || $ === void 0 && !(b in v)) && Xn(v, b, $);
  }
  function Nt(v, b) {
    for (var $ = v.length; $--; )
      if (pn(v[$][0], b))
        return $;
    return -1;
  }
  function Xn(v, b, $) {
    b == "__proto__" && Zr ? Zr(v, b, {
      configurable: !0,
      enumerable: !0,
      value: $,
      writable: !0
    }) : v[b] = $;
  }
  var al = Zi();
  function vn(v) {
    return v == null ? v === void 0 ? M : A : dr && dr in Object(v) ? qi(v) : Ji(v);
  }
  function qa(v) {
    return Lt(v) && vn(v) == u;
  }
  function Vi(v) {
    if (!qr(v) || vi(v))
      return !1;
    var b = ra(v) ? me : be;
    return b.test(ts(v));
  }
  function Wi(v) {
    return Lt(v) && Mo(v.length) && !!q[vn(v)];
  }
  function ol(v) {
    if (!qr(v))
      return Xi(v);
    var b = _n(v), $ = [];
    for (var N in v)
      N == "constructor" && (b || !te.call(v, N)) || $.push(N);
    return $;
  }
  function Eo(v, b, $, N, ie) {
    v !== b && al(b, function(ve, de) {
      if (ie || (ie = new bt()), qr(ve))
        il(v, b, de, $, Eo, N, ie);
      else {
        var ne = N ? N(Ln(v, de), ve, de + "", v, b, ie) : void 0;
        ne === void 0 && (ne = ve), fn(v, de, ne);
      }
    }, Po);
  }
  function il(v, b, $, N, ie, ve, de) {
    var ne = Ln(v, $), ge = Ln(b, $), tr = de.get(ge);
    if (tr) {
      fn(v, $, tr);
      return;
    }
    var Ke = ve ? ve(ne, ge, $ + "", v, b, de) : void 0, Mr = Ke === void 0;
    if (Mr) {
      var zn = ea(ge), Bn = !zn && Oo(ge), Qa = !zn && !Bn && Ro(ge);
      Ke = ge, zn || Bn || Qa ? ea(ne) ? Ke = ne : cl(ne) ? Ke = ll(ne) : Bn ? (Mr = !1, Ke = Gi(ge, !0)) : Qa ? (Mr = !1, Ke = ci(ge, !0)) : Ke = [] : dl(ge) || Jn(ge) ? (Ke = ne, Jn(ne) ? Ke = fl(ne) : (!qr(ne) || ra(ne)) && (Ke = di(ge))) : Mr = !1;
    }
    Mr && (de.set(ge, Ke), ie(Ke, ge, N, ve, de), de.delete(ge)), fn(v, $, Ke);
  }
  function sl(v, b) {
    return es(ul(v, b, ko), v + "");
  }
  var Hi = Zr ? function(v, b) {
    return Zr(v, "toString", {
      configurable: !0,
      enumerable: !1,
      value: yr(b),
      writable: !0
    });
  } : ko;
  function Gi(v, b) {
    if (b)
      return v.slice();
    var $ = v.length, N = lr ? lr($) : new v.constructor($);
    return v.copy(N), N;
  }
  function Yi(v) {
    var b = new v.constructor(v.byteLength);
    return new Sr(b).set(new Sr(v)), b;
  }
  function ci(v, b) {
    var $ = b ? Yi(v.buffer) : v.buffer;
    return new v.constructor($, v.byteOffset, v.length);
  }
  function ll(v, b) {
    var $ = -1, N = v.length;
    for (b || (b = Array(N)); ++$ < N; )
      b[$] = v[$];
    return b;
  }
  function Ki(v, b, $, N) {
    var ie = !$;
    $ || ($ = {});
    for (var ve = -1, de = b.length; ++ve < de; ) {
      var ne = b[ve], ge = N ? N($[ne], v[ne], ne, $, v) : void 0;
      ge === void 0 && (ge = v[ne]), ie ? Xn($, ne, ge) : nl($, ne, ge);
    }
    return $;
  }
  function Ao(v) {
    return sl(function(b, $) {
      var N = -1, ie = $.length, ve = ie > 1 ? $[ie - 1] : void 0, de = ie > 2 ? $[2] : void 0;
      for (ve = v.length > 3 && typeof ve == "function" ? (ie--, ve) : void 0, de && Qi($[0], $[1], de) && (ve = ie < 3 ? void 0 : ve, ie = 1), b = Object(b); ++N < ie; ) {
        var ne = $[N];
        ne && v(b, ne, N, ve);
      }
      return b;
    });
  }
  function Zi(v) {
    return function(b, $, N) {
      for (var ie = -1, ve = Object(b), de = N(b), ne = de.length; ne--; ) {
        var ge = de[v ? ne : ++ie];
        if ($(ve[ge], ge, ve) === !1)
          break;
      }
      return b;
    };
  }
  function hn(v, b) {
    var $ = v.__data__;
    return fi(b) ? $[typeof b == "string" ? "string" : "hash"] : $.map;
  }
  function Nn(v, b) {
    var $ = Kr(v, b);
    return Vi($) ? $ : void 0;
  }
  function qi(v) {
    var b = te.call(v, dr), $ = v[dr];
    try {
      v[dr] = void 0;
      var N = !0;
    } catch (ve) {
    }
    var ie = Q.call(v);
    return N && (b ? v[dr] = $ : delete v[dr]), ie;
  }
  function di(v) {
    return typeof v.constructor == "function" && !_n(v) ? je(ct(v)) : {};
  }
  function Io(v, b) {
    var $ = typeof v;
    return b = b == null ? l : b, !!b && ($ == "number" || $ != "symbol" && ye.test(v)) && v > -1 && v % 1 == 0 && v < b;
  }
  function Qi(v, b, $) {
    if (!qr($))
      return !1;
    var N = typeof b;
    return (N == "number" ? Fn($) && Io(b, $.length) : N == "string" && b in $) ? pn($[b], v) : !1;
  }
  function fi(v) {
    var b = typeof v;
    return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? v !== "__proto__" : v === null;
  }
  function vi(v) {
    return !!Y && Y in v;
  }
  function _n(v) {
    var b = v && v.constructor, $ = typeof b == "function" && b.prototype || pr;
    return v === $;
  }
  function Xi(v) {
    var b = [];
    if (v != null)
      for (var $ in Object(v))
        b.push($);
    return b;
  }
  function Ji(v) {
    return Q.call(v);
  }
  function ul(v, b, $) {
    return b = dn(b === void 0 ? v.length - 1 : b, 0), function() {
      for (var N = arguments, ie = -1, ve = dn(N.length - b, 0), de = Array(ve); ++ie < ve; )
        de[ie] = N[b + ie];
      ie = -1;
      for (var ne = Array(b + 1); ++ie < b; )
        ne[ie] = N[ie];
      return ne[b] = $(de), Je(v, this, ne);
    };
  }
  function Ln(v, b) {
    if (!(b === "constructor" && typeof v[b] == "function") && b != "__proto__")
      return v[b];
  }
  var es = rs(Hi);
  function rs(v) {
    var b = 0, $ = 0;
    return function() {
      var N = Ka(), ie = i - (N - $);
      if ($ = N, ie > 0) {
        if (++b >= a)
          return arguments[0];
      } else
        b = 0;
      return v.apply(void 0, arguments);
    };
  }
  function ts(v) {
    if (v != null) {
      try {
        return G.call(v);
      } catch (b) {
      }
      try {
        return v + "";
      } catch (b) {
      }
    }
    return "";
  }
  function pn(v, b) {
    return v === b || v !== v && b !== b;
  }
  var Jn = qa(function() {
    return arguments;
  }()) ? qa : function(v) {
    return Lt(v) && te.call(v, "callee") && !mt.call(v, "callee");
  }, ea = Array.isArray;
  function Fn(v) {
    return v != null && Mo(v.length) && !ra(v);
  }
  function cl(v) {
    return Lt(v) && Fn(v);
  }
  var Oo = cn || vl;
  function ra(v) {
    if (!qr(v))
      return !1;
    var b = vn(v);
    return b == y || b == S || b == f || b == P;
  }
  function Mo(v) {
    return typeof v == "number" && v > -1 && v % 1 == 0 && v <= l;
  }
  function qr(v) {
    var b = typeof v;
    return v != null && (b == "object" || b == "function");
  }
  function Lt(v) {
    return v != null && typeof v == "object";
  }
  function dl(v) {
    if (!Lt(v) || vn(v) != O)
      return !1;
    var b = ct(v);
    if (b === null)
      return !0;
    var $ = te.call(b, "constructor") && b.constructor;
    return typeof $ == "function" && $ instanceof $ && G.call($) == Ce;
  }
  var Ro = rt ? wt(rt) : Wi;
  function fl(v) {
    return Ki(v, Po(v));
  }
  function Po(v) {
    return Fn(v) ? tl(v, !0) : ol(v);
  }
  var xr = Ao(function(v, b, $, N) {
    Eo(v, b, $, N);
  });
  function yr(v) {
    return function() {
      return v;
    };
  }
  function ko(v) {
    return v;
  }
  function vl() {
    return !1;
  }
  e.exports = xr;
})(Yp, Yp.exports);
var oV = Yp.exports;
const Fa = /* @__PURE__ */ H0(oV);
function iV(e) {
  var r = e == null ? 0 : e.length;
  return r ? e[r - 1] : void 0;
}
function _d(e) {
  return typeof e == "number";
}
function U2(e) {
  return Array.isArray(e);
}
function Wu(e) {
  return typeof e == "function";
}
function In(e) {
  var r = typeof e;
  return e != null && (r === "object" || r === "function") && !U2(e);
}
function sV(e) {
  return In(e) && Object.keys(e).length === 0;
}
function V2(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function GO(e) {
  return /^var\(--.+\)$/.test(e);
}
var lV = !1;
function YO(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    r.includes(n) || (t[n] = e[n]);
  }), t;
}
function uV(e, r) {
  var t = {};
  return r.forEach(function(n) {
    n in e && (t[n] = e[n]);
  }), t;
}
function cV(e, r, t, n) {
  var a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var dV = function(r) {
  var t = /* @__PURE__ */ new WeakMap(), n = function(i, l, u, c) {
    if (typeof i == "undefined")
      return r(i, l, u);
    t.has(i) || t.set(i, /* @__PURE__ */ new Map());
    var f = t.get(i);
    if (f.has(l))
      return f.get(l);
    var h = r(i, l, u, c);
    return f.set(l, h), h;
  };
  return n;
}, sg = dV(cV);
function KO(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var a = e[n], i = r(a, n, e);
    i && (t[n] = a);
  }), t;
}
var W2 = function(r) {
  return KO(r, function(t) {
    return t != null;
  });
}, H2 = function(r) {
  return Object.keys(r);
}, Jd = function(r) {
  return r.reduce(function(t, n) {
    var a = n[0], i = n[1];
    return t[a] = i, t;
  }, {});
};
function fV(e) {
  var r = parseFloat(e.toString()), t = e.toString().replace(String(r), "");
  return {
    unitless: !t,
    value: r,
    unit: t
  };
}
function pS(e) {
  if (e == null)
    return e;
  var r = fV(e), t = r.unitless;
  return t || _d(e) ? e + "px" : e;
}
var ZO = function(r, t) {
  return parseInt(r[1], 10) > parseInt(t[1], 10) ? 1 : -1;
}, G2 = function(r) {
  return Jd(Object.entries(r).sort(ZO));
};
function JT(e) {
  var r = G2(e);
  return Object.assign(Object.values(r), r);
}
function vV(e) {
  var r = Object.keys(G2(e));
  return new Set(r);
}
function hV(e) {
  var r;
  if (!e)
    return e;
  e = (r = pS(e)) != null ? r : e;
  var t = e.endsWith("px") ? -1 : (
    // the equivalent of 1px in em using a 16px base
    -0.0635
  );
  return _d(e) ? "" + (e + t) : e.replace(/([0-9]+\.?[0-9]*)/, function(n) {
    return "" + (parseFloat(n) + t);
  });
}
function Yv(e, r) {
  var t = ["@media screen"];
  return e && t.push("and", "(min-width: " + pS(e) + ")"), r && t.push("and", "(max-width: " + pS(r) + ")"), t.join(" ");
}
function pV(e) {
  var r;
  if (!e)
    return null;
  e.base = (r = e.base) != null ? r : "0px";
  var t = JT(e), n = Object.entries(e).sort(ZO).map(function(l, u, c) {
    var f, h = l[0], p = l[1], g = (f = c[u + 1]) != null ? f : [], y = g[1];
    return y = parseFloat(y) > 0 ? hV(y) : void 0, {
      breakpoint: h,
      minW: p,
      maxW: y,
      maxWQuery: Yv(null, y),
      minWQuery: Yv(p),
      minMaxQuery: Yv(p, y)
    };
  }), a = vV(e), i = Array.from(a.values());
  return {
    keys: a,
    normalized: t,
    isResponsive: function(u) {
      var c = Object.keys(u);
      return c.length > 0 && c.every(function(f) {
        return a.has(f);
      });
    },
    asObject: G2(e),
    asArray: JT(e),
    details: n,
    media: [null].concat(t.map(function(l) {
      return Yv(l);
    }).slice(1)),
    toArrayValue: function(u) {
      if (!In(u))
        throw new Error("toArrayValue: value must be an object");
      for (var c = i.map(function(f) {
        var h;
        return (h = u[f]) != null ? h : null;
      }); iV(c) === null; )
        c.pop();
      return c;
    },
    toObjectValue: function(u) {
      if (!Array.isArray(u))
        throw new Error("toObjectValue: value must be an array");
      return u.reduce(function(c, f, h) {
        var p = i[h];
        return p != null && f != null && (c[p] = f), c;
      }, {});
    }
  };
}
function gV() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
var _c = gV(), eC = function(r) {
  return r ? "" : void 0;
}, Ib = function(r) {
  return r ? !0 : void 0;
}, Va = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return t.filter(Boolean).join(" ");
};
function Xo(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return Wu(e) ? e.apply(void 0, t) : e;
}
function rC() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(a) {
    r.some(function(i) {
      return i == null || i(a), a == null ? void 0 : a.defaultPrevented;
    });
  };
}
function mV(e) {
  var r;
  return function() {
    if (e) {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      r = e.apply(this, a), e = null;
    }
    return r;
  };
}
var ef = function() {
}, bV = mV(function(e) {
  return function() {
    var r = e.condition, t = e.message;
    r && lV && console.warn(t);
  };
}), yV = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return function(a) {
    return t.reduce(function(i, l) {
      return l(i);
    }, a);
  };
};
function gS(e, r) {
  return r === void 0 && (r = 1 / 0), !In(e) && !Array.isArray(e) || !r ? e : Object.entries(e).reduce(function(t, n) {
    var a = n[0], i = n[1];
    return In(i) || U2(i) ? Object.entries(gS(i, r - 1)).forEach(function(l) {
      var u = l[0], c = l[1];
      t[a + "." + u] = c;
    }) : t[a] = i, t;
  }, {});
}
function qO(e, r) {
  return U2(e) ? e.map(function(t) {
    return t === null ? null : r(t);
  }) : In(e) ? H2(e).reduce(function(t, n) {
    return t[n] = r(e[n]), t;
  }, {}) : e != null ? r(e) : null;
}
function Tc(e) {
  e === void 0 && (e = {});
  var r = e, t = r.strict, n = t === void 0 ? !0 : t, a = r.errorMessage, i = a === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : a, l = r.name, u = /* @__PURE__ */ I.createContext(void 0);
  u.displayName = l;
  function c() {
    var f = I.useContext(u);
    if (!f && n) {
      var h = new Error(i);
      throw h.name = "ContextError", Error.captureStackTrace == null || Error.captureStackTrace(h, c), h;
    }
    return f;
  }
  return [u.Provider, c, u];
}
function SV(e) {
  return I.Children.toArray(e).filter(function(r) {
    return /* @__PURE__ */ I.isValidElement(r);
  });
}
var xV = {
  current: 1
}, $V = /* @__PURE__ */ I.createContext(xV), wV = /* @__PURE__ */ I.memo(function(e) {
  var r = e.children;
  return /* @__PURE__ */ I.createElement($V.Provider, {
    value: {
      current: 1
    }
  }, r);
});
function _V(e, r) {
  if (e != null) {
    if (typeof e == "function") {
      e(r);
      return;
    }
    try {
      e.current = r;
    } catch (t) {
      throw new Error("Cannot assign value '" + r + "' to ref '" + e + "'");
    }
  }
}
function TV() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return I.useMemo(function() {
    return r.every(function(n) {
      return n == null;
    }) ? null : function(n) {
      r.forEach(function(a) {
        a && _V(a, n);
      });
    };
  }, r);
}
var CV = Tc({
  strict: !1,
  name: "PortalManagerContext"
}), EV = CV[0];
function AV(e) {
  var r = e.children, t = e.zIndex;
  return /* @__PURE__ */ I.createElement(EV, {
    value: {
      zIndex: t
    }
  }, r);
}
Tc({
  strict: !1,
  name: "PortalContext"
});
var IV = {
  body: {
    classList: {
      add: function() {
      },
      remove: function() {
      }
    }
  },
  addEventListener: function() {
  },
  removeEventListener: function() {
  },
  activeElement: {
    blur: function() {
    },
    nodeName: ""
  },
  querySelector: function() {
    return null;
  },
  querySelectorAll: function() {
    return [];
  },
  getElementById: function() {
    return null;
  },
  createEvent: function() {
    return {
      initEvent: function() {
      }
    };
  },
  createElement: function() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function() {
      },
      getElementsByTagName: function() {
        return [];
      }
    };
  }
}, QO = IV, Iu = function() {
}, OV = {
  document: QO,
  navigator: {
    userAgent: ""
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener: Iu,
  removeEventListener: Iu,
  getComputedStyle: function() {
    return {
      getPropertyValue: function() {
        return "";
      }
    };
  },
  matchMedia: function() {
    return {
      matches: !1,
      addListener: Iu,
      removeListener: Iu
    };
  },
  requestAnimationFrame: function(r) {
    return typeof setTimeout == "undefined" ? (r(), null) : setTimeout(r, 0);
  },
  cancelAnimationFrame: function(r) {
    typeof setTimeout != "undefined" && clearTimeout(r);
  },
  setTimeout: function() {
    return 0;
  },
  clearTimeout: Iu,
  setInterval: function() {
    return 0;
  },
  clearInterval: Iu
}, MV = OV, RV = {
  window: MV,
  document: QO
}, XO = _c ? {
  window,
  document
} : RV, JO = /* @__PURE__ */ On(XO);
function eM() {
  return zr(JO);
}
function PV(e) {
  var r = e.children, t = e.environment, n = Ye(null), a = n[0], i = n[1], l = Rt(function() {
    var c, f = a == null ? void 0 : a.ownerDocument, h = a == null ? void 0 : a.ownerDocument.defaultView, p = f ? {
      document: f,
      window: h
    } : void 0, g = (c = t != null ? t : p) != null ? c : XO;
    return g;
  }, [a, t]), u = !a && !t;
  return /* @__PURE__ */ xo.createElement(JO.Provider, {
    value: l
  }, r, u && /* @__PURE__ */ xo.createElement("span", {
    ref: function(f) {
      f && i(f);
    }
  }));
}
var Kv = {
  light: "chakra-ui-light",
  dark: "chakra-ui-dark"
}, kV = {
  classList: {
    add: ef,
    remove: ef
  }
}, jV = function(r) {
  return _c ? r.body : kV;
};
function DV(e, r) {
  var t = jV(r);
  t.classList.add(e ? Kv.dark : Kv.light), t.classList.remove(e ? Kv.light : Kv.dark);
}
function NV(e) {
  var r = window.matchMedia == null ? void 0 : window.matchMedia(e);
  if (r)
    return !!r.media === r.matches;
}
var rM = {
  light: "(prefers-color-scheme: light)",
  dark: "(prefers-color-scheme: dark)"
};
function LV(e) {
  var r, t = (r = NV(rM.dark)) != null ? r : e === "dark";
  return t ? "dark" : "light";
}
function FV(e) {
  if (!("matchMedia" in window))
    return ef;
  var r = window.matchMedia(rM.dark), t = function() {
    e(r.matches ? "dark" : "light", !0);
  };
  return r.addEventListener("change", t), function() {
    r.removeEventListener("change", t);
  };
}
var tC = {
  get: function() {
    return document.documentElement.style.getPropertyValue("--chakra-ui-color-mode") || document.documentElement.dataset.theme;
  },
  set: function(r) {
    _c && (document.documentElement.style.setProperty("--chakra-ui-color-mode", r), document.documentElement.setAttribute("data-theme", r));
  }
}, nC = function() {
  return typeof Storage != "undefined";
}, aC = "chakra-ui-color-mode", zV = {
  get: function(r) {
    if (!nC())
      return r;
    try {
      var t = localStorage.getItem(aC);
      return t != null ? t : r;
    } catch (n) {
      return r;
    }
  },
  set: function(r) {
    if (nC())
      try {
        localStorage.setItem(aC, r);
      } catch (t) {
      }
  },
  type: "localStorage"
}, tM = /* @__PURE__ */ I.createContext({}), nM = function() {
  var r = I.useContext(tM);
  if (r === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return r;
};
function BV(e) {
  var r = e.value, t = e.children, n = e.options, a = n.useSystemColorMode, i = n.initialColorMode, l = e.colorModeManager, u = l === void 0 ? zV : l, c = i === "dark" ? "dark" : "light", f = I.useState(u.type === "cookie" ? u.get(c) : c), h = f[0], p = f[1], g = eM(), y = g.document;
  I.useEffect(function() {
    if (_c && u.type === "localStorage") {
      var A = LV(c);
      if (a)
        return p(A);
      var O = tC.get(), P = u.get();
      return p(O || P || (i === "system" ? A : c));
    }
  }, [u, a, c, i]), I.useEffect(function() {
    var A = h === "dark";
    DV(A, y), tC.set(A ? "dark" : "light");
  }, [h, y]);
  var S = I.useCallback(function(A, O) {
    if (O === void 0 && (O = !1), !O)
      u.set(A);
    else if (u.get() && !a)
      return;
    p(A);
  }, [u, a]), x = I.useCallback(function() {
    S(h === "light" ? "dark" : "light");
  }, [h, S]);
  I.useEffect(function() {
    var A = a || i === "system", O;
    return A && (O = FV(S)), function() {
      O && A && O();
    };
  }, [S, a, i]);
  var _ = I.useMemo(function() {
    return {
      colorMode: r != null ? r : h,
      toggleColorMode: r ? ef : x,
      setColorMode: r ? ef : S
    };
  }, [h, S, x, r]);
  return /* @__PURE__ */ I.createElement(tM.Provider, {
    value: _
  }, t);
}
function rf() {
  return rf = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, rf.apply(this, arguments);
}
var UV = function(r, t) {
  return function(n) {
    var a = String(t), i = r ? r + "." + a : a;
    return In(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  };
};
function tf(e) {
  var r = e.scale, t = e.transform, n = e.compose, a = function(l, u) {
    var c, f = UV(r, l)(u), h = (c = t == null ? void 0 : t(f, u)) != null ? c : f;
    return n && (h = n(h, u)), h;
  };
  return a;
}
function to(e, r) {
  return function(t) {
    var n = {
      property: t,
      scale: e
    };
    return n.transform = tf({
      scale: e,
      transform: r
    }), n;
  };
}
var VV = function(r) {
  var t = r.rtl, n = r.ltr;
  return function(a) {
    return a.direction === "rtl" ? t : n;
  };
};
function WV(e) {
  var r = e.property, t = e.scale, n = e.transform;
  return {
    scale: t,
    property: VV(r),
    transform: t ? tf({
      scale: t,
      compose: n
    }) : n
  };
}
var Ob, Mb, aM = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function HV() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(aM).join(" ");
}
function GV() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(aM).join(" ");
}
var YV = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
}, KV = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function ZV(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var qV = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, oM = "& > :not(style) ~ :not(style)", QV = (Ob = {}, Ob[oM] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, Ob), XV = (Mb = {}, Mb[oM] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, Mb);
function Kp(e, r) {
  return Kp = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, Kp(e, r);
}
function JV(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), r && Kp(e, r);
}
function mS() {
  mS = function(a, i) {
    return new t(a, void 0, i);
  };
  var e = RegExp.prototype, r = /* @__PURE__ */ new WeakMap();
  function t(a, i, l) {
    var u = new RegExp(a, i);
    return r.set(u, l || r.get(a)), Kp(u, t.prototype);
  }
  JV(t, RegExp), t.prototype.exec = function(a) {
    var i = e.exec.call(this, a);
    return i && (i.groups = n(i, this)), i;
  }, t.prototype[Symbol.replace] = function(a, i) {
    if (typeof i == "string") {
      var l = r.get(this);
      return e[Symbol.replace].call(this, a, i.replace(/\$<([^>]+)>/g, function(c, f) {
        return "$" + l[f];
      }));
    } else if (typeof i == "function") {
      var u = this;
      return e[Symbol.replace].call(this, a, function() {
        var c = arguments;
        return typeof c[c.length - 1] != "object" && (c = [].slice.call(c), c.push(n(c, u))), i.apply(this, c);
      });
    } else
      return e[Symbol.replace].call(this, a, i);
  };
  function n(a, i) {
    var l = r.get(i);
    return Object.keys(l).reduce(function(u, c) {
      return u[c] = a[l[c]], u;
    }, /* @__PURE__ */ Object.create(null));
  }
  return mS.apply(this, arguments);
}
var bS = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, eW = new Set(Object.values(bS)), iM = /* @__PURE__ */ new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]), rW = function(r) {
  return r.trim();
};
function tW(e, r) {
  var t, n;
  if (e == null || iM.has(e))
    return e;
  var a = /* @__PURE__ */ mS(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  }), i = (t = (n = a.exec(e)) == null ? void 0 : n.groups) != null ? t : {}, l = i.type, u = i.values;
  if (!l || !u)
    return e;
  var c = l.includes("-gradient") ? l : l + "-gradient", f = u.split(",").map(rW).filter(Boolean), h = f[0], p = f.slice(1);
  if ((p == null ? void 0 : p.length) === 0)
    return e;
  var g = h in bS ? bS[h] : h;
  p.unshift(g);
  var y = p.map(function(S) {
    if (eW.has(S))
      return S;
    var x = S.indexOf(" "), _ = x !== -1 ? [S.substr(0, x), S.substr(x + 1)] : [S], A = _[0], O = _[1], P = sM(O) ? O : O && O.split(" "), j = "colors." + A, k = j in r.__cssMap ? r.__cssMap[j].varRef : A;
    return P ? [k].concat(Array.isArray(P) ? P : [P]).join(" ") : k;
  });
  return c + "(" + y.join(", ") + ")";
}
var sM = function(r) {
  return V2(r) && r.includes("(") && r.includes(")");
}, nW = function(r, t) {
  return tW(r, t != null ? t : {});
}, aW = function(r) {
  var t = parseFloat(r.toString()), n = r.toString().replace(String(t), "");
  return {
    unitless: !n,
    value: t,
    unit: n
  };
}, Lo = function(r) {
  return function(t) {
    return r + "(" + t + ")";
  };
}, Nr = {
  filter: function(r) {
    return r !== "auto" ? r : YV;
  },
  backdropFilter: function(r) {
    return r !== "auto" ? r : KV;
  },
  ring: function(r) {
    return ZV(Nr.px(r));
  },
  bgClip: function(r) {
    return r === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: r
    };
  },
  transform: function(r) {
    return r === "auto" ? HV() : r === "auto-gpu" ? GV() : r;
  },
  px: function(r) {
    if (r == null)
      return r;
    var t = aW(r), n = t.unitless;
    return n || _d(r) ? r + "px" : r;
  },
  fraction: function(r) {
    return !_d(r) || r > 1 ? r : r * 100 + "%";
  },
  float: function(r, t) {
    var n = {
      left: "right",
      right: "left"
    };
    return t.direction === "rtl" ? n[r] : r;
  },
  degree: function(r) {
    if (GO(r) || r == null)
      return r;
    var t = V2(r) && !r.endsWith("deg");
    return _d(r) || t ? r + "deg" : r;
  },
  gradient: nW,
  blur: Lo("blur"),
  opacity: Lo("opacity"),
  brightness: Lo("brightness"),
  contrast: Lo("contrast"),
  dropShadow: Lo("drop-shadow"),
  grayscale: Lo("grayscale"),
  hueRotate: Lo("hue-rotate"),
  invert: Lo("invert"),
  saturate: Lo("saturate"),
  sepia: Lo("sepia"),
  bgImage: function(r) {
    if (r == null)
      return r;
    var t = sM(r) || iM.has(r);
    return t ? r : "url(" + r + ")";
  },
  outline: function(r) {
    var t = String(r) === "0" || String(r) === "none";
    return r !== null && t ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: r
    };
  },
  flexDirection: function(r) {
    var t, n = (t = qV[r]) != null ? t : {}, a = n.space, i = n.divide, l = {
      flexDirection: r
    };
    return a && (l[a] = 1), i && (l[i] = 1), l;
  }
}, F = {
  borderWidths: to("borderWidths"),
  borderStyles: to("borderStyles"),
  colors: to("colors"),
  borders: to("borders"),
  radii: to("radii", Nr.px),
  space: to("space", Nr.px),
  spaceT: to("space", Nr.px),
  degreeT: function(r) {
    return {
      property: r,
      transform: Nr.degree
    };
  },
  prop: function(r, t, n) {
    return rf({
      property: r,
      scale: t
    }, t && {
      transform: tf({
        scale: t,
        transform: n
      })
    });
  },
  propT: function(r, t) {
    return {
      property: r,
      transform: t
    };
  },
  sizes: to("sizes", Nr.px),
  sizesT: to("sizes", Nr.fraction),
  shadows: to("shadows"),
  logical: WV,
  blur: to("blur", Nr.blur)
}, yp = {
  background: F.colors("background"),
  backgroundColor: F.colors("backgroundColor"),
  backgroundImage: F.propT("backgroundImage", Nr.bgImage),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: {
    transform: Nr.bgClip
  },
  bgSize: F.prop("backgroundSize"),
  bgPosition: F.prop("backgroundPosition"),
  bg: F.colors("background"),
  bgColor: F.colors("backgroundColor"),
  bgPos: F.prop("backgroundPosition"),
  bgRepeat: F.prop("backgroundRepeat"),
  bgAttachment: F.prop("backgroundAttachment"),
  bgGradient: F.propT("backgroundImage", Nr.gradient),
  bgClip: {
    transform: Nr.bgClip
  }
};
Object.assign(yp, {
  bgImage: yp.backgroundImage,
  bgImg: yp.backgroundImage
});
var wr = {
  border: F.borders("border"),
  borderWidth: F.borderWidths("borderWidth"),
  borderStyle: F.borderStyles("borderStyle"),
  borderColor: F.colors("borderColor"),
  borderRadius: F.radii("borderRadius"),
  borderTop: F.borders("borderTop"),
  borderBlockStart: F.borders("borderBlockStart"),
  borderTopLeftRadius: F.radii("borderTopLeftRadius"),
  borderStartStartRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: F.radii("borderTopRightRadius"),
  borderStartEndRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: F.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: F.borders("borderRight"),
  borderInlineEnd: F.borders("borderInlineEnd"),
  borderBottom: F.borders("borderBottom"),
  borderBlockEnd: F.borders("borderBlockEnd"),
  borderBottomLeftRadius: F.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: F.radii("borderBottomRightRadius"),
  borderLeft: F.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: F.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: F.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: F.borders(["borderLeft", "borderRight"]),
  borderInline: F.borders("borderInline"),
  borderY: F.borders(["borderTop", "borderBottom"]),
  borderBlock: F.borders("borderBlock"),
  borderTopWidth: F.borderWidths("borderTopWidth"),
  borderBlockStartWidth: F.borderWidths("borderBlockStartWidth"),
  borderTopColor: F.colors("borderTopColor"),
  borderBlockStartColor: F.colors("borderBlockStartColor"),
  borderTopStyle: F.borderStyles("borderTopStyle"),
  borderBlockStartStyle: F.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: F.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: F.borderWidths("borderBlockEndWidth"),
  borderBottomColor: F.colors("borderBottomColor"),
  borderBlockEndColor: F.colors("borderBlockEndColor"),
  borderBottomStyle: F.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: F.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: F.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: F.borderWidths("borderInlineStartWidth"),
  borderLeftColor: F.colors("borderLeftColor"),
  borderInlineStartColor: F.colors("borderInlineStartColor"),
  borderLeftStyle: F.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: F.borderStyles("borderInlineStartStyle"),
  borderRightWidth: F.borderWidths("borderRightWidth"),
  borderInlineEndWidth: F.borderWidths("borderInlineEndWidth"),
  borderRightColor: F.colors("borderRightColor"),
  borderInlineEndColor: F.colors("borderInlineEndColor"),
  borderRightStyle: F.borderStyles("borderRightStyle"),
  borderInlineEndStyle: F.borderStyles("borderInlineEndStyle"),
  borderTopRadius: F.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: F.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: F.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: F.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(wr, {
  rounded: wr.borderRadius,
  roundedTop: wr.borderTopRadius,
  roundedTopLeft: wr.borderTopLeftRadius,
  roundedTopRight: wr.borderTopRightRadius,
  roundedTopStart: wr.borderStartStartRadius,
  roundedTopEnd: wr.borderStartEndRadius,
  roundedBottom: wr.borderBottomRadius,
  roundedBottomLeft: wr.borderBottomLeftRadius,
  roundedBottomRight: wr.borderBottomRightRadius,
  roundedBottomStart: wr.borderEndStartRadius,
  roundedBottomEnd: wr.borderEndEndRadius,
  roundedLeft: wr.borderLeftRadius,
  roundedRight: wr.borderRightRadius,
  roundedStart: wr.borderInlineStartRadius,
  roundedEnd: wr.borderInlineEndRadius,
  borderStart: wr.borderInlineStart,
  borderEnd: wr.borderInlineEnd,
  borderTopStartRadius: wr.borderStartStartRadius,
  borderTopEndRadius: wr.borderStartEndRadius,
  borderBottomStartRadius: wr.borderEndStartRadius,
  borderBottomEndRadius: wr.borderEndEndRadius,
  borderStartRadius: wr.borderInlineStartRadius,
  borderEndRadius: wr.borderInlineEndRadius,
  borderStartWidth: wr.borderInlineStartWidth,
  borderEndWidth: wr.borderInlineEndWidth,
  borderStartColor: wr.borderInlineStartColor,
  borderEndColor: wr.borderInlineEndColor,
  borderStartStyle: wr.borderInlineStartStyle,
  borderEndStyle: wr.borderInlineEndStyle
});
var oW = {
  color: F.colors("color"),
  textColor: F.colors("color"),
  fill: F.colors("fill"),
  stroke: F.colors("stroke")
}, yS = {
  boxShadow: F.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: F.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: F.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(yS, {
  shadow: yS.boxShadow
});
var iW = {
  filter: {
    transform: Nr.filter
  },
  blur: F.blur("--chakra-blur"),
  brightness: F.propT("--chakra-brightness", Nr.brightness),
  contrast: F.propT("--chakra-contrast", Nr.contrast),
  hueRotate: F.degreeT("--chakra-hue-rotate"),
  invert: F.propT("--chakra-invert", Nr.invert),
  saturate: F.propT("--chakra-saturate", Nr.saturate),
  dropShadow: F.propT("--chakra-drop-shadow", Nr.dropShadow),
  backdropFilter: {
    transform: Nr.backdropFilter
  },
  backdropBlur: F.blur("--chakra-backdrop-blur"),
  backdropBrightness: F.propT("--chakra-backdrop-brightness", Nr.brightness),
  backdropContrast: F.propT("--chakra-backdrop-contrast", Nr.contrast),
  backdropHueRotate: F.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: F.propT("--chakra-backdrop-invert", Nr.invert),
  backdropSaturate: F.propT("--chakra-backdrop-saturate", Nr.saturate)
}, Zp = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: {
    transform: Nr.flexDirection
  },
  experimental_spaceX: {
    static: QV,
    transform: tf({
      scale: "space",
      transform: function(r) {
        return r !== null ? {
          "--chakra-space-x": r
        } : null;
      }
    })
  },
  experimental_spaceY: {
    static: XV,
    transform: tf({
      scale: "space",
      transform: function(r) {
        return r != null ? {
          "--chakra-space-y": r
        } : null;
      }
    })
  },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: F.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: F.space("gap"),
  rowGap: F.space("rowGap"),
  columnGap: F.space("columnGap")
};
Object.assign(Zp, {
  flexDir: Zp.flexDirection
});
var lM = {
  gridGap: F.space("gridGap"),
  gridColumnGap: F.space("gridColumnGap"),
  gridRowGap: F.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, sW = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: {
    transform: Nr.outline
  },
  outlineOffset: !0,
  outlineColor: F.colors("outlineColor")
}, ja = {
  width: F.sizesT("width"),
  inlineSize: F.sizesT("inlineSize"),
  height: F.sizes("height"),
  blockSize: F.sizes("blockSize"),
  boxSize: F.sizes(["width", "height"]),
  minWidth: F.sizes("minWidth"),
  minInlineSize: F.sizes("minInlineSize"),
  minHeight: F.sizes("minHeight"),
  minBlockSize: F.sizes("minBlockSize"),
  maxWidth: F.sizes("maxWidth"),
  maxInlineSize: F.sizes("maxInlineSize"),
  maxHeight: F.sizes("maxHeight"),
  maxBlockSize: F.sizes("maxBlockSize"),
  d: F.prop("display"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: F.propT("float", Nr.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(ja, {
  w: ja.width,
  h: ja.height,
  minW: ja.minWidth,
  maxW: ja.maxWidth,
  minH: ja.minHeight,
  maxH: ja.maxHeight,
  overscroll: ja.overscrollBehavior,
  overscrollX: ja.overscrollBehaviorX,
  overscrollY: ja.overscrollBehaviorY
});
var lW = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: F.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: F.prop("listStyleImage")
}, uW = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, cW = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, Rb = function(r, t, n) {
  var a = {}, i = sg(r, t, {});
  for (var l in i) {
    var u = l in n && n[l] != null;
    u || (a[l] = i[l]);
  }
  return a;
}, dW = {
  srOnly: {
    transform: function(r) {
      return r === !0 ? uW : r === "focusable" ? cW : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return Rb(t, "layerStyles." + r, n);
    }
  },
  textStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return Rb(t, "textStyles." + r, n);
    }
  },
  apply: {
    processResult: !0,
    transform: function(r, t, n) {
      return Rb(t, r, n);
    }
  }
}, Td = {
  position: !0,
  pos: F.prop("position"),
  zIndex: F.prop("zIndex", "zIndices"),
  inset: F.spaceT("inset"),
  insetX: F.spaceT(["left", "right"]),
  insetInline: F.spaceT("insetInline"),
  insetY: F.spaceT(["top", "bottom"]),
  insetBlock: F.spaceT("insetBlock"),
  top: F.spaceT("top"),
  insetBlockStart: F.spaceT("insetBlockStart"),
  bottom: F.spaceT("bottom"),
  insetBlockEnd: F.spaceT("insetBlockEnd"),
  left: F.spaceT("left"),
  insetInlineStart: F.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: F.spaceT("right"),
  insetInlineEnd: F.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(Td, {
  insetStart: Td.insetInlineStart,
  insetEnd: Td.insetInlineEnd
});
var fW = {
  ring: {
    transform: Nr.ring
  },
  ringColor: F.colors("--chakra-ring-color"),
  ringOffset: F.prop("--chakra-ring-offset-width"),
  ringOffsetColor: F.colors("--chakra-ring-offset-color"),
  ringInset: F.prop("--chakra-ring-inset")
}, it = {
  margin: F.spaceT("margin"),
  marginTop: F.spaceT("marginTop"),
  marginBlockStart: F.spaceT("marginBlockStart"),
  marginRight: F.spaceT("marginRight"),
  marginInlineEnd: F.spaceT("marginInlineEnd"),
  marginBottom: F.spaceT("marginBottom"),
  marginBlockEnd: F.spaceT("marginBlockEnd"),
  marginLeft: F.spaceT("marginLeft"),
  marginInlineStart: F.spaceT("marginInlineStart"),
  marginX: F.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: F.spaceT("marginInline"),
  marginY: F.spaceT(["marginTop", "marginBottom"]),
  marginBlock: F.spaceT("marginBlock"),
  padding: F.space("padding"),
  paddingTop: F.space("paddingTop"),
  paddingBlockStart: F.space("paddingBlockStart"),
  paddingRight: F.space("paddingRight"),
  paddingBottom: F.space("paddingBottom"),
  paddingBlockEnd: F.space("paddingBlockEnd"),
  paddingLeft: F.space("paddingLeft"),
  paddingInlineStart: F.space("paddingInlineStart"),
  paddingInlineEnd: F.space("paddingInlineEnd"),
  paddingX: F.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: F.space("paddingInline"),
  paddingY: F.space(["paddingTop", "paddingBottom"]),
  paddingBlock: F.space("paddingBlock")
};
Object.assign(it, {
  m: it.margin,
  mt: it.marginTop,
  mr: it.marginRight,
  me: it.marginInlineEnd,
  marginEnd: it.marginInlineEnd,
  mb: it.marginBottom,
  ml: it.marginLeft,
  ms: it.marginInlineStart,
  marginStart: it.marginInlineStart,
  mx: it.marginX,
  my: it.marginY,
  p: it.padding,
  pt: it.paddingTop,
  py: it.paddingY,
  px: it.paddingX,
  pb: it.paddingBottom,
  pl: it.paddingLeft,
  ps: it.paddingInlineStart,
  paddingStart: it.paddingInlineStart,
  pr: it.paddingRight,
  pe: it.paddingInlineEnd,
  paddingEnd: it.paddingInlineEnd
});
var vW = {
  textDecorationColor: F.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: F.shadows("textShadow")
}, hW = {
  clipPath: !0,
  transform: F.propT("transform", Nr.transform),
  transformOrigin: !0,
  translateX: F.spaceT("--chakra-translate-x"),
  translateY: F.spaceT("--chakra-translate-y"),
  skewX: F.degreeT("--chakra-skew-x"),
  skewY: F.degreeT("--chakra-skew-y"),
  scaleX: F.prop("--chakra-scale-x"),
  scaleY: F.prop("--chakra-scale-y"),
  scale: F.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: F.degreeT("--chakra-rotate")
}, pW = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: F.prop("transitionDuration", "transition.duration"),
  transitionProperty: F.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: F.prop("transitionTimingFunction", "transition.easing")
}, gW = {
  fontFamily: F.prop("fontFamily", "fonts"),
  fontSize: F.prop("fontSize", "fontSizes", Nr.px),
  fontWeight: F.prop("fontWeight", "fontWeights"),
  lineHeight: F.prop("lineHeight", "lineHeights"),
  letterSpacing: F.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function(r) {
      if (r === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  }
}, mW = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: F.spaceT("scrollMargin"),
  scrollMarginTop: F.spaceT("scrollMarginTop"),
  scrollMarginBottom: F.spaceT("scrollMarginBottom"),
  scrollMarginLeft: F.spaceT("scrollMarginLeft"),
  scrollMarginRight: F.spaceT("scrollMarginRight"),
  scrollMarginX: F.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: F.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: F.spaceT("scrollPadding"),
  scrollPaddingTop: F.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: F.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: F.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: F.spaceT("scrollPaddingRight"),
  scrollPaddingX: F.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: F.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function oC(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function bW(e, r) {
  if (e) {
    if (typeof e == "string")
      return oC(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return oC(e, r);
  }
}
function yW(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = bW(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Jt = {
  hover: function(r, t) {
    return r + ":hover " + t + ", " + r + "[data-hover] " + t;
  },
  focus: function(r, t) {
    return r + ":focus " + t + ", " + r + "[data-focus] " + t;
  },
  focusVisible: function(r, t) {
    return r + ":focus-visible " + t;
  },
  focusWithin: function(r, t) {
    return r + ":focus-within " + t;
  },
  active: function(r, t) {
    return r + ":active " + t + ", " + r + "[data-active] " + t;
  },
  disabled: function(r, t) {
    return r + ":disabled " + t + ", " + r + "[data-disabled] " + t;
  },
  invalid: function(r, t) {
    return r + ":invalid " + t + ", " + r + "[data-invalid] " + t;
  },
  checked: function(r, t) {
    return r + ":checked " + t + ", " + r + "[data-checked] " + t;
  },
  indeterminate: function(r, t) {
    return r + ":indeterminate " + t + ", " + r + "[aria-checked=mixed] " + t + ", " + r + "[data-indeterminate] " + t;
  },
  readOnly: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[readonly] " + t + ", " + r + "[data-read-only] " + t;
  },
  expanded: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[aria-expanded=true] " + t + ", " + r + "[data-expanded] " + t;
  },
  placeholderShown: function(r, t) {
    return r + ":placeholder-shown " + t;
  }
}, fs = function(r) {
  return uM(function(t) {
    return r(t, "&");
  }, "[role=group]", "[data-group]", ".group");
}, _i = function(r) {
  return uM(function(t) {
    return r(t, "~ &");
  }, "[data-peer]", ".peer");
}, uM = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(r).join(", ");
}, nf = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: fs(Jt.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: _i(Jt.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: fs(Jt.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: _i(Jt.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: fs(Jt.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: _i(Jt.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: fs(Jt.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: _i(Jt.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: fs(Jt.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: _i(Jt.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: fs(Jt.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: _i(Jt.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: fs(Jt.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: _i(Jt.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: fs(Jt.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: _i(Jt.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: _i(Jt.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
}, SW = H2(nf), Y2 = Fa({}, yp, wr, oW, Zp, ja, iW, fW, sW, lM, dW, Td, yS, it, mW, gW, vW, hW, lW, pW);
Object.assign({}, it, ja, Zp, lM, Td);
var xW = [].concat(H2(Y2), SW), $W = rf({}, Y2, nf), wW = function(r) {
  return r in $W;
}, _W = function(r) {
  return function(t) {
    if (!t.__breakpoints)
      return r;
    var n = t.__breakpoints, a = n.isResponsive, i = n.toArrayValue, l = n.media, u = {};
    for (var c in r) {
      var f = Xo(r[c], t);
      if (f != null) {
        if (f = In(f) && a(f) ? i(f) : f, !Array.isArray(f)) {
          u[c] = f;
          continue;
        }
        for (var h = f.slice(0, l.length).length, p = 0; p < h; p += 1) {
          var g = l == null ? void 0 : l[p];
          if (!g) {
            u[c] = f[p];
            continue;
          }
          u[g] = u[g] || {}, f[p] != null && (u[g][c] = f[p]);
        }
      }
    }
    return u;
  };
}, TW = function(r, t) {
  return r.startsWith("--") && V2(t) && !GO(t);
}, CW = function(r, t) {
  var n, a;
  if (t == null)
    return t;
  var i = function(p) {
    var g, y;
    return (g = r.__cssMap) == null || (y = g[p]) == null ? void 0 : y.varRef;
  }, l = function(p) {
    var g;
    return (g = i(p)) != null ? g : p;
  }, u = t.split(",").map(function(h) {
    return h.trim();
  }), c = u[0], f = u[1];
  return t = (n = (a = i(c)) != null ? a : l(f)) != null ? n : l(t), t;
};
function EW(e) {
  var r = e.configs, t = r === void 0 ? {} : r, n = e.pseudos, a = n === void 0 ? {} : n, i = e.theme, l = function u(c, f) {
    f === void 0 && (f = !1);
    var h = Xo(c, i), p = _W(h)(i), g = {};
    for (var y in p) {
      var S, x, _, A, O, P = p[y], j = Xo(P, i);
      y in a && (y = a[y]), TW(y, j) && (j = CW(i, j));
      var k = t[y];
      if (k === !0 && (k = {
        property: y
      }), In(j)) {
        var L;
        g[y] = (L = g[y]) != null ? L : {}, g[y] = Fa({}, g[y], u(j, !0));
        continue;
      }
      var M = (S = (x = k) == null || x.transform == null ? void 0 : x.transform(j, i, h)) != null ? S : j;
      M = (_ = k) != null && _.processResult ? u(M, !0) : M;
      var W = Xo((A = k) == null ? void 0 : A.property, i);
      if (!f && (O = k) != null && O.static) {
        var Z = Xo(k.static, i);
        g = Fa({}, g, Z);
      }
      if (W && Array.isArray(W)) {
        for (var oe = yW(W), Ie; !(Ie = oe()).done; ) {
          var Te = Ie.value;
          g[Te] = M;
        }
        continue;
      }
      if (W) {
        W === "&" && In(M) ? g = Fa({}, g, M) : g[W] = M;
        continue;
      }
      if (In(M)) {
        g = Fa({}, g, M);
        continue;
      }
      g[y] = M;
    }
    return g;
  };
  return l;
}
var cM = function(r) {
  return function(t) {
    var n = EW({
      theme: t,
      pseudos: nf,
      configs: Y2
    });
    return n(r);
  };
};
function dM(e) {
  return In(e) && e.reference ? e.reference : String(e);
}
var lg = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(dM).join(" " + r + " ").replace(/calc/g, "");
}, iC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + lg.apply(void 0, ["+"].concat(t)) + ")";
}, sC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + lg.apply(void 0, ["-"].concat(t)) + ")";
}, SS = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + lg.apply(void 0, ["*"].concat(t)) + ")";
}, lC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + lg.apply(void 0, ["/"].concat(t)) + ")";
}, uC = function(r) {
  var t = dM(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : SS(t, -1);
}, Ol = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ol(iC.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ol(sC.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ol(SS.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Ol(lC.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return Ol(uC(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: iC,
  subtract: sC,
  multiply: SS,
  divide: lC,
  negate: uC
});
function AW(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function fM(e) {
  var r = AW(e.toString());
  if (r.includes("\\."))
    return e;
  var t = !Number.isInteger(parseFloat(e.toString()));
  return t ? r.replace(".", "\\.") : e;
}
function IW(e, r) {
  return r === void 0 && (r = ""), [r, fM(e)].filter(Boolean).join("-");
}
function OW(e, r) {
  return "var(" + fM(e) + (r ? ", " + r : "") + ")";
}
function MW(e, r) {
  return r === void 0 && (r = ""), "--" + IW(e, r);
}
function RW(e, r, t) {
  var n = MW(e, t);
  return {
    variable: n,
    reference: OW(n, r)
  };
}
function cC(e, r) {
  return RW(String(e).replace(/\./g, "-"), void 0, r);
}
function PW(e, r) {
  for (var t = {}, n = {}, a = function() {
    var f = l[i], h = f[0], p = f[1], g = p.isSemantic, y = p.value, S = cC(h, r == null ? void 0 : r.cssVarPrefix), x = S.variable, _ = S.reference;
    if (!g) {
      if (h.startsWith("space")) {
        var A = h.split("."), O = A[0], P = A.slice(1), j = O + ".-" + P.join("."), k = Ol.negate(y), L = Ol.negate(_);
        n[j] = {
          value: k,
          var: x,
          varRef: L
        };
      }
      return t[x] = y, n[h] = {
        value: y,
        var: x,
        varRef: _
      }, "continue";
    }
    var M = function(oe) {
      var Ie = String(h).split(".")[0], Te = [Ie, oe].join("."), Ee = e[Te];
      if (!Ee)
        return oe;
      var Me = cC(Te, r == null ? void 0 : r.cssVarPrefix), Fe = Me.reference;
      return Fe;
    }, W = In(y) ? y : {
      default: y
    };
    t = Fa(t, Object.entries(W).reduce(function(Z, oe) {
      var Ie, Te, Ee = oe[0], Me = oe[1], Fe = M(Me);
      if (Ee === "default")
        return Z[x] = Fe, Z;
      var Ge = (Ie = nf == null ? void 0 : nf[Ee]) != null ? Ie : Ee;
      return Z[Ge] = (Te = {}, Te[x] = Fe, Te), Z;
    }, {})), n[h] = {
      value: _,
      var: x,
      varRef: _
    };
  }, i = 0, l = Object.entries(e); i < l.length; i++)
    var u = a();
  return {
    cssVars: t,
    cssMap: n
  };
}
function kW(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var jW = ["__cssMap", "__cssVars", "__breakpoints"], DW = ["colors", "borders", "borderWidths", "borderStyles", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "space", "shadows", "sizes", "zIndices", "transition", "blur"];
function NW(e) {
  var r = DW;
  return uV(e, r);
}
function LW(e) {
  return e.semanticTokens;
}
function FW(e) {
  e.__cssMap, e.__cssVars, e.__breakpoints;
  var r = kW(e, jW);
  return r;
}
function zW(e) {
  var r, t, n = e.tokens, a = e.semanticTokens, i = Object.entries((r = gS(n)) != null ? r : {}).map(function(u) {
    var c = u[0], f = u[1], h = {
      isSemantic: !1,
      value: f
    };
    return [c, h];
  }), l = Object.entries((t = gS(a, 1)) != null ? t : {}).map(function(u) {
    var c = u[0], f = u[1], h = {
      isSemantic: !0,
      value: f
    };
    return [c, h];
  });
  return Jd([].concat(i, l));
}
function BW(e) {
  var r, t = FW(e), n = NW(t), a = LW(t), i = zW({
    tokens: n,
    semanticTokens: a
  }), l = (r = t.config) == null ? void 0 : r.cssVarPrefix, u = PW(i, {
    cssVarPrefix: l
  }), c = u.cssMap, f = u.cssVars, h = {
    "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-ring-offset-width": "0px",
    "--chakra-ring-offset-color": "#fff",
    "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
    "--chakra-ring-offset-shadow": "0 0 #0000",
    "--chakra-ring-shadow": "0 0 #0000",
    "--chakra-space-x-reverse": "0",
    "--chakra-space-y-reverse": "0"
  };
  return Object.assign(t, {
    __cssVars: rf({}, h, f),
    __cssMap: c,
    __breakpoints: pV(t.breakpoints)
  }), t;
}
var UW = typeof Element != "undefined", VW = typeof Map == "function", WW = typeof Set == "function", HW = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Sp(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var t, n, a;
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (!Sp(e[n], r[n]))
          return !1;
      return !0;
    }
    var i;
    if (VW && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!Sp(n.value[1], r.get(n.value[0])))
          return !1;
      return !0;
    }
    if (WW && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      return !0;
    }
    if (HW && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (e[n] !== r[n])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (a = Object.keys(e), t = a.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[n]))
        return !1;
    if (UW && e instanceof Element)
      return !1;
    for (n = t; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !Sp(e[a[n]], r[a[n]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var GW = function(r, t) {
  try {
    return Sp(r, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const YW = /* @__PURE__ */ H0(GW);
var KW = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, ZW = /* @__PURE__ */ RO(
  function(e) {
    return KW.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), qW = ZW, QW = function(r) {
  return r !== "theme";
}, dC = function(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96 ? qW : QW;
}, fC = function(r, t, n) {
  var a;
  if (t) {
    var i = t.shouldForwardProp;
    a = r.__emotion_forwardProp && i ? function(l) {
      return r.__emotion_forwardProp(l) && i(l);
    } : i;
  }
  return typeof a != "function" && n && (a = r.__emotion_forwardProp), a;
}, XW = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  return L2(t, n, a), BO(function() {
    return F2(t, n, a);
  }), null;
}, JW = function e(r, t) {
  var n = r.__emotion_real === r, a = n && r.__emotion_base || r, i, l;
  t !== void 0 && (i = t.label, l = t.target);
  var u = fC(r, t, n), c = u || dC(a), f = !c("as");
  return function() {
    var h = arguments, p = n && r.__emotion_styles !== void 0 ? r.__emotion_styles.slice(0) : [];
    if (i !== void 0 && p.push("label:" + i + ";"), h[0] == null || h[0].raw === void 0)
      p.push.apply(p, h);
    else {
      p.push(h[0][0]);
      for (var g = h.length, y = 1; y < g; y++)
        p.push(h[y], h[0][y]);
    }
    var S = z2(function(x, _, A) {
      var O = f && x.as || a, P = "", j = [], k = x;
      if (x.theme == null) {
        k = {};
        for (var L in x)
          k[L] = x[L];
        k.theme = zr(ru);
      }
      typeof x.className == "string" ? P = LO(_.registered, j, x.className) : x.className != null && (P = x.className + " ");
      var M = og(p.concat(j), _.registered, k);
      P += _.key + "-" + M.name, l !== void 0 && (P += " " + l);
      var W = f && u === void 0 ? dC(O) : c, Z = {};
      for (var oe in x)
        f && oe === "as" || // $FlowFixMe
        W(oe) && (Z[oe] = x[oe]);
      return Z.className = P, Z.ref = A, /* @__PURE__ */ ji(M2, null, /* @__PURE__ */ ji(XW, {
        cache: _,
        serialized: M,
        isStringTag: typeof O == "string"
      }), /* @__PURE__ */ ji(O, Z));
    });
    return S.displayName = i !== void 0 ? i : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", S.defaultProps = r.defaultProps, S.__emotion_real = S, S.__emotion_base = a, S.__emotion_styles = p, S.__emotion_forwardProp = u, Object.defineProperty(S, "toString", {
      value: function() {
        return "." + l;
      }
    }), S.withComponent = function(x, _) {
      return e(x, Gp({}, t, _, {
        shouldForwardProp: fC(S, _, !0)
      })).apply(void 0, p);
    }, S;
  };
}, eH = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], qp = JW.bind();
eH.forEach(function(e) {
  qp[e] = qp(e);
});
function xS() {
  return xS = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, xS.apply(this, arguments);
}
var rH = function(r) {
  var t = r.cssVarsRoot, n = r.theme, a = r.children, i = I.useMemo(function() {
    return BW(n);
  }, [n]);
  return /* @__PURE__ */ I.createElement(eV, {
    theme: i
  }, /* @__PURE__ */ I.createElement(tH, {
    root: t
  }), a);
}, tH = function(r) {
  var t = r.root, n = t === void 0 ? ":host, :root" : t, a = [n, "[data-theme]"].join(",");
  return /* @__PURE__ */ I.createElement(B2, {
    styles: function(l) {
      var u;
      return u = {}, u[a] = l.__cssVars, u;
    }
  });
};
function nH() {
  var e = I.useContext(ru);
  if (!e)
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  return e;
}
var aH = Tc({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}), vM = aH[1], oH = function() {
  var r = nM(), t = r.colorMode;
  return /* @__PURE__ */ I.createElement(B2, {
    styles: function(a) {
      var i = sg(a, "styles.global"), l = Xo(i, {
        theme: a,
        colorMode: t
      });
      if (l) {
        var u = cM(l)(a);
        return u;
      }
    }
  });
};
function ug(e) {
  return YO(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function iH() {
  var e = nM(), r = nH();
  return xS({}, e, {
    theme: r
  });
}
function K2(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var sH = new Set([].concat(xW, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"])), lH = /* @__PURE__ */ new Set(["htmlWidth", "htmlHeight", "htmlSize"]), uH = function(r) {
  return lH.has(r) || !sH.has(r);
}, cH = ["theme", "css", "__css", "sx"], dH = ["baseStyle"], fH = function(r) {
  var t = r.baseStyle;
  return function(n) {
    n.theme;
    var a = n.css, i = n.__css, l = n.sx, u = K2(n, cH), c = KO(u, function(g, y) {
      return wW(y);
    }), f = Xo(t, n), h = Object.assign({}, i, f, W2(c), l), p = cM(h)(n.theme);
    return a ? [p, a] : p;
  };
};
function Pb(e, r) {
  var t = r != null ? r : {}, n = t.baseStyle, a = K2(t, dH);
  a.shouldForwardProp || (a.shouldForwardProp = uH);
  var i = fH({
    baseStyle: n
  });
  return qp(e, a)(i);
}
function Mn(e) {
  return /* @__PURE__ */ I.forwardRef(e);
}
var vH = ["styleConfig"];
function cg(e, r, t) {
  var n;
  r === void 0 && (r = {}), t === void 0 && (t = {});
  var a = r, i = a.styleConfig, l = K2(a, vH), u = iH(), c = u.theme, f = u.colorMode, h = sg(c, "components." + e), p = i || h, g = Fa({
    theme: c,
    colorMode: f
  }, (n = p == null ? void 0 : p.defaultProps) != null ? n : {}, W2(YO(l, ["children"]))), y = Qe({});
  if (p) {
    var S, x, _, A, O, P, j = Xo((S = p.baseStyle) != null ? S : {}, g), k = Xo((x = (_ = p.variants) == null ? void 0 : _[g.variant]) != null ? x : {}, g), L = Xo((A = (O = p.sizes) == null ? void 0 : O[g.size]) != null ? A : {}, g), M = Fa({}, j, L, k);
    (P = t) != null && P.isMultiPart && p.parts && p.parts.forEach(function(Z) {
      var oe;
      M[Z] = (oe = M[Z]) != null ? oe : {};
    });
    var W = YW(y.current, M);
    W || (y.current = M);
  }
  return y.current;
}
function hH(e, r) {
  return cg(e, r, {
    isMultiPart: !0
  });
}
function pH() {
  var e = /* @__PURE__ */ new Map();
  return new Proxy(Pb, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function(t, n, a) {
      return Pb.apply(void 0, a);
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function(t, n) {
      return e.has(n) || e.set(n, Pb(n)), e.get(n);
    }
  });
}
var Vt = pH(), gH = function(r) {
  var t = r.children, n = r.colorModeManager, a = r.portalZIndex, i = r.resetCSS, l = i === void 0 ? !0 : i, u = r.theme, c = u === void 0 ? {} : u, f = r.environment, h = r.cssVarsRoot, p = /* @__PURE__ */ I.createElement(PV, {
    environment: f
  }, t);
  return /* @__PURE__ */ I.createElement(wV, null, /* @__PURE__ */ I.createElement(rH, {
    theme: c,
    cssVarsRoot: h
  }, /* @__PURE__ */ I.createElement(BV, {
    colorModeManager: n,
    options: c.config
  }, l && /* @__PURE__ */ I.createElement(aV, null), /* @__PURE__ */ I.createElement(oH, null), a ? /* @__PURE__ */ I.createElement(AV, {
    zIndex: a
  }, p) : p)));
}, hM = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};
function It() {
  return It = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, It.apply(this, arguments);
}
var mH = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem"
}, bH = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, pM = It({}, hM, mH, {
  container: bH
});
function on(e, r) {
  yH(e) && (e = "100%");
  var t = SH(e);
  return e = r === 360 ? e : Math.min(r, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * r), 10) / 100), Math.abs(e - r) < 1e-6 ? 1 : (r === 360 ? e = (e < 0 ? e % r + r : e % r) / parseFloat(String(r)) : e = e % r / parseFloat(String(r)), e);
}
function Zv(e) {
  return Math.min(1, Math.max(0, e));
}
function yH(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function SH(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function gM(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function qv(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Nl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function xH(e, r, t) {
  return {
    r: on(e, 255) * 255,
    g: on(r, 255) * 255,
    b: on(t, 255) * 255
  };
}
function vC(e, r, t) {
  e = on(e, 255), r = on(r, 255), t = on(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = 0, u = (n + a) / 2;
  if (n === a)
    l = 0, i = 0;
  else {
    var c = n - a;
    switch (l = u > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
      case e:
        i = (r - t) / c + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / c + 2;
        break;
      case t:
        i = (e - r) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, l: u };
}
function kb(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * (6 * t) : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function $H(e, r, t) {
  var n, a, i;
  if (e = on(e, 360), r = on(r, 100), t = on(t, 100), r === 0)
    a = t, i = t, n = t;
  else {
    var l = t < 0.5 ? t * (1 + r) : t + r - t * r, u = 2 * t - l;
    n = kb(u, l, e + 1 / 3), a = kb(u, l, e), i = kb(u, l, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function hC(e, r, t) {
  e = on(e, 255), r = on(r, 255), t = on(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = n, u = n - a, c = n === 0 ? 0 : u / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (r - t) / u + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / u + 2;
        break;
      case t:
        i = (e - r) / u + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: l };
}
function wH(e, r, t) {
  e = on(e, 360) * 6, r = on(r, 100), t = on(t, 100);
  var n = Math.floor(e), a = e - n, i = t * (1 - r), l = t * (1 - a * r), u = t * (1 - (1 - a) * r), c = n % 6, f = [t, l, i, i, u, t][c], h = [u, t, t, l, i, i][c], p = [i, i, u, t, t, l][c];
  return { r: f * 255, g: h * 255, b: p * 255 };
}
function pC(e, r, t, n) {
  var a = [
    Nl(Math.round(e).toString(16)),
    Nl(Math.round(r).toString(16)),
    Nl(Math.round(t).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function _H(e, r, t, n, a) {
  var i = [
    Nl(Math.round(e).toString(16)),
    Nl(Math.round(r).toString(16)),
    Nl(Math.round(t).toString(16)),
    Nl(TH(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function TH(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function gC(e) {
  return ua(e) / 255;
}
function ua(e) {
  return parseInt(e, 16);
}
function CH(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var $S = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function EH(e) {
  var r = { r: 0, g: 0, b: 0 }, t = 1, n = null, a = null, i = null, l = !1, u = !1;
  return typeof e == "string" && (e = OH(e)), typeof e == "object" && (Ti(e.r) && Ti(e.g) && Ti(e.b) ? (r = xH(e.r, e.g, e.b), l = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ti(e.h) && Ti(e.s) && Ti(e.v) ? (n = qv(e.s), a = qv(e.v), r = wH(e.h, n, a), l = !0, u = "hsv") : Ti(e.h) && Ti(e.s) && Ti(e.l) && (n = qv(e.s), i = qv(e.l), r = $H(e.h, n, i), l = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = gM(t), {
    ok: l,
    format: e.format || u,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a: t
  };
}
var AH = "[-\\+]?\\d+%?", IH = "[-\\+]?\\d*\\.\\d+%?", Es = "(?:".concat(IH, ")|(?:").concat(AH, ")"), jb = "[\\s|\\(]+(".concat(Es, ")[,|\\s]+(").concat(Es, ")[,|\\s]+(").concat(Es, ")\\s*\\)?"), Db = "[\\s|\\(]+(".concat(Es, ")[,|\\s]+(").concat(Es, ")[,|\\s]+(").concat(Es, ")[,|\\s]+(").concat(Es, ")\\s*\\)?"), co = {
  CSS_UNIT: new RegExp(Es),
  rgb: new RegExp("rgb" + jb),
  rgba: new RegExp("rgba" + Db),
  hsl: new RegExp("hsl" + jb),
  hsla: new RegExp("hsla" + Db),
  hsv: new RegExp("hsv" + jb),
  hsva: new RegExp("hsva" + Db),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function OH(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var r = !1;
  if ($S[e])
    e = $S[e], r = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = co.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = co.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = co.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = co.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = co.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = co.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = co.hex8.exec(e), t ? {
    r: ua(t[1]),
    g: ua(t[2]),
    b: ua(t[3]),
    a: gC(t[4]),
    format: r ? "name" : "hex8"
  } : (t = co.hex6.exec(e), t ? {
    r: ua(t[1]),
    g: ua(t[2]),
    b: ua(t[3]),
    format: r ? "name" : "hex"
  } : (t = co.hex4.exec(e), t ? {
    r: ua(t[1] + t[1]),
    g: ua(t[2] + t[2]),
    b: ua(t[3] + t[3]),
    a: gC(t[4] + t[4]),
    format: r ? "name" : "hex8"
  } : (t = co.hex3.exec(e), t ? {
    r: ua(t[1] + t[1]),
    g: ua(t[2] + t[2]),
    b: ua(t[3] + t[3]),
    format: r ? "name" : "hex"
  } : !1)))))))));
}
function Ti(e) {
  return !!co.CSS_UNIT.exec(String(e));
}
var kf = (
  /** @class */
  function() {
    function e(r, t) {
      r === void 0 && (r = ""), t === void 0 && (t = {});
      var n;
      if (r instanceof e)
        return r;
      typeof r == "number" && (r = CH(r)), this.originalInput = r;
      var a = EH(r);
      this.originalInput = r, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = t.format) !== null && n !== void 0 ? n : a.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var r = this.toRgb();
      return (r.r * 299 + r.g * 587 + r.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var r = this.toRgb(), t, n, a, i = r.r / 255, l = r.g / 255, u = r.b / 255;
      return i <= 0.03928 ? t = i / 12.92 : t = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? n = l / 12.92 : n = Math.pow((l + 0.055) / 1.055, 2.4), u <= 0.03928 ? a = u / 12.92 : a = Math.pow((u + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(r) {
      return this.a = gM(r), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var r = this.toHsl().s;
      return r === 0;
    }, e.prototype.toHsv = function() {
      var r = hC(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, v: r.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var r = hC(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.v * 100);
      return this.a === 1 ? "hsv(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var r = vC(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, l: r.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var r = vC(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.l * 100);
      return this.a === 1 ? "hsl(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(r) {
      return r === void 0 && (r = !1), pC(this.r, this.g, this.b, r);
    }, e.prototype.toHexString = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex(r);
    }, e.prototype.toHex8 = function(r) {
      return r === void 0 && (r = !1), _H(this.r, this.g, this.b, this.a, r);
    }, e.prototype.toHex8String = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex8(r);
    }, e.prototype.toHexShortString = function(r) {
      return r === void 0 && (r = !1), this.a === 1 ? this.toHexString(r) : this.toHex8String(r);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var r = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(r, ", ").concat(t, ", ").concat(n, ")") : "rgba(".concat(r, ", ").concat(t, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var r = function(t) {
        return "".concat(Math.round(on(t, 255) * 100), "%");
      };
      return {
        r: r(this.r),
        g: r(this.g),
        b: r(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var r = function(t) {
        return Math.round(on(t, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%)") : "rgba(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var r = "#" + pC(this.r, this.g, this.b, !1), t = 0, n = Object.entries($S); t < n.length; t++) {
        var a = n[t], i = a[0], l = a[1];
        if (r === l)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(r) {
      var t = !!r;
      r = r != null ? r : this.format;
      var n = !1, a = this.a < 1 && this.a >= 0, i = !t && a && (r.startsWith("hex") || r === "name");
      return i ? r === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (r === "rgb" && (n = this.toRgbString()), r === "prgb" && (n = this.toPercentageRgbString()), (r === "hex" || r === "hex6") && (n = this.toHexString()), r === "hex3" && (n = this.toHexString(!0)), r === "hex4" && (n = this.toHex8String(!0)), r === "hex8" && (n = this.toHex8String()), r === "name" && (n = this.toName()), r === "hsl" && (n = this.toHslString()), r === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l += r / 100, t.l = Zv(t.l), new e(t);
    }, e.prototype.brighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toRgb();
      return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(r / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(r / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(r / 100)))), new e(t);
    }, e.prototype.darken = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l -= r / 100, t.l = Zv(t.l), new e(t);
    }, e.prototype.tint = function(r) {
      return r === void 0 && (r = 10), this.mix("white", r);
    }, e.prototype.shade = function(r) {
      return r === void 0 && (r = 10), this.mix("black", r);
    }, e.prototype.desaturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s -= r / 100, t.s = Zv(t.s), new e(t);
    }, e.prototype.saturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s += r / 100, t.s = Zv(t.s), new e(t);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(r) {
      var t = this.toHsl(), n = (t.h + r) % 360;
      return t.h = n < 0 ? 360 + n : n, new e(t);
    }, e.prototype.mix = function(r, t) {
      t === void 0 && (t = 50);
      var n = this.toRgb(), a = new e(r).toRgb(), i = t / 100, l = {
        r: (a.r - n.r) * i + n.r,
        g: (a.g - n.g) * i + n.g,
        b: (a.b - n.b) * i + n.b,
        a: (a.a - n.a) * i + n.a
      };
      return new e(l);
    }, e.prototype.analogous = function(r, t) {
      r === void 0 && (r = 6), t === void 0 && (t = 30);
      var n = this.toHsl(), a = 360 / t, i = [this];
      for (n.h = (n.h - (a * r >> 1) + 720) % 360; --r; )
        n.h = (n.h + a) % 360, i.push(new e(n));
      return i;
    }, e.prototype.complement = function() {
      var r = this.toHsl();
      return r.h = (r.h + 180) % 360, new e(r);
    }, e.prototype.monochromatic = function(r) {
      r === void 0 && (r = 6);
      for (var t = this.toHsv(), n = t.h, a = t.s, i = t.v, l = [], u = 1 / r; r--; )
        l.push(new e({ h: n, s: a, v: i })), i = (i + u) % 1;
      return l;
    }, e.prototype.splitcomplement = function() {
      var r = this.toHsl(), t = r.h;
      return [
        this,
        new e({ h: (t + 72) % 360, s: r.s, l: r.l }),
        new e({ h: (t + 216) % 360, s: r.s, l: r.l })
      ];
    }, e.prototype.onBackground = function(r) {
      var t = this.toRgb(), n = new e(r).toRgb(), a = t.a + n.a * (1 - t.a);
      return new e({
        r: (t.r * t.a + n.r * n.a * (1 - t.a)) / a,
        g: (t.g * t.a + n.g * n.a * (1 - t.a)) / a,
        b: (t.b * t.a + n.b * n.a * (1 - t.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(r) {
      for (var t = this.toHsl(), n = t.h, a = [this], i = 360 / r, l = 1; l < r; l++)
        a.push(new e({ h: (n + l * i) % 360, s: t.s, l: t.l }));
      return a;
    }, e.prototype.equals = function(r) {
      return this.toRgbString() === new e(r).toRgbString();
    }, e;
  }()
);
function mM(e) {
  if (e === void 0 && (e = {}), e.count !== void 0 && e.count !== null) {
    var r = e.count, t = [];
    for (e.count = void 0; r > t.length; )
      e.count = null, e.seed && (e.seed += 1), t.push(mM(e));
    return e.count = r, t;
  }
  var n = MH(e.hue, e.seed), a = RH(n, e), i = PH(n, a, e), l = { h: n, s: a, v: i };
  return e.alpha !== void 0 && (l.a = e.alpha), new kf(l);
}
function MH(e, r) {
  var t = jH(e), n = Qp(t, r);
  return n < 0 && (n = 360 + n), n;
}
function RH(e, r) {
  if (r.hue === "monochrome")
    return 0;
  if (r.luminosity === "random")
    return Qp([0, 100], r.seed);
  var t = bM(e).saturationRange, n = t[0], a = t[1];
  switch (r.luminosity) {
    case "bright":
      n = 55;
      break;
    case "dark":
      n = a - 10;
      break;
    case "light":
      a = 55;
      break;
  }
  return Qp([n, a], r.seed);
}
function PH(e, r, t) {
  var n = kH(e, r), a = 100;
  switch (t.luminosity) {
    case "dark":
      a = n + 20;
      break;
    case "light":
      n = (a + n) / 2;
      break;
    case "random":
      n = 0, a = 100;
      break;
  }
  return Qp([n, a], t.seed);
}
function kH(e, r) {
  for (var t = bM(e).lowerBounds, n = 0; n < t.length - 1; n++) {
    var a = t[n][0], i = t[n][1], l = t[n + 1][0], u = t[n + 1][1];
    if (r >= a && r <= l) {
      var c = (u - i) / (l - a), f = i - c * a;
      return c * r + f;
    }
  }
  return 0;
}
function jH(e) {
  var r = parseInt(e, 10);
  if (!Number.isNaN(r) && r < 360 && r > 0)
    return [r, r];
  if (typeof e == "string") {
    var t = SM.find(function(l) {
      return l.name === e;
    });
    if (t) {
      var n = yM(t);
      if (n.hueRange)
        return n.hueRange;
    }
    var a = new kf(e);
    if (a.isValid) {
      var i = a.toHsv().h;
      return [i, i];
    }
  }
  return [0, 360];
}
function bM(e) {
  e >= 334 && e <= 360 && (e -= 360);
  for (var r = 0, t = SM; r < t.length; r++) {
    var n = t[r], a = yM(n);
    if (a.hueRange && e >= a.hueRange[0] && e <= a.hueRange[1])
      return a;
  }
  throw Error("Color not found");
}
function Qp(e, r) {
  if (r === void 0)
    return Math.floor(e[0] + Math.random() * (e[1] + 1 - e[0]));
  var t = e[1] || 1, n = e[0] || 0;
  r = (r * 9301 + 49297) % 233280;
  var a = r / 233280;
  return Math.floor(n + a * (t - n));
}
function yM(e) {
  var r = e.lowerBounds[0][0], t = e.lowerBounds[e.lowerBounds.length - 1][0], n = e.lowerBounds[e.lowerBounds.length - 1][1], a = e.lowerBounds[0][1];
  return {
    name: e.name,
    hueRange: e.hueRange,
    lowerBounds: e.lowerBounds,
    saturationRange: [r, t],
    brightnessRange: [n, a]
  };
}
var SM = [
  {
    name: "monochrome",
    hueRange: null,
    lowerBounds: [
      [0, 0],
      [100, 0]
    ]
  },
  {
    name: "red",
    hueRange: [-26, 18],
    lowerBounds: [
      [20, 100],
      [30, 92],
      [40, 89],
      [50, 85],
      [60, 78],
      [70, 70],
      [80, 60],
      [90, 55],
      [100, 50]
    ]
  },
  {
    name: "orange",
    hueRange: [19, 46],
    lowerBounds: [
      [20, 100],
      [30, 93],
      [40, 88],
      [50, 86],
      [60, 85],
      [70, 70],
      [100, 70]
    ]
  },
  {
    name: "yellow",
    hueRange: [47, 62],
    lowerBounds: [
      [25, 100],
      [40, 94],
      [50, 89],
      [60, 86],
      [70, 84],
      [80, 82],
      [90, 80],
      [100, 75]
    ]
  },
  {
    name: "green",
    hueRange: [63, 178],
    lowerBounds: [
      [30, 100],
      [40, 90],
      [50, 85],
      [60, 81],
      [70, 74],
      [80, 64],
      [90, 50],
      [100, 40]
    ]
  },
  {
    name: "blue",
    hueRange: [179, 257],
    lowerBounds: [
      [20, 100],
      [30, 86],
      [40, 80],
      [50, 74],
      [60, 60],
      [70, 52],
      [80, 44],
      [90, 39],
      [100, 35]
    ]
  },
  {
    name: "purple",
    hueRange: [258, 282],
    lowerBounds: [
      [20, 100],
      [30, 87],
      [40, 79],
      [50, 70],
      [60, 65],
      [70, 59],
      [80, 52],
      [90, 45],
      [100, 42]
    ]
  },
  {
    name: "pink",
    hueRange: [283, 334],
    lowerBounds: [
      [20, 100],
      [30, 90],
      [40, 86],
      [60, 84],
      [80, 80],
      [90, 75],
      [100, 73]
    ]
  }
], Ut = function(r, t, n) {
  var a = sg(r, "colors." + t, t), i = new kf(a), l = i.isValid;
  return l ? a : n;
}, DH = function(r) {
  return function(t) {
    var n = Ut(t, r), a = new kf(n).isDark();
    return a ? "dark" : "light";
  };
}, NH = function(r) {
  return function(t) {
    return DH(r)(t) === "dark";
  };
}, hc = function(r, t) {
  return function(n) {
    var a = Ut(n, r);
    return new kf(a).setAlpha(t).toRgbString();
  };
};
function mC(e, r) {
  return e === void 0 && (e = "1rem"), r === void 0 && (r = "rgba(255, 255, 255, 0.15)"), {
    backgroundImage: `linear-gradient(
    45deg,
    ` + r + ` 25%,
    transparent 25%,
    transparent 50%,
    ` + r + ` 50%,
    ` + r + ` 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: e + " " + e
  };
}
function LH(e) {
  var r = mM().toHexString();
  return !e || sV(e) ? r : e.string && e.colors ? zH(e.string, e.colors) : e.string && !e.colors ? FH(e.string) : e.colors && !e.string ? BH(e.colors) : r;
}
function FH(e) {
  var r = 0;
  if (e.length === 0)
    return r.toString();
  for (var t = 0; t < e.length; t += 1)
    r = e.charCodeAt(t) + ((r << 5) - r), r = r & r;
  for (var n = "#", a = 0; a < 3; a += 1) {
    var i = r >> a * 8 & 255;
    n += ("00" + i.toString(16)).substr(-2);
  }
  return n;
}
function zH(e, r) {
  var t = 0;
  if (e.length === 0)
    return r[0];
  for (var n = 0; n < e.length; n += 1)
    t = e.charCodeAt(n) + ((t << 5) - t), t = t & t;
  return t = (t % r.length + r.length) % r.length, r[t];
}
function BH(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function re(e, r) {
  return function(t) {
    return t.colorMode === "dark" ? r : e;
  };
}
function jf(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r ? r === "vertical" ? t : n : {};
}
function wS() {
  return wS = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, wS.apply(this, arguments);
}
var UH = function(r) {
  return bV({
    condition: !0,
    message: ["[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon", "simply pass the breakpoints as an object. Remove the createBreakpoint(..) call"].join("")
  }), wS({
    base: "0em"
  }, r);
};
function bC(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function VH(e, r, t) {
  return r && bC(e.prototype, r), t && bC(e, t), e;
}
var WH = /* @__PURE__ */ function() {
  function e(r) {
    var t = this;
    this.map = {}, this.called = !1, this.assert = function() {
      if (!t.called) {
        t.called = !0;
        return;
      }
      throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }, this.parts = function() {
      t.assert();
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        t.map[c] = t.toPart(c);
      }
      return t;
    }, this.extend = function() {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        c in t.map || (t.map[c] = t.toPart(c));
      }
      return t;
    }, this.toPart = function(n) {
      var a = ["container", "root"].includes(n != null ? n : "") ? [t.name] : [t.name, n], i = a.filter(Boolean).join("__"), l = "chakra-" + i, u = {
        className: l,
        selector: "." + l,
        toString: function() {
          return n;
        }
      };
      return u;
    }, this.__type = {};
  }
  return VH(e, [{
    key: "selectors",
    get: (
      /**
       * Get all selectors for the component anatomy
       */
      function() {
        var t = Jd(Object.entries(this.map).map(function(n) {
          var a = n[0], i = n[1];
          return [a, i.selector];
        }));
        return t;
      }
    )
    /**
     * Get all classNames for the component anatomy
     */
  }, {
    key: "classNames",
    get: function() {
      var t = Jd(Object.entries(this.map).map(function(n) {
        var a = n[0], i = n[1];
        return [a, i.className];
      }));
      return t;
    }
    /**
     * Get all parts as array of string
     */
  }, {
    key: "keys",
    get: function() {
      return Object.keys(this.map);
    }
    /**
     * Creates the part object for the given part
     */
  }]), e;
}();
function et(e) {
  return new WH(e);
}
function xM(e) {
  return In(e) && e.reference ? e.reference : String(e);
}
var dg = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(xM).join(" " + r + " ").replace(/calc/g, "");
}, yC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + dg.apply(void 0, ["+"].concat(t)) + ")";
}, SC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + dg.apply(void 0, ["-"].concat(t)) + ")";
}, _S = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + dg.apply(void 0, ["*"].concat(t)) + ")";
}, xC = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + dg.apply(void 0, ["/"].concat(t)) + ")";
}, $C = function(r) {
  var t = xM(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : _S(t, -1);
}, Pi = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pi(yC.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pi(SC.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pi(_S.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Pi(xC.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return Pi($C(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: yC,
  subtract: SC,
  multiply: _S,
  divide: xC,
  negate: $C
});
function HH(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function GH(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function $M(e) {
  var r = GH(e.toString());
  return r.includes("\\.") ? e : HH(e) ? r.replace(".", "\\.") : e;
}
function YH(e, r) {
  return r === void 0 && (r = ""), [r, $M(e)].filter(Boolean).join("-");
}
function KH(e, r) {
  return "var(" + $M(e) + (r ? ", " + r : "") + ")";
}
function ZH(e, r) {
  return r === void 0 && (r = ""), "--" + YH(e, r);
}
function ya(e, r) {
  var t = ZH(e, r == null ? void 0 : r.prefix);
  return {
    variable: t,
    reference: KH(t, qH(r == null ? void 0 : r.fallback))
  };
}
function qH(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
var QH = et("accordion").parts("root", "container", "button", "panel").extend("icon"), XH = et("alert").parts("title", "description", "container").extend("icon"), JH = et("avatar").parts("label", "badge", "container").extend("excessLabel", "group"), eG = et("breadcrumb").parts("link", "item", "container").extend("separator");
et("button").parts();
var rG = et("checkbox").parts("control", "icon", "container").extend("label");
et("progress").parts("track", "filledTrack").extend("label");
var tG = et("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), nG = et("editable").parts("preview", "input", "textarea"), aG = et("form").parts("container", "requiredIndicator", "helperText"), oG = et("formError").parts("text", "icon"), iG = et("input").parts("addon", "field", "element"), sG = et("list").parts("container", "item", "icon"), lG = et("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider"), uG = et("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), cG = et("numberinput").parts("root", "field", "stepperGroup", "stepper");
et("pininput").parts("field");
var dG = et("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton"), fG = et("progress").parts("label", "filledTrack", "track"), vG = et("radio").parts("container", "control", "label"), hG = et("select").parts("field", "icon"), pG = et("slider").parts("container", "track", "thumb", "filledTrack"), gG = et("stat").parts("container", "label", "helpText", "number", "icon"), mG = et("switch").parts("container", "track", "thumb"), bG = et("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption"), yG = et("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator"), SG = et("tag").parts("container", "label", "closeButton"), wM = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, xG = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, $G = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "1rem",
  _focus: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: 4,
  py: 2
}, wG = {
  pt: 2,
  px: 4,
  pb: 5
}, _G = {
  fontSize: "1.25em"
}, TG = {
  root: {},
  container: xG,
  button: $G,
  panel: wG,
  icon: _G
}, CG = {
  parts: QH.keys,
  baseStyle: TG
}, EG = {
  container: {
    px: 4,
    py: 3
  },
  title: {
    fontWeight: "bold",
    lineHeight: 6,
    marginEnd: 2
  },
  description: {
    lineHeight: 6
  },
  icon: {
    flexShrink: 0,
    marginEnd: 3,
    w: 5,
    h: 6
  }
};
function Z2(e) {
  var r = e.theme, t = e.colorScheme, n = Ut(r, t + ".100", t), a = hc(t + ".200", 0.16)(r);
  return re(n, a)(e);
}
var AG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: Z2(r)
    },
    icon: {
      color: re(t + ".500", t + ".200")(r)
    }
  };
}, IG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      paddingStart: 3,
      borderStartWidth: "4px",
      borderStartColor: re(t + ".500", t + ".200")(r),
      bg: Z2(r)
    },
    icon: {
      color: re(t + ".500", t + ".200")(r)
    }
  };
}, OG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      pt: 2,
      borderTopWidth: "4px",
      borderTopColor: re(t + ".500", t + ".200")(r),
      bg: Z2(r)
    },
    icon: {
      color: re(t + ".500", t + ".200")(r)
    }
  };
}, MG = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: re(t + ".500", t + ".200")(r),
      color: re("white", "gray.900")(r)
    }
  };
}, RG = {
  subtle: AG,
  "left-accent": IG,
  "top-accent": OG,
  solid: MG
}, PG = {
  variant: "subtle",
  colorScheme: "blue"
}, kG = {
  parts: XH.keys,
  baseStyle: EG,
  variants: RG,
  defaultProps: PG
}, jG = function(r) {
  return {
    transform: "translate(25%, 25%)",
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: re("white", "gray.800")(r)
  };
}, DG = function(r) {
  return {
    bg: re("gray.200", "whiteAlpha.400")(r)
  };
}, NG = function(r) {
  var t = r.name, n = r.theme, a = t ? LH({
    string: t
  }) : "gray.400", i = NH(a)(n), l = "white";
  i || (l = "gray.800");
  var u = re("white", "gray.800")(r);
  return {
    bg: a,
    color: l,
    borderColor: u,
    verticalAlign: "top"
  };
}, LG = function(r) {
  return {
    badge: jG(r),
    excessLabel: DG(r),
    container: NG(r)
  };
};
function vs(e) {
  var r = pM[e];
  return {
    container: {
      width: e,
      height: e,
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)"
    },
    excessLabel: {
      width: e,
      height: e
    },
    label: {
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)",
      lineHeight: e !== "100%" ? r != null ? r : e : void 0
    }
  };
}
var FG = {
  "2xs": vs("4"),
  xs: vs("6"),
  sm: vs("8"),
  md: vs("12"),
  lg: vs("16"),
  xl: vs("24"),
  "2xl": vs("32"),
  full: vs("100%")
}, zG = {
  size: "md"
}, BG = {
  parts: JH.keys,
  baseStyle: LG,
  sizes: FG,
  defaultProps: zG
}, UG = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, VG = function(r) {
  var t = r.colorScheme, n = r.theme, a = hc(t + ".500", 0.6)(n);
  return {
    bg: re(t + ".500", a)(r),
    color: re("white", "whiteAlpha.800")(r)
  };
}, WG = function(r) {
  var t = r.colorScheme, n = r.theme, a = hc(t + ".200", 0.16)(n);
  return {
    bg: re(t + ".100", a)(r),
    color: re(t + ".800", t + ".200")(r)
  };
}, HG = function(r) {
  var t = r.colorScheme, n = r.theme, a = hc(t + ".200", 0.8)(n), i = Ut(n, t + ".500"), l = re(i, a)(r);
  return {
    color: l,
    boxShadow: "inset 0 0 0px 1px " + l
  };
}, GG = {
  solid: VG,
  subtle: WG,
  outline: HG
}, YG = {
  variant: "subtle",
  colorScheme: "gray"
}, tc = {
  baseStyle: UG,
  variants: GG,
  defaultProps: YG
}, KG = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, ZG = {
  link: KG
}, qG = {
  parts: eG.keys,
  baseStyle: ZG
}, QG = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focus: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, _M = function(r) {
  var t = r.colorScheme, n = r.theme;
  if (t === "gray")
    return {
      color: re("inherit", "whiteAlpha.900")(r),
      _hover: {
        bg: re("gray.100", "whiteAlpha.200")(r)
      },
      _active: {
        bg: re("gray.200", "whiteAlpha.300")(r)
      }
    };
  var a = hc(t + ".200", 0.12)(n), i = hc(t + ".200", 0.24)(n);
  return {
    color: re(t + ".600", t + ".200")(r),
    bg: "transparent",
    _hover: {
      bg: re(t + ".50", a)(r)
    },
    _active: {
      bg: re(t + ".100", i)(r)
    }
  };
}, XG = function(r) {
  var t = r.colorScheme, n = re("gray.200", "whiteAlpha.300")(r);
  return It({
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor"
  }, _M(r));
}, JG = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, eY = function(r) {
  var t, n = r.colorScheme;
  if (n === "gray") {
    var a = re("gray.100", "whiteAlpha.200")(r);
    return {
      bg: a,
      _hover: {
        bg: re("gray.200", "whiteAlpha.300")(r),
        _disabled: {
          bg: a
        }
      },
      _active: {
        bg: re("gray.300", "whiteAlpha.400")(r)
      }
    };
  }
  var i = (t = JG[n]) != null ? t : {}, l = i.bg, u = l === void 0 ? n + ".500" : l, c = i.color, f = c === void 0 ? "white" : c, h = i.hoverBg, p = h === void 0 ? n + ".600" : h, g = i.activeBg, y = g === void 0 ? n + ".700" : g, S = re(u, n + ".200")(r);
  return {
    bg: S,
    color: re(f, "gray.800")(r),
    _hover: {
      bg: re(p, n + ".300")(r),
      _disabled: {
        bg: S
      }
    },
    _active: {
      bg: re(y, n + ".400")(r)
    }
  };
}, rY = function(r) {
  var t = r.colorScheme;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: re(t + ".500", t + ".200")(r),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: re(t + ".700", t + ".500")(r)
    }
  };
}, tY = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: 0,
  p: 0
}, nY = {
  ghost: _M,
  outline: XG,
  solid: eY,
  link: rY,
  unstyled: tY
}, aY = {
  lg: {
    h: 12,
    minW: 12,
    fontSize: "lg",
    px: 6
  },
  md: {
    h: 10,
    minW: 10,
    fontSize: "md",
    px: 4
  },
  sm: {
    h: 8,
    minW: 8,
    fontSize: "sm",
    px: 3
  },
  xs: {
    h: 6,
    minW: 6,
    fontSize: "xs",
    px: 2
  }
}, oY = {
  variant: "solid",
  size: "md",
  colorScheme: "gray"
}, iY = {
  baseStyle: QG,
  variants: nY,
  sizes: aY,
  defaultProps: oY
}, sY = function(r) {
  var t = r.colorScheme;
  return {
    w: "100%",
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: re(t + ".500", t + ".200")(r),
      borderColor: re(t + ".500", t + ".200")(r),
      color: re("white", "gray.900")(r),
      _hover: {
        bg: re(t + ".600", t + ".300")(r),
        borderColor: re(t + ".600", t + ".300")(r)
      },
      _disabled: {
        borderColor: re("gray.200", "transparent")(r),
        bg: re("gray.200", "whiteAlpha.300")(r),
        color: re("gray.500", "whiteAlpha.500")(r)
      }
    },
    _indeterminate: {
      bg: re(t + ".500", t + ".200")(r),
      borderColor: re(t + ".500", t + ".200")(r),
      color: re("white", "gray.900")(r)
    },
    _disabled: {
      bg: re("gray.100", "whiteAlpha.100")(r),
      borderColor: re("gray.100", "transparent")(r)
    },
    _focus: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: re("red.500", "red.300")(r)
    }
  };
}, lY = {
  _disabled: {
    cursor: "not-allowed"
  }
}, uY = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, cY = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, dY = function(r) {
  return {
    icon: cY,
    container: lY,
    control: sY(r),
    label: uY
  };
}, fY = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.45rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "0.625rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "0.625rem"
    }
  }
}, vY = {
  size: "md",
  colorScheme: "blue"
}, Xp = {
  parts: rG.keys,
  baseStyle: dY,
  sizes: fY,
  defaultProps: vY
}, Qv, Xv, Jv, Cd = ya("close-button-size"), hY = function(r) {
  var t = re("blackAlpha.100", "whiteAlpha.100")(r), n = re("blackAlpha.200", "whiteAlpha.200")(r);
  return {
    w: [Cd.reference],
    h: [Cd.reference],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      bg: t
    },
    _active: {
      bg: n
    },
    _focus: {
      boxShadow: "outline"
    }
  };
}, pY = {
  lg: (Qv = {}, Qv[Cd.variable] = "40px", Qv.fontSize = "16px", Qv),
  md: (Xv = {}, Xv[Cd.variable] = "32px", Xv.fontSize = "12px", Xv),
  sm: (Jv = {}, Jv[Cd.variable] = "24px", Jv.fontSize = "10px", Jv)
}, gY = {
  size: "md"
}, mY = {
  baseStyle: hY,
  sizes: pY,
  defaultProps: gY
}, bY = tc.variants, yY = tc.defaultProps, SY = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm"
}, xY = {
  baseStyle: SY,
  variants: bY,
  defaultProps: yY
}, $Y = {
  w: "100%",
  mx: "auto",
  maxW: "60ch",
  px: "1rem"
}, wY = {
  baseStyle: $Y
}, _Y = {
  opacity: 0.6,
  borderColor: "inherit"
}, TY = {
  borderStyle: "solid"
}, CY = {
  borderStyle: "dashed"
}, EY = {
  solid: TY,
  dashed: CY
}, AY = {
  variant: "solid"
}, IY = {
  baseStyle: _Y,
  variants: EY,
  defaultProps: AY
};
function Ou(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      h: "100vh"
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var OY = {
  bg: "blackAlpha.600",
  zIndex: "overlay"
}, MY = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, RY = function(r) {
  var t = r.isFullHeight;
  return It({}, t && {
    height: "100vh"
  }, {
    zIndex: "modal",
    maxH: "100vh",
    bg: re("white", "gray.700")(r),
    color: "inherit",
    boxShadow: re("lg", "dark-lg")(r)
  });
}, PY = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, kY = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, jY = {
  px: 6,
  py: 2,
  flex: 1,
  overflow: "auto"
}, DY = {
  px: 6,
  py: 4
}, NY = function(r) {
  return {
    overlay: OY,
    dialogContainer: MY,
    dialog: RY(r),
    header: PY,
    closeButton: kY,
    body: jY,
    footer: DY
  };
}, LY = {
  xs: Ou("xs"),
  sm: Ou("md"),
  md: Ou("lg"),
  lg: Ou("2xl"),
  xl: Ou("4xl"),
  full: Ou("full")
}, FY = {
  size: "xs"
}, zY = {
  parts: tG.keys,
  baseStyle: NY,
  sizes: LY,
  defaultProps: FY
}, BY = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal"
}, UY = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, VY = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, WY = {
  preview: BY,
  input: UY,
  textarea: VY
}, HY = {
  parts: nG.keys,
  baseStyle: WY
}, GY = function(r) {
  return {
    marginStart: 1,
    color: re("red.500", "red.300")(r)
  };
}, YY = function(r) {
  return {
    mt: 2,
    color: re("gray.500", "whiteAlpha.600")(r),
    lineHeight: "normal",
    fontSize: "sm"
  };
}, KY = function(r) {
  return {
    container: {
      width: "100%",
      position: "relative"
    },
    requiredIndicator: GY(r),
    helperText: YY(r)
  };
}, ZY = {
  parts: aG.keys,
  baseStyle: KY
}, qY = function(r) {
  return {
    color: re("red.500", "red.300")(r),
    mt: 2,
    fontSize: "sm",
    lineHeight: "normal"
  };
}, QY = function(r) {
  return {
    marginEnd: "0.5em",
    color: re("red.500", "red.300")(r)
  };
}, XY = function(r) {
  return {
    text: qY(r),
    icon: QY(r)
  };
}, JY = {
  parts: oG.keys,
  baseStyle: XY
}, eK = {
  fontSize: "md",
  marginEnd: 3,
  mb: 2,
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, rK = {
  baseStyle: eK
}, tK = {
  fontFamily: "heading",
  fontWeight: "bold"
}, nK = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, aK = {
  size: "xl"
}, oK = {
  baseStyle: tK,
  sizes: nK,
  defaultProps: aK
}, iK = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal"
  }
}, hs = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: 6,
    borderRadius: "sm"
  }
}, sK = {
  lg: {
    field: hs.lg,
    addon: hs.lg
  },
  md: {
    field: hs.md,
    addon: hs.md
  },
  sm: {
    field: hs.sm,
    addon: hs.sm
  },
  xs: {
    field: hs.xs,
    addon: hs.xs
  }
};
function q2(e) {
  var r = e.focusBorderColor, t = e.errorBorderColor;
  return {
    focusBorderColor: r || re("blue.500", "blue.300")(e),
    errorBorderColor: t || re("red.500", "red.300")(e)
  };
}
var lK = function(r) {
  var t = r.theme, n = q2(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: re("gray.300", "whiteAlpha.400")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: Ut(t, i),
        boxShadow: "0 0 0 1px " + Ut(t, i)
      },
      _focus: {
        zIndex: 1,
        borderColor: Ut(t, a),
        boxShadow: "0 0 0 1px " + Ut(t, a)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: re("inherit", "whiteAlpha.50")(r),
      bg: re("gray.100", "whiteAlpha.300")(r)
    }
  };
}, uK = function(r) {
  var t = r.theme, n = q2(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: re("gray.100", "whiteAlpha.50")(r),
      _hover: {
        bg: re("gray.200", "whiteAlpha.100")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: Ut(t, i)
      },
      _focus: {
        bg: "transparent",
        borderColor: Ut(t, a)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: re("gray.100", "whiteAlpha.50")(r)
    }
  };
}, cK = function(r) {
  var t = r.theme, n = q2(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: Ut(t, i),
        boxShadow: "0px 1px 0px 0px " + Ut(t, i)
      },
      _focus: {
        borderColor: Ut(t, a),
        boxShadow: "0px 1px 0px 0px " + Ut(t, a)
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent"
    }
  };
}, dK = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, fK = {
  outline: lK,
  filled: uK,
  flushed: cK,
  unstyled: dK
}, vK = {
  size: "md",
  variant: "outline"
}, vt = {
  parts: iG.keys,
  baseStyle: iK,
  sizes: sK,
  variants: fK,
  defaultProps: vK
}, hK = function(r) {
  return {
    bg: re("gray.100", "whiteAlpha")(r),
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
  };
}, pK = {
  baseStyle: hK
}, gK = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, mK = {
  baseStyle: gK
}, bK = {
  marginEnd: "0.5rem",
  display: "inline",
  verticalAlign: "text-bottom"
}, yK = {
  container: {},
  item: {},
  icon: bK
}, SK = {
  parts: sG.keys,
  baseStyle: yK
}, xK = function(r) {
  return {
    bg: re("#fff", "gray.700")(r),
    boxShadow: re("sm", "dark-lg")(r),
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px"
  };
}, $K = function(r) {
  return {
    py: "0.4rem",
    px: "0.8rem",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
      bg: re("gray.100", "whiteAlpha.100")(r)
    },
    _active: {
      bg: re("gray.200", "whiteAlpha.200")(r)
    },
    _expanded: {
      bg: re("gray.100", "whiteAlpha.100")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, wK = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, _K = {
  opacity: 0.6
}, TK = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "0.5rem",
  opacity: 0.6
}, CK = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, EK = function(r) {
  return {
    button: CK,
    list: xK(r),
    item: $K(r),
    groupTitle: wK,
    command: _K,
    divider: TK
  };
}, AK = {
  parts: lG.keys,
  baseStyle: EK
}, IK = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, OK = function(r) {
  var t = r.isCentered, n = r.scrollBehavior;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto"
  };
}, MK = function(r) {
  var t = r.scrollBehavior;
  return {
    borderRadius: "md",
    bg: re("white", "gray.700")(r),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: t === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: re("lg", "dark-lg")(r)
  };
}, RK = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, PK = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, kK = function(r) {
  var t = r.scrollBehavior;
  return {
    px: 6,
    py: 2,
    flex: 1,
    overflow: t === "inside" ? "auto" : void 0
  };
}, jK = {
  px: 6,
  py: 4
}, DK = function(r) {
  return {
    overlay: IK,
    dialogContainer: OK(r),
    dialog: MK(r),
    header: RK,
    closeButton: PK,
    body: kK(r),
    footer: jK
  };
};
function no(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var NK = {
  xs: no("xs"),
  sm: no("sm"),
  md: no("md"),
  lg: no("lg"),
  xl: no("xl"),
  "2xl": no("2xl"),
  "3xl": no("3xl"),
  "4xl": no("4xl"),
  "5xl": no("5xl"),
  "6xl": no("6xl"),
  full: no("full")
}, LK = {
  size: "md"
}, FK = {
  parts: uG.keys,
  baseStyle: DK,
  sizes: NK,
  defaultProps: LK
}, eh, wC, _C, zK = vt.variants, BK = vt.defaultProps, Q2 = ya("number-input-stepper-width"), TM = ya("number-input-input-padding"), UK = Pi(Q2).add("0.5rem").toString(), VK = (eh = {}, eh[Q2.variable] = "24px", eh[TM.variable] = UK, eh), WK = (wC = (_C = vt.baseStyle) == null ? void 0 : _C.field) != null ? wC : {}, HK = {
  width: [Q2.reference]
}, GK = function(r) {
  return {
    borderStart: "1px solid",
    borderStartColor: re("inherit", "whiteAlpha.300")(r),
    color: re("inherit", "whiteAlpha.800")(r),
    _active: {
      bg: re("gray.200", "whiteAlpha.300")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, YK = function(r) {
  return {
    root: VK,
    field: WK,
    stepperGroup: HK,
    stepper: GK(r)
  };
};
function rh(e) {
  var r, t, n = vt.sizes[e], a = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, i = (r = (t = n.field) == null ? void 0 : t.fontSize) != null ? r : "md", l = wM.fontSizes[i.toString()];
  return {
    field: It({}, n.field, {
      paddingInlineEnd: TM.reference,
      verticalAlign: "top"
    }),
    stepper: {
      fontSize: Pi(l).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: a[e]
      },
      _last: {
        borderBottomEndRadius: a[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  };
}
var KK = {
  xs: rh("xs"),
  sm: rh("sm"),
  md: rh("md"),
  lg: rh("lg")
}, ZK = {
  parts: cG.keys,
  baseStyle: YK,
  sizes: KK,
  variants: zK,
  defaultProps: BK
}, TC, qK = It({}, vt.baseStyle.field, {
  textAlign: "center"
}), QK = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
}, XK = {
  outline: function(r) {
    var t;
    return (t = vt.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = vt.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = vt.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (TC = vt.variants.unstyled.field) != null ? TC : {}
}, JK = vt.defaultProps, eZ = {
  baseStyle: qK,
  sizes: QK,
  variants: XK,
  defaultProps: JK
}, Nb = ya("popper-bg"), rZ = ya("popper-arrow-bg"), tZ = ya("popper-arrow-shadow-color"), nZ = {
  zIndex: 10
}, aZ = function(r) {
  var t, n = re("white", "gray.700")(r), a = re("gray.200", "whiteAlpha.300")(r);
  return t = {}, t[Nb.variable] = "colors." + n, t.bg = Nb.reference, t[rZ.variable] = Nb.reference, t[tZ.variable] = "colors." + a, t.width = "xs", t.border = "1px solid", t.borderColor = "inherit", t.borderRadius = "md", t.boxShadow = "sm", t.zIndex = "inherit", t._focus = {
    outline: 0,
    boxShadow: "outline"
  }, t;
}, oZ = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, iZ = {
  px: 3,
  py: 2
}, sZ = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, lZ = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, uZ = function(r) {
  return {
    popper: nZ,
    content: aZ(r),
    header: oZ,
    body: iZ,
    footer: sZ,
    arrow: {},
    closeButton: lZ
  };
}, cZ = {
  parts: dG.keys,
  baseStyle: uZ
};
function dZ(e) {
  var r = e.colorScheme, t = e.theme, n = e.isIndeterminate, a = e.hasStripe, i = re(mC(), mC("1rem", "rgba(0,0,0,0.1)"))(e), l = re(r + ".500", r + ".200")(e), u = `linear-gradient(
    to right,
    transparent 0%,
    ` + Ut(t, l) + ` 50%,
    transparent 100%
  )`, c = !n && a;
  return It({}, c && i, n ? {
    bgImage: u
  } : {
    bgColor: l
  });
}
var fZ = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, vZ = function(r) {
  return {
    bg: re("gray.100", "whiteAlpha.300")(r)
  };
}, hZ = function(r) {
  return It({
    transitionProperty: "common",
    transitionDuration: "slow"
  }, dZ(r));
}, pZ = function(r) {
  return {
    label: fZ,
    filledTrack: hZ(r),
    track: vZ(r)
  };
}, gZ = {
  xs: {
    track: {
      h: "0.25rem"
    }
  },
  sm: {
    track: {
      h: "0.5rem"
    }
  },
  md: {
    track: {
      h: "0.75rem"
    }
  },
  lg: {
    track: {
      h: "1rem"
    }
  }
}, mZ = {
  size: "md",
  colorScheme: "blue"
}, bZ = {
  parts: fG.keys,
  sizes: gZ,
  baseStyle: pZ,
  defaultProps: mZ
}, yZ = function(r) {
  var t = Xp.baseStyle(r), n = t.control, a = n === void 0 ? {} : n;
  return It({}, a, {
    borderRadius: "full",
    _checked: It({}, a._checked, {
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    })
  });
}, SZ = function(r) {
  return {
    label: Xp.baseStyle(r).label,
    container: Xp.baseStyle(r).container,
    control: yZ(r)
  };
}, xZ = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, $Z = {
  size: "md",
  colorScheme: "blue"
}, wZ = {
  parts: vG.keys,
  baseStyle: SZ,
  sizes: xZ,
  defaultProps: $Z
}, _Z = function(r) {
  return It({}, vt.baseStyle.field, {
    bg: re("white", "gray.700")(r),
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    "> option, > optgroup": {
      bg: re("white", "gray.700")(r)
    }
  });
}, TZ = {
  width: "1.5rem",
  height: "100%",
  insetEnd: "0.5rem",
  position: "relative",
  color: "currentColor",
  fontSize: "1.25rem",
  _disabled: {
    opacity: 0.5
  }
}, CZ = function(r) {
  return {
    field: _Z(r),
    icon: TZ
  };
}, th = {
  paddingInlineEnd: "2rem"
}, EZ = Fa({}, vt.sizes, {
  lg: {
    field: th
  },
  md: {
    field: th
  },
  sm: {
    field: th
  },
  xs: {
    field: th,
    icon: {
      insetEnd: "0.25rem"
    }
  }
}), AZ = {
  parts: hG.keys,
  baseStyle: CZ,
  sizes: EZ,
  variants: vt.variants,
  defaultProps: vt.defaultProps
}, IZ = function(r, t) {
  return HO({
    from: {
      borderColor: r,
      background: r
    },
    to: {
      borderColor: t,
      background: t
    }
  });
}, OZ = function(r) {
  var t = re("gray.100", "gray.800")(r), n = re("gray.400", "gray.600")(r), a = r.startColor, i = a === void 0 ? t : a, l = r.endColor, u = l === void 0 ? n : l, c = r.speed, f = r.theme, h = Ut(f, i), p = Ut(f, u);
  return {
    opacity: 0.7,
    borderRadius: "2px",
    borderColor: h,
    background: p,
    animation: c + "s linear infinite alternate " + IZ(h, p)
  };
}, MZ = {
  baseStyle: OZ
}, RZ = function(r) {
  return {
    borderRadius: "md",
    fontWeight: "semibold",
    _focus: {
      boxShadow: "outline",
      padding: "1rem",
      position: "fixed",
      top: "1.5rem",
      insetStart: "1.5rem",
      bg: re("white", "gray.700")(r)
    }
  };
}, PZ = {
  baseStyle: RZ
};
function kZ(e) {
  return jf({
    orientation: e.orientation,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      _active: {
        transform: "translateX(-50%) scale(1.15)"
      }
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      _active: {
        transform: "translateY(-50%) scale(1.15)"
      }
    }
  });
}
var jZ = function(r) {
  var t = r.orientation;
  return It({
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    }
  }, jf({
    orientation: t,
    vertical: {
      h: "100%"
    },
    horizontal: {
      w: "100%"
    }
  }));
}, DZ = function(r) {
  return {
    overflow: "hidden",
    borderRadius: "sm",
    bg: re("gray.200", "whiteAlpha.200")(r),
    _disabled: {
      bg: re("gray.300", "whiteAlpha.300")(r)
    }
  };
}, NZ = function(r) {
  return It({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  }, kZ(r));
}, LZ = function(r) {
  var t = r.colorScheme;
  return {
    width: "inherit",
    height: "inherit",
    bg: re(t + ".500", t + ".200")(r)
  };
}, FZ = function(r) {
  return {
    container: jZ(r),
    track: DZ(r),
    thumb: NZ(r),
    filledTrack: LZ(r)
  };
}, zZ = function(r) {
  return {
    thumb: {
      w: "16px",
      h: "16px"
    },
    track: jf({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, BZ = function(r) {
  return {
    thumb: {
      w: "14px",
      h: "14px"
    },
    track: jf({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, UZ = function(r) {
  return {
    thumb: {
      w: "10px",
      h: "10px"
    },
    track: jf({
      orientation: r.orientation,
      horizontal: {
        h: "2px"
      },
      vertical: {
        w: "2px"
      }
    })
  };
}, VZ = {
  lg: zZ,
  md: BZ,
  sm: UZ
}, WZ = {
  size: "md",
  colorScheme: "blue"
}, HZ = {
  parts: pG.keys,
  sizes: VZ,
  baseStyle: FZ,
  defaultProps: WZ
}, Lb, Fb, zb, Bb, Ub, Ml = ya("spinner-size"), GZ = {
  width: [Ml.reference],
  height: [Ml.reference]
}, YZ = {
  xs: (Lb = {}, Lb[Ml.variable] = "0.75rem", Lb),
  sm: (Fb = {}, Fb[Ml.variable] = "1rem", Fb),
  md: (zb = {}, zb[Ml.variable] = "1.5rem", zb),
  lg: (Bb = {}, Bb[Ml.variable] = "2rem", Bb),
  xl: (Ub = {}, Ub[Ml.variable] = "3rem", Ub)
}, KZ = {
  size: "md"
}, ZZ = {
  baseStyle: GZ,
  sizes: YZ,
  defaultProps: KZ
}, qZ = {
  fontWeight: "medium"
}, QZ = {
  opacity: 0.8,
  marginBottom: 2
}, XZ = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, JZ = {
  marginEnd: 1,
  w: "14px",
  h: "14px",
  verticalAlign: "middle"
}, eq = {
  container: {},
  label: qZ,
  helpText: QZ,
  number: XZ,
  icon: JZ
}, rq = {
  md: {
    label: {
      fontSize: "sm"
    },
    helpText: {
      fontSize: "sm"
    },
    number: {
      fontSize: "2xl"
    }
  }
}, tq = {
  size: "md"
}, nq = {
  parts: gG.keys,
  baseStyle: eq,
  sizes: rq,
  defaultProps: tq
}, nh, ah, oh, Ed = ya("switch-track-width"), Gl = ya("switch-track-height"), Vb = ya("switch-track-diff"), aq = Pi.subtract(Ed, Gl), TS = ya("switch-thumb-x"), oq = function(r) {
  var t = r.colorScheme;
  return {
    borderRadius: "full",
    p: "2px",
    width: [Ed.reference],
    height: [Gl.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: re("gray.300", "whiteAlpha.400")(r),
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: re(t + ".500", t + ".200")(r)
    }
  };
}, iq = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Gl.reference],
  height: [Gl.reference],
  _checked: {
    transform: "translateX(" + TS.reference + ")"
  }
}, sq = function(r) {
  var t, n;
  return {
    container: (n = {}, n[Vb.variable] = aq, n[TS.variable] = Vb.reference, n._rtl = (t = {}, t[TS.variable] = Pi(Vb).negate().toString(), t), n),
    track: oq(r),
    thumb: iq
  };
}, lq = {
  sm: {
    container: (nh = {}, nh[Ed.variable] = "1.375rem", nh[Gl.variable] = "0.75rem", nh)
  },
  md: {
    container: (ah = {}, ah[Ed.variable] = "1.875rem", ah[Gl.variable] = "1rem", ah)
  },
  lg: {
    container: (oh = {}, oh[Ed.variable] = "2.875rem", oh[Gl.variable] = "1.5rem", oh)
  }
}, uq = {
  size: "md",
  colorScheme: "blue"
}, cq = {
  parts: mG.keys,
  baseStyle: sq,
  sizes: lq,
  defaultProps: uq
}, dq = {
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}, Jp = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, fq = function(r) {
  var t = r.colorScheme;
  return {
    th: It({
      color: re("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, Jp),
    td: It({
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, Jp),
    caption: {
      color: re("gray.600", "gray.100")(r)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, vq = function(r) {
  var t = r.colorScheme;
  return {
    th: It({
      color: re("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, Jp),
    td: It({
      borderBottom: "1px",
      borderColor: re(t + ".100", t + ".700")(r)
    }, Jp),
    caption: {
      color: re("gray.600", "gray.100")(r)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: re(t + ".100", t + ".700")(r)
          },
          td: {
            background: re(t + ".100", t + ".700")(r)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, hq = {
  simple: fq,
  striped: vq,
  unstyled: {}
}, pq = {
  sm: {
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  },
  md: {
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  },
  lg: {
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  }
}, gq = {
  variant: "simple",
  size: "md",
  colorScheme: "gray"
}, mq = {
  parts: bG.keys,
  baseStyle: dq,
  variants: hq,
  sizes: pq,
  defaultProps: gq
}, bq = function(r) {
  var t = r.orientation;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, yq = function(r) {
  var t = r.isFitted;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
      zIndex: 1,
      boxShadow: "outline"
    }
  };
}, Sq = function(r) {
  var t = r.align, n = t === void 0 ? "start" : t, a = r.orientation, i = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };
  return {
    justifyContent: i[n],
    flexDirection: a === "vertical" ? "column" : "row"
  };
}, xq = {
  p: 4
}, $q = function(r) {
  return {
    root: bq(r),
    tab: yq(r),
    tablist: Sq(r),
    tabpanel: xq
  };
}, wq = {
  sm: {
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  },
  md: {
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  },
  lg: {
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  }
}, _q = function(r) {
  var t, n, a = r.colorScheme, i = r.orientation, l = i === "vertical", u = i === "vertical" ? "borderStart" : "borderBottom", c = l ? "marginStart" : "marginBottom";
  return {
    tablist: (t = {}, t[u] = "2px solid", t.borderColor = "inherit", t),
    tab: (n = {}, n[u] = "2px solid", n.borderColor = "transparent", n[c] = "-2px", n._selected = {
      color: re(a + ".600", a + ".300")(r),
      borderColor: "currentColor"
    }, n._active = {
      bg: re("gray.200", "whiteAlpha.300")(r)
    }, n._disabled = {
      opacity: 0.4,
      cursor: "not-allowed"
    }, n)
  };
}, Tq = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      _selected: {
        color: re(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderBottomColor: re("white", "gray.800")(r)
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, Cq = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      bg: re("gray.50", "whiteAlpha.50")(r),
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        bg: re("#fff", "gray.800")(r),
        color: re(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, Eq = function(r) {
  var t = r.colorScheme, n = r.theme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: Ut(n, t + ".700"),
        bg: Ut(n, t + ".100")
      }
    }
  };
}, Aq = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: re("gray.600", "inherit")(r),
      _selected: {
        color: re("#fff", "gray.800")(r),
        bg: re(t + ".600", t + ".300")(r)
      }
    }
  };
}, Iq = {}, Oq = {
  line: _q,
  enclosed: Tq,
  "enclosed-colored": Cq,
  "soft-rounded": Eq,
  "solid-rounded": Aq,
  unstyled: Iq
}, Mq = {
  size: "md",
  variant: "line",
  colorScheme: "blue"
}, Rq = {
  parts: yG.keys,
  baseStyle: $q,
  sizes: wq,
  variants: Oq,
  defaultProps: Mq
}, Pq = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  _focus: {
    boxShadow: "outline"
  }
}, kq = {
  lineHeight: 1.2,
  overflow: "visible"
}, jq = {
  fontSize: "18px",
  w: "1.25rem",
  h: "1.25rem",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "0.375rem",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focus: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, Dq = {
  container: Pq,
  label: kq,
  closeButton: jq
}, Nq = {
  sm: {
    container: {
      minH: "1.25rem",
      minW: "1.25rem",
      fontSize: "xs",
      px: 2,
      borderRadius: "md"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  },
  md: {
    container: {
      minH: "1.5rem",
      minW: "1.5rem",
      fontSize: "sm",
      borderRadius: "md",
      px: 2
    }
  },
  lg: {
    container: {
      minH: 8,
      minW: 8,
      fontSize: "md",
      borderRadius: "md",
      px: 3
    }
  }
}, Lq = {
  subtle: function(r) {
    return {
      container: tc.variants.subtle(r)
    };
  },
  solid: function(r) {
    return {
      container: tc.variants.solid(r)
    };
  },
  outline: function(r) {
    return {
      container: tc.variants.outline(r)
    };
  }
}, Fq = {
  size: "md",
  variant: "subtle",
  colorScheme: "gray"
}, zq = {
  parts: SG.keys,
  variants: Lq,
  baseStyle: Dq,
  sizes: Nq,
  defaultProps: Fq
}, CC, EC, AC, IC, OC, Bq = It({}, vt.baseStyle.field, {
  paddingY: "8px",
  minHeight: "80px",
  lineHeight: "short",
  verticalAlign: "top"
}), Uq = {
  outline: function(r) {
    var t;
    return (t = vt.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = vt.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = vt.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (CC = vt.variants.unstyled.field) != null ? CC : {}
}, Vq = {
  xs: (EC = vt.sizes.xs.field) != null ? EC : {},
  sm: (AC = vt.sizes.sm.field) != null ? AC : {},
  md: (IC = vt.sizes.md.field) != null ? IC : {},
  lg: (OC = vt.sizes.lg.field) != null ? OC : {}
}, Wq = {
  size: "md",
  variant: "outline"
}, Hq = {
  baseStyle: Bq,
  sizes: Vq,
  variants: Uq,
  defaultProps: Wq
}, Wb = ya("tooltip-bg"), Gq = ya("popper-arrow-bg"), Yq = function(r) {
  var t, n = re("gray.700", "gray.300")(r);
  return t = {}, t[Wb.variable] = "colors." + n, t.px = "8px", t.py = "2px", t.bg = [Wb.reference], t[Gq.variable] = [Wb.reference], t.color = re("whiteAlpha.900", "gray.900")(r), t.borderRadius = "sm", t.fontWeight = "medium", t.fontSize = "sm", t.boxShadow = "md", t.maxW = "320px", t.zIndex = "tooltip", t;
}, Kq = {
  baseStyle: Yq
}, Zq = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Accordion: CG,
  Alert: kG,
  Avatar: BG,
  Badge: tc,
  Breadcrumb: qG,
  Button: iY,
  Checkbox: Xp,
  CloseButton: mY,
  Code: xY,
  Container: wY,
  Divider: IY,
  Drawer: zY,
  Editable: HY,
  Form: ZY,
  FormError: JY,
  FormLabel: rK,
  Heading: oK,
  Input: vt,
  Kbd: pK,
  Link: mK,
  List: SK,
  Menu: AK,
  Modal: FK,
  NumberInput: ZK,
  PinInput: eZ,
  Popover: cZ,
  Progress: bZ,
  Radio: wZ,
  Select: AZ,
  Skeleton: MZ,
  SkipLink: PZ,
  Slider: HZ,
  Spinner: ZZ,
  Stat: nq,
  Switch: cq,
  Table: mq,
  Tabs: Rq,
  Tag: zq,
  Textarea: Hq,
  Tooltip: Kq
}), qq = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, Qq = UH({
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}), Xq = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, Jq = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, eQ = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, rQ = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, tQ = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, nQ = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, aQ = {
  property: rQ,
  easing: tQ,
  duration: nQ
}, oQ = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, iQ = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, sQ = It({
  breakpoints: Qq,
  zIndices: oQ,
  radii: Jq,
  blur: iQ,
  colors: Xq
}, wM, {
  sizes: pM,
  shadows: eQ,
  space: hM,
  borders: qq,
  transition: aQ
}), lQ = {
  global: function(r) {
    return {
      body: {
        fontFamily: "body",
        color: re("gray.800", "whiteAlpha.900")(r),
        bg: re("white", "gray.800")(r),
        transitionProperty: "background-color",
        transitionDuration: "normal",
        lineHeight: "base"
      },
      "*::placeholder": {
        color: re("gray.400", "whiteAlpha.400")(r)
      },
      "*, *::before, &::after": {
        borderColor: re("gray.200", "whiteAlpha.300")(r),
        wordWrap: "break-word"
      }
    };
  }
}, uQ = lQ, cQ = ["borders", "breakpoints", "colors", "components", "config", "direction", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "shadows", "sizes", "space", "styles", "transition", "zIndices"];
function dQ(e) {
  return In(e) ? cQ.every(function(r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }) : !1;
}
var fQ = "ltr", vQ = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, Df = It({
  direction: fQ
}, sQ, {
  components: Zq,
  styles: uQ,
  config: vQ
});
function nc() {
  return nc = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, nc.apply(this, arguments);
}
function hQ(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var pQ = ["as", "viewBox", "color", "focusable", "children", "className", "__css"], MC = {
  path: /* @__PURE__ */ I.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /* @__PURE__ */ I.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /* @__PURE__ */ I.createElement("path", {
    fill: "currentColor",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /* @__PURE__ */ I.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  })),
  viewBox: "0 0 24 24"
}, gQ = /* @__PURE__ */ Mn(function(e, r) {
  var t = e.as, n = e.viewBox, a = e.color, i = a === void 0 ? "currentColor" : a, l = e.focusable, u = l === void 0 ? !1 : l, c = e.children, f = e.className, h = e.__css, p = hQ(e, pQ), g = Va("chakra-icon", f), y = nc({
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: i
  }, h), S = {
    ref: r,
    focusable: u,
    className: g,
    __css: y
  }, x = n != null ? n : MC.viewBox;
  if (t && typeof t != "string")
    return /* @__PURE__ */ I.createElement(Vt.svg, nc({
      as: t
    }, S, p));
  var _ = c != null ? c : MC.path;
  return /* @__PURE__ */ I.createElement(Vt.svg, nc({
    verticalAlign: "middle",
    viewBox: x
  }, S, p), _);
});
function De(e) {
  var r = e.viewBox, t = r === void 0 ? "0 0 24 24" : r, n = e.d;
  e.displayName;
  var a = e.defaultProps, i = a === void 0 ? {} : a, l = I.Children.toArray(e.path), u = /* @__PURE__ */ Mn(function(c, f) {
    return /* @__PURE__ */ I.createElement(gQ, nc({
      ref: f,
      viewBox: t
    }, i, c), l.length ? l : /* @__PURE__ */ I.createElement("path", {
      fill: "currentColor",
      d: n
    }));
  });
  return u;
}
var CS = function(e, r) {
  return CS = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
  }, CS(e, r);
};
function CM(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  CS(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var fe = function() {
  return fe = Object.assign || function(r) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, fe.apply(this, arguments);
};
function Wa(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}
function Cc(e, r, t, n) {
  function a(i) {
    return i instanceof t ? i : new t(function(l) {
      l(i);
    });
  }
  return new (t || (t = Promise))(function(i, l) {
    function u(h) {
      try {
        f(n.next(h));
      } catch (p) {
        l(p);
      }
    }
    function c(h) {
      try {
        f(n.throw(h));
      } catch (p) {
        l(p);
      }
    }
    function f(h) {
      h.done ? i(h.value) : a(h.value).then(u, c);
    }
    f((n = n.apply(e, r || [])).next());
  });
}
function Ec(e, r) {
  var t = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, l;
  return l = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function u(f) {
    return function(h) {
      return c([f, h]);
    };
  }
  function c(f) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; l && (l = 0, f[0] && (t = 0)), t; )
      try {
        if (n = 1, a && (i = f[0] & 2 ? a.return : f[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, f[1])).done)
          return i;
        switch (a = 0, i && (f = [f[0] & 2, i.value]), f[0]) {
          case 0:
          case 1:
            i = f;
            break;
          case 4:
            return t.label++, { value: f[1], done: !1 };
          case 5:
            t.label++, a = f[1], f = [0];
            continue;
          case 7:
            f = t.ops.pop(), t.trys.pop();
            continue;
          default:
            if (i = t.trys, !(i = i.length > 0 && i[i.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              t = 0;
              continue;
            }
            if (f[0] === 3 && (!i || f[1] > i[0] && f[1] < i[3])) {
              t.label = f[1];
              break;
            }
            if (f[0] === 6 && t.label < i[1]) {
              t.label = i[1], i = f;
              break;
            }
            if (i && t.label < i[2]) {
              t.label = i[2], t.ops.push(f);
              break;
            }
            i[2] && t.ops.pop(), t.trys.pop();
            continue;
        }
        f = r.call(e, t);
      } catch (h) {
        f = [6, h], a = 0;
      } finally {
        n = i = 0;
      }
    if (f[0] & 5)
      throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function mQ(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], n = 0;
  if (t)
    return t.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function pt(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t)
    return e;
  var n = t.call(e), a, i = [], l;
  try {
    for (; (r === void 0 || r-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (u) {
    l = { error: u };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return i;
}
function pa(e, r, t) {
  if (t || arguments.length === 2)
    for (var n = 0, a = r.length, i; n < a; n++)
      (i || !(n in r)) && (i || (i = Array.prototype.slice.call(r, 0, n)), i[n] = r[n]);
  return e.concat(i || Array.prototype.slice.call(r));
}
var bQ = "production", X2 = typeof process == "undefined" || process.env === void 0 ? bQ : "production", Ci = function(e) {
  return {
    isEnabled: function(r) {
      return e.some(function(t) {
        return !!r[t];
      });
    }
  };
}, af = {
  measureLayout: Ci(["layout", "layoutId", "drag"]),
  animation: Ci([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Ci(["exit"]),
  drag: Ci(["drag", "dragControls"]),
  focus: Ci(["whileFocus"]),
  hover: Ci(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Ci(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Ci([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Ci([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function yQ(e) {
  for (var r in e)
    e[r] !== null && (r === "projectionNodeConstructor" ? af.projectionNodeConstructor = e[r] : af[r].Component = e[r]);
}
var SQ = function() {
}, e0 = function() {
}, EM = On({ strict: !1 }), AM = Object.keys(af), xQ = AM.length;
function $Q(e, r, t) {
  var n = [], a = zr(EM);
  if (!r)
    return null;
  X2 !== "production" && t && a.strict;
  for (var i = 0; i < xQ; i++) {
    var l = AM[i], u = af[l], c = u.isEnabled, f = u.Component;
    c(e) && f && n.push(I.createElement(f, fe({ key: l }, e, { visualElement: r })));
  }
  return n;
}
var J2 = On({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), fg = On({});
function wQ() {
  return zr(fg).visualElement;
}
var Nf = On(null), Ac = typeof document != "undefined", r0 = Ac ? $O : ar, ES = { current: null }, IM = !1;
function _Q() {
  if (IM = !0, !!Ac)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), r = function() {
        return ES.current = e.matches;
      };
      e.addListener(r), r();
    } else
      ES.current = !1;
}
function TQ() {
  !IM && _Q();
  var e = pt(Ye(ES.current), 1), r = e[0];
  return r;
}
function CQ() {
  var e = TQ(), r = zr(J2).reducedMotion;
  return r === "never" ? !1 : r === "always" ? !0 : e;
}
function EQ(e, r, t, n) {
  var a = zr(EM), i = wQ(), l = zr(Nf), u = CQ(), c = Qe(void 0);
  n || (n = a.renderer), !c.current && n && (c.current = n(e, {
    visualState: r,
    parent: i,
    props: t,
    presenceId: l == null ? void 0 : l.id,
    blockInitialAnimation: (l == null ? void 0 : l.initial) === !1,
    shouldReduceMotion: u
  }));
  var f = c.current;
  return r0(function() {
    f == null || f.syncRender();
  }), ar(function() {
    var h;
    (h = f == null ? void 0 : f.animationState) === null || h === void 0 || h.animateChanges();
  }), r0(function() {
    return function() {
      return f == null ? void 0 : f.notifyUnmount();
    };
  }, []), f;
}
function Hu(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function AQ(e, r, t) {
  return Ne(
    function(n) {
      var a;
      n && ((a = e.mount) === null || a === void 0 || a.call(e, n)), r && (n ? r.mount(n) : r.unmount()), t && (typeof t == "function" ? t(n) : Hu(t) && (t.current = n));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [r]
  );
}
function OM(e) {
  return Array.isArray(e);
}
function mo(e) {
  return typeof e == "string" || OM(e);
}
function IQ(e) {
  var r = {};
  return e.forEachValue(function(t, n) {
    return r[n] = t.get();
  }), r;
}
function OQ(e) {
  var r = {};
  return e.forEachValue(function(t, n) {
    return r[n] = t.getVelocity();
  }), r;
}
function MM(e, r, t, n, a) {
  var i;
  return n === void 0 && (n = {}), a === void 0 && (a = {}), typeof r == "function" && (r = r(t != null ? t : e.custom, n, a)), typeof r == "string" && (r = (i = e.variants) === null || i === void 0 ? void 0 : i[r]), typeof r == "function" && (r = r(t != null ? t : e.custom, n, a)), r;
}
function vg(e, r, t) {
  var n = e.getProps();
  return MM(n, r, t != null ? t : n.custom, IQ(e), OQ(e));
}
function hg(e) {
  var r;
  return typeof ((r = e.animate) === null || r === void 0 ? void 0 : r.start) == "function" || mo(e.initial) || mo(e.animate) || mo(e.whileHover) || mo(e.whileDrag) || mo(e.whileTap) || mo(e.whileFocus) || mo(e.exit);
}
function RM(e) {
  return !!(hg(e) || e.variants);
}
function MQ(e, r) {
  if (hg(e)) {
    var t = e.initial, n = e.animate;
    return {
      initial: t === !1 || mo(t) ? t : void 0,
      animate: mo(n) ? n : void 0
    };
  }
  return e.inherit !== !1 ? r : {};
}
function RQ(e) {
  var r = MQ(e, zr(fg)), t = r.initial, n = r.animate;
  return Rt(function() {
    return { initial: t, animate: n };
  }, [RC(t), RC(n)]);
}
function RC(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function Lf(e) {
  var r = Qe(null);
  return r.current === null && (r.current = e()), r.current;
}
var Ad = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, PQ = 1;
function kQ() {
  return Lf(function() {
    if (Ad.hasEverUpdated)
      return PQ++;
  });
}
var e$ = On({}), PM = On({});
function jQ(e, r, t, n) {
  var a, i = r.layoutId, l = r.layout, u = r.drag, c = r.dragConstraints, f = r.layoutScroll, h = zr(PM);
  !n || !t || t != null && t.projection || (t.projection = new n(e, t.getLatestValues(), (a = t.parent) === null || a === void 0 ? void 0 : a.projection), t.projection.setOptions({
    layoutId: i,
    layout: l,
    alwaysMeasureLayout: !!u || c && Hu(c),
    visualElement: t,
    scheduleRender: function() {
      return t.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof l == "string" ? l : "both",
    initialPromotionConfig: h,
    layoutScroll: f
  }));
}
var DQ = (
  /** @class */
  function(e) {
    CM(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, r.prototype.componentDidUpdate = function() {
    }, r.prototype.updateProps = function() {
      var t = this.props, n = t.visualElement, a = t.props;
      n && n.setProps(a);
    }, r.prototype.render = function() {
      return this.props.children;
    }, r;
  }(xo.Component)
);
function NQ(e) {
  var r = e.preloadedFeatures, t = e.createVisualElement, n = e.projectionNodeConstructor, a = e.useRender, i = e.useVisualState, l = e.Component;
  r && yQ(r);
  function u(c, f) {
    var h = LQ(c);
    c = fe(fe({}, c), { layoutId: h });
    var p = zr(J2), g = null, y = RQ(c), S = p.isStatic ? void 0 : kQ(), x = i(c, p.isStatic);
    return !p.isStatic && Ac && (y.visualElement = EQ(l, x, fe(fe({}, p), c), t), jQ(S, c, y.visualElement, n || af.projectionNodeConstructor), g = $Q(c, y.visualElement, r)), I.createElement(
      DQ,
      { visualElement: y.visualElement, props: fe(fe({}, p), c) },
      g,
      I.createElement(fg.Provider, { value: y }, a(l, c, S, AQ(x, y.visualElement, f), x, p.isStatic, y.visualElement))
    );
  }
  return W0(u);
}
function LQ(e) {
  var r, t = e.layoutId, n = (r = zr(e$)) === null || r === void 0 ? void 0 : r.id;
  return n && t !== void 0 ? n + "-" + t : t;
}
function FQ(e) {
  function r(n, a) {
    return a === void 0 && (a = {}), NQ(e(n, a));
  }
  if (typeof Proxy == "undefined")
    return r;
  var t = /* @__PURE__ */ new Map();
  return new Proxy(r, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(n, a) {
      return t.has(a) || t.set(a, r(a)), t.get(a);
    }
  });
}
var zQ = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function r$(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(zQ.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var t0 = {};
function BQ(e) {
  Object.assign(t0, e);
}
var AS = ["", "X", "Y", "Z"], UQ = ["translate", "scale", "rotate", "skew"], of = ["transformPerspective", "x", "y", "z"];
UQ.forEach(function(e) {
  return AS.forEach(function(r) {
    return of.push(e + r);
  });
});
function VQ(e, r) {
  return of.indexOf(e) - of.indexOf(r);
}
var WQ = new Set(of);
function Ff(e) {
  return WQ.has(e);
}
var HQ = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function kM(e) {
  return HQ.has(e);
}
function jM(e, r) {
  var t = r.layout, n = r.layoutId;
  return Ff(e) || kM(e) || (t || n !== void 0) && (!!t0[e] || e === "opacity");
}
var Ni = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, GQ = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function YQ(e, r, t, n) {
  var a = e.transform, i = e.transformKeys, l = r.enableHardwareAcceleration, u = l === void 0 ? !0 : l, c = r.allowTransformNone, f = c === void 0 ? !0 : c, h = "";
  i.sort(VQ);
  for (var p = !1, g = i.length, y = 0; y < g; y++) {
    var S = i[y];
    h += "".concat(GQ[S] || S, "(").concat(a[S], ") "), S === "z" && (p = !0);
  }
  return !p && u ? h += "translateZ(0)" : h = h.trim(), n ? h = n(a, t ? "" : h) : f && t && (h = "none"), h;
}
function KQ(e) {
  var r = e.originX, t = r === void 0 ? "50%" : r, n = e.originY, a = n === void 0 ? "50%" : n, i = e.originZ, l = i === void 0 ? 0 : i;
  return "".concat(t, " ").concat(a, " ").concat(l);
}
function DM(e) {
  return e.startsWith("--");
}
var ZQ = function(e, r) {
  return r && typeof e == "number" ? r.transform(e) : e;
};
const NM = (e, r) => (t) => Math.max(Math.min(t, r), e), Id = (e) => e % 1 ? Number(e.toFixed(5)) : e, sf = /(-)?([\d]*\.?[\d])+/g, IS = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, qQ = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function zf(e) {
  return typeof e == "string";
}
const iu = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Od = Object.assign(Object.assign({}, iu), { transform: NM(0, 1) }), ih = Object.assign(Object.assign({}, iu), { default: 1 }), Bf = (e) => ({
  test: (r) => zf(r) && r.endsWith(e) && r.split(" ").length === 1,
  parse: parseFloat,
  transform: (r) => `${r}${e}`
}), _s = Bf("deg"), ei = Bf("%"), We = Bf("px"), QQ = Bf("vh"), XQ = Bf("vw"), PC = Object.assign(Object.assign({}, ei), { parse: (e) => ei.parse(e) / 100, transform: (e) => ei.transform(e * 100) }), t$ = (e, r) => (t) => !!(zf(t) && qQ.test(t) && t.startsWith(e) || r && Object.prototype.hasOwnProperty.call(t, r)), LM = (e, r, t) => (n) => {
  if (!zf(n))
    return n;
  const [a, i, l, u] = n.match(sf);
  return {
    [e]: parseFloat(a),
    [r]: parseFloat(i),
    [t]: parseFloat(l),
    alpha: u !== void 0 ? parseFloat(u) : 1
  };
}, Ll = {
  test: t$("hsl", "hue"),
  parse: LM("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: r, lightness: t, alpha: n = 1 }) => "hsla(" + Math.round(e) + ", " + ei.transform(Id(r)) + ", " + ei.transform(Id(t)) + ", " + Id(Od.transform(n)) + ")"
}, JQ = NM(0, 255), Hb = Object.assign(Object.assign({}, iu), { transform: (e) => Math.round(JQ(e)) }), As = {
  test: t$("rgb", "red"),
  parse: LM("red", "green", "blue"),
  transform: ({ red: e, green: r, blue: t, alpha: n = 1 }) => "rgba(" + Hb.transform(e) + ", " + Hb.transform(r) + ", " + Hb.transform(t) + ", " + Id(Od.transform(n)) + ")"
};
function eX(e) {
  let r = "", t = "", n = "", a = "";
  return e.length > 5 ? (r = e.substr(1, 2), t = e.substr(3, 2), n = e.substr(5, 2), a = e.substr(7, 2)) : (r = e.substr(1, 1), t = e.substr(2, 1), n = e.substr(3, 1), a = e.substr(4, 1), r += r, t += t, n += n, a += a), {
    red: parseInt(r, 16),
    green: parseInt(t, 16),
    blue: parseInt(n, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
const OS = {
  test: t$("#"),
  parse: eX,
  transform: As.transform
}, An = {
  test: (e) => As.test(e) || OS.test(e) || Ll.test(e),
  parse: (e) => As.test(e) ? As.parse(e) : Ll.test(e) ? Ll.parse(e) : OS.parse(e),
  transform: (e) => zf(e) ? e : e.hasOwnProperty("red") ? As.transform(e) : Ll.transform(e)
}, FM = "${c}", zM = "${n}";
function rX(e) {
  var r, t, n, a;
  return isNaN(e) && zf(e) && ((t = (r = e.match(sf)) === null || r === void 0 ? void 0 : r.length) !== null && t !== void 0 ? t : 0) + ((a = (n = e.match(IS)) === null || n === void 0 ? void 0 : n.length) !== null && a !== void 0 ? a : 0) > 0;
}
function BM(e) {
  typeof e == "number" && (e = `${e}`);
  const r = [];
  let t = 0;
  const n = e.match(IS);
  n && (t = n.length, e = e.replace(IS, FM), r.push(...n.map(An.parse)));
  const a = e.match(sf);
  return a && (e = e.replace(sf, zM), r.push(...a.map(iu.parse))), { values: r, numColors: t, tokenised: e };
}
function UM(e) {
  return BM(e).values;
}
function VM(e) {
  const { values: r, numColors: t, tokenised: n } = BM(e), a = r.length;
  return (i) => {
    let l = n;
    for (let u = 0; u < a; u++)
      l = l.replace(u < t ? FM : zM, u < t ? An.transform(i[u]) : Id(i[u]));
    return l;
  };
}
const tX = (e) => typeof e == "number" ? 0 : e;
function nX(e) {
  const r = UM(e);
  return VM(e)(r.map(tX));
}
const Li = { test: rX, parse: UM, createTransformer: VM, getAnimatableNone: nX }, aX = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function oX(e) {
  let [r, t] = e.slice(0, -1).split("(");
  if (r === "drop-shadow")
    return e;
  const [n] = t.match(sf) || [];
  if (!n)
    return e;
  const a = t.replace(n, "");
  let i = aX.has(r) ? 1 : 0;
  return n !== t && (i *= 100), r + "(" + i + a + ")";
}
const iX = /([a-z-]*)\(.*?\)/g, MS = Object.assign(Object.assign({}, Li), { getAnimatableNone: (e) => {
  const r = e.match(iX);
  return r ? r.map(oX).join(" ") : e;
} });
var kC = fe(fe({}, iu), { transform: Math.round }), WM = {
  // Border props
  borderWidth: We,
  borderTopWidth: We,
  borderRightWidth: We,
  borderBottomWidth: We,
  borderLeftWidth: We,
  borderRadius: We,
  radius: We,
  borderTopLeftRadius: We,
  borderTopRightRadius: We,
  borderBottomRightRadius: We,
  borderBottomLeftRadius: We,
  // Positioning props
  width: We,
  maxWidth: We,
  height: We,
  maxHeight: We,
  size: We,
  top: We,
  right: We,
  bottom: We,
  left: We,
  // Spacing props
  padding: We,
  paddingTop: We,
  paddingRight: We,
  paddingBottom: We,
  paddingLeft: We,
  margin: We,
  marginTop: We,
  marginRight: We,
  marginBottom: We,
  marginLeft: We,
  // Transform props
  rotate: _s,
  rotateX: _s,
  rotateY: _s,
  rotateZ: _s,
  scale: ih,
  scaleX: ih,
  scaleY: ih,
  scaleZ: ih,
  skew: _s,
  skewX: _s,
  skewY: _s,
  distance: We,
  translateX: We,
  translateY: We,
  translateZ: We,
  x: We,
  y: We,
  z: We,
  perspective: We,
  transformPerspective: We,
  opacity: Od,
  originX: PC,
  originY: PC,
  originZ: We,
  // Misc
  zIndex: kC,
  // SVG
  fillOpacity: Od,
  strokeOpacity: Od,
  numOctaves: kC
};
function n$(e, r, t, n) {
  var a, i = e.style, l = e.vars, u = e.transform, c = e.transformKeys, f = e.transformOrigin;
  c.length = 0;
  var h = !1, p = !1, g = !0;
  for (var y in r) {
    var S = r[y];
    if (DM(y)) {
      l[y] = S;
      continue;
    }
    var x = WM[y], _ = ZQ(S, x);
    if (Ff(y)) {
      if (h = !0, u[y] = _, c.push(y), !g)
        continue;
      S !== ((a = x.default) !== null && a !== void 0 ? a : 0) && (g = !1);
    } else
      kM(y) ? (f[y] = _, p = !0) : i[y] = _;
  }
  h ? i.transform = YQ(e, t, g, n) : n ? i.transform = n({}, "") : !r.transform && i.transform && (i.transform = "none"), p && (i.transformOrigin = KQ(f));
}
var a$ = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function HM(e, r, t) {
  for (var n in r)
    !Ni(r[n]) && !jM(n, t) && (e[n] = r[n]);
}
function sX(e, r, t) {
  var n = e.transformTemplate;
  return Rt(function() {
    var a = a$();
    n$(a, r, { enableHardwareAcceleration: !t }, n);
    var i = a.vars, l = a.style;
    return fe(fe({}, i), l);
  }, [r]);
}
function lX(e, r, t) {
  var n = e.style || {}, a = {};
  return HM(a, n, e), Object.assign(a, sX(e, r, t)), e.transformValues && (a = e.transformValues(a)), a;
}
function uX(e, r, t) {
  var n = {}, a = lX(e, r, t);
  return e.drag && e.dragListener !== !1 && (n.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), n.style = a, n;
}
var cX = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function n0(e) {
  return cX.has(e);
}
var GM = function(e) {
  return !n0(e);
};
function dX(e) {
  e && (GM = function(r) {
    return r.startsWith("on") ? !n0(r) : e(r);
  });
}
try {
  dX(require("@emotion/is-prop-valid").default);
} catch (e) {
}
function fX(e, r, t) {
  var n = {};
  for (var a in e)
    (GM(a) || t === !0 && n0(a) || !r && !n0(a) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && a.startsWith("onDrag")) && (n[a] = e[a]);
  return n;
}
function jC(e, r, t) {
  return typeof e == "string" ? e : We.transform(r + t * e);
}
function vX(e, r, t) {
  var n = jC(r, e.x, e.width), a = jC(t, e.y, e.height);
  return "".concat(n, " ").concat(a);
}
var hX = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, pX = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function gX(e, r, t, n, a) {
  t === void 0 && (t = 1), n === void 0 && (n = 0), a === void 0 && (a = !0), e.pathLength = 1;
  var i = a ? hX : pX;
  e[i.offset] = We.transform(-n);
  var l = We.transform(r), u = We.transform(t);
  e[i.array] = "".concat(l, " ").concat(u);
}
function o$(e, r, t, n) {
  var a = r.attrX, i = r.attrY, l = r.originX, u = r.originY, c = r.pathLength, f = r.pathSpacing, h = f === void 0 ? 1 : f, p = r.pathOffset, g = p === void 0 ? 0 : p, y = Wa(r, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  n$(e, y, t, n), e.attrs = e.style, e.style = {};
  var S = e.attrs, x = e.style, _ = e.dimensions;
  S.transform && (_ && (x.transform = S.transform), delete S.transform), _ && (l !== void 0 || u !== void 0 || x.transform) && (x.transformOrigin = vX(_, l !== void 0 ? l : 0.5, u !== void 0 ? u : 0.5)), a !== void 0 && (S.x = a), i !== void 0 && (S.y = i), c !== void 0 && gX(S, c, h, g, !1);
}
var YM = function() {
  return fe(fe({}, a$()), { attrs: {} });
};
function mX(e, r) {
  var t = Rt(function() {
    var a = YM();
    return o$(a, r, { enableHardwareAcceleration: !1 }, e.transformTemplate), fe(fe({}, a.attrs), { style: fe({}, a.style) });
  }, [r]);
  if (e.style) {
    var n = {};
    HM(n, e.style, e), t.style = fe(fe({}, n), t.style);
  }
  return t;
}
function bX(e) {
  e === void 0 && (e = !1);
  var r = function(t, n, a, i, l, u) {
    var c = l.latestValues, f = r$(t) ? mX : uX, h = f(n, c, u), p = fX(n, typeof t == "string", e), g = fe(fe(fe({}, p), h), { ref: i });
    return a && (g["data-projection-id"] = a), ji(t, g);
  };
  return r;
}
var yX = /([a-z])([A-Z])/g, SX = "$1-$2", KM = function(e) {
  return e.replace(yX, SX).toLowerCase();
};
function ZM(e, r, t, n) {
  var a = r.style, i = r.vars;
  Object.assign(e.style, a, n && n.getProjectionStyles(t));
  for (var l in i)
    e.style.setProperty(l, i[l]);
}
var qM = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function QM(e, r, t, n) {
  ZM(e, r, void 0, n);
  for (var a in r.attrs)
    e.setAttribute(qM.has(a) ? a : KM(a), r.attrs[a]);
}
function i$(e) {
  var r = e.style, t = {};
  for (var n in r)
    (Ni(r[n]) || jM(n, e)) && (t[n] = r[n]);
  return t;
}
function XM(e) {
  var r = i$(e);
  for (var t in e)
    if (Ni(e[t])) {
      var n = t === "x" || t === "y" ? "attr" + t.toUpperCase() : t;
      r[n] = e[t];
    }
  return r;
}
function s$(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var lf = function(e) {
  return Array.isArray(e);
}, xX = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, JM = function(e) {
  return lf(e) ? e[e.length - 1] || 0 : e;
};
function xp(e) {
  var r = Ni(e) ? e.get() : e;
  return xX(r) ? r.toValue() : r;
}
function DC(e, r, t, n) {
  var a = e.scrapeMotionValuesFromProps, i = e.createRenderState, l = e.onMount, u = {
    latestValues: $X(r, t, n, a),
    renderState: i()
  };
  return l && (u.mount = function(c) {
    return l(r, c, u);
  }), u;
}
var eR = function(e) {
  return function(r, t) {
    var n = zr(fg), a = zr(Nf);
    return t ? DC(e, r, n, a) : Lf(function() {
      return DC(e, r, n, a);
    });
  };
};
function $X(e, r, t, n) {
  var a = {}, i = (t == null ? void 0 : t.initial) === !1, l = n(e);
  for (var u in l)
    a[u] = xp(l[u]);
  var c = e.initial, f = e.animate, h = hg(e), p = RM(e);
  r && p && !h && e.inherit !== !1 && (c != null || (c = r.initial), f != null || (f = r.animate));
  var g = i || c === !1, y = g ? f : c;
  if (y && typeof y != "boolean" && !s$(y)) {
    var S = Array.isArray(y) ? y : [y];
    S.forEach(function(x) {
      var _ = MM(e, x);
      if (_) {
        var A = _.transitionEnd;
        _.transition;
        var O = Wa(_, ["transitionEnd", "transition"]);
        for (var P in O) {
          var j = O[P];
          if (Array.isArray(j)) {
            var k = g ? j.length - 1 : 0;
            j = j[k];
          }
          j !== null && (a[P] = j);
        }
        for (var P in A)
          a[P] = A[P];
      }
    });
  }
  return a;
}
var wX = {
  useVisualState: eR({
    scrapeMotionValuesFromProps: XM,
    createRenderState: YM,
    onMount: function(e, r, t) {
      var n = t.renderState, a = t.latestValues;
      try {
        n.dimensions = typeof r.getBBox == "function" ? r.getBBox() : r.getBoundingClientRect();
      } catch (i) {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      o$(n, a, { enableHardwareAcceleration: !1 }, e.transformTemplate), QM(r, n);
    }
  })
}, _X = {
  useVisualState: eR({
    scrapeMotionValuesFromProps: i$,
    createRenderState: a$
  })
};
function TX(e, r, t, n, a) {
  var i = r.forwardMotionProps, l = i === void 0 ? !1 : i, u = r$(e) ? wX : _X;
  return fe(fe({}, u), { preloadedFeatures: t, useRender: bX(l), createVisualElement: n, projectionNodeConstructor: a, Component: e });
}
var nt;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})(nt || (nt = {}));
function pg(e, r, t, n) {
  return n === void 0 && (n = { passive: !0 }), e.addEventListener(r, t, n), function() {
    return e.removeEventListener(r, t);
  };
}
function RS(e, r, t, n) {
  ar(function() {
    var a = e.current;
    if (t && a)
      return pg(a, r, t, n);
  }, [e, r, t, n]);
}
function CX(e) {
  var r = e.whileFocus, t = e.visualElement, n = function() {
    var i;
    (i = t.animationState) === null || i === void 0 || i.setActive(nt.Focus, !0);
  }, a = function() {
    var i;
    (i = t.animationState) === null || i === void 0 || i.setActive(nt.Focus, !1);
  };
  RS(t, "focus", r ? n : void 0), RS(t, "blur", r ? a : void 0);
}
function rR(e) {
  return typeof PointerEvent != "undefined" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function tR(e) {
  var r = !!e.touches;
  return r;
}
function EX(e) {
  return function(r) {
    var t = r instanceof MouseEvent, n = !t || t && r.button === 0;
    n && e(r);
  };
}
var AX = { pageX: 0, pageY: 0 };
function IX(e, r) {
  r === void 0 && (r = "page");
  var t = e.touches[0] || e.changedTouches[0], n = t || AX;
  return {
    x: n[r + "X"],
    y: n[r + "Y"]
  };
}
function OX(e, r) {
  return r === void 0 && (r = "page"), {
    x: e[r + "X"],
    y: e[r + "Y"]
  };
}
function l$(e, r) {
  return r === void 0 && (r = "page"), {
    point: tR(e) ? IX(e, r) : OX(e, r)
  };
}
var nR = function(e, r) {
  r === void 0 && (r = !1);
  var t = function(n) {
    return e(n, l$(n));
  };
  return r ? EX(t) : t;
}, MX = function() {
  return Ac && window.onpointerdown === null;
}, RX = function() {
  return Ac && window.ontouchstart === null;
}, PX = function() {
  return Ac && window.onmousedown === null;
}, kX = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, jX = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function aR(e) {
  return MX() ? e : RX() ? jX[e] : PX() ? kX[e] : e;
}
function ac(e, r, t, n) {
  return pg(e, aR(r), nR(t, r === "pointerdown"), n);
}
function a0(e, r, t, n) {
  return RS(e, aR(r), t && nR(t, r === "pointerdown"), n);
}
function oR(e) {
  var r = null;
  return function() {
    var t = function() {
      r = null;
    };
    return r === null ? (r = e, t) : !1;
  };
}
var NC = oR("dragHorizontal"), LC = oR("dragVertical");
function iR(e) {
  var r = !1;
  if (e === "y")
    r = LC();
  else if (e === "x")
    r = NC();
  else {
    var t = NC(), n = LC();
    t && n ? r = function() {
      t(), n();
    } : (t && t(), n && n());
  }
  return r;
}
function sR() {
  var e = iR(!0);
  return e ? (e(), !1) : !0;
}
function FC(e, r, t) {
  return function(n, a) {
    var i;
    !rR(n) || sR() || ((i = e.animationState) === null || i === void 0 || i.setActive(nt.Hover, r), t == null || t(n, a));
  };
}
function DX(e) {
  var r = e.onHoverStart, t = e.onHoverEnd, n = e.whileHover, a = e.visualElement;
  a0(a, "pointerenter", r || n ? FC(a, !0, r) : void 0, { passive: !r }), a0(a, "pointerleave", t || n ? FC(a, !1, t) : void 0, { passive: !t });
}
var lR = function(e, r) {
  return r ? e === r ? !0 : lR(e, r.parentElement) : !1;
};
function u$(e) {
  return ar(function() {
    return function() {
      return e();
    };
  }, []);
}
const o0 = (e, r, t) => Math.min(Math.max(t, e), r), Gb = 1e-3, NX = 0.01, zC = 10, LX = 0.05, FX = 1;
function zX({ duration: e = 800, bounce: r = 0.25, velocity: t = 0, mass: n = 1 }) {
  let a, i;
  SQ(e <= zC * 1e3);
  let l = 1 - r;
  l = o0(LX, FX, l), e = o0(NX, zC, e / 1e3), l < 1 ? (a = (f) => {
    const h = f * l, p = h * e, g = h - t, y = PS(f, l), S = Math.exp(-p);
    return Gb - g / y * S;
  }, i = (f) => {
    const p = f * l * e, g = p * t + t, y = Math.pow(l, 2) * Math.pow(f, 2) * e, S = Math.exp(-p), x = PS(Math.pow(f, 2), l);
    return (-a(f) + Gb > 0 ? -1 : 1) * ((g - y) * S) / x;
  }) : (a = (f) => {
    const h = Math.exp(-f * e), p = (f - t) * e + 1;
    return -Gb + h * p;
  }, i = (f) => {
    const h = Math.exp(-f * e), p = (t - f) * (e * e);
    return h * p;
  });
  const u = 5 / e, c = UX(a, i, u);
  if (e = e * 1e3, isNaN(c))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const f = Math.pow(c, 2) * n;
    return {
      stiffness: f,
      damping: l * 2 * Math.sqrt(n * f),
      duration: e
    };
  }
}
const BX = 12;
function UX(e, r, t) {
  let n = t;
  for (let a = 1; a < BX; a++)
    n = n - e(n) / r(n);
  return n;
}
function PS(e, r) {
  return e * Math.sqrt(1 - r * r);
}
const VX = ["duration", "bounce"], WX = ["stiffness", "damping", "mass"];
function BC(e, r) {
  return r.some((t) => e[t] !== void 0);
}
function HX(e) {
  let r = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!BC(e, WX) && BC(e, VX)) {
    const t = zX(e);
    r = Object.assign(Object.assign(Object.assign({}, r), t), { velocity: 0, mass: 1 }), r.isResolvedFromDuration = !0;
  }
  return r;
}
function c$(e) {
  var { from: r = 0, to: t = 1, restSpeed: n = 2, restDelta: a } = e, i = Wa(e, ["from", "to", "restSpeed", "restDelta"]);
  const l = { done: !1, value: r };
  let { stiffness: u, damping: c, mass: f, velocity: h, duration: p, isResolvedFromDuration: g } = HX(i), y = UC, S = UC;
  function x() {
    const _ = h ? -(h / 1e3) : 0, A = t - r, O = c / (2 * Math.sqrt(u * f)), P = Math.sqrt(u / f) / 1e3;
    if (a === void 0 && (a = Math.min(Math.abs(t - r) / 100, 0.4)), O < 1) {
      const j = PS(P, O);
      y = (k) => {
        const L = Math.exp(-O * P * k);
        return t - L * ((_ + O * P * A) / j * Math.sin(j * k) + A * Math.cos(j * k));
      }, S = (k) => {
        const L = Math.exp(-O * P * k);
        return O * P * L * (Math.sin(j * k) * (_ + O * P * A) / j + A * Math.cos(j * k)) - L * (Math.cos(j * k) * (_ + O * P * A) - j * A * Math.sin(j * k));
      };
    } else if (O === 1)
      y = (j) => t - Math.exp(-P * j) * (A + (_ + P * A) * j);
    else {
      const j = P * Math.sqrt(O * O - 1);
      y = (k) => {
        const L = Math.exp(-O * P * k), M = Math.min(j * k, 300);
        return t - L * ((_ + O * P * A) * Math.sinh(M) + j * A * Math.cosh(M)) / j;
      };
    }
  }
  return x(), {
    next: (_) => {
      const A = y(_);
      if (g)
        l.done = _ >= p;
      else {
        const O = S(_) * 1e3, P = Math.abs(O) <= n, j = Math.abs(t - A) <= a;
        l.done = P && j;
      }
      return l.value = l.done ? t : A, l;
    },
    flipTarget: () => {
      h = -h, [r, t] = [t, r], x();
    }
  };
}
c$.needsInterpolation = (e, r) => typeof e == "string" || typeof r == "string";
const UC = (e) => 0, uf = (e, r, t) => {
  const n = r - e;
  return n === 0 ? 1 : (t - e) / n;
}, Tt = (e, r, t) => -t * e + t * r + e;
function Yb(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * 6 * t : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function VC({ hue: e, saturation: r, lightness: t, alpha: n }) {
  e /= 360, r /= 100, t /= 100;
  let a = 0, i = 0, l = 0;
  if (!r)
    a = i = l = t;
  else {
    const u = t < 0.5 ? t * (1 + r) : t + r - t * r, c = 2 * t - u;
    a = Yb(c, u, e + 1 / 3), i = Yb(c, u, e), l = Yb(c, u, e - 1 / 3);
  }
  return {
    red: Math.round(a * 255),
    green: Math.round(i * 255),
    blue: Math.round(l * 255),
    alpha: n
  };
}
const GX = (e, r, t) => {
  const n = e * e, a = r * r;
  return Math.sqrt(Math.max(0, t * (a - n) + n));
}, YX = [OS, As, Ll], WC = (e) => YX.find((r) => r.test(e)), uR = (e, r) => {
  let t = WC(e), n = WC(r), a = t.parse(e), i = n.parse(r);
  t === Ll && (a = VC(a), t = As), n === Ll && (i = VC(i), n = As);
  const l = Object.assign({}, a);
  return (u) => {
    for (const c in l)
      c !== "alpha" && (l[c] = GX(a[c], i[c], u));
    return l.alpha = Tt(a.alpha, i.alpha, u), t.transform(l);
  };
}, kS = (e) => typeof e == "number", KX = (e, r) => (t) => r(e(t)), gg = (...e) => e.reduce(KX);
function cR(e, r) {
  return kS(e) ? (t) => Tt(e, r, t) : An.test(e) ? uR(e, r) : fR(e, r);
}
const dR = (e, r) => {
  const t = [...e], n = t.length, a = e.map((i, l) => cR(i, r[l]));
  return (i) => {
    for (let l = 0; l < n; l++)
      t[l] = a[l](i);
    return t;
  };
}, ZX = (e, r) => {
  const t = Object.assign(Object.assign({}, e), r), n = {};
  for (const a in t)
    e[a] !== void 0 && r[a] !== void 0 && (n[a] = cR(e[a], r[a]));
  return (a) => {
    for (const i in n)
      t[i] = n[i](a);
    return t;
  };
};
function HC(e) {
  const r = Li.parse(e), t = r.length;
  let n = 0, a = 0, i = 0;
  for (let l = 0; l < t; l++)
    n || typeof r[l] == "number" ? n++ : r[l].hue !== void 0 ? i++ : a++;
  return { parsed: r, numNumbers: n, numRGB: a, numHSL: i };
}
const fR = (e, r) => {
  const t = Li.createTransformer(r), n = HC(e), a = HC(r);
  return n.numHSL === a.numHSL && n.numRGB === a.numRGB && n.numNumbers >= a.numNumbers ? gg(dR(n.parsed, a.parsed), t) : (l) => `${l > 0 ? r : e}`;
}, qX = (e, r) => (t) => Tt(e, r, t);
function QX(e) {
  if (typeof e == "number")
    return qX;
  if (typeof e == "string")
    return An.test(e) ? uR : fR;
  if (Array.isArray(e))
    return dR;
  if (typeof e == "object")
    return ZX;
}
function XX(e, r, t) {
  const n = [], a = t || QX(e[0]), i = e.length - 1;
  for (let l = 0; l < i; l++) {
    let u = a(e[l], e[l + 1]);
    if (r) {
      const c = Array.isArray(r) ? r[l] : r;
      u = gg(c, u);
    }
    n.push(u);
  }
  return n;
}
function JX([e, r], [t]) {
  return (n) => t(uf(e, r, n));
}
function eJ(e, r) {
  const t = e.length, n = t - 1;
  return (a) => {
    let i = 0, l = !1;
    if (a <= e[0] ? l = !0 : a >= e[n] && (i = n - 1, l = !0), !l) {
      let c = 1;
      for (; c < t && !(e[c] > a || c === n); c++)
        ;
      i = c - 1;
    }
    const u = uf(e[i], e[i + 1], a);
    return r[i](u);
  };
}
function vR(e, r, { clamp: t = !0, ease: n, mixer: a } = {}) {
  const i = e.length;
  e0(i === r.length), e0(!n || !Array.isArray(n) || n.length === i - 1), e[0] > e[i - 1] && (e = [].concat(e), r = [].concat(r), e.reverse(), r.reverse());
  const l = XX(r, n, a), u = i === 2 ? JX(e, l) : eJ(e, l);
  return t ? (c) => u(o0(e[0], e[i - 1], c)) : u;
}
const mg = (e) => (r) => 1 - e(1 - r), d$ = (e) => (r) => r <= 0.5 ? e(2 * r) / 2 : (2 - e(2 * (1 - r))) / 2, rJ = (e) => (r) => Math.pow(r, e), hR = (e) => (r) => r * r * ((e + 1) * r - e), tJ = (e) => {
  const r = hR(e);
  return (t) => (t *= 2) < 1 ? 0.5 * r(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1)));
}, pR = 1.525, nJ = 4 / 11, aJ = 8 / 11, oJ = 9 / 10, f$ = (e) => e, v$ = rJ(2), iJ = mg(v$), gR = d$(v$), mR = (e) => 1 - Math.sin(Math.acos(e)), h$ = mg(mR), sJ = d$(h$), p$ = hR(pR), lJ = mg(p$), uJ = d$(p$), cJ = tJ(pR), dJ = 4356 / 361, fJ = 35442 / 1805, vJ = 16061 / 1805, i0 = (e) => {
  if (e === 1 || e === 0)
    return e;
  const r = e * e;
  return e < nJ ? 7.5625 * r : e < aJ ? 9.075 * r - 9.9 * e + 3.4 : e < oJ ? dJ * r - fJ * e + vJ : 10.8 * e * e - 20.52 * e + 10.72;
}, hJ = mg(i0), pJ = (e) => e < 0.5 ? 0.5 * (1 - i0(1 - e * 2)) : 0.5 * i0(e * 2 - 1) + 0.5;
function gJ(e, r) {
  return e.map(() => r || gR).splice(0, e.length - 1);
}
function mJ(e) {
  const r = e.length;
  return e.map((t, n) => n !== 0 ? n / (r - 1) : 0);
}
function bJ(e, r) {
  return e.map((t) => t * r);
}
function $p({ from: e = 0, to: r = 1, ease: t, offset: n, duration: a = 300 }) {
  const i = { done: !1, value: e }, l = Array.isArray(r) ? r : [e, r], u = bJ(n && n.length === l.length ? n : mJ(l), a);
  function c() {
    return vR(u, l, {
      ease: Array.isArray(t) ? t : gJ(l, t)
    });
  }
  let f = c();
  return {
    next: (h) => (i.value = f(h), i.done = h >= a, i),
    flipTarget: () => {
      l.reverse(), f = c();
    }
  };
}
function yJ({ velocity: e = 0, from: r = 0, power: t = 0.8, timeConstant: n = 350, restDelta: a = 0.5, modifyTarget: i }) {
  const l = { done: !1, value: r };
  let u = t * e;
  const c = r + u, f = i === void 0 ? c : i(c);
  return f !== c && (u = f - r), {
    next: (h) => {
      const p = -u * Math.exp(-h / n);
      return l.done = !(p > a || p < -a), l.value = l.done ? f : f + p, l;
    },
    flipTarget: () => {
    }
  };
}
const GC = { keyframes: $p, spring: c$, decay: yJ };
function SJ(e) {
  if (Array.isArray(e.to))
    return $p;
  if (GC[e.type])
    return GC[e.type];
  const r = new Set(Object.keys(e));
  return r.has("ease") || r.has("duration") && !r.has("dampingRatio") ? $p : r.has("dampingRatio") || r.has("stiffness") || r.has("mass") || r.has("damping") || r.has("restSpeed") || r.has("restDelta") ? c$ : $p;
}
const bR = 1 / 60 * 1e3, xJ = typeof performance != "undefined" ? () => performance.now() : () => Date.now(), yR = typeof window != "undefined" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(xJ()), bR);
function $J(e) {
  let r = [], t = [], n = 0, a = !1, i = !1;
  const l = /* @__PURE__ */ new WeakSet(), u = {
    schedule: (c, f = !1, h = !1) => {
      const p = h && a, g = p ? r : t;
      return f && l.add(c), g.indexOf(c) === -1 && (g.push(c), p && a && (n = r.length)), c;
    },
    cancel: (c) => {
      const f = t.indexOf(c);
      f !== -1 && t.splice(f, 1), l.delete(c);
    },
    process: (c) => {
      if (a) {
        i = !0;
        return;
      }
      if (a = !0, [r, t] = [t, r], t.length = 0, n = r.length, n)
        for (let f = 0; f < n; f++) {
          const h = r[f];
          h(c), l.has(h) && (u.schedule(h), e());
        }
      a = !1, i && (i = !1, u.process(c));
    }
  };
  return u;
}
const wJ = 40;
let jS = !0, cf = !1, DS = !1;
const oc = {
  delta: 0,
  timestamp: 0
}, Uf = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], bg = Uf.reduce((e, r) => (e[r] = $J(() => cf = !0), e), {}), _J = Uf.reduce((e, r) => {
  const t = bg[r];
  return e[r] = (n, a = !1, i = !1) => (cf || EJ(), t.schedule(n, a, i)), e;
}, {}), TJ = Uf.reduce((e, r) => (e[r] = bg[r].cancel, e), {});
Uf.reduce((e, r) => (e[r] = () => bg[r].process(oc), e), {});
const CJ = (e) => bg[e].process(oc), SR = (e) => {
  cf = !1, oc.delta = jS ? bR : Math.max(Math.min(e - oc.timestamp, wJ), 1), oc.timestamp = e, DS = !0, Uf.forEach(CJ), DS = !1, cf && (jS = !1, yR(SR));
}, EJ = () => {
  cf = !0, jS = !0, DS || yR(SR);
}, AJ = () => oc;
function xR(e, r, t = 0) {
  return e - r - t;
}
function IJ(e, r, t = 0, n = !0) {
  return n ? xR(r + -e, r, t) : r - (e - r) + t;
}
function OJ(e, r, t, n) {
  return n ? e >= r + t : e <= -t;
}
const MJ = (e) => {
  const r = ({ delta: t }) => e(t);
  return {
    start: () => _J.update(r, !0),
    stop: () => TJ.update(r)
  };
};
function $R(e) {
  var r, t, { from: n, autoplay: a = !0, driver: i = MJ, elapsed: l = 0, repeat: u = 0, repeatType: c = "loop", repeatDelay: f = 0, onPlay: h, onStop: p, onComplete: g, onRepeat: y, onUpdate: S } = e, x = Wa(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: _ } = x, A, O = 0, P = x.duration, j, k = !1, L = !0, M;
  const W = SJ(x);
  !((t = (r = W).needsInterpolation) === null || t === void 0) && t.call(r, n, _) && (M = vR([0, 100], [n, _], {
    clamp: !1
  }), n = 0, _ = 100);
  const Z = W(Object.assign(Object.assign({}, x), { from: n, to: _ }));
  function oe() {
    O++, c === "reverse" ? (L = O % 2 === 0, l = IJ(l, P, f, L)) : (l = xR(l, P, f), c === "mirror" && Z.flipTarget()), k = !1, y && y();
  }
  function Ie() {
    A.stop(), g && g();
  }
  function Te(Me) {
    if (L || (Me = -Me), l += Me, !k) {
      const Fe = Z.next(Math.max(0, l));
      j = Fe.value, M && (j = M(j)), k = L ? Fe.done : l <= 0;
    }
    S == null || S(j), k && (O === 0 && (P != null || (P = l)), O < u ? OJ(l, P, f, L) && oe() : Ie());
  }
  function Ee() {
    h == null || h(), A = i(Te), A.start();
  }
  return a && Ee(), {
    stop: () => {
      p == null || p(), A.stop();
    }
  };
}
function wR(e, r) {
  return r ? e * (1e3 / r) : 0;
}
function RJ({ from: e = 0, velocity: r = 0, min: t, max: n, power: a = 0.8, timeConstant: i = 750, bounceStiffness: l = 500, bounceDamping: u = 10, restDelta: c = 1, modifyTarget: f, driver: h, onUpdate: p, onComplete: g, onStop: y }) {
  let S;
  function x(P) {
    return t !== void 0 && P < t || n !== void 0 && P > n;
  }
  function _(P) {
    return t === void 0 ? n : n === void 0 || Math.abs(t - P) < Math.abs(n - P) ? t : n;
  }
  function A(P) {
    S == null || S.stop(), S = $R(Object.assign(Object.assign({}, P), {
      driver: h,
      onUpdate: (j) => {
        var k;
        p == null || p(j), (k = P.onUpdate) === null || k === void 0 || k.call(P, j);
      },
      onComplete: g,
      onStop: y
    }));
  }
  function O(P) {
    A(Object.assign({ type: "spring", stiffness: l, damping: u, restDelta: c }, P));
  }
  if (x(e))
    O({ from: e, velocity: r, to: _(e) });
  else {
    let P = a * r + e;
    typeof f != "undefined" && (P = f(P));
    const j = _(P), k = j === t ? -1 : 1;
    let L, M;
    const W = (Z) => {
      L = M, M = Z, r = wR(Z - L, AJ().delta), (k === 1 && Z > j || k === -1 && Z < j) && O({ from: Z, to: j, velocity: r });
    };
    A({
      type: "decay",
      from: e,
      velocity: r,
      timeConstant: i,
      power: a,
      restDelta: c,
      modifyTarget: f,
      onUpdate: x(P) ? W : void 0
    });
  }
  return {
    stop: () => S == null ? void 0 : S.stop()
  };
}
const NS = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), YC = (e) => NS(e) && e.hasOwnProperty("z"), sh = (e, r) => Math.abs(e - r);
function _R(e, r) {
  if (kS(e) && kS(r))
    return sh(e, r);
  if (NS(e) && NS(r)) {
    const t = sh(e.x, r.x), n = sh(e.y, r.y), a = YC(e) && YC(r) ? sh(e.z, r.z) : 0;
    return Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2) + Math.pow(a, 2));
  }
}
const TR = (e, r) => 1 - 3 * r + 3 * e, CR = (e, r) => 3 * r - 6 * e, ER = (e) => 3 * e, s0 = (e, r, t) => ((TR(r, t) * e + CR(r, t)) * e + ER(r)) * e, AR = (e, r, t) => 3 * TR(r, t) * e * e + 2 * CR(r, t) * e + ER(r), PJ = 1e-7, kJ = 10;
function jJ(e, r, t, n, a) {
  let i, l, u = 0;
  do
    l = r + (t - r) / 2, i = s0(l, n, a) - e, i > 0 ? t = l : r = l;
  while (Math.abs(i) > PJ && ++u < kJ);
  return l;
}
const DJ = 8, NJ = 1e-3;
function LJ(e, r, t, n) {
  for (let a = 0; a < DJ; ++a) {
    const i = AR(r, t, n);
    if (i === 0)
      return r;
    const l = s0(r, t, n) - e;
    r -= l / i;
  }
  return r;
}
const wp = 11, lh = 1 / (wp - 1);
function FJ(e, r, t, n) {
  if (e === r && t === n)
    return f$;
  const a = new Float32Array(wp);
  for (let l = 0; l < wp; ++l)
    a[l] = s0(l * lh, e, t);
  function i(l) {
    let u = 0, c = 1;
    const f = wp - 1;
    for (; c !== f && a[c] <= l; ++c)
      u += lh;
    --c;
    const h = (l - a[c]) / (a[c + 1] - a[c]), p = u + h * lh, g = AR(p, e, t);
    return g >= NJ ? LJ(l, p, e, t) : g === 0 ? p : jJ(l, u, u + lh, e, t);
  }
  return (l) => l === 0 || l === 1 ? l : s0(i(l), r, n);
}
function zJ(e) {
  var r = e.onTap, t = e.onTapStart, n = e.onTapCancel, a = e.whileTap, i = e.visualElement, l = r || t || n || a, u = Qe(!1), c = Qe(null), f = {
    passive: !(t || r || n || S)
  };
  function h() {
    var x;
    (x = c.current) === null || x === void 0 || x.call(c), c.current = null;
  }
  function p() {
    var x;
    return h(), u.current = !1, (x = i.animationState) === null || x === void 0 || x.setActive(nt.Tap, !1), !sR();
  }
  function g(x, _) {
    p() && (lR(i.getInstance(), x.target) ? r == null || r(x, _) : n == null || n(x, _));
  }
  function y(x, _) {
    p() && (n == null || n(x, _));
  }
  function S(x, _) {
    var A;
    h(), !u.current && (u.current = !0, c.current = gg(ac(window, "pointerup", g, f), ac(window, "pointercancel", y, f)), (A = i.animationState) === null || A === void 0 || A.setActive(nt.Tap, !0), t == null || t(x, _));
  }
  a0(i, "pointerdown", l ? S : void 0, f), u$(h);
}
var KC = /* @__PURE__ */ new Set();
function BJ(e, r, t) {
  e || KC.has(r) || (console.warn(r), t && console.warn(t), KC.add(r));
}
var LS = /* @__PURE__ */ new WeakMap(), Kb = /* @__PURE__ */ new WeakMap(), UJ = function(e) {
  var r;
  (r = LS.get(e.target)) === null || r === void 0 || r(e);
}, VJ = function(e) {
  e.forEach(UJ);
};
function WJ(e) {
  var r = e.root, t = Wa(e, ["root"]), n = r || document;
  Kb.has(n) || Kb.set(n, {});
  var a = Kb.get(n), i = JSON.stringify(t);
  return a[i] || (a[i] = new IntersectionObserver(VJ, fe({ root: r }, t))), a[i];
}
function HJ(e, r, t) {
  var n = WJ(r);
  return LS.set(e, t), n.observe(e), function() {
    LS.delete(e), n.unobserve(e);
  };
}
function GJ(e) {
  var r = e.visualElement, t = e.whileInView, n = e.onViewportEnter, a = e.onViewportLeave, i = e.viewport, l = i === void 0 ? {} : i, u = Qe({
    hasEnteredView: !1,
    isInView: !1
  }), c = !!(t || n || a);
  l.once && u.current.hasEnteredView && (c = !1);
  var f = typeof IntersectionObserver == "undefined" ? ZJ : KJ;
  f(c, u.current, r, l);
}
var YJ = {
  some: 0,
  all: 1
};
function KJ(e, r, t, n) {
  var a = n.root, i = n.margin, l = n.amount, u = l === void 0 ? "some" : l, c = n.once;
  ar(function() {
    if (e) {
      var f = {
        root: a == null ? void 0 : a.current,
        rootMargin: i,
        threshold: typeof u == "number" ? u : YJ[u]
      }, h = function(p) {
        var g, y = p.isIntersecting;
        if (r.isInView !== y && (r.isInView = y, !(c && !y && r.hasEnteredView))) {
          y && (r.hasEnteredView = !0), (g = t.animationState) === null || g === void 0 || g.setActive(nt.InView, y);
          var S = t.getProps(), x = y ? S.onViewportEnter : S.onViewportLeave;
          x == null || x(p);
        }
      };
      return HJ(t.getInstance(), f, h);
    }
  }, [e, a, i, u]);
}
function ZJ(e, r, t, n) {
  var a = n.fallback, i = a === void 0 ? !0 : a;
  ar(function() {
    !e || !i || (X2 !== "production" && BJ(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var l;
      r.hasEnteredView = !0;
      var u = t.getProps().onViewportEnter;
      u == null || u(null), (l = t.animationState) === null || l === void 0 || l.setActive(nt.InView, !0);
    }));
  }, [e]);
}
var Is = function(e) {
  return function(r) {
    return e(r), null;
  };
}, qJ = {
  inView: Is(GJ),
  tap: Is(zJ),
  focus: Is(CX),
  hover: Is(DX)
}, QJ = 0, XJ = function() {
  return QJ++;
}, IR = function() {
  return Lf(XJ);
};
function OR() {
  var e = zr(Nf);
  if (e === null)
    return [!0, null];
  var r = e.isPresent, t = e.onExitComplete, n = e.register, a = IR();
  ar(function() {
    return n(a);
  }, []);
  var i = function() {
    return t == null ? void 0 : t(a);
  };
  return !r && t ? [!1, i] : [!0];
}
function MR(e, r) {
  if (!Array.isArray(r))
    return !1;
  var t = r.length;
  if (t !== e.length)
    return !1;
  for (var n = 0; n < t; n++)
    if (r[n] !== e[n])
      return !1;
  return !0;
}
var l0 = function(e) {
  return e * 1e3;
}, JJ = {
  linear: f$,
  easeIn: v$,
  easeInOut: gR,
  easeOut: iJ,
  circIn: mR,
  circInOut: sJ,
  circOut: h$,
  backIn: p$,
  backInOut: uJ,
  backOut: lJ,
  anticipate: cJ,
  bounceIn: hJ,
  bounceInOut: pJ,
  bounceOut: i0
}, ZC = function(e) {
  if (Array.isArray(e)) {
    e0(e.length === 4);
    var r = pt(e, 4), t = r[0], n = r[1], a = r[2], i = r[3];
    return FJ(t, n, a, i);
  } else if (typeof e == "string")
    return JJ[e];
  return e;
}, eee = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, qC = function(e, r) {
  return e === "zIndex" ? !1 : !!(typeof r == "number" || Array.isArray(r) || typeof r == "string" && // It's animatable if we have a string
  Li.test(r) && // And it contains numbers and/or colors
  !r.startsWith("url("));
}, $l = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, uh = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, Zb = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, ree = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, QC = {
  x: $l,
  y: $l,
  z: $l,
  rotate: $l,
  rotateX: $l,
  rotateY: $l,
  rotateZ: $l,
  scaleX: uh,
  scaleY: uh,
  scale: uh,
  opacity: Zb,
  backgroundColor: Zb,
  color: Zb,
  default: uh
}, tee = function(e, r) {
  var t;
  return lf(r) ? t = ree : t = QC[e] || QC.default, fe({ to: r }, t(r));
}, nee = fe(fe({}, WM), {
  // Color props
  color: An,
  backgroundColor: An,
  outlineColor: An,
  fill: An,
  stroke: An,
  // Border props
  borderColor: An,
  borderTopColor: An,
  borderRightColor: An,
  borderBottomColor: An,
  borderLeftColor: An,
  filter: MS,
  WebkitFilter: MS
}), g$ = function(e) {
  return nee[e];
};
function m$(e, r) {
  var t, n = g$(e);
  return n !== MS && (n = Li), (t = n.getAnimatableNone) === null || t === void 0 ? void 0 : t.call(n, r);
}
function aee(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var r = Wa(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(r).length;
}
function oee(e) {
  var r = e.ease, t = e.times, n = e.yoyo, a = e.flip, i = e.loop, l = Wa(e, ["ease", "times", "yoyo", "flip", "loop"]), u = fe({}, l);
  return t && (u.offset = t), l.duration && (u.duration = l0(l.duration)), l.repeatDelay && (u.repeatDelay = l0(l.repeatDelay)), r && (u.ease = eee(r) ? r.map(ZC) : ZC(r)), l.type === "tween" && (u.type = "keyframes"), (n || i || a) && (n ? u.repeatType = "reverse" : i ? u.repeatType = "loop" : a && (u.repeatType = "mirror"), u.repeat = i || n || a || l.repeat), l.type !== "spring" && (u.type = "keyframes"), u;
}
function iee(e, r) {
  var t, n, a = b$(e, r) || {};
  return (n = (t = a.delay) !== null && t !== void 0 ? t : e.delay) !== null && n !== void 0 ? n : 0;
}
function see(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = pa([], pt(e.to), !1), e.to[0] = e.from), e;
}
function lee(e, r, t) {
  var n;
  return Array.isArray(r.to) && ((n = e.duration) !== null && n !== void 0 || (e.duration = 0.8)), see(r), aee(e) || (e = fe(fe({}, e), tee(t, r.to))), fe(fe({}, r), oee(e));
}
function uee(e, r, t, n, a) {
  var i, l = b$(n, e), u = (i = l.from) !== null && i !== void 0 ? i : r.get(), c = qC(e, t);
  u === "none" && c && typeof t == "string" ? u = m$(e, t) : XC(u) && typeof t == "string" ? u = JC(t) : !Array.isArray(t) && XC(t) && typeof u == "string" && (t = JC(u));
  var f = qC(e, u);
  function h() {
    var g = {
      from: u,
      to: t,
      velocity: r.getVelocity(),
      onComplete: a,
      onUpdate: function(y) {
        return r.set(y);
      }
    };
    return l.type === "inertia" || l.type === "decay" ? RJ(fe(fe({}, g), l)) : $R(fe(fe({}, lee(l, g, e)), { onUpdate: function(y) {
      var S;
      g.onUpdate(y), (S = l.onUpdate) === null || S === void 0 || S.call(l, y);
    }, onComplete: function() {
      var y;
      g.onComplete(), (y = l.onComplete) === null || y === void 0 || y.call(l);
    } }));
  }
  function p() {
    var g, y, S = JM(t);
    return r.set(S), a(), (g = l == null ? void 0 : l.onUpdate) === null || g === void 0 || g.call(l, S), (y = l == null ? void 0 : l.onComplete) === null || y === void 0 || y.call(l), { stop: function() {
    } };
  }
  return !f || !c || l.type === !1 ? p : h;
}
function XC(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function JC(e) {
  return typeof e == "number" ? 0 : m$("", e);
}
function b$(e, r) {
  return e[r] || e.default || e;
}
function y$(e, r, t, n) {
  return n === void 0 && (n = {}), r.start(function(a) {
    var i, l, u = uee(e, r, t, n, a), c = iee(n, e), f = function() {
      return l = u();
    };
    return c ? i = window.setTimeout(f, l0(c)) : f(), function() {
      clearTimeout(i), l == null || l.stop();
    };
  });
}
var cee = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, dee = function(e) {
  return /^0[^.\s]+$/.test(e);
};
const RR = 1 / 60 * 1e3, fee = typeof performance != "undefined" ? () => performance.now() : () => Date.now(), PR = typeof window != "undefined" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(fee()), RR);
function vee(e) {
  let r = [], t = [], n = 0, a = !1, i = !1;
  const l = /* @__PURE__ */ new WeakSet(), u = {
    schedule: (c, f = !1, h = !1) => {
      const p = h && a, g = p ? r : t;
      return f && l.add(c), g.indexOf(c) === -1 && (g.push(c), p && a && (n = r.length)), c;
    },
    cancel: (c) => {
      const f = t.indexOf(c);
      f !== -1 && t.splice(f, 1), l.delete(c);
    },
    process: (c) => {
      if (a) {
        i = !0;
        return;
      }
      if (a = !0, [r, t] = [t, r], t.length = 0, n = r.length, n)
        for (let f = 0; f < n; f++) {
          const h = r[f];
          h(c), l.has(h) && (u.schedule(h), e());
        }
      a = !1, i && (i = !1, u.process(c));
    }
  };
  return u;
}
const hee = 40;
let FS = !0, df = !1, zS = !1;
const ic = {
  delta: 0,
  timestamp: 0
}, Vf = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], yg = Vf.reduce((e, r) => (e[r] = vee(() => df = !0), e), {}), ri = Vf.reduce((e, r) => {
  const t = yg[r];
  return e[r] = (n, a = !1, i = !1) => (df || gee(), t.schedule(n, a, i)), e;
}, {}), ff = Vf.reduce((e, r) => (e[r] = yg[r].cancel, e), {}), qb = Vf.reduce((e, r) => (e[r] = () => yg[r].process(ic), e), {}), pee = (e) => yg[e].process(ic), kR = (e) => {
  df = !1, ic.delta = FS ? RR : Math.max(Math.min(e - ic.timestamp, hee), 1), ic.timestamp = e, zS = !0, Vf.forEach(pee), zS = !1, df && (FS = !1, PR(kR));
}, gee = () => {
  df = !0, FS = !0, zS || PR(kR);
}, BS = () => ic;
function S$(e, r) {
  e.indexOf(r) === -1 && e.push(r);
}
function x$(e, r) {
  var t = e.indexOf(r);
  t > -1 && e.splice(t, 1);
}
var Md = (
  /** @class */
  function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(r) {
      var t = this;
      return S$(this.subscriptions, r), function() {
        return x$(t.subscriptions, r);
      };
    }, e.prototype.notify = function(r, t, n) {
      var a = this.subscriptions.length;
      if (a)
        if (a === 1)
          this.subscriptions[0](r, t, n);
        else
          for (var i = 0; i < a; i++) {
            var l = this.subscriptions[i];
            l && l(r, t, n);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  }()
), mee = function(e) {
  return !isNaN(parseFloat(e));
}, bee = (
  /** @class */
  function() {
    function e(r) {
      var t = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new Md(), this.velocityUpdateSubscribers = new Md(), this.renderSubscribers = new Md(), this.canTrackVelocity = !1, this.updateAndNotify = function(n, a) {
        a === void 0 && (a = !0), t.prev = t.current, t.current = n;
        var i = BS(), l = i.delta, u = i.timestamp;
        t.lastUpdated !== u && (t.timeDelta = l, t.lastUpdated = u, ri.postRender(t.scheduleVelocityCheck)), t.prev !== t.current && t.updateSubscribers.notify(t.current), t.velocityUpdateSubscribers.getSize() && t.velocityUpdateSubscribers.notify(t.getVelocity()), a && t.renderSubscribers.notify(t.current);
      }, this.scheduleVelocityCheck = function() {
        return ri.postRender(t.velocityCheck);
      }, this.velocityCheck = function(n) {
        var a = n.timestamp;
        a !== t.lastUpdated && (t.prev = t.current, t.velocityUpdateSubscribers.notify(t.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = r, this.canTrackVelocity = mee(this.current);
    }
    return e.prototype.onChange = function(r) {
      return this.updateSubscribers.add(r);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(r) {
      return r(this.get()), this.renderSubscribers.add(r);
    }, e.prototype.attach = function(r) {
      this.passiveEffect = r;
    }, e.prototype.set = function(r, t) {
      t === void 0 && (t = !0), !t || !this.passiveEffect ? this.updateAndNotify(r, t) : this.passiveEffect(r, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        wR(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(r) {
      var t = this;
      return this.stop(), new Promise(function(n) {
        t.hasAnimated = !0, t.stopAnimation = r(n);
      }).then(function() {
        return t.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }()
);
function pc(e) {
  return new bee(e);
}
var jR = function(e) {
  return function(r) {
    return r.test(e);
  };
}, yee = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, DR = [iu, We, ei, _s, XQ, QQ, yee], rd = function(e) {
  return DR.find(jR(e));
}, See = pa(pa([], pt(DR), !1), [An, Li], !1), xee = function(e) {
  return See.find(jR(e));
};
function $ee(e, r, t) {
  e.hasValue(r) ? e.getValue(r).set(t) : e.addValue(r, pc(t));
}
function wee(e, r) {
  var t = vg(e, r), n = t ? e.makeTargetAnimatable(t, !1) : {}, a = n.transitionEnd, i = a === void 0 ? {} : a;
  n.transition;
  var l = Wa(n, ["transitionEnd", "transition"]);
  l = fe(fe({}, l), i);
  for (var u in l) {
    var c = JM(l[u]);
    $ee(e, u, c);
  }
}
function _ee(e, r, t) {
  var n, a, i, l, u = Object.keys(r).filter(function(y) {
    return !e.hasValue(y);
  }), c = u.length;
  if (c)
    for (var f = 0; f < c; f++) {
      var h = u[f], p = r[h], g = null;
      Array.isArray(p) && (g = p[0]), g === null && (g = (a = (n = t[h]) !== null && n !== void 0 ? n : e.readValue(h)) !== null && a !== void 0 ? a : r[h]), g != null && (typeof g == "string" && (cee(g) || dee(g)) ? g = parseFloat(g) : !xee(g) && Li.test(p) && (g = m$(h, p)), e.addValue(h, pc(g)), (i = (l = t)[h]) !== null && i !== void 0 || (l[h] = g), e.setBaseTarget(h, g));
    }
}
function Tee(e, r) {
  if (r) {
    var t = r[e] || r.default || r;
    return t.from;
  }
}
function Cee(e, r, t) {
  var n, a, i = {};
  for (var l in e)
    i[l] = (n = Tee(l, r)) !== null && n !== void 0 ? n : (a = t.getValue(l)) === null || a === void 0 ? void 0 : a.get();
  return i;
}
function Eee(e, r, t) {
  t === void 0 && (t = {}), e.notifyAnimationStart(r);
  var n;
  if (Array.isArray(r)) {
    var a = r.map(function(l) {
      return US(e, l, t);
    });
    n = Promise.all(a);
  } else if (typeof r == "string")
    n = US(e, r, t);
  else {
    var i = typeof r == "function" ? vg(e, r, t.custom) : r;
    n = NR(e, i, t);
  }
  return n.then(function() {
    return e.notifyAnimationComplete(r);
  });
}
function US(e, r, t) {
  var n;
  t === void 0 && (t = {});
  var a = vg(e, r, t.custom), i = (a || {}).transition, l = i === void 0 ? e.getDefaultTransition() || {} : i;
  t.transitionOverride && (l = t.transitionOverride);
  var u = a ? function() {
    return NR(e, a, t);
  } : function() {
    return Promise.resolve();
  }, c = !((n = e.variantChildren) === null || n === void 0) && n.size ? function(y) {
    y === void 0 && (y = 0);
    var S = l.delayChildren, x = S === void 0 ? 0 : S, _ = l.staggerChildren, A = l.staggerDirection;
    return Aee(e, r, x + y, _, A, t);
  } : function() {
    return Promise.resolve();
  }, f = l.when;
  if (f) {
    var h = pt(f === "beforeChildren" ? [u, c] : [c, u], 2), p = h[0], g = h[1];
    return p().then(g);
  } else
    return Promise.all([u(), c(t.delay)]);
}
function NR(e, r, t) {
  var n, a = t === void 0 ? {} : t, i = a.delay, l = i === void 0 ? 0 : i, u = a.transitionOverride, c = a.type, f = e.makeTargetAnimatable(r), h = f.transition, p = h === void 0 ? e.getDefaultTransition() : h, g = f.transitionEnd, y = Wa(f, ["transition", "transitionEnd"]);
  u && (p = u);
  var S = [], x = c && ((n = e.animationState) === null || n === void 0 ? void 0 : n.getState()[c]);
  for (var _ in y) {
    var A = e.getValue(_), O = y[_];
    if (!(!A || O === void 0 || x && Oee(x, _))) {
      var P = fe({ delay: l }, p);
      e.shouldReduceMotion && Ff(_) && (P = fe(fe({}, P), { type: !1, delay: 0 }));
      var j = y$(_, A, O, P);
      S.push(j);
    }
  }
  return Promise.all(S).then(function() {
    g && wee(e, g);
  });
}
function Aee(e, r, t, n, a, i) {
  t === void 0 && (t = 0), n === void 0 && (n = 0), a === void 0 && (a = 1);
  var l = [], u = (e.variantChildren.size - 1) * n, c = a === 1 ? function(f) {
    return f === void 0 && (f = 0), f * n;
  } : function(f) {
    return f === void 0 && (f = 0), u - f * n;
  };
  return Array.from(e.variantChildren).sort(Iee).forEach(function(f, h) {
    l.push(US(f, r, fe(fe({}, i), { delay: t + c(h) })).then(function() {
      return f.notifyAnimationComplete(r);
    }));
  }), Promise.all(l);
}
function Iee(e, r) {
  return e.sortNodePosition(r);
}
function Oee(e, r) {
  var t = e.protectedKeys, n = e.needsAnimating, a = t.hasOwnProperty(r) && n[r] !== !0;
  return n[r] = !1, a;
}
var $$ = [
  nt.Animate,
  nt.InView,
  nt.Focus,
  nt.Hover,
  nt.Tap,
  nt.Drag,
  nt.Exit
], Mee = pa([], pt($$), !1).reverse(), Ree = $$.length;
function Pee(e) {
  return function(r) {
    return Promise.all(r.map(function(t) {
      var n = t.animation, a = t.options;
      return Eee(e, n, a);
    }));
  };
}
function kee(e) {
  var r = Pee(e), t = Dee(), n = {}, a = !0, i = function(h, p) {
    var g = vg(e, p);
    if (g) {
      g.transition;
      var y = g.transitionEnd, S = Wa(g, ["transition", "transitionEnd"]);
      h = fe(fe(fe({}, h), S), y);
    }
    return h;
  };
  function l(h) {
    return n[h] !== void 0;
  }
  function u(h) {
    r = h(e);
  }
  function c(h, p) {
    for (var g, y = e.getProps(), S = e.getVariantContext(!0) || {}, x = [], _ = /* @__PURE__ */ new Set(), A = {}, O = 1 / 0, P = function(M) {
      var W = Mee[M], Z = t[W], oe = (g = y[W]) !== null && g !== void 0 ? g : S[W], Ie = mo(oe), Te = W === p ? Z.isActive : null;
      Te === !1 && (O = M);
      var Ee = oe === S[W] && oe !== y[W] && Ie;
      if (Ee && a && e.manuallyAnimateOnMount && (Ee = !1), Z.protectedKeys = fe({}, A), // If it isn't active and hasn't *just* been set as inactive
      !Z.isActive && Te === null || // If we didn't and don't have any defined prop for this animation type
      !oe && !Z.prevProp || // Or if the prop doesn't define an animation
      s$(oe) || typeof oe == "boolean")
        return "continue";
      var Me = jee(Z.prevProp, oe), Fe = Me || // If we're making this variant active, we want to always make it active
      W === p && Z.isActive && !Ee && Ie || // If we removed a higher-priority variant (i is in reverse order)
      M > O && Ie, Ge = Array.isArray(oe) ? oe : [oe], ze = Ge.reduce(i, {});
      Te === !1 && (ze = {});
      var le = Z.prevResolvedValues, ce = le === void 0 ? {} : le, he = fe(fe({}, ce), ze), be = function(ue) {
        Fe = !0, _.delete(ue), Z.needsAnimating[ue] = !0;
      };
      for (var ye in he) {
        var q = ze[ye], ae = ce[ye];
        A.hasOwnProperty(ye) || (q !== ae ? lf(q) && lf(ae) ? !MR(q, ae) || Me ? be(ye) : Z.protectedKeys[ye] = !0 : q !== void 0 ? be(ye) : _.add(ye) : q !== void 0 && _.has(ye) ? be(ye) : Z.protectedKeys[ye] = !0);
      }
      Z.prevProp = oe, Z.prevResolvedValues = ze, Z.isActive && (A = fe(fe({}, A), ze)), a && e.blockInitialAnimation && (Fe = !1), Fe && !Ee && x.push.apply(x, pa([], pt(Ge.map(function(ue) {
        return {
          animation: ue,
          options: fe({ type: W }, h)
        };
      })), !1));
    }, j = 0; j < Ree; j++)
      P(j);
    if (n = fe({}, A), _.size) {
      var k = {};
      _.forEach(function(M) {
        var W = e.getBaseTarget(M);
        W !== void 0 && (k[M] = W);
      }), x.push({ animation: k });
    }
    var L = !!x.length;
    return a && y.initial === !1 && !e.manuallyAnimateOnMount && (L = !1), a = !1, L ? r(x) : Promise.resolve();
  }
  function f(h, p, g) {
    var y;
    if (t[h].isActive === p)
      return Promise.resolve();
    (y = e.variantChildren) === null || y === void 0 || y.forEach(function(_) {
      var A;
      return (A = _.animationState) === null || A === void 0 ? void 0 : A.setActive(h, p);
    }), t[h].isActive = p;
    var S = c(g, h);
    for (var x in t)
      t[x].protectedKeys = {};
    return S;
  }
  return {
    isAnimated: l,
    animateChanges: c,
    setActive: f,
    setAnimateFunction: u,
    getState: function() {
      return t;
    }
  };
}
function jee(e, r) {
  return typeof r == "string" ? r !== e : OM(r) ? !MR(r, e) : !1;
}
function wl(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Dee() {
  var e;
  return e = {}, e[nt.Animate] = wl(!0), e[nt.InView] = wl(), e[nt.Hover] = wl(), e[nt.Tap] = wl(), e[nt.Drag] = wl(), e[nt.Focus] = wl(), e[nt.Exit] = wl(), e;
}
var Nee = {
  animation: Is(function(e) {
    var r = e.visualElement, t = e.animate;
    r.animationState || (r.animationState = kee(r)), s$(t) && ar(function() {
      return t.subscribe(r);
    }, [t]);
  }),
  exit: Is(function(e) {
    var r = e.custom, t = e.visualElement, n = pt(OR(), 2), a = n[0], i = n[1], l = zr(Nf);
    ar(function() {
      var u, c;
      t.isPresent = a;
      var f = (u = t.animationState) === null || u === void 0 ? void 0 : u.setActive(nt.Exit, !a, { custom: (c = l == null ? void 0 : l.custom) !== null && c !== void 0 ? c : r });
      !a && (f == null || f.then(i));
    }, [a]);
  })
}, LR = (
  /** @class */
  function() {
    function e(r, t, n) {
      var a = this, i = n === void 0 ? {} : n, l = i.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (a.lastMoveEvent && a.lastMoveEventInfo) {
          var g = Xb(a.lastMoveEventInfo, a.history), y = a.startEvent !== null, S = _R(g.offset, { x: 0, y: 0 }) >= 3;
          if (!(!y && !S)) {
            var x = g.point, _ = BS().timestamp;
            a.history.push(fe(fe({}, x), { timestamp: _ }));
            var A = a.handlers, O = A.onStart, P = A.onMove;
            y || (O && O(a.lastMoveEvent, g), a.startEvent = a.lastMoveEvent), P && P(a.lastMoveEvent, g);
          }
        }
      }, this.handlePointerMove = function(g, y) {
        if (a.lastMoveEvent = g, a.lastMoveEventInfo = Qb(y, a.transformPagePoint), rR(g) && g.buttons === 0) {
          a.handlePointerUp(g, y);
          return;
        }
        ri.update(a.updatePoint, !0);
      }, this.handlePointerUp = function(g, y) {
        a.end();
        var S = a.handlers, x = S.onEnd, _ = S.onSessionEnd, A = Xb(Qb(y, a.transformPagePoint), a.history);
        a.startEvent && x && x(g, A), _ && _(g, A);
      }, !(tR(r) && r.touches.length > 1)) {
        this.handlers = t, this.transformPagePoint = l;
        var u = l$(r), c = Qb(u, this.transformPagePoint), f = c.point, h = BS().timestamp;
        this.history = [fe(fe({}, f), { timestamp: h })];
        var p = t.onSessionStart;
        p && p(r, Xb(c, this.history)), this.removeListeners = gg(ac(window, "pointermove", this.handlePointerMove), ac(window, "pointerup", this.handlePointerUp), ac(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(r) {
      this.handlers = r;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), ff.update(this.updatePoint);
    }, e;
  }()
);
function Qb(e, r) {
  return r ? { point: r(e.point) } : e;
}
function e4(e, r) {
  return { x: e.x - r.x, y: e.y - r.y };
}
function Xb(e, r) {
  var t = e.point;
  return {
    point: t,
    delta: e4(t, FR(r)),
    offset: e4(t, Lee(r)),
    velocity: Fee(r, 0.1)
  };
}
function Lee(e) {
  return e[0];
}
function FR(e) {
  return e[e.length - 1];
}
function Fee(e, r) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var t = e.length - 1, n = null, a = FR(e); t >= 0 && (n = e[t], !(a.timestamp - n.timestamp > l0(r))); )
    t--;
  if (!n)
    return { x: 0, y: 0 };
  var i = (a.timestamp - n.timestamp) / 1e3;
  if (i === 0)
    return { x: 0, y: 0 };
  var l = {
    x: (a.x - n.x) / i,
    y: (a.y - n.y) / i
  };
  return l.x === 1 / 0 && (l.x = 0), l.y === 1 / 0 && (l.y = 0), l;
}
function Fi(e) {
  return e.max - e.min;
}
function r4(e, r, t) {
  return r === void 0 && (r = 0), t === void 0 && (t = 0.01), _R(e, r) < t;
}
function t4(e, r, t, n) {
  n === void 0 && (n = 0.5), e.origin = n, e.originPoint = Tt(r.min, r.max, e.origin), e.scale = Fi(t) / Fi(r), (r4(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Tt(t.min, t.max, e.origin) - e.originPoint, (r4(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function Rd(e, r, t, n) {
  t4(e.x, r.x, t.x, n == null ? void 0 : n.originX), t4(e.y, r.y, t.y, n == null ? void 0 : n.originY);
}
function n4(e, r, t) {
  e.min = t.min + r.min, e.max = e.min + Fi(r);
}
function zee(e, r, t) {
  n4(e.x, r.x, t.x), n4(e.y, r.y, t.y);
}
function a4(e, r, t) {
  e.min = r.min - t.min, e.max = e.min + Fi(r);
}
function Pd(e, r, t) {
  a4(e.x, r.x, t.x), a4(e.y, r.y, t.y);
}
function Bee(e, r, t) {
  var n = r.min, a = r.max;
  return n !== void 0 && e < n ? e = t ? Tt(n, e, t.min) : Math.max(e, n) : a !== void 0 && e > a && (e = t ? Tt(a, e, t.max) : Math.min(e, a)), e;
}
function o4(e, r, t) {
  return {
    min: r !== void 0 ? e.min + r : void 0,
    max: t !== void 0 ? e.max + t - (e.max - e.min) : void 0
  };
}
function Uee(e, r) {
  var t = r.top, n = r.left, a = r.bottom, i = r.right;
  return {
    x: o4(e.x, n, i),
    y: o4(e.y, t, a)
  };
}
function i4(e, r) {
  var t, n = r.min - e.min, a = r.max - e.max;
  return r.max - r.min < e.max - e.min && (t = pt([a, n], 2), n = t[0], a = t[1]), { min: n, max: a };
}
function Vee(e, r) {
  return {
    x: i4(e.x, r.x),
    y: i4(e.y, r.y)
  };
}
function Wee(e, r) {
  var t = 0.5, n = Fi(e), a = Fi(r);
  return a > n ? t = uf(r.min, r.max - n, e.min) : n > a && (t = uf(e.min, e.max - a, r.min)), o0(0, 1, t);
}
function Hee(e, r) {
  var t = {};
  return r.min !== void 0 && (t.min = r.min - e.min), r.max !== void 0 && (t.max = r.max - e.min), t;
}
var VS = 0.35;
function Gee(e) {
  return e === void 0 && (e = VS), e === !1 ? e = 0 : e === !0 && (e = VS), {
    x: s4(e, "left", "right"),
    y: s4(e, "top", "bottom")
  };
}
function s4(e, r, t) {
  return {
    min: l4(e, r),
    max: l4(e, t)
  };
}
function l4(e, r) {
  var t;
  return typeof e == "number" ? e : (t = e[r]) !== null && t !== void 0 ? t : 0;
}
var u4 = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, kd = function() {
  return {
    x: u4(),
    y: u4()
  };
}, c4 = function() {
  return { min: 0, max: 0 };
}, $n = function() {
  return {
    x: c4(),
    y: c4()
  };
};
function Ho(e) {
  return [e("x"), e("y")];
}
function zR(e) {
  var r = e.top, t = e.left, n = e.right, a = e.bottom;
  return {
    x: { min: t, max: n },
    y: { min: r, max: a }
  };
}
function Yee(e) {
  var r = e.x, t = e.y;
  return { top: t.min, right: r.max, bottom: t.max, left: r.min };
}
function Kee(e, r) {
  if (!r)
    return e;
  var t = r({ x: e.left, y: e.top }), n = r({ x: e.right, y: e.bottom });
  return {
    top: t.y,
    left: t.x,
    bottom: n.y,
    right: n.x
  };
}
function Jb(e) {
  return e === void 0 || e === 1;
}
function BR(e) {
  var r = e.scale, t = e.scaleX, n = e.scaleY;
  return !Jb(r) || !Jb(t) || !Jb(n);
}
function Ts(e) {
  return BR(e) || d4(e.x) || d4(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function d4(e) {
  return e && e !== "0%";
}
function u0(e, r, t) {
  var n = e - t, a = r * n;
  return t + a;
}
function f4(e, r, t, n, a) {
  return a !== void 0 && (e = u0(e, a, n)), u0(e, t, n) + r;
}
function WS(e, r, t, n, a) {
  r === void 0 && (r = 0), t === void 0 && (t = 1), e.min = f4(e.min, r, t, n, a), e.max = f4(e.max, r, t, n, a);
}
function UR(e, r) {
  var t = r.x, n = r.y;
  WS(e.x, t.translate, t.scale, t.originPoint), WS(e.y, n.translate, n.scale, n.originPoint);
}
function Zee(e, r, t, n) {
  var a, i;
  n === void 0 && (n = !1);
  var l = t.length;
  if (l) {
    r.x = r.y = 1;
    for (var u, c, f = 0; f < l; f++)
      u = t[f], c = u.projectionDelta, ((i = (a = u.instance) === null || a === void 0 ? void 0 : a.style) === null || i === void 0 ? void 0 : i.display) !== "contents" && (n && u.options.layoutScroll && u.scroll && u !== u.root && Gu(e, { x: -u.scroll.x, y: -u.scroll.y }), c && (r.x *= c.x.scale, r.y *= c.y.scale, UR(e, c)), n && Ts(u.latestValues) && Gu(e, u.latestValues));
  }
}
function Cs(e, r) {
  e.min = e.min + r, e.max = e.max + r;
}
function v4(e, r, t) {
  var n = pt(t, 3), a = n[0], i = n[1], l = n[2], u = r[l] !== void 0 ? r[l] : 0.5, c = Tt(e.min, e.max, u);
  WS(e, r[a], r[i], c, r.scale);
}
var qee = ["x", "scaleX", "originX"], Qee = ["y", "scaleY", "originY"];
function Gu(e, r) {
  v4(e.x, r, qee), v4(e.y, r, Qee);
}
function VR(e, r) {
  return zR(Kee(e.getBoundingClientRect(), r));
}
function Xee(e, r, t) {
  var n = VR(e, t), a = r.scroll;
  return a && (Cs(n.x, a.x), Cs(n.y, a.y)), n;
}
var Jee = /* @__PURE__ */ new WeakMap(), ere = (
  /** @class */
  function() {
    function e(r) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = $n(), this.visualElement = r;
    }
    return e.prototype.start = function(r, t) {
      var n = this, a = t === void 0 ? {} : t, i = a.snapToCursor, l = i === void 0 ? !1 : i;
      if (this.visualElement.isPresent !== !1) {
        var u = function(p) {
          n.stopAnimation(), l && n.snapToCursor(l$(p, "page").point);
        }, c = function(p, g) {
          var y, S = n.getProps(), x = S.drag, _ = S.dragPropagation, A = S.onDragStart;
          x && !_ && (n.openGlobalLock && n.openGlobalLock(), n.openGlobalLock = iR(x), !n.openGlobalLock) || (n.isDragging = !0, n.currentDirection = null, n.resolveConstraints(), n.visualElement.projection && (n.visualElement.projection.isAnimationBlocked = !0, n.visualElement.projection.target = void 0), Ho(function(O) {
            var P, j, k = n.getAxisMotionValue(O).get() || 0;
            if (ei.test(k)) {
              var L = (j = (P = n.visualElement.projection) === null || P === void 0 ? void 0 : P.layout) === null || j === void 0 ? void 0 : j.actual[O];
              if (L) {
                var M = Fi(L);
                k = M * (parseFloat(k) / 100);
              }
            }
            n.originPoint[O] = k;
          }), A == null || A(p, g), (y = n.visualElement.animationState) === null || y === void 0 || y.setActive(nt.Drag, !0));
        }, f = function(p, g) {
          var y = n.getProps(), S = y.dragPropagation, x = y.dragDirectionLock, _ = y.onDirectionLock, A = y.onDrag;
          if (!(!S && !n.openGlobalLock)) {
            var O = g.offset;
            if (x && n.currentDirection === null) {
              n.currentDirection = rre(O), n.currentDirection !== null && (_ == null || _(n.currentDirection));
              return;
            }
            n.updateAxis("x", g.point, O), n.updateAxis("y", g.point, O), n.visualElement.syncRender(), A == null || A(p, g);
          }
        }, h = function(p, g) {
          return n.stop(p, g);
        };
        this.panSession = new LR(r, {
          onSessionStart: u,
          onStart: c,
          onMove: f,
          onSessionEnd: h
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(r, t) {
      var n = this.isDragging;
      if (this.cancel(), !!n) {
        var a = t.velocity;
        this.startAnimation(a);
        var i = this.getProps().onDragEnd;
        i == null || i(r, t);
      }
    }, e.prototype.cancel = function() {
      var r, t;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (r = this.panSession) === null || r === void 0 || r.end(), this.panSession = void 0;
      var n = this.getProps().dragPropagation;
      !n && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (t = this.visualElement.animationState) === null || t === void 0 || t.setActive(nt.Drag, !1);
    }, e.prototype.updateAxis = function(r, t, n) {
      var a = this.getProps().drag;
      if (!(!n || !ch(r, a, this.currentDirection))) {
        var i = this.getAxisMotionValue(r), l = this.originPoint[r] + n[r];
        this.constraints && this.constraints[r] && (l = Bee(l, this.constraints[r], this.elastic[r])), i.set(l);
      }
    }, e.prototype.resolveConstraints = function() {
      var r = this, t = this.getProps(), n = t.dragConstraints, a = t.dragElastic, i = (this.visualElement.projection || {}).layout, l = this.constraints;
      n && Hu(n) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : n && i ? this.constraints = Uee(i.actual, n) : this.constraints = !1, this.elastic = Gee(a), l !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && Ho(function(u) {
        r.getAxisMotionValue(u) && (r.constraints[u] = Hee(i.actual[u], r.constraints[u]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var r = this.getProps(), t = r.dragConstraints, n = r.onMeasureDragConstraints;
      if (!t || !Hu(t))
        return !1;
      var a = t.current, i = this.visualElement.projection;
      if (!i || !i.layout)
        return !1;
      var l = Xee(a, i.root, this.visualElement.getTransformPagePoint()), u = Vee(i.layout.actual, l);
      if (n) {
        var c = n(Yee(u));
        this.hasMutatedConstraints = !!c, c && (u = zR(c));
      }
      return u;
    }, e.prototype.startAnimation = function(r) {
      var t = this, n = this.getProps(), a = n.drag, i = n.dragMomentum, l = n.dragElastic, u = n.dragTransition, c = n.dragSnapToOrigin, f = n.onDragTransitionEnd, h = this.constraints || {}, p = Ho(function(g) {
        var y;
        if (ch(g, a, t.currentDirection)) {
          var S = (y = h == null ? void 0 : h[g]) !== null && y !== void 0 ? y : {};
          c && (S = { min: 0, max: 0 });
          var x = l ? 200 : 1e6, _ = l ? 40 : 1e7, A = fe(fe({ type: "inertia", velocity: i ? r[g] : 0, bounceStiffness: x, bounceDamping: _, timeConstant: 750, restDelta: 1, restSpeed: 10 }, u), S);
          return t.startAxisValueAnimation(g, A);
        }
      });
      return Promise.all(p).then(f);
    }, e.prototype.startAxisValueAnimation = function(r, t) {
      var n = this.getAxisMotionValue(r);
      return y$(r, n, 0, t);
    }, e.prototype.stopAnimation = function() {
      var r = this;
      Ho(function(t) {
        return r.getAxisMotionValue(t).stop();
      });
    }, e.prototype.getAxisMotionValue = function(r) {
      var t, n, a = "_drag" + r.toUpperCase(), i = this.visualElement.getProps()[a];
      return i || this.visualElement.getValue(r, (n = (t = this.visualElement.getProps().initial) === null || t === void 0 ? void 0 : t[r]) !== null && n !== void 0 ? n : 0);
    }, e.prototype.snapToCursor = function(r) {
      var t = this;
      Ho(function(n) {
        var a = t.getProps().drag;
        if (ch(n, a, t.currentDirection)) {
          var i = t.visualElement.projection, l = t.getAxisMotionValue(n);
          if (i && i.layout) {
            var u = i.layout.actual[n], c = u.min, f = u.max;
            l.set(r[n] - Tt(c, f, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var r = this, t, n = this.getProps(), a = n.drag, i = n.dragConstraints, l = this.visualElement.projection;
      if (!(!Hu(i) || !l || !this.constraints)) {
        this.stopAnimation();
        var u = { x: 0, y: 0 };
        Ho(function(f) {
          var h = r.getAxisMotionValue(f);
          if (h) {
            var p = h.get();
            u[f] = Wee({ min: p, max: p }, r.constraints[f]);
          }
        });
        var c = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = c ? c({}, "") : "none", (t = l.root) === null || t === void 0 || t.updateScroll(), l.updateLayout(), this.resolveConstraints(), Ho(function(f) {
          if (ch(f, a, null)) {
            var h = r.getAxisMotionValue(f), p = r.constraints[f], g = p.min, y = p.max;
            h.set(Tt(g, y, u[f]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var r = this, t;
      Jee.set(this.visualElement, this);
      var n = this.visualElement.getInstance(), a = ac(n, "pointerdown", function(f) {
        var h = r.getProps(), p = h.drag, g = h.dragListener, y = g === void 0 ? !0 : g;
        p && y && r.start(f);
      }), i = function() {
        var f = r.getProps().dragConstraints;
        Hu(f) && (r.constraints = r.resolveRefConstraints());
      }, l = this.visualElement.projection, u = l.addEventListener("measure", i);
      l && !l.layout && ((t = l.root) === null || t === void 0 || t.updateScroll(), l.updateLayout()), i();
      var c = pg(window, "resize", function() {
        return r.scalePositionWithinConstraints();
      });
      return l.addEventListener("didUpdate", function(f) {
        var h = f.delta, p = f.hasLayoutChanged;
        r.isDragging && p && (Ho(function(g) {
          var y = r.getAxisMotionValue(g);
          y && (r.originPoint[g] += h[g].translate, y.set(y.get() + h[g].translate));
        }), r.visualElement.syncRender());
      }), function() {
        c(), a(), u();
      };
    }, e.prototype.getProps = function() {
      var r = this.visualElement.getProps(), t = r.drag, n = t === void 0 ? !1 : t, a = r.dragDirectionLock, i = a === void 0 ? !1 : a, l = r.dragPropagation, u = l === void 0 ? !1 : l, c = r.dragConstraints, f = c === void 0 ? !1 : c, h = r.dragElastic, p = h === void 0 ? VS : h, g = r.dragMomentum, y = g === void 0 ? !0 : g;
      return fe(fe({}, r), { drag: n, dragDirectionLock: i, dragPropagation: u, dragConstraints: f, dragElastic: p, dragMomentum: y });
    }, e;
  }()
);
function ch(e, r, t) {
  return (r === !0 || r === e) && (t === null || t === e);
}
function rre(e, r) {
  r === void 0 && (r = 10);
  var t = null;
  return Math.abs(e.y) > r ? t = "y" : Math.abs(e.x) > r && (t = "x"), t;
}
function tre(e) {
  var r = e.dragControls, t = e.visualElement, n = Lf(function() {
    return new ere(t);
  });
  ar(function() {
    return r && r.subscribe(n);
  }, [n, r]), ar(function() {
    return n.addListeners();
  }, [n]);
}
function nre(e) {
  var r = e.onPan, t = e.onPanStart, n = e.onPanEnd, a = e.onPanSessionStart, i = e.visualElement, l = r || t || n || a, u = Qe(null), c = zr(J2).transformPagePoint, f = {
    onSessionStart: a,
    onStart: t,
    onMove: r,
    onEnd: function(p, g) {
      u.current = null, n && n(p, g);
    }
  };
  ar(function() {
    u.current !== null && u.current.updateHandlers(f);
  });
  function h(p) {
    u.current = new LR(p, f, {
      transformPagePoint: c
    });
  }
  a0(i, "pointerdown", l && h), u$(function() {
    return u.current && u.current.end();
  });
}
var are = {
  pan: Is(nre),
  drag: Is(tre)
}, dh = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function ore() {
  var e = dh.map(function() {
    return new Md();
  }), r = {}, t = {
    clearAllListeners: function() {
      return e.forEach(function(n) {
        return n.clear();
      });
    },
    updatePropListeners: function(n) {
      dh.forEach(function(a) {
        var i, l = "on" + a, u = n[l];
        (i = r[a]) === null || i === void 0 || i.call(r), u && (r[a] = t[l](u));
      });
    }
  };
  return e.forEach(function(n, a) {
    t["on" + dh[a]] = function(i) {
      return n.add(i);
    }, t["notify" + dh[a]] = function() {
      for (var i = [], l = 0; l < arguments.length; l++)
        i[l] = arguments[l];
      return n.notify.apply(n, pa([], pt(i), !1));
    };
  }), t;
}
function ire(e, r, t) {
  var n;
  for (var a in r) {
    var i = r[a], l = t[a];
    if (Ni(i))
      e.addValue(a, i);
    else if (Ni(l))
      e.addValue(a, pc(i));
    else if (l !== i)
      if (e.hasValue(a)) {
        var u = e.getValue(a);
        !u.hasAnimated && u.set(i);
      } else
        e.addValue(a, pc((n = e.getStaticValue(a)) !== null && n !== void 0 ? n : i));
  }
  for (var a in t)
    r[a] === void 0 && e.removeValue(a);
  return r;
}
var WR = function(e) {
  var r = e.treeType, t = r === void 0 ? "" : r, n = e.build, a = e.getBaseTarget, i = e.makeTargetAnimatable, l = e.measureViewportBox, u = e.render, c = e.readValueFromInstance, f = e.removeValueFromRenderState, h = e.sortNodePosition, p = e.scrapeMotionValuesFromProps;
  return function(g, y) {
    var S = g.parent, x = g.props, _ = g.presenceId, A = g.blockInitialAnimation, O = g.visualState, P = g.shouldReduceMotion;
    y === void 0 && (y = {});
    var j = !1, k = O.latestValues, L = O.renderState, M, W = ore(), Z = /* @__PURE__ */ new Map(), oe = /* @__PURE__ */ new Map(), Ie = {}, Te = fe({}, k), Ee;
    function Me() {
      !M || !j || (Fe(), u(M, L, x.style, q.projection));
    }
    function Fe() {
      n(q, L, k, y, x);
    }
    function Ge() {
      W.notifyUpdate(k);
    }
    function ze(ae, ue) {
      var $e = ue.onChange(function(_e) {
        k[ae] = _e, x.onUpdate && ri.update(Ge, !1, !0);
      }), Ze = ue.onRenderRequest(q.scheduleRender);
      oe.set(ae, function() {
        $e(), Ze();
      });
    }
    var le = p(x);
    for (var ce in le) {
      var he = le[ce];
      k[ce] !== void 0 && Ni(he) && he.set(k[ce], !1);
    }
    var be = hg(x), ye = RM(x), q = fe(fe({
      treeType: t,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: S ? S.depth + 1 : 0,
      parent: S,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: _,
      shouldReduceMotion: P,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: ye ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(S != null && S.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: A,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!M;
      },
      mount: function(ae) {
        j = !0, M = q.current = ae, q.projection && q.projection.mount(ae), ye && S && !be && (Ee = S == null ? void 0 : S.addVariantChild(q)), Z.forEach(function(ue, $e) {
          return ze($e, ue);
        }), S == null || S.children.add(q), q.setProps(x);
      },
      /**
       *
       */
      unmount: function() {
        var ae;
        (ae = q.projection) === null || ae === void 0 || ae.unmount(), ff.update(Ge), ff.render(Me), oe.forEach(function(ue) {
          return ue();
        }), Ee == null || Ee(), S == null || S.children.delete(q), W.clearAllListeners(), M = void 0, j = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(ae) {
        var ue, $e = q.getClosestVariantNode();
        if ($e)
          return (ue = $e.variantChildren) === null || ue === void 0 || ue.add(ae), function() {
            return $e.variantChildren.delete(ae);
          };
      },
      sortNodePosition: function(ae) {
        return !h || t !== ae.treeType ? 0 : h(q.getInstance(), ae.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return ye ? q : S == null ? void 0 : S.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return x.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return M;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(ae) {
        return k[ae];
      },
      setStaticValue: function(ae, ue) {
        return k[ae] = ue;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return k;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(ae) {
        q.isVisible !== ae && (q.isVisible = ae, q.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(ae, ue) {
        return ue === void 0 && (ue = !0), i(q, ae, x, ue);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return l(M, x);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(ae, ue) {
        q.hasValue(ae) && q.removeValue(ae), Z.set(ae, ue), k[ae] = ue.get(), ze(ae, ue);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(ae) {
        var ue;
        Z.delete(ae), (ue = oe.get(ae)) === null || ue === void 0 || ue(), oe.delete(ae), delete k[ae], f(ae, L);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(ae) {
        return Z.has(ae);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(ae, ue) {
        var $e = Z.get(ae);
        return $e === void 0 && ue !== void 0 && ($e = pc(ue), q.addValue(ae, $e)), $e;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(ae) {
        return Z.forEach(ae);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(ae) {
        var ue;
        return (ue = k[ae]) !== null && ue !== void 0 ? ue : c(M, ae, y);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(ae, ue) {
        Te[ae] = ue;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(ae) {
        if (a) {
          var ue = a(x, ae);
          if (ue !== void 0 && !Ni(ue))
            return ue;
        }
        return Te[ae];
      }
    }, W), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return Fe(), L;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        ri.render(Me, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: Me,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(ae) {
        (ae.transformTemplate || x.transformTemplate) && q.scheduleRender(), x = ae, W.updatePropListeners(ae), Ie = ire(q, p(x), Ie);
      },
      getProps: function() {
        return x;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(ae) {
        var ue;
        return (ue = x.variants) === null || ue === void 0 ? void 0 : ue[ae];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return x.transition;
      },
      getTransformPagePoint: function() {
        return x.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(ae) {
        if (ae === void 0 && (ae = !1), ae)
          return S == null ? void 0 : S.getVariantContext();
        if (!be) {
          var ue = (S == null ? void 0 : S.getVariantContext()) || {};
          return x.initial !== void 0 && (ue.initial = x.initial), ue;
        }
        for (var $e = {}, Ze = 0; Ze < sre; Ze++) {
          var _e = HR[Ze], or = x[_e];
          (mo(or) || or === !1) && ($e[_e] = or);
        }
        return $e;
      }
    });
    return q;
  };
}, HR = pa(["initial"], pt($$), !1), sre = HR.length;
function HS(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var GR = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function lre(e) {
  var r = GR.exec(e);
  if (!r)
    return [,];
  var t = pt(r, 3), n = t[1], a = t[2];
  return [n, a];
}
function GS(e, r, t) {
  var n = pt(lre(e), 2), a = n[0], i = n[1];
  if (a) {
    var l = window.getComputedStyle(r).getPropertyValue(a);
    return l ? l.trim() : HS(i) ? GS(i, r) : i;
  }
}
function ure(e, r, t) {
  var n, a = Wa(r, []), i = e.getInstance();
  if (!(i instanceof Element))
    return { target: a, transitionEnd: t };
  t && (t = fe({}, t)), e.forEachValue(function(f) {
    var h = f.get();
    if (HS(h)) {
      var p = GS(h, i);
      p && f.set(p);
    }
  });
  for (var l in a) {
    var u = a[l];
    if (HS(u)) {
      var c = GS(u, i);
      c && (a[l] = c, t && ((n = t[l]) !== null && n !== void 0 || (t[l] = u)));
    }
  }
  return { target: a, transitionEnd: t };
}
var cre = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), YR = function(e) {
  return cre.has(e);
}, dre = function(e) {
  return Object.keys(e).some(YR);
}, KR = function(e, r) {
  e.set(r, !1), e.set(r);
}, h4 = function(e) {
  return e === iu || e === We;
}, p4;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(p4 || (p4 = {}));
var g4 = function(e, r) {
  return parseFloat(e.split(", ")[r]);
}, m4 = function(e, r) {
  return function(t, n) {
    var a = n.transform;
    if (a === "none" || !a)
      return 0;
    var i = a.match(/^matrix3d\((.+)\)$/);
    if (i)
      return g4(i[1], r);
    var l = a.match(/^matrix\((.+)\)$/);
    return l ? g4(l[1], e) : 0;
  };
}, fre = /* @__PURE__ */ new Set(["x", "y", "z"]), vre = of.filter(function(e) {
  return !fre.has(e);
});
function hre(e) {
  var r = [];
  return vre.forEach(function(t) {
    var n = e.getValue(t);
    n !== void 0 && (r.push([t, n.get()]), n.set(t.startsWith("scale") ? 1 : 0));
  }), r.length && e.syncRender(), r;
}
var b4 = {
  // Dimensions
  width: function(e, r) {
    var t = e.x, n = r.paddingLeft, a = n === void 0 ? "0" : n, i = r.paddingRight, l = i === void 0 ? "0" : i;
    return t.max - t.min - parseFloat(a) - parseFloat(l);
  },
  height: function(e, r) {
    var t = e.y, n = r.paddingTop, a = n === void 0 ? "0" : n, i = r.paddingBottom, l = i === void 0 ? "0" : i;
    return t.max - t.min - parseFloat(a) - parseFloat(l);
  },
  top: function(e, r) {
    var t = r.top;
    return parseFloat(t);
  },
  left: function(e, r) {
    var t = r.left;
    return parseFloat(t);
  },
  bottom: function(e, r) {
    var t = e.y, n = r.top;
    return parseFloat(n) + (t.max - t.min);
  },
  right: function(e, r) {
    var t = e.x, n = r.left;
    return parseFloat(n) + (t.max - t.min);
  },
  // Transform
  x: m4(4, 13),
  y: m4(5, 14)
}, pre = function(e, r, t) {
  var n = r.measureViewportBox(), a = r.getInstance(), i = getComputedStyle(a), l = i.display, u = {};
  l === "none" && r.setStaticValue("display", e.display || "block"), t.forEach(function(f) {
    u[f] = b4[f](n, i);
  }), r.syncRender();
  var c = r.measureViewportBox();
  return t.forEach(function(f) {
    var h = r.getValue(f);
    KR(h, u[f]), e[f] = b4[f](c, i);
  }), e;
}, gre = function(e, r, t, n) {
  t === void 0 && (t = {}), n === void 0 && (n = {}), r = fe({}, r), n = fe({}, n);
  var a = Object.keys(r).filter(YR), i = [], l = !1, u = [];
  if (a.forEach(function(h) {
    var p = e.getValue(h);
    if (e.hasValue(h)) {
      var g = t[h], y = rd(g), S = r[h], x;
      if (lf(S)) {
        var _ = S.length, A = S[0] === null ? 1 : 0;
        g = S[A], y = rd(g);
        for (var O = A; O < _; O++)
          x ? e0(rd(S[O]) === x) : x = rd(S[O]);
      } else
        x = rd(S);
      if (y !== x)
        if (h4(y) && h4(x)) {
          var P = p.get();
          typeof P == "string" && p.set(parseFloat(P)), typeof S == "string" ? r[h] = parseFloat(S) : Array.isArray(S) && x === We && (r[h] = S.map(parseFloat));
        } else
          y != null && y.transform && (x != null && x.transform) && (g === 0 || S === 0) ? g === 0 ? p.set(x.transform(g)) : r[h] = y.transform(S) : (l || (i = hre(e), l = !0), u.push(h), n[h] = n[h] !== void 0 ? n[h] : r[h], KR(p, S));
    }
  }), u.length) {
    var c = u.indexOf("height") >= 0 ? window.pageYOffset : null, f = pre(r, e, u);
    return i.length && i.forEach(function(h) {
      var p = pt(h, 2), g = p[0], y = p[1];
      e.getValue(g).set(y);
    }), e.syncRender(), c !== null && window.scrollTo({ top: c }), { target: f, transitionEnd: n };
  } else
    return { target: r, transitionEnd: n };
};
function mre(e, r, t, n) {
  return dre(r) ? gre(e, r, t, n) : { target: r, transitionEnd: n };
}
var bre = function(e, r, t, n) {
  var a = ure(e, r, n);
  return r = a.target, n = a.transitionEnd, mre(e, r, t, n);
};
function yre(e) {
  return window.getComputedStyle(e);
}
var ZR = {
  treeType: "dom",
  readValueFromInstance: function(e, r) {
    if (Ff(r)) {
      var t = g$(r);
      return t && t.default || 0;
    } else {
      var n = yre(e);
      return (DM(r) ? n.getPropertyValue(r) : n[r]) || 0;
    }
  },
  sortNodePosition: function(e, r) {
    return e.compareDocumentPosition(r) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, r) {
    var t;
    return (t = e.style) === null || t === void 0 ? void 0 : t[r];
  },
  measureViewportBox: function(e, r) {
    var t = r.transformPagePoint;
    return VR(e, t);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, r, t) {
    var n = t.transformTemplate;
    r.style.transform = n ? n({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, r) {
    e.style.transform = r.style.transform;
  },
  removeValueFromRenderState: function(e, r) {
    var t = r.vars, n = r.style;
    delete t[e], delete n[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, r, t, n) {
    var a = t.transformValues;
    n === void 0 && (n = !0);
    var i = r.transition, l = r.transitionEnd, u = Wa(r, ["transition", "transitionEnd"]), c = Cee(u, i || {}, e);
    if (a && (l && (l = a(l)), u && (u = a(u)), c && (c = a(c))), n) {
      _ee(e, u, c);
      var f = bre(e, u, c, l);
      l = f.transitionEnd, u = f.target;
    }
    return fe({ transition: i, transitionEnd: l }, u);
  },
  scrapeMotionValuesFromProps: i$,
  build: function(e, r, t, n, a) {
    e.isVisible !== void 0 && (r.style.visibility = e.isVisible ? "visible" : "hidden"), n$(r, t, n, a.transformTemplate);
  },
  render: ZM
}, Sre = WR(ZR), xre = WR(fe(fe({}, ZR), { getBaseTarget: function(e, r) {
  return e[r];
}, readValueFromInstance: function(e, r) {
  var t;
  return Ff(r) ? ((t = g$(r)) === null || t === void 0 ? void 0 : t.default) || 0 : (r = qM.has(r) ? r : KM(r), e.getAttribute(r));
}, scrapeMotionValuesFromProps: XM, build: function(e, r, t, n, a) {
  o$(r, t, n, a.transformTemplate);
}, render: QM })), $re = function(e, r) {
  return r$(e) ? xre(r, { enableHardwareAcceleration: !1 }) : Sre(r, { enableHardwareAcceleration: !0 });
};
function y4(e, r) {
  return r.max === r.min ? 0 : e / (r.max - r.min) * 100;
}
var td = {
  correct: function(e, r) {
    if (!r.target)
      return e;
    if (typeof e == "string")
      if (We.test(e))
        e = parseFloat(e);
      else
        return e;
    var t = y4(e, r.target.x), n = y4(e, r.target.y);
    return "".concat(t, "% ").concat(n, "%");
  }
}, S4 = "_$css", wre = {
  correct: function(e, r) {
    var t = r.treeScale, n = r.projectionDelta, a = e, i = e.includes("var("), l = [];
    i && (e = e.replace(GR, function(x) {
      return l.push(x), S4;
    }));
    var u = Li.parse(e);
    if (u.length > 5)
      return a;
    var c = Li.createTransformer(e), f = typeof u[0] != "number" ? 1 : 0, h = n.x.scale * t.x, p = n.y.scale * t.y;
    u[0 + f] /= h, u[1 + f] /= p;
    var g = Tt(h, p, 0.5);
    typeof u[2 + f] == "number" && (u[2 + f] /= g), typeof u[3 + f] == "number" && (u[3 + f] /= g);
    var y = c(u);
    if (i) {
      var S = 0;
      y = y.replace(S4, function() {
        var x = l[S];
        return S++, x;
      });
    }
    return y;
  }
}, _re = (
  /** @class */
  function(e) {
    CM(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return r.prototype.componentDidMount = function() {
      var t = this, n = this.props, a = n.visualElement, i = n.layoutGroup, l = n.switchLayoutGroup, u = n.layoutId, c = a.projection;
      BQ(Cre), c && (i != null && i.group && i.group.add(c), l != null && l.register && u && l.register(c), c.root.didUpdate(), c.addEventListener("animationComplete", function() {
        t.safeToRemove();
      }), c.setOptions(fe(fe({}, c.options), { onExitComplete: function() {
        return t.safeToRemove();
      } }))), Ad.hasEverUpdated = !0;
    }, r.prototype.getSnapshotBeforeUpdate = function(t) {
      var n = this, a = this.props, i = a.layoutDependency, l = a.visualElement, u = a.drag, c = a.isPresent, f = l.projection;
      return f && (f.isPresent = c, u || t.layoutDependency !== i || i === void 0 ? f.willUpdate() : this.safeToRemove(), t.isPresent !== c && (c ? f.promote() : f.relegate() || ri.postRender(function() {
        var h;
        !((h = f.getStack()) === null || h === void 0) && h.members.length || n.safeToRemove();
      }))), null;
    }, r.prototype.componentDidUpdate = function() {
      var t = this.props.visualElement.projection;
      t && (t.root.didUpdate(), !t.currentAnimation && t.isLead() && this.safeToRemove());
    }, r.prototype.componentWillUnmount = function() {
      var t = this.props, n = t.visualElement, a = t.layoutGroup, i = t.switchLayoutGroup, l = n.projection;
      l && (l.scheduleCheckAfterUnmount(), a != null && a.group && a.group.remove(l), i != null && i.deregister && i.deregister(l));
    }, r.prototype.safeToRemove = function() {
      var t = this.props.safeToRemove;
      t == null || t();
    }, r.prototype.render = function() {
      return null;
    }, r;
  }(xo.Component)
);
function Tre(e) {
  var r = pt(OR(), 2), t = r[0], n = r[1], a = zr(e$);
  return xo.createElement(_re, fe({}, e, { layoutGroup: a, switchLayoutGroup: zr(PM), isPresent: t, safeToRemove: n }));
}
var Cre = {
  borderRadius: fe(fe({}, td), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: td,
  borderTopRightRadius: td,
  borderBottomLeftRadius: td,
  borderBottomRightRadius: td,
  boxShadow: wre
}, Ere = {
  measureLayout: Tre
};
function Are(e, r, t) {
  t === void 0 && (t = {});
  var n = Ni(e) ? e : pc(e);
  return y$("", n, r, t), {
    stop: function() {
      return n.stop();
    },
    isAnimating: function() {
      return n.isAnimating();
    }
  };
}
var qR = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Ire = qR.length, x4 = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, $4 = function(e) {
  return typeof e == "number" || We.test(e);
};
function Ore(e, r, t, n, a, i) {
  var l, u, c, f;
  a ? (e.opacity = Tt(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (l = t.opacity) !== null && l !== void 0 ? l : 1,
    Mre(n)
  ), e.opacityExit = Tt((u = r.opacity) !== null && u !== void 0 ? u : 1, 0, Rre(n))) : i && (e.opacity = Tt((c = r.opacity) !== null && c !== void 0 ? c : 1, (f = t.opacity) !== null && f !== void 0 ? f : 1, n));
  for (var h = 0; h < Ire; h++) {
    var p = "border".concat(qR[h], "Radius"), g = w4(r, p), y = w4(t, p);
    if (!(g === void 0 && y === void 0)) {
      g || (g = 0), y || (y = 0);
      var S = g === 0 || y === 0 || $4(g) === $4(y);
      S ? (e[p] = Math.max(Tt(x4(g), x4(y), n), 0), (ei.test(y) || ei.test(g)) && (e[p] += "%")) : e[p] = y;
    }
  }
  (r.rotate || t.rotate) && (e.rotate = Tt(r.rotate || 0, t.rotate || 0, n));
}
function w4(e, r) {
  var t;
  return (t = e[r]) !== null && t !== void 0 ? t : e.borderRadius;
}
var Mre = QR(0, 0.5, h$), Rre = QR(0.5, 0.95, f$);
function QR(e, r, t) {
  return function(n) {
    return n < e ? 0 : n > r ? 1 : t(uf(e, r, n));
  };
}
function _4(e, r) {
  e.min = r.min, e.max = r.max;
}
function ao(e, r) {
  _4(e.x, r.x), _4(e.y, r.y);
}
function T4(e, r, t, n, a) {
  return e -= r, e = u0(e, 1 / t, n), a !== void 0 && (e = u0(e, 1 / a, n)), e;
}
function Pre(e, r, t, n, a, i, l) {
  if (r === void 0 && (r = 0), t === void 0 && (t = 1), n === void 0 && (n = 0.5), i === void 0 && (i = e), l === void 0 && (l = e), ei.test(r)) {
    r = parseFloat(r);
    var u = Tt(l.min, l.max, r / 100);
    r = u - l.min;
  }
  if (typeof r == "number") {
    var c = Tt(i.min, i.max, n);
    e === i && (c -= r), e.min = T4(e.min, r, t, c, a), e.max = T4(e.max, r, t, c, a);
  }
}
function C4(e, r, t, n, a) {
  var i = pt(t, 3), l = i[0], u = i[1], c = i[2];
  Pre(e, r[l], r[u], r[c], r.scale, n, a);
}
var kre = ["x", "scaleX", "originX"], jre = ["y", "scaleY", "originY"];
function E4(e, r, t, n) {
  C4(e.x, r, kre, t == null ? void 0 : t.x, n == null ? void 0 : n.x), C4(e.y, r, jre, t == null ? void 0 : t.y, n == null ? void 0 : n.y);
}
function A4(e) {
  return e.translate === 0 && e.scale === 1;
}
function XR(e) {
  return A4(e.x) && A4(e.y);
}
function JR(e, r) {
  return e.x.min === r.x.min && e.x.max === r.x.max && e.y.min === r.y.min && e.y.max === r.y.max;
}
var Dre = (
  /** @class */
  function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(r) {
      S$(this.members, r), r.scheduleRender();
    }, e.prototype.remove = function(r) {
      if (x$(this.members, r), r === this.prevLead && (this.prevLead = void 0), r === this.lead) {
        var t = this.members[this.members.length - 1];
        t && this.promote(t);
      }
    }, e.prototype.relegate = function(r) {
      var t = this.members.findIndex(function(l) {
        return r === l;
      });
      if (t === 0)
        return !1;
      for (var n, a = t; a >= 0; a--) {
        var i = this.members[a];
        if (i.isPresent !== !1) {
          n = i;
          break;
        }
      }
      return n ? (this.promote(n), !0) : !1;
    }, e.prototype.promote = function(r, t) {
      var n, a = this.lead;
      if (r !== a && (this.prevLead = a, this.lead = r, r.show(), a)) {
        a.instance && a.scheduleRender(), r.scheduleRender(), r.resumeFrom = a, t && (r.resumeFrom.preserveOpacity = !0), a.snapshot && (r.snapshot = a.snapshot, r.snapshot.latestValues = a.animationValues || a.latestValues, r.snapshot.isShared = !0), !((n = r.root) === null || n === void 0) && n.isUpdating && (r.isLayoutDirty = !0);
        var i = r.options.crossfade;
        i === !1 && a.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(r) {
        var t, n, a, i, l;
        (n = (t = r.options).onExitComplete) === null || n === void 0 || n.call(t), (l = (a = r.resumingFrom) === null || a === void 0 ? void 0 : (i = a.options).onExitComplete) === null || l === void 0 || l.call(i);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(r) {
        r.instance && r.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  }()
), Nre = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function I4(e, r, t) {
  var n = e.x.translate / r.x, a = e.y.translate / r.y, i = "translate3d(".concat(n, "px, ").concat(a, "px, 0) ");
  if (i += "scale(".concat(1 / r.x, ", ").concat(1 / r.y, ") "), t) {
    var l = t.rotate, u = t.rotateX, c = t.rotateY;
    l && (i += "rotate(".concat(l, "deg) ")), u && (i += "rotateX(".concat(u, "deg) ")), c && (i += "rotateY(".concat(c, "deg) "));
  }
  var f = e.x.scale * r.x, h = e.y.scale * r.y;
  return i += "scale(".concat(f, ", ").concat(h, ")"), i === Nre ? "none" : i;
}
var Lre = function(e, r) {
  return e.depth - r.depth;
}, Fre = (
  /** @class */
  function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(r) {
      S$(this.children, r), this.isDirty = !0;
    }, e.prototype.remove = function(r) {
      x$(this.children, r), this.isDirty = !0;
    }, e.prototype.forEach = function(r) {
      this.isDirty && this.children.sort(Lre), this.isDirty = !1, this.children.forEach(r);
    }, e;
  }()
), O4 = 1e3;
function eP(e) {
  var r = e.attachResizeListener, t = e.defaultParent, n = e.measureScroll, a = e.checkIsScrollRoot, i = e.resetTransform;
  return (
    /** @class */
    function() {
      function l(u, c, f) {
        var h = this;
        c === void 0 && (c = {}), f === void 0 && (f = t == null ? void 0 : t()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          h.isUpdating && (h.isUpdating = !1, h.clearAllSnapshots());
        }, this.updateProjection = function() {
          h.nodes.forEach(Hre), h.nodes.forEach(Gre);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = u, this.latestValues = c, this.root = f ? f.root || f : this, this.path = f ? pa(pa([], pt(f.path), !1), [f], !1) : [], this.parent = f, this.depth = f ? f.depth + 1 : 0, u && this.root.registerPotentialNode(u, this);
        for (var p = 0; p < this.path.length; p++)
          this.path[p].shouldResetTransform = !0;
        this.root === this && (this.nodes = new Fre());
      }
      return l.prototype.addEventListener = function(u, c) {
        return this.eventHandlers.has(u) || this.eventHandlers.set(u, new Md()), this.eventHandlers.get(u).add(c);
      }, l.prototype.notifyListeners = function(u) {
        for (var c = [], f = 1; f < arguments.length; f++)
          c[f - 1] = arguments[f];
        var h = this.eventHandlers.get(u);
        h == null || h.notify.apply(h, pa([], pt(c), !1));
      }, l.prototype.hasListeners = function(u) {
        return this.eventHandlers.has(u);
      }, l.prototype.registerPotentialNode = function(u, c) {
        this.potentialNodes.set(u, c);
      }, l.prototype.mount = function(u, c) {
        var f = this, h;
        if (c === void 0 && (c = !1), !this.instance) {
          this.isSVG = u instanceof SVGElement && u.tagName !== "svg", this.instance = u;
          var p = this.options, g = p.layoutId, y = p.layout, S = p.visualElement;
          if (S && !S.getInstance() && S.mount(u), this.root.nodes.add(this), (h = this.parent) === null || h === void 0 || h.children.add(this), this.id && this.root.potentialNodes.delete(this.id), c && (y || g) && (this.isLayoutDirty = !0), r) {
            var x, _ = function() {
              return f.root.updateBlockedByResize = !1;
            };
            r(u, function() {
              f.root.updateBlockedByResize = !0, clearTimeout(x), x = window.setTimeout(_, 250), Ad.hasAnimatedSinceResize && (Ad.hasAnimatedSinceResize = !1, f.nodes.forEach(Wre));
            });
          }
          g && this.root.registerSharedNode(g, this), this.options.animate !== !1 && S && (g || y) && this.addEventListener("didUpdate", function(A) {
            var O, P, j, k, L, M = A.delta, W = A.hasLayoutChanged, Z = A.hasRelativeTargetChanged, oe = A.layout;
            if (f.isTreeAnimationBlocked()) {
              f.target = void 0, f.relativeTarget = void 0;
              return;
            }
            var Ie = (P = (O = f.options.transition) !== null && O !== void 0 ? O : S.getDefaultTransition()) !== null && P !== void 0 ? P : Qre, Te = S.getProps(), Ee = Te.onLayoutAnimationStart, Me = Te.onLayoutAnimationComplete, Fe = !f.targetLayout || !JR(f.targetLayout, oe) || Z, Ge = !W && Z;
            if (!((j = f.resumeFrom) === null || j === void 0) && j.instance || Ge || W && (Fe || !f.currentAnimation)) {
              f.resumeFrom && (f.resumingFrom = f.resumeFrom, f.resumingFrom.resumingFrom = void 0), f.setAnimationOrigin(M, Ge);
              var ze = fe(fe({}, b$(Ie, "layout")), { onPlay: Ee, onComplete: Me });
              S.shouldReduceMotion && (ze.delay = 0, ze.type = !1), f.startAnimation(ze);
            } else
              !W && f.animationProgress === 0 && f.finishAnimation(), f.isLead() && ((L = (k = f.options).onExitComplete) === null || L === void 0 || L.call(k));
            f.targetLayout = oe;
          });
        }
      }, l.prototype.unmount = function() {
        var u, c;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (u = this.getStack()) === null || u === void 0 || u.remove(this), (c = this.parent) === null || c === void 0 || c.children.delete(this), this.instance = void 0, ff.preRender(this.updateProjection);
      }, l.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, l.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, l.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, l.prototype.isTreeAnimationBlocked = function() {
        var u;
        return this.isAnimationBlocked || ((u = this.parent) === null || u === void 0 ? void 0 : u.isTreeAnimationBlocked()) || !1;
      }, l.prototype.startUpdate = function() {
        var u;
        this.isUpdateBlocked() || (this.isUpdating = !0, (u = this.nodes) === null || u === void 0 || u.forEach(Yre));
      }, l.prototype.willUpdate = function(u) {
        var c, f, h;
        if (u === void 0 && (u = !0), this.root.isUpdateBlocked()) {
          (f = (c = this.options).onExitComplete) === null || f === void 0 || f.call(c);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var p = 0; p < this.path.length; p++) {
            var g = this.path[p];
            g.shouldResetTransform = !0, g.updateScroll();
          }
          var y = this.options, S = y.layoutId, x = y.layout;
          if (!(S === void 0 && !x)) {
            var _ = (h = this.options.visualElement) === null || h === void 0 ? void 0 : h.getProps().transformTemplate;
            this.prevTransformTemplateValue = _ == null ? void 0 : _(this.latestValues, ""), this.updateSnapshot(), u && this.notifyListeners("willUpdate");
          }
        }
      }, l.prototype.didUpdate = function() {
        var u = this.isUpdateBlocked();
        if (u) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(M4);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(Xre), this.potentialNodes.clear()), this.nodes.forEach(Vre), this.nodes.forEach(zre), this.nodes.forEach(Bre), this.clearAllSnapshots(), qb.update(), qb.preRender(), qb.render());
      }, l.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(Ure), this.sharedNodes.forEach(Kre);
      }, l.prototype.scheduleUpdateProjection = function() {
        ri.preRender(this.updateProjection, !1, !0);
      }, l.prototype.scheduleCheckAfterUnmount = function() {
        var u = this;
        ri.postRender(function() {
          u.isLayoutDirty ? u.root.didUpdate() : u.root.checkUpdateFailed();
        });
      }, l.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var u = this.measure(), c = this.removeTransform(this.removeElementScroll(u));
          j4(c), this.snapshot = {
            measured: u,
            layout: c,
            latestValues: {}
          };
        }
      }, l.prototype.updateLayout = function() {
        var u;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var c = 0; c < this.path.length; c++) {
              var f = this.path[c];
              f.updateScroll();
            }
          var h = this.measure();
          j4(h);
          var p = this.layout;
          this.layout = {
            measured: h,
            actual: this.removeElementScroll(h)
          }, this.layoutCorrected = $n(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (u = this.options.visualElement) === null || u === void 0 || u.notifyLayoutMeasure(this.layout.actual, p == null ? void 0 : p.actual);
        }
      }, l.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = a(this.instance), this.scroll = n(this.instance));
      }, l.prototype.resetTransform = function() {
        var u;
        if (i) {
          var c = this.isLayoutDirty || this.shouldResetTransform, f = this.projectionDelta && !XR(this.projectionDelta), h = (u = this.options.visualElement) === null || u === void 0 ? void 0 : u.getProps().transformTemplate, p = h == null ? void 0 : h(this.latestValues, ""), g = p !== this.prevTransformTemplateValue;
          c && (f || Ts(this.latestValues) || g) && (i(this.instance, p), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, l.prototype.measure = function() {
        var u = this.options.visualElement;
        if (!u)
          return $n();
        var c = u.measureViewportBox(), f = this.root.scroll;
        return f && (Cs(c.x, f.x), Cs(c.y, f.y)), c;
      }, l.prototype.removeElementScroll = function(u) {
        var c = $n();
        ao(c, u);
        for (var f = 0; f < this.path.length; f++) {
          var h = this.path[f], p = h.scroll, g = h.options, y = h.isScrollRoot;
          if (h !== this.root && p && g.layoutScroll) {
            if (y) {
              ao(c, u);
              var S = this.root.scroll;
              S && (Cs(c.x, -S.x), Cs(c.y, -S.y));
            }
            Cs(c.x, p.x), Cs(c.y, p.y);
          }
        }
        return c;
      }, l.prototype.applyTransform = function(u, c) {
        c === void 0 && (c = !1);
        var f = $n();
        ao(f, u);
        for (var h = 0; h < this.path.length; h++) {
          var p = this.path[h];
          !c && p.options.layoutScroll && p.scroll && p !== p.root && Gu(f, {
            x: -p.scroll.x,
            y: -p.scroll.y
          }), Ts(p.latestValues) && Gu(f, p.latestValues);
        }
        return Ts(this.latestValues) && Gu(f, this.latestValues), f;
      }, l.prototype.removeTransform = function(u) {
        var c, f = $n();
        ao(f, u);
        for (var h = 0; h < this.path.length; h++) {
          var p = this.path[h];
          if (p.instance && Ts(p.latestValues)) {
            BR(p.latestValues) && p.updateSnapshot();
            var g = $n(), y = p.measure();
            ao(g, y), E4(f, p.latestValues, (c = p.snapshot) === null || c === void 0 ? void 0 : c.layout, g);
          }
        }
        return Ts(this.latestValues) && E4(f, this.latestValues), f;
      }, l.prototype.setTargetDelta = function(u) {
        this.targetDelta = u, this.root.scheduleUpdateProjection();
      }, l.prototype.setOptions = function(u) {
        var c;
        this.options = fe(fe(fe({}, this.options), u), { crossfade: (c = u.crossfade) !== null && c !== void 0 ? c : !0 });
      }, l.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, l.prototype.resolveTargetDelta = function() {
        var u, c = this.options, f = c.layout, h = c.layoutId;
        !this.layout || !(f || h) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = $n(), this.relativeTargetOrigin = $n(), Pd(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), ao(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = $n(), this.targetWithTransforms = $n()), this.relativeTarget && this.relativeTargetOrigin && (!((u = this.relativeParent) === null || u === void 0) && u.target) ? zee(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : ao(this.target, this.layout.actual), UR(this.target, this.targetDelta)) : ao(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = $n(), this.relativeTargetOrigin = $n(), Pd(this.relativeTargetOrigin, this.target, this.relativeParent.target), ao(this.relativeTarget, this.relativeTargetOrigin)))));
      }, l.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || Ts(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, l.prototype.calcProjection = function() {
        var u, c = this.options, f = c.layout, h = c.layoutId;
        if (this.isTreeAnimating = !!(!((u = this.parent) === null || u === void 0) && u.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(f || h))) {
          var p = this.getLead();
          ao(this.layoutCorrected, this.layout.actual), Zee(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== p);
          var g = p.target;
          if (g) {
            this.projectionDelta || (this.projectionDelta = kd(), this.projectionDeltaWithTransform = kd());
            var y = this.treeScale.x, S = this.treeScale.y, x = this.projectionTransform;
            Rd(this.projectionDelta, this.layoutCorrected, g, this.latestValues), this.projectionTransform = I4(this.projectionDelta, this.treeScale), (this.projectionTransform !== x || this.treeScale.x !== y || this.treeScale.y !== S) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", g));
          }
        }
      }, l.prototype.hide = function() {
        this.isVisible = !1;
      }, l.prototype.show = function() {
        this.isVisible = !0;
      }, l.prototype.scheduleRender = function(u) {
        var c, f, h;
        u === void 0 && (u = !0), (f = (c = this.options).scheduleRender) === null || f === void 0 || f.call(c), u && ((h = this.getStack()) === null || h === void 0 || h.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, l.prototype.setAnimationOrigin = function(u, c) {
        var f = this, h;
        c === void 0 && (c = !1);
        var p = this.snapshot, g = (p == null ? void 0 : p.latestValues) || {}, y = fe({}, this.latestValues), S = kd();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !c;
        var x = $n(), _ = p == null ? void 0 : p.isShared, A = (((h = this.getStack()) === null || h === void 0 ? void 0 : h.members.length) || 0) <= 1, O = !!(_ && !A && this.options.crossfade === !0 && !this.path.some(qre));
        this.animationProgress = 0, this.mixTargetDelta = function(P) {
          var j, k = P / 1e3;
          R4(S.x, u.x, k), R4(S.y, u.y, k), f.setTargetDelta(S), f.relativeTarget && f.relativeTargetOrigin && f.layout && (!((j = f.relativeParent) === null || j === void 0) && j.layout) && (Pd(x, f.layout.actual, f.relativeParent.layout.actual), Zre(f.relativeTarget, f.relativeTargetOrigin, x, k)), _ && (f.animationValues = y, Ore(y, g, f.latestValues, k, O, A)), f.root.scheduleUpdateProjection(), f.scheduleRender(), f.animationProgress = k;
        }, this.mixTargetDelta(0);
      }, l.prototype.startAnimation = function(u) {
        var c = this, f, h;
        this.notifyListeners("animationStart"), (f = this.currentAnimation) === null || f === void 0 || f.stop(), this.resumingFrom && ((h = this.resumingFrom.currentAnimation) === null || h === void 0 || h.stop()), this.pendingAnimation && (ff.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ri.update(function() {
          Ad.hasAnimatedSinceResize = !0, c.currentAnimation = Are(0, O4, fe(fe({}, u), { onUpdate: function(p) {
            var g;
            c.mixTargetDelta(p), (g = u.onUpdate) === null || g === void 0 || g.call(u, p);
          }, onComplete: function() {
            var p;
            (p = u.onComplete) === null || p === void 0 || p.call(u), c.completeAnimation();
          } })), c.resumingFrom && (c.resumingFrom.currentAnimation = c.currentAnimation), c.pendingAnimation = void 0;
        });
      }, l.prototype.completeAnimation = function() {
        var u;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (u = this.getStack()) === null || u === void 0 || u.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, l.prototype.finishAnimation = function() {
        var u;
        this.currentAnimation && ((u = this.mixTargetDelta) === null || u === void 0 || u.call(this, O4), this.currentAnimation.stop()), this.completeAnimation();
      }, l.prototype.applyTransformsToTarget = function() {
        var u = this.getLead(), c = u.targetWithTransforms, f = u.target, h = u.layout, p = u.latestValues;
        !c || !f || !h || (ao(c, f), Gu(c, p), Rd(this.projectionDeltaWithTransform, this.layoutCorrected, c, p));
      }, l.prototype.registerSharedNode = function(u, c) {
        var f, h, p;
        this.sharedNodes.has(u) || this.sharedNodes.set(u, new Dre());
        var g = this.sharedNodes.get(u);
        g.add(c), c.promote({
          transition: (f = c.options.initialPromotionConfig) === null || f === void 0 ? void 0 : f.transition,
          preserveFollowOpacity: (p = (h = c.options.initialPromotionConfig) === null || h === void 0 ? void 0 : h.shouldPreserveFollowOpacity) === null || p === void 0 ? void 0 : p.call(h, c)
        });
      }, l.prototype.isLead = function() {
        var u = this.getStack();
        return u ? u.lead === this : !0;
      }, l.prototype.getLead = function() {
        var u, c = this.options.layoutId;
        return c ? ((u = this.getStack()) === null || u === void 0 ? void 0 : u.lead) || this : this;
      }, l.prototype.getPrevLead = function() {
        var u, c = this.options.layoutId;
        return c ? (u = this.getStack()) === null || u === void 0 ? void 0 : u.prevLead : void 0;
      }, l.prototype.getStack = function() {
        var u = this.options.layoutId;
        if (u)
          return this.root.sharedNodes.get(u);
      }, l.prototype.promote = function(u) {
        var c = u === void 0 ? {} : u, f = c.needsReset, h = c.transition, p = c.preserveFollowOpacity, g = this.getStack();
        g && g.promote(this, p), f && (this.projectionDelta = void 0, this.needsReset = !0), h && this.setOptions({ transition: h });
      }, l.prototype.relegate = function() {
        var u = this.getStack();
        return u ? u.relegate(this) : !1;
      }, l.prototype.resetRotation = function() {
        var u = this.options.visualElement;
        if (u) {
          for (var c = !1, f = {}, h = 0; h < AS.length; h++) {
            var p = AS[h], g = "rotate" + p;
            u.getStaticValue(g) && (c = !0, f[g] = u.getStaticValue(g), u.setStaticValue(g, 0));
          }
          if (c) {
            u == null || u.syncRender();
            for (var g in f)
              u.setStaticValue(g, f[g]);
            u.scheduleRender();
          }
        }
      }, l.prototype.getProjectionStyles = function(u) {
        var c, f, h, p, g, y;
        u === void 0 && (u = {});
        var S = {};
        if (!this.instance || this.isSVG)
          return S;
        if (this.isVisible)
          S.visibility = "";
        else
          return { visibility: "hidden" };
        var x = (c = this.options.visualElement) === null || c === void 0 ? void 0 : c.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, S.opacity = "", S.pointerEvents = xp(u.pointerEvents) || "", S.transform = x ? x(this.latestValues, "") : "none", S;
        var _ = this.getLead();
        if (!this.projectionDelta || !this.layout || !_.target) {
          var A = {};
          return this.options.layoutId && (A.opacity = (f = this.latestValues.opacity) !== null && f !== void 0 ? f : 1, A.pointerEvents = xp(u.pointerEvents) || ""), this.hasProjected && !Ts(this.latestValues) && (A.transform = x ? x({}, "") : "none", this.hasProjected = !1), A;
        }
        var O = _.animationValues || _.latestValues;
        this.applyTransformsToTarget(), S.transform = I4(this.projectionDeltaWithTransform, this.treeScale, O), x && (S.transform = x(O, S.transform));
        var P = this.projectionDelta, j = P.x, k = P.y;
        S.transformOrigin = "".concat(j.origin * 100, "% ").concat(k.origin * 100, "% 0"), _.animationValues ? S.opacity = _ === this ? (p = (h = O.opacity) !== null && h !== void 0 ? h : this.latestValues.opacity) !== null && p !== void 0 ? p : 1 : this.preserveOpacity ? this.latestValues.opacity : O.opacityExit : S.opacity = _ === this ? (g = O.opacity) !== null && g !== void 0 ? g : "" : (y = O.opacityExit) !== null && y !== void 0 ? y : 0;
        for (var L in t0)
          if (O[L] !== void 0) {
            var M = t0[L], W = M.correct, Z = M.applyTo, oe = W(O[L], _);
            if (Z)
              for (var Ie = Z.length, Te = 0; Te < Ie; Te++)
                S[Z[Te]] = oe;
            else
              S[L] = oe;
          }
        return this.options.layoutId && (S.pointerEvents = _ === this ? xp(u.pointerEvents) || "" : "none"), S;
      }, l.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, l.prototype.resetTree = function() {
        this.root.nodes.forEach(function(u) {
          var c;
          return (c = u.currentAnimation) === null || c === void 0 ? void 0 : c.stop();
        }), this.root.nodes.forEach(M4), this.root.sharedNodes.clear();
      }, l;
    }()
  );
}
function zre(e) {
  e.updateLayout();
}
function Bre(e) {
  var r, t, n, a, i = (t = (r = e.resumeFrom) === null || r === void 0 ? void 0 : r.snapshot) !== null && t !== void 0 ? t : e.snapshot;
  if (e.isLead() && e.layout && i && e.hasListeners("didUpdate")) {
    var l = e.layout, u = l.actual, c = l.measured;
    e.options.animationType === "size" ? Ho(function(O) {
      var P = i.isShared ? i.measured[O] : i.layout[O], j = Fi(P);
      P.min = u[O].min, P.max = P.min + j;
    }) : e.options.animationType === "position" && Ho(function(O) {
      var P = i.isShared ? i.measured[O] : i.layout[O], j = Fi(u[O]);
      P.max = P.min + j;
    });
    var f = kd();
    Rd(f, u, i.layout);
    var h = kd();
    i.isShared ? Rd(h, e.applyTransform(c, !0), i.measured) : Rd(h, u, i.layout);
    var p = !XR(f), g = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var y = e.relativeParent, S = y.snapshot, x = y.layout;
      if (S && x) {
        var _ = $n();
        Pd(_, i.layout, S.layout);
        var A = $n();
        Pd(A, u, x.actual), JR(_, A) || (g = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: u,
      snapshot: i,
      delta: h,
      layoutDelta: f,
      hasLayoutChanged: p,
      hasRelativeTargetChanged: g
    });
  } else
    e.isLead() && ((a = (n = e.options).onExitComplete) === null || a === void 0 || a.call(n));
  e.options.transition = void 0;
}
function Ure(e) {
  e.clearSnapshot();
}
function M4(e) {
  e.clearMeasurements();
}
function Vre(e) {
  var r = e.options.visualElement;
  r != null && r.getProps().onBeforeLayoutMeasure && r.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function Wre(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function Hre(e) {
  e.resolveTargetDelta();
}
function Gre(e) {
  e.calcProjection();
}
function Yre(e) {
  e.resetRotation();
}
function Kre(e) {
  e.removeLeadSnapshot();
}
function R4(e, r, t) {
  e.translate = Tt(r.translate, 0, t), e.scale = Tt(r.scale, 1, t), e.origin = r.origin, e.originPoint = r.originPoint;
}
function P4(e, r, t, n) {
  e.min = Tt(r.min, t.min, n), e.max = Tt(r.max, t.max, n);
}
function Zre(e, r, t, n) {
  P4(e.x, r.x, t.x, n), P4(e.y, r.y, t.y, n);
}
function qre(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var Qre = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function Xre(e, r) {
  for (var t = e.root, n = e.path.length - 1; n >= 0; n--)
    if (e.path[n].instance) {
      t = e.path[n];
      break;
    }
  var a = t && t !== e.root ? t.instance : document, i = a.querySelector('[data-projection-id="'.concat(r, '"]'));
  i && e.mount(i, !0);
}
function k4(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function j4(e) {
  k4(e.x), k4(e.y);
}
var Jre = eP({
  attachResizeListener: function(e, r) {
    return pg(e, "resize", r);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), e1 = {
  current: void 0
}, ete = eP({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!e1.current) {
      var e = new Jre(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), e1.current = e;
    }
    return e1.current;
  },
  resetTransform: function(e, r) {
    e.style.transform = r != null ? r : "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), rte = fe(fe(fe(fe({}, Nee), qJ), are), Ere), zs = /* @__PURE__ */ FQ(function(e, r) {
  return TX(e, r, rte, $re, ete);
});
function rP() {
  var e = Qe(!1);
  return r0(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
function tte() {
  var e = rP(), r = pt(Ye(0), 2), t = r[0], n = r[1], a = Ne(function() {
    e.current && n(t + 1);
  }, [t]), i = Ne(function() {
    return ri.postRender(a);
  }, [a]);
  return [i, t];
}
var r1 = function(e) {
  var r = e.children, t = e.initial, n = e.isPresent, a = e.onExitComplete, i = e.custom, l = e.presenceAffectsLayout, u = Lf(nte), c = IR(), f = Rt(
    function() {
      return {
        id: c,
        initial: t,
        isPresent: n,
        custom: i,
        onExitComplete: function(h) {
          var p, g;
          u.set(h, !0);
          try {
            for (var y = mQ(u.values()), S = y.next(); !S.done; S = y.next()) {
              var x = S.value;
              if (!x)
                return;
            }
          } catch (_) {
            p = { error: _ };
          } finally {
            try {
              S && !S.done && (g = y.return) && g.call(y);
            } finally {
              if (p)
                throw p.error;
            }
          }
          a == null || a();
        },
        register: function(h) {
          return u.set(h, !1), function() {
            return u.delete(h);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    l ? void 0 : [n]
  );
  return Rt(function() {
    u.forEach(function(h, p) {
      return u.set(p, !1);
    });
  }, [n]), I.useEffect(function() {
    !n && !u.size && (a == null || a());
  }, [n]), I.createElement(Nf.Provider, { value: f }, r);
};
function nte() {
  return /* @__PURE__ */ new Map();
}
var Bu = function(e) {
  return e.key || "";
};
function ate(e, r) {
  e.forEach(function(t) {
    var n = Bu(t);
    r.set(n, t);
  });
}
function ote(e) {
  var r = [];
  return XB.forEach(e, function(t) {
    JB(t) && r.push(t);
  }), r;
}
var ite = function(e) {
  var r = e.children, t = e.custom, n = e.initial, a = n === void 0 ? !0 : n, i = e.onExitComplete, l = e.exitBeforeEnter, u = e.presenceAffectsLayout, c = u === void 0 ? !0 : u, f = pt(tte(), 1), h = f[0], p = zr(e$).forceRender;
  p && (h = p);
  var g = rP(), y = ote(r), S = y, x = /* @__PURE__ */ new Set(), _ = Qe(S), A = Qe(/* @__PURE__ */ new Map()).current, O = Qe(!0);
  if (r0(function() {
    O.current = !1, ate(y, A), _.current = S;
  }), u$(function() {
    O.current = !0, A.clear(), x.clear();
  }), O.current)
    return I.createElement(I.Fragment, null, S.map(function(W) {
      return I.createElement(r1, { key: Bu(W), isPresent: !0, initial: a ? void 0 : !1, presenceAffectsLayout: c }, W);
    }));
  S = pa([], pt(S), !1);
  for (var P = _.current.map(Bu), j = y.map(Bu), k = P.length, L = 0; L < k; L++) {
    var M = P[L];
    j.indexOf(M) === -1 && x.add(M);
  }
  return l && x.size && (S = []), x.forEach(function(W) {
    if (j.indexOf(W) === -1) {
      var Z = A.get(W);
      if (Z) {
        var oe = P.indexOf(W), Ie = function() {
          A.delete(W), x.delete(W);
          var Te = _.current.findIndex(function(Ee) {
            return Ee.key === W;
          });
          if (_.current.splice(Te, 1), !x.size) {
            if (_.current = y, g.current === !1)
              return;
            h(), i && i();
          }
        };
        S.splice(oe, 0, I.createElement(r1, { key: Bu(Z), isPresent: !1, onExitComplete: Ie, custom: t, presenceAffectsLayout: c }, Z));
      }
    }
  }), S = S.map(function(W) {
    var Z = W.key;
    return x.has(Z) ? W : I.createElement(r1, { key: Bu(W), isPresent: !0, presenceAffectsLayout: c }, W);
  }), X2 !== "production" && l && S.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), I.createElement(I.Fragment, null, x.size ? S : S.map(function(W) {
    return QB(W);
  }));
}, tP = {
  border: "0px",
  clip: "rect(0px, 0px, 0px, 0px)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, ste = Vt("span", {
  baseStyle: tP
});
Vt("input", {
  baseStyle: tP
});
function c0() {
  return c0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, c0.apply(this, arguments);
}
function lte(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var ute = ["label", "thickness", "speed", "emptyColor", "className"], cte = HO({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), dte = /* @__PURE__ */ Mn(function(e, r) {
  var t = cg("Spinner", e), n = ug(e), a = n.label, i = a === void 0 ? "Loading..." : a, l = n.thickness, u = l === void 0 ? "2px" : l, c = n.speed, f = c === void 0 ? "0.45s" : c, h = n.emptyColor, p = h === void 0 ? "transparent" : h, g = n.className, y = lte(n, ute), S = Va("chakra-spinner", g), x = c0({
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: u,
    borderBottomColor: p,
    borderLeftColor: p,
    animation: cte + " " + f + " linear infinite"
  }, t);
  return /* @__PURE__ */ I.createElement(Vt.div, c0({
    ref: r,
    __css: x,
    className: S
  }, y), i && /* @__PURE__ */ I.createElement(ste, null, i));
});
function w$(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function ks() {
  return ks = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ks.apply(this, arguments);
}
var fte = Tc({
  strict: !1,
  name: "ButtonGroupContext"
}), vte = fte[1], hte = ["label", "placement", "spacing", "children", "className", "__css"], D4 = function(r) {
  var t = r.label, n = r.placement, a = r.spacing, i = a === void 0 ? "0.5rem" : a, l = r.children, u = l === void 0 ? /* @__PURE__ */ I.createElement(dte, {
    color: "currentColor",
    width: "1em",
    height: "1em"
  }) : l, c = r.className, f = r.__css, h = w$(r, hte), p = Va("chakra-button__spinner", c), g = n === "start" ? "marginEnd" : "marginStart", y = I.useMemo(function() {
    var S;
    return ks((S = {
      display: "flex",
      alignItems: "center",
      position: t ? "relative" : "absolute"
    }, S[g] = t ? i : 0, S.fontSize = "1em", S.lineHeight = "normal", S), f);
  }, [f, t, g, i]);
  return /* @__PURE__ */ I.createElement(Vt.div, ks({
    className: p
  }, h, {
    __css: y
  }), u);
}, pte = ["children", "className"], N4 = function(r) {
  var t = r.children, n = r.className, a = w$(r, pte), i = /* @__PURE__ */ I.isValidElement(t) ? /* @__PURE__ */ I.cloneElement(t, {
    "aria-hidden": !0,
    focusable: !1
  }) : t, l = Va("chakra-button__icon", n);
  return /* @__PURE__ */ I.createElement(Vt.span, ks({
    display: "inline-flex",
    alignSelf: "center",
    flexShrink: 0
  }, a, {
    className: l
  }), i);
};
function gte(e) {
  var r = I.useState(!e), t = r[0], n = r[1], a = I.useCallback(function(l) {
    l && n(l.tagName === "BUTTON");
  }, []), i = t ? "button" : void 0;
  return {
    ref: a,
    type: i
  };
}
var mte = ["isDisabled", "isLoading", "isActive", "isFullWidth", "children", "leftIcon", "rightIcon", "loadingText", "iconSpacing", "type", "spinner", "spinnerPlacement", "className", "as"], Sg = /* @__PURE__ */ Mn(function(e, r) {
  var t = vte(), n = cg("Button", ks({}, t, e)), a = ug(e), i = a.isDisabled, l = i === void 0 ? t == null ? void 0 : t.isDisabled : i, u = a.isLoading, c = a.isActive, f = a.isFullWidth, h = a.children, p = a.leftIcon, g = a.rightIcon, y = a.loadingText, S = a.iconSpacing, x = S === void 0 ? "0.5rem" : S, _ = a.type, A = a.spinner, O = a.spinnerPlacement, P = O === void 0 ? "start" : O, j = a.className, k = a.as, L = w$(a, mte), M = I.useMemo(function() {
    var Te, Ee = Fa({}, (Te = n == null ? void 0 : n._focus) != null ? Te : {}, {
      zIndex: 1
    });
    return ks({
      display: "inline-flex",
      appearance: "none",
      alignItems: "center",
      justifyContent: "center",
      userSelect: "none",
      position: "relative",
      whiteSpace: "nowrap",
      verticalAlign: "middle",
      outline: "none",
      width: f ? "100%" : "auto"
    }, n, !!t && {
      _focus: Ee
    });
  }, [n, t, f]), W = gte(k), Z = W.ref, oe = W.type, Ie = {
    rightIcon: g,
    leftIcon: p,
    iconSpacing: x,
    children: h
  };
  return /* @__PURE__ */ I.createElement(Vt.button, ks({
    disabled: l || u,
    ref: TV(r, Z),
    as: k,
    type: _ != null ? _ : oe,
    "data-active": eC(c),
    "data-loading": eC(u),
    __css: M,
    className: Va("chakra-button", j)
  }, L), u && P === "start" && /* @__PURE__ */ I.createElement(D4, {
    className: "chakra-button__spinner--start",
    label: y,
    placement: "start",
    spacing: x
  }, A), u ? y || /* @__PURE__ */ I.createElement(Vt.span, {
    opacity: 0
  }, /* @__PURE__ */ I.createElement(L4, Ie)) : /* @__PURE__ */ I.createElement(L4, Ie), u && P === "end" && /* @__PURE__ */ I.createElement(D4, {
    className: "chakra-button__spinner--end",
    label: y,
    placement: "end",
    spacing: x
  }, A));
});
function L4(e) {
  var r = e.leftIcon, t = e.rightIcon, n = e.children, a = e.iconSpacing;
  return /* @__PURE__ */ I.createElement(I.Fragment, null, r && /* @__PURE__ */ I.createElement(N4, {
    marginEnd: a
  }, r), n, t && /* @__PURE__ */ I.createElement(N4, {
    marginStart: a
  }, t));
}
function d0() {
  return d0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, d0.apply(this, arguments);
}
function nP(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var bte = Tc({
  strict: !1,
  name: "FormControlContext"
}), yte = bte[1], Ste = ["isDisabled", "isInvalid", "isReadOnly", "isRequired"], xte = ["id", "disabled", "readOnly", "required", "isRequired", "isInvalid", "isReadOnly", "isDisabled", "onFocus", "onBlur"];
function $te(e) {
  var r = wte(e), t = r.isDisabled, n = r.isInvalid, a = r.isReadOnly, i = r.isRequired, l = nP(r, Ste);
  return d0({}, l, {
    disabled: t,
    readOnly: a,
    required: i,
    "aria-invalid": Ib(n),
    "aria-required": Ib(i),
    "aria-readonly": Ib(a)
  });
}
function wte(e) {
  var r, t, n, a = yte(), i = e.id, l = e.disabled, u = e.readOnly, c = e.required, f = e.isRequired, h = e.isInvalid, p = e.isReadOnly, g = e.isDisabled, y = e.onFocus, S = e.onBlur, x = nP(e, xte), _ = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return a != null && a.hasFeedbackText && a != null && a.isInvalid && _.push(a.feedbackId), a != null && a.hasHelpText && _.push(a.helpTextId), d0({}, x, {
    "aria-describedby": _.join(" ") || void 0,
    id: i != null ? i : a == null ? void 0 : a.id,
    isDisabled: (r = l != null ? l : g) != null ? r : a == null ? void 0 : a.isDisabled,
    isReadOnly: (t = u != null ? u : p) != null ? t : a == null ? void 0 : a.isReadOnly,
    isRequired: (n = c != null ? c : f) != null ? n : a == null ? void 0 : a.isRequired,
    isInvalid: h != null ? h : a == null ? void 0 : a.isInvalid,
    onFocus: rC(a == null ? void 0 : a.onFocus, y),
    onBlur: rC(a == null ? void 0 : a.onBlur, S)
  });
}
function $o() {
  return $o = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, $o.apply(this, arguments);
}
function Wf(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var _te = ["htmlSize"], YS = /* @__PURE__ */ Mn(function(e, r) {
  var t = e.htmlSize, n = Wf(e, _te), a = hH("Input", n), i = ug(n), l = $te(i), u = Va("chakra-input", e.className);
  return /* @__PURE__ */ I.createElement(Vt.input, $o({
    size: t
  }, l, {
    __css: a.field,
    ref: r,
    className: u
  }));
});
YS.id = "Input";
var Tte = ["placement"], Cte = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
}, Ete = Vt("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
}), aP = /* @__PURE__ */ Mn(function(e, r) {
  var t, n = e.placement, a = n === void 0 ? "left" : n, i = Wf(e, Tte), l = (t = Cte[a]) != null ? t : {}, u = vM();
  return /* @__PURE__ */ I.createElement(Ete, $o({
    ref: r
  }, i, {
    __css: $o({}, u.addon, l)
  }));
}), Ate = /* @__PURE__ */ Mn(function(e, r) {
  return /* @__PURE__ */ I.createElement(aP, $o({
    ref: r,
    placement: "left"
  }, e, {
    className: Va("chakra-input__left-addon", e.className)
  }));
});
Ate.id = "InputLeftAddon";
var Ite = /* @__PURE__ */ Mn(function(e, r) {
  return /* @__PURE__ */ I.createElement(aP, $o({
    ref: r,
    placement: "right"
  }, e, {
    className: Va("chakra-input__right-addon", e.className)
  }));
});
Ite.id = "InputRightAddon";
var Ote = ["placement"], Mte = ["className"], Rte = ["className"], Pte = Vt("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
}), _$ = /* @__PURE__ */ Mn(function(e, r) {
  var t, n, a, i = e.placement, l = i === void 0 ? "left" : i, u = Wf(e, Ote), c = vM(), f = c.field, h = l === "left" ? "insetStart" : "insetEnd", p = $o((a = {}, a[h] = "0", a.width = (t = f == null ? void 0 : f.height) != null ? t : f == null ? void 0 : f.h, a.height = (n = f == null ? void 0 : f.height) != null ? n : f == null ? void 0 : f.h, a.fontSize = f == null ? void 0 : f.fontSize, a), c.element);
  return /* @__PURE__ */ I.createElement(Pte, $o({
    ref: r,
    __css: p
  }, u));
});
_$.id = "InputElement";
var kte = /* @__PURE__ */ Mn(function(e, r) {
  var t = e.className, n = Wf(e, Mte), a = Va("chakra-input__left-element", t);
  return /* @__PURE__ */ I.createElement(_$, $o({
    ref: r,
    placement: "left",
    className: a
  }, n));
});
kte.id = "InputLeftElement";
var jte = /* @__PURE__ */ Mn(function(e, r) {
  var t = e.className, n = Wf(e, Rte), a = Va("chakra-input__right-element", t);
  return /* @__PURE__ */ I.createElement(_$, $o({
    ref: r,
    placement: "right",
    className: a
  }, n));
});
jte.id = "InputRightElement";
function Ds() {
  return Ds = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ds.apply(this, arguments);
}
function T$(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var an = Vt("div");
Vt("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
var Dte = ["direction", "align", "justify", "wrap", "basis", "grow", "shrink"], oP = /* @__PURE__ */ Mn(function(e, r) {
  var t = e.direction, n = e.align, a = e.justify, i = e.wrap, l = e.basis, u = e.grow, c = e.shrink, f = T$(e, Dte), h = {
    display: "flex",
    flexDirection: t,
    alignItems: n,
    justifyContent: a,
    flexWrap: i,
    flexBasis: l,
    flexGrow: u,
    flexShrink: c
  };
  return /* @__PURE__ */ I.createElement(Vt.div, Ds({
    ref: r,
    __css: h
  }, f));
});
Tc({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in a `<*List />` "
});
Vt("div", {
  baseStyle: {
    flex: 1,
    justifySelf: "stretch",
    alignSelf: "stretch"
  }
});
var KS = "& > *:not(style) ~ *:not(style)";
function Nte(e) {
  var r, t = e.spacing, n = e.direction, a = {
    column: {
      marginTop: t,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: 0
    },
    row: {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: 0,
      marginStart: t
    },
    "column-reverse": {
      marginTop: 0,
      marginEnd: 0,
      marginBottom: t,
      marginStart: 0
    },
    "row-reverse": {
      marginTop: 0,
      marginEnd: t,
      marginBottom: 0,
      marginStart: 0
    }
  };
  return r = {
    flexDirection: n
  }, r[KS] = qO(n, function(i) {
    return a[i];
  }), r;
}
function Lte(e) {
  var r = e.spacing, t = e.direction, n = {
    column: {
      my: r,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    "column-reverse": {
      my: r,
      mx: 0,
      borderLeftWidth: 0,
      borderBottomWidth: "1px"
    },
    row: {
      mx: r,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    },
    "row-reverse": {
      mx: r,
      my: 0,
      borderLeftWidth: "1px",
      borderBottomWidth: 0
    }
  };
  return {
    "&": qO(t, function(a) {
      return n[a];
    })
  };
}
var Fte = ["isInline", "direction", "align", "justify", "spacing", "wrap", "children", "divider", "className", "shouldWrapChildren"], zte = function(r) {
  return /* @__PURE__ */ I.createElement(Vt.div, Ds({
    className: "chakra-stack__item"
  }, r, {
    __css: Ds({
      display: "inline-block",
      flex: "0 0 auto",
      minWidth: 0
    }, r.__css)
  }));
}, iP = /* @__PURE__ */ Mn(function(e, r) {
  var t, n = e.isInline, a = e.direction, i = e.align, l = e.justify, u = e.spacing, c = u === void 0 ? "0.5rem" : u, f = e.wrap, h = e.children, p = e.divider, g = e.className, y = e.shouldWrapChildren, S = T$(e, Fte), x = n ? "row" : a != null ? a : "column", _ = I.useMemo(function() {
    return Nte({
      direction: x,
      spacing: c
    });
  }, [x, c]), A = I.useMemo(function() {
    return Lte({
      spacing: c,
      direction: x
    });
  }, [c, x]), O = !!p, P = !y && !O, j = SV(h), k = P ? j : j.map(function(M, W) {
    var Z = typeof M.key != "undefined" ? M.key : W, oe = W + 1 === j.length, Ie = /* @__PURE__ */ I.createElement(zte, {
      key: Z
    }, M), Te = y ? Ie : M;
    if (!O)
      return Te;
    var Ee = /* @__PURE__ */ I.cloneElement(p, {
      __css: A
    }), Me = oe ? null : Ee;
    return /* @__PURE__ */ I.createElement(I.Fragment, {
      key: Z
    }, Te, Me);
  }), L = Va("chakra-stack", g);
  return /* @__PURE__ */ I.createElement(Vt.div, Ds({
    ref: r,
    display: "flex",
    alignItems: i,
    justifyContent: l,
    flexDirection: _.flexDirection,
    flexWrap: f,
    className: L,
    __css: O ? {} : (t = {}, t[KS] = _[KS], t)
  }, S), k);
}), ZS = /* @__PURE__ */ Mn(function(e, r) {
  return /* @__PURE__ */ I.createElement(iP, Ds({
    align: "center"
  }, e, {
    direction: "row",
    ref: r
  }));
}), Bte = ["className", "align", "decoration", "casing"], gc = /* @__PURE__ */ Mn(function(e, r) {
  var t = cg("Text", e), n = ug(e);
  n.className, n.align, n.decoration, n.casing;
  var a = T$(n, Bte), i = W2({
    textAlign: e.align,
    textDecoration: e.decoration,
    textTransform: e.casing
  });
  return /* @__PURE__ */ I.createElement(Vt.p, Ds({
    ref: r,
    className: Va("chakra-text", e.className)
  }, i, a, {
    __css: t
  }));
}), Ute = _c ? I.useLayoutEffect : I.useEffect;
function Vte(e) {
  var r = eM(), t = Array.isArray(e) ? e : [e], n = _c && "matchMedia" in r.window, a = I.useState(t.map(function(u) {
    return n ? !!r.window.matchMedia(u).matches : !1;
  })), i = a[0], l = a[1];
  return Ute(function() {
    if (n) {
      var u = t.map(function(f) {
        return r.window.matchMedia(f);
      }), c = u.map(function(f, h) {
        var p = function(y) {
          var S = u.findIndex(function(x) {
            return x.media === y.media;
          });
          l(function(x) {
            var _ = x.map(function(A) {
              return A;
            });
            return _[S] = y.matches, _;
          });
        };
        return typeof u[h].addEventListener == "function" ? u[h].addEventListener("change", p) : u[h].addListener(p), p;
      });
      return function() {
        u.forEach(function(f, h) {
          typeof u[h].removeEventListener == "function" ? u[h].removeEventListener("change", c[h]) : u[h].removeListener(c[h]);
        });
      };
    }
  }, []), i;
}
var sP = { exports: {} }, Wte = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Hte = Wte, Gte = Hte;
function lP() {
}
function uP() {
}
uP.resetWarningCache = lP;
var Yte = function() {
  function e(n, a, i, l, u, c) {
    if (c !== Gte) {
      var f = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw f.name = "Invariant Violation", f;
    }
  }
  e.isRequired = e;
  function r() {
    return e;
  }
  var t = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: r,
    element: e,
    elementType: e,
    instanceOf: r,
    node: e,
    objectOf: r,
    oneOf: r,
    oneOfType: r,
    shape: r,
    exact: r,
    checkPropTypes: uP,
    resetWarningCache: lP
  };
  return t.PropTypes = t, t;
};
sP.exports = Yte();
var cP = sP.exports;
const Jr = /* @__PURE__ */ H0(cP);
var dP = gH;
dP.defaultProps = {
  theme: Df
};
function fP() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  var n = [].concat(r), a = r[r.length - 1];
  return dQ(a) && // this ensures backward compatibility
  // previously only `extendTheme(override, baseTheme?)` was allowed
  n.length > 1 ? n = n.slice(0, n.length - 1) : a = Df, yV.apply(void 0, n.map(function(i) {
    return function(l) {
      return Wu(i) ? i(l) : vP(l, i);
    };
  }))(a);
}
function vP() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return Fa.apply(void 0, [{}].concat(r, [hP]));
}
function hP(e, r, t, n) {
  if ((Wu(e) || Wu(r)) && Object.prototype.hasOwnProperty.call(n, t))
    return function() {
      var a = Wu(e) ? e.apply(void 0, arguments) : e, i = Wu(r) ? r.apply(void 0, arguments) : r;
      return Fa({}, a, i, hP);
    };
}
function Kte(e) {
  var r = e.colorScheme, t = e.components;
  return function(n) {
    var a = Object.keys(n.components || {});
    return Array.isArray(t) ? a = t : In(t) && (a = Object.keys(t)), vP(n, {
      components: Jd(a.map(function(i) {
        var l = {
          defaultProps: {
            colorScheme: r
          }
        };
        return [i, l];
      }))
    });
  };
}
function qS(e, r, t) {
  return ig.call(r, "css") ? T.jsx(WO, VO(e, r), t) : T.jsx(e, r, t);
}
function Zte(e, r, t) {
  return ig.call(r, "css") ? T.jsxs(WO, VO(e, r), t) : T.jsxs(e, r, t);
}
De({
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
  displayName: "CopyIcon"
});
De({
  d: "M23.384,21.619,16.855,15.09a9.284,9.284,0,1,0-1.768,1.768l6.529,6.529a1.266,1.266,0,0,0,1.768,0A1.251,1.251,0,0,0,23.384,21.619ZM2.75,9.5a6.75,6.75,0,1,1,6.75,6.75A6.758,6.758,0,0,1,2.75,9.5Z",
  displayName: "SearchIcon"
});
De({
  d: "M23.414,20.591l-4.645-4.645a10.256,10.256,0,1,0-2.828,2.829l4.645,4.644a2.025,2.025,0,0,0,2.828,0A2,2,0,0,0,23.414,20.591ZM10.25,3.005A7.25,7.25,0,1,1,3,10.255,7.258,7.258,0,0,1,10.25,3.005Z",
  displayName: "Search2Icon"
});
De({
  d: "M21.4,13.7C20.6,13.9,19.8,14,19,14c-5,0-9-4-9-9c0-0.8,0.1-1.6,0.3-2.4c0.1-0.3,0-0.7-0.3-1 c-0.3-0.3-0.6-0.4-1-0.3C4.3,2.7,1,7.1,1,12c0,6.1,4.9,11,11,11c4.9,0,9.3-3.3,10.6-8.1c0.1-0.3,0-0.7-0.3-1 C22.1,13.7,21.7,13.6,21.4,13.7z",
  displayName: "MoonIcon"
});
De({
  displayName: "SunIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: "2",
    fill: "none",
    stroke: "currentColor"
  }, /* @__PURE__ */ I.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12 1v2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12 21v2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M4.22 4.22l1.42 1.42"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M18.36 18.36l1.42 1.42"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M1 12h2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M21 12h2"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M4.22 19.78l1.42-1.42"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M18.36 5.64l1.42-1.42"
  }))
});
De({
  d: "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
  displayName: "AddIcon"
});
De({
  displayName: "SmallAddIcon",
  viewBox: "0 0 20 20",
  path: /* @__PURE__ */ I.createElement("path", {
    fill: "currentColor",
    d: "M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z",
    fillRule: "evenodd"
  })
});
De({
  viewBox: "0 0 14 14",
  d: "M14,7.77 L14,6.17 L12.06,5.53 L11.61,4.44 L12.49,2.6 L11.36,1.47 L9.55,2.38 L8.46,1.93 L7.77,0.01 L6.17,0.01 L5.54,1.95 L4.43,2.4 L2.59,1.52 L1.46,2.65 L2.37,4.46 L1.92,5.55 L0,6.23 L0,7.82 L1.94,8.46 L2.39,9.55 L1.51,11.39 L2.64,12.52 L4.45,11.61 L5.54,12.06 L6.23,13.98 L7.82,13.98 L8.45,12.04 L9.56,11.59 L11.4,12.47 L12.53,11.34 L11.61,9.53 L12.08,8.44 L14,7.75 L14,7.77 Z M7,10 C5.34,10 4,8.66 4,7 C4,5.34 5.34,4 7,4 C8.66,4 10,5.34 10,7 C10,8.66 8.66,10 7,10 Z",
  displayName: "SettingsIcon"
});
De({
  displayName: "CheckCircleIcon",
  d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
});
De({
  d: "M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z",
  displayName: "LockIcon"
});
De({
  d: "M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5Z",
  displayName: "UnlockIcon"
});
De({
  displayName: "ViewIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"
  }), /* @__PURE__ */ I.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "2"
  }))
});
De({
  displayName: "ViewOffIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z"
  }))
});
De({
  d: "M11.2857,6.05714 L10.08571,4.85714 L7.85714,7.14786 L7.85714,1 L6.14286,1 L6.14286,7.14786 L3.91429,4.85714 L2.71429,6.05714 L7,10.42857 L11.2857,6.05714 Z M1,11.2857 L1,13 L13,13 L13,11.2857 L1,11.2857 Z",
  displayName: "DownloadIcon",
  viewBox: "0 0 14 14"
});
De({
  displayName: "DeleteIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M19.452 7.5H4.547a.5.5 0 00-.5.545l1.287 14.136A2 2 0 007.326 24h9.347a2 2 0 001.992-1.819L19.95 8.045a.5.5 0 00-.129-.382.5.5 0 00-.369-.163zm-9.2 13a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zm5 0a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zM22 4h-4.75a.25.25 0 01-.25-.25V2.5A2.5 2.5 0 0014.5 0h-5A2.5 2.5 0 007 2.5v1.25a.25.25 0 01-.25.25H2a1 1 0 000 2h20a1 1 0 000-2zM9 3.75V2.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1.25a.25.25 0 01-.25.25h-5.5A.25.25 0 019 3.75z"
  }))
});
De({
  displayName: "RepeatIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M10.319,4.936a7.239,7.239,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657A9.737,9.737,0,0,0,9.743,2.5,10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333A7.7,7.7,0,0,1,10.319,4.936Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M23.406,14.1a.5.5,0,0,0,.015-.526l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253,1.25,1.25,0,1,0-1.872,1.656,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0A.5.5,0,0,0,23.406,14.1Z"
  }))
});
De({
  displayName: "RepeatClockIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M12.965,6a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2h-3.75a.25.25,0,0,1-.25-.25V7A1,1,0,0,0,12.965,6Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z"
  }))
});
De({
  displayName: "EditIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
  }))
});
De({
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
  displayName: "ChevronLeftIcon"
});
De({
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
  displayName: "ChevronRightIcon"
});
De({
  displayName: "ChevronDownIcon",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});
De({
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
  displayName: "ChevronUpIcon"
});
De({
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
  displayName: "ArrowBackIcon"
});
De({
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
  displayName: "ArrowForwardIcon"
});
De({
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z",
  displayName: "ArrowUpIcon"
});
De({
  viewBox: "0 0 16 16",
  d: "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z",
  displayName: "ArrowUpDownIcon"
});
De({
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
  displayName: "ArrowDownIcon"
});
De({
  displayName: "ExternalLinkIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M15 3h6v6"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M10 14L21 3"
  }))
});
De({
  displayName: "LinkIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z"
  }))
});
De({
  displayName: "PlusSquareIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("rect", {
    height: "18",
    width: "18",
    rx: "2",
    ry: "2",
    x: "3",
    y: "3"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M12 8v8"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M8 12h8"
  }))
});
De({
  displayName: "CalendarIcon",
  viewBox: "0 0 14 14",
  d: "M10.8889,5.5 L3.11111,5.5 L3.11111,7.05556 L10.8889,7.05556 L10.8889,5.5 Z M12.4444,1.05556 L11.6667,1.05556 L11.6667,0 L10.1111,0 L10.1111,1.05556 L3.88889,1.05556 L3.88889,0 L2.33333,0 L2.33333,1.05556 L1.55556,1.05556 C0.692222,1.05556 0.00777777,1.75556 0.00777777,2.61111 L0,12.5 C0,13.3556 0.692222,14 1.55556,14 L12.4444,14 C13.3,14 14,13.3556 14,12.5 L14,2.61111 C14,1.75556 13.3,1.05556 12.4444,1.05556 Z M12.4444,12.5 L1.55556,12.5 L1.55556,3.94444 L12.4444,3.94444 L12.4444,12.5 Z M8.55556,8.61111 L3.11111,8.61111 L3.11111,10.1667 L8.55556,10.1667 L8.55556,8.61111 Z"
});
De({
  d: "M0.913134,0.920639 C1.49851,0.331726 2.29348,0 3.12342,0 L10.8766,0 C11.7065,0 12.5015,0.331725 13.0869,0.920639 C13.6721,1.50939 14,2.30689 14,3.13746 L14,8.12943 C13.9962,8.51443 13.9059,8.97125 13.7629,9.32852 C13.6128,9.683 13.3552,10.0709 13.0869,10.3462 C12.813,10.6163 12.4265,10.8761 12.0734,11.0274 C11.7172,11.1716 11.2607,11.263 10.8766,11.2669 L10.1234,11.2669 L10.1234,12.5676 L10.1209,12.5676 C10.1204,12.793 10.0633,13.0791 9.97807,13.262 C9.8627,13.466 9.61158,13.7198 9.40818,13.8382 L9.40824,13.8383 C9.4077,13.8386 9.40716,13.8388 9.40661,13.8391 C9.40621,13.8393 9.4058,13.8396 9.40539,13.8398 L9.40535,13.8397 C9.22958,13.9254 8.94505,13.9951 8.75059,14 L8.74789,14 C8.35724,13.9963 7.98473,13.8383 7.71035,13.5617 L5.39553,11.2669 L3.12342,11.2669 C2.29348,11.2669 1.49851,10.9352 0.913134,10.3462 C0.644826,10.0709 0.387187,9.683 0.23711,9.32852 C0.0941235,8.97125 0.00379528,8.51443 0,8.12943 L0,3.13746 C0,2.30689 0.327915,1.50939 0.913134,0.920639 Z M3.12342,1.59494 C2.71959,1.59494 2.33133,1.75628 2.04431,2.04503 C1.75713,2.33395 1.59494,2.72681 1.59494,3.13746 L1.59494,8.12943 C1.59114,8.35901 1.62114,8.51076 1.71193,8.72129 C1.79563,8.9346 1.88065,9.06264 2.04431,9.22185 C2.33133,9.5106 2.71959,9.67195 3.12342,9.67195 L5.72383,9.67195 C5.93413,9.67195 6.13592,9.75502 6.28527,9.90308 L8.52848,12.1269 L8.52848,10.4694 C8.52848,10.029 8.88552,9.67195 9.32595,9.67195 L10.8766,9.67195 C11.1034,9.67583 11.2517,9.64614 11.4599,9.55518 C11.6712,9.47132 11.7976,9.38635 11.9557,9.22185 C12.1193,9.06264 12.2044,8.9346 12.2881,8.72129 C12.3789,8.51076 12.4089,8.35901 12.4051,8.12943 L12.4051,3.13746 C12.4051,2.72681 12.2429,2.33394 11.9557,2.04503 C11.6687,1.75628 11.2804,1.59494 10.8766,1.59494 L3.12342,1.59494 Z",
  displayName: "ChatIcon",
  viewBox: "0 0 14 14"
});
De({
  displayName: "TimeIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z"
  }))
});
De({
  displayName: "ArrowRightIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M13.584,12a2.643,2.643,0,0,1-.775,1.875L3.268,23.416a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L.768,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,13.584,12Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M23.75,12a2.643,2.643,0,0,1-.775,1.875l-9.541,9.541a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L10.934,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,23.75,12Z"
  }))
});
De({
  displayName: "ArrowLeftIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M10.416,12a2.643,2.643,0,0,1,.775-1.875L20.732.584a1.768,1.768,0,0,1,2.5,2.5l-8.739,8.739a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5l-9.541-9.541A2.643,2.643,0,0,1,10.416,12Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M.25,12a2.643,2.643,0,0,1,.775-1.875L10.566.584a1.768,1.768,0,0,1,2.5,2.5L4.327,11.823a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5L1.025,13.875A2.643,2.643,0,0,1,.25,12Z"
  }))
});
De({
  displayName: "AtSignIcon",
  d: "M12,.5A11.634,11.634,0,0,0,.262,12,11.634,11.634,0,0,0,12,23.5a11.836,11.836,0,0,0,6.624-2,1.25,1.25,0,1,0-1.393-2.076A9.34,9.34,0,0,1,12,21a9.132,9.132,0,0,1-9.238-9A9.132,9.132,0,0,1,12,3a9.132,9.132,0,0,1,9.238,9v.891a1.943,1.943,0,0,1-3.884,0V12A5.355,5.355,0,1,0,12,17.261a5.376,5.376,0,0,0,3.861-1.634,4.438,4.438,0,0,0,7.877-2.736V12A11.634,11.634,0,0,0,12,.5Zm0,14.261A2.763,2.763,0,1,1,14.854,12,2.812,2.812,0,0,1,12,14.761Z"
});
De({
  displayName: "AttachmentIcon",
  d: "M21.843,3.455a6.961,6.961,0,0,0-9.846,0L1.619,13.832a5.128,5.128,0,0,0,7.252,7.252L17.3,12.653A3.293,3.293,0,1,0,12.646,8L7.457,13.184A1,1,0,1,0,8.871,14.6L14.06,9.409a1.294,1.294,0,0,1,1.829,1.83L7.457,19.67a3.128,3.128,0,0,1-4.424-4.424L13.411,4.869a4.962,4.962,0,1,1,7.018,7.018L12.646,19.67a1,1,0,1,0,1.414,1.414L21.843,13.3a6.96,6.96,0,0,0,0-9.846Z"
});
De({
  displayName: "UpDownIcon",
  viewBox: "-1 -1 9 11",
  d: "M 3.5 0L 3.98809 -0.569442L 3.5 -0.987808L 3.01191 -0.569442L 3.5 0ZM 3.5 9L 3.01191 9.56944L 3.5 9.98781L 3.98809 9.56944L 3.5 9ZM 0.488094 3.56944L 3.98809 0.569442L 3.01191 -0.569442L -0.488094 2.43056L 0.488094 3.56944ZM 3.01191 0.569442L 6.51191 3.56944L 7.48809 2.43056L 3.98809 -0.569442L 3.01191 0.569442ZM -0.488094 6.56944L 3.01191 9.56944L 3.98809 8.43056L 0.488094 5.43056L -0.488094 6.56944ZM 3.98809 9.56944L 7.48809 6.56944L 6.51191 5.43056L 3.01191 8.43056L 3.98809 9.56944Z"
});
De({
  d: "M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z",
  displayName: "StarIcon"
});
De({
  displayName: "EmailIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("path", {
    d: "M11.114,14.556a1.252,1.252,0,0,0,1.768,0L22.568,4.87a.5.5,0,0,0-.281-.849A1.966,1.966,0,0,0,22,4H2a1.966,1.966,0,0,0-.289.021.5.5,0,0,0-.281.849Z"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M23.888,5.832a.182.182,0,0,0-.2.039l-6.2,6.2a.251.251,0,0,0,0,.354l5.043,5.043a.75.75,0,1,1-1.06,1.061l-5.043-5.043a.25.25,0,0,0-.354,0l-2.129,2.129a2.75,2.75,0,0,1-3.888,0L7.926,13.488a.251.251,0,0,0-.354,0L2.529,18.531a.75.75,0,0,1-1.06-1.061l5.043-5.043a.251.251,0,0,0,0-.354l-6.2-6.2a.18.18,0,0,0-.2-.039A.182.182,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.181.181,0,0,0,23.888,5.832Z"
  }))
});
De({
  d: "M2.20731,0.0127209 C2.1105,-0.0066419 1.99432,-0.00664663 1.91687,0.032079 C0.871279,0.438698 0.212942,1.92964 0.0580392,2.95587 C-0.426031,6.28627 2.20731,9.17133 4.62766,11.0689 C6.77694,12.7534 10.9012,15.5223 13.3409,12.8503 C13.6507,12.5211 14.0186,12.037 13.9993,11.553 C13.9412,10.7397 13.186,10.1588 12.6051,9.71349 C12.1598,9.38432 11.2304,8.47427 10.6495,8.49363 C10.1267,8.51299 9.79754,9.05515 9.46837,9.38432 L8.88748,9.96521 C8.79067,10.062 7.55145,9.24878 7.41591,9.15197 C6.91248,8.8228 6.4284,8.45491 6.00242,8.04829 C5.57644,7.64167 5.18919,7.19632 4.86002,6.73161 C4.7632,6.59607 3.96933,5.41495 4.04678,5.31813 C4.04678,5.31813 4.72448,4.58234 4.91811,4.2919 C5.32473,3.67229 5.63453,3.18822 5.16982,2.45243 C4.99556,2.18135 4.78257,1.96836 4.55021,1.73601 C4.14359,1.34875 3.73698,0.942131 3.27227,0.612963 C3.02055,0.419335 2.59457,0.0708094 2.20731,0.0127209 Z",
  displayName: "PhoneIcon",
  viewBox: "0 0 14 14"
});
De({
  viewBox: "0 0 10 10",
  d: "M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z",
  displayName: "DragHandleIcon"
});
De({
  displayName: "SpinnerIcon",
  path: /* @__PURE__ */ I.createElement(I.Fragment, null, /* @__PURE__ */ I.createElement("defs", null, /* @__PURE__ */ I.createElement("linearGradient", {
    x1: "28.154%",
    y1: "63.74%",
    x2: "74.629%",
    y2: "17.783%",
    id: "a"
  }, /* @__PURE__ */ I.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /* @__PURE__ */ I.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: "0",
    offset: "100%"
  }))), /* @__PURE__ */ I.createElement("g", {
    transform: "translate(2)",
    fill: "none"
  }, /* @__PURE__ */ I.createElement("circle", {
    stroke: "url(#a)",
    strokeWidth: "4",
    cx: "10",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ I.createElement("path", {
    d: "M10 2C4.477 2 0 6.477 0 12",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /* @__PURE__ */ I.createElement("rect", {
    fill: "currentColor",
    x: "8",
    width: "4",
    height: "4",
    rx: "8"
  })))
});
var qte = De({
  displayName: "CloseIcon",
  d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
});
De({
  displayName: "SmallCloseIcon",
  viewBox: "0 0 16 16",
  path: /* @__PURE__ */ I.createElement("path", {
    d: "M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 0 0-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L9.41 8z",
    fillRule: "evenodd",
    fill: "currentColor"
  })
});
De({
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z",
  displayName: "NotAllowedIcon"
});
De({
  d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z",
  displayName: "TriangleDownIcon"
});
De({
  d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z",
  displayName: "TriangleUpIcon"
});
De({
  displayName: "InfoOutlineIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /* @__PURE__ */ I.createElement("circle", {
    cx: "12",
    cy: "12",
    fill: "none",
    r: "11",
    stroke: "currentColor"
  }), /* @__PURE__ */ I.createElement("line", {
    fill: "none",
    x1: "11.959",
    x2: "11.959",
    y1: "11",
    y2: "17"
  }), /* @__PURE__ */ I.createElement("circle", {
    cx: "11.959",
    cy: "7",
    r: "1",
    stroke: "none"
  }))
});
De({
  displayName: "BellIcon",
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
});
De({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
});
De({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z",
  displayName: "QuestionIcon"
});
De({
  displayName: "QuestionOutlineIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    stroke: "currentColor",
    strokeWidth: "1.5"
  }, /* @__PURE__ */ I.createElement("path", {
    strokeLinecap: "round",
    fill: "none",
    d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
  }), /* @__PURE__ */ I.createElement("path", {
    fill: "none",
    strokeLinecap: "round",
    d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
  }), /* @__PURE__ */ I.createElement("circle", {
    fill: "none",
    strokeMiterlimit: "10",
    cx: "12",
    cy: "12",
    r: "11.25"
  }))
});
De({
  d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z",
  displayName: "WarningIcon"
});
De({
  displayName: "WarningTwoIcon",
  d: "M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z"
});
De({
  viewBox: "0 0 14 14",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("polygon", {
    points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
  }))
});
De({
  displayName: "MinusIcon",
  path: /* @__PURE__ */ I.createElement("g", {
    fill: "currentColor"
  }, /* @__PURE__ */ I.createElement("rect", {
    height: "4",
    width: "20",
    x: "2",
    y: "10"
  }))
});
De({
  displayName: "HamburgerIcon",
  viewBox: "0 0 24 24",
  d: "M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z"
});
var Fl = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, fh = function(e) {
  return e && e.Math == Math && e;
}, un = (
  // eslint-disable-next-line es/no-global-this -- safe
  fh(typeof globalThis == "object" && globalThis) || fh(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  fh(typeof self == "object" && self) || fh(typeof Fl == "object" && Fl) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Fl || Function("return this")()
), xg = {}, Rn = function(e) {
  try {
    return !!e();
  } catch (r) {
    return !0;
  }
}, Qte = Rn, Ha = !Qte(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), Xte = Rn, $g = !Xte(function() {
  var e = function() {
  }.bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), Jte = $g, vh = Function.prototype.call, Sa = Jte ? vh.bind(vh) : function() {
  return vh.apply(vh, arguments);
}, C$ = {}, pP = {}.propertyIsEnumerable, gP = Object.getOwnPropertyDescriptor, ene = gP && !pP.call({ 1: 2 }, 1);
C$.f = ene ? function(r) {
  var t = gP(this, r);
  return !!t && t.enumerable;
} : pP;
var E$ = function(e, r) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: r
  };
}, mP = $g, bP = Function.prototype, QS = bP.call, rne = mP && bP.bind.bind(QS, QS), Pn = mP ? rne : function(e) {
  return function() {
    return QS.apply(e, arguments);
  };
}, yP = Pn, tne = yP({}.toString), nne = yP("".slice), wg = function(e) {
  return nne(tne(e), 8, -1);
}, ane = Pn, one = Rn, ine = wg, t1 = Object, sne = ane("".split), SP = one(function() {
  return !t1("z").propertyIsEnumerable(0);
}) ? function(e) {
  return ine(e) == "String" ? sne(e, "") : t1(e);
} : t1, _g = function(e) {
  return e == null;
}, lne = _g, une = TypeError, xP = function(e) {
  if (lne(e))
    throw une("Can't call method on " + e);
  return e;
}, cne = SP, dne = xP, Hf = function(e) {
  return cne(dne(e));
}, XS = typeof document == "object" && document.all, fne = typeof XS == "undefined" && XS !== void 0, $P = {
  all: XS,
  IS_HTMLDDA: fne
}, wP = $P, vne = wP.all, Mt = wP.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === vne;
} : function(e) {
  return typeof e == "function";
}, F4 = Mt, _P = $P, hne = _P.all, Bs = _P.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : F4(e) || e === hne;
} : function(e) {
  return typeof e == "object" ? e !== null : F4(e);
}, n1 = un, pne = Mt, gne = function(e) {
  return pne(e) ? e : void 0;
}, su = function(e, r) {
  return arguments.length < 2 ? gne(n1[e]) : n1[e] && n1[e][r];
}, mne = Pn, Gf = mne({}.isPrototypeOf), Tg = typeof navigator != "undefined" && String(navigator.userAgent) || "", TP = un, a1 = Tg, z4 = TP.process, B4 = TP.Deno, U4 = z4 && z4.versions || B4 && B4.version, V4 = U4 && U4.v8, bo, f0;
V4 && (bo = V4.split("."), f0 = bo[0] > 0 && bo[0] < 4 ? 1 : +(bo[0] + bo[1]));
!f0 && a1 && (bo = a1.match(/Edge\/(\d+)/), (!bo || bo[1] >= 74) && (bo = a1.match(/Chrome\/(\d+)/), bo && (f0 = +bo[1])));
var CP = f0, W4 = CP, bne = Rn, yne = un, Sne = yne.String, EP = !!Object.getOwnPropertySymbols && !bne(function() {
  var e = Symbol();
  return !Sne(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && W4 && W4 < 41;
}), xne = EP, AP = xne && !Symbol.sham && typeof Symbol.iterator == "symbol", $ne = su, wne = Mt, _ne = Gf, Tne = AP, Cne = Object, IP = Tne ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var r = $ne("Symbol");
  return wne(r) && _ne(r.prototype, Cne(e));
}, Ene = String, Cg = function(e) {
  try {
    return Ene(e);
  } catch (r) {
    return "Object";
  }
}, Ane = Mt, Ine = Cg, One = TypeError, Us = function(e) {
  if (Ane(e))
    return e;
  throw One(Ine(e) + " is not a function");
}, Mne = Us, Rne = _g, A$ = function(e, r) {
  var t = e[r];
  return Rne(t) ? void 0 : Mne(t);
}, o1 = Sa, i1 = Mt, s1 = Bs, Pne = TypeError, kne = function(e, r) {
  var t, n;
  if (r === "string" && i1(t = e.toString) && !s1(n = o1(t, e)) || i1(t = e.valueOf) && !s1(n = o1(t, e)) || r !== "string" && i1(t = e.toString) && !s1(n = o1(t, e)))
    return n;
  throw Pne("Can't convert object to primitive value");
}, I$ = { exports: {} }, H4 = un, jne = Object.defineProperty, O$ = function(e, r) {
  try {
    jne(H4, e, { value: r, configurable: !0, writable: !0 });
  } catch (t) {
    H4[e] = r;
  }
  return r;
}, Dne = un, Nne = O$, G4 = "__core-js_shared__", Lne = Dne[G4] || Nne(G4, {}), M$ = Lne, Y4 = M$;
(I$.exports = function(e, r) {
  return Y4[e] || (Y4[e] = r !== void 0 ? r : {});
})("versions", []).push({
  version: "3.31.0",
  mode: "global",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Fne = xP, zne = Object, R$ = function(e) {
  return zne(Fne(e));
}, Bne = Pn, Une = R$, Vne = Bne({}.hasOwnProperty), Ga = Object.hasOwn || function(r, t) {
  return Vne(Une(r), t);
}, Wne = Pn, Hne = 0, Gne = Math.random(), Yne = Wne(1 .toString), OP = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Yne(++Hne + Gne, 36);
}, Kne = un, Zne = I$.exports, K4 = Ga, qne = OP, Qne = EP, Xne = AP, Yu = Kne.Symbol, l1 = Zne("wks"), Jne = Xne ? Yu.for || Yu : Yu && Yu.withoutSetter || qne, qn = function(e) {
  return K4(l1, e) || (l1[e] = Qne && K4(Yu, e) ? Yu[e] : Jne("Symbol." + e)), l1[e];
}, eae = Sa, Z4 = Bs, q4 = IP, rae = A$, tae = kne, nae = qn, aae = TypeError, oae = nae("toPrimitive"), iae = function(e, r) {
  if (!Z4(e) || q4(e))
    return e;
  var t = rae(e, oae), n;
  if (t) {
    if (r === void 0 && (r = "default"), n = eae(t, e, r), !Z4(n) || q4(n))
      return n;
    throw aae("Can't convert object to primitive value");
  }
  return r === void 0 && (r = "number"), tae(e, r);
}, sae = iae, lae = IP, MP = function(e) {
  var r = sae(e, "string");
  return lae(r) ? r : r + "";
}, uae = un, Q4 = Bs, JS = uae.document, cae = Q4(JS) && Q4(JS.createElement), Eg = function(e) {
  return cae ? JS.createElement(e) : {};
}, dae = Ha, fae = Rn, vae = Eg, RP = !dae && !fae(function() {
  return Object.defineProperty(vae("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), hae = Ha, pae = Sa, gae = C$, mae = E$, bae = Hf, yae = MP, Sae = Ga, xae = RP, X4 = Object.getOwnPropertyDescriptor;
xg.f = hae ? X4 : function(r, t) {
  if (r = bae(r), t = yae(t), xae)
    try {
      return X4(r, t);
    } catch (n) {
    }
  if (Sae(r, t))
    return mae(!pae(gae.f, r, t), r[t]);
};
var zi = {}, $ae = Ha, wae = Rn, PP = $ae && wae(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), _ae = Bs, Tae = String, Cae = TypeError, Ya = function(e) {
  if (_ae(e))
    return e;
  throw Cae(Tae(e) + " is not an object");
}, Eae = Ha, Aae = RP, Iae = PP, hh = Ya, J4 = MP, Oae = TypeError, u1 = Object.defineProperty, Mae = Object.getOwnPropertyDescriptor, c1 = "enumerable", d1 = "configurable", f1 = "writable";
zi.f = Eae ? Iae ? function(r, t, n) {
  if (hh(r), t = J4(t), hh(n), typeof r == "function" && t === "prototype" && "value" in n && f1 in n && !n[f1]) {
    var a = Mae(r, t);
    a && a[f1] && (r[t] = n.value, n = {
      configurable: d1 in n ? n[d1] : a[d1],
      enumerable: c1 in n ? n[c1] : a[c1],
      writable: !1
    });
  }
  return u1(r, t, n);
} : u1 : function(r, t, n) {
  if (hh(r), t = J4(t), hh(n), Aae)
    try {
      return u1(r, t, n);
    } catch (a) {
    }
  if ("get" in n || "set" in n)
    throw Oae("Accessors not supported");
  return "value" in n && (r[t] = n.value), r;
};
var Rae = Ha, Pae = zi, kae = E$, Ag = Rae ? function(e, r, t) {
  return Pae.f(e, r, kae(1, t));
} : function(e, r, t) {
  return e[r] = t, e;
}, P$ = { exports: {} }, ex = Ha, jae = Ga, kP = Function.prototype, Dae = ex && Object.getOwnPropertyDescriptor, k$ = jae(kP, "name"), Nae = k$ && function() {
}.name === "something", Lae = k$ && (!ex || ex && Dae(kP, "name").configurable), j$ = {
  EXISTS: k$,
  PROPER: Nae,
  CONFIGURABLE: Lae
}, Fae = Pn, zae = Mt, rx = M$, Bae = Fae(Function.toString);
zae(rx.inspectSource) || (rx.inspectSource = function(e) {
  return Bae(e);
});
var D$ = rx.inspectSource, Uae = un, Vae = Mt, eE = Uae.WeakMap, Wae = Vae(eE) && /native code/.test(String(eE)), Hae = I$.exports, Gae = OP, rE = Hae("keys"), N$ = function(e) {
  return rE[e] || (rE[e] = Gae(e));
}, L$ = {}, Yae = Wae, jP = un, Kae = Bs, Zae = Ag, v1 = Ga, h1 = M$, qae = N$, Qae = L$, tE = "Object already initialized", tx = jP.TypeError, Xae = jP.WeakMap, v0, vf, h0, Jae = function(e) {
  return h0(e) ? vf(e) : v0(e, {});
}, eoe = function(e) {
  return function(r) {
    var t;
    if (!Kae(r) || (t = vf(r)).type !== e)
      throw tx("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (Yae || h1.state) {
  var Fo = h1.state || (h1.state = new Xae());
  Fo.get = Fo.get, Fo.has = Fo.has, Fo.set = Fo.set, v0 = function(e, r) {
    if (Fo.has(e))
      throw tx(tE);
    return r.facade = e, Fo.set(e, r), r;
  }, vf = function(e) {
    return Fo.get(e) || {};
  }, h0 = function(e) {
    return Fo.has(e);
  };
} else {
  var Mu = qae("state");
  Qae[Mu] = !0, v0 = function(e, r) {
    if (v1(e, Mu))
      throw tx(tE);
    return r.facade = e, Zae(e, Mu, r), r;
  }, vf = function(e) {
    return v1(e, Mu) ? e[Mu] : {};
  }, h0 = function(e) {
    return v1(e, Mu);
  };
}
var F$ = {
  set: v0,
  get: vf,
  has: h0,
  enforce: Jae,
  getterFor: eoe
}, z$ = Pn, roe = Rn, toe = Mt, ph = Ga, nx = Ha, noe = j$.CONFIGURABLE, aoe = D$, DP = F$, ooe = DP.enforce, ioe = DP.get, nE = String, _p = Object.defineProperty, soe = z$("".slice), loe = z$("".replace), uoe = z$([].join), coe = nx && !roe(function() {
  return _p(function() {
  }, "length", { value: 8 }).length !== 8;
}), doe = String(String).split("String"), foe = P$.exports = function(e, r, t) {
  soe(nE(r), 0, 7) === "Symbol(" && (r = "[" + loe(nE(r), /^Symbol\(([^)]*)\)/, "$1") + "]"), t && t.getter && (r = "get " + r), t && t.setter && (r = "set " + r), (!ph(e, "name") || noe && e.name !== r) && (nx ? _p(e, "name", { value: r, configurable: !0 }) : e.name = r), coe && t && ph(t, "arity") && e.length !== t.arity && _p(e, "length", { value: t.arity });
  try {
    t && ph(t, "constructor") && t.constructor ? nx && _p(e, "prototype", { writable: !1 }) : e.prototype && (e.prototype = void 0);
  } catch (a) {
  }
  var n = ooe(e);
  return ph(n, "source") || (n.source = uoe(doe, typeof r == "string" ? r : "")), e;
};
Function.prototype.toString = foe(function() {
  return toe(this) && ioe(this).source || aoe(this);
}, "toString");
var voe = Mt, hoe = zi, poe = P$.exports, goe = O$, Ic = function(e, r, t, n) {
  n || (n = {});
  var a = n.enumerable, i = n.name !== void 0 ? n.name : r;
  if (voe(t) && poe(t, i, n), n.global)
    a ? e[r] = t : goe(r, t);
  else {
    try {
      n.unsafe ? e[r] && (a = !0) : delete e[r];
    } catch (l) {
    }
    a ? e[r] = t : hoe.f(e, r, {
      value: t,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return e;
}, NP = {}, moe = Math.ceil, boe = Math.floor, yoe = Math.trunc || function(r) {
  var t = +r;
  return (t > 0 ? boe : moe)(t);
}, Soe = yoe, LP = function(e) {
  var r = +e;
  return r !== r || r === 0 ? 0 : Soe(r);
}, xoe = LP, $oe = Math.max, woe = Math.min, _oe = function(e, r) {
  var t = xoe(e);
  return t < 0 ? $oe(t + r, 0) : woe(t, r);
}, Toe = LP, Coe = Math.min, Eoe = function(e) {
  return e > 0 ? Coe(Toe(e), 9007199254740991) : 0;
}, Aoe = Eoe, FP = function(e) {
  return Aoe(e.length);
}, Ioe = Hf, Ooe = _oe, Moe = FP, aE = function(e) {
  return function(r, t, n) {
    var a = Ioe(r), i = Moe(a), l = Ooe(n, i), u;
    if (e && t != t) {
      for (; i > l; )
        if (u = a[l++], u != u)
          return !0;
    } else
      for (; i > l; l++)
        if ((e || l in a) && a[l] === t)
          return e || l || 0;
    return !e && -1;
  };
}, zP = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: aE(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: aE(!1)
}, Roe = Pn, p1 = Ga, Poe = Hf, koe = zP.indexOf, joe = L$, oE = Roe([].push), BP = function(e, r) {
  var t = Poe(e), n = 0, a = [], i;
  for (i in t)
    !p1(joe, i) && p1(t, i) && oE(a, i);
  for (; r.length > n; )
    p1(t, i = r[n++]) && (~koe(a, i) || oE(a, i));
  return a;
}, B$ = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Doe = BP, Noe = B$, Loe = Noe.concat("length", "prototype");
NP.f = Object.getOwnPropertyNames || function(r) {
  return Doe(r, Loe);
};
var U$ = {};
U$.f = Object.getOwnPropertySymbols;
var Foe = su, zoe = Pn, Boe = NP, Uoe = U$, Voe = Ya, Woe = zoe([].concat), Hoe = Foe("Reflect", "ownKeys") || function(r) {
  var t = Boe.f(Voe(r)), n = Uoe.f;
  return n ? Woe(t, n(r)) : t;
}, iE = Ga, Goe = Hoe, Yoe = xg, Koe = zi, UP = function(e, r, t) {
  for (var n = Goe(r), a = Koe.f, i = Yoe.f, l = 0; l < n.length; l++) {
    var u = n[l];
    !iE(e, u) && !(t && iE(t, u)) && a(e, u, i(r, u));
  }
}, Zoe = Rn, qoe = Mt, Qoe = /#|\.prototype\./, Yf = function(e, r) {
  var t = Joe[Xoe(e)];
  return t == rie ? !0 : t == eie ? !1 : qoe(r) ? Zoe(r) : !!r;
}, Xoe = Yf.normalize = function(e) {
  return String(e).replace(Qoe, ".").toLowerCase();
}, Joe = Yf.data = {}, eie = Yf.NATIVE = "N", rie = Yf.POLYFILL = "P", VP = Yf, g1 = un, tie = xg.f, nie = Ag, aie = Ic, oie = O$, iie = UP, sie = VP, oi = function(e, r) {
  var t = e.target, n = e.global, a = e.stat, i, l, u, c, f, h;
  if (n ? l = g1 : a ? l = g1[t] || oie(t, {}) : l = (g1[t] || {}).prototype, l)
    for (u in r) {
      if (f = r[u], e.dontCallGetSet ? (h = tie(l, u), c = h && h.value) : c = l[u], i = sie(n ? u : t + (a ? "." : "#") + u, e.forced), !i && c !== void 0) {
        if (typeof f == typeof c)
          continue;
        iie(f, c);
      }
      (e.sham || c && c.sham) && nie(f, "sham", !0), aie(l, u, f, e);
    }
}, lie = BP, uie = B$, WP = Object.keys || function(r) {
  return lie(r, uie);
}, sE = Ha, cie = Pn, die = Sa, fie = Rn, m1 = WP, vie = U$, hie = C$, pie = R$, gie = SP, Ru = Object.assign, lE = Object.defineProperty, mie = cie([].concat), bie = !Ru || fie(function() {
  if (sE && Ru({ b: 1 }, Ru(lE({}, "a", {
    enumerable: !0,
    get: function() {
      lE(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var e = {}, r = {}, t = Symbol(), n = "abcdefghijklmnopqrst";
  return e[t] = 7, n.split("").forEach(function(a) {
    r[a] = a;
  }), Ru({}, e)[t] != 7 || m1(Ru({}, r)).join("") != n;
}) ? function(r, t) {
  for (var n = pie(r), a = arguments.length, i = 1, l = vie.f, u = hie.f; a > i; )
    for (var c = gie(arguments[i++]), f = l ? mie(m1(c), l(c)) : m1(c), h = f.length, p = 0, g; h > p; )
      g = f[p++], (!sE || die(u, c, g)) && (n[g] = c[g]);
  return n;
} : Ru, yie = oi, uE = bie;
yie({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== uE }, {
  assign: uE
});
var js = function() {
  return js = Object.assign || function(r) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (r[i] = t[i]);
    }
    return r;
  }, js.apply(this, arguments);
};
function V$(e, r) {
  var t = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && r.indexOf(n) < 0 && (t[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      r.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (t[n[a]] = e[n[a]]);
  return t;
}
var Sie = "Invariant failed";
function xie(e, r) {
  if (!e)
    throw new Error(Sie);
}
var gh = function(r) {
  var t = r.top, n = r.right, a = r.bottom, i = r.left, l = n - i, u = a - t, c = {
    top: t,
    right: n,
    bottom: a,
    left: i,
    width: l,
    height: u,
    x: i,
    y: t,
    center: {
      x: (n + i) / 2,
      y: (a + t) / 2
    }
  };
  return c;
}, $ie = function(r, t) {
  return {
    top: r.top - t.top,
    left: r.left - t.left,
    bottom: r.bottom + t.bottom,
    right: r.right + t.right
  };
}, cE = function(r, t) {
  return {
    top: r.top + t.top,
    left: r.left + t.left,
    bottom: r.bottom - t.bottom,
    right: r.right - t.right
  };
}, b1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, wie = function(r) {
  var t = r.borderBox, n = r.margin, a = n === void 0 ? b1 : n, i = r.border, l = i === void 0 ? b1 : i, u = r.padding, c = u === void 0 ? b1 : u, f = gh($ie(t, a)), h = gh(cE(t, l)), p = gh(cE(h, c));
  return {
    marginBox: f,
    borderBox: gh(t),
    paddingBox: h,
    contentBox: p,
    margin: a,
    border: l,
    padding: c
  };
}, Pa = function(r) {
  var t = r.slice(0, -2), n = r.slice(-2);
  if (n !== "px")
    return 0;
  var a = Number(t);
  return isNaN(a) && xie(!1), a;
}, _ie = function(r, t) {
  var n = {
    top: Pa(t.marginTop),
    right: Pa(t.marginRight),
    bottom: Pa(t.marginBottom),
    left: Pa(t.marginLeft)
  }, a = {
    top: Pa(t.paddingTop),
    right: Pa(t.paddingRight),
    bottom: Pa(t.paddingBottom),
    left: Pa(t.paddingLeft)
  }, i = {
    top: Pa(t.borderTopWidth),
    right: Pa(t.borderRightWidth),
    bottom: Pa(t.borderBottomWidth),
    left: Pa(t.borderLeftWidth)
  };
  return wie({
    borderBox: r,
    margin: n,
    padding: a,
    border: i
  });
}, HP = function(r) {
  var t = r.getBoundingClientRect(), n = window.getComputedStyle(r);
  return _ie(t, n);
}, ax = { exports: {} };
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", a = 800, i = 16, l = 9007199254740991, u = "[object Arguments]", c = "[object Array]", f = "[object AsyncFunction]", h = "[object Boolean]", p = "[object Date]", g = "[object Error]", y = "[object Function]", S = "[object GeneratorFunction]", x = "[object Map]", _ = "[object Number]", A = "[object Null]", O = "[object Object]", P = "[object Proxy]", j = "[object RegExp]", k = "[object Set]", L = "[object String]", M = "[object Undefined]", W = "[object WeakMap]", Z = "[object ArrayBuffer]", oe = "[object DataView]", Ie = "[object Float32Array]", Te = "[object Float64Array]", Ee = "[object Int8Array]", Me = "[object Int16Array]", Fe = "[object Int32Array]", Ge = "[object Uint8Array]", ze = "[object Uint8ClampedArray]", le = "[object Uint16Array]", ce = "[object Uint32Array]", he = /[\\^$.*+?()[\]{}|]/g, be = /^\[object .+?Constructor\]$/, ye = /^(?:0|[1-9]\d*)$/, q = {};
  q[Ie] = q[Te] = q[Ee] = q[Me] = q[Fe] = q[Ge] = q[ze] = q[le] = q[ce] = !0, q[u] = q[c] = q[Z] = q[h] = q[oe] = q[p] = q[g] = q[y] = q[x] = q[_] = q[O] = q[j] = q[k] = q[L] = q[W] = !1;
  var ae = typeof Fl == "object" && Fl && Fl.Object === Object && Fl, ue = typeof self == "object" && self && self.Object === Object && self, $e = ae || ue || Function("return this")(), Ze = r && !r.nodeType && r, _e = Ze && !0 && e && !e.nodeType && e, or = _e && _e.exports === Ze, Yr = or && ae.process, mr = function() {
    try {
      var v = _e && _e.require && _e.require("util").types;
      return v || Yr && Yr.binding && Yr.binding("util");
    } catch (b) {
    }
  }(), rt = mr && mr.isTypedArray;
  function Je(v, b, $) {
    switch ($.length) {
      case 0:
        return v.call(b);
      case 1:
        return v.call(b, $[0]);
      case 2:
        return v.call(b, $[0], $[1]);
      case 3:
        return v.call(b, $[0], $[1], $[2]);
    }
    return v.apply(b, $);
  }
  function Ir(v, b) {
    for (var $ = -1, N = Array(v); ++$ < v; )
      N[$] = b($);
    return N;
  }
  function wt(v) {
    return function(b) {
      return v(b);
    };
  }
  function Kr(v, b) {
    return v == null ? void 0 : v[b];
  }
  function jr(v, b) {
    return function($) {
      return v(b($));
    };
  }
  var jt = Array.prototype, gt = Function.prototype, pr = Object.prototype, br = $e["__core-js_shared__"], G = gt.toString, te = pr.hasOwnProperty, Y = function() {
    var v = /[^.]+$/.exec(br && br.keys && br.keys.IE_PROTO || "");
    return v ? "Symbol(src)_1." + v : "";
  }(), Q = pr.toString, Ce = G.call(Object), me = RegExp(
    "^" + G.call(te).replace(he, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Re = or ? $e.Buffer : void 0, ur = $e.Symbol, Sr = $e.Uint8Array, lr = Re ? Re.allocUnsafe : void 0, ct = jr(Object.getPrototypeOf, Object), at = Object.create, mt = pr.propertyIsEnumerable, Ct = jt.splice, dr = ur ? ur.toStringTag : void 0, Zr = function() {
    try {
      var v = Nn(Object, "defineProperty");
      return v({}, "", {}), v;
    } catch (b) {
    }
  }(), cn = Re ? Re.isBuffer : void 0, dn = Math.max, Ka = Date.now, wn = Nn($e, "Map"), pe = Nn(Object, "create"), je = function() {
    function v() {
    }
    return function(b) {
      if (!qr(b))
        return {};
      if (at)
        return at(b);
      v.prototype = b;
      var $ = new v();
      return v.prototype = void 0, $;
    };
  }();
  function er(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Dt() {
    this.__data__ = pe ? pe(null) : {}, this.size = 0;
  }
  function ot(v) {
    var b = this.has(v) && delete this.__data__[v];
    return this.size -= b ? 1 : 0, b;
  }
  function Dn(v) {
    var b = this.__data__;
    if (pe) {
      var $ = b[v];
      return $ === n ? void 0 : $;
    }
    return te.call(b, v) ? b[v] : void 0;
  }
  function xe(v) {
    var b = this.__data__;
    return pe ? b[v] !== void 0 : te.call(b, v);
  }
  function Ae(v, b) {
    var $ = this.__data__;
    return this.size += this.has(v) ? 0 : 1, $[v] = pe && b === void 0 ? n : b, this;
  }
  er.prototype.clear = Dt, er.prototype.delete = ot, er.prototype.get = Dn, er.prototype.has = xe, er.prototype.set = Ae;
  function Se(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Pe() {
    this.__data__ = [], this.size = 0;
  }
  function rr(v) {
    var b = this.__data__, $ = Nt(b, v);
    if ($ < 0)
      return !1;
    var N = b.length - 1;
    return $ == N ? b.pop() : Ct.call(b, $, 1), --this.size, !0;
  }
  function Vr(v) {
    var b = this.__data__, $ = Nt(b, v);
    return $ < 0 ? void 0 : b[$][1];
  }
  function Zt(v) {
    return Nt(this.__data__, v) > -1;
  }
  function qt(v, b) {
    var $ = this.__data__, N = Nt($, v);
    return N < 0 ? (++this.size, $.push([v, b])) : $[N][1] = b, this;
  }
  Se.prototype.clear = Pe, Se.prototype.delete = rr, Se.prototype.get = Vr, Se.prototype.has = Zt, Se.prototype.set = qt;
  function Or(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Za() {
    this.size = 0, this.__data__ = {
      hash: new er(),
      map: new (wn || Se)(),
      string: new er()
    };
  }
  function Ys(v) {
    var b = hn(this, v).delete(v);
    return this.size -= b ? 1 : 0, b;
  }
  function Ks(v) {
    return hn(this, v).get(v);
  }
  function Zs(v) {
    return hn(this, v).has(v);
  }
  function qs(v, b) {
    var $ = hn(this, v), N = $.size;
    return $.set(v, b), this.size += $.size == N ? 0 : 1, this;
  }
  Or.prototype.clear = Za, Or.prototype.delete = Ys, Or.prototype.get = Ks, Or.prototype.has = Zs, Or.prototype.set = qs;
  function bt(v) {
    var b = this.__data__ = new Se(v);
    this.size = b.size;
  }
  function Qs() {
    this.__data__ = new Se(), this.size = 0;
  }
  function Xs(v) {
    var b = this.__data__, $ = b.delete(v);
    return this.size = b.size, $;
  }
  function Js(v) {
    return this.__data__.get(v);
  }
  function el(v) {
    return this.__data__.has(v);
  }
  function rl(v, b) {
    var $ = this.__data__;
    if ($ instanceof Se) {
      var N = $.__data__;
      if (!wn || N.length < t - 1)
        return N.push([v, b]), this.size = ++$.size, this;
      $ = this.__data__ = new Or(N);
    }
    return $.set(v, b), this.size = $.size, this;
  }
  bt.prototype.clear = Qs, bt.prototype.delete = Xs, bt.prototype.get = Js, bt.prototype.has = el, bt.prototype.set = rl;
  function tl(v, b) {
    var $ = ea(v), N = !$ && Jn(v), ie = !$ && !N && Oo(v), ve = !$ && !N && !ie && Ro(v), de = $ || N || ie || ve, ne = de ? Ir(v.length, String) : [], ge = ne.length;
    for (var tr in v)
      (b || te.call(v, tr)) && !(de && // Safari 9 has enumerable `arguments.length` in strict mode.
      (tr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ie && (tr == "offset" || tr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      ve && (tr == "buffer" || tr == "byteLength" || tr == "byteOffset") || // Skip index properties.
      Io(tr, ge))) && ne.push(tr);
    return ne;
  }
  function fn(v, b, $) {
    ($ !== void 0 && !pn(v[b], $) || $ === void 0 && !(b in v)) && Xn(v, b, $);
  }
  function nl(v, b, $) {
    var N = v[b];
    (!(te.call(v, b) && pn(N, $)) || $ === void 0 && !(b in v)) && Xn(v, b, $);
  }
  function Nt(v, b) {
    for (var $ = v.length; $--; )
      if (pn(v[$][0], b))
        return $;
    return -1;
  }
  function Xn(v, b, $) {
    b == "__proto__" && Zr ? Zr(v, b, {
      configurable: !0,
      enumerable: !0,
      value: $,
      writable: !0
    }) : v[b] = $;
  }
  var al = Zi();
  function vn(v) {
    return v == null ? v === void 0 ? M : A : dr && dr in Object(v) ? qi(v) : Ji(v);
  }
  function qa(v) {
    return Lt(v) && vn(v) == u;
  }
  function Vi(v) {
    if (!qr(v) || vi(v))
      return !1;
    var b = ra(v) ? me : be;
    return b.test(ts(v));
  }
  function Wi(v) {
    return Lt(v) && Mo(v.length) && !!q[vn(v)];
  }
  function ol(v) {
    if (!qr(v))
      return Xi(v);
    var b = _n(v), $ = [];
    for (var N in v)
      N == "constructor" && (b || !te.call(v, N)) || $.push(N);
    return $;
  }
  function Eo(v, b, $, N, ie) {
    v !== b && al(b, function(ve, de) {
      if (ie || (ie = new bt()), qr(ve))
        il(v, b, de, $, Eo, N, ie);
      else {
        var ne = N ? N(Ln(v, de), ve, de + "", v, b, ie) : void 0;
        ne === void 0 && (ne = ve), fn(v, de, ne);
      }
    }, Po);
  }
  function il(v, b, $, N, ie, ve, de) {
    var ne = Ln(v, $), ge = Ln(b, $), tr = de.get(ge);
    if (tr) {
      fn(v, $, tr);
      return;
    }
    var Ke = ve ? ve(ne, ge, $ + "", v, b, de) : void 0, Mr = Ke === void 0;
    if (Mr) {
      var zn = ea(ge), Bn = !zn && Oo(ge), Qa = !zn && !Bn && Ro(ge);
      Ke = ge, zn || Bn || Qa ? ea(ne) ? Ke = ne : cl(ne) ? Ke = ll(ne) : Bn ? (Mr = !1, Ke = Gi(ge, !0)) : Qa ? (Mr = !1, Ke = ci(ge, !0)) : Ke = [] : dl(ge) || Jn(ge) ? (Ke = ne, Jn(ne) ? Ke = fl(ne) : (!qr(ne) || ra(ne)) && (Ke = di(ge))) : Mr = !1;
    }
    Mr && (de.set(ge, Ke), ie(Ke, ge, N, ve, de), de.delete(ge)), fn(v, $, Ke);
  }
  function sl(v, b) {
    return es(ul(v, b, ko), v + "");
  }
  var Hi = Zr ? function(v, b) {
    return Zr(v, "toString", {
      configurable: !0,
      enumerable: !1,
      value: yr(b),
      writable: !0
    });
  } : ko;
  function Gi(v, b) {
    if (b)
      return v.slice();
    var $ = v.length, N = lr ? lr($) : new v.constructor($);
    return v.copy(N), N;
  }
  function Yi(v) {
    var b = new v.constructor(v.byteLength);
    return new Sr(b).set(new Sr(v)), b;
  }
  function ci(v, b) {
    var $ = b ? Yi(v.buffer) : v.buffer;
    return new v.constructor($, v.byteOffset, v.length);
  }
  function ll(v, b) {
    var $ = -1, N = v.length;
    for (b || (b = Array(N)); ++$ < N; )
      b[$] = v[$];
    return b;
  }
  function Ki(v, b, $, N) {
    var ie = !$;
    $ || ($ = {});
    for (var ve = -1, de = b.length; ++ve < de; ) {
      var ne = b[ve], ge = N ? N($[ne], v[ne], ne, $, v) : void 0;
      ge === void 0 && (ge = v[ne]), ie ? Xn($, ne, ge) : nl($, ne, ge);
    }
    return $;
  }
  function Ao(v) {
    return sl(function(b, $) {
      var N = -1, ie = $.length, ve = ie > 1 ? $[ie - 1] : void 0, de = ie > 2 ? $[2] : void 0;
      for (ve = v.length > 3 && typeof ve == "function" ? (ie--, ve) : void 0, de && Qi($[0], $[1], de) && (ve = ie < 3 ? void 0 : ve, ie = 1), b = Object(b); ++N < ie; ) {
        var ne = $[N];
        ne && v(b, ne, N, ve);
      }
      return b;
    });
  }
  function Zi(v) {
    return function(b, $, N) {
      for (var ie = -1, ve = Object(b), de = N(b), ne = de.length; ne--; ) {
        var ge = de[v ? ne : ++ie];
        if ($(ve[ge], ge, ve) === !1)
          break;
      }
      return b;
    };
  }
  function hn(v, b) {
    var $ = v.__data__;
    return fi(b) ? $[typeof b == "string" ? "string" : "hash"] : $.map;
  }
  function Nn(v, b) {
    var $ = Kr(v, b);
    return Vi($) ? $ : void 0;
  }
  function qi(v) {
    var b = te.call(v, dr), $ = v[dr];
    try {
      v[dr] = void 0;
      var N = !0;
    } catch (ve) {
    }
    var ie = Q.call(v);
    return N && (b ? v[dr] = $ : delete v[dr]), ie;
  }
  function di(v) {
    return typeof v.constructor == "function" && !_n(v) ? je(ct(v)) : {};
  }
  function Io(v, b) {
    var $ = typeof v;
    return b = b == null ? l : b, !!b && ($ == "number" || $ != "symbol" && ye.test(v)) && v > -1 && v % 1 == 0 && v < b;
  }
  function Qi(v, b, $) {
    if (!qr($))
      return !1;
    var N = typeof b;
    return (N == "number" ? Fn($) && Io(b, $.length) : N == "string" && b in $) ? pn($[b], v) : !1;
  }
  function fi(v) {
    var b = typeof v;
    return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? v !== "__proto__" : v === null;
  }
  function vi(v) {
    return !!Y && Y in v;
  }
  function _n(v) {
    var b = v && v.constructor, $ = typeof b == "function" && b.prototype || pr;
    return v === $;
  }
  function Xi(v) {
    var b = [];
    if (v != null)
      for (var $ in Object(v))
        b.push($);
    return b;
  }
  function Ji(v) {
    return Q.call(v);
  }
  function ul(v, b, $) {
    return b = dn(b === void 0 ? v.length - 1 : b, 0), function() {
      for (var N = arguments, ie = -1, ve = dn(N.length - b, 0), de = Array(ve); ++ie < ve; )
        de[ie] = N[b + ie];
      ie = -1;
      for (var ne = Array(b + 1); ++ie < b; )
        ne[ie] = N[ie];
      return ne[b] = $(de), Je(v, this, ne);
    };
  }
  function Ln(v, b) {
    if (!(b === "constructor" && typeof v[b] == "function") && b != "__proto__")
      return v[b];
  }
  var es = rs(Hi);
  function rs(v) {
    var b = 0, $ = 0;
    return function() {
      var N = Ka(), ie = i - (N - $);
      if ($ = N, ie > 0) {
        if (++b >= a)
          return arguments[0];
      } else
        b = 0;
      return v.apply(void 0, arguments);
    };
  }
  function ts(v) {
    if (v != null) {
      try {
        return G.call(v);
      } catch (b) {
      }
      try {
        return v + "";
      } catch (b) {
      }
    }
    return "";
  }
  function pn(v, b) {
    return v === b || v !== v && b !== b;
  }
  var Jn = qa(function() {
    return arguments;
  }()) ? qa : function(v) {
    return Lt(v) && te.call(v, "callee") && !mt.call(v, "callee");
  }, ea = Array.isArray;
  function Fn(v) {
    return v != null && Mo(v.length) && !ra(v);
  }
  function cl(v) {
    return Lt(v) && Fn(v);
  }
  var Oo = cn || vl;
  function ra(v) {
    if (!qr(v))
      return !1;
    var b = vn(v);
    return b == y || b == S || b == f || b == P;
  }
  function Mo(v) {
    return typeof v == "number" && v > -1 && v % 1 == 0 && v <= l;
  }
  function qr(v) {
    var b = typeof v;
    return v != null && (b == "object" || b == "function");
  }
  function Lt(v) {
    return v != null && typeof v == "object";
  }
  function dl(v) {
    if (!Lt(v) || vn(v) != O)
      return !1;
    var b = ct(v);
    if (b === null)
      return !0;
    var $ = te.call(b, "constructor") && b.constructor;
    return typeof $ == "function" && $ instanceof $ && G.call($) == Ce;
  }
  var Ro = rt ? wt(rt) : Wi;
  function fl(v) {
    return Ki(v, Po(v));
  }
  function Po(v) {
    return Fn(v) ? tl(v, !0) : ol(v);
  }
  var xr = Ao(function(v, b, $, N) {
    Eo(v, b, $, N);
  });
  function yr(v) {
    return function() {
      return v;
    };
  }
  function ko(v) {
    return v;
  }
  function vl() {
    return !1;
  }
  e.exports = xr;
})(ax, ax.exports);
var zl = ax.exports, GP = 1 / 60 * 1e3, Tie = typeof performance != "undefined" ? function() {
  return performance.now();
} : function() {
  return Date.now();
}, YP = typeof window != "undefined" ? function(e) {
  return window.requestAnimationFrame(e);
} : function(e) {
  return setTimeout(function() {
    return e(Tie());
  }, GP);
};
function Cie(e) {
  var r = [], t = [], n = 0, a = !1, i = /* @__PURE__ */ new WeakSet(), l = {
    schedule: function(u, c, f) {
      c === void 0 && (c = !1), f === void 0 && (f = !1);
      var h = f && a, p = h ? r : t;
      return c && i.add(u), p.indexOf(u) === -1 && (p.push(u), h && a && (n = r.length)), u;
    },
    cancel: function(u) {
      var c = t.indexOf(u);
      c !== -1 && t.splice(c, 1), i.delete(u);
    },
    process: function(u) {
      var c;
      if (a = !0, c = [t, r], r = c[0], t = c[1], t.length = 0, n = r.length, n)
        for (var f = 0; f < n; f++) {
          var h = r[f];
          h(u), i.has(h) && (l.schedule(h), e());
        }
      a = !1;
    }
  };
  return l;
}
var Eie = 40, ox = !0, hf = !1, ix = !1, jd = {
  delta: 0,
  timestamp: 0
}, Ig = ["read", "update", "preRender", "render", "postRender"], W$ = /* @__PURE__ */ Ig.reduce(function(e, r) {
  return e[r] = Cie(function() {
    return hf = !0;
  }), e;
}, {}), Aie = /* @__PURE__ */ Ig.reduce(function(e, r) {
  var t = W$[r];
  return e[r] = function(n, a, i) {
    return a === void 0 && (a = !1), i === void 0 && (i = !1), hf || Mie(), t.schedule(n, a, i);
  }, e;
}, {}), Iie = /* @__PURE__ */ Ig.reduce(function(e, r) {
  return e[r] = W$[r].cancel, e;
}, {}), Oie = function(e) {
  return W$[e].process(jd);
}, KP = function(e) {
  hf = !1, jd.delta = ox ? GP : Math.max(Math.min(e - jd.timestamp, Eie), 1), jd.timestamp = e, ix = !0, Ig.forEach(Oie), ix = !1, hf && (ox = !1, YP(KP));
}, Mie = function() {
  hf = !0, ox = !0, ix || YP(KP);
}, dE = function() {
  return jd;
};
function Yl(e) {
  return typeof e == "number";
}
function Rie(e) {
  return typeof e != "number" || Number.isNaN(e) || !Number.isFinite(e);
}
function Pie(e) {
  return Array.isArray(e);
}
function ZP(e) {
  return typeof e == "function";
}
function Kl(e) {
  var r = typeof e;
  return e != null && (r === "object" || r === "function") && !Pie(e);
}
function H$(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function qP(e) {
  return /^var\(--.+\)$/.test(e);
}
var kie = !1;
function G$(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    r.includes(n) || (t[n] = e[n]);
  }), t;
}
function jie(e, r, t, n) {
  var a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var Die = function(r) {
  var t = /* @__PURE__ */ new WeakMap(), n = function(i, l, u, c) {
    if (typeof i == "undefined")
      return r(i, l, u);
    t.has(i) || t.set(i, /* @__PURE__ */ new Map());
    var f = t.get(i);
    if (f.has(l))
      return f.get(l);
    var h = r(i, l, u, c);
    return f.set(l, h), h;
  };
  return n;
}, Y$ = Die(jie);
function QP(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var a = e[n], i = r(a, n, e);
    i && (t[n] = a);
  }), t;
}
var XP = function(r) {
  return QP(r, function(t) {
    return t != null;
  });
}, JP = function(r) {
  return Object.keys(r);
}, fE = function(r) {
  return r.reduce(function(t, n) {
    var a = n[0], i = n[1];
    return t[a] = i, t;
  }, {});
};
function ek(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function rk(e) {
  var r;
  if (!ek(e))
    return !1;
  var t = (r = e.ownerDocument.defaultView) != null ? r : window;
  return e instanceof t.HTMLElement;
}
function tk(e) {
  var r;
  return ek(e) && (r = e.ownerDocument) != null ? r : document;
}
function K$(e) {
  var r;
  return (r = e.view) != null ? r : window;
}
function Nie() {
  return !!(typeof window != "undefined" && window.document && window.document.createElement);
}
var Og = Nie(), La = function(r) {
  return r ? "" : void 0;
}, sc = function(r) {
  return r ? !0 : void 0;
}, Z$ = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return t.filter(Boolean).join(" ");
};
function Lie(e, r, t, n) {
  return e.addEventListener(r, t, n), function() {
    e.removeEventListener(r, t, n);
  };
}
function nk(e) {
  var r = e.key, t = e.keyCode, n = t >= 37 && t <= 40 && r.indexOf("Arrow") !== 0, a = n ? "Arrow" + r : r;
  return a;
}
function Fie(e) {
  return rk(e) && e.tagName.toLowerCase() === "input" && "select" in e;
}
function zie(e) {
  var r = rk(e) ? tk(e) : document;
  return r.activeElement === e;
}
function vE(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Bie(e, r) {
  if (e) {
    if (typeof e == "string")
      return vE(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return vE(e, r);
  }
}
function Uie(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Bie(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function za(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return ZP(e) ? e.apply(void 0, t) : e;
}
function lc() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(a) {
    r.some(function(i) {
      return i == null || i(a), a == null ? void 0 : a.defaultPrevented;
    });
  };
}
function Vie(e) {
  var r;
  return function() {
    if (e) {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      r = e.apply(this, a), e = null;
    }
    return r;
  };
}
var ak = function() {
}, ok = Vie(function(e) {
  return function() {
    var r = e.condition, t = e.message;
    r && kie && console.warn(t);
  };
}), Wie = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return function(a) {
    return t.reduce(function(i, l) {
      return l(i);
    }, a);
  };
}, y1 = function(r, t) {
  return Math.abs(r - t);
}, hE = function(r) {
  return "x" in r && "y" in r;
};
function Hie(e, r) {
  if (Yl(e) && Yl(r))
    return y1(e, r);
  if (hE(e) && hE(r)) {
    var t = y1(e.x, r.x), n = y1(e.y, r.y);
    return Math.sqrt(Math.pow(t, 2) + Math.pow(n, 2));
  }
  return 0;
}
function ik(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.isActive, a = n === void 0 ? zie : n, i = t.nextTick, l = t.preventScroll, u = l === void 0 ? !0 : l, c = t.selectTextIfInput, f = c === void 0 ? !0 : c;
  if (!e || a(e))
    return -1;
  function h() {
    if (!e) {
      ok({
        condition: !0,
        message: "[chakra-ui]: can't call focus() on `null` or `undefined` element"
      });
      return;
    }
    if (Gie())
      e.focus({
        preventScroll: u
      });
    else if (e.focus(), u) {
      var p = Yie(e);
      Kie(p);
    }
    Fie(e) && f && e.select();
  }
  return i ? requestAnimationFrame(h) : (h(), -1);
}
var mh = null;
function Gie() {
  if (mh == null) {
    mh = !1;
    try {
      var e = document.createElement("div");
      e.focus({
        get preventScroll() {
          return mh = !0, !0;
        }
      });
    } catch (r) {
    }
  }
  return mh;
}
function Yie(e) {
  for (var r, t = tk(e), n = (r = t.defaultView) != null ? r : window, a = e.parentNode, i = [], l = t.scrollingElement || t.documentElement; a instanceof n.HTMLElement && a !== l; )
    (a.offsetHeight < a.scrollHeight || a.offsetWidth < a.scrollWidth) && i.push({
      element: a,
      scrollTop: a.scrollTop,
      scrollLeft: a.scrollLeft
    }), a = a.parentNode;
  return l instanceof n.HTMLElement && i.push({
    element: l,
    scrollTop: l.scrollTop,
    scrollLeft: l.scrollLeft
  }), i;
}
function Kie(e) {
  for (var r = Uie(e), t; !(t = r()).done; ) {
    var n = t.value, a = n.element, i = n.scrollTop, l = n.scrollLeft;
    a.scrollTop = i, a.scrollLeft = l;
  }
}
function Zie(e) {
  var r = parseFloat(e);
  return Rie(r) ? 0 : r;
}
function qie(e, r) {
  var t = Zie(e), n = Math.pow(10, r != null ? r : 10);
  return t = Math.round(t * n) / n, r ? t.toFixed(r) : t.toString();
}
function Qie(e) {
  if (!Number.isFinite(e))
    return 0;
  for (var r = 1, t = 0; Math.round(e * r) / r !== e; )
    r *= 10, t += 1;
  return t;
}
function p0(e, r, t) {
  return (e - r) * 100 / (t - r);
}
function sk(e, r, t) {
  return (t - r) * e + r;
}
function sx(e, r, t) {
  var n = Math.round((e - r) / t) * t + r, a = Qie(t);
  return qie(n, a);
}
function Dd(e, r, t) {
  return e == null ? e : (ok({
    condition: t < r,
    message: "clamp: max cannot be less than min"
  }), Math.min(Math.max(e, r), t));
}
function g0() {
  return g0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, g0.apply(this, arguments);
}
function Xie(e) {
  var r = K$(e);
  return typeof r.PointerEvent != "undefined" && e instanceof r.PointerEvent ? e.pointerType === "mouse" : e instanceof r.MouseEvent;
}
function lk(e) {
  var r = !!e.touches;
  return r;
}
function Jie(e) {
  return function(r) {
    var t = K$(r), n = r instanceof t.MouseEvent, a = !n || n && r.button === 0;
    a && e(r);
  };
}
var ese = {
  pageX: 0,
  pageY: 0
};
function rse(e, r) {
  r === void 0 && (r = "page");
  var t = e.touches[0] || e.changedTouches[0], n = t || ese;
  return {
    x: n[r + "X"],
    y: n[r + "Y"]
  };
}
function tse(e, r) {
  return r === void 0 && (r = "page"), {
    x: e[r + "X"],
    y: e[r + "Y"]
  };
}
function uk(e, r) {
  return r === void 0 && (r = "page"), {
    point: lk(e) ? rse(e, r) : tse(e, r)
  };
}
var ck = function(r, t) {
  t === void 0 && (t = !1);
  var n = function(i) {
    return r(i, uk(i));
  };
  return t ? Jie(n) : n;
}, nse = function() {
  return Og && window.onpointerdown === null;
}, ase = function() {
  return Og && window.ontouchstart === null;
}, ose = function() {
  return Og && window.onmousedown === null;
}, ise = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, sse = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function dk(e) {
  return nse() ? e : ase() ? sse[e] : ose() ? ise[e] : e;
}
function S1(e, r, t, n) {
  return Lie(e, dk(r), ck(t, r === "pointerdown"), n);
}
function lse(e) {
  return lk(e) && e.touches.length > 1;
}
var use = /* @__PURE__ */ function() {
  function e(t, n, a) {
    var i = this;
    if (this.history = [], this.startEvent = null, this.lastEvent = null, this.lastEventInfo = null, this.handlers = {}, this.removeListeners = ak, this.threshold = 3, this.win = void 0, this.updatePoint = function() {
      if (i.lastEvent && i.lastEventInfo) {
        var h = x1(i.lastEventInfo, i.history), p = i.startEvent !== null, g = Hie(h.offset, {
          x: 0,
          y: 0
        }) >= i.threshold;
        if (!(!p && !g)) {
          var y = dE(), S = y.timestamp;
          i.history.push(g0({}, h.point, {
            timestamp: S
          }));
          var x = i.handlers, _ = x.onStart, A = x.onMove;
          p || (_ == null || _(i.lastEvent, h), i.startEvent = i.lastEvent), A == null || A(i.lastEvent, h);
        }
      }
    }, this.onPointerMove = function(h, p) {
      if (i.lastEvent = h, i.lastEventInfo = p, Xie(h) && h.buttons === 0) {
        i.onPointerUp(h, p);
        return;
      }
      Aie.update(i.updatePoint, !0);
    }, this.onPointerUp = function(h, p) {
      var g = x1(p, i.history), y = i.handlers, S = y.onEnd, x = y.onSessionEnd;
      x == null || x(h, g), i.end(), !(!S || !i.startEvent) && (S == null || S(h, g));
    }, this.win = K$(t), !lse(t)) {
      this.handlers = n, a && (this.threshold = a), t.stopPropagation(), t.preventDefault();
      var l = uk(t), u = dE(), c = u.timestamp;
      this.history = [g0({}, l.point, {
        timestamp: c
      })];
      var f = n.onSessionStart;
      f == null || f(t, x1(l, this.history)), this.removeListeners = Wie(S1(this.win, "pointermove", this.onPointerMove), S1(this.win, "pointerup", this.onPointerUp), S1(this.win, "pointercancel", this.onPointerUp));
    }
  }
  var r = e.prototype;
  return r.updateHandlers = function(n) {
    this.handlers = n;
  }, r.end = function() {
    var n;
    (n = this.removeListeners) == null || n.call(this), Iie.update(this.updatePoint);
  }, e;
}();
function pE(e, r) {
  return {
    x: e.x - r.x,
    y: e.y - r.y
  };
}
function cse(e) {
  return e[0];
}
function dse(e) {
  return e[e.length - 1];
}
function x1(e, r) {
  return {
    point: e.point,
    delta: pE(e.point, dse(r)),
    offset: pE(e.point, cse(r)),
    velocity: hse(r, 0.1)
  };
}
function fse(e) {
  return e[e.length - 1];
}
var vse = function(r) {
  return r * 1e3;
};
function hse(e, r) {
  if (e.length < 2)
    return {
      x: 0,
      y: 0
    };
  for (var t = e.length - 1, n = null, a = fse(e); t >= 0 && (n = e[t], !(a.timestamp - n.timestamp > vse(r))); )
    t--;
  if (!n)
    return {
      x: 0,
      y: 0
    };
  var i = (a.timestamp - n.timestamp) / 1e3;
  if (i === 0)
    return {
      x: 0,
      y: 0
    };
  var l = {
    x: (a.x - n.x) / i,
    y: (a.y - n.y) / i
  };
  return l.x === 1 / 0 && (l.x = 0), l.y === 1 / 0 && (l.y = 0), l;
}
var pse = /* @__PURE__ */ I.createContext({}), gse = function() {
  var r = I.useContext(pse);
  if (r === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return r;
};
function m0() {
  return m0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, m0.apply(this, arguments);
}
var mse = function(r, t) {
  return function(n) {
    var a = String(t), i = r ? r + "." + a : a;
    return Kl(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  };
};
function pf(e) {
  var r = e.scale, t = e.transform, n = e.compose, a = function(l, u) {
    var c, f = mse(r, l)(u), h = (c = t == null ? void 0 : t(f, u)) != null ? c : f;
    return n && (h = n(h, u)), h;
  };
  return a;
}
function oo(e, r) {
  return function(t) {
    var n = {
      property: t,
      scale: e
    };
    return n.transform = pf({
      scale: e,
      transform: r
    }), n;
  };
}
var bse = function(r) {
  var t = r.rtl, n = r.ltr;
  return function(a) {
    return a.direction === "rtl" ? t : n;
  };
};
function yse(e) {
  var r = e.property, t = e.scale, n = e.transform;
  return {
    scale: t,
    property: bse(r),
    transform: t ? pf({
      scale: t,
      compose: n
    }) : n
  };
}
var $1, w1, fk = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function Sse() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(fk).join(" ");
}
function xse() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(fk).join(" ");
}
var $se = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
}, wse = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function _se(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var Tse = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, vk = "& > :not(style) ~ :not(style)", Cse = ($1 = {}, $1[vk] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, $1), Ese = (w1 = {}, w1[vk] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, w1);
function b0(e, r) {
  return b0 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, b0(e, r);
}
function Ase(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), r && b0(e, r);
}
function lx() {
  lx = function(a, i) {
    return new t(a, void 0, i);
  };
  var e = RegExp.prototype, r = /* @__PURE__ */ new WeakMap();
  function t(a, i, l) {
    var u = new RegExp(a, i);
    return r.set(u, l || r.get(a)), b0(u, t.prototype);
  }
  Ase(t, RegExp), t.prototype.exec = function(a) {
    var i = e.exec.call(this, a);
    return i && (i.groups = n(i, this)), i;
  }, t.prototype[Symbol.replace] = function(a, i) {
    if (typeof i == "string") {
      var l = r.get(this);
      return e[Symbol.replace].call(this, a, i.replace(/\$<([^>]+)>/g, function(c, f) {
        return "$" + l[f];
      }));
    } else if (typeof i == "function") {
      var u = this;
      return e[Symbol.replace].call(this, a, function() {
        var c = arguments;
        return typeof c[c.length - 1] != "object" && (c = [].slice.call(c), c.push(n(c, u))), i.apply(this, c);
      });
    } else
      return e[Symbol.replace].call(this, a, i);
  };
  function n(a, i) {
    var l = r.get(i);
    return Object.keys(l).reduce(function(u, c) {
      return u[c] = a[l[c]], u;
    }, /* @__PURE__ */ Object.create(null));
  }
  return lx.apply(this, arguments);
}
var ux = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, Ise = new Set(Object.values(ux)), hk = /* @__PURE__ */ new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]), Ose = function(r) {
  return r.trim();
};
function Mse(e, r) {
  var t, n;
  if (e == null || hk.has(e))
    return e;
  var a = /* @__PURE__ */ lx(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  }), i = (t = (n = a.exec(e)) == null ? void 0 : n.groups) != null ? t : {}, l = i.type, u = i.values;
  if (!l || !u)
    return e;
  var c = l.includes("-gradient") ? l : l + "-gradient", f = u.split(",").map(Ose).filter(Boolean), h = f[0], p = f.slice(1);
  if ((p == null ? void 0 : p.length) === 0)
    return e;
  var g = h in ux ? ux[h] : h;
  p.unshift(g);
  var y = p.map(function(S) {
    if (Ise.has(S))
      return S;
    var x = S.indexOf(" "), _ = x !== -1 ? [S.substr(0, x), S.substr(x + 1)] : [S], A = _[0], O = _[1], P = pk(O) ? O : O && O.split(" "), j = "colors." + A, k = j in r.__cssMap ? r.__cssMap[j].varRef : A;
    return P ? [k].concat(Array.isArray(P) ? P : [P]).join(" ") : k;
  });
  return c + "(" + y.join(", ") + ")";
}
var pk = function(r) {
  return H$(r) && r.includes("(") && r.includes(")");
}, Rse = function(r, t) {
  return Mse(r, t != null ? t : {});
}, Pse = function(r) {
  var t = parseFloat(r.toString()), n = r.toString().replace(String(t), "");
  return {
    unitless: !n,
    value: t,
    unit: n
  };
}, zo = function(r) {
  return function(t) {
    return r + "(" + t + ")";
  };
}, Lr = {
  filter: function(r) {
    return r !== "auto" ? r : $se;
  },
  backdropFilter: function(r) {
    return r !== "auto" ? r : wse;
  },
  ring: function(r) {
    return _se(Lr.px(r));
  },
  bgClip: function(r) {
    return r === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: r
    };
  },
  transform: function(r) {
    return r === "auto" ? Sse() : r === "auto-gpu" ? xse() : r;
  },
  px: function(r) {
    if (r == null)
      return r;
    var t = Pse(r), n = t.unitless;
    return n || Yl(r) ? r + "px" : r;
  },
  fraction: function(r) {
    return !Yl(r) || r > 1 ? r : r * 100 + "%";
  },
  float: function(r, t) {
    var n = {
      left: "right",
      right: "left"
    };
    return t.direction === "rtl" ? n[r] : r;
  },
  degree: function(r) {
    if (qP(r) || r == null)
      return r;
    var t = H$(r) && !r.endsWith("deg");
    return Yl(r) || t ? r + "deg" : r;
  },
  gradient: Rse,
  blur: zo("blur"),
  opacity: zo("opacity"),
  brightness: zo("brightness"),
  contrast: zo("contrast"),
  dropShadow: zo("drop-shadow"),
  grayscale: zo("grayscale"),
  hueRotate: zo("hue-rotate"),
  invert: zo("invert"),
  saturate: zo("saturate"),
  sepia: zo("sepia"),
  bgImage: function(r) {
    if (r == null)
      return r;
    var t = pk(r) || hk.has(r);
    return t ? r : "url(" + r + ")";
  },
  outline: function(r) {
    var t = String(r) === "0" || String(r) === "none";
    return r !== null && t ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: r
    };
  },
  flexDirection: function(r) {
    var t, n = (t = Tse[r]) != null ? t : {}, a = n.space, i = n.divide, l = {
      flexDirection: r
    };
    return a && (l[a] = 1), i && (l[i] = 1), l;
  }
}, z = {
  borderWidths: oo("borderWidths"),
  borderStyles: oo("borderStyles"),
  colors: oo("colors"),
  borders: oo("borders"),
  radii: oo("radii", Lr.px),
  space: oo("space", Lr.px),
  spaceT: oo("space", Lr.px),
  degreeT: function(r) {
    return {
      property: r,
      transform: Lr.degree
    };
  },
  prop: function(r, t, n) {
    return m0({
      property: r,
      scale: t
    }, t && {
      transform: pf({
        scale: t,
        transform: n
      })
    });
  },
  propT: function(r, t) {
    return {
      property: r,
      transform: t
    };
  },
  sizes: oo("sizes", Lr.px),
  sizesT: oo("sizes", Lr.fraction),
  shadows: oo("shadows"),
  logical: yse,
  blur: oo("blur", Lr.blur)
}, Tp = {
  background: z.colors("background"),
  backgroundColor: z.colors("backgroundColor"),
  backgroundImage: z.propT("backgroundImage", Lr.bgImage),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: {
    transform: Lr.bgClip
  },
  bgSize: z.prop("backgroundSize"),
  bgPosition: z.prop("backgroundPosition"),
  bg: z.colors("background"),
  bgColor: z.colors("backgroundColor"),
  bgPos: z.prop("backgroundPosition"),
  bgRepeat: z.prop("backgroundRepeat"),
  bgAttachment: z.prop("backgroundAttachment"),
  bgGradient: z.propT("backgroundImage", Lr.gradient),
  bgClip: {
    transform: Lr.bgClip
  }
};
Object.assign(Tp, {
  bgImage: Tp.backgroundImage,
  bgImg: Tp.backgroundImage
});
var _r = {
  border: z.borders("border"),
  borderWidth: z.borderWidths("borderWidth"),
  borderStyle: z.borderStyles("borderStyle"),
  borderColor: z.colors("borderColor"),
  borderRadius: z.radii("borderRadius"),
  borderTop: z.borders("borderTop"),
  borderBlockStart: z.borders("borderBlockStart"),
  borderTopLeftRadius: z.radii("borderTopLeftRadius"),
  borderStartStartRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: z.radii("borderTopRightRadius"),
  borderStartEndRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: z.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: z.borders("borderRight"),
  borderInlineEnd: z.borders("borderInlineEnd"),
  borderBottom: z.borders("borderBottom"),
  borderBlockEnd: z.borders("borderBlockEnd"),
  borderBottomLeftRadius: z.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: z.radii("borderBottomRightRadius"),
  borderLeft: z.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: z.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: z.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: z.borders(["borderLeft", "borderRight"]),
  borderInline: z.borders("borderInline"),
  borderY: z.borders(["borderTop", "borderBottom"]),
  borderBlock: z.borders("borderBlock"),
  borderTopWidth: z.borderWidths("borderTopWidth"),
  borderBlockStartWidth: z.borderWidths("borderBlockStartWidth"),
  borderTopColor: z.colors("borderTopColor"),
  borderBlockStartColor: z.colors("borderBlockStartColor"),
  borderTopStyle: z.borderStyles("borderTopStyle"),
  borderBlockStartStyle: z.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: z.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: z.borderWidths("borderBlockEndWidth"),
  borderBottomColor: z.colors("borderBottomColor"),
  borderBlockEndColor: z.colors("borderBlockEndColor"),
  borderBottomStyle: z.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: z.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: z.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: z.borderWidths("borderInlineStartWidth"),
  borderLeftColor: z.colors("borderLeftColor"),
  borderInlineStartColor: z.colors("borderInlineStartColor"),
  borderLeftStyle: z.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: z.borderStyles("borderInlineStartStyle"),
  borderRightWidth: z.borderWidths("borderRightWidth"),
  borderInlineEndWidth: z.borderWidths("borderInlineEndWidth"),
  borderRightColor: z.colors("borderRightColor"),
  borderInlineEndColor: z.colors("borderInlineEndColor"),
  borderRightStyle: z.borderStyles("borderRightStyle"),
  borderInlineEndStyle: z.borderStyles("borderInlineEndStyle"),
  borderTopRadius: z.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: z.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: z.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: z.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(_r, {
  rounded: _r.borderRadius,
  roundedTop: _r.borderTopRadius,
  roundedTopLeft: _r.borderTopLeftRadius,
  roundedTopRight: _r.borderTopRightRadius,
  roundedTopStart: _r.borderStartStartRadius,
  roundedTopEnd: _r.borderStartEndRadius,
  roundedBottom: _r.borderBottomRadius,
  roundedBottomLeft: _r.borderBottomLeftRadius,
  roundedBottomRight: _r.borderBottomRightRadius,
  roundedBottomStart: _r.borderEndStartRadius,
  roundedBottomEnd: _r.borderEndEndRadius,
  roundedLeft: _r.borderLeftRadius,
  roundedRight: _r.borderRightRadius,
  roundedStart: _r.borderInlineStartRadius,
  roundedEnd: _r.borderInlineEndRadius,
  borderStart: _r.borderInlineStart,
  borderEnd: _r.borderInlineEnd,
  borderTopStartRadius: _r.borderStartStartRadius,
  borderTopEndRadius: _r.borderStartEndRadius,
  borderBottomStartRadius: _r.borderEndStartRadius,
  borderBottomEndRadius: _r.borderEndEndRadius,
  borderStartRadius: _r.borderInlineStartRadius,
  borderEndRadius: _r.borderInlineEndRadius,
  borderStartWidth: _r.borderInlineStartWidth,
  borderEndWidth: _r.borderInlineEndWidth,
  borderStartColor: _r.borderInlineStartColor,
  borderEndColor: _r.borderInlineEndColor,
  borderStartStyle: _r.borderInlineStartStyle,
  borderEndStyle: _r.borderInlineEndStyle
});
var kse = {
  color: z.colors("color"),
  textColor: z.colors("color"),
  fill: z.colors("fill"),
  stroke: z.colors("stroke")
}, cx = {
  boxShadow: z.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: z.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: z.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(cx, {
  shadow: cx.boxShadow
});
var jse = {
  filter: {
    transform: Lr.filter
  },
  blur: z.blur("--chakra-blur"),
  brightness: z.propT("--chakra-brightness", Lr.brightness),
  contrast: z.propT("--chakra-contrast", Lr.contrast),
  hueRotate: z.degreeT("--chakra-hue-rotate"),
  invert: z.propT("--chakra-invert", Lr.invert),
  saturate: z.propT("--chakra-saturate", Lr.saturate),
  dropShadow: z.propT("--chakra-drop-shadow", Lr.dropShadow),
  backdropFilter: {
    transform: Lr.backdropFilter
  },
  backdropBlur: z.blur("--chakra-backdrop-blur"),
  backdropBrightness: z.propT("--chakra-backdrop-brightness", Lr.brightness),
  backdropContrast: z.propT("--chakra-backdrop-contrast", Lr.contrast),
  backdropHueRotate: z.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: z.propT("--chakra-backdrop-invert", Lr.invert),
  backdropSaturate: z.propT("--chakra-backdrop-saturate", Lr.saturate)
}, y0 = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: {
    transform: Lr.flexDirection
  },
  experimental_spaceX: {
    static: Cse,
    transform: pf({
      scale: "space",
      transform: function(r) {
        return r !== null ? {
          "--chakra-space-x": r
        } : null;
      }
    })
  },
  experimental_spaceY: {
    static: Ese,
    transform: pf({
      scale: "space",
      transform: function(r) {
        return r != null ? {
          "--chakra-space-y": r
        } : null;
      }
    })
  },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: z.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: z.space("gap"),
  rowGap: z.space("rowGap"),
  columnGap: z.space("columnGap")
};
Object.assign(y0, {
  flexDir: y0.flexDirection
});
var gk = {
  gridGap: z.space("gridGap"),
  gridColumnGap: z.space("gridColumnGap"),
  gridRowGap: z.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, Dse = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: {
    transform: Lr.outline
  },
  outlineOffset: !0,
  outlineColor: z.colors("outlineColor")
}, Da = {
  width: z.sizesT("width"),
  inlineSize: z.sizesT("inlineSize"),
  height: z.sizes("height"),
  blockSize: z.sizes("blockSize"),
  boxSize: z.sizes(["width", "height"]),
  minWidth: z.sizes("minWidth"),
  minInlineSize: z.sizes("minInlineSize"),
  minHeight: z.sizes("minHeight"),
  minBlockSize: z.sizes("minBlockSize"),
  maxWidth: z.sizes("maxWidth"),
  maxInlineSize: z.sizes("maxInlineSize"),
  maxHeight: z.sizes("maxHeight"),
  maxBlockSize: z.sizes("maxBlockSize"),
  d: z.prop("display"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: z.propT("float", Lr.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Da, {
  w: Da.width,
  h: Da.height,
  minW: Da.minWidth,
  maxW: Da.maxWidth,
  minH: Da.minHeight,
  maxH: Da.maxHeight,
  overscroll: Da.overscrollBehavior,
  overscrollX: Da.overscrollBehaviorX,
  overscrollY: Da.overscrollBehaviorY
});
var Nse = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: z.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: z.prop("listStyleImage")
}, Lse = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, Fse = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, _1 = function(r, t, n) {
  var a = {}, i = Y$(r, t, {});
  for (var l in i) {
    var u = l in n && n[l] != null;
    u || (a[l] = i[l]);
  }
  return a;
}, zse = {
  srOnly: {
    transform: function(r) {
      return r === !0 ? Lse : r === "focusable" ? Fse : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return _1(t, "layerStyles." + r, n);
    }
  },
  textStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return _1(t, "textStyles." + r, n);
    }
  },
  apply: {
    processResult: !0,
    transform: function(r, t, n) {
      return _1(t, r, n);
    }
  }
}, Nd = {
  position: !0,
  pos: z.prop("position"),
  zIndex: z.prop("zIndex", "zIndices"),
  inset: z.spaceT("inset"),
  insetX: z.spaceT(["left", "right"]),
  insetInline: z.spaceT("insetInline"),
  insetY: z.spaceT(["top", "bottom"]),
  insetBlock: z.spaceT("insetBlock"),
  top: z.spaceT("top"),
  insetBlockStart: z.spaceT("insetBlockStart"),
  bottom: z.spaceT("bottom"),
  insetBlockEnd: z.spaceT("insetBlockEnd"),
  left: z.spaceT("left"),
  insetInlineStart: z.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: z.spaceT("right"),
  insetInlineEnd: z.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(Nd, {
  insetStart: Nd.insetInlineStart,
  insetEnd: Nd.insetInlineEnd
});
var Bse = {
  ring: {
    transform: Lr.ring
  },
  ringColor: z.colors("--chakra-ring-color"),
  ringOffset: z.prop("--chakra-ring-offset-width"),
  ringOffsetColor: z.colors("--chakra-ring-offset-color"),
  ringInset: z.prop("--chakra-ring-inset")
}, st = {
  margin: z.spaceT("margin"),
  marginTop: z.spaceT("marginTop"),
  marginBlockStart: z.spaceT("marginBlockStart"),
  marginRight: z.spaceT("marginRight"),
  marginInlineEnd: z.spaceT("marginInlineEnd"),
  marginBottom: z.spaceT("marginBottom"),
  marginBlockEnd: z.spaceT("marginBlockEnd"),
  marginLeft: z.spaceT("marginLeft"),
  marginInlineStart: z.spaceT("marginInlineStart"),
  marginX: z.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: z.spaceT("marginInline"),
  marginY: z.spaceT(["marginTop", "marginBottom"]),
  marginBlock: z.spaceT("marginBlock"),
  padding: z.space("padding"),
  paddingTop: z.space("paddingTop"),
  paddingBlockStart: z.space("paddingBlockStart"),
  paddingRight: z.space("paddingRight"),
  paddingBottom: z.space("paddingBottom"),
  paddingBlockEnd: z.space("paddingBlockEnd"),
  paddingLeft: z.space("paddingLeft"),
  paddingInlineStart: z.space("paddingInlineStart"),
  paddingInlineEnd: z.space("paddingInlineEnd"),
  paddingX: z.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: z.space("paddingInline"),
  paddingY: z.space(["paddingTop", "paddingBottom"]),
  paddingBlock: z.space("paddingBlock")
};
Object.assign(st, {
  m: st.margin,
  mt: st.marginTop,
  mr: st.marginRight,
  me: st.marginInlineEnd,
  marginEnd: st.marginInlineEnd,
  mb: st.marginBottom,
  ml: st.marginLeft,
  ms: st.marginInlineStart,
  marginStart: st.marginInlineStart,
  mx: st.marginX,
  my: st.marginY,
  p: st.padding,
  pt: st.paddingTop,
  py: st.paddingY,
  px: st.paddingX,
  pb: st.paddingBottom,
  pl: st.paddingLeft,
  ps: st.paddingInlineStart,
  paddingStart: st.paddingInlineStart,
  pr: st.paddingRight,
  pe: st.paddingInlineEnd,
  paddingEnd: st.paddingInlineEnd
});
var Use = {
  textDecorationColor: z.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: z.shadows("textShadow")
}, Vse = {
  clipPath: !0,
  transform: z.propT("transform", Lr.transform),
  transformOrigin: !0,
  translateX: z.spaceT("--chakra-translate-x"),
  translateY: z.spaceT("--chakra-translate-y"),
  skewX: z.degreeT("--chakra-skew-x"),
  skewY: z.degreeT("--chakra-skew-y"),
  scaleX: z.prop("--chakra-scale-x"),
  scaleY: z.prop("--chakra-scale-y"),
  scale: z.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: z.degreeT("--chakra-rotate")
}, Wse = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: z.prop("transitionDuration", "transition.duration"),
  transitionProperty: z.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: z.prop("transitionTimingFunction", "transition.easing")
}, Hse = {
  fontFamily: z.prop("fontFamily", "fonts"),
  fontSize: z.prop("fontSize", "fontSizes", Lr.px),
  fontWeight: z.prop("fontWeight", "fontWeights"),
  lineHeight: z.prop("lineHeight", "lineHeights"),
  letterSpacing: z.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function(r) {
      if (r === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  }
}, Gse = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: z.spaceT("scrollMargin"),
  scrollMarginTop: z.spaceT("scrollMarginTop"),
  scrollMarginBottom: z.spaceT("scrollMarginBottom"),
  scrollMarginLeft: z.spaceT("scrollMarginLeft"),
  scrollMarginRight: z.spaceT("scrollMarginRight"),
  scrollMarginX: z.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: z.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: z.spaceT("scrollPadding"),
  scrollPaddingTop: z.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: z.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: z.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: z.spaceT("scrollPaddingRight"),
  scrollPaddingX: z.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: z.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function gE(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Yse(e, r) {
  if (e) {
    if (typeof e == "string")
      return gE(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return gE(e, r);
  }
}
function Kse(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = Yse(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var en = {
  hover: function(r, t) {
    return r + ":hover " + t + ", " + r + "[data-hover] " + t;
  },
  focus: function(r, t) {
    return r + ":focus " + t + ", " + r + "[data-focus] " + t;
  },
  focusVisible: function(r, t) {
    return r + ":focus-visible " + t;
  },
  focusWithin: function(r, t) {
    return r + ":focus-within " + t;
  },
  active: function(r, t) {
    return r + ":active " + t + ", " + r + "[data-active] " + t;
  },
  disabled: function(r, t) {
    return r + ":disabled " + t + ", " + r + "[data-disabled] " + t;
  },
  invalid: function(r, t) {
    return r + ":invalid " + t + ", " + r + "[data-invalid] " + t;
  },
  checked: function(r, t) {
    return r + ":checked " + t + ", " + r + "[data-checked] " + t;
  },
  indeterminate: function(r, t) {
    return r + ":indeterminate " + t + ", " + r + "[aria-checked=mixed] " + t + ", " + r + "[data-indeterminate] " + t;
  },
  readOnly: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[readonly] " + t + ", " + r + "[data-read-only] " + t;
  },
  expanded: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[aria-expanded=true] " + t + ", " + r + "[data-expanded] " + t;
  },
  placeholderShown: function(r, t) {
    return r + ":placeholder-shown " + t;
  }
}, ps = function(r) {
  return mk(function(t) {
    return r(t, "&");
  }, "[role=group]", "[data-group]", ".group");
}, Ei = function(r) {
  return mk(function(t) {
    return r(t, "~ &");
  }, "[data-peer]", ".peer");
}, mk = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(r).join(", ");
}, q$ = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: ps(en.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: Ei(en.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: ps(en.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: Ei(en.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: ps(en.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: Ei(en.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: ps(en.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: Ei(en.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: ps(en.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: Ei(en.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: ps(en.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: Ei(en.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: ps(en.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: Ei(en.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: ps(en.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: Ei(en.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: Ei(en.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
}, Zse = JP(q$), Q$ = zl({}, Tp, _r, kse, y0, Da, jse, Bse, Dse, gk, zse, Nd, cx, st, Gse, Hse, Use, Vse, Nse, Wse);
Object.assign({}, st, Da, y0, gk, Nd);
var qse = [].concat(JP(Q$), Zse), Qse = m0({}, Q$, q$), Xse = function(r) {
  return r in Qse;
}, Jse = function(r) {
  return function(t) {
    if (!t.__breakpoints)
      return r;
    var n = t.__breakpoints, a = n.isResponsive, i = n.toArrayValue, l = n.media, u = {};
    for (var c in r) {
      var f = za(r[c], t);
      if (f != null) {
        if (f = Kl(f) && a(f) ? i(f) : f, !Array.isArray(f)) {
          u[c] = f;
          continue;
        }
        for (var h = f.slice(0, l.length).length, p = 0; p < h; p += 1) {
          var g = l == null ? void 0 : l[p];
          if (!g) {
            u[c] = f[p];
            continue;
          }
          u[g] = u[g] || {}, f[p] != null && (u[g][c] = f[p]);
        }
      }
    }
    return u;
  };
}, ele = function(r, t) {
  return r.startsWith("--") && H$(t) && !qP(t);
}, rle = function(r, t) {
  var n, a;
  if (t == null)
    return t;
  var i = function(p) {
    var g, y;
    return (g = r.__cssMap) == null || (y = g[p]) == null ? void 0 : y.varRef;
  }, l = function(p) {
    var g;
    return (g = i(p)) != null ? g : p;
  }, u = t.split(",").map(function(h) {
    return h.trim();
  }), c = u[0], f = u[1];
  return t = (n = (a = i(c)) != null ? a : l(f)) != null ? n : l(t), t;
};
function tle(e) {
  var r = e.configs, t = r === void 0 ? {} : r, n = e.pseudos, a = n === void 0 ? {} : n, i = e.theme, l = function u(c, f) {
    f === void 0 && (f = !1);
    var h = za(c, i), p = Jse(h)(i), g = {};
    for (var y in p) {
      var S, x, _, A, O, P = p[y], j = za(P, i);
      y in a && (y = a[y]), ele(y, j) && (j = rle(i, j));
      var k = t[y];
      if (k === !0 && (k = {
        property: y
      }), Kl(j)) {
        var L;
        g[y] = (L = g[y]) != null ? L : {}, g[y] = zl({}, g[y], u(j, !0));
        continue;
      }
      var M = (S = (x = k) == null || x.transform == null ? void 0 : x.transform(j, i, h)) != null ? S : j;
      M = (_ = k) != null && _.processResult ? u(M, !0) : M;
      var W = za((A = k) == null ? void 0 : A.property, i);
      if (!f && (O = k) != null && O.static) {
        var Z = za(k.static, i);
        g = zl({}, g, Z);
      }
      if (W && Array.isArray(W)) {
        for (var oe = Kse(W), Ie; !(Ie = oe()).done; ) {
          var Te = Ie.value;
          g[Te] = M;
        }
        continue;
      }
      if (W) {
        W === "&" && Kl(M) ? g = zl({}, g, M) : g[W] = M;
        continue;
      }
      if (Kl(M)) {
        g = zl({}, g, M);
        continue;
      }
      g[y] = M;
    }
    return g;
  };
  return l;
}
var nle = function(r) {
  return function(t) {
    var n = tle({
      theme: t,
      pseudos: q$,
      configs: Q$
    });
    return n(r);
  };
};
function bk(e) {
  return Kl(e) && e.reference ? e.reference : String(e);
}
var Mg = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(bk).join(" " + r + " ").replace(/calc/g, "");
}, mE = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Mg.apply(void 0, ["+"].concat(t)) + ")";
}, bE = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Mg.apply(void 0, ["-"].concat(t)) + ")";
}, dx = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Mg.apply(void 0, ["*"].concat(t)) + ")";
}, yE = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Mg.apply(void 0, ["/"].concat(t)) + ")";
}, SE = function(r) {
  var t = bk(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : dx(t, -1);
}, nd = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return nd(mE.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return nd(bE.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return nd(dx.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return nd(yE.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return nd(SE(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: mE,
  subtract: bE,
  multiply: dx,
  divide: yE,
  negate: SE
}), ale = typeof Element != "undefined", ole = typeof Map == "function", ile = typeof Set == "function", sle = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Cp(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor)
      return !1;
    var t, n, a;
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (!Cp(e[n], r[n]))
          return !1;
      return !0;
    }
    var i;
    if (ole && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!Cp(n.value[1], r.get(n.value[0])))
          return !1;
      return !0;
    }
    if (ile && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size)
        return !1;
      for (i = e.entries(); !(n = i.next()).done; )
        if (!r.has(n.value[0]))
          return !1;
      return !0;
    }
    if (sle && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (t = e.length, t != r.length)
        return !1;
      for (n = t; n-- !== 0; )
        if (e[n] !== r[n])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === r.toString();
    if (a = Object.keys(e), t = a.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[n]))
        return !1;
    if (ale && e instanceof Element)
      return !1;
    for (n = t; n-- !== 0; )
      if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !Cp(e[a[n]], r[a[n]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var lle = function(r, t) {
  try {
    return Cp(r, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
function ule(e, r) {
  if (e != null) {
    if (ZP(e)) {
      e(r);
      return;
    }
    try {
      e.current = r;
    } catch (t) {
      throw new Error("Cannot assign value '" + r + "' to ref '" + e + "'");
    }
  }
}
function Ld() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    r.forEach(function(a) {
      return ule(a, n);
    });
  };
}
function lu(e) {
  e === void 0 && (e = {});
  var r = e, t = r.strict, n = t === void 0 ? !0 : t, a = r.errorMessage, i = a === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : a, l = r.name, u = /* @__PURE__ */ I.createContext(void 0);
  u.displayName = l;
  function c() {
    var f = I.useContext(u);
    if (!f && n) {
      var h = new Error(i);
      throw h.name = "ContextError", Error.captureStackTrace == null || Error.captureStackTrace(h, c), h;
    }
    return f;
  }
  return [u.Provider, c, u];
}
function fx() {
  return fx = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, fx.apply(this, arguments);
}
function X$() {
  var e = I.useContext(ru);
  if (!e)
    throw Error("useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`");
  return e;
}
var cle = lu({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
}), J$ = cle[0];
function ew(e) {
  return G$(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function dle() {
  var e = gse(), r = X$();
  return fx({}, e, {
    theme: r
  });
}
function rw(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var fle = new Set([].concat(qse, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"])), vle = /* @__PURE__ */ new Set(["htmlWidth", "htmlHeight", "htmlSize"]), hle = function(r) {
  return vle.has(r) || !fle.has(r);
}, ple = ["theme", "css", "__css", "sx"], gle = ["baseStyle"], mle = function(r) {
  var t = r.baseStyle;
  return function(n) {
    n.theme;
    var a = n.css, i = n.__css, l = n.sx, u = rw(n, ple), c = QP(u, function(g, y) {
      return Xse(y);
    }), f = za(t, n), h = Object.assign({}, i, f, XP(c), l), p = nle(h)(n.theme);
    return a ? [p, a] : p;
  };
};
function T1(e, r) {
  var t = r != null ? r : {}, n = t.baseStyle, a = rw(t, gle);
  a.shouldForwardProp || (a.shouldForwardProp = hle);
  var i = mle({
    baseStyle: n
  });
  return qp(e, a)(i);
}
function Rg(e) {
  return /* @__PURE__ */ I.forwardRef(e);
}
var ble = ["styleConfig"];
function yle(e, r, t) {
  var n;
  r === void 0 && (r = {}), t === void 0 && (t = {});
  var a = r, i = a.styleConfig, l = rw(a, ble), u = dle(), c = u.theme, f = u.colorMode, h = Y$(c, "components." + e), p = i || h, g = zl({
    theme: c,
    colorMode: f
  }, (n = p == null ? void 0 : p.defaultProps) != null ? n : {}, XP(G$(l, ["children"]))), y = Qe({});
  if (p) {
    var S, x, _, A, O, P, j = za((S = p.baseStyle) != null ? S : {}, g), k = za((x = (_ = p.variants) == null ? void 0 : _[g.variant]) != null ? x : {}, g), L = za((A = (O = p.sizes) == null ? void 0 : O[g.size]) != null ? A : {}, g), M = zl({}, j, L, k);
    (P = t) != null && P.isMultiPart && p.parts && p.parts.forEach(function(Z) {
      var oe;
      M[Z] = (oe = M[Z]) != null ? oe : {};
    });
    var W = lle(y.current, M);
    W || (y.current = M);
  }
  return y.current;
}
function tw(e, r) {
  return yle(e, r, {
    isMultiPart: !0
  });
}
function Sle() {
  var e = /* @__PURE__ */ new Map();
  return new Proxy(T1, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function(t, n, a) {
      return T1.apply(void 0, a);
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function(t, n) {
      return e.has(n) || e.set(n, T1(n)), e.get(n);
    }
  });
}
var ma = Sle();
function xle(e) {
  const r = zs;
  return "custom" in r && typeof r.custom == "function" ? r.custom(e) : r(e);
}
xle(ma.svg);
var nw = Og ? I.useLayoutEffect : I.useEffect;
function Di(e, r) {
  r === void 0 && (r = []);
  var t = I.useRef(e);
  return nw(function() {
    t.current = e;
  }), I.useCallback(function() {
    for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
      a[i] = arguments[i];
    return t.current == null ? void 0 : t.current.apply(t, a);
  }, r);
}
function $le(e, r, t, n) {
  var a = Di(r);
  return I.useEffect(function() {
    var i, l = (i = za(t)) != null ? i : document;
    if (r)
      return l.addEventListener(e, a, n), function() {
        l.removeEventListener(e, a, n);
      };
  }, [e, t, n, a, r]), function() {
    var i, l = (i = za(t)) != null ? i : document;
    l.removeEventListener(e, a, n);
  };
}
function S0(e) {
  e === void 0 && (e = !1);
  var r = Ye(e), t = r[0], n = r[1], a = Rt(function() {
    return {
      on: function() {
        return n(!0);
      },
      off: function() {
        return n(!1);
      },
      toggle: function() {
        return n(function(l) {
          return !l;
        });
      }
    };
  }, []);
  return [t, a];
}
function yk(e) {
  var r = e.value, t = e.defaultValue, n = e.onChange, a = e.shouldUpdate, i = a === void 0 ? function(S, x) {
    return S !== x;
  } : a, l = Di(n), u = Di(i), c = I.useState(t), f = c[0], h = c[1], p = r !== void 0, g = p ? r : f, y = I.useCallback(function(S) {
    var x = za(S, g);
    u(g, x) && (p || h(x), l(x));
  }, [p, l, g, u]);
  return [g, y];
}
function wle(e, r) {
  var t = I.useState(null), n = t[0], a = t[1], i = I.useRef();
  return nw(function() {
    if (!e.current)
      return;
    var l = e.current;
    function u() {
      i.current = requestAnimationFrame(function() {
        var c = HP(l);
        a(c);
      });
    }
    return u(), r && (window.addEventListener("resize", u), window.addEventListener("scroll", u)), function() {
      r && (window.removeEventListener("resize", u), window.removeEventListener("scroll", u)), i.current && cancelAnimationFrame(i.current);
    };
  }, [r]), n;
}
var _le = {
  current: 1
}, Tle = /* @__PURE__ */ I.createContext(_le), Cle = function(r) {
  return r.current++;
};
function Sk(e, r) {
  var t = I.useContext(Tle), n = I.useState(t.current), a = n[0], i = n[1];
  return I.useEffect(function() {
    i(Cle(t));
  }, [t]), I.useMemo(function() {
    return e || [r, a].filter(Boolean).join("-");
  }, [e, r, a]);
}
function Ele(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  var a = Sk(e);
  return I.useMemo(function() {
    return t.map(function(i) {
      return i + "-" + a;
    });
  }, [a, t]);
}
var xk = function(r, t) {
  var n = I.useRef(!1);
  return I.useEffect(function() {
    if (n.current)
      return r();
    n.current = !0;
  }, t), n.current;
};
function Ale(e, r, t, n) {
  return $le(dk(r), ck(t, r === "pointerdown"), e, n);
}
function Ile(e, r) {
  return r === void 0 && (r = []), I.useEffect(
    function() {
      return function() {
        return e();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
}
function $k(e) {
  var r = I.useRef(null);
  return r.current = e, r;
}
function wk(e, r) {
  var t = r.onPan, n = r.onPanStart, a = r.onPanEnd, i = r.onPanSessionStart, l = r.onPanSessionEnd, u = r.threshold, c = !!(t || n || a || i || l), f = Qe(null), h = {
    onSessionStart: i,
    onSessionEnd: l,
    onStart: n,
    onMove: t,
    onEnd: function(y, S) {
      f.current = null, a == null || a(y, S);
    }
  };
  ar(function() {
    var g;
    (g = f.current) == null || g.updateHandlers(h);
  });
  function p(g) {
    f.current = new use(g, h, u);
  }
  Ale(function() {
    return e.current;
  }, "pointerdown", c ? p : ak), Ile(function() {
    var g;
    (g = f.current) == null || g.end(), f.current = null;
  });
}
function Bl() {
  return Bl = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Bl.apply(this, arguments);
}
function _k(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function Ole(e) {
  var r = e.loading, t = e.src, n = e.srcSet, a = e.onLoad, i = e.onError, l = e.crossOrigin, u = e.sizes, c = e.ignoreFallback, f = Ye("pending"), h = f[0], p = f[1];
  ar(function() {
    p(t ? "loading" : "pending");
  }, [t]);
  var g = Qe(), y = Ne(function() {
    if (t) {
      S();
      var x = new Image();
      x.src = t, l && (x.crossOrigin = l), n && (x.srcset = n), u && (x.sizes = u), r && (x.loading = r), x.onload = function(_) {
        S(), p("loaded"), a == null || a(_);
      }, x.onerror = function(_) {
        S(), p("failed"), i == null || i(_);
      }, g.current = x;
    }
  }, [t, l, n, u, a, i, r]), S = function() {
    g.current && (g.current.onload = null, g.current.onerror = null, g.current = null);
  };
  return nw(function() {
    if (!c)
      return h === "loading" && y(), function() {
        S();
      };
  }, [h, y, c]), c ? "loaded" : h;
}
var Mle = ["htmlWidth", "htmlHeight", "alt"], Rle = ["fallbackSrc", "fallback", "src", "srcSet", "align", "fit", "loading", "ignoreFallback", "crossOrigin"], xE = /* @__PURE__ */ I.forwardRef(function(e, r) {
  var t = e.htmlWidth, n = e.htmlHeight, a = e.alt, i = _k(e, Mle);
  return /* @__PURE__ */ I.createElement("img", Bl({
    width: t,
    height: n,
    ref: r,
    alt: a
  }, i));
}), Ple = /* @__PURE__ */ Rg(function(e, r) {
  var t = e.fallbackSrc, n = e.fallback, a = e.src, i = e.srcSet, l = e.align, u = e.fit, c = e.loading, f = e.ignoreFallback, h = e.crossOrigin, p = _k(e, Rle), g = c != null || f || t === void 0 && n === void 0, y = Ole(Bl({}, e, {
    ignoreFallback: g
  })), S = Bl({
    ref: r,
    objectFit: u,
    objectPosition: l
  }, g ? p : G$(p, ["onError", "onLoad"]));
  return y !== "loaded" ? n || /* @__PURE__ */ I.createElement(ma.img, Bl({
    as: xE,
    className: "chakra-image__placeholder",
    src: t
  }, S)) : /* @__PURE__ */ I.createElement(ma.img, Bl({
    as: xE,
    src: a,
    srcSet: i,
    crossOrigin: h,
    loading: c,
    className: "chakra-image"
  }, S));
});
function kle(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function gf() {
  return gf = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, gf.apply(this, arguments);
}
var Wr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yt = typeof Symbol == "function" && Symbol.for, aw = Yt ? Symbol.for("react.element") : 60103, ow = Yt ? Symbol.for("react.portal") : 60106, Pg = Yt ? Symbol.for("react.fragment") : 60107, kg = Yt ? Symbol.for("react.strict_mode") : 60108, jg = Yt ? Symbol.for("react.profiler") : 60114, Dg = Yt ? Symbol.for("react.provider") : 60109, Ng = Yt ? Symbol.for("react.context") : 60110, iw = Yt ? Symbol.for("react.async_mode") : 60111, Lg = Yt ? Symbol.for("react.concurrent_mode") : 60111, Fg = Yt ? Symbol.for("react.forward_ref") : 60112, zg = Yt ? Symbol.for("react.suspense") : 60113, jle = Yt ? Symbol.for("react.suspense_list") : 60120, Bg = Yt ? Symbol.for("react.memo") : 60115, Ug = Yt ? Symbol.for("react.lazy") : 60116, Dle = Yt ? Symbol.for("react.block") : 60121, Nle = Yt ? Symbol.for("react.fundamental") : 60117, Lle = Yt ? Symbol.for("react.responder") : 60118, Fle = Yt ? Symbol.for("react.scope") : 60119;
function xa(e) {
  if (typeof e == "object" && e !== null) {
    var r = e.$$typeof;
    switch (r) {
      case aw:
        switch (e = e.type, e) {
          case iw:
          case Lg:
          case Pg:
          case jg:
          case kg:
          case zg:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Ng:
              case Fg:
              case Ug:
              case Bg:
              case Dg:
                return e;
              default:
                return r;
            }
        }
      case ow:
        return r;
    }
  }
}
function Tk(e) {
  return xa(e) === Lg;
}
Wr.AsyncMode = iw;
Wr.ConcurrentMode = Lg;
Wr.ContextConsumer = Ng;
Wr.ContextProvider = Dg;
Wr.Element = aw;
Wr.ForwardRef = Fg;
Wr.Fragment = Pg;
Wr.Lazy = Ug;
Wr.Memo = Bg;
Wr.Portal = ow;
Wr.Profiler = jg;
Wr.StrictMode = kg;
Wr.Suspense = zg;
Wr.isAsyncMode = function(e) {
  return Tk(e) || xa(e) === iw;
};
Wr.isConcurrentMode = Tk;
Wr.isContextConsumer = function(e) {
  return xa(e) === Ng;
};
Wr.isContextProvider = function(e) {
  return xa(e) === Dg;
};
Wr.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === aw;
};
Wr.isForwardRef = function(e) {
  return xa(e) === Fg;
};
Wr.isFragment = function(e) {
  return xa(e) === Pg;
};
Wr.isLazy = function(e) {
  return xa(e) === Ug;
};
Wr.isMemo = function(e) {
  return xa(e) === Bg;
};
Wr.isPortal = function(e) {
  return xa(e) === ow;
};
Wr.isProfiler = function(e) {
  return xa(e) === jg;
};
Wr.isStrictMode = function(e) {
  return xa(e) === kg;
};
Wr.isSuspense = function(e) {
  return xa(e) === zg;
};
Wr.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Pg || e === Lg || e === jg || e === kg || e === zg || e === jle || typeof e == "object" && e !== null && (e.$$typeof === Ug || e.$$typeof === Bg || e.$$typeof === Dg || e.$$typeof === Ng || e.$$typeof === Fg || e.$$typeof === Nle || e.$$typeof === Lle || e.$$typeof === Fle || e.$$typeof === Dle);
};
Wr.typeOf = xa;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var $E = Object.getOwnPropertySymbols, zle = Object.prototype.hasOwnProperty, Ble = Object.prototype.propertyIsEnumerable;
function Ule(e) {
  if (e == null)
    throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(e);
}
function Vle() {
  try {
    if (!Object.assign)
      return !1;
    var e = new String("abc");
    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5")
      return !1;
    for (var r = {}, t = 0; t < 10; t++)
      r["_" + String.fromCharCode(t)] = t;
    var n = Object.getOwnPropertyNames(r).map(function(i) {
      return r[i];
    });
    if (n.join("") !== "0123456789")
      return !1;
    var a = {};
    return "abcdefghijklmnopqrst".split("").forEach(function(i) {
      a[i] = i;
    }), Object.keys(Object.assign({}, a)).join("") === "abcdefghijklmnopqrst";
  } catch (i) {
    return !1;
  }
}
Vle();
var Wle = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Hle = Wle;
Function.call.bind(Object.prototype.hasOwnProperty);
var Gle = Hle;
function Ck() {
}
function Ek() {
}
Ek.resetWarningCache = Ck;
var Yle = function() {
  function e(n, a, i, l, u, c) {
    if (c !== Gle) {
      var f = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw f.name = "Invariant Violation", f;
    }
  }
  e.isRequired = e;
  function r() {
    return e;
  }
  var t = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: r,
    element: e,
    elementType: e,
    instanceOf: r,
    node: e,
    objectOf: r,
    oneOf: r,
    oneOfType: r,
    shape: r,
    exact: r,
    checkPropTypes: Ek,
    resetWarningCache: Ck
  };
  return t.PropTypes = t, t;
};
Yle();
var vx = "data-focus-lock", Ak = "data-focus-lock-disabled", Kle = "data-no-focus-lock", Zle = "data-autofocus-inside";
function qle(e, r) {
  return typeof e == "function" ? e(r) : e && (e.current = r), e;
}
function Qle(e, r) {
  var t = Ye(function() {
    return {
      // value
      value: e,
      // last callback
      callback: r,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(n) {
          var a = t.value;
          a !== n && (t.value = n, t.callback(n, a));
        }
      }
    };
  })[0];
  return t.callback = r, t.facade;
}
function Ik(e, r) {
  return Qle(r || null, function(t) {
    return e.forEach(function(n) {
      return qle(n, t);
    });
  });
}
var C1 = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
function Ok(e) {
  return e;
}
function Mk(e, r) {
  r === void 0 && (r = Ok);
  var t = [], n = !1, a = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(i) {
      var l = r(i, n);
      return t.push(l), function() {
        t = t.filter(function(u) {
          return u !== l;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; t.length; ) {
        var l = t;
        t = [], l.forEach(i);
      }
      t = {
        push: function(u) {
          return i(u);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var l = [];
      if (t.length) {
        var u = t;
        t = [], u.forEach(i), l = t;
      }
      var c = function() {
        var h = l;
        l = [], h.forEach(i);
      }, f = function() {
        return Promise.resolve().then(c);
      };
      f(), t = {
        push: function(h) {
          l.push(h), f();
        },
        filter: function(h) {
          return l = l.filter(h), t;
        }
      };
    }
  };
  return a;
}
function sw(e, r) {
  return r === void 0 && (r = Ok), Mk(e, r);
}
function Rk(e) {
  e === void 0 && (e = {});
  var r = Mk(null);
  return r.options = js({ async: !0, ssr: !1 }, e), r;
}
var Pk = function(e) {
  var r = e.sideCar, t = V$(e, ["sideCar"]);
  if (!r)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = r.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return I.createElement(n, js({}, t));
};
Pk.isSideCarExport = !0;
function Xle(e, r) {
  return e.useMedium(r), Pk;
}
var kk = sw({}, function(e) {
  var r = e.target, t = e.currentTarget;
  return {
    target: r,
    currentTarget: t
  };
}), jk = sw(), Jle = sw(), eue = Rk({
  async: !0
}), rue = [], lw = /* @__PURE__ */ I.forwardRef(function(r, t) {
  var n, a = I.useState(), i = a[0], l = a[1], u = I.useRef(), c = I.useRef(!1), f = I.useRef(null), h = r.children, p = r.disabled, g = r.noFocusGuards, y = r.persistentFocus, S = r.crossFrame, x = r.autoFocus;
  r.allowTextSelection;
  var _ = r.group, A = r.className, O = r.whiteList, P = r.shards, j = P === void 0 ? rue : P, k = r.as, L = k === void 0 ? "div" : k, M = r.lockProps, W = M === void 0 ? {} : M, Z = r.sideCar, oe = r.returnFocus, Ie = r.onActivation, Te = r.onDeactivation, Ee = I.useState({}), Me = Ee[0], Fe = I.useCallback(function() {
    f.current = f.current || document && document.activeElement, u.current && Ie && Ie(u.current), c.current = !0;
  }, [Ie]), Ge = I.useCallback(function() {
    c.current = !1, Te && Te(u.current);
  }, [Te]), ze = I.useCallback(function(ue) {
    var $e = f.current;
    if (oe && $e && $e.focus) {
      var Ze = typeof oe == "object" ? oe : void 0;
      f.current = null, ue ? Promise.resolve().then(function() {
        return $e.focus(Ze);
      }) : $e.focus(Ze);
    }
  }, [oe]), le = I.useCallback(function(ue) {
    c.current && kk.useMedium(ue);
  }, []), ce = jk.useMedium, he = I.useCallback(function(ue) {
    u.current !== ue && (u.current = ue, l(ue));
  }, []), be = gf((n = {}, n[Ak] = p && "disabled", n[vx] = _, n), W), ye = g !== !0, q = ye && g !== "tail", ae = Ik([t, he]);
  return /* @__PURE__ */ I.createElement(I.Fragment, null, ye && [
    /* @__PURE__ */ I.createElement("div", {
      key: "guard-first",
      "data-focus-guard": !0,
      tabIndex: p ? -1 : 0,
      style: C1
    }),
    // nearest focus guard
    /* @__PURE__ */ I.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": !0,
      tabIndex: p ? -1 : 1,
      style: C1
    })
    // first tabbed element guard
  ], !p && /* @__PURE__ */ I.createElement(Z, {
    id: Me,
    sideCar: eue,
    observed: i,
    disabled: p,
    persistentFocus: y,
    crossFrame: S,
    autoFocus: x,
    whiteList: O,
    shards: j,
    onActivation: Fe,
    onDeactivation: Ge,
    returnFocus: ze
  }), /* @__PURE__ */ I.createElement(L, gf({
    ref: ae
  }, be, {
    className: A,
    onBlur: ce,
    onFocus: le
  }), h), q && /* @__PURE__ */ I.createElement("div", {
    "data-focus-guard": !0,
    tabIndex: p ? -1 : 0,
    style: C1
  }));
});
lw.propTypes = {};
lw.defaultProps = {
  children: void 0,
  disabled: !1,
  returnFocus: !1,
  noFocusGuards: !1,
  autoFocus: !0,
  persistentFocus: !1,
  crossFrame: !0,
  allowTextSelection: void 0,
  group: void 0,
  className: void 0,
  whiteList: void 0,
  shards: void 0,
  as: "div",
  lockProps: {},
  onActivation: void 0,
  onDeactivation: void 0
};
var Dk = lw;
function hx(e, r) {
  return hx = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, a) {
    return n.__proto__ = a, n;
  }, hx(e, r);
}
function tue(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, hx(e, r);
}
function mf(e) {
  "@babel/helpers - typeof";
  return mf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, mf(e);
}
function nue(e, r) {
  if (mf(e) !== "object" || e === null)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r || "default");
    if (mf(n) !== "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function aue(e) {
  var r = nue(e, "string");
  return mf(r) === "symbol" ? r : String(r);
}
function oue(e, r, t) {
  return r = aue(r), r in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function iue(e, r) {
  function t(n) {
    return n.displayName || n.name || "Component";
  }
  return function(a) {
    var i = [], l;
    function u() {
      l = e(i.map(function(f) {
        return f.props;
      })), r(l);
    }
    var c = /* @__PURE__ */ function(f) {
      tue(h, f);
      function h() {
        return f.apply(this, arguments) || this;
      }
      h.peek = function() {
        return l;
      };
      var p = h.prototype;
      return p.componentDidMount = function() {
        i.push(this), u();
      }, p.componentDidUpdate = function() {
        u();
      }, p.componentWillUnmount = function() {
        var y = i.indexOf(this);
        i.splice(y, 1), u();
      }, p.render = function() {
        return /* @__PURE__ */ xo.createElement(a, this.props);
      }, h;
    }(eU);
    return oue(c, "displayName", "SideEffect(" + t(a) + ")"), c;
  };
}
var Ns = function(e) {
  for (var r = Array(e.length), t = 0; t < e.length; ++t)
    r[t] = e[t];
  return r;
}, px = function(e) {
  return Array.isArray(e) ? e : [e];
}, sue = function(e) {
  for (var r = /* @__PURE__ */ new Set(), t = e.length, n = 0; n < t; n += 1)
    for (var a = n + 1; a < t; a += 1) {
      var i = e[n].compareDocumentPosition(e[a]);
      (i & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0 && r.add(a), (i & Node.DOCUMENT_POSITION_CONTAINS) > 0 && r.add(n);
    }
  return e.filter(function(l, u) {
    return !r.has(u);
  });
}, Nk = function(e) {
  return e.parentNode ? Nk(e.parentNode) : e;
}, uw = function(e) {
  var r = px(e);
  return r.filter(Boolean).reduce(function(t, n) {
    var a = n.getAttribute(vx);
    return t.push.apply(t, a ? sue(Ns(Nk(n).querySelectorAll("[" + vx + '="' + a + '"]:not([' + Ak + '="disabled"])'))) : [n]), t;
  }, []);
}, lue = function(e) {
  if (e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  var r = window.getComputedStyle(e, null);
  return !r || !r.getPropertyValue ? !1 : r.getPropertyValue("display") === "none" || r.getPropertyValue("visibility") === "hidden";
}, uue = function(e, r) {
  return !e || e === document || e && e.nodeType === Node.DOCUMENT_NODE || !lue(e) && r(e.parentNode && e.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? e.parentNode.host : e.parentNode);
}, Lk = function(e, r) {
  var t = e.get(r);
  if (t !== void 0)
    return t;
  var n = uue(r, Lk.bind(void 0, e));
  return e.set(r, n), n;
}, cue = function(e) {
  return !((e.tagName === "INPUT" || e.tagName === "BUTTON") && (e.type === "hidden" || e.disabled));
}, cw = function(e) {
  return !!(e && e.dataset && e.dataset.focusGuard);
}, x0 = function(e) {
  return !cw(e);
}, due = function(e) {
  return !!e;
}, fue = function(e, r) {
  var t = e.tabIndex - r.tabIndex, n = e.index - r.index;
  if (t) {
    if (!e.tabIndex)
      return 1;
    if (!r.tabIndex)
      return -1;
  }
  return t || n;
}, Fk = function(e, r, t) {
  return Ns(e).map(function(n, a) {
    return {
      node: n,
      index: a,
      tabIndex: t && n.tabIndex === -1 ? (n.dataset || {}).focusGuard ? 0 : -1 : n.tabIndex
    };
  }).filter(function(n) {
    return !r || n.tabIndex >= 0;
  }).sort(fue);
}, vue = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
], gx = vue.join(","), hue = gx + ", [data-focus-guard]", dw = function(e, r) {
  return e.reduce(function(t, n) {
    return t.concat(Ns(n.querySelectorAll(r ? hue : gx)), n.parentNode ? Ns(n.parentNode.querySelectorAll(gx)).filter(function(a) {
      return a === n;
    }) : []);
  }, []);
}, pue = function(e) {
  var r = e.querySelectorAll("[" + Zle + "]");
  return Ns(r).map(function(t) {
    return dw([t]);
  }).reduce(function(t, n) {
    return t.concat(n);
  }, []);
}, fw = function(e, r) {
  return Ns(e).filter(function(t) {
    return Lk(r, t);
  }).filter(function(t) {
    return cue(t);
  });
}, mx = function(e, r, t) {
  return Fk(fw(dw(e, t), r), !0, t);
}, wE = function(e, r) {
  return Fk(fw(dw(e), r), !1);
}, gue = function(e, r) {
  return fw(pue(e), r);
}, bx = function(e, r) {
  return r === void 0 && (r = []), r.push(e), e.parentNode && bx(e.parentNode, r), r;
}, E1 = function(e, r) {
  for (var t = bx(e), n = bx(r), a = 0; a < t.length; a += 1) {
    var i = t[a];
    if (n.indexOf(i) >= 0)
      return i;
  }
  return !1;
}, zk = function(e, r, t) {
  var n = px(e), a = px(r), i = n[0], l = !1;
  return a.filter(Boolean).forEach(function(u) {
    l = E1(l || u, u) || l, t.filter(Boolean).forEach(function(c) {
      var f = E1(i, c);
      f && (!l || f.contains(l) ? l = f : l = E1(f, l));
    });
  }), l;
}, mue = function(e, r) {
  return e.reduce(function(t, n) {
    return t.concat(gue(n, r));
  }, []);
}, bue = function(e) {
  var r = uw(e).filter(x0), t = zk(e, e, r), n = /* @__PURE__ */ new Map(), a = mx([t], n, !0), i = mx(r, n).filter(function(l) {
    var u = l.node;
    return x0(u);
  }).map(function(l) {
    var u = l.node;
    return u;
  });
  return a.map(function(l) {
    var u = l.node, c = l.index;
    return {
      node: u,
      index: c,
      lockItem: i.indexOf(u) >= 0,
      guard: cw(u)
    };
  });
}, yue = function(e) {
  return e === document.activeElement;
}, Sue = function(e) {
  return !!Ns(e.querySelectorAll("iframe")).some(function(r) {
    return yue(r);
  });
}, Bk = function(e) {
  var r = document && document.activeElement;
  return !r || r.dataset && r.dataset.focusGuard ? !1 : uw(e).reduce(function(t, n) {
    return t || n.contains(r) || Sue(n);
  }, !1);
}, xue = function() {
  return document && Ns(document.querySelectorAll("[" + Kle + "]")).some(function(e) {
    return e.contains(document.activeElement);
  });
}, Uk = function(e) {
  return e.tagName === "INPUT" && e.type === "radio";
}, $ue = function(e, r) {
  return r.filter(Uk).filter(function(t) {
    return t.name === e.name;
  }).filter(function(t) {
    return t.checked;
  })[0] || e;
}, vw = function(e, r) {
  return Uk(e) && e.name ? $ue(e, r) : e;
}, wue = function(e) {
  var r = /* @__PURE__ */ new Set();
  return e.forEach(function(t) {
    return r.add(vw(t, e));
  }), e.filter(function(t) {
    return r.has(t);
  });
}, _E = function(e) {
  return e[0] && e.length > 1 ? vw(e[0], e) : e[0];
}, TE = function(e, r) {
  return e.length > 1 ? e.indexOf(vw(e[r], e)) : r;
}, Vk = "NEW_FOCUS", _ue = function(e, r, t, n) {
  var a = e.length, i = e[0], l = e[a - 1], u = cw(t);
  if (!(e.indexOf(t) >= 0)) {
    var c = r.indexOf(t), f = n ? r.indexOf(n) : c, h = n ? e.indexOf(n) : -1, p = c - f, g = r.indexOf(i), y = r.indexOf(l), S = wue(r), x = S.indexOf(t) - (n ? S.indexOf(n) : c), _ = TE(e, 0), A = TE(e, a - 1);
    if (c === -1 || h === -1)
      return Vk;
    if (!p && h >= 0)
      return h;
    if (c <= g && u && Math.abs(p) > 1)
      return A;
    if (c >= y && u && Math.abs(p) > 1)
      return _;
    if (p && Math.abs(x) > 1)
      return h;
    if (c <= g)
      return A;
    if (c > y)
      return _;
    if (p)
      return Math.abs(p) > 1 ? h : (a + h + p) % a;
  }
}, Tue = function(e) {
  return function(r) {
    return r.autofocus || r.dataset && !!r.dataset.autofocus || e.indexOf(r) >= 0;
  };
}, Cue = function(e, r) {
  var t = /* @__PURE__ */ new Map();
  return r.forEach(function(n) {
    return t.set(n.node, n);
  }), e.map(function(n) {
    return t.get(n);
  }).filter(due);
}, Eue = function(e, r) {
  var t = document && document.activeElement, n = uw(e).filter(x0), a = zk(t || e, e, n), i = /* @__PURE__ */ new Map(), l = wE(n, i), u = mx(n, i).filter(function(y) {
    var S = y.node;
    return x0(S);
  });
  if (!(!u[0] && (u = l, !u[0]))) {
    var c = wE([a], i).map(function(y) {
      var S = y.node;
      return S;
    }), f = Cue(c, u), h = f.map(function(y) {
      var S = y.node;
      return S;
    }), p = _ue(h, c, t, r);
    if (p === Vk) {
      var g = l.map(function(y) {
        var S = y.node;
        return S;
      }).filter(Tue(mue(n, i)));
      return {
        node: g && g.length ? _E(g) : _E(h)
      };
    }
    return p === void 0 ? p : f[p];
  }
}, Aue = function(e) {
  e.focus(), "contentWindow" in e && e.contentWindow && e.contentWindow.focus();
}, A1 = 0, I1 = !1, Iue = function(e, r) {
  var t = Eue(e, r);
  if (!I1 && t) {
    if (A1 > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), I1 = !0, setTimeout(function() {
        I1 = !1;
      }, 1);
      return;
    }
    A1++, Aue(t.node), A1--;
  }
}, Wk = Iue;
function Hk(e) {
  var r = window, t = r.setImmediate;
  typeof t != "undefined" ? t(e) : setTimeout(e, 1);
}
var Oue = function() {
  return document && document.activeElement === document.body;
}, Mue = function() {
  return Oue() || xue();
}, uc = null, Ku = null, cc = null, bf = !1, Rue = function() {
  return !0;
}, Pue = function(r) {
  return (uc.whiteList || Rue)(r);
}, kue = function(r, t) {
  cc = {
    observerNode: r,
    portaledElement: t
  };
}, jue = function(r) {
  return cc && cc.portaledElement === r;
};
function CE(e, r, t, n) {
  var a = null, i = e;
  do {
    var l = n[i];
    if (l.guard)
      l.node.dataset.focusAutoGuard && (a = l);
    else if (l.lockItem) {
      if (i !== e)
        return;
      a = null;
    } else
      break;
  } while ((i += t) !== r);
  a && (a.node.tabIndex = 0);
}
var Due = function(r) {
  return r && "current" in r ? r.current : r;
}, Nue = function(r) {
  return r ? !!bf : bf === "meanwhile";
}, $0 = function() {
  var r = !1;
  if (uc) {
    var t = uc, n = t.observed, a = t.persistentFocus, i = t.autoFocus, l = t.shards, u = t.crossFrame, c = n || cc && cc.portaledElement, f = document && document.activeElement;
    if (c) {
      var h = [c].concat(l.map(Due).filter(Boolean));
      if ((!f || Pue(f)) && (a || Nue(u) || !Mue() || !Ku && i) && (c && !(Bk(h) || jue(f)) && (document && !Ku && f && !i ? (f.blur && f.blur(), document.body.focus()) : (r = Wk(h, Ku), cc = {})), bf = !1, Ku = document && document.activeElement), document) {
        var p = document && document.activeElement, g = bue(h), y = g.map(function(S) {
          var x = S.node;
          return x;
        }).indexOf(p);
        y > -1 && (g.filter(function(S) {
          var x = S.guard, _ = S.node;
          return x && _.dataset.focusAutoGuard;
        }).forEach(function(S) {
          var x = S.node;
          return x.removeAttribute("tabIndex");
        }), CE(y, g.length, 1, g), CE(y, -1, -1, g));
      }
    }
  }
  return r;
}, Gk = function(r) {
  $0() && r && (r.stopPropagation(), r.preventDefault());
}, hw = function() {
  return Hk($0);
}, Lue = function(r) {
  var t = r.target, n = r.currentTarget;
  n.contains(t) || kue(n, t);
}, Fue = function() {
  return null;
}, Yk = function() {
  bf = "just", setTimeout(function() {
    bf = "meanwhile";
  }, 0);
}, zue = function() {
  document.addEventListener("focusin", Gk, !0), document.addEventListener("focusout", hw), window.addEventListener("blur", Yk);
}, Bue = function() {
  document.removeEventListener("focusin", Gk, !0), document.removeEventListener("focusout", hw), window.removeEventListener("blur", Yk);
};
function Uue(e) {
  return e.filter(function(r) {
    var t = r.disabled;
    return !t;
  });
}
function Vue(e) {
  var r = e.slice(-1)[0];
  r && !uc && zue();
  var t = uc, n = t && r && r.id === t.id;
  uc = r, t && !n && (t.onDeactivation(), e.filter(function(a) {
    var i = a.id;
    return i === t.id;
  }).length || t.returnFocus(!r)), r ? (Ku = null, (!n || t.observed !== r.observed) && r.onActivation(), $0(), Hk($0)) : (Bue(), Ku = null);
}
kk.assignSyncMedium(Lue);
jk.assignMedium(hw);
Jle.assignMedium(function(e) {
  return e({
    moveFocusInside: Wk,
    focusInside: Bk
  });
});
var Wue = iue(Uue, Vue)(Fue), Hue = /* @__PURE__ */ I.forwardRef(function(r, t) {
  return /* @__PURE__ */ I.createElement(Dk, gf({
    sideCar: Wue,
    ref: t
  }, r));
}), Kk = Dk.propTypes || {};
Kk.sideCar;
kle(Kk, ["sideCar"]);
Hue.propTypes = {};
lu({
  strict: !1,
  name: "PortalManagerContext"
});
lu({
  strict: !1,
  name: "PortalContext"
});
function Gue(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function Ba() {
  return Ba = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ba.apply(this, arguments);
}
var yx = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
}, ad = {
  scale: {
    enter: {
      scale: 1
    },
    exit: {
      scale: 0.95
    }
  },
  fade: {
    enter: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  pushLeft: {
    enter: {
      x: "100%"
    },
    exit: {
      x: "-30%"
    }
  },
  pushRight: {
    enter: {
      x: "-100%"
    },
    exit: {
      x: "30%"
    }
  },
  pushUp: {
    enter: {
      y: "100%"
    },
    exit: {
      y: "-30%"
    }
  },
  pushDown: {
    enter: {
      y: "-100%"
    },
    exit: {
      y: "30%"
    }
  },
  slideLeft: {
    position: {
      left: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "-100%",
      y: 0
    }
  },
  slideRight: {
    position: {
      right: 0,
      top: 0,
      bottom: 0,
      width: "100%"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: "100%",
      y: 0
    }
  },
  slideUp: {
    position: {
      top: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "-100%"
    }
  },
  slideDown: {
    position: {
      bottom: 0,
      left: 0,
      right: 0,
      maxWidth: "100vw"
    },
    enter: {
      x: 0,
      y: 0
    },
    exit: {
      x: 0,
      y: "100%"
    }
  }
};
function Sx(e) {
  var r, t = (r = e == null ? void 0 : e.direction) != null ? r : "right";
  switch (t) {
    case "right":
      return ad.slideRight;
    case "left":
      return ad.slideLeft;
    case "bottom":
      return ad.slideDown;
    case "top":
      return ad.slideUp;
    default:
      return ad.slideRight;
  }
}
var Fd = {
  enter: {
    duration: 0.2,
    ease: yx.easeOut
  },
  exit: {
    duration: 0.1,
    ease: yx.easeIn
  }
}, Zl = {
  enter: function(r, t) {
    return Ba({}, r, {
      delay: Yl(t) ? t : t == null ? void 0 : t.enter
    });
  },
  exit: function(r, t) {
    return Ba({}, r, {
      delay: Yl(t) ? t : t == null ? void 0 : t.exit
    });
  }
}, Yue = {
  exit: function(r) {
    var t, n = r.reverse, a = r.initialScale, i = r.transition, l = r.transitionEnd, u = r.delay;
    return Ba({
      opacity: 0
    }, n ? {
      scale: a,
      transitionEnd: l == null ? void 0 : l.exit
    } : {
      transitionEnd: Ba({
        scale: a
      }, l == null ? void 0 : l.exit)
    }, {
      transition: (t = i == null ? void 0 : i.exit) != null ? t : Zl.exit(Fd.exit, u)
    });
  },
  enter: function(r) {
    var t, n = r.transitionEnd, a = r.transition, i = r.delay;
    return {
      opacity: 1,
      scale: 1,
      transition: (t = a == null ? void 0 : a.enter) != null ? t : Zl.enter(Fd.enter, i),
      transitionEnd: n == null ? void 0 : n.enter
    };
  }
}, Kue = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: Yue
}, Zue = ["direction", "style", "unmountOnExit", "in", "className", "transition", "transitionEnd", "delay"], EE = {
  exit: {
    duration: 0.15,
    ease: yx.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
}, que = {
  exit: function(r) {
    var t, n = r.direction, a = r.transition, i = r.transitionEnd, l = r.delay, u = Sx({
      direction: n
    }), c = u.exit;
    return Ba({}, c, {
      transition: (t = a == null ? void 0 : a.exit) != null ? t : Zl.exit(EE.exit, l),
      transitionEnd: i == null ? void 0 : i.exit
    });
  },
  enter: function(r) {
    var t, n = r.direction, a = r.transitionEnd, i = r.transition, l = r.delay, u = Sx({
      direction: n
    }), c = u.enter;
    return Ba({}, c, {
      transition: (t = i == null ? void 0 : i.enter) != null ? t : Zl.enter(EE.enter, l),
      transitionEnd: a == null ? void 0 : a.enter
    });
  }
}, Que = /* @__PURE__ */ I.forwardRef(function(e, r) {
  var t = e.direction, n = t === void 0 ? "right" : t, a = e.style, i = e.unmountOnExit, l = e.in, u = e.className, c = e.transition, f = e.transitionEnd, h = e.delay, p = Gue(e, Zue), g = Sx({
    direction: n
  }), y = Object.assign({
    position: "fixed"
  }, g.position, a), S = i ? l && i : !0, x = l || i ? "enter" : "exit", _ = {
    transitionEnd: f,
    transition: c,
    direction: n,
    delay: h
  };
  return /* @__PURE__ */ I.createElement(ite, {
    custom: _
  }, S && /* @__PURE__ */ I.createElement(zs.div, Ba({}, p, {
    ref: r,
    initial: "exit",
    className: Z$("chakra-slide", u),
    animate: x,
    exit: "exit",
    custom: _,
    variants: que,
    style: y
  })));
}), Xue = {
  initial: function(r) {
    var t, n = r.offsetX, a = r.offsetY, i = r.transition, l = r.transitionEnd, u = r.delay;
    return {
      opacity: 0,
      x: n,
      y: a,
      transition: (t = i == null ? void 0 : i.exit) != null ? t : Zl.exit(Fd.exit, u),
      transitionEnd: l == null ? void 0 : l.exit
    };
  },
  enter: function(r) {
    var t, n = r.transition, a = r.transitionEnd, i = r.delay;
    return {
      opacity: 1,
      x: 0,
      y: 0,
      transition: (t = n == null ? void 0 : n.enter) != null ? t : Zl.enter(Fd.enter, i),
      transitionEnd: a == null ? void 0 : a.enter
    };
  },
  exit: function(r) {
    var t, n = r.offsetY, a = r.offsetX, i = r.transition, l = r.transitionEnd, u = r.reverse, c = r.delay, f = {
      x: a,
      y: n
    };
    return Ba({
      opacity: 0,
      transition: (t = i == null ? void 0 : i.exit) != null ? t : Zl.exit(Fd.exit, c)
    }, u ? Ba({}, f, {
      transitionEnd: l == null ? void 0 : l.exit
    }) : {
      transitionEnd: Ba({}, f, l == null ? void 0 : l.exit)
    });
  }
}, AE = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: Xue
}, Ep = "right-scroll-bar-position", Ap = "width-before-scroll-bar", Jue = "with-scroll-bars-hidden", ece = "--removed-body-scroll-bar-size", Zk = Rk(), O1 = function() {
}, Vg = I.forwardRef(function(e, r) {
  var t = I.useRef(null), n = I.useState({
    onScrollCapture: O1,
    onWheelCapture: O1,
    onTouchMoveCapture: O1
  }), a = n[0], i = n[1], l = e.forwardProps, u = e.children, c = e.className, f = e.removeScrollBar, h = e.enabled, p = e.shards, g = e.sideCar, y = e.noIsolation, S = e.inert, x = e.allowPinchZoom, _ = e.as, A = _ === void 0 ? "div" : _, O = V$(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), P = g, j = Ik([
    t,
    r
  ]), k = js({}, O, a);
  return I.createElement(
    I.Fragment,
    null,
    h && I.createElement(P, { sideCar: Zk, removeScrollBar: f, shards: p, noIsolation: y, inert: S, setCallbacks: i, allowPinchZoom: !!x, lockRef: t }),
    l ? I.cloneElement(I.Children.only(u), js({}, k, { ref: j })) : I.createElement(A, js({}, k, { className: c, ref: j }), u)
  );
});
Vg.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Vg.classNames = {
  fullWidth: Ap,
  zeroRight: Ep
};
var rce = function() {
  if (typeof __webpack_nonce__ != "undefined")
    return __webpack_nonce__;
};
function tce() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var r = rce();
  return r && e.setAttribute("nonce", r), e;
}
function nce(e, r) {
  e.styleSheet ? e.styleSheet.cssText = r : e.appendChild(document.createTextNode(r));
}
function ace(e) {
  var r = document.head || document.getElementsByTagName("head")[0];
  r.appendChild(e);
}
var oce = function() {
  var e = 0, r = null;
  return {
    add: function(t) {
      e == 0 && (r = tce()) && (nce(r, t), ace(r)), e++;
    },
    remove: function() {
      e--, !e && r && (r.parentNode && r.parentNode.removeChild(r), r = null);
    }
  };
}, ice = function() {
  var e = oce();
  return function(r, t) {
    I.useEffect(function() {
      return e.add(r), function() {
        e.remove();
      };
    }, [r && t]);
  };
}, qk = function() {
  var e = ice(), r = function(t) {
    var n = t.styles, a = t.dynamic;
    return e(n, a), null;
  };
  return r;
}, sce = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, M1 = function(e) {
  return parseInt(e || "", 10) || 0;
}, lce = function(e) {
  var r = window.getComputedStyle(document.body), t = r[e === "padding" ? "paddingLeft" : "marginLeft"], n = r[e === "padding" ? "paddingTop" : "marginTop"], a = r[e === "padding" ? "paddingRight" : "marginRight"];
  return [M1(t), M1(n), M1(a)];
}, uce = function(e) {
  if (e === void 0 && (e = "margin"), typeof window == "undefined")
    return sce;
  var r = lce(e), t = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: r[0],
    top: r[1],
    right: r[2],
    gap: Math.max(0, n - t + r[2] - r[0])
  };
}, cce = qk(), dce = function(e, r, t, n) {
  var a = e.left, i = e.top, l = e.right, u = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(Jue, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(u, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    r && "position: relative ".concat(n, ";"),
    t === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(l, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(u, "px ").concat(n, `;
    `),
    t === "padding" && "padding-right: ".concat(u, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ep, ` {
    right: `).concat(u, "px ").concat(n, `;
  }
  
  .`).concat(Ap, ` {
    margin-right: `).concat(u, "px ").concat(n, `;
  }
  
  .`).concat(Ep, " .").concat(Ep, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Ap, " .").concat(Ap, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(ece, ": ").concat(u, `px;
  }
`);
}, fce = function(e) {
  var r = e.noRelative, t = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n, i = I.useMemo(function() {
    return uce(a);
  }, [a]);
  return I.createElement(cce, { styles: dce(i, !r, a, t ? "" : "!important") });
}, vce = function(e) {
  var r = window.getComputedStyle(e);
  return r.overflowY !== "hidden" && // not-not-scrollable
  !(r.overflowY === r.overflowX && r.overflowY === "visible");
}, hce = function(e) {
  var r = window.getComputedStyle(e);
  return r.overflowX !== "hidden" && // not-not-scrollable
  !(r.overflowY === r.overflowX && r.overflowX === "visible");
}, IE = function(e, r) {
  var t = r;
  do {
    var n = Qk(e, t);
    if (n) {
      var a = Xk(e, t), i = a[1], l = a[2];
      if (i > l)
        return !0;
    }
    t = t.parentNode;
  } while (t && t !== document.body);
  return !1;
}, pce = function(e) {
  var r = e.scrollTop, t = e.scrollHeight, n = e.clientHeight;
  return [r, t, n];
}, gce = function(e) {
  var r = e.scrollLeft, t = e.scrollWidth, n = e.clientWidth;
  return [r, t, n];
}, Qk = function(e, r) {
  return e === "v" ? vce(r) : hce(r);
}, Xk = function(e, r) {
  return e === "v" ? pce(r) : gce(r);
}, mce = function(e, r, t, n, a) {
  var i = n, l = t.target, u = r.contains(l), c = !1, f = i > 0, h = 0, p = 0;
  do {
    var g = Xk(e, l), y = g[0], S = g[1], x = g[2], _ = S - x - y;
    (y || _) && Qk(e, l) && (h += _, p += y), l = l.parentNode;
  } while (
    // portaled content
    !u && l !== document.body || // self content
    u && (r.contains(l) || r === l)
  );
  return (f && (a && h === 0 || !a && i > h) || !f && (a && p === 0 || !a && -i > p)) && (c = !0), c;
}, xx = !1;
if (typeof window != "undefined")
  try {
    var bh = Object.defineProperty({}, "passive", {
      get: function() {
        return xx = !0, !0;
      }
    });
    window.addEventListener("test", bh, bh), window.removeEventListener("test", bh, bh);
  } catch (e) {
    xx = !1;
  }
var Pu = xx ? { passive: !1 } : !1, yh = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, OE = function(e) {
  return [e.deltaX, e.deltaY];
}, ME = function(e) {
  return e && "current" in e ? e.current : e;
}, bce = function(e, r) {
  return e[0] === r[0] && e[1] === r[1];
}, yce = function(e) {
  return `
  .block-interactivity-` + e + ` {pointer-events: none;}
  .allow-interactivity-` + e + ` {pointer-events: all;}
`;
}, Sce = 0, ku = [];
function xce(e) {
  var r = I.useRef([]), t = I.useRef([0, 0]), n = I.useRef(), a = I.useState(Sce++)[0], i = I.useState(function() {
    return qk();
  })[0], l = I.useRef(e);
  I.useEffect(function() {
    l.current = e;
  }, [e]), I.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-" + a);
      var x = [
        e.lockRef.current
      ].concat((e.shards || []).map(ME)).filter(Boolean);
      return x.forEach(function(_) {
        return _.classList.add("allow-interactivity-" + a);
      }), function() {
        document.body.classList.remove("block-interactivity-" + a), x.forEach(function(_) {
          return _.classList.remove("allow-interactivity-" + a);
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var u = I.useCallback(function(x, _) {
    if ("touches" in x && x.touches.length === 2)
      return !l.current.allowPinchZoom;
    var A = yh(x), O = t.current, P = "deltaX" in x ? x.deltaX : O[0] - A[0], j = "deltaY" in x ? x.deltaY : O[1] - A[1], k, L = x.target, M = Math.abs(P) > Math.abs(j) ? "h" : "v", W = IE(M, L);
    if (!W)
      return !0;
    if (W ? k = M : (k = M === "v" ? "h" : "v", W = IE(M, L)), !W)
      return !1;
    if (!n.current && "changedTouches" in x && (P || j) && (n.current = k), !k)
      return !0;
    var Z = n.current || k;
    return mce(Z, _, x, Z === "h" ? P : j, !0);
  }, []), c = I.useCallback(function(x) {
    var _ = x;
    if (!(!ku.length || ku[ku.length - 1] !== i)) {
      var A = "deltaY" in _ ? OE(_) : yh(_), O = r.current.filter(function(k) {
        return k.name === _.type && k.target === _.target && bce(k.delta, A);
      })[0];
      if (O && O.should) {
        _.preventDefault();
        return;
      }
      if (!O) {
        var P = (l.current.shards || []).map(ME).filter(Boolean).filter(function(k) {
          return k.contains(_.target);
        }), j = P.length > 0 ? u(_, P[0]) : !l.current.noIsolation;
        j && _.preventDefault();
      }
    }
  }, []), f = I.useCallback(function(x, _, A, O) {
    var P = { name: x, delta: _, target: A, should: O };
    r.current.push(P), setTimeout(function() {
      r.current = r.current.filter(function(j) {
        return j !== P;
      });
    }, 1);
  }, []), h = I.useCallback(function(x) {
    t.current = yh(x), n.current = void 0;
  }, []), p = I.useCallback(function(x) {
    f(x.type, OE(x), x.target, u(x, e.lockRef.current));
  }, []), g = I.useCallback(function(x) {
    f(x.type, yh(x), x.target, u(x, e.lockRef.current));
  }, []);
  I.useEffect(function() {
    return ku.push(i), e.setCallbacks({
      onScrollCapture: p,
      onWheelCapture: p,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, Pu), document.addEventListener("touchmove", c, Pu), document.addEventListener("touchstart", h, Pu), function() {
      ku = ku.filter(function(x) {
        return x !== i;
      }), document.removeEventListener("wheel", c, Pu), document.removeEventListener("touchmove", c, Pu), document.removeEventListener("touchstart", h, Pu);
    };
  }, []);
  var y = e.removeScrollBar, S = e.inert;
  return I.createElement(
    I.Fragment,
    null,
    S ? I.createElement(i, { styles: yce(a) }) : null,
    y ? I.createElement(fce, { gapMode: "margin" }) : null
  );
}
var $ce = Xle(Zk, xce), wce = I.forwardRef(function(e, r) {
  return I.createElement(Vg, js({}, e, { ref: r, sideCar: $ce }));
});
wce.classNames = Vg.classNames;
function zd() {
  return zd = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, zd.apply(this, arguments);
}
zd({}, AE, {
  custom: {
    offsetY: 16,
    reverse: !0
  }
}), zd({}, AE, {
  custom: {
    offsetX: 16,
    reverse: !0
  }
}), zd({}, Kue, {
  custom: {
    initialScale: 0.95,
    reverse: !0
  }
});
ma(zs.section);
lu({
  strict: !0,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
});
ma(zs.div);
lu();
ma(Que);
var Jk = {}, _ce = Ha, Tce = PP, Cce = zi, Ece = Ya, Ace = Hf, Ice = WP;
Jk.f = _ce && !Tce ? Object.defineProperties : function(r, t) {
  Ece(r);
  for (var n = Ace(t), a = Ice(t), i = a.length, l = 0, u; i > l; )
    Cce.f(r, u = a[l++], n[u]);
  return r;
};
var Oce = su, ej = Oce("document", "documentElement"), Mce = Ya, Rce = Jk, RE = B$, Pce = L$, kce = ej, jce = Eg, Dce = N$, PE = ">", kE = "<", $x = "prototype", wx = "script", rj = Dce("IE_PROTO"), R1 = function() {
}, tj = function(e) {
  return kE + wx + PE + e + kE + "/" + wx + PE;
}, jE = function(e) {
  e.write(tj("")), e.close();
  var r = e.parentWindow.Object;
  return e = null, r;
}, Nce = function() {
  var e = jce("iframe"), r = "java" + wx + ":", t;
  return e.style.display = "none", kce.appendChild(e), e.src = String(r), t = e.contentWindow.document, t.open(), t.write(tj("document.F=Object")), t.close(), t.F;
}, Sh, Ip = function() {
  try {
    Sh = new ActiveXObject("htmlfile");
  } catch (r) {
  }
  Ip = typeof document != "undefined" ? document.domain && Sh ? jE(Sh) : Nce() : jE(Sh);
  for (var e = RE.length; e--; )
    delete Ip[$x][RE[e]];
  return Ip();
};
Pce[rj] = !0;
var nj = Object.create || function(r, t) {
  var n;
  return r !== null ? (R1[$x] = Mce(r), n = new R1(), R1[$x] = null, n[rj] = r) : n = Ip(), t === void 0 ? n : Rce.f(n, t);
}, Lce = qn, Fce = nj, zce = zi.f, _x = Lce("unscopables"), Tx = Array.prototype;
Tx[_x] == null && zce(Tx, _x, {
  configurable: !0,
  value: Fce(null)
});
var aj = function(e) {
  Tx[_x][e] = !0;
}, Kf = {}, Bce = Rn, Uce = !Bce(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), Vce = Ga, Wce = Mt, Hce = R$, Gce = N$, Yce = Uce, DE = Gce("IE_PROTO"), Cx = Object, Kce = Cx.prototype, oj = Yce ? Cx.getPrototypeOf : function(e) {
  var r = Hce(e);
  if (Vce(r, DE))
    return r[DE];
  var t = r.constructor;
  return Wce(t) && r instanceof t ? t.prototype : r instanceof Cx ? Kce : null;
}, Zce = Rn, qce = Mt, Qce = Bs, NE = oj, Xce = Ic, Jce = qn, Ex = Jce("iterator"), ij = !1, tu, P1, k1;
[].keys && (k1 = [].keys(), "next" in k1 ? (P1 = NE(NE(k1)), P1 !== Object.prototype && (tu = P1)) : ij = !0);
var ede = !Qce(tu) || Zce(function() {
  var e = {};
  return tu[Ex].call(e) !== e;
});
ede && (tu = {});
qce(tu[Ex]) || Xce(tu, Ex, function() {
  return this;
});
var sj = {
  IteratorPrototype: tu,
  BUGGY_SAFARI_ITERATORS: ij
}, rde = zi.f, tde = Ga, nde = qn, LE = nde("toStringTag"), pw = function(e, r, t) {
  e && !t && (e = e.prototype), e && !tde(e, LE) && rde(e, LE, { configurable: !0, value: r });
}, ade = sj.IteratorPrototype, ode = nj, ide = E$, sde = pw, lde = Kf, ude = function() {
  return this;
}, cde = function(e, r, t, n) {
  var a = r + " Iterator";
  return e.prototype = ode(ade, { next: ide(+!n, t) }), sde(e, a, !1), lde[a] = ude, e;
}, dde = Pn, fde = Us, vde = function(e, r, t) {
  try {
    return dde(fde(Object.getOwnPropertyDescriptor(e, r)[t]));
  } catch (n) {
  }
}, hde = Mt, pde = String, gde = TypeError, mde = function(e) {
  if (typeof e == "object" || hde(e))
    return e;
  throw gde("Can't set " + pde(e) + " as a prototype");
}, bde = vde, yde = Ya, Sde = mde, lj = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, r = {}, t;
  try {
    t = bde(Object.prototype, "__proto__", "set"), t(r, []), e = r instanceof Array;
  } catch (n) {
  }
  return function(a, i) {
    return yde(a), Sde(i), e ? t(a, i) : a.__proto__ = i, a;
  };
}() : void 0), xde = oi, $de = Sa, uj = j$, wde = Mt, _de = cde, FE = oj, zE = lj, Tde = pw, Cde = Ag, j1 = Ic, Ede = qn, Ade = Kf, cj = sj, Ide = uj.PROPER, Ode = uj.CONFIGURABLE, BE = cj.IteratorPrototype, xh = cj.BUGGY_SAFARI_ITERATORS, od = Ede("iterator"), UE = "keys", id = "values", VE = "entries", Mde = function() {
  return this;
}, Rde = function(e, r, t, n, a, i, l) {
  _de(t, r, n);
  var u = function(A) {
    if (A === a && g)
      return g;
    if (!xh && A in h)
      return h[A];
    switch (A) {
      case UE:
        return function() {
          return new t(this, A);
        };
      case id:
        return function() {
          return new t(this, A);
        };
      case VE:
        return function() {
          return new t(this, A);
        };
    }
    return function() {
      return new t(this);
    };
  }, c = r + " Iterator", f = !1, h = e.prototype, p = h[od] || h["@@iterator"] || a && h[a], g = !xh && p || u(a), y = r == "Array" && h.entries || p, S, x, _;
  if (y && (S = FE(y.call(new e())), S !== Object.prototype && S.next && (FE(S) !== BE && (zE ? zE(S, BE) : wde(S[od]) || j1(S, od, Mde)), Tde(S, c, !0))), Ide && a == id && p && p.name !== id && (Ode ? Cde(h, "name", id) : (f = !0, g = function() {
    return $de(p, this);
  })), a)
    if (x = {
      values: u(id),
      keys: i ? g : u(UE),
      entries: u(VE)
    }, l)
      for (_ in x)
        (xh || f || !(_ in h)) && j1(h, _, x[_]);
    else
      xde({ target: r, proto: !0, forced: xh || f }, x);
  return h[od] !== g && j1(h, od, g, { name: a }), Ade[r] = g, x;
}, Pde = function(e, r) {
  return { value: e, done: r };
}, kde = Hf, gw = aj, WE = Kf, dj = F$, jde = zi.f, Dde = Rde, $h = Pde, Nde = Ha, fj = "Array Iterator", Lde = dj.set, Fde = dj.getterFor(fj), zde = Dde(Array, "Array", function(e, r) {
  Lde(this, {
    type: fj,
    target: kde(e),
    // target
    index: 0,
    // next index
    kind: r
    // kind
  });
}, function() {
  var e = Fde(this), r = e.target, t = e.kind, n = e.index++;
  return !r || n >= r.length ? (e.target = void 0, $h(void 0, !0)) : t == "keys" ? $h(n, !1) : t == "values" ? $h(r[n], !1) : $h([n, r[n]], !1);
}, "values"), HE = WE.Arguments = WE.Array;
gw("keys");
gw("values");
gw("entries");
if (Nde && HE.name !== "values")
  try {
    jde(HE, "name", { value: "values" });
  } catch (e) {
  }
var Bde = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, Ude = Eg, D1 = Ude("span").classList, GE = D1 && D1.constructor && D1.constructor.prototype, Vde = GE === Object.prototype ? void 0 : GE, YE = un, vj = Bde, Wde = Vde, Sd = zde, N1 = Ag, hj = qn, L1 = hj("iterator"), KE = hj("toStringTag"), F1 = Sd.values, pj = function(e, r) {
  if (e) {
    if (e[L1] !== F1)
      try {
        N1(e, L1, F1);
      } catch (n) {
        e[L1] = F1;
      }
    if (e[KE] || N1(e, KE, r), vj[r]) {
      for (var t in Sd)
        if (e[t] !== Sd[t])
          try {
            N1(e, t, Sd[t]);
          } catch (n) {
            e[t] = Sd[t];
          }
    }
  }
};
for (var z1 in vj)
  pj(YE[z1] && YE[z1].prototype, z1);
pj(Wde, "DOMTokenList");
function gr() {
  return gr = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, gr.apply(this, arguments);
}
function Ul(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
function Hde(e) {
  return {
    root: "slider-root-" + e,
    getThumb: function(t) {
      return "slider-thumb-" + e + "-" + t;
    },
    getInput: function(t) {
      return "slider-input-" + e + "-" + t;
    },
    track: "slider-track-" + e,
    innerTrack: "slider-filled-track-" + e,
    getMarker: function(t) {
      return "slider-marker-" + e + "-" + t;
    },
    output: "slider-output-" + e
  };
}
function xd(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r === "vertical" ? t : n;
}
var ZE = {
  width: 0,
  height: 0
};
function gj(e) {
  var r = e.orientation, t = e.thumbPercents, n = e.thumbRects, a = e.isReversed, i = function(_) {
    return gr({
      position: "absolute",
      userSelect: "none",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      touchAction: "none"
    }, xd({
      orientation: r,
      vertical: {
        bottom: "calc(" + t[_] + "% - " + n[_].height / 2 + "px)"
      },
      horizontal: {
        left: "calc(" + t[_] + "% - " + n[_].width / 2 + "px)"
      }
    }));
  }, l = r === "vertical" ? n.reduce(function(x, _) {
    return x.height > _.height ? x : _;
  }, ZE) : n.reduce(function(x, _) {
    return x.width > _.width ? x : _;
  }, ZE), u = gr({
    position: "relative",
    touchAction: "none",
    WebkitTapHighlightColor: "rgba(0,0,0,0)",
    userSelect: "none",
    outline: 0
  }, xd({
    orientation: r,
    vertical: {
      paddingLeft: l.width / 2,
      paddingRight: l.width / 2
    },
    horizontal: {
      paddingTop: l.height / 2,
      paddingBottom: l.height / 2
    }
  })), c = gr({
    position: "absolute"
  }, xd({
    orientation: r,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      height: "100%"
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      width: "100%"
    }
  })), f = t.length === 1, h = [0, a ? 100 - t[0] : t[0]], p = f ? h : t, g = p[0];
  !f && a && (g = 100 - g);
  var y = Math.abs(p[p.length - 1] - p[0]), S = gr({}, c, xd({
    orientation: r,
    vertical: a ? {
      height: y + "%",
      top: g + "%"
    } : {
      height: y + "%",
      bottom: g + "%"
    },
    horizontal: a ? {
      width: y + "%",
      right: g + "%"
    } : {
      width: y + "%",
      left: g + "%"
    }
  }));
  return {
    trackStyle: c,
    innerTrackStyle: S,
    rootStyle: u,
    getThumbStyle: i
  };
}
function mj(e) {
  var r = e.isReversed, t = e.direction, n = e.orientation;
  return t === "ltr" || n === "vertical" ? r : !r;
}
var Gde = ["min", "max", "onChange", "value", "defaultValue", "isReversed", "direction", "orientation", "id", "isDisabled", "isReadOnly", "onChangeStart", "onChangeEnd", "step", "getAriaValueText", "aria-valuetext", "aria-label", "aria-labelledby", "name", "focusThumbOnChange", "minStepsBetweenThumbs"], Yde = ["index"], Kde = ["value"], Zde = ["index"];
function qde(e) {
  var r = e.min, t = r === void 0 ? 0 : r, n = e.max, a = n === void 0 ? 100 : n, i = e.onChange, l = e.value, u = e.defaultValue, c = e.isReversed, f = e.direction, h = f === void 0 ? "ltr" : f, p = e.orientation, g = p === void 0 ? "horizontal" : p, y = e.id, S = e.isDisabled, x = e.isReadOnly, _ = e.onChangeStart, A = e.onChangeEnd, O = e.step, P = O === void 0 ? 1 : O, j = e.getAriaValueText, k = e["aria-valuetext"], L = e["aria-label"], M = e["aria-labelledby"], W = e.name, Z = e.focusThumbOnChange, oe = Z === void 0 ? !0 : Z, Ie = e.minStepsBetweenThumbs, Te = Ie === void 0 ? 0 : Ie, Ee = Ul(e, Gde), Me = Di(_), Fe = Di(A), Ge = Di(j), ze = mj({
    isReversed: c,
    direction: h,
    orientation: g
  }), le = yk({
    value: l,
    defaultValue: u != null ? u : [25, 75],
    onChange: i
  }), ce = le[0], he = le[1];
  if (!Array.isArray(ce))
    throw new TypeError("[range-slider] You passed an invalid value for `value` or `defaultValue`, expected `Array` but got `" + typeof ce + "`");
  var be = S0(), ye = be[0], q = be[1], ae = S0(), ue = ae[0], $e = ae[1], Ze = Ye(-1), _e = Ze[0], or = Ze[1], Yr = Qe(null), mr = !(S || x), rt = Qe(ce), Je = ce.map(function(xe) {
    return Dd(xe, t, a);
  }), Ir = $k(Je), wt = Te * P, Kr = Qde(Je, t, a, wt), jr = Je.map(function(xe) {
    return a - xe + t;
  }), jt = ze ? jr : Je, gt = jt.map(function(xe) {
    return p0(xe, t, a);
  }), pr = g === "vertical", br = Ye(Array.from({
    length: Je.length
  }).map(function() {
    return {
      width: 0,
      height: 0
    };
  })), G = br[0], te = br[1];
  ar(function() {
    var xe;
    if (Q.current) {
      var Ae = Array.from((xe = Q.current) == null ? void 0 : xe.querySelectorAll("[role=slider]")), Se = Ae.map(function(Pe) {
        return {
          width: Pe.offsetWidth,
          height: Pe.offsetHeight
        };
      });
      Se.length && te(Se);
    }
  }, []);
  var Y = Qe(null), Q = Qe(null), Ce = Sk(y), me = Hde(Ce), Re = Ne(function(xe) {
    var Ae, Se;
    if (Y.current) {
      Yr.current = "pointer";
      var Pe = Y.current.getBoundingClientRect(), rr = (Ae = (Se = xe.touches) == null ? void 0 : Se[0]) != null ? Ae : xe, Vr = rr.clientX, Zt = rr.clientY, qt = pr ? Pe.bottom - Zt : Vr - Pe.left, Or = pr ? Pe.height : Pe.width, Za = qt / Or;
      return ze && (Za = 1 - Za), sk(Za, t, a);
    }
  }, [pr, ze, a, t]), ur = (a - t) / 10, Sr = P || (a - t) / 100, lr = Rt(function() {
    return {
      setValueAtIndex: function(Ae, Se) {
        if (mr) {
          var Pe = Kr[Ae];
          Se = parseFloat(sx(Se, Pe.min, Sr)), Se = Dd(Se, Pe.min, Pe.max);
          var rr = [].concat(Je);
          rr[Ae] = Se, he(rr);
        }
      },
      setActiveIndex: or,
      stepUp: function(Ae, Se) {
        Se === void 0 && (Se = Sr);
        var Pe = Je[Ae], rr = ze ? Pe - Se : Pe + Se;
        lr.setValueAtIndex(Ae, rr);
      },
      stepDown: function(Ae, Se) {
        Se === void 0 && (Se = Sr);
        var Pe = Je[Ae], rr = ze ? Pe + Se : Pe - Se;
        lr.setValueAtIndex(Ae, rr);
      },
      reset: function() {
        return he(rt.current);
      }
    };
  }, [Sr, Je, ze, he, mr, Kr]), ct = Ne(function(xe) {
    var Ae = nk(xe), Se = {
      ArrowRight: function() {
        return lr.stepUp(_e);
      },
      ArrowUp: function() {
        return lr.stepUp(_e);
      },
      ArrowLeft: function() {
        return lr.stepDown(_e);
      },
      ArrowDown: function() {
        return lr.stepDown(_e);
      },
      PageUp: function() {
        return lr.stepUp(_e, ur);
      },
      PageDown: function() {
        return lr.stepDown(_e, ur);
      },
      Home: function() {
        var Vr = Kr[_e].min;
        lr.setValueAtIndex(_e, Vr);
      },
      End: function() {
        var Vr = Kr[_e].max;
        lr.setValueAtIndex(_e, Vr);
      }
    }, Pe = Se[Ae];
    Pe && (xe.preventDefault(), xe.stopPropagation(), Pe(xe), Yr.current = "keyboard");
  }, [lr, _e, ur, Kr]), at = Rt(function() {
    return gj({
      isReversed: ze,
      orientation: g,
      thumbRects: G,
      thumbPercents: gt
    });
  }, [ze, g, gt, G]), mt = at.getThumbStyle, Ct = at.rootStyle, dr = at.trackStyle, Zr = at.innerTrackStyle, cn = Ne(function(xe) {
    var Ae = xe != null ? xe : _e;
    if (Ae !== -1 && oe) {
      var Se, Pe = me.getThumb(Ae), rr = (Se = Q.current) == null ? void 0 : Se.ownerDocument.getElementById(Pe);
      rr && setTimeout(function() {
        return ik(rr);
      });
    }
  }, [oe, _e, me]);
  xk(function() {
    Yr.current === "keyboard" && (Fe == null || Fe(Ir.current));
  }, [Je, Fe]);
  var dn = function(Ae) {
    var Se = Re(Ae) || 0, Pe = Je.map(function(Or) {
      return Math.abs(Or - Se);
    }), rr = Math.min.apply(Math, Pe), Vr = Pe.indexOf(rr), Zt = Pe.filter(function(Or) {
      return Or === rr;
    }), qt = Zt.length > 1;
    qt && Se > Je[Vr] && (Vr = Vr + Zt.length - 1), or(Vr), lr.setValueAtIndex(Vr, Se), cn(Vr);
  }, Ka = function(Ae) {
    if (_e != -1) {
      var Se = Re(Ae) || 0;
      or(_e), lr.setValueAtIndex(_e, Se), cn(_e);
    }
  };
  wk(Q, {
    onPanSessionStart: function(Ae) {
      mr && (q.on(), dn(Ae), Me == null || Me(Ir.current));
    },
    onPanSessionEnd: function() {
      mr && (q.off(), Fe == null || Fe(Ir.current));
    },
    onPan: function(Ae) {
      mr && Ka(Ae);
    }
  });
  var wn = Ne(function(xe, Ae) {
    return xe === void 0 && (xe = {}), Ae === void 0 && (Ae = null), gr({}, xe, Ee, {
      id: me.root,
      ref: Ld(Ae, Q),
      tabIndex: -1,
      "aria-disabled": sc(S),
      "data-focused": La(ue),
      style: gr({}, xe.style, Ct)
    });
  }, [Ee, S, ue, Ct, me]), pe = Ne(function(xe, Ae) {
    return xe === void 0 && (xe = {}), Ae === void 0 && (Ae = null), gr({}, xe, {
      ref: Ld(Ae, Y),
      id: me.track,
      "data-disabled": La(S),
      style: gr({}, xe.style, dr)
    });
  }, [S, dr, me]), je = Ne(function(xe, Ae) {
    return xe === void 0 && (xe = {}), Ae === void 0 && (Ae = null), gr({}, xe, {
      ref: Ae,
      id: me.innerTrack,
      style: gr({}, xe.style, Zr)
    });
  }, [Zr, me]), er = Ne(function(xe, Ae) {
    var Se;
    Ae === void 0 && (Ae = null);
    var Pe = xe.index, rr = Ul(xe, Yde), Vr = Je[Pe];
    if (Vr == null)
      throw new TypeError("[range-slider > thumb] Cannot find value at index `" + Pe + "`. The `value` or `defaultValue` length is : " + Je.length);
    var Zt = Kr[Pe];
    return gr({}, rr, {
      ref: Ae,
      role: "slider",
      tabIndex: mr ? 0 : void 0,
      id: me.getThumb(Pe),
      "data-active": La(ye && _e === Pe),
      "aria-valuetext": (Se = Ge == null ? void 0 : Ge(Vr)) != null ? Se : k == null ? void 0 : k[Pe],
      "aria-valuemin": Zt.min,
      "aria-valuemax": Zt.max,
      "aria-valuenow": Vr,
      "aria-orientation": g,
      "aria-disabled": sc(S),
      "aria-readonly": sc(x),
      "aria-label": L == null ? void 0 : L[Pe],
      "aria-labelledby": L != null && L[Pe] || M == null ? void 0 : M[Pe],
      style: gr({}, xe.style, mt(Pe)),
      onKeyDown: lc(xe.onKeyDown, ct),
      onFocus: lc(xe.onFocus, function() {
        $e.on(), or(Pe);
      }),
      onBlur: lc(xe.onBlur, function() {
        $e.off(), or(-1);
      })
    });
  }, [me, Je, Kr, mr, ye, _e, Ge, k, g, S, x, L, M, mt, ct, $e]), Dt = Ne(function(xe, Ae) {
    return xe === void 0 && (xe = {}), Ae === void 0 && (Ae = null), gr({}, xe, {
      ref: Ae,
      id: me.output,
      htmlFor: Je.map(function(Se, Pe) {
        return me.getThumb(Pe);
      }).join(" "),
      "aria-live": "off"
    });
  }, [me, Je]), ot = Ne(function(xe, Ae) {
    xe === void 0 && (xe = {}), Ae === void 0 && (Ae = null);
    var Se = xe, Pe = Se.value, rr = Ul(Se, Kde), Vr = !(Pe < t || Pe > a), Zt = Pe >= Je[0] && Pe <= Je[Je.length - 1], qt = p0(Pe, t, a);
    qt = ze ? 100 - qt : qt;
    var Or = gr({
      position: "absolute",
      pointerEvents: "none"
    }, xd({
      orientation: g,
      vertical: {
        bottom: qt + "%"
      },
      horizontal: {
        left: qt + "%"
      }
    }));
    return gr({}, rr, {
      ref: Ae,
      id: me.getMarker(xe.value),
      role: "presentation",
      "aria-hidden": !0,
      "data-disabled": La(S),
      "data-invalid": La(!Vr),
      "data-highlighted": La(Zt),
      style: gr({}, xe.style, Or)
    });
  }, [S, ze, a, t, g, Je, me]), Dn = Ne(function(xe, Ae) {
    Ae === void 0 && (Ae = null);
    var Se = xe.index, Pe = Ul(xe, Zde);
    return gr({}, Pe, {
      ref: Ae,
      id: me.getInput(Se),
      type: "hidden",
      value: Je[Se],
      name: Array.isArray(W) ? W[Se] : W + "-" + Se
    });
  }, [W, Je, me]);
  return {
    state: {
      value: Je,
      isFocused: ue,
      isDragging: ye,
      getThumbPercent: function(Ae) {
        return gt[Ae];
      },
      getThumbMinValue: function(Ae) {
        return Kr[Ae].min;
      },
      getThumbMaxValue: function(Ae) {
        return Kr[Ae].max;
      }
    },
    actions: lr,
    getRootProps: wn,
    getTrackProps: pe,
    getInnerTrackProps: je,
    getThumbProps: er,
    getMarkerProps: ot,
    getInputProps: Dn,
    getOutputProps: Dt
  };
}
var Qde = function(r, t, n, a) {
  return r.map(function(i, l) {
    var u = l === 0 ? t : r[l - 1] + a, c = l === r.length - 1 ? n : r[l + 1] - a;
    return {
      min: u,
      max: c
    };
  });
}, Xde = ["getRootProps"], Jde = lu({
  name: "SliderContext",
  errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <RangeSlider />"
}), efe = Jde[0], rfe = /* @__PURE__ */ Rg(function(e, r) {
  var t = tw("Slider", e), n = ew(e), a = X$(), i = a.direction;
  n.direction = i;
  var l = qde(n), u = l.getRootProps, c = Ul(l, Xde), f = I.useMemo(function() {
    return gr({}, c, {
      name: e.name
    });
  }, [c, e.name]);
  return /* @__PURE__ */ I.createElement(efe, {
    value: f
  }, /* @__PURE__ */ I.createElement(J$, {
    value: t
  }, /* @__PURE__ */ I.createElement(ma.div, gr({}, u({}, r), {
    className: "chakra-slider",
    __css: t.container
  }), e.children)));
});
rfe.defaultProps = {
  orientation: "horizontal"
};
var tfe = ["min", "max", "onChange", "value", "defaultValue", "isReversed", "direction", "orientation", "id", "isDisabled", "isReadOnly", "onChangeStart", "onChangeEnd", "step", "getAriaValueText", "aria-valuetext", "aria-label", "aria-labelledby", "name", "focusThumbOnChange"];
function nfe(e) {
  var r, t = e.min, n = t === void 0 ? 0 : t, a = e.max, i = a === void 0 ? 100 : a, l = e.onChange, u = e.value, c = e.defaultValue, f = e.isReversed, h = e.direction, p = h === void 0 ? "ltr" : h, g = e.orientation, y = g === void 0 ? "horizontal" : g, S = e.id, x = e.isDisabled, _ = e.isReadOnly, A = e.onChangeStart, O = e.onChangeEnd, P = e.step, j = P === void 0 ? 1 : P, k = e.getAriaValueText, L = e["aria-valuetext"], M = e["aria-label"], W = e["aria-labelledby"], Z = e.name, oe = e.focusThumbOnChange, Ie = oe === void 0 ? !0 : oe, Te = Ul(e, tfe), Ee = Di(A), Me = Di(O), Fe = Di(k), Ge = mj({
    isReversed: f,
    direction: p,
    orientation: y
  }), ze = yk({
    value: u,
    defaultValue: c != null ? c : ofe(n, i),
    onChange: l
  }), le = ze[0], ce = ze[1], he = S0(), be = he[0], ye = he[1], q = S0(), ae = q[0], ue = q[1], $e = Qe(null), Ze = !(x || _), _e = Dd(le, n, i), or = $k(_e), Yr = Qe(or.current), mr = i - _e + n, rt = Ge ? mr : _e, Je = p0(rt, n, i), Ir = y === "vertical", wt = Qe(null), Kr = Qe(null), jr = Qe(null), jt = Ele(S, "slider-thumb", "slider-track"), gt = jt[0], pr = jt[1], br = Ne(function(pe) {
    var je, er;
    if (wt.current) {
      $e.current = "pointer";
      var Dt = HP(wt.current).borderBox, ot = (je = (er = pe.touches) == null ? void 0 : er[0]) != null ? je : pe, Dn = ot.clientX, xe = ot.clientY, Ae = Ir ? Dt.bottom - xe : Dn - Dt.left, Se = Ir ? Dt.height : Dt.width, Pe = Ae / Se;
      Ge && (Pe = 1 - Pe);
      var rr = sk(Pe, n, i);
      return j && (rr = parseFloat(sx(rr, n, j))), rr = Dd(rr, n, i), rr;
    }
  }, [Ir, Ge, i, n, j]), G = (i - n) / 10, te = j || (i - n) / 100, Y = Ne(function(pe) {
    Ze && (pe = parseFloat(sx(pe, n, te)), pe = Dd(pe, n, i), ce(pe));
  }, [te, i, n, ce, Ze]), Q = Rt(function() {
    return {
      stepUp: function(je) {
        je === void 0 && (je = te);
        var er = Ge ? _e - je : _e + je;
        Y(er);
      },
      stepDown: function(je) {
        je === void 0 && (je = te);
        var er = Ge ? _e + je : _e - je;
        Y(er);
      },
      reset: function() {
        return Y(c || 0);
      },
      stepTo: function(je) {
        return Y(je);
      }
    };
  }, [Y, Ge, _e, te, c]), Ce = Ne(function(pe) {
    var je = nk(pe), er = {
      ArrowRight: function() {
        return Q.stepUp();
      },
      ArrowUp: function() {
        return Q.stepUp();
      },
      ArrowLeft: function() {
        return Q.stepDown();
      },
      ArrowDown: function() {
        return Q.stepDown();
      },
      PageUp: function() {
        return Q.stepUp(G);
      },
      PageDown: function() {
        return Q.stepDown(G);
      },
      Home: function() {
        return Y(n);
      },
      End: function() {
        return Y(i);
      }
    }, Dt = er[je];
    Dt && (pe.preventDefault(), pe.stopPropagation(), Dt(pe), $e.current = "keyboard");
  }, [Q, Y, i, n, G]), me = (r = Fe == null ? void 0 : Fe(_e)) != null ? r : L, Re = wle(Kr), ur = Rt(function() {
    var pe, je = (pe = Re == null ? void 0 : Re.borderBox) != null ? pe : {
      width: 0,
      height: 0
    };
    return gj({
      isReversed: Ge,
      orientation: y,
      thumbRects: [je],
      thumbPercents: [Je]
    });
  }, [Ge, y, Re == null ? void 0 : Re.borderBox, Je]), Sr = ur.getThumbStyle, lr = ur.rootStyle, ct = ur.trackStyle, at = ur.innerTrackStyle, mt = Ne(function() {
    Kr.current && Ie && setTimeout(function() {
      return ik(Kr.current);
    });
  }, [Ie]);
  xk(function() {
    mt(), $e.current === "keyboard" && (Me == null || Me(or.current));
  }, [_e, Me]);
  var Ct = function(je) {
    var er = br(je);
    er != null && er !== or.current && ce(er);
  };
  wk(jr, {
    onPanSessionStart: function(je) {
      Ze && (ye.on(), mt(), Ct(je), Ee == null || Ee(or.current));
    },
    onPanSessionEnd: function() {
      Ze && (ye.off(), Me == null || Me(or.current), Yr.current = or.current);
    },
    onPan: function(je) {
      Ze && Ct(je);
    }
  });
  var dr = Ne(function(pe, je) {
    return pe === void 0 && (pe = {}), je === void 0 && (je = null), gr({}, pe, Te, {
      ref: Ld(je, jr),
      tabIndex: -1,
      "aria-disabled": sc(x),
      "data-focused": La(ae),
      style: gr({}, pe.style, lr)
    });
  }, [Te, x, ae, lr]), Zr = Ne(function(pe, je) {
    return pe === void 0 && (pe = {}), je === void 0 && (je = null), gr({}, pe, {
      ref: Ld(je, wt),
      id: pr,
      "data-disabled": La(x),
      style: gr({}, pe.style, ct)
    });
  }, [x, pr, ct]), cn = Ne(function(pe, je) {
    return pe === void 0 && (pe = {}), je === void 0 && (je = null), gr({}, pe, {
      ref: je,
      style: gr({}, pe.style, at)
    });
  }, [at]), dn = Ne(function(pe, je) {
    return pe === void 0 && (pe = {}), je === void 0 && (je = null), gr({}, pe, {
      ref: Ld(je, Kr),
      role: "slider",
      tabIndex: Ze ? 0 : void 0,
      id: gt,
      "data-active": La(be),
      "aria-valuetext": me,
      "aria-valuemin": n,
      "aria-valuemax": i,
      "aria-valuenow": _e,
      "aria-orientation": y,
      "aria-disabled": sc(x),
      "aria-readonly": sc(_),
      "aria-label": M,
      "aria-labelledby": M ? void 0 : W,
      style: gr({}, pe.style, Sr(0)),
      onKeyDown: lc(pe.onKeyDown, Ce),
      onFocus: lc(pe.onFocus, ue.on),
      onBlur: lc(pe.onBlur, ue.off)
    });
  }, [Ze, gt, be, me, n, i, _e, y, x, _, M, W, Sr, Ce, ue.on, ue.off]), Ka = Ne(function(pe, je) {
    pe === void 0 && (pe = {}), je === void 0 && (je = null);
    var er = !(pe.value < n || pe.value > i), Dt = _e >= pe.value, ot = p0(pe.value, n, i), Dn = gr({
      position: "absolute",
      pointerEvents: "none"
    }, afe({
      orientation: y,
      vertical: {
        bottom: Ge ? 100 - ot + "%" : ot + "%"
      },
      horizontal: {
        left: Ge ? 100 - ot + "%" : ot + "%"
      }
    }));
    return gr({}, pe, {
      ref: je,
      role: "presentation",
      "aria-hidden": !0,
      "data-disabled": La(x),
      "data-invalid": La(!er),
      "data-highlighted": La(Dt),
      style: gr({}, pe.style, Dn)
    });
  }, [x, Ge, i, n, y, _e]), wn = Ne(function(pe, je) {
    return pe === void 0 && (pe = {}), je === void 0 && (je = null), gr({}, pe, {
      ref: je,
      type: "hidden",
      value: _e,
      name: Z
    });
  }, [Z, _e]);
  return {
    state: {
      value: _e,
      isFocused: ae,
      isDragging: be
    },
    actions: Q,
    getRootProps: dr,
    getTrackProps: Zr,
    getInnerTrackProps: cn,
    getThumbProps: dn,
    getMarkerProps: Ka,
    getInputProps: wn
  };
}
function afe(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r === "vertical" ? t : n;
}
function ofe(e, r) {
  return r < e ? e : e + (r - e) / 2;
}
var ife = ["getInputProps", "getRootProps"], sfe = lu({
  name: "SliderContext",
  errorMessage: "useSliderContext: `context` is undefined. Seems you forgot to wrap all slider components within <Slider />"
}), lfe = sfe[0], ufe = /* @__PURE__ */ Rg(function(e, r) {
  var t = tw("Slider", e), n = ew(e), a = X$(), i = a.direction;
  n.direction = i;
  var l = nfe(n), u = l.getInputProps, c = l.getRootProps, f = Ul(l, ife), h = c(), p = u({}, r);
  return /* @__PURE__ */ I.createElement(lfe, {
    value: f
  }, /* @__PURE__ */ I.createElement(J$, {
    value: t
  }, /* @__PURE__ */ I.createElement(ma.div, gr({}, h, {
    className: Z$("chakra-slider", e.className),
    __css: t.container
  }), e.children, /* @__PURE__ */ I.createElement("input", p))));
});
ufe.defaultProps = {
  orientation: "horizontal"
};
var cfe = qn, dfe = cfe("toStringTag"), bj = {};
bj[dfe] = "z";
var ffe = String(bj) === "[object z]", vfe = ffe, hfe = Mt, Op = wg, pfe = qn, gfe = pfe("toStringTag"), mfe = Object, bfe = Op(function() {
  return arguments;
}()) == "Arguments", yfe = function(e, r) {
  try {
    return e[r];
  } catch (t) {
  }
}, mw = vfe ? Op : function(e) {
  var r, t, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = yfe(r = mfe(e), gfe)) == "string" ? t : bfe ? Op(r) : (n = Op(r)) == "Object" && hfe(r.callee) ? "Arguments" : n;
}, Sfe = mw, xfe = String, yj = function(e) {
  if (Sfe(e) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return xfe(e);
}, qE = P$.exports, $fe = zi, Sj = function(e, r, t) {
  return t.get && qE(t.get, r, { getter: !0 }), t.set && qE(t.set, r, { setter: !0 }), $fe.f(e, r, t);
}, wfe = oi, _fe = Ha, Tfe = un, wh = Pn, Cfe = Ga, Efe = Mt, Afe = Gf, Ife = yj, Ofe = Sj, Mfe = UP, Mi = Tfe.Symbol, _l = Mi && Mi.prototype;
if (_fe && Efe(Mi) && (!("description" in _l) || // Safari 12 bug
Mi().description !== void 0)) {
  var QE = {}, _h = function() {
    var r = arguments.length < 1 || arguments[0] === void 0 ? void 0 : Ife(arguments[0]), t = Afe(_l, this) ? new Mi(r) : r === void 0 ? Mi() : Mi(r);
    return r === "" && (QE[t] = !0), t;
  };
  Mfe(_h, Mi), _h.prototype = _l, _l.constructor = _h;
  var Rfe = String(Mi("test")) == "Symbol(test)", Pfe = wh(_l.valueOf), kfe = wh(_l.toString), jfe = /^Symbol\((.*)\)[^)]+$/, Dfe = wh("".replace), Nfe = wh("".slice);
  Ofe(_l, "description", {
    configurable: !0,
    get: function() {
      var r = Pfe(this);
      if (Cfe(QE, r))
        return "";
      var t = kfe(r), n = Rfe ? Nfe(t, 7, -1) : Dfe(t, jfe, "$1");
      return n === "" ? void 0 : n;
    }
  }), wfe({ global: !0, constructor: !0, forced: !0 }, {
    Symbol: _h
  });
}
const Lfe = /* @__PURE__ */ I.createContext({
  activeStep: 0
}), Ffe = ({
  value: e,
  children: r
}) => {
  const [t, n] = I.useState([]), a = e.state === "error", i = e.state === "loading", l = e.orientation === "vertical", u = e.orientation !== "vertical" && e.labelOrientation === "vertical";
  return qS(Lfe.Provider, Object.assign({
    value: Object.assign(Object.assign({}, e), {
      widths: t,
      setWidths: n,
      isError: a,
      isLoading: i,
      isVertical: l,
      isLabelVertical: u
    })
  }, {
    children: r
  }));
};
function sn(e, r) {
  zfe(e) && (e = "100%");
  var t = Bfe(e);
  return e = r === 360 ? e : Math.min(r, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * r), 10) / 100), Math.abs(e - r) < 1e-6 ? 1 : (r === 360 ? e = (e < 0 ? e % r + r : e % r) / parseFloat(String(r)) : e = e % r / parseFloat(String(r)), e);
}
function Th(e) {
  return Math.min(1, Math.max(0, e));
}
function zfe(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function Bfe(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function xj(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ch(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Vl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function Ufe(e, r, t) {
  return {
    r: sn(e, 255) * 255,
    g: sn(r, 255) * 255,
    b: sn(t, 255) * 255
  };
}
function XE(e, r, t) {
  e = sn(e, 255), r = sn(r, 255), t = sn(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = 0, u = (n + a) / 2;
  if (n === a)
    l = 0, i = 0;
  else {
    var c = n - a;
    switch (l = u > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
      case e:
        i = (r - t) / c + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / c + 2;
        break;
      case t:
        i = (e - r) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, l: u };
}
function B1(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * (6 * t) : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function Vfe(e, r, t) {
  var n, a, i;
  if (e = sn(e, 360), r = sn(r, 100), t = sn(t, 100), r === 0)
    a = t, i = t, n = t;
  else {
    var l = t < 0.5 ? t * (1 + r) : t + r - t * r, u = 2 * t - l;
    n = B1(u, l, e + 1 / 3), a = B1(u, l, e), i = B1(u, l, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function JE(e, r, t) {
  e = sn(e, 255), r = sn(r, 255), t = sn(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = n, u = n - a, c = n === 0 ? 0 : u / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (r - t) / u + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / u + 2;
        break;
      case t:
        i = (e - r) / u + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: l };
}
function Wfe(e, r, t) {
  e = sn(e, 360) * 6, r = sn(r, 100), t = sn(t, 100);
  var n = Math.floor(e), a = e - n, i = t * (1 - r), l = t * (1 - a * r), u = t * (1 - (1 - a) * r), c = n % 6, f = [t, l, i, i, u, t][c], h = [u, t, t, l, i, i][c], p = [i, i, u, t, t, l][c];
  return { r: f * 255, g: h * 255, b: p * 255 };
}
function eA(e, r, t, n) {
  var a = [
    Vl(Math.round(e).toString(16)),
    Vl(Math.round(r).toString(16)),
    Vl(Math.round(t).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function Hfe(e, r, t, n, a) {
  var i = [
    Vl(Math.round(e).toString(16)),
    Vl(Math.round(r).toString(16)),
    Vl(Math.round(t).toString(16)),
    Vl(Gfe(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function Gfe(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function rA(e) {
  return ca(e) / 255;
}
function ca(e) {
  return parseInt(e, 16);
}
function Yfe(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var Ax = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function Kfe(e) {
  var r = { r: 0, g: 0, b: 0 }, t = 1, n = null, a = null, i = null, l = !1, u = !1;
  return typeof e == "string" && (e = Qfe(e)), typeof e == "object" && (Ai(e.r) && Ai(e.g) && Ai(e.b) ? (r = Ufe(e.r, e.g, e.b), l = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Ai(e.h) && Ai(e.s) && Ai(e.v) ? (n = Ch(e.s), a = Ch(e.v), r = Wfe(e.h, n, a), l = !0, u = "hsv") : Ai(e.h) && Ai(e.s) && Ai(e.l) && (n = Ch(e.s), i = Ch(e.l), r = Vfe(e.h, n, i), l = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = xj(t), {
    ok: l,
    format: e.format || u,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a: t
  };
}
var Zfe = "[-\\+]?\\d+%?", qfe = "[-\\+]?\\d*\\.\\d+%?", Os = "(?:".concat(qfe, ")|(?:").concat(Zfe, ")"), U1 = "[\\s|\\(]+(".concat(Os, ")[,|\\s]+(").concat(Os, ")[,|\\s]+(").concat(Os, ")\\s*\\)?"), V1 = "[\\s|\\(]+(".concat(Os, ")[,|\\s]+(").concat(Os, ")[,|\\s]+(").concat(Os, ")[,|\\s]+(").concat(Os, ")\\s*\\)?"), fo = {
  CSS_UNIT: new RegExp(Os),
  rgb: new RegExp("rgb" + U1),
  rgba: new RegExp("rgba" + V1),
  hsl: new RegExp("hsl" + U1),
  hsla: new RegExp("hsla" + V1),
  hsv: new RegExp("hsv" + U1),
  hsva: new RegExp("hsva" + V1),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function Qfe(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var r = !1;
  if (Ax[e])
    e = Ax[e], r = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = fo.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = fo.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = fo.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = fo.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = fo.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = fo.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = fo.hex8.exec(e), t ? {
    r: ca(t[1]),
    g: ca(t[2]),
    b: ca(t[3]),
    a: rA(t[4]),
    format: r ? "name" : "hex8"
  } : (t = fo.hex6.exec(e), t ? {
    r: ca(t[1]),
    g: ca(t[2]),
    b: ca(t[3]),
    format: r ? "name" : "hex"
  } : (t = fo.hex4.exec(e), t ? {
    r: ca(t[1] + t[1]),
    g: ca(t[2] + t[2]),
    b: ca(t[3] + t[3]),
    a: rA(t[4] + t[4]),
    format: r ? "name" : "hex8"
  } : (t = fo.hex3.exec(e), t ? {
    r: ca(t[1] + t[1]),
    g: ca(t[2] + t[2]),
    b: ca(t[3] + t[3]),
    format: r ? "name" : "hex"
  } : !1)))))))));
}
function Ai(e) {
  return !!fo.CSS_UNIT.exec(String(e));
}
var Wg = (
  /** @class */
  function() {
    function e(r, t) {
      r === void 0 && (r = ""), t === void 0 && (t = {});
      var n;
      if (r instanceof e)
        return r;
      typeof r == "number" && (r = Yfe(r)), this.originalInput = r;
      var a = Kfe(r);
      this.originalInput = r, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = t.format) !== null && n !== void 0 ? n : a.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var r = this.toRgb();
      return (r.r * 299 + r.g * 587 + r.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var r = this.toRgb(), t, n, a, i = r.r / 255, l = r.g / 255, u = r.b / 255;
      return i <= 0.03928 ? t = i / 12.92 : t = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? n = l / 12.92 : n = Math.pow((l + 0.055) / 1.055, 2.4), u <= 0.03928 ? a = u / 12.92 : a = Math.pow((u + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(r) {
      return this.a = xj(r), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var r = this.toHsl().s;
      return r === 0;
    }, e.prototype.toHsv = function() {
      var r = JE(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, v: r.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var r = JE(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.v * 100);
      return this.a === 1 ? "hsv(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var r = XE(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, l: r.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var r = XE(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.l * 100);
      return this.a === 1 ? "hsl(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(r) {
      return r === void 0 && (r = !1), eA(this.r, this.g, this.b, r);
    }, e.prototype.toHexString = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex(r);
    }, e.prototype.toHex8 = function(r) {
      return r === void 0 && (r = !1), Hfe(this.r, this.g, this.b, this.a, r);
    }, e.prototype.toHex8String = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex8(r);
    }, e.prototype.toHexShortString = function(r) {
      return r === void 0 && (r = !1), this.a === 1 ? this.toHexString(r) : this.toHex8String(r);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var r = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(r, ", ").concat(t, ", ").concat(n, ")") : "rgba(".concat(r, ", ").concat(t, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var r = function(t) {
        return "".concat(Math.round(sn(t, 255) * 100), "%");
      };
      return {
        r: r(this.r),
        g: r(this.g),
        b: r(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var r = function(t) {
        return Math.round(sn(t, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%)") : "rgba(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var r = "#" + eA(this.r, this.g, this.b, !1), t = 0, n = Object.entries(Ax); t < n.length; t++) {
        var a = n[t], i = a[0], l = a[1];
        if (r === l)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(r) {
      var t = !!r;
      r = r != null ? r : this.format;
      var n = !1, a = this.a < 1 && this.a >= 0, i = !t && a && (r.startsWith("hex") || r === "name");
      return i ? r === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (r === "rgb" && (n = this.toRgbString()), r === "prgb" && (n = this.toPercentageRgbString()), (r === "hex" || r === "hex6") && (n = this.toHexString()), r === "hex3" && (n = this.toHexString(!0)), r === "hex4" && (n = this.toHex8String(!0)), r === "hex8" && (n = this.toHex8String()), r === "name" && (n = this.toName()), r === "hsl" && (n = this.toHslString()), r === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l += r / 100, t.l = Th(t.l), new e(t);
    }, e.prototype.brighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toRgb();
      return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(r / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(r / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(r / 100)))), new e(t);
    }, e.prototype.darken = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l -= r / 100, t.l = Th(t.l), new e(t);
    }, e.prototype.tint = function(r) {
      return r === void 0 && (r = 10), this.mix("white", r);
    }, e.prototype.shade = function(r) {
      return r === void 0 && (r = 10), this.mix("black", r);
    }, e.prototype.desaturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s -= r / 100, t.s = Th(t.s), new e(t);
    }, e.prototype.saturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s += r / 100, t.s = Th(t.s), new e(t);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(r) {
      var t = this.toHsl(), n = (t.h + r) % 360;
      return t.h = n < 0 ? 360 + n : n, new e(t);
    }, e.prototype.mix = function(r, t) {
      t === void 0 && (t = 50);
      var n = this.toRgb(), a = new e(r).toRgb(), i = t / 100, l = {
        r: (a.r - n.r) * i + n.r,
        g: (a.g - n.g) * i + n.g,
        b: (a.b - n.b) * i + n.b,
        a: (a.a - n.a) * i + n.a
      };
      return new e(l);
    }, e.prototype.analogous = function(r, t) {
      r === void 0 && (r = 6), t === void 0 && (t = 30);
      var n = this.toHsl(), a = 360 / t, i = [this];
      for (n.h = (n.h - (a * r >> 1) + 720) % 360; --r; )
        n.h = (n.h + a) % 360, i.push(new e(n));
      return i;
    }, e.prototype.complement = function() {
      var r = this.toHsl();
      return r.h = (r.h + 180) % 360, new e(r);
    }, e.prototype.monochromatic = function(r) {
      r === void 0 && (r = 6);
      for (var t = this.toHsv(), n = t.h, a = t.s, i = t.v, l = [], u = 1 / r; r--; )
        l.push(new e({ h: n, s: a, v: i })), i = (i + u) % 1;
      return l;
    }, e.prototype.splitcomplement = function() {
      var r = this.toHsl(), t = r.h;
      return [
        this,
        new e({ h: (t + 72) % 360, s: r.s, l: r.l }),
        new e({ h: (t + 216) % 360, s: r.s, l: r.l })
      ];
    }, e.prototype.onBackground = function(r) {
      var t = this.toRgb(), n = new e(r).toRgb(), a = t.a + n.a * (1 - t.a);
      return new e({
        r: (t.r * t.a + n.r * n.a * (1 - t.a)) / a,
        g: (t.g * t.a + n.g * n.a * (1 - t.a)) / a,
        b: (t.b * t.a + n.b * n.a * (1 - t.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(r) {
      for (var t = this.toHsl(), n = t.h, a = [this], i = 360 / r, l = 1; l < r; l++)
        a.push(new e({ h: (n + l * i) % 360, s: t.s, l: t.l }));
      return a;
    }, e.prototype.equals = function(r) {
      return this.toRgbString() === new e(r).toRgbString();
    }, e;
  }()
), kr = function(r, t, n) {
  var a = Y$(r, "colors." + t, t), i = new Wg(a), l = i.isValid;
  return l ? a : n;
}, mc = function(r, t) {
  return function(n) {
    var a = kr(n, r);
    return new Wg(a).setAlpha(t).toRgbString();
  };
}, Xfe = function(r, t) {
  return function(n) {
    var a = kr(n, r);
    return new Wg(a).darken(t).toHexString();
  };
}, Jfe = function(r, t) {
  return function(n) {
    return new Wg(kr(n, r)).lighten(t).toHexString();
  };
};
function Le(e, r) {
  return function(t) {
    return t.colorMode === "dark" ? r : e;
  };
}
function tA(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function eve(e, r, t) {
  return r && tA(e.prototype, r), t && tA(e, t), e;
}
var rve = /* @__PURE__ */ function() {
  function e(r) {
    var t = this;
    this.map = {}, this.called = !1, this.assert = function() {
      if (!t.called) {
        t.called = !0;
        return;
      }
      throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }, this.parts = function() {
      t.assert();
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        t.map[c] = t.toPart(c);
      }
      return t;
    }, this.extend = function() {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        c in t.map || (t.map[c] = t.toPart(c));
      }
      return t;
    }, this.toPart = function(n) {
      var a = ["container", "root"].includes(n != null ? n : "") ? [t.name] : [t.name, n], i = a.filter(Boolean).join("__"), l = "chakra-" + i, u = {
        className: l,
        selector: "." + l,
        toString: function() {
          return n;
        }
      };
      return u;
    }, this.__type = {};
  }
  return eve(e, [{
    key: "selectors",
    get: (
      /**
       * Get all selectors for the component anatomy
       */
      function() {
        var t = fE(Object.entries(this.map).map(function(n) {
          var a = n[0], i = n[1];
          return [a, i.selector];
        }));
        return t;
      }
    )
    /**
     * Get all classNames for the component anatomy
     */
  }, {
    key: "classNames",
    get: function() {
      var t = fE(Object.entries(this.map).map(function(n) {
        var a = n[0], i = n[1];
        return [a, i.className];
      }));
      return t;
    }
    /**
     * Get all parts as array of string
     */
  }, {
    key: "keys",
    get: function() {
      return Object.keys(this.map);
    }
    /**
     * Creates the part object for the given part
     */
  }]), e;
}();
function Hr(e) {
  return new rve(e);
}
function $j(e) {
  return Kl(e) && e.reference ? e.reference : String(e);
}
var Hg = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map($j).join(" " + r + " ").replace(/calc/g, "");
}, nA = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Hg.apply(void 0, ["+"].concat(t)) + ")";
}, aA = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Hg.apply(void 0, ["-"].concat(t)) + ")";
}, Ix = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Hg.apply(void 0, ["*"].concat(t)) + ")";
}, oA = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + Hg.apply(void 0, ["/"].concat(t)) + ")";
}, iA = function(r) {
  var t = $j(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : Ix(t, -1);
}, Rl = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Rl(nA.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Rl(aA.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Rl(Ix.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return Rl(oA.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return Rl(iA(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: nA,
  subtract: aA,
  multiply: Ix,
  divide: oA,
  negate: iA
});
function tve(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function nve(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function wj(e) {
  var r = nve(e.toString());
  return r.includes("\\.") ? e : tve(e) ? r.replace(".", "\\.") : e;
}
function ave(e, r) {
  return r === void 0 && (r = ""), [r, wj(e)].filter(Boolean).join("-");
}
function ove(e, r) {
  return "var(" + wj(e) + (r ? ", " + r : "") + ")";
}
function ive(e, r) {
  return r === void 0 && (r = ""), "--" + ave(e, r);
}
function ii(e, r) {
  var t = ive(e, r == null ? void 0 : r.prefix);
  return {
    variable: t,
    reference: ove(t, sve(r == null ? void 0 : r.fallback))
  };
}
function sve(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
zs(oP);
zs(qte);
zs(ma.span);
var lve = wg, Gg = typeof process != "undefined" && lve(process) == "process", uve = su, cve = Sj, dve = qn, fve = Ha, sA = dve("species"), vve = function(e) {
  var r = uve(e);
  fve && r && !r[sA] && cve(r, sA, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, hve = Gf, pve = TypeError, gve = function(e, r) {
  if (hve(r, e))
    return e;
  throw pve("Incorrect invocation");
}, mve = Pn, bve = Rn, _j = Mt, yve = mw, Sve = su, xve = D$, Tj = function() {
}, $ve = [], Cj = Sve("Reflect", "construct"), bw = /^\s*(?:class|function)\b/, wve = mve(bw.exec), _ve = !bw.exec(Tj), sd = function(r) {
  if (!_j(r))
    return !1;
  try {
    return Cj(Tj, $ve, r), !0;
  } catch (t) {
    return !1;
  }
}, Ej = function(r) {
  if (!_j(r))
    return !1;
  switch (yve(r)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return _ve || !!wve(bw, xve(r));
  } catch (t) {
    return !0;
  }
};
Ej.sham = !0;
var Tve = !Cj || bve(function() {
  var e;
  return sd(sd.call) || !sd(Object) || !sd(function() {
    e = !0;
  }) || e;
}) ? Ej : sd, Cve = Tve, Eve = Cg, Ave = TypeError, Ive = function(e) {
  if (Cve(e))
    return e;
  throw Ave(Eve(e) + " is not a constructor");
}, lA = Ya, Ove = Ive, Mve = _g, Rve = qn, Pve = Rve("species"), kve = function(e, r) {
  var t = lA(e).constructor, n;
  return t === void 0 || Mve(n = lA(t)[Pve]) ? r : Ove(n);
}, jve = $g, Aj = Function.prototype, uA = Aj.apply, cA = Aj.call, Dve = typeof Reflect == "object" && Reflect.apply || (jve ? cA.bind(uA) : function() {
  return cA.apply(uA, arguments);
}), Nve = wg, Lve = Pn, Fve = function(e) {
  if (Nve(e) === "Function")
    return Lve(e);
}, dA = Fve, zve = Us, Bve = $g, Uve = dA(dA.bind), yw = function(e, r) {
  return zve(e), r === void 0 ? e : Bve ? Uve(e, r) : function() {
    return e.apply(r, arguments);
  };
}, Vve = Pn, Wve = Vve([].slice), Hve = TypeError, Gve = function(e, r) {
  if (e < r)
    throw Hve("Not enough arguments");
  return e;
}, Yve = Tg, Ij = /(?:ipad|iphone|ipod).*applewebkit/i.test(Yve), va = un, Kve = Dve, Zve = yw, fA = Mt, qve = Ga, Oj = Rn, vA = ej, Qve = Wve, hA = Eg, Xve = Gve, Jve = Ij, ehe = Gg, Ox = va.setImmediate, Mx = va.clearImmediate, rhe = va.process, W1 = va.Dispatch, the = va.Function, pA = va.MessageChannel, nhe = va.String, H1 = 0, Bd = {}, gA = "onreadystatechange", yf, Tl, G1, Y1;
Oj(function() {
  yf = va.location;
});
var Sw = function(e) {
  if (qve(Bd, e)) {
    var r = Bd[e];
    delete Bd[e], r();
  }
}, K1 = function(e) {
  return function() {
    Sw(e);
  };
}, mA = function(e) {
  Sw(e.data);
}, bA = function(e) {
  va.postMessage(nhe(e), yf.protocol + "//" + yf.host);
};
(!Ox || !Mx) && (Ox = function(r) {
  Xve(arguments.length, 1);
  var t = fA(r) ? r : the(r), n = Qve(arguments, 1);
  return Bd[++H1] = function() {
    Kve(t, void 0, n);
  }, Tl(H1), H1;
}, Mx = function(r) {
  delete Bd[r];
}, ehe ? Tl = function(e) {
  rhe.nextTick(K1(e));
} : W1 && W1.now ? Tl = function(e) {
  W1.now(K1(e));
} : pA && !Jve ? (G1 = new pA(), Y1 = G1.port2, G1.port1.onmessage = mA, Tl = Zve(Y1.postMessage, Y1)) : va.addEventListener && fA(va.postMessage) && !va.importScripts && yf && yf.protocol !== "file:" && !Oj(bA) ? (Tl = bA, va.addEventListener("message", mA, !1)) : gA in hA("script") ? Tl = function(e) {
  vA.appendChild(hA("script"))[gA] = function() {
    vA.removeChild(this), Sw(e);
  };
} : Tl = function(e) {
  setTimeout(K1(e), 0);
});
var Mj = {
  set: Ox,
  clear: Mx
}, Rj = function() {
  this.head = null, this.tail = null;
};
Rj.prototype = {
  add: function(e) {
    var r = { item: e, next: null }, t = this.tail;
    t ? t.next = r : this.head = r, this.tail = r;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var r = this.head = e.next;
      return r === null && (this.tail = null), e.item;
    }
  }
};
var Pj = Rj, ahe = Tg, ohe = /ipad|iphone|ipod/i.test(ahe) && typeof Pebble != "undefined", ihe = Tg, she = /web0s(?!.*chrome)/i.test(ihe), nu = un, yA = yw, lhe = xg.f, Z1 = Mj.set, uhe = Pj, che = Ij, dhe = ohe, fhe = she, q1 = Gg, SA = nu.MutationObserver || nu.WebKitMutationObserver, xA = nu.document, $A = nu.process, Eh = nu.Promise, wA = lhe(nu, "queueMicrotask"), Rx = wA && wA.value, ju, Q1, X1, Ah, _A;
if (!Rx) {
  var Ih = new uhe(), Oh = function() {
    var e, r;
    for (q1 && (e = $A.domain) && e.exit(); r = Ih.get(); )
      try {
        r();
      } catch (t) {
        throw Ih.head && ju(), t;
      }
    e && e.enter();
  };
  !che && !q1 && !fhe && SA && xA ? (Q1 = !0, X1 = xA.createTextNode(""), new SA(Oh).observe(X1, { characterData: !0 }), ju = function() {
    X1.data = Q1 = !Q1;
  }) : !dhe && Eh && Eh.resolve ? (Ah = Eh.resolve(void 0), Ah.constructor = Eh, _A = yA(Ah.then, Ah), ju = function() {
    _A(Oh);
  }) : q1 ? ju = function() {
    $A.nextTick(Oh);
  } : (Z1 = yA(Z1, nu), ju = function() {
    Z1(Oh);
  }), Rx = function(e) {
    Ih.head || ju(), Ih.add(e);
  };
}
var vhe = Rx, hhe = function(e, r) {
  try {
    arguments.length == 1 ? console.error(e) : console.error(e, r);
  } catch (t) {
  }
}, xw = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (r) {
    return { error: !0, value: r };
  }
}, phe = un, Yg = phe.Promise, kj = typeof Deno == "object" && Deno && typeof Deno.version == "object", ghe = kj, mhe = Gg, bhe = !ghe && !mhe && typeof window == "object" && typeof document == "object", yhe = un, Ud = Yg, She = Mt, xhe = VP, $he = D$, whe = qn, _he = bhe, The = kj, J1 = CP;
Ud && Ud.prototype;
var Che = whe("species"), Px = !1, jj = She(yhe.PromiseRejectionEvent), Ehe = xhe("Promise", function() {
  var e = $he(Ud), r = e !== String(Ud);
  if (!r && J1 === 66)
    return !0;
  if (!J1 || J1 < 51 || !/native code/.test(e)) {
    var t = new Ud(function(i) {
      i(1);
    }), n = function(i) {
      i(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[Che] = n, Px = t.then(function() {
    }) instanceof n, !Px)
      return !0;
  }
  return !r && (_he || The) && !jj;
}), Zf = {
  CONSTRUCTOR: Ehe,
  REJECTION_EVENT: jj,
  SUBCLASSING: Px
}, Oc = {}, TA = Us, Ahe = TypeError, Ihe = function(e) {
  var r, t;
  this.promise = new e(function(n, a) {
    if (r !== void 0 || t !== void 0)
      throw Ahe("Bad Promise constructor");
    r = n, t = a;
  }), this.resolve = TA(r), this.reject = TA(t);
};
Oc.f = function(e) {
  return new Ihe(e);
};
var Ohe = oi, w0 = Gg, Ls = un, bc = Sa, CA = Ic, EA = lj, Mhe = pw, Rhe = vve, Phe = Us, Mp = Mt, khe = Bs, jhe = gve, Dhe = kve, Dj = Mj.set, $w = vhe, Nhe = hhe, Lhe = xw, Fhe = Pj, Nj = F$, _0 = Yg, ww = Zf, Lj = Oc, Kg = "Promise", Fj = ww.CONSTRUCTOR, zhe = ww.REJECTION_EVENT, Bhe = ww.SUBCLASSING, ey = Nj.getterFor(Kg), Uhe = Nj.set, Uu = _0 && _0.prototype, Pl = _0, Mh = Uu, zj = Ls.TypeError, kx = Ls.document, _w = Ls.process, jx = Lj.f, Vhe = jx, Whe = !!(kx && kx.createEvent && Ls.dispatchEvent), Bj = "unhandledrejection", Hhe = "rejectionhandled", AA = 0, Uj = 1, Ghe = 2, Tw = 1, Vj = 2, Rh, IA, Yhe, OA, Wj = function(e) {
  var r;
  return khe(e) && Mp(r = e.then) ? r : !1;
}, Hj = function(e, r) {
  var t = r.value, n = r.state == Uj, a = n ? e.ok : e.fail, i = e.resolve, l = e.reject, u = e.domain, c, f, h;
  try {
    a ? (n || (r.rejection === Vj && Zhe(r), r.rejection = Tw), a === !0 ? c = t : (u && u.enter(), c = a(t), u && (u.exit(), h = !0)), c === e.promise ? l(zj("Promise-chain cycle")) : (f = Wj(c)) ? bc(f, c, i, l) : i(c)) : l(t);
  } catch (p) {
    u && !h && u.exit(), l(p);
  }
}, Gj = function(e, r) {
  e.notified || (e.notified = !0, $w(function() {
    for (var t = e.reactions, n; n = t.get(); )
      Hj(n, e);
    e.notified = !1, r && !e.rejection && Khe(e);
  }));
}, Yj = function(e, r, t) {
  var n, a;
  Whe ? (n = kx.createEvent("Event"), n.promise = r, n.reason = t, n.initEvent(e, !1, !0), Ls.dispatchEvent(n)) : n = { promise: r, reason: t }, !zhe && (a = Ls["on" + e]) ? a(n) : e === Bj && Nhe("Unhandled promise rejection", t);
}, Khe = function(e) {
  bc(Dj, Ls, function() {
    var r = e.facade, t = e.value, n = MA(e), a;
    if (n && (a = Lhe(function() {
      w0 ? _w.emit("unhandledRejection", t, r) : Yj(Bj, r, t);
    }), e.rejection = w0 || MA(e) ? Vj : Tw, a.error))
      throw a.value;
  });
}, MA = function(e) {
  return e.rejection !== Tw && !e.parent;
}, Zhe = function(e) {
  bc(Dj, Ls, function() {
    var r = e.facade;
    w0 ? _w.emit("rejectionHandled", r) : Yj(Hhe, r, e.value);
  });
}, Zu = function(e, r, t) {
  return function(n) {
    e(r, n, t);
  };
}, dc = function(e, r, t) {
  e.done || (e.done = !0, t && (e = t), e.value = r, e.state = Ghe, Gj(e, !0));
}, Dx = function(e, r, t) {
  if (!e.done) {
    e.done = !0, t && (e = t);
    try {
      if (e.facade === r)
        throw zj("Promise can't be resolved itself");
      var n = Wj(r);
      n ? $w(function() {
        var a = { done: !1 };
        try {
          bc(
            n,
            r,
            Zu(Dx, a, e),
            Zu(dc, a, e)
          );
        } catch (i) {
          dc(a, i, e);
        }
      }) : (e.value = r, e.state = Uj, Gj(e, !1));
    } catch (a) {
      dc({ done: !1 }, a, e);
    }
  }
};
if (Fj && (Pl = function(r) {
  jhe(this, Mh), Phe(r), bc(Rh, this);
  var t = ey(this);
  try {
    r(Zu(Dx, t), Zu(dc, t));
  } catch (n) {
    dc(t, n);
  }
}, Mh = Pl.prototype, Rh = function(r) {
  Uhe(this, {
    type: Kg,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new Fhe(),
    rejection: !1,
    state: AA,
    value: void 0
  });
}, Rh.prototype = CA(Mh, "then", function(r, t) {
  var n = ey(this), a = jx(Dhe(this, Pl));
  return n.parent = !0, a.ok = Mp(r) ? r : !0, a.fail = Mp(t) && t, a.domain = w0 ? _w.domain : void 0, n.state == AA ? n.reactions.add(a) : $w(function() {
    Hj(a, n);
  }), a.promise;
}), IA = function() {
  var e = new Rh(), r = ey(e);
  this.promise = e, this.resolve = Zu(Dx, r), this.reject = Zu(dc, r);
}, Lj.f = jx = function(e) {
  return e === Pl || e === Yhe ? new IA(e) : Vhe(e);
}, Mp(_0) && Uu !== Object.prototype)) {
  OA = Uu.then, Bhe || CA(Uu, "then", function(r, t) {
    var n = this;
    return new Pl(function(a, i) {
      bc(OA, n, a, i);
    }).then(r, t);
  }, { unsafe: !0 });
  try {
    delete Uu.constructor;
  } catch (e) {
  }
  EA && EA(Uu, Mh);
}
Ohe({ global: !0, constructor: !0, wrap: !0, forced: Fj }, {
  Promise: Pl
});
Mhe(Pl, Kg, !1);
Rhe(Kg);
var qhe = qn, Qhe = Kf, Xhe = qhe("iterator"), Jhe = Array.prototype, epe = function(e) {
  return e !== void 0 && (Qhe.Array === e || Jhe[Xhe] === e);
}, rpe = mw, RA = A$, tpe = _g, npe = Kf, ape = qn, ope = ape("iterator"), Kj = function(e) {
  if (!tpe(e))
    return RA(e, ope) || RA(e, "@@iterator") || npe[rpe(e)];
}, ipe = Sa, spe = Us, lpe = Ya, upe = Cg, cpe = Kj, dpe = TypeError, fpe = function(e, r) {
  var t = arguments.length < 2 ? cpe(e) : r;
  if (spe(t))
    return lpe(ipe(t, e));
  throw dpe(upe(e) + " is not iterable");
}, vpe = Sa, PA = Ya, hpe = A$, ppe = function(e, r, t) {
  var n, a;
  PA(e);
  try {
    if (n = hpe(e, "return"), !n) {
      if (r === "throw")
        throw t;
      return t;
    }
    n = vpe(n, e);
  } catch (i) {
    a = !0, n = i;
  }
  if (r === "throw")
    throw t;
  if (a)
    throw n;
  return PA(n), t;
}, gpe = yw, mpe = Sa, bpe = Ya, ype = Cg, Spe = epe, xpe = FP, kA = Gf, $pe = fpe, wpe = Kj, jA = ppe, _pe = TypeError, Rp = function(e, r) {
  this.stopped = e, this.result = r;
}, DA = Rp.prototype, Zj = function(e, r, t) {
  var n = t && t.that, a = !!(t && t.AS_ENTRIES), i = !!(t && t.IS_RECORD), l = !!(t && t.IS_ITERATOR), u = !!(t && t.INTERRUPTED), c = gpe(r, n), f, h, p, g, y, S, x, _ = function(O) {
    return f && jA(f, "normal", O), new Rp(!0, O);
  }, A = function(O) {
    return a ? (bpe(O), u ? c(O[0], O[1], _) : c(O[0], O[1])) : u ? c(O, _) : c(O);
  };
  if (i)
    f = e.iterator;
  else if (l)
    f = e;
  else {
    if (h = wpe(e), !h)
      throw _pe(ype(e) + " is not iterable");
    if (Spe(h)) {
      for (p = 0, g = xpe(e); g > p; p++)
        if (y = A(e[p]), y && kA(DA, y))
          return y;
      return new Rp(!1);
    }
    f = $pe(e, h);
  }
  for (S = i ? e.next : f.next; !(x = mpe(S, f)).done; ) {
    try {
      y = A(x.value);
    } catch (O) {
      jA(f, "throw", O);
    }
    if (typeof y == "object" && y && kA(DA, y))
      return y;
  }
  return new Rp(!1);
}, Tpe = qn, qj = Tpe("iterator"), Qj = !1;
try {
  var Cpe = 0, NA = {
    next: function() {
      return { done: !!Cpe++ };
    },
    return: function() {
      Qj = !0;
    }
  };
  NA[qj] = function() {
    return this;
  }, Array.from(NA, function() {
    throw 2;
  });
} catch (e) {
}
var Epe = function(e, r) {
  if (!r && !Qj)
    return !1;
  var t = !1;
  try {
    var n = {};
    n[qj] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, e(n);
  } catch (a) {
  }
  return t;
}, Ape = Yg, Ipe = Epe, Ope = Zf.CONSTRUCTOR, Xj = Ope || !Ipe(function(e) {
  Ape.all(e).then(void 0, function() {
  });
}), Mpe = oi, Rpe = Sa, Ppe = Us, kpe = Oc, jpe = xw, Dpe = Zj, Npe = Xj;
Mpe({ target: "Promise", stat: !0, forced: Npe }, {
  all: function(r) {
    var t = this, n = kpe.f(t), a = n.resolve, i = n.reject, l = jpe(function() {
      var u = Ppe(t.resolve), c = [], f = 0, h = 1;
      Dpe(r, function(p) {
        var g = f++, y = !1;
        h++, Rpe(u, t, p).then(function(S) {
          y || (y = !0, c[g] = S, --h || a(c));
        }, i);
      }), --h || a(c);
    });
    return l.error && i(l.value), n.promise;
  }
});
var Lpe = oi, Fpe = Zf.CONSTRUCTOR, Nx = Yg, zpe = su, Bpe = Mt, Upe = Ic, LA = Nx && Nx.prototype;
Lpe({ target: "Promise", proto: !0, forced: Fpe, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
if (Bpe(Nx)) {
  var FA = zpe("Promise").prototype.catch;
  LA.catch !== FA && Upe(LA, "catch", FA, { unsafe: !0 });
}
var Vpe = oi, Wpe = Sa, Hpe = Us, Gpe = Oc, Ype = xw, Kpe = Zj, Zpe = Xj;
Vpe({ target: "Promise", stat: !0, forced: Zpe }, {
  race: function(r) {
    var t = this, n = Gpe.f(t), a = n.reject, i = Ype(function() {
      var l = Hpe(t.resolve);
      Kpe(r, function(u) {
        Wpe(l, t, u).then(n.resolve, a);
      });
    });
    return i.error && a(i.value), n.promise;
  }
});
var qpe = oi, Qpe = Sa, Xpe = Oc, Jpe = Zf.CONSTRUCTOR;
qpe({ target: "Promise", stat: !0, forced: Jpe }, {
  reject: function(r) {
    var t = Xpe.f(this);
    return Qpe(t.reject, void 0, r), t.promise;
  }
});
var e0e = Ya, r0e = Bs, t0e = Oc, n0e = function(e, r) {
  if (e0e(e), r0e(r) && r.constructor === e)
    return r;
  var t = t0e.f(e), n = t.resolve;
  return n(r), t.promise;
}, a0e = oi, o0e = su, i0e = Zf.CONSTRUCTOR, s0e = n0e;
o0e("Promise");
a0e({ target: "Promise", stat: !0, forced: i0e }, {
  resolve: function(r) {
    return s0e(this, r);
  }
});
const l0e = Rg((e, r) => {
  const t = tw("Steps", e), n = Object.assign({}, t.steps), a = ew(e), {
    className: i,
    activeStep: l,
    children: u,
    orientation: c,
    state: f,
    responsive: h,
    checkIcon: p,
    onClickStep: g,
    labelOrientation: y,
    restrictedFordward: S,
    gap: x
  } = a, _ = V$(a, ["className", "activeStep", "children", "orientation", "state", "responsive", "checkIcon", "onClickStep", "labelOrientation", "restrictedFordward", "gap"]), A = I.Children.toArray(u), O = A.length, P = () => l <= A.length ? I.Children.map(A[l], (M) => {
    if (/* @__PURE__ */ I.isValidElement(M))
      return I.Children.map(M.props.children, (W) => W);
  }) : null, j = !!g, [k] = Vte("(max-width: 43em)"), L = k && h ? "vertical" : c;
  return qS(J$, Object.assign({
    value: t
  }, {
    children: Zte(Ffe, Object.assign({
      value: {
        activeStep: l,
        orientation: L,
        state: f,
        responsive: h,
        checkIcon: p,
        onClickStep: g,
        labelOrientation: y,
        clickable: j,
        colorScheme: e.colorScheme,
        stepCount: O,
        restrictedFordward: S,
        gap: x
      }
    }, {
      children: [qS(ma.ol, Object.assign({
        ref: r,
        __css: Object.assign({
          justifyContent: O === 1 ? "flex-end" : "space-between",
          flexDir: L === "vertical" ? "column" : "row"
        }, n),
        className: Z$("chakra-steps", i)
      }, _, {
        children: I.Children.map(u, (M, W) => {
          var Z;
          const oe = (Z = /* @__PURE__ */ I.isValidElement(M) && M.props.isCompletedStep) !== null && Z !== void 0 ? Z : W < l, Ie = W === O - 1, Ee = {
            index: W,
            isCompletedStep: oe,
            isCurrentStep: W === l,
            isLastStep: Ie
          };
          return /* @__PURE__ */ I.isValidElement(M) ? /* @__PURE__ */ I.cloneElement(M, Ee) : null;
        })
      })), L === "horizontal" && P()]
    }))
  }));
});
l0e.defaultProps = {
  activeStep: 0,
  colorScheme: "brand",
  orientation: "horizontal",
  responsive: !0
};
const u0e = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, c0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = mc(`${r}.500`, 0.6)(t);
  return {
    bg: Le(`${r}.500`, n)(e),
    color: Le("white", "whiteAlpha.800")(e)
  };
}, d0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = mc(`${r}.200`, 0.16)(t);
  return {
    bg: Le(`${r}.100`, n)(e),
    color: Le(`${r}.800`, `${r}.200`)(e)
  };
}, f0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = mc(`${r}.200`, 0.8)(t), a = kr(t, `${r}.500`), i = Le(a, n)(e);
  return {
    color: i,
    boxShadow: `inset 0 0 0px 1px ${i}`
  };
}, v0e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = mc(`${r}.500`, 0.6)(t);
  return {
    bg: Le(`${r}.500`, n)(e),
    color: Le("white", "whiteAlpha.800")(e),
    borderRadius: "full",
    border: "1px",
    borderColor: "white",
    minWidth: "21.5px",
    boxShadow: "base",
    textAlign: "center"
  };
}, h0e = {
  solid: c0e,
  subtle: d0e,
  outline: f0e,
  number: v0e
}, p0e = {
  variant: "subtle",
  colorScheme: "gray"
}, g0e = {
  baseStyle: u0e,
  variants: h0e,
  defaultProps: p0e
};
var m0e = oi, b0e = zP.includes, y0e = Rn, S0e = aj, x0e = y0e(function() {
  return !Array(1).includes();
});
m0e({ target: "Array", proto: !0, forced: x0e }, {
  includes: function(r) {
    return b0e(this, r, arguments.length > 1 ? arguments[1] : void 0);
  }
});
S0e("includes");
const $0e = {
  borderRadius: "50vh",
  fontWeight: "bold",
  _focus: "none",
  _disabled: {
    opacity: 1,
    cursor: "not-allowed",
    boxShadow: "none",
    border: "none",
    color: "gray.600",
    bg: "gray.300"
  },
  _hover: {
    _disabled: {
      color: "gray.600",
      bg: "gray.300"
    }
  }
}, Jj = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e;
  if (r === "brand") {
    mc(`${r}.500`, 0.12)(t);
    const n = mc(`${r}.500`, 0.24)(t);
    return {
      fontWeight: "normal",
      color: Le(`${r}.500`, `${r}.200`)(e),
      bg: "transparent",
      _disabled: {
        bg: "transparent",
        color: "gray.500"
      },
      _hover: {
        bg: Le(`${r}.100`, "whiteAlpha.200")(e),
        _disabled: {
          bg: "transparent",
          color: "gray.500"
        }
      },
      _active: {
        color: Le("white", `${r}.200`)(e),
        borderColor: Le(`${r}.600`, n)(e),
        bg: Le(`${r}.300`, n)(e)
      }
    };
  }
  return r === "secondary" ? {
    fontWeight: "normal",
    color: Le("gray.800", "whiteAlpha.900")(e),
    bg: "transparent",
    _disabled: {
      bg: "transparent",
      color: "gray.500"
    },
    _hover: {
      bg: Le("gray.100", "whiteAlpha.200")(e),
      _disabled: {
        bg: "transparent",
        color: "gray.500"
      }
    },
    _active: {
      bg: Le("gray.300", "whiteAlpha.300")(e)
    }
  } : Df.components.Button.variants.ghost(e);
}, zA = {
  xs: 1,
  sm: 1.5,
  md: 2,
  xl: 2
}, w0e = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, n = Le("secondary.700", "whiteAlpha.300")(e), a = Jj(e);
  return Object.assign(Object.assign({
    fontWeight: "normal",
    border: `${zA[t] || 2}px solid`,
    borderColor: ["secondary"].includes(r) ? n : "currentColor"
  }, a), {
    color: ["secondary"].includes(r) ? n : a.color,
    _hover: {
      bg: ["secondary"].includes(r) ? "secondary.50" : a._hover.bg,
      _disabled: {
        bg: "gray.300"
      }
    },
    _active: {
      bg: ["secondary"].includes(r) ? "secondary.200" : a._active.bg
    },
    _disabled: {
      border: `${zA[t] || 2}px solid`,
      borderColor: "gray.500",
      _hover: {
        borderColor: "gray.500"
      }
    }
  });
}, _0e = (e) => {
  const {
    colorScheme: r
  } = e;
  return r === "brand" ? {
    bg: Le(`${r}.500`, `${r}.200`)(e),
    color: Le("white", "gray.800")(e),
    _hover: {
      bg: Le(`${r}.600`, `${r}.300`)(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.300"
      }
    },
    _active: {
      bg: Le(`${r}.700`, `${r}.400`)(e)
    }
  } : r === "secondary" ? {
    bg: Le("secondary.700", "whiteAlpha.200")(e),
    color: "white",
    _hover: {
      bg: Le(`${r}.400`, "whiteAlpha.300")(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.300"
      }
    },
    _active: {
      bg: Le(`${r}.800`, "whiteAlpha.400")(e)
    }
  } : Df.components.Button.variants.solid(e);
}, T0e = (e) => {
  const {
    colorScheme: r
  } = e, t = Df.components.Button.variants.link(e);
  let {
    color: n
  } = t;
  const {
    _active: a
  } = t;
  return t.textDecoration = "underline", t._disabled = Object.assign(Object.assign({}, t._disabled), {
    color: "gray.500",
    bg: "none"
  }), t._hover = Object.assign(Object.assign({}, t._hover), {
    fontWeight: "bold",
    _disabled: Object.assign(Object.assign({}, t._hover._disabled), {
      color: "gray.500",
      fontWeight: "normal",
      bg: "none",
      textDecoration: "underline"
    })
  }), r === "brand" && (t.fontWeight = "normal", n = Le(`${r}.500`, `${r}.200`)(e), a.color = Le(`${r}.600`, `${r}.400`)(e)), r === "secondary" && (t.fontWeight = "normal", n = Le("gray.800", "whiteAlpha.900")(e), a.color = Le("gray.600", "whiteAlpha.300")(e)), Object.assign(Object.assign({}, t), {
    color: n,
    _active: Object.assign({}, a)
  });
}, C0e = {
  ghost: Jj,
  outline: w0e,
  solid: _0e,
  link: T0e
}, E0e = {
  lg: {
    h: "46px",
    minW: "46px",
    fontSize: "lg",
    px: 6
  },
  md: {
    h: "42px",
    minW: "42px",
    fontSize: "md",
    px: 5
  },
  sm: {
    h: "32px",
    minW: "32px",
    fontSize: "sm",
    px: 4
  },
  xs: {
    h: "26px",
    minW: "26px",
    fontSize: "xs",
    px: 3
  }
}, A0e = {
  variant: "solid",
  size: "md"
}, I0e = {
  baseStyle: $0e,
  sizes: E0e,
  variants: C0e,
  defaultProps: A0e
}, O0e = {
  display: "flex",
  flexDirection: "column",
  background: "white",
  alignItems: "center",
  gap: 6
}, M0e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "1rem",
  boxShadow: "base"
}, R0e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "none",
  boxShadow: "none"
}, P0e = {
  flat: R0e,
  rounded: M0e
}, k0e = {
  variant: "rounded"
}, j0e = {
  baseStyle: O0e,
  variants: P0e,
  defaultProps: k0e
};
Hr("accordion").parts("root", "container", "button", "panel").extend("icon");
Hr("alert").parts("title", "description", "container").extend("icon");
Hr("avatar").parts("label", "badge", "container").extend("excessLabel", "group");
Hr("breadcrumb").parts("link", "item", "container").extend("separator");
Hr("button").parts();
var D0e = Hr("checkbox").parts("control", "icon", "container").extend("label");
Hr("progress").parts("track", "filledTrack").extend("label");
Hr("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Hr("editable").parts("preview", "input", "textarea");
Hr("form").parts("container", "requiredIndicator", "helperText");
Hr("formError").parts("text", "icon");
var N0e = Hr("input").parts("addon", "field", "element");
Hr("list").parts("container", "item", "icon");
Hr("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider");
var L0e = Hr("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer");
Hr("numberinput").parts("root", "field", "stepperGroup", "stepper");
Hr("pininput").parts("field");
var F0e = Hr("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton");
Hr("progress").parts("label", "filledTrack", "track");
var z0e = Hr("radio").parts("container", "control", "label");
Hr("select").parts("field", "icon");
Hr("slider").parts("container", "track", "thumb", "filledTrack");
Hr("stat").parts("container", "label", "helpText", "number", "icon");
var B0e = Hr("switch").parts("container", "track", "thumb");
Hr("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption");
Hr("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator");
Hr("tag").parts("container", "label", "closeButton");
const U0e = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    w: "100%",
    border: "1px",
    borderRadius: "base",
    borderColor: "gray.300",
    _indeterminate: {
      bg: "white",
      borderColor: "gray.300",
      color: Le(`${r}.500`, `${r}.200`)(e)
    },
    _disabled: {
      borderColor: "gray.300",
      bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)"
    },
    _focus: {
      boxShadow: "none"
    }
  };
}, V0e = {
  _disabled: {
    cursor: "not-allowed"
  }
}, W0e = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, H0e = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, Sf = (e) => ({
  icon: H0e,
  container: V0e,
  control: U0e(e),
  label: W0e
}), G0e = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.72rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "1rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "1rem"
    }
  }
}, Y0e = {
  size: "md",
  colorScheme: "brand"
}, K0e = {
  parts: D0e.keys,
  baseStyle: Sf,
  sizes: G0e,
  defaultProps: Y0e
}, Z0e = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _placeholder: {
      color: "gray.400"
    }
  }
}, gs = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: "50px",
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: "44px",
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: "32px",
    borderRadius: "md"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: "24px",
    borderRadius: "md"
  }
}, q0e = {
  lg: {
    field: gs.lg,
    addon: gs.lg
  },
  md: {
    field: gs.md,
    addon: gs.md
  },
  sm: {
    field: gs.sm,
    addon: gs.sm
  },
  xs: {
    field: gs.xs,
    addon: gs.xs
  }
};
function Cw(e) {
  const {
    focusBorderColor: r,
    errorBorderColor: t,
    fieldBorderColor: n,
    disabledColor: a
  } = e;
  return {
    focusBorderColor: r || Le("secondary.700", "secondary.300")(e),
    errorBorderColor: t || Le("#DB371F", "red.300")(e),
    fieldBorderColor: n || Le("gray.400", "gray.200")(e),
    disabledColor: a || Le("gray.300", "gray.100")(e)
  };
}
const Q0e = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = Cw(e);
  return {
    field: {
      border: "0.5px solid",
      borderColor: kr(r, a),
      bg: "inherit",
      _hover: {
        borderColor: kr(r, a)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        borderColor: kr(r, i),
        boxShadow: `0 0 0 0.5px ${kr(r, i)}`,
        _hover: {
          borderColor: kr(r, i)
        },
        _placeholder: {
          color: kr(r, i)
        }
      },
      _invalid: {
        borderColor: kr(r, n),
        boxShadow: `0 0 0 0.5px ${kr(r, n)}`
      },
      _focus: {
        zIndex: 1,
        borderColor: kr(r, t),
        boxShadow: `0 0 0 0.5px ${kr(r, t)}`
      }
    },
    addon: {
      border: "0.5px solid",
      borderColor: kr(r, a),
      bg: Le("gray.100", "whiteAlpha.300")(e)
    }
  };
}, X0e = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    disabledColor: a
  } = Cw(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "transparent",
      bg: Le("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: Le("gray.100", "whiteAlpha.50")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        bg: kr(r, a),
        _placeholder: {
          color: Le("gray.700", "whiteAlpha.100")(e)
        },
        _hover: {
          bg: kr(r, a)
        }
      },
      _invalid: {
        borderColor: kr(r, n)
      },
      _focus: {
        bg: "transparent",
        borderColor: kr(r, t)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: "transparent",
      bg: Le("gray.100", "whiteAlpha.50")(e)
    }
  };
}, J0e = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = Cw(e);
  return {
    field: {
      borderBottom: "0px solid",
      borderColor: kr(r, a),
      borderRadius: 0,
      px: 0,
      boxShadow: `0px 1px 0px ${kr(r, a)}`,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: kr(r, n),
        boxShadow: `0px 1px 0px ${kr(r, n)}`
      },
      _focus: {
        borderColor: kr(r, t),
        boxShadow: `0px 1px 0px ${kr(r, t)}`
      },
      _disabled: {
        borderColor: kr(r, i),
        boxShadow: `0px 1px 0px ${kr(r, i)}`,
        _placeholder: {
          color: kr(r, i)
        }
      }
    },
    addon: {
      borderBottom: "0px solid",
      borderColor: kr(r, a),
      boxShadow: `0px 1px 0px ${kr(r, a)}`,
      borderRadius: 0,
      px: 0,
      pr: 2,
      bg: "transparent"
    }
  };
}, ege = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto",
    _disabled: {
      _placeholder: {
        color: "gray.300"
      }
    }
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, rge = {
  outline: Q0e,
  filled: X0e,
  flushed: J0e,
  unstyled: ege
}, tge = {
  size: "sm",
  variant: "flushed"
}, nge = {
  parts: N0e.keys,
  baseStyle: Z0e,
  sizes: q0e,
  variants: rge,
  defaultProps: tge
}, age = {
  bg: "blackAlpha.400",
  zIndex: "modal"
}, oge = (e) => {
  const {
    isCentered: r,
    scrollBehavior: t
  } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: r ? "center" : "flex-start",
    overflow: t === "inside" ? "hidden" : "auto",
    fontSize: "sm"
  };
}, ige = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    borderRadius: "md",
    bg: Le("white", "gray.700")(e),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: r === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: Le("lg", "dark-lg")(e)
  };
}, sge = {
  px: 6,
  py: 3,
  fontSize: "md",
  fontWeight: "normal",
  borderBottom: "1px solid",
  borderBottomColor: "gray.100"
}, lge = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  color: "gray.400"
}, uge = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    px: 6,
    py: 6,
    flex: 1,
    overflow: r === "inside" ? "auto" : void 0,
    fontSize: "sm"
  };
}, cge = (e) => ({
  px: 6,
  py: 3,
  bg: Le("gray.100", "gray.700")(e),
  borderBottomRadius: "md"
}), dge = (e) => ({
  overlay: age,
  dialogContainer: oge(e),
  dialog: ige(e),
  header: sge,
  closeButton: lge,
  body: uge(e),
  footer: cge(e)
});
function io(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
const fge = {
  xs: io("xs"),
  sm: io("sm"),
  md: io("md"),
  lg: io("lg"),
  xl: io("xl"),
  "2xl": io("2xl"),
  "3xl": io("3xl"),
  "4xl": io("4xl"),
  "5xl": io("5xl"),
  "6xl": io("6xl"),
  full: io("full")
}, vge = {
  size: "md",
  autoFocus: !1
}, hge = {
  parts: L0e.keys,
  baseStyle: dge,
  sizes: fge,
  defaultProps: vge
}, ry = ii("popper-bg"), pge = ii("popper-arrow-bg"), gge = ii("popper-arrow-shadow-color"), mge = {
  zIndex: 10
}, bge = (e) => {
  const r = Le("white", "gray.700")(e), t = Le("gray.200", "whiteAlpha.300")(e);
  return {
    [ry.variable]: `colors.${r}`,
    bg: ry.reference,
    [pge.variable]: ry.reference,
    [gge.variable]: `colors.${t}`,
    width: "xs",
    border: "1px solid",
    borderColor: "gray.300",
    borderRadius: "base",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    zIndex: "inherit",
    _focus: {
      outline: 0,
      boxShadow: "node"
    }
  };
}, yge = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px",
  fontSize: "sm"
}, Sge = {
  fontSize: "xs",
  px: 3,
  py: 2
}, xge = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, $ge = {
  position: "absolute",
  borderRadius: "md",
  top: 2,
  insetEnd: 2,
  color: "gray.400"
}, wge = (e) => ({
  popper: mge,
  content: bge(e),
  header: yge,
  body: Sge,
  footer: xge,
  arrow: {},
  closeButton: $ge
}), _ge = {
  parts: F0e.keys,
  baseStyle: wge
}, Tge = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, {
    control: n = {}
  } = Sf(e);
  let a = "12px";
  return t === "md" ? a = "9px" : t === "sm" && (a = "6px"), Object.assign(Object.assign({}, n), {
    borderRadius: "full",
    _hover: {
      bg: "white",
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: Le(`${r}.500`, `${r}.200`)(e)
      },
      _disabled: {
        bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)",
        _before: {
          bg: "none"
        }
      }
    },
    _checked: {
      bg: "white",
      borderColor: Le(`${r}.500`, `${r}.200`)(e),
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: Le(`${r}.500`, `${r}.200`)(e)
      },
      _hover: {
        _disabled: {
          bg: "gray.200",
          _before: {
            bg: "gray.500"
          }
        }
      },
      _disabled: {
        _before: {
          bg: "gray.500"
        }
      }
    },
    _active: {
      _before: {
        bg: Le(`${r}.600`, `${r}.400`)(e)
      }
    }
  });
}, Cge = (e) => ({
  label: Sf(e).label,
  container: Sf(e).container,
  control: Tge(e)
}), Ege = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, Age = {
  size: "md",
  colorScheme: "brand"
}, Ige = {
  parts: z0e.keys,
  baseStyle: Cge,
  sizes: Ege,
  defaultProps: Age
}, Go = ii("spinner-size"), Oge = {
  width: [Go.reference],
  height: [Go.reference]
}, Mge = {
  xs: {
    [Go.variable]: "0.75rem"
  },
  sm: {
    [Go.variable]: "1rem"
  },
  md: {
    [Go.variable]: "1.5rem"
  },
  lg: {
    [Go.variable]: "2rem"
  },
  xl: {
    [Go.variable]: "3rem"
  },
  "2xl": {
    [Go.variable]: "4rem"
  },
  "3xl": {
    [Go.variable]: "5rem"
  },
  "4xl": {
    [Go.variable]: "6rem"
  }
}, Rge = {
  size: "md"
}, Pge = {
  baseStyle: Oge,
  sizes: Mge,
  defaultProps: Rge
}, kge = Hr("steps").parts("connector", "description", "icon", "iconLabel", "label", "labelContainer", "step", "stepContainer", "stepIconContainer", "steps"), jge = {
  strokeWidth: "2px"
}, BA = (e) => ({
  color: Le("gray.800", "gray.100")(e),
  fontWeight: "medium",
  textAlign: "center",
  fontSize: "md",
  _activeStep: {
    color: "gray.900"
  }
}), Dge = (e) => ({
  color: Le("gray.800", "gray.200")(e),
  marginTop: "-2px",
  textAlign: "center",
  fontSize: "sm"
}), Nge = (e) => {
  const {
    colorScheme: r
  } = e, t = Le("gray.200", "gray.700")(e);
  let n = `${r}.500`;
  r === "secondary" && (n = `${r}.700`);
  const a = Le(n, `${r}.200`)(e);
  return {
    flex: 1,
    display: "flex",
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "border-color",
    transitionDuration: "normal",
    _highlighted: {
      borderColor: a
    }
  };
}, Lge = (e) => {
  const {
    colorScheme: r
  } = e, t = Le("gray.400", "gray.700")(e);
  let n = `${r}.500`;
  return r === "secondary" && (n = `${r}.700`), {
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    bg: t,
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "background, border-color",
    transitionDuration: "normal",
    _activeStep: {
      bg: Le(Xfe("white", 0.5), Jfe(t, 0.5))(e),
      borderColor: n,
      _invalid: {
        bg: "red.500",
        borderColor: "red.500"
      }
    },
    _highlighted: {
      bg: n,
      borderColor: n
    },
    "&[data-clickable]:hover": {
      borderColor: n
    }
  };
}, Fge = (e) => {
  const {
    colorScheme: r
  } = e;
  let t = `${r}.500`;
  return r === "secondary" && (t = `${r}.700`), {
    connector: Nge(e),
    description: Dge(e),
    icon: jge,
    iconLabel: BA(e),
    label: Object.assign(Object.assign({}, BA(e)), {
      _activeStep: {
        color: t
      }
    }),
    labelContainer: {
      display: "flex",
      flexDir: "column",
      justifyContent: "center"
    },
    step: {
      display: "flex",
      position: "relative"
    },
    stepContainer: {
      display: "flex",
      alignItems: "center"
    },
    stepIconContainer: Lge(e),
    steps: {
      fontFamily: "heading",
      textAlign: "center",
      width: "100%",
      display: "flex",
      flex: 1
    }
  };
}, zge = {
  sm: {
    stepIconContainer: {
      width: "26px",
      height: "26px",
      borderWidth: "2px"
    },
    icon: {
      width: "14px",
      height: "14px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "sm"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "xs"
    }
  },
  md: {
    stepIconContainer: {
      width: "40px",
      height: "40px",
      borderWidth: "2px"
    },
    icon: {
      width: "18px",
      height: "18px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "md"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "sm"
    }
  },
  lg: {
    stepIconContainer: {
      width: "48px",
      height: "48px",
      borderWidth: "2px"
    },
    icon: {
      width: "22px",
      height: "22px"
    },
    label: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "lg"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "md"
    }
  }
}, Bge = {
  size: "md",
  colorScheme: "brand"
}, Uge = {
  parts: kge.keys,
  baseStyle: Fge,
  sizes: zge,
  defaultProps: Bge
};
var Vge = Ya, Wge = function() {
  var e = Vge(this), r = "";
  return e.hasIndices && (r += "d"), e.global && (r += "g"), e.ignoreCase && (r += "i"), e.multiline && (r += "m"), e.dotAll && (r += "s"), e.unicode && (r += "u"), e.unicodeSets && (r += "v"), e.sticky && (r += "y"), r;
}, Hge = Sa, Gge = Ga, Yge = Gf, Kge = Wge, UA = RegExp.prototype, Zge = function(e) {
  var r = e.flags;
  return r === void 0 && !("flags" in UA) && !Gge(e, "flags") && Yge(UA, e) ? Hge(Kge, e) : r;
}, qge = j$.PROPER, Qge = Ic, Xge = Ya, VA = yj, Jge = Rn, eme = Zge, Ew = "toString", rme = RegExp.prototype, e6 = rme[Ew], tme = Jge(function() {
  return e6.call({ source: "a", flags: "b" }) != "/a/b";
}), nme = qge && e6.name != Ew;
(tme || nme) && Qge(RegExp.prototype, Ew, function() {
  var r = Xge(this), t = VA(r.source), n = VA(eme(r));
  return "/" + t + "/" + n;
}, { unsafe: !0 });
const Vd = ii("switch-track-width"), ql = ii("switch-track-height"), ty = ii("switch-track-diff"), ame = Rl.subtract(Vd, ql), Lx = ii("switch-thumb-x"), ome = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    borderRadius: "full",
    p: "1px",
    width: [Vd.reference],
    height: [ql.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: Le("gray.100", "whiteAlpha.400")(e),
    _focus: {
      boxShadow: "none"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: Le(`${r}.500`, `${r}.200`)(e)
    }
  };
}, ime = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [ql.reference],
  height: [ql.reference],
  _checked: {
    transform: `translateX(${Lx.reference})`
  }
}, sme = (e) => ({
  container: {
    [ty.variable]: ame,
    [Lx.variable]: ty.reference,
    _rtl: {
      [Lx.variable]: Rl(ty).negate().toString()
    }
  },
  track: ome(e),
  thumb: ime
}), lme = {
  sm: {
    container: {
      [Vd.variable]: "2.8rem",
      [ql.variable]: "1.6rem"
    }
  },
  md: {
    container: {
      [Vd.variable]: "3.8rem",
      [ql.variable]: "2.2rem"
    }
  },
  lg: {
    container: {
      // 50x30
      [Vd.variable]: "4.8rem",
      [ql.variable]: "2.8rem"
    }
  }
}, ume = {
  size: "md",
  colorScheme: "brand"
}, cme = {
  parts: B0e.keys,
  baseStyle: sme,
  sizes: lme,
  defaultProps: ume
}, ny = ii("tooltip-bg"), dme = ii("popper-arrow-bg"), fme = (e) => {
  const r = Le("white", "gray.700")(e);
  return {
    [ny.variable]: `colors.${r}`,
    bg: [ny.reference],
    [dme.variable]: [ny.reference],
    color: Le("gray", "white")(e),
    px: "8px",
    py: "2px",
    fontWeight: "normal",
    fontSize: "xs",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    maxW: "320px",
    zIndex: "tooltip"
  };
}, vme = {
  baseStyle: fme
};
var hme = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Badge: g0e,
  Button: I0e,
  Card: j0e,
  baseStyle: Sf,
  Checkbox: K0e,
  Input: nge,
  Modal: hge,
  Popover: _ge,
  Radio: Ige,
  Spinner: Pge,
  Steps: Uge,
  Switch: cme,
  Tooltip: vme
});
const pme = {
  base: "0px",
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1440px"
}, gme = {
  50: "#FFF0E8",
  100: "#FFD7BF",
  200: "#FFC7A5",
  300: "#FFB080",
  400: "#FF943E",
  500: "#FF6200",
  600: "#EE5601",
  700: "#D54D00",
  800: "#C14600",
  900: "#AC3F01"
}, mme = {
  50: "#E9EDF1",
  100: "#CAD1D9",
  200: "#A9B5C0",
  300: "#8998A7",
  400: "#758595",
  500: "#68717D",
  600: "#495867",
  700: "#3E5061",
  800: "#1E364B",
  900: "#0C2941"
}, bme = {
  50: "#FAFAFA",
  100: "#F1F1F1",
  200: "#E1E1E1",
  300: "#D1D1D1",
  400: "#ACACAC",
  500: "#717171",
  600: "#636363",
  700: "#515151",
  800: "#333333",
  900: "#131313"
}, yme = {
  brand: gme,
  secondary: mme,
  gray: bme
}, Sme = {
  none: "0",
  sm: "0.2rem",
  base: "0.4rem",
  md: "0.6rem",
  lg: "0.8rem",
  xl: "1.2rem",
  "2xl": "1.5rem",
  "3xl": "2.4rem",
  full: "9999px"
}, xme = {
  // xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
  // sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  // base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  // md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  // lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  // xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  // '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  // outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  // 'outline-md': '0 0 10px rgba(0, 0, 0, 0.1)',
  // inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  // none: 'none',
  // 'dark-lg': 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px',
  base: "0px 2px 2px rgba(0, 0, 0, 0.1)",
  md: "0px 0px 10px rgba(0, 0, 0, 0.2)",
  lg: "0px 5px 20px rgba(0, 0, 0, 0.2)"
}, r6 = {
  px: "1px",
  0.5: "0.2rem",
  1: "0.4rem",
  1.5: "0.6rem",
  2: "0.8rem",
  2.5: "1rem",
  3: "1.2rem",
  3.5: "1.4rem",
  4: "1.6rem",
  5: "2rem",
  6: "2.4rem",
  7: "2.8rem",
  8: "3.2rem",
  9: "3.6rem",
  10: "4rem",
  12: "4.8rem",
  14: "5.6rem",
  16: "6.4rem",
  20: "8rem",
  24: "9.6rem",
  28: "11.2rem",
  32: "12.8rem",
  36: "14.4rem",
  40: "16rem",
  44: "17.6rem",
  48: "19.2rem",
  52: "20.8rem",
  56: "22.4rem",
  60: "24rem",
  64: "25.6rem",
  72: "28.8rem",
  80: "32rem",
  96: "38.4rem"
}, $me = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "22.4rem",
  "2xs": "25.6rem",
  xs: "32rem",
  sm: "38.4rem",
  md: "44.8rem",
  lg: "51.2rem",
  xl: "57.6rem",
  "2xl": "67.2rem",
  "3xl": "76.8rem",
  "4xl": "89.6rem",
  "5xl": "102.4rem",
  "6xl": "115.2rem",
  "7xl": "128rem",
  "8xl": "144rem"
}, wme = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, _me = Object.assign(Object.assign(Object.assign({}, r6), $me), {
  container: wme
}), Tme = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xxs: "1.3rem",
    xs: "1.4rem",
    sm: "1.6rem",
    md: "1.8rem",
    lg: "2.0rem",
    xl: "2.2rem",
    "2xl": "2.4rem",
    "3xl": "3.2rem",
    "4xl": "3.6rem",
    "5xl": "4.8rem",
    "6xl": "6rem",
    "7xl": "7.2rem",
    "8xl": "9.6rem",
    "9xl": "12.8rem"
  }
}, Cme = Object.assign(Object.assign({
  radii: Sme,
  colors: yme
}, Tme), {
  sizes: _me,
  space: r6,
  shadows: xme,
  breakpoints: pme
}), Eme = {
  global: (e) => ({
    html: {
      fontSize: "10px"
    },
    "html, body, #__next": {
      height: "100vh",
      bg: Le("white", "gray.800")(e)
    }
  })
}, Ame = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "fa-solar"
}, Ime = fP(Object.assign(Object.assign({}, Cme), {
  components: Object.assign({}, hme),
  styles: Eme,
  config: Ame
}), Kte({
  colorScheme: "brand"
}));
var t6 = {
  border: "0px",
  clip: "rect(0px, 0px, 0px, 0px)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
};
ma("span", {
  baseStyle: t6
});
ma("input", {
  baseStyle: t6
});
ma(zs.div);
function Ome(e, r) {
  return r.forEach(function(t) {
    t && typeof t != "string" && !Array.isArray(t) && Object.keys(t).forEach(function(n) {
      if (n !== "default" && !(n in e)) {
        var a = Object.getOwnPropertyDescriptor(t, n);
        Object.defineProperty(e, n, a.get ? a : {
          enumerable: !0,
          get: function() {
            return t[n];
          }
        });
      }
    });
  }), Object.freeze(e);
}
var Wl = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {}, Ph = function(e) {
  return e && e.Math == Math && e;
}, wo = (
  // eslint-disable-next-line es/no-global-this -- safe
  Ph(typeof globalThis == "object" && globalThis) || Ph(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Ph(typeof self == "object" && self) || Ph(typeof Wl == "object" && Wl) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Wl || Function("return this")()
), Aw = {}, $a = function(e) {
  try {
    return !!e();
  } catch (r) {
    return !0;
  }
}, Mme = $a, si = !Mme(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), Rme = $a, n6 = !Rme(function() {
  var e = function() {
  }.bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), Pme = n6, kh = Function.prototype.call, Mc = Pme ? kh.bind(kh) : function() {
  return kh.apply(kh, arguments);
}, Iw = {}, a6 = {}.propertyIsEnumerable, o6 = Object.getOwnPropertyDescriptor, kme = o6 && !a6.call({ 1: 2 }, 1);
Iw.f = kme ? function(r) {
  var t = o6(this, r);
  return !!t && t.enumerable;
} : a6;
var Ow = function(e, r) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: r
  };
}, i6 = n6, s6 = Function.prototype, Fx = s6.call, jme = i6 && s6.bind.bind(Fx, Fx), _o = i6 ? jme : function(e) {
  return function() {
    return Fx.apply(e, arguments);
  };
}, l6 = _o, Dme = l6({}.toString), Nme = l6("".slice), u6 = function(e) {
  return Nme(Dme(e), 8, -1);
}, Lme = _o, Fme = $a, zme = u6, ay = Object, Bme = Lme("".split), c6 = Fme(function() {
  return !ay("z").propertyIsEnumerable(0);
}) ? function(e) {
  return zme(e) == "String" ? Bme(e, "") : ay(e);
} : ay, d6 = function(e) {
  return e == null;
}, Ume = d6, Vme = TypeError, f6 = function(e) {
  if (Ume(e))
    throw Vme("Can't call method on " + e);
  return e;
}, Wme = c6, Hme = f6, qf = function(e) {
  return Wme(Hme(e));
}, zx = typeof document == "object" && document.all, Gme = typeof zx == "undefined" && zx !== void 0, v6 = {
  all: zx,
  IS_HTMLDDA: Gme
}, h6 = v6, Yme = h6.all, kn = h6.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === Yme;
} : function(e) {
  return typeof e == "function";
}, WA = kn, p6 = v6, Kme = p6.all, Rc = p6.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : WA(e) || e === Kme;
} : function(e) {
  return typeof e == "object" ? e !== null : WA(e);
}, oy = wo, Zme = kn, qme = function(e) {
  return Zme(e) ? e : void 0;
}, Mw = function(e, r) {
  return arguments.length < 2 ? qme(oy[e]) : oy[e] && oy[e][r];
}, Qme = _o, g6 = Qme({}.isPrototypeOf), Xme = typeof navigator != "undefined" && String(navigator.userAgent) || "", m6 = wo, iy = Xme, HA = m6.process, GA = m6.Deno, YA = HA && HA.versions || GA && GA.version, KA = YA && YA.v8, yo, T0;
KA && (yo = KA.split("."), T0 = yo[0] > 0 && yo[0] < 4 ? 1 : +(yo[0] + yo[1]));
!T0 && iy && (yo = iy.match(/Edge\/(\d+)/), (!yo || yo[1] >= 74) && (yo = iy.match(/Chrome\/(\d+)/), yo && (T0 = +yo[1])));
var Jme = T0, ZA = Jme, ebe = $a, rbe = wo, tbe = rbe.String, b6 = !!Object.getOwnPropertySymbols && !ebe(function() {
  var e = Symbol();
  return !tbe(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && ZA && ZA < 41;
}), nbe = b6, y6 = nbe && !Symbol.sham && typeof Symbol.iterator == "symbol", abe = Mw, obe = kn, ibe = g6, sbe = y6, lbe = Object, S6 = sbe ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var r = abe("Symbol");
  return obe(r) && ibe(r.prototype, lbe(e));
}, ube = String, cbe = function(e) {
  try {
    return ube(e);
  } catch (r) {
    return "Object";
  }
}, dbe = kn, fbe = cbe, vbe = TypeError, x6 = function(e) {
  if (dbe(e))
    return e;
  throw vbe(fbe(e) + " is not a function");
}, hbe = x6, pbe = d6, gbe = function(e, r) {
  var t = e[r];
  return pbe(t) ? void 0 : hbe(t);
}, sy = Mc, ly = kn, uy = Rc, mbe = TypeError, bbe = function(e, r) {
  var t, n;
  if (r === "string" && ly(t = e.toString) && !uy(n = sy(t, e)) || ly(t = e.valueOf) && !uy(n = sy(t, e)) || r !== "string" && ly(t = e.toString) && !uy(n = sy(t, e)))
    return n;
  throw mbe("Can't convert object to primitive value");
}, Rw = { exports: {} }, qA = wo, ybe = Object.defineProperty, Pw = function(e, r) {
  try {
    ybe(qA, e, { value: r, configurable: !0, writable: !0 });
  } catch (t) {
    qA[e] = r;
  }
  return r;
}, Sbe = wo, xbe = Pw, QA = "__core-js_shared__", $be = Sbe[QA] || xbe(QA, {}), kw = $be, XA = kw;
(Rw.exports = function(e, r) {
  return XA[e] || (XA[e] = r !== void 0 ? r : {});
})("versions", []).push({
  version: "3.31.0",
  mode: "global",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var wbe = f6, _be = Object, jw = function(e) {
  return _be(wbe(e));
}, Tbe = _o, Cbe = jw, Ebe = Tbe({}.hasOwnProperty), li = Object.hasOwn || function(r, t) {
  return Ebe(Cbe(r), t);
}, Abe = _o, Ibe = 0, Obe = Math.random(), Mbe = Abe(1 .toString), $6 = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Mbe(++Ibe + Obe, 36);
}, Rbe = wo, Pbe = Rw.exports, JA = li, kbe = $6, jbe = b6, Dbe = y6, qu = Rbe.Symbol, cy = Pbe("wks"), Nbe = Dbe ? qu.for || qu : qu && qu.withoutSetter || kbe, Vs = function(e) {
  return JA(cy, e) || (cy[e] = jbe && JA(qu, e) ? qu[e] : Nbe("Symbol." + e)), cy[e];
}, Lbe = Mc, e3 = Rc, r3 = S6, Fbe = gbe, zbe = bbe, Bbe = Vs, Ube = TypeError, Vbe = Bbe("toPrimitive"), Wbe = function(e, r) {
  if (!e3(e) || r3(e))
    return e;
  var t = Fbe(e, Vbe), n;
  if (t) {
    if (r === void 0 && (r = "default"), n = Lbe(t, e, r), !e3(n) || r3(n))
      return n;
    throw Ube("Can't convert object to primitive value");
  }
  return r === void 0 && (r = "number"), zbe(e, r);
}, Hbe = Wbe, Gbe = S6, w6 = function(e) {
  var r = Hbe(e, "string");
  return Gbe(r) ? r : r + "";
}, Ybe = wo, t3 = Rc, Bx = Ybe.document, Kbe = t3(Bx) && t3(Bx.createElement), Dw = function(e) {
  return Kbe ? Bx.createElement(e) : {};
}, Zbe = si, qbe = $a, Qbe = Dw, _6 = !Zbe && !qbe(function() {
  return Object.defineProperty(Qbe("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), Xbe = si, Jbe = Mc, e1e = Iw, r1e = Ow, t1e = qf, n1e = w6, a1e = li, o1e = _6, n3 = Object.getOwnPropertyDescriptor;
Aw.f = Xbe ? n3 : function(r, t) {
  if (r = t1e(r), t = n1e(t), o1e)
    try {
      return n3(r, t);
    } catch (n) {
    }
  if (a1e(r, t))
    return r1e(!Jbe(e1e.f, r, t), r[t]);
};
var Ws = {}, i1e = si, s1e = $a, T6 = i1e && s1e(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype != 42;
}), l1e = Rc, u1e = String, c1e = TypeError, uu = function(e) {
  if (l1e(e))
    return e;
  throw c1e(u1e(e) + " is not an object");
}, d1e = si, f1e = _6, v1e = T6, jh = uu, a3 = w6, h1e = TypeError, dy = Object.defineProperty, p1e = Object.getOwnPropertyDescriptor, fy = "enumerable", vy = "configurable", hy = "writable";
Ws.f = d1e ? v1e ? function(r, t, n) {
  if (jh(r), t = a3(t), jh(n), typeof r == "function" && t === "prototype" && "value" in n && hy in n && !n[hy]) {
    var a = p1e(r, t);
    a && a[hy] && (r[t] = n.value, n = {
      configurable: vy in n ? n[vy] : a[vy],
      enumerable: fy in n ? n[fy] : a[fy],
      writable: !1
    });
  }
  return dy(r, t, n);
} : dy : function(r, t, n) {
  if (jh(r), t = a3(t), jh(n), f1e)
    try {
      return dy(r, t, n);
    } catch (a) {
    }
  if ("get" in n || "set" in n)
    throw h1e("Accessors not supported");
  return "value" in n && (r[t] = n.value), r;
};
var g1e = si, m1e = Ws, b1e = Ow, Zg = g1e ? function(e, r, t) {
  return m1e.f(e, r, b1e(1, t));
} : function(e, r, t) {
  return e[r] = t, e;
}, C6 = { exports: {} }, Ux = si, y1e = li, E6 = Function.prototype, S1e = Ux && Object.getOwnPropertyDescriptor, Nw = y1e(E6, "name"), x1e = Nw && function() {
}.name === "something", $1e = Nw && (!Ux || Ux && S1e(E6, "name").configurable), Lw = {
  EXISTS: Nw,
  PROPER: x1e,
  CONFIGURABLE: $1e
}, w1e = _o, _1e = kn, Vx = kw, T1e = w1e(Function.toString);
_1e(Vx.inspectSource) || (Vx.inspectSource = function(e) {
  return T1e(e);
});
var C1e = Vx.inspectSource, E1e = wo, A1e = kn, o3 = E1e.WeakMap, I1e = A1e(o3) && /native code/.test(String(o3)), O1e = Rw.exports, M1e = $6, i3 = O1e("keys"), Fw = function(e) {
  return i3[e] || (i3[e] = M1e(e));
}, zw = {}, R1e = I1e, A6 = wo, P1e = Rc, k1e = Zg, py = li, gy = kw, j1e = Fw, D1e = zw, s3 = "Object already initialized", Wx = A6.TypeError, N1e = A6.WeakMap, C0, xf, E0, L1e = function(e) {
  return E0(e) ? xf(e) : C0(e, {});
}, F1e = function(e) {
  return function(r) {
    var t;
    if (!P1e(r) || (t = xf(r)).type !== e)
      throw Wx("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (R1e || gy.state) {
  var Bo = gy.state || (gy.state = new N1e());
  Bo.get = Bo.get, Bo.has = Bo.has, Bo.set = Bo.set, C0 = function(e, r) {
    if (Bo.has(e))
      throw Wx(s3);
    return r.facade = e, Bo.set(e, r), r;
  }, xf = function(e) {
    return Bo.get(e) || {};
  }, E0 = function(e) {
    return Bo.has(e);
  };
} else {
  var Du = j1e("state");
  D1e[Du] = !0, C0 = function(e, r) {
    if (py(e, Du))
      throw Wx(s3);
    return r.facade = e, k1e(e, Du, r), r;
  }, xf = function(e) {
    return py(e, Du) ? e[Du] : {};
  }, E0 = function(e) {
    return py(e, Du);
  };
}
var I6 = {
  set: C0,
  get: xf,
  has: E0,
  enforce: L1e,
  getterFor: F1e
}, Bw = _o, z1e = $a, B1e = kn, Dh = li, Hx = si, U1e = Lw.CONFIGURABLE, V1e = C1e, O6 = I6, W1e = O6.enforce, H1e = O6.get, l3 = String, Pp = Object.defineProperty, G1e = Bw("".slice), Y1e = Bw("".replace), K1e = Bw([].join), Z1e = Hx && !z1e(function() {
  return Pp(function() {
  }, "length", { value: 8 }).length !== 8;
}), q1e = String(String).split("String"), Q1e = C6.exports = function(e, r, t) {
  G1e(l3(r), 0, 7) === "Symbol(" && (r = "[" + Y1e(l3(r), /^Symbol\(([^)]*)\)/, "$1") + "]"), t && t.getter && (r = "get " + r), t && t.setter && (r = "set " + r), (!Dh(e, "name") || U1e && e.name !== r) && (Hx ? Pp(e, "name", { value: r, configurable: !0 }) : e.name = r), Z1e && t && Dh(t, "arity") && e.length !== t.arity && Pp(e, "length", { value: t.arity });
  try {
    t && Dh(t, "constructor") && t.constructor ? Hx && Pp(e, "prototype", { writable: !1 }) : e.prototype && (e.prototype = void 0);
  } catch (a) {
  }
  var n = W1e(e);
  return Dh(n, "source") || (n.source = K1e(q1e, typeof r == "string" ? r : "")), e;
};
Function.prototype.toString = Q1e(function() {
  return B1e(this) && H1e(this).source || V1e(this);
}, "toString");
var X1e = kn, J1e = Ws, eye = C6.exports, rye = Pw, qg = function(e, r, t, n) {
  n || (n = {});
  var a = n.enumerable, i = n.name !== void 0 ? n.name : r;
  if (X1e(t) && eye(t, i, n), n.global)
    a ? e[r] = t : rye(r, t);
  else {
    try {
      n.unsafe ? e[r] && (a = !0) : delete e[r];
    } catch (l) {
    }
    a ? e[r] = t : J1e.f(e, r, {
      value: t,
      enumerable: !1,
      configurable: !n.nonConfigurable,
      writable: !n.nonWritable
    });
  }
  return e;
}, M6 = {}, tye = Math.ceil, nye = Math.floor, aye = Math.trunc || function(r) {
  var t = +r;
  return (t > 0 ? nye : tye)(t);
}, oye = aye, R6 = function(e) {
  var r = +e;
  return r !== r || r === 0 ? 0 : oye(r);
}, iye = R6, sye = Math.max, lye = Math.min, uye = function(e, r) {
  var t = iye(e);
  return t < 0 ? sye(t + r, 0) : lye(t, r);
}, cye = R6, dye = Math.min, fye = function(e) {
  return e > 0 ? dye(cye(e), 9007199254740991) : 0;
}, vye = fye, hye = function(e) {
  return vye(e.length);
}, pye = qf, gye = uye, mye = hye, u3 = function(e) {
  return function(r, t, n) {
    var a = pye(r), i = mye(a), l = gye(n, i), u;
    if (e && t != t) {
      for (; i > l; )
        if (u = a[l++], u != u)
          return !0;
    } else
      for (; i > l; l++)
        if ((e || l in a) && a[l] === t)
          return e || l || 0;
    return !e && -1;
  };
}, P6 = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: u3(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: u3(!1)
}, bye = _o, my = li, yye = qf, Sye = P6.indexOf, xye = zw, c3 = bye([].push), k6 = function(e, r) {
  var t = yye(e), n = 0, a = [], i;
  for (i in t)
    !my(xye, i) && my(t, i) && c3(a, i);
  for (; r.length > n; )
    my(t, i = r[n++]) && (~Sye(a, i) || c3(a, i));
  return a;
}, Uw = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], $ye = k6, wye = Uw, _ye = wye.concat("length", "prototype");
M6.f = Object.getOwnPropertyNames || function(r) {
  return $ye(r, _ye);
};
var Vw = {};
Vw.f = Object.getOwnPropertySymbols;
var Tye = Mw, Cye = _o, Eye = M6, Aye = Vw, Iye = uu, Oye = Cye([].concat), Mye = Tye("Reflect", "ownKeys") || function(r) {
  var t = Eye.f(Iye(r)), n = Aye.f;
  return n ? Oye(t, n(r)) : t;
}, d3 = li, Rye = Mye, Pye = Aw, kye = Ws, jye = function(e, r, t) {
  for (var n = Rye(r), a = kye.f, i = Pye.f, l = 0; l < n.length; l++) {
    var u = n[l];
    !d3(e, u) && !(t && d3(t, u)) && a(e, u, i(r, u));
  }
}, Dye = $a, Nye = kn, Lye = /#|\.prototype\./, Qf = function(e, r) {
  var t = zye[Fye(e)];
  return t == Uye ? !0 : t == Bye ? !1 : Nye(r) ? Dye(r) : !!r;
}, Fye = Qf.normalize = function(e) {
  return String(e).replace(Lye, ".").toLowerCase();
}, zye = Qf.data = {}, Bye = Qf.NATIVE = "N", Uye = Qf.POLYFILL = "P", Vye = Qf, by = wo, Wye = Aw.f, Hye = Zg, Gye = qg, Yye = Pw, Kye = jye, Zye = Vye, Ww = function(e, r) {
  var t = e.target, n = e.global, a = e.stat, i, l, u, c, f, h;
  if (n ? l = by : a ? l = by[t] || Yye(t, {}) : l = (by[t] || {}).prototype, l)
    for (u in r) {
      if (f = r[u], e.dontCallGetSet ? (h = Wye(l, u), c = h && h.value) : c = l[u], i = Zye(n ? u : t + (a ? "." : "#") + u, e.forced), !i && c !== void 0) {
        if (typeof f == typeof c)
          continue;
        Kye(f, c);
      }
      (e.sham || c && c.sham) && Hye(f, "sham", !0), Gye(l, u, f, e);
    }
}, qye = k6, Qye = Uw, j6 = Object.keys || function(r) {
  return qye(r, Qye);
}, f3 = si, Xye = _o, Jye = Mc, eSe = $a, yy = j6, rSe = Vw, tSe = Iw, nSe = jw, aSe = c6, Nu = Object.assign, v3 = Object.defineProperty, oSe = Xye([].concat), iSe = !Nu || eSe(function() {
  if (f3 && Nu({ b: 1 }, Nu(v3({}, "a", {
    enumerable: !0,
    get: function() {
      v3(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1)
    return !0;
  var e = {}, r = {}, t = Symbol(), n = "abcdefghijklmnopqrst";
  return e[t] = 7, n.split("").forEach(function(a) {
    r[a] = a;
  }), Nu({}, e)[t] != 7 || yy(Nu({}, r)).join("") != n;
}) ? function(r, t) {
  for (var n = nSe(r), a = arguments.length, i = 1, l = rSe.f, u = tSe.f; a > i; )
    for (var c = aSe(arguments[i++]), f = l ? oSe(yy(c), l(c)) : yy(c), h = f.length, p = 0, g; h > p; )
      g = f[p++], (!f3 || Jye(u, c, g)) && (n[g] = c[g]);
  return n;
} : Nu, sSe = Ww, h3 = iSe;
sSe({ target: "Object", stat: !0, arity: 2, forced: Object.assign !== h3 }, {
  assign: h3
});
var Bt = { exports: {} }, vr = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xf = Symbol.for("react.element"), lSe = Symbol.for("react.portal"), uSe = Symbol.for("react.fragment"), cSe = Symbol.for("react.strict_mode"), dSe = Symbol.for("react.profiler"), fSe = Symbol.for("react.provider"), vSe = Symbol.for("react.context"), hSe = Symbol.for("react.forward_ref"), pSe = Symbol.for("react.suspense"), gSe = Symbol.for("react.memo"), mSe = Symbol.for("react.lazy"), p3 = Symbol.iterator;
function bSe(e) {
  return e === null || typeof e != "object" ? null : (e = p3 && e[p3] || e["@@iterator"], typeof e == "function" ? e : null);
}
var D6 = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, N6 = Object.assign, L6 = {};
function Pc(e, r, t) {
  this.props = e, this.context = r, this.refs = L6, this.updater = t || D6;
}
Pc.prototype.isReactComponent = {};
Pc.prototype.setState = function(e, r) {
  if (typeof e != "object" && typeof e != "function" && e != null)
    throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, e, r, "setState");
};
Pc.prototype.forceUpdate = function(e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function F6() {
}
F6.prototype = Pc.prototype;
function Hw(e, r, t) {
  this.props = e, this.context = r, this.refs = L6, this.updater = t || D6;
}
var Gw = Hw.prototype = new F6();
Gw.constructor = Hw;
N6(Gw, Pc.prototype);
Gw.isPureReactComponent = !0;
var g3 = Array.isArray, z6 = Object.prototype.hasOwnProperty, Yw = { current: null }, B6 = { key: !0, ref: !0, __self: !0, __source: !0 };
function U6(e, r, t) {
  var n, a = {}, i = null, l = null;
  if (r != null)
    for (n in r.ref !== void 0 && (l = r.ref), r.key !== void 0 && (i = "" + r.key), r)
      z6.call(r, n) && !B6.hasOwnProperty(n) && (a[n] = r[n]);
  var u = arguments.length - 2;
  if (u === 1)
    a.children = t;
  else if (1 < u) {
    for (var c = Array(u), f = 0; f < u; f++)
      c[f] = arguments[f + 2];
    a.children = c;
  }
  if (e && e.defaultProps)
    for (n in u = e.defaultProps, u)
      a[n] === void 0 && (a[n] = u[n]);
  return { $$typeof: Xf, type: e, key: i, ref: l, props: a, _owner: Yw.current };
}
function ySe(e, r) {
  return { $$typeof: Xf, type: e.type, key: r, ref: e.ref, props: e.props, _owner: e._owner };
}
function Kw(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Xf;
}
function SSe(e) {
  var r = { "=": "=0", ":": "=2" };
  return "$" + e.replace(/[=:]/g, function(t) {
    return r[t];
  });
}
var m3 = /\/+/g;
function Sy(e, r) {
  return typeof e == "object" && e !== null && e.key != null ? SSe("" + e.key) : r.toString(36);
}
function kp(e, r, t, n, a) {
  var i = typeof e;
  (i === "undefined" || i === "boolean") && (e = null);
  var l = !1;
  if (e === null)
    l = !0;
  else
    switch (i) {
      case "string":
      case "number":
        l = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case Xf:
          case lSe:
            l = !0;
        }
    }
  if (l)
    return l = e, a = a(l), e = n === "" ? "." + Sy(l, 0) : n, g3(a) ? (t = "", e != null && (t = e.replace(m3, "$&/") + "/"), kp(a, r, t, "", function(f) {
      return f;
    })) : a != null && (Kw(a) && (a = ySe(a, t + (!a.key || l && l.key === a.key ? "" : ("" + a.key).replace(m3, "$&/") + "/") + e)), r.push(a)), 1;
  if (l = 0, n = n === "" ? "." : n + ":", g3(e))
    for (var u = 0; u < e.length; u++) {
      i = e[u];
      var c = n + Sy(i, u);
      l += kp(i, r, t, c, a);
    }
  else if (c = bSe(e), typeof c == "function")
    for (e = c.call(e), u = 0; !(i = e.next()).done; )
      i = i.value, c = n + Sy(i, u++), l += kp(i, r, t, c, a);
  else if (i === "object")
    throw r = String(e), Error("Objects are not valid as a React child (found: " + (r === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : r) + "). If you meant to render a collection of children, use an array instead.");
  return l;
}
function Nh(e, r, t) {
  if (e == null)
    return e;
  var n = [], a = 0;
  return kp(e, n, "", "", function(i) {
    return r.call(t, i, a++);
  }), n;
}
function xSe(e) {
  if (e._status === -1) {
    var r = e._result;
    r = r(), r.then(function(t) {
      (e._status === 0 || e._status === -1) && (e._status = 1, e._result = t);
    }, function(t) {
      (e._status === 0 || e._status === -1) && (e._status = 2, e._result = t);
    }), e._status === -1 && (e._status = 0, e._result = r);
  }
  if (e._status === 1)
    return e._result.default;
  throw e._result;
}
var jn = { current: null }, jp = { transition: null }, $Se = { ReactCurrentDispatcher: jn, ReactCurrentBatchConfig: jp, ReactCurrentOwner: Yw };
vr.Children = { map: Nh, forEach: function(e, r, t) {
  Nh(e, function() {
    r.apply(this, arguments);
  }, t);
}, count: function(e) {
  var r = 0;
  return Nh(e, function() {
    r++;
  }), r;
}, toArray: function(e) {
  return Nh(e, function(r) {
    return r;
  }) || [];
}, only: function(e) {
  if (!Kw(e))
    throw Error("React.Children.only expected to receive a single React element child.");
  return e;
} };
vr.Component = Pc;
vr.Fragment = uSe;
vr.Profiler = dSe;
vr.PureComponent = Hw;
vr.StrictMode = cSe;
vr.Suspense = pSe;
vr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = $Se;
vr.cloneElement = function(e, r, t) {
  if (e == null)
    throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
  var n = N6({}, e.props), a = e.key, i = e.ref, l = e._owner;
  if (r != null) {
    if (r.ref !== void 0 && (i = r.ref, l = Yw.current), r.key !== void 0 && (a = "" + r.key), e.type && e.type.defaultProps)
      var u = e.type.defaultProps;
    for (c in r)
      z6.call(r, c) && !B6.hasOwnProperty(c) && (n[c] = r[c] === void 0 && u !== void 0 ? u[c] : r[c]);
  }
  var c = arguments.length - 2;
  if (c === 1)
    n.children = t;
  else if (1 < c) {
    u = Array(c);
    for (var f = 0; f < c; f++)
      u[f] = arguments[f + 2];
    n.children = u;
  }
  return { $$typeof: Xf, type: e.type, key: a, ref: i, props: n, _owner: l };
};
vr.createContext = function(e) {
  return e = { $$typeof: vSe, _currentValue: e, _currentValue2: e, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, e.Provider = { $$typeof: fSe, _context: e }, e.Consumer = e;
};
vr.createElement = U6;
vr.createFactory = function(e) {
  var r = U6.bind(null, e);
  return r.type = e, r;
};
vr.createRef = function() {
  return { current: null };
};
vr.forwardRef = function(e) {
  return { $$typeof: hSe, render: e };
};
vr.isValidElement = Kw;
vr.lazy = function(e) {
  return { $$typeof: mSe, _payload: { _status: -1, _result: e }, _init: xSe };
};
vr.memo = function(e, r) {
  return { $$typeof: gSe, type: e, compare: r === void 0 ? null : r };
};
vr.startTransition = function(e) {
  var r = jp.transition;
  jp.transition = {};
  try {
    e();
  } finally {
    jp.transition = r;
  }
};
vr.unstable_act = function() {
  throw Error("act(...) is not supported in production builds of React.");
};
vr.useCallback = function(e, r) {
  return jn.current.useCallback(e, r);
};
vr.useContext = function(e) {
  return jn.current.useContext(e);
};
vr.useDebugValue = function() {
};
vr.useDeferredValue = function(e) {
  return jn.current.useDeferredValue(e);
};
vr.useEffect = function(e, r) {
  return jn.current.useEffect(e, r);
};
vr.useId = function() {
  return jn.current.useId();
};
vr.useImperativeHandle = function(e, r, t) {
  return jn.current.useImperativeHandle(e, r, t);
};
vr.useInsertionEffect = function(e, r) {
  return jn.current.useInsertionEffect(e, r);
};
vr.useLayoutEffect = function(e, r) {
  return jn.current.useLayoutEffect(e, r);
};
vr.useMemo = function(e, r) {
  return jn.current.useMemo(e, r);
};
vr.useReducer = function(e, r, t) {
  return jn.current.useReducer(e, r, t);
};
vr.useRef = function(e) {
  return jn.current.useRef(e);
};
vr.useState = function(e) {
  return jn.current.useState(e);
};
vr.useSyncExternalStore = function(e, r, t) {
  return jn.current.useSyncExternalStore(e, r, t);
};
vr.useTransition = function() {
  return jn.current.useTransition();
};
vr.version = "18.2.0";
Bt.exports = vr;
var wSe = Bt.exports, b3 = /* @__PURE__ */ Ome({
  __proto__: null,
  default: wSe
}, [Bt.exports]);
function _Se(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function TSe(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var CSe = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(a) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, i), n.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? !0 : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(TSe(this));
    var a = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = _Se(a);
      try {
        i.insertRule(n, i.cssRules.length);
      } catch (l) {
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), xn = "-ms-", A0 = "-moz-", Er = "-webkit-", V6 = "comm", Zw = "rule", qw = "decl", ESe = "@import", W6 = "@keyframes", ASe = Math.abs, Qg = String.fromCharCode, ISe = Object.assign;
function OSe(e, r) {
  return nn(e, 0) ^ 45 ? (((r << 2 ^ nn(e, 0)) << 2 ^ nn(e, 1)) << 2 ^ nn(e, 2)) << 2 ^ nn(e, 3) : 0;
}
function H6(e) {
  return e.trim();
}
function MSe(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function Pr(e, r, t) {
  return e.replace(r, t);
}
function Gx(e, r) {
  return e.indexOf(r);
}
function nn(e, r) {
  return e.charCodeAt(r) | 0;
}
function $f(e, r, t) {
  return e.slice(r, t);
}
function qo(e) {
  return e.length;
}
function Qw(e) {
  return e.length;
}
function Lh(e, r) {
  return r.push(e), e;
}
function RSe(e, r) {
  return e.map(r).join("");
}
var Xg = 1, yc = 1, G6 = 0, Zn = 0, kt = 0, kc = "";
function Jg(e, r, t, n, a, i, l) {
  return { value: e, root: r, parent: t, type: n, props: a, children: i, line: Xg, column: yc, length: l, return: "" };
}
function ld(e, r) {
  return ISe(Jg("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function PSe() {
  return kt;
}
function kSe() {
  return kt = Zn > 0 ? nn(kc, --Zn) : 0, yc--, kt === 10 && (yc = 1, Xg--), kt;
}
function ga() {
  return kt = Zn < G6 ? nn(kc, Zn++) : 0, yc++, kt === 10 && (yc = 1, Xg++), kt;
}
function ti() {
  return nn(kc, Zn);
}
function Dp() {
  return Zn;
}
function Jf(e, r) {
  return $f(kc, e, r);
}
function wf(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Y6(e) {
  return Xg = yc = 1, G6 = qo(kc = e), Zn = 0, [];
}
function K6(e) {
  return kc = "", e;
}
function Np(e) {
  return H6(Jf(Zn - 1, Yx(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function jSe(e) {
  for (; (kt = ti()) && kt < 33; )
    ga();
  return wf(e) > 2 || wf(kt) > 3 ? "" : " ";
}
function DSe(e, r) {
  for (; --r && ga() && !(kt < 48 || kt > 102 || kt > 57 && kt < 65 || kt > 70 && kt < 97); )
    ;
  return Jf(e, Dp() + (r < 6 && ti() == 32 && ga() == 32));
}
function Yx(e) {
  for (; ga(); )
    switch (kt) {
      case e:
        return Zn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Yx(kt);
        break;
      case 40:
        e === 41 && Yx(e);
        break;
      case 92:
        ga();
        break;
    }
  return Zn;
}
function NSe(e, r) {
  for (; ga() && e + kt !== 47 + 10; )
    if (e + kt === 42 + 42 && ti() === 47)
      break;
  return "/*" + Jf(r, Zn - 1) + "*" + Qg(e === 47 ? e : ga());
}
function LSe(e) {
  for (; !wf(ti()); )
    ga();
  return Jf(e, Zn);
}
function y3(e) {
  return K6(Lp("", null, null, null, [""], e = Y6(e), 0, [0], e));
}
function Lp(e, r, t, n, a, i, l, u, c) {
  for (var f = 0, h = 0, p = l, g = 0, y = 0, S = 0, x = 1, _ = 1, A = 1, O = 0, P = "", j = a, k = i, L = n, M = P; _; )
    switch (S = O, O = ga()) {
      case 40:
        if (S != 108 && nn(M, p - 1) == 58) {
          Gx(M += Pr(Np(O), "&", "&\f"), "&\f") != -1 && (A = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        M += Np(O);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        M += jSe(S);
        break;
      case 92:
        M += DSe(Dp() - 1, 7);
        continue;
      case 47:
        switch (ti()) {
          case 42:
          case 47:
            Lh(FSe(NSe(ga(), Dp()), r, t), c);
            break;
          default:
            M += "/";
        }
        break;
      case 123 * x:
        u[f++] = qo(M) * A;
      case 125 * x:
      case 59:
      case 0:
        switch (O) {
          case 0:
          case 125:
            _ = 0;
          case 59 + h:
            y > 0 && qo(M) - p && Lh(y > 32 ? x3(M + ";", n, t, p - 1) : x3(Pr(M, " ", "") + ";", n, t, p - 2), c);
            break;
          case 59:
            M += ";";
          default:
            if (Lh(L = S3(M, r, t, f, h, a, u, P, j = [], k = [], p), i), O === 123)
              if (h === 0)
                Lp(M, r, L, L, j, i, p, u, k);
              else
                switch (g === 99 && nn(M, 3) === 110 ? 100 : g) {
                  case 100:
                  case 109:
                  case 115:
                    Lp(e, L, L, n && Lh(S3(e, L, L, 0, 0, a, u, P, a, j = [], p), k), a, k, p, u, n ? j : k);
                    break;
                  default:
                    Lp(M, L, L, L, [""], k, 0, u, k);
                }
        }
        f = h = y = 0, x = A = 1, P = M = "", p = l;
        break;
      case 58:
        p = 1 + qo(M), y = S;
      default:
        if (x < 1) {
          if (O == 123)
            --x;
          else if (O == 125 && x++ == 0 && kSe() == 125)
            continue;
        }
        switch (M += Qg(O), O * x) {
          case 38:
            A = h > 0 ? 1 : (M += "\f", -1);
            break;
          case 44:
            u[f++] = (qo(M) - 1) * A, A = 1;
            break;
          case 64:
            ti() === 45 && (M += Np(ga())), g = ti(), h = p = qo(P = M += LSe(Dp())), O++;
            break;
          case 45:
            S === 45 && qo(M) == 2 && (x = 0);
        }
    }
  return i;
}
function S3(e, r, t, n, a, i, l, u, c, f, h) {
  for (var p = a - 1, g = a === 0 ? i : [""], y = Qw(g), S = 0, x = 0, _ = 0; S < n; ++S)
    for (var A = 0, O = $f(e, p + 1, p = ASe(x = l[S])), P = e; A < y; ++A)
      (P = H6(x > 0 ? g[A] + " " + O : Pr(O, /&\f/g, g[A]))) && (c[_++] = P);
  return Jg(e, r, t, a === 0 ? Zw : u, c, f, h);
}
function FSe(e, r, t) {
  return Jg(e, r, t, V6, Qg(PSe()), $f(e, 2, -2), 0);
}
function x3(e, r, t, n) {
  return Jg(e, r, t, qw, $f(e, 0, n), $f(e, n + 1, -1), n);
}
function Ql(e, r) {
  for (var t = "", n = Qw(e), a = 0; a < n; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function $3(e, r, t, n) {
  switch (e.type) {
    case ESe:
    case qw:
      return e.return = e.return || e.value;
    case V6:
      return "";
    case W6:
      return e.return = e.value + "{" + Ql(e.children, n) + "}";
    case Zw:
      e.value = e.props.join(",");
  }
  return qo(t = Ql(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function w3(e) {
  var r = Qw(e);
  return function(t, n, a, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](t, n, a, i) || "";
    return l;
  };
}
function zSe(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
var BSe = function(r) {
  var t = /* @__PURE__ */ new WeakMap();
  return function(n) {
    if (t.has(n))
      return t.get(n);
    var a = r(n);
    return t.set(n, a), a;
  };
};
function Xw(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var USe = function(r, t, n) {
  for (var a = 0, i = 0; a = i, i = ti(), a === 38 && i === 12 && (t[n] = 1), !wf(i); )
    ga();
  return Jf(r, Zn);
}, VSe = function(r, t) {
  var n = -1, a = 44;
  do
    switch (wf(a)) {
      case 0:
        a === 38 && ti() === 12 && (t[n] = 1), r[n] += USe(Zn - 1, t, n);
        break;
      case 2:
        r[n] += Np(a);
        break;
      case 4:
        if (a === 44) {
          r[++n] = ti() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += Qg(a);
    }
  while (a = ga());
  return r;
}, WSe = function(r, t) {
  return K6(VSe(Y6(r), t));
}, _3 = /* @__PURE__ */ new WeakMap(), HSe = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, a = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !_3.get(n)) && !a) {
      _3.set(r, !0);
      for (var i = [], l = WSe(t, i), u = n.props, c = 0, f = 0; c < l.length; c++)
        for (var h = 0; h < u.length; h++, f++)
          r.props[f] = i[c] ? l[c].replace(/&\f/g, u[h]) : u[h] + " " + l[c];
    }
  }
}, GSe = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
};
function Z6(e, r) {
  switch (OSe(e, r)) {
    case 5103:
      return Er + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Er + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Er + e + A0 + e + xn + e + e;
    case 6828:
    case 4268:
      return Er + e + xn + e + e;
    case 6165:
      return Er + e + xn + "flex-" + e + e;
    case 5187:
      return Er + e + Pr(e, /(\w+).+(:[^]+)/, Er + "box-$1$2" + xn + "flex-$1$2") + e;
    case 5443:
      return Er + e + xn + "flex-item-" + Pr(e, /flex-|-self/, "") + e;
    case 4675:
      return Er + e + xn + "flex-line-pack" + Pr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Er + e + xn + Pr(e, "shrink", "negative") + e;
    case 5292:
      return Er + e + xn + Pr(e, "basis", "preferred-size") + e;
    case 6060:
      return Er + "box-" + Pr(e, "-grow", "") + Er + e + xn + Pr(e, "grow", "positive") + e;
    case 4554:
      return Er + Pr(e, /([^-])(transform)/g, "$1" + Er + "$2") + e;
    case 6187:
      return Pr(Pr(Pr(e, /(zoom-|grab)/, Er + "$1"), /(image-set)/, Er + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Pr(e, /(image-set\([^]*)/, Er + "$1$`$1");
    case 4968:
      return Pr(Pr(e, /(.+:)(flex-)?(.*)/, Er + "box-pack:$3" + xn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Er + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Pr(e, /(.+)-inline(.+)/, Er + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (qo(e) - 1 - r > 6)
        switch (nn(e, r + 1)) {
          case 109:
            if (nn(e, r + 4) !== 45)
              break;
          case 102:
            return Pr(e, /(.+:)(.+)-([^]+)/, "$1" + Er + "$2-$3$1" + A0 + (nn(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Gx(e, "stretch") ? Z6(Pr(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (nn(e, r + 1) !== 115)
        break;
    case 6444:
      switch (nn(e, qo(e) - 3 - (~Gx(e, "!important") && 10))) {
        case 107:
          return Pr(e, ":", ":" + Er) + e;
        case 101:
          return Pr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Er + (nn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Er + "$2$3$1" + xn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (nn(e, r + 11)) {
        case 114:
          return Er + e + xn + Pr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Er + e + xn + Pr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Er + e + xn + Pr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Er + e + xn + e + e;
  }
  return e;
}
var YSe = function(r, t, n, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case qw:
        r.return = Z6(r.value, r.length);
        break;
      case W6:
        return Ql([ld(r, {
          value: Pr(r.value, "@", "@" + Er)
        })], a);
      case Zw:
        if (r.length)
          return RSe(r.props, function(i) {
            switch (MSe(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Ql([ld(r, {
                  props: [Pr(i, /:(read-\w+)/, ":" + A0 + "$1")]
                })], a);
              case "::placeholder":
                return Ql([ld(r, {
                  props: [Pr(i, /:(plac\w+)/, ":" + Er + "input-$1")]
                }), ld(r, {
                  props: [Pr(i, /:(plac\w+)/, ":" + A0 + "$1")]
                }), ld(r, {
                  props: [Pr(i, /:(plac\w+)/, xn + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, Fp = typeof document != "undefined", KSe = Fp ? void 0 : BSe(function() {
  return Xw(function() {
    var e = {};
    return function(r) {
      return e[r];
    };
  });
}), ZSe = [YSe], q6 = function(r) {
  var t = r.key;
  if (Fp && t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(j) {
      var k = j.getAttribute("data-emotion");
      k.indexOf(" ") !== -1 && (document.head.appendChild(j), j.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || ZSe, i = {}, l, u = [];
  Fp && (l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(j) {
      for (var k = j.getAttribute("data-emotion").split(" "), L = 1; L < k.length; L++)
        i[k[L]] = !0;
      u.push(j);
    }
  ));
  var c, f = [HSe, GSe];
  if (Fp) {
    var h, p = [$3, zSe(function(j) {
      h.insert(j);
    })], g = w3(f.concat(a, p)), y = function(k) {
      return Ql(y3(k), g);
    };
    c = function(k, L, M, W) {
      h = M, y(k ? k + "{" + L.styles + "}" : L.styles), W && (P.inserted[L.name] = !0);
    };
  } else {
    var S = [$3], x = w3(f.concat(a, S)), _ = function(k) {
      return Ql(y3(k), x);
    }, A = KSe(a)(t), O = function(k, L) {
      var M = L.name;
      return A[M] === void 0 && (A[M] = _(k ? k + "{" + L.styles + "}" : L.styles)), A[M];
    };
    c = function(k, L, M, W) {
      var Z = L.name, oe = O(k, L);
      if (P.compat === void 0)
        return W && (P.inserted[Z] = !0), oe;
      if (W)
        P.inserted[Z] = oe;
      else
        return oe;
    };
  }
  var P = {
    key: t,
    sheet: new CSe({
      key: t,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return P.sheet.hydrate(u), P;
};
function Kx() {
  return Kx = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Kx.apply(this, arguments);
}
var Q6 = { exports: {} }, Ur = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kt = typeof Symbol == "function" && Symbol.for, Jw = Kt ? Symbol.for("react.element") : 60103, e_ = Kt ? Symbol.for("react.portal") : 60106, em = Kt ? Symbol.for("react.fragment") : 60107, rm = Kt ? Symbol.for("react.strict_mode") : 60108, tm = Kt ? Symbol.for("react.profiler") : 60114, nm = Kt ? Symbol.for("react.provider") : 60109, am = Kt ? Symbol.for("react.context") : 60110, r_ = Kt ? Symbol.for("react.async_mode") : 60111, om = Kt ? Symbol.for("react.concurrent_mode") : 60111, im = Kt ? Symbol.for("react.forward_ref") : 60112, sm = Kt ? Symbol.for("react.suspense") : 60113, qSe = Kt ? Symbol.for("react.suspense_list") : 60120, lm = Kt ? Symbol.for("react.memo") : 60115, um = Kt ? Symbol.for("react.lazy") : 60116, QSe = Kt ? Symbol.for("react.block") : 60121, XSe = Kt ? Symbol.for("react.fundamental") : 60117, JSe = Kt ? Symbol.for("react.responder") : 60118, exe = Kt ? Symbol.for("react.scope") : 60119;
function wa(e) {
  if (typeof e == "object" && e !== null) {
    var r = e.$$typeof;
    switch (r) {
      case Jw:
        switch (e = e.type, e) {
          case r_:
          case om:
          case em:
          case tm:
          case rm:
          case sm:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case am:
              case im:
              case um:
              case lm:
              case nm:
                return e;
              default:
                return r;
            }
        }
      case e_:
        return r;
    }
  }
}
function X6(e) {
  return wa(e) === om;
}
Ur.AsyncMode = r_;
Ur.ConcurrentMode = om;
Ur.ContextConsumer = am;
Ur.ContextProvider = nm;
Ur.Element = Jw;
Ur.ForwardRef = im;
Ur.Fragment = em;
Ur.Lazy = um;
Ur.Memo = lm;
Ur.Portal = e_;
Ur.Profiler = tm;
Ur.StrictMode = rm;
Ur.Suspense = sm;
Ur.isAsyncMode = function(e) {
  return X6(e) || wa(e) === r_;
};
Ur.isConcurrentMode = X6;
Ur.isContextConsumer = function(e) {
  return wa(e) === am;
};
Ur.isContextProvider = function(e) {
  return wa(e) === nm;
};
Ur.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Jw;
};
Ur.isForwardRef = function(e) {
  return wa(e) === im;
};
Ur.isFragment = function(e) {
  return wa(e) === em;
};
Ur.isLazy = function(e) {
  return wa(e) === um;
};
Ur.isMemo = function(e) {
  return wa(e) === lm;
};
Ur.isPortal = function(e) {
  return wa(e) === e_;
};
Ur.isProfiler = function(e) {
  return wa(e) === tm;
};
Ur.isStrictMode = function(e) {
  return wa(e) === rm;
};
Ur.isSuspense = function(e) {
  return wa(e) === sm;
};
Ur.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === em || e === om || e === tm || e === rm || e === sm || e === qSe || typeof e == "object" && e !== null && (e.$$typeof === um || e.$$typeof === lm || e.$$typeof === nm || e.$$typeof === am || e.$$typeof === im || e.$$typeof === XSe || e.$$typeof === JSe || e.$$typeof === exe || e.$$typeof === QSe);
};
Ur.typeOf = wa;
Q6.exports = Ur;
var J6 = Q6.exports, rxe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, txe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, e8 = {};
e8[J6.ForwardRef] = rxe;
e8[J6.Memo] = txe;
var Zx = typeof document != "undefined";
function nxe(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : n += a + " ";
  }), n;
}
var r8 = function(r, t, n) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Zx === !1 && r.compat !== void 0) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, axe = function(r, t, n) {
  r8(r, t, n);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = "", l = t;
    do {
      var u = r.insert(t === l ? "." + a : "", l, r.sheet, !0);
      !Zx && u !== void 0 && (i += u), l = l.next;
    } while (l !== void 0);
    if (!Zx && i.length !== 0)
      return i;
  }
};
function oxe(e) {
  for (var r = 0, t, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var ixe = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, sxe = /[A-Z]|^ms/g, lxe = /_EMO_([^_]+?)_([^]*?)_EMO_/g, t8 = function(r) {
  return r.charCodeAt(1) === 45;
}, T3 = function(r) {
  return r != null && typeof r != "boolean";
}, xy = /* @__PURE__ */ Xw(function(e) {
  return t8(e) ? e : e.replace(sxe, "-$&").toLowerCase();
}), C3 = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(lxe, function(n, a, i) {
          return Qo = {
            name: a,
            styles: i,
            next: Qo
          }, a;
        });
  }
  return ixe[r] !== 1 && !t8(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
function _f(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0)
    return t;
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return Qo = {
          name: t.name,
          styles: t.styles,
          next: Qo
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            Qo = {
              name: n.name,
              styles: n.styles,
              next: Qo
            }, n = n.next;
        var a = t.styles + ";";
        return a;
      }
      return uxe(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = Qo, l = t(e);
        return Qo = i, _f(e, r, l);
      }
      break;
    }
  }
  if (r == null)
    return t;
  var u = r[t];
  return u !== void 0 ? u : t;
}
function uxe(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      n += _f(e, r, t[a]) + ";";
  else
    for (var i in t) {
      var l = t[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? n += i + "{" + r[l] + "}" : T3(l) && (n += xy(i) + ":" + C3(i, l) + ";");
      else if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
        for (var u = 0; u < l.length; u++)
          T3(l[u]) && (n += xy(i) + ":" + C3(i, l[u]) + ";");
      else {
        var c = _f(e, r, l);
        switch (i) {
          case "animation":
          case "animationName": {
            n += xy(i) + ":" + c + ";";
            break;
          }
          default:
            n += i + "{" + c + "}";
        }
      }
    }
  return n;
}
var E3 = /label:\s*([^\s;\n{]+)\s*(;|$)/g, Qo, n8 = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, i = "";
  Qo = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (a = !1, i += _f(n, t, l)) : i += l[0];
  for (var u = 1; u < r.length; u++)
    i += _f(n, t, r[u]), a && (i += l[u]);
  E3.lastIndex = 0;
  for (var c = "", f; (f = E3.exec(i)) !== null; )
    c += "-" + // $FlowFixMe we know it's not null
    f[1];
  var h = oxe(i) + c;
  return {
    name: h,
    styles: i,
    next: Qo
  };
}, cxe = typeof document != "undefined", A3 = function(r) {
  return r();
}, a8 = b3["useInsertionEffect"] ? b3["useInsertionEffect"] : !1, dxe = cxe && a8 || A3;
a8 || Bt.exports.useLayoutEffect;
var fxe = typeof document != "undefined", I0 = /* @__PURE__ */ Bt.exports.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement != "undefined" ? /* @__PURE__ */ q6({
    key: "css"
  }) : null
);
I0.Provider;
var o8 = function(r) {
  return /* @__PURE__ */ Bt.exports.forwardRef(function(t, n) {
    var a = Bt.exports.useContext(I0);
    return r(t, a, n);
  });
};
fxe || (o8 = function(r) {
  return function(t) {
    var n = Bt.exports.useContext(I0);
    return n === null ? (n = q6({
      key: "css"
    }), /* @__PURE__ */ Bt.exports.createElement(I0.Provider, {
      value: n
    }, r(t, n))) : r(t, n);
  };
});
var vxe = /* @__PURE__ */ Bt.exports.createContext({});
function hxe() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return n8(r);
}
var pxe = function() {
  var r = hxe.apply(void 0, arguments), t = "animation-" + r.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + r.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, qx = { exports: {} };
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", a = 800, i = 16, l = 9007199254740991, u = "[object Arguments]", c = "[object Array]", f = "[object AsyncFunction]", h = "[object Boolean]", p = "[object Date]", g = "[object Error]", y = "[object Function]", S = "[object GeneratorFunction]", x = "[object Map]", _ = "[object Number]", A = "[object Null]", O = "[object Object]", P = "[object Proxy]", j = "[object RegExp]", k = "[object Set]", L = "[object String]", M = "[object Undefined]", W = "[object WeakMap]", Z = "[object ArrayBuffer]", oe = "[object DataView]", Ie = "[object Float32Array]", Te = "[object Float64Array]", Ee = "[object Int8Array]", Me = "[object Int16Array]", Fe = "[object Int32Array]", Ge = "[object Uint8Array]", ze = "[object Uint8ClampedArray]", le = "[object Uint16Array]", ce = "[object Uint32Array]", he = /[\\^$.*+?()[\]{}|]/g, be = /^\[object .+?Constructor\]$/, ye = /^(?:0|[1-9]\d*)$/, q = {};
  q[Ie] = q[Te] = q[Ee] = q[Me] = q[Fe] = q[Ge] = q[ze] = q[le] = q[ce] = !0, q[u] = q[c] = q[Z] = q[h] = q[oe] = q[p] = q[g] = q[y] = q[x] = q[_] = q[O] = q[j] = q[k] = q[L] = q[W] = !1;
  var ae = typeof Wl == "object" && Wl && Wl.Object === Object && Wl, ue = typeof self == "object" && self && self.Object === Object && self, $e = ae || ue || Function("return this")(), Ze = r && !r.nodeType && r, _e = Ze && !0 && e && !e.nodeType && e, or = _e && _e.exports === Ze, Yr = or && ae.process, mr = function() {
    try {
      var v = _e && _e.require && _e.require("util").types;
      return v || Yr && Yr.binding && Yr.binding("util");
    } catch (b) {
    }
  }(), rt = mr && mr.isTypedArray;
  function Je(v, b, $) {
    switch ($.length) {
      case 0:
        return v.call(b);
      case 1:
        return v.call(b, $[0]);
      case 2:
        return v.call(b, $[0], $[1]);
      case 3:
        return v.call(b, $[0], $[1], $[2]);
    }
    return v.apply(b, $);
  }
  function Ir(v, b) {
    for (var $ = -1, N = Array(v); ++$ < v; )
      N[$] = b($);
    return N;
  }
  function wt(v) {
    return function(b) {
      return v(b);
    };
  }
  function Kr(v, b) {
    return v == null ? void 0 : v[b];
  }
  function jr(v, b) {
    return function($) {
      return v(b($));
    };
  }
  var jt = Array.prototype, gt = Function.prototype, pr = Object.prototype, br = $e["__core-js_shared__"], G = gt.toString, te = pr.hasOwnProperty, Y = function() {
    var v = /[^.]+$/.exec(br && br.keys && br.keys.IE_PROTO || "");
    return v ? "Symbol(src)_1." + v : "";
  }(), Q = pr.toString, Ce = G.call(Object), me = RegExp(
    "^" + G.call(te).replace(he, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Re = or ? $e.Buffer : void 0, ur = $e.Symbol, Sr = $e.Uint8Array, lr = Re ? Re.allocUnsafe : void 0, ct = jr(Object.getPrototypeOf, Object), at = Object.create, mt = pr.propertyIsEnumerable, Ct = jt.splice, dr = ur ? ur.toStringTag : void 0, Zr = function() {
    try {
      var v = Nn(Object, "defineProperty");
      return v({}, "", {}), v;
    } catch (b) {
    }
  }(), cn = Re ? Re.isBuffer : void 0, dn = Math.max, Ka = Date.now, wn = Nn($e, "Map"), pe = Nn(Object, "create"), je = function() {
    function v() {
    }
    return function(b) {
      if (!qr(b))
        return {};
      if (at)
        return at(b);
      v.prototype = b;
      var $ = new v();
      return v.prototype = void 0, $;
    };
  }();
  function er(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Dt() {
    this.__data__ = pe ? pe(null) : {}, this.size = 0;
  }
  function ot(v) {
    var b = this.has(v) && delete this.__data__[v];
    return this.size -= b ? 1 : 0, b;
  }
  function Dn(v) {
    var b = this.__data__;
    if (pe) {
      var $ = b[v];
      return $ === n ? void 0 : $;
    }
    return te.call(b, v) ? b[v] : void 0;
  }
  function xe(v) {
    var b = this.__data__;
    return pe ? b[v] !== void 0 : te.call(b, v);
  }
  function Ae(v, b) {
    var $ = this.__data__;
    return this.size += this.has(v) ? 0 : 1, $[v] = pe && b === void 0 ? n : b, this;
  }
  er.prototype.clear = Dt, er.prototype.delete = ot, er.prototype.get = Dn, er.prototype.has = xe, er.prototype.set = Ae;
  function Se(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Pe() {
    this.__data__ = [], this.size = 0;
  }
  function rr(v) {
    var b = this.__data__, $ = Nt(b, v);
    if ($ < 0)
      return !1;
    var N = b.length - 1;
    return $ == N ? b.pop() : Ct.call(b, $, 1), --this.size, !0;
  }
  function Vr(v) {
    var b = this.__data__, $ = Nt(b, v);
    return $ < 0 ? void 0 : b[$][1];
  }
  function Zt(v) {
    return Nt(this.__data__, v) > -1;
  }
  function qt(v, b) {
    var $ = this.__data__, N = Nt($, v);
    return N < 0 ? (++this.size, $.push([v, b])) : $[N][1] = b, this;
  }
  Se.prototype.clear = Pe, Se.prototype.delete = rr, Se.prototype.get = Vr, Se.prototype.has = Zt, Se.prototype.set = qt;
  function Or(v) {
    var b = -1, $ = v == null ? 0 : v.length;
    for (this.clear(); ++b < $; ) {
      var N = v[b];
      this.set(N[0], N[1]);
    }
  }
  function Za() {
    this.size = 0, this.__data__ = {
      hash: new er(),
      map: new (wn || Se)(),
      string: new er()
    };
  }
  function Ys(v) {
    var b = hn(this, v).delete(v);
    return this.size -= b ? 1 : 0, b;
  }
  function Ks(v) {
    return hn(this, v).get(v);
  }
  function Zs(v) {
    return hn(this, v).has(v);
  }
  function qs(v, b) {
    var $ = hn(this, v), N = $.size;
    return $.set(v, b), this.size += $.size == N ? 0 : 1, this;
  }
  Or.prototype.clear = Za, Or.prototype.delete = Ys, Or.prototype.get = Ks, Or.prototype.has = Zs, Or.prototype.set = qs;
  function bt(v) {
    var b = this.__data__ = new Se(v);
    this.size = b.size;
  }
  function Qs() {
    this.__data__ = new Se(), this.size = 0;
  }
  function Xs(v) {
    var b = this.__data__, $ = b.delete(v);
    return this.size = b.size, $;
  }
  function Js(v) {
    return this.__data__.get(v);
  }
  function el(v) {
    return this.__data__.has(v);
  }
  function rl(v, b) {
    var $ = this.__data__;
    if ($ instanceof Se) {
      var N = $.__data__;
      if (!wn || N.length < t - 1)
        return N.push([v, b]), this.size = ++$.size, this;
      $ = this.__data__ = new Or(N);
    }
    return $.set(v, b), this.size = $.size, this;
  }
  bt.prototype.clear = Qs, bt.prototype.delete = Xs, bt.prototype.get = Js, bt.prototype.has = el, bt.prototype.set = rl;
  function tl(v, b) {
    var $ = ea(v), N = !$ && Jn(v), ie = !$ && !N && Oo(v), ve = !$ && !N && !ie && Ro(v), de = $ || N || ie || ve, ne = de ? Ir(v.length, String) : [], ge = ne.length;
    for (var tr in v)
      (b || te.call(v, tr)) && !(de && // Safari 9 has enumerable `arguments.length` in strict mode.
      (tr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      ie && (tr == "offset" || tr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      ve && (tr == "buffer" || tr == "byteLength" || tr == "byteOffset") || // Skip index properties.
      Io(tr, ge))) && ne.push(tr);
    return ne;
  }
  function fn(v, b, $) {
    ($ !== void 0 && !pn(v[b], $) || $ === void 0 && !(b in v)) && Xn(v, b, $);
  }
  function nl(v, b, $) {
    var N = v[b];
    (!(te.call(v, b) && pn(N, $)) || $ === void 0 && !(b in v)) && Xn(v, b, $);
  }
  function Nt(v, b) {
    for (var $ = v.length; $--; )
      if (pn(v[$][0], b))
        return $;
    return -1;
  }
  function Xn(v, b, $) {
    b == "__proto__" && Zr ? Zr(v, b, {
      configurable: !0,
      enumerable: !0,
      value: $,
      writable: !0
    }) : v[b] = $;
  }
  var al = Zi();
  function vn(v) {
    return v == null ? v === void 0 ? M : A : dr && dr in Object(v) ? qi(v) : Ji(v);
  }
  function qa(v) {
    return Lt(v) && vn(v) == u;
  }
  function Vi(v) {
    if (!qr(v) || vi(v))
      return !1;
    var b = ra(v) ? me : be;
    return b.test(ts(v));
  }
  function Wi(v) {
    return Lt(v) && Mo(v.length) && !!q[vn(v)];
  }
  function ol(v) {
    if (!qr(v))
      return Xi(v);
    var b = _n(v), $ = [];
    for (var N in v)
      N == "constructor" && (b || !te.call(v, N)) || $.push(N);
    return $;
  }
  function Eo(v, b, $, N, ie) {
    v !== b && al(b, function(ve, de) {
      if (ie || (ie = new bt()), qr(ve))
        il(v, b, de, $, Eo, N, ie);
      else {
        var ne = N ? N(Ln(v, de), ve, de + "", v, b, ie) : void 0;
        ne === void 0 && (ne = ve), fn(v, de, ne);
      }
    }, Po);
  }
  function il(v, b, $, N, ie, ve, de) {
    var ne = Ln(v, $), ge = Ln(b, $), tr = de.get(ge);
    if (tr) {
      fn(v, $, tr);
      return;
    }
    var Ke = ve ? ve(ne, ge, $ + "", v, b, de) : void 0, Mr = Ke === void 0;
    if (Mr) {
      var zn = ea(ge), Bn = !zn && Oo(ge), Qa = !zn && !Bn && Ro(ge);
      Ke = ge, zn || Bn || Qa ? ea(ne) ? Ke = ne : cl(ne) ? Ke = ll(ne) : Bn ? (Mr = !1, Ke = Gi(ge, !0)) : Qa ? (Mr = !1, Ke = ci(ge, !0)) : Ke = [] : dl(ge) || Jn(ge) ? (Ke = ne, Jn(ne) ? Ke = fl(ne) : (!qr(ne) || ra(ne)) && (Ke = di(ge))) : Mr = !1;
    }
    Mr && (de.set(ge, Ke), ie(Ke, ge, N, ve, de), de.delete(ge)), fn(v, $, Ke);
  }
  function sl(v, b) {
    return es(ul(v, b, ko), v + "");
  }
  var Hi = Zr ? function(v, b) {
    return Zr(v, "toString", {
      configurable: !0,
      enumerable: !1,
      value: yr(b),
      writable: !0
    });
  } : ko;
  function Gi(v, b) {
    if (b)
      return v.slice();
    var $ = v.length, N = lr ? lr($) : new v.constructor($);
    return v.copy(N), N;
  }
  function Yi(v) {
    var b = new v.constructor(v.byteLength);
    return new Sr(b).set(new Sr(v)), b;
  }
  function ci(v, b) {
    var $ = b ? Yi(v.buffer) : v.buffer;
    return new v.constructor($, v.byteOffset, v.length);
  }
  function ll(v, b) {
    var $ = -1, N = v.length;
    for (b || (b = Array(N)); ++$ < N; )
      b[$] = v[$];
    return b;
  }
  function Ki(v, b, $, N) {
    var ie = !$;
    $ || ($ = {});
    for (var ve = -1, de = b.length; ++ve < de; ) {
      var ne = b[ve], ge = N ? N($[ne], v[ne], ne, $, v) : void 0;
      ge === void 0 && (ge = v[ne]), ie ? Xn($, ne, ge) : nl($, ne, ge);
    }
    return $;
  }
  function Ao(v) {
    return sl(function(b, $) {
      var N = -1, ie = $.length, ve = ie > 1 ? $[ie - 1] : void 0, de = ie > 2 ? $[2] : void 0;
      for (ve = v.length > 3 && typeof ve == "function" ? (ie--, ve) : void 0, de && Qi($[0], $[1], de) && (ve = ie < 3 ? void 0 : ve, ie = 1), b = Object(b); ++N < ie; ) {
        var ne = $[N];
        ne && v(b, ne, N, ve);
      }
      return b;
    });
  }
  function Zi(v) {
    return function(b, $, N) {
      for (var ie = -1, ve = Object(b), de = N(b), ne = de.length; ne--; ) {
        var ge = de[v ? ne : ++ie];
        if ($(ve[ge], ge, ve) === !1)
          break;
      }
      return b;
    };
  }
  function hn(v, b) {
    var $ = v.__data__;
    return fi(b) ? $[typeof b == "string" ? "string" : "hash"] : $.map;
  }
  function Nn(v, b) {
    var $ = Kr(v, b);
    return Vi($) ? $ : void 0;
  }
  function qi(v) {
    var b = te.call(v, dr), $ = v[dr];
    try {
      v[dr] = void 0;
      var N = !0;
    } catch (ve) {
    }
    var ie = Q.call(v);
    return N && (b ? v[dr] = $ : delete v[dr]), ie;
  }
  function di(v) {
    return typeof v.constructor == "function" && !_n(v) ? je(ct(v)) : {};
  }
  function Io(v, b) {
    var $ = typeof v;
    return b = b == null ? l : b, !!b && ($ == "number" || $ != "symbol" && ye.test(v)) && v > -1 && v % 1 == 0 && v < b;
  }
  function Qi(v, b, $) {
    if (!qr($))
      return !1;
    var N = typeof b;
    return (N == "number" ? Fn($) && Io(b, $.length) : N == "string" && b in $) ? pn($[b], v) : !1;
  }
  function fi(v) {
    var b = typeof v;
    return b == "string" || b == "number" || b == "symbol" || b == "boolean" ? v !== "__proto__" : v === null;
  }
  function vi(v) {
    return !!Y && Y in v;
  }
  function _n(v) {
    var b = v && v.constructor, $ = typeof b == "function" && b.prototype || pr;
    return v === $;
  }
  function Xi(v) {
    var b = [];
    if (v != null)
      for (var $ in Object(v))
        b.push($);
    return b;
  }
  function Ji(v) {
    return Q.call(v);
  }
  function ul(v, b, $) {
    return b = dn(b === void 0 ? v.length - 1 : b, 0), function() {
      for (var N = arguments, ie = -1, ve = dn(N.length - b, 0), de = Array(ve); ++ie < ve; )
        de[ie] = N[b + ie];
      ie = -1;
      for (var ne = Array(b + 1); ++ie < b; )
        ne[ie] = N[ie];
      return ne[b] = $(de), Je(v, this, ne);
    };
  }
  function Ln(v, b) {
    if (!(b === "constructor" && typeof v[b] == "function") && b != "__proto__")
      return v[b];
  }
  var es = rs(Hi);
  function rs(v) {
    var b = 0, $ = 0;
    return function() {
      var N = Ka(), ie = i - (N - $);
      if ($ = N, ie > 0) {
        if (++b >= a)
          return arguments[0];
      } else
        b = 0;
      return v.apply(void 0, arguments);
    };
  }
  function ts(v) {
    if (v != null) {
      try {
        return G.call(v);
      } catch (b) {
      }
      try {
        return v + "";
      } catch (b) {
      }
    }
    return "";
  }
  function pn(v, b) {
    return v === b || v !== v && b !== b;
  }
  var Jn = qa(function() {
    return arguments;
  }()) ? qa : function(v) {
    return Lt(v) && te.call(v, "callee") && !mt.call(v, "callee");
  }, ea = Array.isArray;
  function Fn(v) {
    return v != null && Mo(v.length) && !ra(v);
  }
  function cl(v) {
    return Lt(v) && Fn(v);
  }
  var Oo = cn || vl;
  function ra(v) {
    if (!qr(v))
      return !1;
    var b = vn(v);
    return b == y || b == S || b == f || b == P;
  }
  function Mo(v) {
    return typeof v == "number" && v > -1 && v % 1 == 0 && v <= l;
  }
  function qr(v) {
    var b = typeof v;
    return v != null && (b == "object" || b == "function");
  }
  function Lt(v) {
    return v != null && typeof v == "object";
  }
  function dl(v) {
    if (!Lt(v) || vn(v) != O)
      return !1;
    var b = ct(v);
    if (b === null)
      return !0;
    var $ = te.call(b, "constructor") && b.constructor;
    return typeof $ == "function" && $ instanceof $ && G.call($) == Ce;
  }
  var Ro = rt ? wt(rt) : Wi;
  function fl(v) {
    return Ki(v, Po(v));
  }
  function Po(v) {
    return Fn(v) ? tl(v, !0) : ol(v);
  }
  var xr = Ao(function(v, b, $, N) {
    Eo(v, b, $, N);
  });
  function yr(v) {
    return function() {
      return v;
    };
  }
  function ko(v) {
    return v;
  }
  function vl() {
    return !1;
  }
  e.exports = xr;
})(qx, qx.exports);
var Ms = qx.exports;
function $y(e) {
  return typeof e == "number";
}
function gxe(e) {
  return Array.isArray(e);
}
function Qu(e) {
  return typeof e == "function";
}
function ni(e) {
  var r = typeof e;
  return e != null && (r === "object" || r === "function") && !gxe(e);
}
function mxe(e) {
  return ni(e) && Object.keys(e).length === 0;
}
function t_(e) {
  return Object.prototype.toString.call(e) === "[object String]";
}
function i8(e) {
  return /^var\(--.+\)$/.test(e);
}
var bxe = !1;
function yxe(e, r, t, n) {
  var a = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < a.length && e; n += 1)
    e = e[a[n]];
  return e === void 0 ? t : e;
}
var Sxe = function(r) {
  var t = /* @__PURE__ */ new WeakMap(), n = function(i, l, u, c) {
    if (typeof i == "undefined")
      return r(i, l, u);
    t.has(i) || t.set(i, /* @__PURE__ */ new Map());
    var f = t.get(i);
    if (f.has(l))
      return f.get(l);
    var h = r(i, l, u, c);
    return f.set(l, h), h;
  };
  return n;
}, s8 = Sxe(yxe);
function l8(e, r) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var a = e[n], i = r(a, n, e);
    i && (t[n] = a);
  }), t;
}
var xxe = function(r) {
  return l8(r, function(t) {
    return t != null;
  });
}, u8 = function(r) {
  return Object.keys(r);
}, Qx = function(r) {
  return r.reduce(function(t, n) {
    var a = n[0], i = n[1];
    return t[a] = i, t;
  }, {});
};
function Xu(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return Qu(e) ? e.apply(void 0, t) : e;
}
function $xe(e) {
  var r;
  return function() {
    if (e) {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      r = e.apply(this, a), e = null;
    }
    return r;
  };
}
var wxe = $xe(function(e) {
  return function() {
    var r = e.condition, t = e.message;
    r && bxe && console.warn(t);
  };
}), _xe = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return function(a) {
    return t.reduce(function(i, l) {
      return l(i);
    }, a);
  };
};
function n_(e) {
  e === void 0 && (e = {});
  var r = e, t = r.strict, n = t === void 0 ? !0 : t, a = r.errorMessage, i = a === void 0 ? "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider" : a, l = r.name, u = /* @__PURE__ */ Bt.exports.createContext(void 0);
  u.displayName = l;
  function c() {
    var f = Bt.exports.useContext(u);
    if (!f && n) {
      var h = new Error(i);
      throw h.name = "ContextError", Error.captureStackTrace == null || Error.captureStackTrace(h, c), h;
    }
    return f;
  }
  return [u.Provider, c, u];
}
var c8 = { exports: {} }, d8 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(e) {
  function r(le, ce) {
    var he = le.length;
    le.push(ce);
    e:
      for (; 0 < he; ) {
        var be = he - 1 >>> 1, ye = le[be];
        if (0 < a(ye, ce))
          le[be] = ce, le[he] = ye, he = be;
        else
          break e;
      }
  }
  function t(le) {
    return le.length === 0 ? null : le[0];
  }
  function n(le) {
    if (le.length === 0)
      return null;
    var ce = le[0], he = le.pop();
    if (he !== ce) {
      le[0] = he;
      e:
        for (var be = 0, ye = le.length, q = ye >>> 1; be < q; ) {
          var ae = 2 * (be + 1) - 1, ue = le[ae], $e = ae + 1, Ze = le[$e];
          if (0 > a(ue, he))
            $e < ye && 0 > a(Ze, ue) ? (le[be] = Ze, le[$e] = he, be = $e) : (le[be] = ue, le[ae] = he, be = ae);
          else if ($e < ye && 0 > a(Ze, he))
            le[be] = Ze, le[$e] = he, be = $e;
          else
            break e;
        }
    }
    return ce;
  }
  function a(le, ce) {
    var he = le.sortIndex - ce.sortIndex;
    return he !== 0 ? he : le.id - ce.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var i = performance;
    e.unstable_now = function() {
      return i.now();
    };
  } else {
    var l = Date, u = l.now();
    e.unstable_now = function() {
      return l.now() - u;
    };
  }
  var c = [], f = [], h = 1, p = null, g = 3, y = !1, S = !1, x = !1, _ = typeof setTimeout == "function" ? setTimeout : null, A = typeof clearTimeout == "function" ? clearTimeout : null, O = typeof setImmediate != "undefined" ? setImmediate : null;
  typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function P(le) {
    for (var ce = t(f); ce !== null; ) {
      if (ce.callback === null)
        n(f);
      else if (ce.startTime <= le)
        n(f), ce.sortIndex = ce.expirationTime, r(c, ce);
      else
        break;
      ce = t(f);
    }
  }
  function j(le) {
    if (x = !1, P(le), !S)
      if (t(c) !== null)
        S = !0, Ge(k);
      else {
        var ce = t(f);
        ce !== null && ze(j, ce.startTime - le);
      }
  }
  function k(le, ce) {
    S = !1, x && (x = !1, A(W), W = -1), y = !0;
    var he = g;
    try {
      for (P(ce), p = t(c); p !== null && (!(p.expirationTime > ce) || le && !Ie()); ) {
        var be = p.callback;
        if (typeof be == "function") {
          p.callback = null, g = p.priorityLevel;
          var ye = be(p.expirationTime <= ce);
          ce = e.unstable_now(), typeof ye == "function" ? p.callback = ye : p === t(c) && n(c), P(ce);
        } else
          n(c);
        p = t(c);
      }
      if (p !== null)
        var q = !0;
      else {
        var ae = t(f);
        ae !== null && ze(j, ae.startTime - ce), q = !1;
      }
      return q;
    } finally {
      p = null, g = he, y = !1;
    }
  }
  var L = !1, M = null, W = -1, Z = 5, oe = -1;
  function Ie() {
    return !(e.unstable_now() - oe < Z);
  }
  function Te() {
    if (M !== null) {
      var le = e.unstable_now();
      oe = le;
      var ce = !0;
      try {
        ce = M(!0, le);
      } finally {
        ce ? Ee() : (L = !1, M = null);
      }
    } else
      L = !1;
  }
  var Ee;
  if (typeof O == "function")
    Ee = function() {
      O(Te);
    };
  else if (typeof MessageChannel != "undefined") {
    var Me = new MessageChannel(), Fe = Me.port2;
    Me.port1.onmessage = Te, Ee = function() {
      Fe.postMessage(null);
    };
  } else
    Ee = function() {
      _(Te, 0);
    };
  function Ge(le) {
    M = le, L || (L = !0, Ee());
  }
  function ze(le, ce) {
    W = _(function() {
      le(e.unstable_now());
    }, ce);
  }
  e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(le) {
    le.callback = null;
  }, e.unstable_continueExecution = function() {
    S || y || (S = !0, Ge(k));
  }, e.unstable_forceFrameRate = function(le) {
    0 > le || 125 < le ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Z = 0 < le ? Math.floor(1e3 / le) : 5;
  }, e.unstable_getCurrentPriorityLevel = function() {
    return g;
  }, e.unstable_getFirstCallbackNode = function() {
    return t(c);
  }, e.unstable_next = function(le) {
    switch (g) {
      case 1:
      case 2:
      case 3:
        var ce = 3;
        break;
      default:
        ce = g;
    }
    var he = g;
    g = ce;
    try {
      return le();
    } finally {
      g = he;
    }
  }, e.unstable_pauseExecution = function() {
  }, e.unstable_requestPaint = function() {
  }, e.unstable_runWithPriority = function(le, ce) {
    switch (le) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        le = 3;
    }
    var he = g;
    g = le;
    try {
      return ce();
    } finally {
      g = he;
    }
  }, e.unstable_scheduleCallback = function(le, ce, he) {
    var be = e.unstable_now();
    switch (typeof he == "object" && he !== null ? (he = he.delay, he = typeof he == "number" && 0 < he ? be + he : be) : he = be, le) {
      case 1:
        var ye = -1;
        break;
      case 2:
        ye = 250;
        break;
      case 5:
        ye = 1073741823;
        break;
      case 4:
        ye = 1e4;
        break;
      default:
        ye = 5e3;
    }
    return ye = he + ye, le = { id: h++, callback: ce, priorityLevel: le, startTime: he, expirationTime: ye, sortIndex: -1 }, he > be ? (le.sortIndex = he, r(f, le), t(c) === null && le === t(f) && (x ? (A(W), W = -1) : x = !0, ze(j, he - be))) : (le.sortIndex = ye, r(c, le), S || y || (S = !0, Ge(k))), le;
  }, e.unstable_shouldYield = Ie, e.unstable_wrapCallback = function(le) {
    var ce = g;
    return function() {
      var he = g;
      g = ce;
      try {
        return le.apply(this, arguments);
      } finally {
        g = he;
      }
    };
  };
})(d8);
c8.exports = d8;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f8 = Bt.exports, To = c8.exports;
function Vu(e) {
  for (var r = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, t = 1; t < arguments.length; t++)
    r += "&args[]=" + encodeURIComponent(arguments[t]);
  return "Minified React error #" + e + "; visit " + r + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var Txe = /* @__PURE__ */ new Set();
function cu(e, r) {
  Sc(e, r), Sc(e + "Capture", r);
}
function Sc(e, r) {
  for (e = 0; e < r.length; e++)
    Txe.add(r[e]);
}
var O0 = !(typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined");
function jc(e, r, t, n, a, i, l) {
  this.acceptsBooleans = r === 2 || r === 3 || r === 4, this.attributeName = n, this.attributeNamespace = a, this.mustUseProperty = t, this.propertyName = e, this.type = r, this.sanitizeURL = i, this.removeEmptyString = l;
}
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var r = e[0];
  new jc(r, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  new jc(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
  new jc(e, 3, !1, e.toLowerCase(), null, !1, !1);
});
["rowSpan", "start"].forEach(function(e) {
  new jc(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var a_ = /[\-:]([a-z])/g;
function o_(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
  e.replace(
    a_,
    o_
  );
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
  e.replace(a_, o_);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(e) {
  e.replace(a_, o_);
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  new jc(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
["src", "href", "action", "formAction"].forEach(function(e) {
  new jc(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
var Bi = f8.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Qn = Object.assign, Fh;
(function(e) {
  return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(r, t, n, a) {
    MSApp.execUnsafeLocalFunction(function() {
      return e(r, t, n, a);
    });
  } : e;
})(function(e, r) {
  if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e)
    e.innerHTML = r;
  else {
    for (Fh = Fh || document.createElement("div"), Fh.innerHTML = "<svg>" + r.valueOf().toString() + "</svg>", r = Fh.firstChild; e.firstChild; )
      e.removeChild(e.firstChild);
    for (; r.firstChild; )
      e.appendChild(r.firstChild);
  }
});
var wy = {
  animationIterationCount: !0,
  aspectRatio: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
}, Cxe = ["Webkit", "ms", "Moz", "O"];
Object.keys(wy).forEach(function(e) {
  Cxe.forEach(function(r) {
    r = r + e.charAt(0).toUpperCase() + e.substring(1), wy[r] = wy[e];
  });
});
Qn({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
var I3 = !1;
if (O0)
  try {
    var ud = {};
    Object.defineProperty(ud, "passive", { get: function() {
      I3 = !0;
    } }), window.addEventListener("test", ud, ud), window.removeEventListener("test", ud, ud);
  } catch (e) {
    I3 = !1;
  }
function v8(e) {
  var r = e, t = e;
  if (e.alternate)
    for (; r.return; )
      r = r.return;
  else {
    e = r;
    do
      r = e, r.flags & 4098 && (t = r.return), e = r.return;
    while (e);
  }
  return r.tag === 3 ? t : null;
}
function O3(e) {
  if (v8(e) !== e)
    throw Error(Vu(188));
}
function Exe(e) {
  var r = e.alternate;
  if (!r) {
    if (r = v8(e), r === null)
      throw Error(Vu(188));
    return r !== e ? null : e;
  }
  for (var t = e, n = r; ; ) {
    var a = t.return;
    if (a === null)
      break;
    var i = a.alternate;
    if (i === null) {
      if (n = a.return, n !== null) {
        t = n;
        continue;
      }
      break;
    }
    if (a.child === i.child) {
      for (i = a.child; i; ) {
        if (i === t)
          return O3(a), e;
        if (i === n)
          return O3(a), r;
        i = i.sibling;
      }
      throw Error(Vu(188));
    }
    if (t.return !== n.return)
      t = a, n = i;
    else {
      for (var l = !1, u = a.child; u; ) {
        if (u === t) {
          l = !0, t = a, n = i;
          break;
        }
        if (u === n) {
          l = !0, n = a, t = i;
          break;
        }
        u = u.sibling;
      }
      if (!l) {
        for (u = i.child; u; ) {
          if (u === t) {
            l = !0, t = i, n = a;
            break;
          }
          if (u === n) {
            l = !0, n = i, t = a;
            break;
          }
          u = u.sibling;
        }
        if (!l)
          throw Error(Vu(189));
      }
    }
    if (t.alternate !== n)
      throw Error(Vu(190));
  }
  if (t.tag !== 3)
    throw Error(Vu(188));
  return t.stateNode.current === t ? e : r;
}
function Axe(e) {
  return e = Exe(e), e !== null ? h8(e) : null;
}
function h8(e) {
  if (e.tag === 5 || e.tag === 6)
    return e;
  for (e = e.child; e !== null; ) {
    var r = h8(e);
    if (r !== null)
      return r;
    e = e.sibling;
  }
  return null;
}
To.unstable_scheduleCallback;
To.unstable_cancelCallback;
To.unstable_shouldYield;
To.unstable_requestPaint;
To.unstable_now;
To.unstable_getCurrentPriorityLevel;
To.unstable_ImmediatePriority;
To.unstable_UserBlockingPriority;
To.unstable_NormalPriority;
To.unstable_LowPriority;
To.unstable_IdlePriority;
var Ixe = null, Oxe = null;
Bi.ReactCurrentBatchConfig;
function _y(e) {
  var r = e.keyCode;
  return "charCode" in e ? (e = e.charCode, e === 0 && r === 13 && (e = 13)) : e = r, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
}
function zh() {
  return !0;
}
function M3() {
  return !1;
}
function _a(e) {
  function r(t, n, a, i, l) {
    this._reactName = t, this._targetInst = a, this.type = n, this.nativeEvent = i, this.target = l, this.currentTarget = null;
    for (var u in e)
      e.hasOwnProperty(u) && (t = e[u], this[u] = t ? t(i) : i[u]);
    return this.isDefaultPrevented = (i.defaultPrevented != null ? i.defaultPrevented : i.returnValue === !1) ? zh : M3, this.isPropagationStopped = M3, this;
  }
  return Qn(r.prototype, { preventDefault: function() {
    this.defaultPrevented = !0;
    var t = this.nativeEvent;
    t && (t.preventDefault ? t.preventDefault() : typeof t.returnValue != "unknown" && (t.returnValue = !1), this.isDefaultPrevented = zh);
  }, stopPropagation: function() {
    var t = this.nativeEvent;
    t && (t.stopPropagation ? t.stopPropagation() : typeof t.cancelBubble != "unknown" && (t.cancelBubble = !0), this.isPropagationStopped = zh);
  }, persist: function() {
  }, isPersistent: zh }), r;
}
var Dc = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(e) {
  return e.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 };
_a(Dc);
var ev = Qn({}, Dc, { view: 0, detail: 0 });
_a(ev);
var Ty, Cy, cd, cm = Qn({}, ev, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: i_, button: 0, buttons: 0, relatedTarget: function(e) {
  return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
}, movementX: function(e) {
  return "movementX" in e ? e.movementX : (e !== cd && (cd && e.type === "mousemove" ? (Ty = e.screenX - cd.screenX, Cy = e.screenY - cd.screenY) : Cy = Ty = 0, cd = e), Ty);
}, movementY: function(e) {
  return "movementY" in e ? e.movementY : Cy;
} });
_a(cm);
var Mxe = Qn({}, cm, { dataTransfer: 0 });
_a(Mxe);
var Rxe = Qn({}, ev, { relatedTarget: 0 });
_a(Rxe);
var Pxe = Qn({}, Dc, { animationName: 0, elapsedTime: 0, pseudoElement: 0 });
_a(Pxe);
var kxe = Qn({}, Dc, { clipboardData: function(e) {
  return "clipboardData" in e ? e.clipboardData : window.clipboardData;
} });
_a(kxe);
var jxe = Qn({}, Dc, { data: 0 });
_a(jxe);
var Dxe = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Nxe = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Lxe = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Fxe(e) {
  var r = this.nativeEvent;
  return r.getModifierState ? r.getModifierState(e) : (e = Lxe[e]) ? !!r[e] : !1;
}
function i_() {
  return Fxe;
}
var zxe = Qn({}, ev, { key: function(e) {
  if (e.key) {
    var r = Dxe[e.key] || e.key;
    if (r !== "Unidentified")
      return r;
  }
  return e.type === "keypress" ? (e = _y(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Nxe[e.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: i_, charCode: function(e) {
  return e.type === "keypress" ? _y(e) : 0;
}, keyCode: function(e) {
  return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
}, which: function(e) {
  return e.type === "keypress" ? _y(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
} });
_a(zxe);
var Bxe = Qn({}, cm, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 });
_a(Bxe);
var Uxe = Qn({}, ev, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: i_ });
_a(Uxe);
var Vxe = Qn({}, Dc, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 });
_a(Vxe);
var Wxe = Qn({}, cm, {
  deltaX: function(e) {
    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
  },
  deltaY: function(e) {
    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
});
_a(Wxe);
if (O0 && O0) {
  var R3 = "oninput" in document;
  if (!R3) {
    var P3 = document.createElement("div");
    P3.setAttribute("oninput", "return;"), R3 = typeof P3.oninput == "function";
  }
}
function Bh(e, r) {
  var t = {};
  return t[e.toLowerCase()] = r.toLowerCase(), t["Webkit" + e] = "webkit" + r, t["Moz" + e] = "moz" + r, t;
}
var Ju = { animationend: Bh("Animation", "AnimationEnd"), animationiteration: Bh("Animation", "AnimationIteration"), animationstart: Bh("Animation", "AnimationStart"), transitionend: Bh("Transition", "TransitionEnd") }, Ey = {}, p8 = {};
O0 && (p8 = document.createElement("div").style, "AnimationEvent" in window || (delete Ju.animationend.animation, delete Ju.animationiteration.animation, delete Ju.animationstart.animation), "TransitionEvent" in window || delete Ju.transitionend.transition);
function dm(e) {
  if (Ey[e])
    return Ey[e];
  if (!Ju[e])
    return e;
  var r = Ju[e], t;
  for (t in r)
    if (r.hasOwnProperty(t) && t in p8)
      return Ey[e] = r[t];
  return e;
}
var Hxe = dm("animationend"), Gxe = dm("animationiteration"), Yxe = dm("animationstart"), Kxe = dm("transitionend"), Zxe = /* @__PURE__ */ new Map(), k3 = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function Hs(e, r) {
  Zxe.set(e, r), cu(r, [e]);
}
for (var Ay = 0; Ay < k3.length; Ay++) {
  var Iy = k3[Ay], qxe = Iy.toLowerCase(), Qxe = Iy[0].toUpperCase() + Iy.slice(1);
  Hs(qxe, "on" + Qxe);
}
Hs(Hxe, "onAnimationEnd");
Hs(Gxe, "onAnimationIteration");
Hs(Yxe, "onAnimationStart");
Hs("dblclick", "onDoubleClick");
Hs("focusin", "onFocus");
Hs("focusout", "onBlur");
Hs(Kxe, "onTransitionEnd");
Sc("onMouseEnter", ["mouseout", "mouseover"]);
Sc("onMouseLeave", ["mouseout", "mouseover"]);
Sc("onPointerEnter", ["pointerout", "pointerover"]);
Sc("onPointerLeave", ["pointerout", "pointerover"]);
cu("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
cu("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
cu("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
cu("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
cu("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
cu("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xxe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
new Set("cancel close invalid load scroll toggle".split(" ").concat(Xxe));
"" + Math.random().toString(36).slice(2);
function j3(e) {
  e = e.previousSibling;
  for (var r = 0; e; ) {
    if (e.nodeType === 8) {
      var t = e.data;
      if (t === "$" || t === "$!" || t === "$?") {
        if (r === 0)
          return e;
        r--;
      } else
        t === "/$" && r++;
    }
    e = e.previousSibling;
  }
  return null;
}
var g8 = Math.random().toString(36).slice(2), Oy = "__reactFiber$" + g8, Jxe = "__reactContainer$" + g8;
function e2e(e) {
  var r = e[Oy];
  if (r)
    return r;
  for (var t = e.parentNode; t; ) {
    if (r = t[Jxe] || t[Oy]) {
      if (t = r.alternate, r.child !== null || t !== null && t.child !== null)
        for (e = j3(e); e !== null; ) {
          if (t = e[Oy])
            return t;
          e = j3(e);
        }
      return r;
    }
    e = t, t = e.parentNode;
  }
  return null;
}
Bi.ReactCurrentBatchConfig;
new f8.Component().refs;
Bi.ReactCurrentDispatcher;
Bi.ReactCurrentBatchConfig;
Bi.ReactCurrentOwner;
Bi.ReactCurrentDispatcher;
Bi.ReactCurrentOwner;
Bi.ReactCurrentBatchConfig;
function r2e() {
  return null;
}
var dd = { findFiberByHostInstance: e2e, bundleType: 0, version: "18.2.0", rendererPackageName: "react-dom" }, t2e = { bundleType: dd.bundleType, version: dd.version, rendererPackageName: dd.rendererPackageName, rendererConfig: dd.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Bi.ReactCurrentDispatcher, findHostInstanceByFiber: function(e) {
  return e = Axe(e), e === null ? null : e.stateNode;
}, findFiberByHostInstance: dd.findFiberByHostInstance || r2e, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.2.0-next-9e3b772b8-20220608" };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined") {
  var Uh = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!Uh.isDisabled && Uh.supportsFiber)
    try {
      Ixe = Uh.inject(t2e), Oxe = Uh;
    } catch (e) {
    }
}
function m8() {
  if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(m8);
    } catch (e) {
      console.error(e);
    }
}
m8();
n_({
  strict: !1,
  name: "PortalManagerContext"
});
n_({
  strict: !1,
  name: "PortalContext"
});
function M0() {
  return M0 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, M0.apply(this, arguments);
}
var n2e = function(r, t) {
  return function(n) {
    var a = String(t), i = r ? r + "." + a : a;
    return ni(n.__cssMap) && i in n.__cssMap ? n.__cssMap[i].varRef : t;
  };
};
function Tf(e) {
  var r = e.scale, t = e.transform, n = e.compose, a = function(l, u) {
    var c, f = n2e(r, l)(u), h = (c = t == null ? void 0 : t(f, u)) != null ? c : f;
    return n && (h = n(h, u)), h;
  };
  return a;
}
function so(e, r) {
  return function(t) {
    var n = {
      property: t,
      scale: e
    };
    return n.transform = Tf({
      scale: e,
      transform: r
    }), n;
  };
}
var a2e = function(r) {
  var t = r.rtl, n = r.ltr;
  return function(a) {
    return a.direction === "rtl" ? t : n;
  };
};
function o2e(e) {
  var r = e.property, t = e.scale, n = e.transform;
  return {
    scale: t,
    property: a2e(r),
    transform: t ? Tf({
      scale: t,
      compose: n
    }) : n
  };
}
var My, Ry, b8 = ["rotate(var(--chakra-rotate, 0))", "scaleX(var(--chakra-scale-x, 1))", "scaleY(var(--chakra-scale-y, 1))", "skewX(var(--chakra-skew-x, 0))", "skewY(var(--chakra-skew-y, 0))"];
function i2e() {
  return ["translateX(var(--chakra-translate-x, 0))", "translateY(var(--chakra-translate-y, 0))"].concat(b8).join(" ");
}
function s2e() {
  return ["translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)"].concat(b8).join(" ");
}
var l2e = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: ["var(--chakra-blur)", "var(--chakra-brightness)", "var(--chakra-contrast)", "var(--chakra-grayscale)", "var(--chakra-hue-rotate)", "var(--chakra-invert)", "var(--chakra-saturate)", "var(--chakra-sepia)", "var(--chakra-drop-shadow)"].join(" ")
}, u2e = {
  backdropFilter: ["var(--chakra-backdrop-blur)", "var(--chakra-backdrop-brightness)", "var(--chakra-backdrop-contrast)", "var(--chakra-backdrop-grayscale)", "var(--chakra-backdrop-hue-rotate)", "var(--chakra-backdrop-invert)", "var(--chakra-backdrop-opacity)", "var(--chakra-backdrop-saturate)", "var(--chakra-backdrop-sepia)"].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function c2e(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: ["var(--chakra-ring-offset-shadow)", "var(--chakra-ring-shadow)", "var(--chakra-shadow, 0 0 #0000)"].join(", ")
  };
}
var d2e = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, y8 = "& > :not(style) ~ :not(style)", f2e = (My = {}, My[y8] = {
  marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
  marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
}, My), v2e = (Ry = {}, Ry[y8] = {
  marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
  marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
}, Ry);
function R0(e, r) {
  return R0 = Object.setPrototypeOf || function(n, a) {
    return n.__proto__ = a, n;
  }, R0(e, r);
}
function h2e(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), r && R0(e, r);
}
function Xx() {
  Xx = function(a, i) {
    return new t(a, void 0, i);
  };
  var e = RegExp.prototype, r = /* @__PURE__ */ new WeakMap();
  function t(a, i, l) {
    var u = new RegExp(a, i);
    return r.set(u, l || r.get(a)), R0(u, t.prototype);
  }
  h2e(t, RegExp), t.prototype.exec = function(a) {
    var i = e.exec.call(this, a);
    return i && (i.groups = n(i, this)), i;
  }, t.prototype[Symbol.replace] = function(a, i) {
    if (typeof i == "string") {
      var l = r.get(this);
      return e[Symbol.replace].call(this, a, i.replace(/\$<([^>]+)>/g, function(c, f) {
        return "$" + l[f];
      }));
    } else if (typeof i == "function") {
      var u = this;
      return e[Symbol.replace].call(this, a, function() {
        var c = arguments;
        return typeof c[c.length - 1] != "object" && (c = [].slice.call(c), c.push(n(c, u))), i.apply(this, c);
      });
    } else
      return e[Symbol.replace].call(this, a, i);
  };
  function n(a, i) {
    var l = r.get(i);
    return Object.keys(l).reduce(function(u, c) {
      return u[c] = a[l[c]], u;
    }, /* @__PURE__ */ Object.create(null));
  }
  return Xx.apply(this, arguments);
}
var Jx = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, p2e = new Set(Object.values(Jx)), S8 = /* @__PURE__ */ new Set(["none", "-moz-initial", "inherit", "initial", "revert", "unset"]), g2e = function(r) {
  return r.trim();
};
function m2e(e, r) {
  var t, n;
  if (e == null || S8.has(e))
    return e;
  var a = /* @__PURE__ */ Xx(/(^[\x2DA-Za-z]+)\(((.*))\)/g, {
    type: 1,
    values: 2
  }), i = (t = (n = a.exec(e)) == null ? void 0 : n.groups) != null ? t : {}, l = i.type, u = i.values;
  if (!l || !u)
    return e;
  var c = l.includes("-gradient") ? l : l + "-gradient", f = u.split(",").map(g2e).filter(Boolean), h = f[0], p = f.slice(1);
  if ((p == null ? void 0 : p.length) === 0)
    return e;
  var g = h in Jx ? Jx[h] : h;
  p.unshift(g);
  var y = p.map(function(S) {
    if (p2e.has(S))
      return S;
    var x = S.indexOf(" "), _ = x !== -1 ? [S.substr(0, x), S.substr(x + 1)] : [S], A = _[0], O = _[1], P = x8(O) ? O : O && O.split(" "), j = "colors." + A, k = j in r.__cssMap ? r.__cssMap[j].varRef : A;
    return P ? [k].concat(Array.isArray(P) ? P : [P]).join(" ") : k;
  });
  return c + "(" + y.join(", ") + ")";
}
var x8 = function(r) {
  return t_(r) && r.includes("(") && r.includes(")");
}, b2e = function(r, t) {
  return m2e(r, t != null ? t : {});
}, y2e = function(r) {
  var t = parseFloat(r.toString()), n = r.toString().replace(String(t), "");
  return {
    unitless: !n,
    value: t,
    unit: n
  };
}, Uo = function(r) {
  return function(t) {
    return r + "(" + t + ")";
  };
}, Fr = {
  filter: function(r) {
    return r !== "auto" ? r : l2e;
  },
  backdropFilter: function(r) {
    return r !== "auto" ? r : u2e;
  },
  ring: function(r) {
    return c2e(Fr.px(r));
  },
  bgClip: function(r) {
    return r === "text" ? {
      color: "transparent",
      backgroundClip: "text"
    } : {
      backgroundClip: r
    };
  },
  transform: function(r) {
    return r === "auto" ? i2e() : r === "auto-gpu" ? s2e() : r;
  },
  px: function(r) {
    if (r == null)
      return r;
    var t = y2e(r), n = t.unitless;
    return n || $y(r) ? r + "px" : r;
  },
  fraction: function(r) {
    return !$y(r) || r > 1 ? r : r * 100 + "%";
  },
  float: function(r, t) {
    var n = {
      left: "right",
      right: "left"
    };
    return t.direction === "rtl" ? n[r] : r;
  },
  degree: function(r) {
    if (i8(r) || r == null)
      return r;
    var t = t_(r) && !r.endsWith("deg");
    return $y(r) || t ? r + "deg" : r;
  },
  gradient: b2e,
  blur: Uo("blur"),
  opacity: Uo("opacity"),
  brightness: Uo("brightness"),
  contrast: Uo("contrast"),
  dropShadow: Uo("drop-shadow"),
  grayscale: Uo("grayscale"),
  hueRotate: Uo("hue-rotate"),
  invert: Uo("invert"),
  saturate: Uo("saturate"),
  sepia: Uo("sepia"),
  bgImage: function(r) {
    if (r == null)
      return r;
    var t = x8(r) || S8.has(r);
    return t ? r : "url(" + r + ")";
  },
  outline: function(r) {
    var t = String(r) === "0" || String(r) === "none";
    return r !== null && t ? {
      outline: "2px solid transparent",
      outlineOffset: "2px"
    } : {
      outline: r
    };
  },
  flexDirection: function(r) {
    var t, n = (t = d2e[r]) != null ? t : {}, a = n.space, i = n.divide, l = {
      flexDirection: r
    };
    return a && (l[a] = 1), i && (l[i] = 1), l;
  }
}, B = {
  borderWidths: so("borderWidths"),
  borderStyles: so("borderStyles"),
  colors: so("colors"),
  borders: so("borders"),
  radii: so("radii", Fr.px),
  space: so("space", Fr.px),
  spaceT: so("space", Fr.px),
  degreeT: function(r) {
    return {
      property: r,
      transform: Fr.degree
    };
  },
  prop: function(r, t, n) {
    return M0({
      property: r,
      scale: t
    }, t && {
      transform: Tf({
        scale: t,
        transform: n
      })
    });
  },
  propT: function(r, t) {
    return {
      property: r,
      transform: t
    };
  },
  sizes: so("sizes", Fr.px),
  sizesT: so("sizes", Fr.fraction),
  shadows: so("shadows"),
  logical: o2e,
  blur: so("blur", Fr.blur)
}, zp = {
  background: B.colors("background"),
  backgroundColor: B.colors("backgroundColor"),
  backgroundImage: B.propT("backgroundImage", Fr.bgImage),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: {
    transform: Fr.bgClip
  },
  bgSize: B.prop("backgroundSize"),
  bgPosition: B.prop("backgroundPosition"),
  bg: B.colors("background"),
  bgColor: B.colors("backgroundColor"),
  bgPos: B.prop("backgroundPosition"),
  bgRepeat: B.prop("backgroundRepeat"),
  bgAttachment: B.prop("backgroundAttachment"),
  bgGradient: B.propT("backgroundImage", Fr.gradient),
  bgClip: {
    transform: Fr.bgClip
  }
};
Object.assign(zp, {
  bgImage: zp.backgroundImage,
  bgImg: zp.backgroundImage
});
var Tr = {
  border: B.borders("border"),
  borderWidth: B.borderWidths("borderWidth"),
  borderStyle: B.borderStyles("borderStyle"),
  borderColor: B.colors("borderColor"),
  borderRadius: B.radii("borderRadius"),
  borderTop: B.borders("borderTop"),
  borderBlockStart: B.borders("borderBlockStart"),
  borderTopLeftRadius: B.radii("borderTopLeftRadius"),
  borderStartStartRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: B.radii("borderTopRightRadius"),
  borderStartEndRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: B.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: B.borders("borderRight"),
  borderInlineEnd: B.borders("borderInlineEnd"),
  borderBottom: B.borders("borderBottom"),
  borderBlockEnd: B.borders("borderBlockEnd"),
  borderBottomLeftRadius: B.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: B.radii("borderBottomRightRadius"),
  borderLeft: B.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: B.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: B.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: B.borders(["borderLeft", "borderRight"]),
  borderInline: B.borders("borderInline"),
  borderY: B.borders(["borderTop", "borderBottom"]),
  borderBlock: B.borders("borderBlock"),
  borderTopWidth: B.borderWidths("borderTopWidth"),
  borderBlockStartWidth: B.borderWidths("borderBlockStartWidth"),
  borderTopColor: B.colors("borderTopColor"),
  borderBlockStartColor: B.colors("borderBlockStartColor"),
  borderTopStyle: B.borderStyles("borderTopStyle"),
  borderBlockStartStyle: B.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: B.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: B.borderWidths("borderBlockEndWidth"),
  borderBottomColor: B.colors("borderBottomColor"),
  borderBlockEndColor: B.colors("borderBlockEndColor"),
  borderBottomStyle: B.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: B.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: B.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: B.borderWidths("borderInlineStartWidth"),
  borderLeftColor: B.colors("borderLeftColor"),
  borderInlineStartColor: B.colors("borderInlineStartColor"),
  borderLeftStyle: B.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: B.borderStyles("borderInlineStartStyle"),
  borderRightWidth: B.borderWidths("borderRightWidth"),
  borderInlineEndWidth: B.borderWidths("borderInlineEndWidth"),
  borderRightColor: B.colors("borderRightColor"),
  borderInlineEndColor: B.colors("borderInlineEndColor"),
  borderRightStyle: B.borderStyles("borderRightStyle"),
  borderInlineEndStyle: B.borderStyles("borderInlineEndStyle"),
  borderTopRadius: B.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: B.radii(["borderBottomLeftRadius", "borderBottomRightRadius"]),
  borderLeftRadius: B.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: B.radii(["borderTopRightRadius", "borderBottomRightRadius"])
};
Object.assign(Tr, {
  rounded: Tr.borderRadius,
  roundedTop: Tr.borderTopRadius,
  roundedTopLeft: Tr.borderTopLeftRadius,
  roundedTopRight: Tr.borderTopRightRadius,
  roundedTopStart: Tr.borderStartStartRadius,
  roundedTopEnd: Tr.borderStartEndRadius,
  roundedBottom: Tr.borderBottomRadius,
  roundedBottomLeft: Tr.borderBottomLeftRadius,
  roundedBottomRight: Tr.borderBottomRightRadius,
  roundedBottomStart: Tr.borderEndStartRadius,
  roundedBottomEnd: Tr.borderEndEndRadius,
  roundedLeft: Tr.borderLeftRadius,
  roundedRight: Tr.borderRightRadius,
  roundedStart: Tr.borderInlineStartRadius,
  roundedEnd: Tr.borderInlineEndRadius,
  borderStart: Tr.borderInlineStart,
  borderEnd: Tr.borderInlineEnd,
  borderTopStartRadius: Tr.borderStartStartRadius,
  borderTopEndRadius: Tr.borderStartEndRadius,
  borderBottomStartRadius: Tr.borderEndStartRadius,
  borderBottomEndRadius: Tr.borderEndEndRadius,
  borderStartRadius: Tr.borderInlineStartRadius,
  borderEndRadius: Tr.borderInlineEndRadius,
  borderStartWidth: Tr.borderInlineStartWidth,
  borderEndWidth: Tr.borderInlineEndWidth,
  borderStartColor: Tr.borderInlineStartColor,
  borderEndColor: Tr.borderInlineEndColor,
  borderStartStyle: Tr.borderInlineStartStyle,
  borderEndStyle: Tr.borderInlineEndStyle
});
var S2e = {
  color: B.colors("color"),
  textColor: B.colors("color"),
  fill: B.colors("fill"),
  stroke: B.colors("stroke")
}, e2 = {
  boxShadow: B.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: B.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: B.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(e2, {
  shadow: e2.boxShadow
});
var x2e = {
  filter: {
    transform: Fr.filter
  },
  blur: B.blur("--chakra-blur"),
  brightness: B.propT("--chakra-brightness", Fr.brightness),
  contrast: B.propT("--chakra-contrast", Fr.contrast),
  hueRotate: B.degreeT("--chakra-hue-rotate"),
  invert: B.propT("--chakra-invert", Fr.invert),
  saturate: B.propT("--chakra-saturate", Fr.saturate),
  dropShadow: B.propT("--chakra-drop-shadow", Fr.dropShadow),
  backdropFilter: {
    transform: Fr.backdropFilter
  },
  backdropBlur: B.blur("--chakra-backdrop-blur"),
  backdropBrightness: B.propT("--chakra-backdrop-brightness", Fr.brightness),
  backdropContrast: B.propT("--chakra-backdrop-contrast", Fr.contrast),
  backdropHueRotate: B.degreeT("--chakra-backdrop-hue-rotate"),
  backdropInvert: B.propT("--chakra-backdrop-invert", Fr.invert),
  backdropSaturate: B.propT("--chakra-backdrop-saturate", Fr.saturate)
}, P0 = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: {
    transform: Fr.flexDirection
  },
  experimental_spaceX: {
    static: f2e,
    transform: Tf({
      scale: "space",
      transform: function(r) {
        return r !== null ? {
          "--chakra-space-x": r
        } : null;
      }
    })
  },
  experimental_spaceY: {
    static: v2e,
    transform: Tf({
      scale: "space",
      transform: function(r) {
        return r != null ? {
          "--chakra-space-y": r
        } : null;
      }
    })
  },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: B.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: B.space("gap"),
  rowGap: B.space("rowGap"),
  columnGap: B.space("columnGap")
};
Object.assign(P0, {
  flexDir: P0.flexDirection
});
var $8 = {
  gridGap: B.space("gridGap"),
  gridColumnGap: B.space("gridColumnGap"),
  gridRowGap: B.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, $2e = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: {
    transform: Fr.outline
  },
  outlineOffset: !0,
  outlineColor: B.colors("outlineColor")
}, Na = {
  width: B.sizesT("width"),
  inlineSize: B.sizesT("inlineSize"),
  height: B.sizes("height"),
  blockSize: B.sizes("blockSize"),
  boxSize: B.sizes(["width", "height"]),
  minWidth: B.sizes("minWidth"),
  minInlineSize: B.sizes("minInlineSize"),
  minHeight: B.sizes("minHeight"),
  minBlockSize: B.sizes("minBlockSize"),
  maxWidth: B.sizes("maxWidth"),
  maxInlineSize: B.sizes("maxInlineSize"),
  maxHeight: B.sizes("maxHeight"),
  maxBlockSize: B.sizes("maxBlockSize"),
  d: B.prop("display"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: B.propT("float", Fr.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(Na, {
  w: Na.width,
  h: Na.height,
  minW: Na.minWidth,
  maxW: Na.maxWidth,
  minH: Na.minHeight,
  maxH: Na.maxHeight,
  overscroll: Na.overscrollBehavior,
  overscrollX: Na.overscrollBehaviorX,
  overscrollY: Na.overscrollBehaviorY
});
var w2e = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: B.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: B.prop("listStyleImage")
}, _2e = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, T2e = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, Py = function(r, t, n) {
  var a = {}, i = s8(r, t, {});
  for (var l in i) {
    var u = l in n && n[l] != null;
    u || (a[l] = i[l]);
  }
  return a;
}, C2e = {
  srOnly: {
    transform: function(r) {
      return r === !0 ? _2e : r === "focusable" ? T2e : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return Py(t, "layerStyles." + r, n);
    }
  },
  textStyle: {
    processResult: !0,
    transform: function(r, t, n) {
      return Py(t, "textStyles." + r, n);
    }
  },
  apply: {
    processResult: !0,
    transform: function(r, t, n) {
      return Py(t, r, n);
    }
  }
}, Wd = {
  position: !0,
  pos: B.prop("position"),
  zIndex: B.prop("zIndex", "zIndices"),
  inset: B.spaceT("inset"),
  insetX: B.spaceT(["left", "right"]),
  insetInline: B.spaceT("insetInline"),
  insetY: B.spaceT(["top", "bottom"]),
  insetBlock: B.spaceT("insetBlock"),
  top: B.spaceT("top"),
  insetBlockStart: B.spaceT("insetBlockStart"),
  bottom: B.spaceT("bottom"),
  insetBlockEnd: B.spaceT("insetBlockEnd"),
  left: B.spaceT("left"),
  insetInlineStart: B.logical({
    scale: "space",
    property: {
      ltr: "left",
      rtl: "right"
    }
  }),
  right: B.spaceT("right"),
  insetInlineEnd: B.logical({
    scale: "space",
    property: {
      ltr: "right",
      rtl: "left"
    }
  })
};
Object.assign(Wd, {
  insetStart: Wd.insetInlineStart,
  insetEnd: Wd.insetInlineEnd
});
var E2e = {
  ring: {
    transform: Fr.ring
  },
  ringColor: B.colors("--chakra-ring-color"),
  ringOffset: B.prop("--chakra-ring-offset-width"),
  ringOffsetColor: B.colors("--chakra-ring-offset-color"),
  ringInset: B.prop("--chakra-ring-inset")
}, lt = {
  margin: B.spaceT("margin"),
  marginTop: B.spaceT("marginTop"),
  marginBlockStart: B.spaceT("marginBlockStart"),
  marginRight: B.spaceT("marginRight"),
  marginInlineEnd: B.spaceT("marginInlineEnd"),
  marginBottom: B.spaceT("marginBottom"),
  marginBlockEnd: B.spaceT("marginBlockEnd"),
  marginLeft: B.spaceT("marginLeft"),
  marginInlineStart: B.spaceT("marginInlineStart"),
  marginX: B.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: B.spaceT("marginInline"),
  marginY: B.spaceT(["marginTop", "marginBottom"]),
  marginBlock: B.spaceT("marginBlock"),
  padding: B.space("padding"),
  paddingTop: B.space("paddingTop"),
  paddingBlockStart: B.space("paddingBlockStart"),
  paddingRight: B.space("paddingRight"),
  paddingBottom: B.space("paddingBottom"),
  paddingBlockEnd: B.space("paddingBlockEnd"),
  paddingLeft: B.space("paddingLeft"),
  paddingInlineStart: B.space("paddingInlineStart"),
  paddingInlineEnd: B.space("paddingInlineEnd"),
  paddingX: B.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: B.space("paddingInline"),
  paddingY: B.space(["paddingTop", "paddingBottom"]),
  paddingBlock: B.space("paddingBlock")
};
Object.assign(lt, {
  m: lt.margin,
  mt: lt.marginTop,
  mr: lt.marginRight,
  me: lt.marginInlineEnd,
  marginEnd: lt.marginInlineEnd,
  mb: lt.marginBottom,
  ml: lt.marginLeft,
  ms: lt.marginInlineStart,
  marginStart: lt.marginInlineStart,
  mx: lt.marginX,
  my: lt.marginY,
  p: lt.padding,
  pt: lt.paddingTop,
  py: lt.paddingY,
  px: lt.paddingX,
  pb: lt.paddingBottom,
  pl: lt.paddingLeft,
  ps: lt.paddingInlineStart,
  paddingStart: lt.paddingInlineStart,
  pr: lt.paddingRight,
  pe: lt.paddingInlineEnd,
  paddingEnd: lt.paddingInlineEnd
});
var A2e = {
  textDecorationColor: B.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: {
    property: "textDecoration"
  },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: B.shadows("textShadow")
}, I2e = {
  clipPath: !0,
  transform: B.propT("transform", Fr.transform),
  transformOrigin: !0,
  translateX: B.spaceT("--chakra-translate-x"),
  translateY: B.spaceT("--chakra-translate-y"),
  skewX: B.degreeT("--chakra-skew-x"),
  skewY: B.degreeT("--chakra-skew-y"),
  scaleX: B.prop("--chakra-scale-x"),
  scaleY: B.prop("--chakra-scale-y"),
  scale: B.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: B.degreeT("--chakra-rotate")
}, O2e = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: B.prop("transitionDuration", "transition.duration"),
  transitionProperty: B.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: B.prop("transitionTimingFunction", "transition.easing")
}, M2e = {
  fontFamily: B.prop("fontFamily", "fonts"),
  fontSize: B.prop("fontSize", "fontSizes", Fr.px),
  fontWeight: B.prop("fontWeight", "fontWeights"),
  lineHeight: B.prop("lineHeight", "lineHeights"),
  letterSpacing: B.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  },
  isTruncated: {
    transform: function(r) {
      if (r === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  }
}, R2e = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: B.spaceT("scrollMargin"),
  scrollMarginTop: B.spaceT("scrollMarginTop"),
  scrollMarginBottom: B.spaceT("scrollMarginBottom"),
  scrollMarginLeft: B.spaceT("scrollMarginLeft"),
  scrollMarginRight: B.spaceT("scrollMarginRight"),
  scrollMarginX: B.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: B.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: B.spaceT("scrollPadding"),
  scrollPaddingTop: B.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: B.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: B.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: B.spaceT("scrollPaddingRight"),
  scrollPaddingX: B.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: B.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function D3(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function P2e(e, r) {
  if (e) {
    if (typeof e == "string")
      return D3(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return D3(e, r);
  }
}
function k2e(e, r) {
  var t = typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t)
    return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = P2e(e)) || r && e && typeof e.length == "number") {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[n++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var rn = {
  hover: function(r, t) {
    return r + ":hover " + t + ", " + r + "[data-hover] " + t;
  },
  focus: function(r, t) {
    return r + ":focus " + t + ", " + r + "[data-focus] " + t;
  },
  focusVisible: function(r, t) {
    return r + ":focus-visible " + t;
  },
  focusWithin: function(r, t) {
    return r + ":focus-within " + t;
  },
  active: function(r, t) {
    return r + ":active " + t + ", " + r + "[data-active] " + t;
  },
  disabled: function(r, t) {
    return r + ":disabled " + t + ", " + r + "[data-disabled] " + t;
  },
  invalid: function(r, t) {
    return r + ":invalid " + t + ", " + r + "[data-invalid] " + t;
  },
  checked: function(r, t) {
    return r + ":checked " + t + ", " + r + "[data-checked] " + t;
  },
  indeterminate: function(r, t) {
    return r + ":indeterminate " + t + ", " + r + "[aria-checked=mixed] " + t + ", " + r + "[data-indeterminate] " + t;
  },
  readOnly: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[readonly] " + t + ", " + r + "[data-read-only] " + t;
  },
  expanded: function(r, t) {
    return r + ":read-only " + t + ", " + r + "[aria-expanded=true] " + t + ", " + r + "[data-expanded] " + t;
  },
  placeholderShown: function(r, t) {
    return r + ":placeholder-shown " + t;
  }
}, ms = function(r) {
  return w8(function(t) {
    return r(t, "&");
  }, "[role=group]", "[data-group]", ".group");
}, Ii = function(r) {
  return w8(function(t) {
    return r(t, "~ &");
  }, "[data-peer]", ".peer");
}, w8 = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(r).join(", ");
}, s_ = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   */
  _disabled: "&[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: ms(rn.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: Ii(rn.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: ms(rn.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: Ii(rn.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: ms(rn.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: Ii(rn.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: ms(rn.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: Ii(rn.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: ms(rn.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: Ii(rn.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: ms(rn.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: Ii(rn.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: ms(rn.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: Ii(rn.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: ms(rn.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: Ii(rn.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: Ii(rn.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
}, j2e = u8(s_), l_ = Ms({}, zp, Tr, S2e, P0, Na, x2e, E2e, $2e, $8, C2e, Wd, e2, lt, R2e, M2e, A2e, I2e, w2e, O2e);
Object.assign({}, lt, Na, P0, $8, Wd);
var D2e = [].concat(u8(l_), j2e), N2e = M0({}, l_, s_), L2e = function(r) {
  return r in N2e;
}, F2e = function(r) {
  return function(t) {
    if (!t.__breakpoints)
      return r;
    var n = t.__breakpoints, a = n.isResponsive, i = n.toArrayValue, l = n.media, u = {};
    for (var c in r) {
      var f = Xu(r[c], t);
      if (f != null) {
        if (f = ni(f) && a(f) ? i(f) : f, !Array.isArray(f)) {
          u[c] = f;
          continue;
        }
        for (var h = f.slice(0, l.length).length, p = 0; p < h; p += 1) {
          var g = l == null ? void 0 : l[p];
          if (!g) {
            u[c] = f[p];
            continue;
          }
          u[g] = u[g] || {}, f[p] != null && (u[g][c] = f[p]);
        }
      }
    }
    return u;
  };
}, z2e = function(r, t) {
  return r.startsWith("--") && t_(t) && !i8(t);
}, B2e = function(r, t) {
  var n, a;
  if (t == null)
    return t;
  var i = function(p) {
    var g, y;
    return (g = r.__cssMap) == null || (y = g[p]) == null ? void 0 : y.varRef;
  }, l = function(p) {
    var g;
    return (g = i(p)) != null ? g : p;
  }, u = t.split(",").map(function(h) {
    return h.trim();
  }), c = u[0], f = u[1];
  return t = (n = (a = i(c)) != null ? a : l(f)) != null ? n : l(t), t;
};
function U2e(e) {
  var r = e.configs, t = r === void 0 ? {} : r, n = e.pseudos, a = n === void 0 ? {} : n, i = e.theme, l = function u(c, f) {
    f === void 0 && (f = !1);
    var h = Xu(c, i), p = F2e(h)(i), g = {};
    for (var y in p) {
      var S, x, _, A, O, P = p[y], j = Xu(P, i);
      y in a && (y = a[y]), z2e(y, j) && (j = B2e(i, j));
      var k = t[y];
      if (k === !0 && (k = {
        property: y
      }), ni(j)) {
        var L;
        g[y] = (L = g[y]) != null ? L : {}, g[y] = Ms({}, g[y], u(j, !0));
        continue;
      }
      var M = (S = (x = k) == null || x.transform == null ? void 0 : x.transform(j, i, h)) != null ? S : j;
      M = (_ = k) != null && _.processResult ? u(M, !0) : M;
      var W = Xu((A = k) == null ? void 0 : A.property, i);
      if (!f && (O = k) != null && O.static) {
        var Z = Xu(k.static, i);
        g = Ms({}, g, Z);
      }
      if (W && Array.isArray(W)) {
        for (var oe = k2e(W), Ie; !(Ie = oe()).done; ) {
          var Te = Ie.value;
          g[Te] = M;
        }
        continue;
      }
      if (W) {
        W === "&" && ni(M) ? g = Ms({}, g, M) : g[W] = M;
        continue;
      }
      if (ni(M)) {
        g = Ms({}, g, M);
        continue;
      }
      g[y] = M;
    }
    return g;
  };
  return l;
}
var V2e = function(r) {
  return function(t) {
    var n = U2e({
      theme: t,
      pseudos: s_,
      configs: l_
    });
    return n(r);
  };
};
function _8(e) {
  return ni(e) && e.reference ? e.reference : String(e);
}
var fm = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(_8).join(" " + r + " ").replace(/calc/g, "");
}, N3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fm.apply(void 0, ["+"].concat(t)) + ")";
}, L3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fm.apply(void 0, ["-"].concat(t)) + ")";
}, r2 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fm.apply(void 0, ["*"].concat(t)) + ")";
}, F3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + fm.apply(void 0, ["/"].concat(t)) + ")";
}, z3 = function(r) {
  var t = _8(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : r2(t, -1);
}, fd = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return fd(N3.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return fd(L3.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return fd(r2.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return fd(F3.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return fd(z3(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: N3,
  subtract: L3,
  multiply: r2,
  divide: F3,
  negate: z3
}), W2e = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, H2e = /* @__PURE__ */ Xw(
  function(e) {
    return W2e.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), G2e = H2e, Y2e = function(r) {
  return r !== "theme";
}, B3 = function(r) {
  return typeof r == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  r.charCodeAt(0) > 96 ? G2e : Y2e;
}, U3 = function(r, t, n) {
  var a;
  if (t) {
    var i = t.shouldForwardProp;
    a = r.__emotion_forwardProp && i ? function(l) {
      return r.__emotion_forwardProp(l) && i(l);
    } : i;
  }
  return typeof a != "function" && n && (a = r.__emotion_forwardProp), a;
}, K2e = typeof document != "undefined", Z2e = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  r8(t, n, a);
  var i = dxe(function() {
    return axe(t, n, a);
  });
  if (!K2e && i !== void 0) {
    for (var l, u = n.name, c = n.next; c !== void 0; )
      u += " " + c.name, c = c.next;
    return /* @__PURE__ */ Bt.exports.createElement("style", (l = {}, l["data-emotion"] = t.key + " " + u, l.dangerouslySetInnerHTML = {
      __html: i
    }, l.nonce = t.sheet.nonce, l));
  }
  return null;
}, q2e = function e(r, t) {
  var n = r.__emotion_real === r, a = n && r.__emotion_base || r, i, l;
  t !== void 0 && (i = t.label, l = t.target);
  var u = U3(r, t, n), c = u || B3(a), f = !c("as");
  return function() {
    var h = arguments, p = n && r.__emotion_styles !== void 0 ? r.__emotion_styles.slice(0) : [];
    if (i !== void 0 && p.push("label:" + i + ";"), h[0] == null || h[0].raw === void 0)
      p.push.apply(p, h);
    else {
      p.push(h[0][0]);
      for (var g = h.length, y = 1; y < g; y++)
        p.push(h[y], h[0][y]);
    }
    var S = o8(function(x, _, A) {
      var O = f && x.as || a, P = "", j = [], k = x;
      if (x.theme == null) {
        k = {};
        for (var L in x)
          k[L] = x[L];
        k.theme = Bt.exports.useContext(vxe);
      }
      typeof x.className == "string" ? P = nxe(_.registered, j, x.className) : x.className != null && (P = x.className + " ");
      var M = n8(p.concat(j), _.registered, k);
      P += _.key + "-" + M.name, l !== void 0 && (P += " " + l);
      var W = f && u === void 0 ? B3(O) : c, Z = {};
      for (var oe in x)
        f && oe === "as" || // $FlowFixMe
        W(oe) && (Z[oe] = x[oe]);
      return Z.className = P, Z.ref = A, /* @__PURE__ */ Bt.exports.createElement(Bt.exports.Fragment, null, /* @__PURE__ */ Bt.exports.createElement(Z2e, {
        cache: _,
        serialized: M,
        isStringTag: typeof O == "string"
      }), /* @__PURE__ */ Bt.exports.createElement(O, Z));
    });
    return S.displayName = i !== void 0 ? i : "Styled(" + (typeof a == "string" ? a : a.displayName || a.name || "Component") + ")", S.defaultProps = r.defaultProps, S.__emotion_real = S, S.__emotion_base = a, S.__emotion_styles = p, S.__emotion_forwardProp = u, Object.defineProperty(S, "toString", {
      value: function() {
        return "." + l;
      }
    }), S.withComponent = function(x, _) {
      return e(x, Kx({}, t, _, {
        shouldForwardProp: U3(S, _, !0)
      })).apply(void 0, p);
    }, S;
  };
}, Q2e = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], t2 = q2e.bind();
Q2e.forEach(function(e) {
  t2[e] = t2(e);
});
n_({
  name: "StylesContext",
  errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
});
function T8(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var X2e = new Set([].concat(D2e, ["textStyle", "layerStyle", "apply", "isTruncated", "noOfLines", "focusBorderColor", "errorBorderColor", "as", "__css", "css", "sx"])), J2e = /* @__PURE__ */ new Set(["htmlWidth", "htmlHeight", "htmlSize"]), e$e = function(r) {
  return J2e.has(r) || !X2e.has(r);
}, r$e = ["theme", "css", "__css", "sx"], t$e = ["baseStyle"], n$e = function(r) {
  var t = r.baseStyle;
  return function(n) {
    n.theme;
    var a = n.css, i = n.__css, l = n.sx, u = T8(n, r$e), c = l8(u, function(g, y) {
      return L2e(y);
    }), f = Xu(t, n), h = Object.assign({}, i, f, xxe(c), l), p = V2e(h)(n.theme);
    return a ? [p, a] : p;
  };
};
function ky(e, r) {
  var t = r != null ? r : {}, n = t.baseStyle, a = T8(t, t$e);
  a.shouldForwardProp || (a.shouldForwardProp = e$e);
  var i = n$e({
    baseStyle: n
  });
  return t2(e, a)(i);
}
function a$e() {
  var e = /* @__PURE__ */ new Map();
  return new Proxy(ky, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply: function(t, n, a) {
      return ky.apply(void 0, a);
    },
    /**
     * @example
     * <chakra.div />
     */
    get: function(t, n) {
      return e.has(n) || e.set(n, ky(n)), e.get(n);
    }
  });
}
a$e();
var C8 = {
  px: "1px",
  0.5: "0.125rem",
  1: "0.25rem",
  1.5: "0.375rem",
  2: "0.5rem",
  2.5: "0.625rem",
  3: "0.75rem",
  3.5: "0.875rem",
  4: "1rem",
  5: "1.25rem",
  6: "1.5rem",
  7: "1.75rem",
  8: "2rem",
  9: "2.25rem",
  10: "2.5rem",
  12: "3rem",
  14: "3.5rem",
  16: "4rem",
  20: "5rem",
  24: "6rem",
  28: "7rem",
  32: "8rem",
  36: "9rem",
  40: "10rem",
  44: "11rem",
  48: "12rem",
  52: "13rem",
  56: "14rem",
  60: "15rem",
  64: "16rem",
  72: "18rem",
  80: "20rem",
  96: "24rem"
};
function Ot() {
  return Ot = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ot.apply(this, arguments);
}
var o$e = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "14rem",
  "2xs": "16rem",
  xs: "20rem",
  sm: "24rem",
  md: "28rem",
  lg: "32rem",
  xl: "36rem",
  "2xl": "42rem",
  "3xl": "48rem",
  "4xl": "56rem",
  "5xl": "64rem",
  "6xl": "72rem",
  "7xl": "80rem",
  "8xl": "90rem"
}, i$e = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, E8 = Ot({}, C8, o$e, {
  container: i$e
});
function ln(e, r) {
  s$e(e) && (e = "100%");
  var t = l$e(e);
  return e = r === 360 ? e : Math.min(r, Math.max(0, parseFloat(e))), t && (e = parseInt(String(e * r), 10) / 100), Math.abs(e - r) < 1e-6 ? 1 : (r === 360 ? e = (e < 0 ? e % r + r : e % r) / parseFloat(String(r)) : e = e % r / parseFloat(String(r)), e);
}
function Vh(e) {
  return Math.min(1, Math.max(0, e));
}
function s$e(e) {
  return typeof e == "string" && e.indexOf(".") !== -1 && parseFloat(e) === 1;
}
function l$e(e) {
  return typeof e == "string" && e.indexOf("%") !== -1;
}
function A8(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Wh(e) {
  return e <= 1 ? "".concat(Number(e) * 100, "%") : e;
}
function Hl(e) {
  return e.length === 1 ? "0" + e : String(e);
}
function u$e(e, r, t) {
  return {
    r: ln(e, 255) * 255,
    g: ln(r, 255) * 255,
    b: ln(t, 255) * 255
  };
}
function V3(e, r, t) {
  e = ln(e, 255), r = ln(r, 255), t = ln(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = 0, u = (n + a) / 2;
  if (n === a)
    l = 0, i = 0;
  else {
    var c = n - a;
    switch (l = u > 0.5 ? c / (2 - n - a) : c / (n + a), n) {
      case e:
        i = (r - t) / c + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / c + 2;
        break;
      case t:
        i = (e - r) / c + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: l, l: u };
}
function jy(e, r, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? e + (r - e) * (6 * t) : t < 1 / 2 ? r : t < 2 / 3 ? e + (r - e) * (2 / 3 - t) * 6 : e;
}
function c$e(e, r, t) {
  var n, a, i;
  if (e = ln(e, 360), r = ln(r, 100), t = ln(t, 100), r === 0)
    a = t, i = t, n = t;
  else {
    var l = t < 0.5 ? t * (1 + r) : t + r - t * r, u = 2 * t - l;
    n = jy(u, l, e + 1 / 3), a = jy(u, l, e), i = jy(u, l, e - 1 / 3);
  }
  return { r: n * 255, g: a * 255, b: i * 255 };
}
function W3(e, r, t) {
  e = ln(e, 255), r = ln(r, 255), t = ln(t, 255);
  var n = Math.max(e, r, t), a = Math.min(e, r, t), i = 0, l = n, u = n - a, c = n === 0 ? 0 : u / n;
  if (n === a)
    i = 0;
  else {
    switch (n) {
      case e:
        i = (r - t) / u + (r < t ? 6 : 0);
        break;
      case r:
        i = (t - e) / u + 2;
        break;
      case t:
        i = (e - r) / u + 4;
        break;
    }
    i /= 6;
  }
  return { h: i, s: c, v: l };
}
function d$e(e, r, t) {
  e = ln(e, 360) * 6, r = ln(r, 100), t = ln(t, 100);
  var n = Math.floor(e), a = e - n, i = t * (1 - r), l = t * (1 - a * r), u = t * (1 - (1 - a) * r), c = n % 6, f = [t, l, i, i, u, t][c], h = [u, t, t, l, i, i][c], p = [i, i, u, t, t, l][c];
  return { r: f * 255, g: h * 255, b: p * 255 };
}
function H3(e, r, t, n) {
  var a = [
    Hl(Math.round(e).toString(16)),
    Hl(Math.round(r).toString(16)),
    Hl(Math.round(t).toString(16))
  ];
  return n && a[0].startsWith(a[0].charAt(1)) && a[1].startsWith(a[1].charAt(1)) && a[2].startsWith(a[2].charAt(1)) ? a[0].charAt(0) + a[1].charAt(0) + a[2].charAt(0) : a.join("");
}
function f$e(e, r, t, n, a) {
  var i = [
    Hl(Math.round(e).toString(16)),
    Hl(Math.round(r).toString(16)),
    Hl(Math.round(t).toString(16)),
    Hl(v$e(n))
  ];
  return a && i[0].startsWith(i[0].charAt(1)) && i[1].startsWith(i[1].charAt(1)) && i[2].startsWith(i[2].charAt(1)) && i[3].startsWith(i[3].charAt(1)) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function v$e(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function G3(e) {
  return da(e) / 255;
}
function da(e) {
  return parseInt(e, 16);
}
function h$e(e) {
  return {
    r: e >> 16,
    g: (e & 65280) >> 8,
    b: e & 255
  };
}
var n2 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function p$e(e) {
  var r = { r: 0, g: 0, b: 0 }, t = 1, n = null, a = null, i = null, l = !1, u = !1;
  return typeof e == "string" && (e = b$e(e)), typeof e == "object" && (Oi(e.r) && Oi(e.g) && Oi(e.b) ? (r = u$e(e.r, e.g, e.b), l = !0, u = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Oi(e.h) && Oi(e.s) && Oi(e.v) ? (n = Wh(e.s), a = Wh(e.v), r = d$e(e.h, n, a), l = !0, u = "hsv") : Oi(e.h) && Oi(e.s) && Oi(e.l) && (n = Wh(e.s), i = Wh(e.l), r = c$e(e.h, n, i), l = !0, u = "hsl"), Object.prototype.hasOwnProperty.call(e, "a") && (t = e.a)), t = A8(t), {
    ok: l,
    format: e.format || u,
    r: Math.min(255, Math.max(r.r, 0)),
    g: Math.min(255, Math.max(r.g, 0)),
    b: Math.min(255, Math.max(r.b, 0)),
    a: t
  };
}
var g$e = "[-\\+]?\\d+%?", m$e = "[-\\+]?\\d*\\.\\d+%?", Rs = "(?:".concat(m$e, ")|(?:").concat(g$e, ")"), Dy = "[\\s|\\(]+(".concat(Rs, ")[,|\\s]+(").concat(Rs, ")[,|\\s]+(").concat(Rs, ")\\s*\\)?"), Ny = "[\\s|\\(]+(".concat(Rs, ")[,|\\s]+(").concat(Rs, ")[,|\\s]+(").concat(Rs, ")[,|\\s]+(").concat(Rs, ")\\s*\\)?"), vo = {
  CSS_UNIT: new RegExp(Rs),
  rgb: new RegExp("rgb" + Dy),
  rgba: new RegExp("rgba" + Ny),
  hsl: new RegExp("hsl" + Dy),
  hsla: new RegExp("hsla" + Ny),
  hsv: new RegExp("hsv" + Dy),
  hsva: new RegExp("hsva" + Ny),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function b$e(e) {
  if (e = e.trim().toLowerCase(), e.length === 0)
    return !1;
  var r = !1;
  if (n2[e])
    e = n2[e], r = !0;
  else if (e === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var t = vo.rgb.exec(e);
  return t ? { r: t[1], g: t[2], b: t[3] } : (t = vo.rgba.exec(e), t ? { r: t[1], g: t[2], b: t[3], a: t[4] } : (t = vo.hsl.exec(e), t ? { h: t[1], s: t[2], l: t[3] } : (t = vo.hsla.exec(e), t ? { h: t[1], s: t[2], l: t[3], a: t[4] } : (t = vo.hsv.exec(e), t ? { h: t[1], s: t[2], v: t[3] } : (t = vo.hsva.exec(e), t ? { h: t[1], s: t[2], v: t[3], a: t[4] } : (t = vo.hex8.exec(e), t ? {
    r: da(t[1]),
    g: da(t[2]),
    b: da(t[3]),
    a: G3(t[4]),
    format: r ? "name" : "hex8"
  } : (t = vo.hex6.exec(e), t ? {
    r: da(t[1]),
    g: da(t[2]),
    b: da(t[3]),
    format: r ? "name" : "hex"
  } : (t = vo.hex4.exec(e), t ? {
    r: da(t[1] + t[1]),
    g: da(t[2] + t[2]),
    b: da(t[3] + t[3]),
    a: G3(t[4] + t[4]),
    format: r ? "name" : "hex8"
  } : (t = vo.hex3.exec(e), t ? {
    r: da(t[1] + t[1]),
    g: da(t[2] + t[2]),
    b: da(t[3] + t[3]),
    format: r ? "name" : "hex"
  } : !1)))))))));
}
function Oi(e) {
  return !!vo.CSS_UNIT.exec(String(e));
}
var du = (
  /** @class */
  function() {
    function e(r, t) {
      r === void 0 && (r = ""), t === void 0 && (t = {});
      var n;
      if (r instanceof e)
        return r;
      typeof r == "number" && (r = h$e(r)), this.originalInput = r;
      var a = p$e(r);
      this.originalInput = r, this.r = a.r, this.g = a.g, this.b = a.b, this.a = a.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (n = t.format) !== null && n !== void 0 ? n : a.format, this.gradientType = t.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = a.ok;
    }
    return e.prototype.isDark = function() {
      return this.getBrightness() < 128;
    }, e.prototype.isLight = function() {
      return !this.isDark();
    }, e.prototype.getBrightness = function() {
      var r = this.toRgb();
      return (r.r * 299 + r.g * 587 + r.b * 114) / 1e3;
    }, e.prototype.getLuminance = function() {
      var r = this.toRgb(), t, n, a, i = r.r / 255, l = r.g / 255, u = r.b / 255;
      return i <= 0.03928 ? t = i / 12.92 : t = Math.pow((i + 0.055) / 1.055, 2.4), l <= 0.03928 ? n = l / 12.92 : n = Math.pow((l + 0.055) / 1.055, 2.4), u <= 0.03928 ? a = u / 12.92 : a = Math.pow((u + 0.055) / 1.055, 2.4), 0.2126 * t + 0.7152 * n + 0.0722 * a;
    }, e.prototype.getAlpha = function() {
      return this.a;
    }, e.prototype.setAlpha = function(r) {
      return this.a = A8(r), this.roundA = Math.round(100 * this.a) / 100, this;
    }, e.prototype.isMonochrome = function() {
      var r = this.toHsl().s;
      return r === 0;
    }, e.prototype.toHsv = function() {
      var r = W3(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, v: r.v, a: this.a };
    }, e.prototype.toHsvString = function() {
      var r = W3(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.v * 100);
      return this.a === 1 ? "hsv(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsva(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHsl = function() {
      var r = V3(this.r, this.g, this.b);
      return { h: r.h * 360, s: r.s, l: r.l, a: this.a };
    }, e.prototype.toHslString = function() {
      var r = V3(this.r, this.g, this.b), t = Math.round(r.h * 360), n = Math.round(r.s * 100), a = Math.round(r.l * 100);
      return this.a === 1 ? "hsl(".concat(t, ", ").concat(n, "%, ").concat(a, "%)") : "hsla(".concat(t, ", ").concat(n, "%, ").concat(a, "%, ").concat(this.roundA, ")");
    }, e.prototype.toHex = function(r) {
      return r === void 0 && (r = !1), H3(this.r, this.g, this.b, r);
    }, e.prototype.toHexString = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex(r);
    }, e.prototype.toHex8 = function(r) {
      return r === void 0 && (r = !1), f$e(this.r, this.g, this.b, this.a, r);
    }, e.prototype.toHex8String = function(r) {
      return r === void 0 && (r = !1), "#" + this.toHex8(r);
    }, e.prototype.toHexShortString = function(r) {
      return r === void 0 && (r = !1), this.a === 1 ? this.toHexString(r) : this.toHex8String(r);
    }, e.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    }, e.prototype.toRgbString = function() {
      var r = Math.round(this.r), t = Math.round(this.g), n = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(r, ", ").concat(t, ", ").concat(n, ")") : "rgba(".concat(r, ", ").concat(t, ", ").concat(n, ", ").concat(this.roundA, ")");
    }, e.prototype.toPercentageRgb = function() {
      var r = function(t) {
        return "".concat(Math.round(ln(t, 255) * 100), "%");
      };
      return {
        r: r(this.r),
        g: r(this.g),
        b: r(this.b),
        a: this.a
      };
    }, e.prototype.toPercentageRgbString = function() {
      var r = function(t) {
        return Math.round(ln(t, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%)") : "rgba(".concat(r(this.r), "%, ").concat(r(this.g), "%, ").concat(r(this.b), "%, ").concat(this.roundA, ")");
    }, e.prototype.toName = function() {
      if (this.a === 0)
        return "transparent";
      if (this.a < 1)
        return !1;
      for (var r = "#" + H3(this.r, this.g, this.b, !1), t = 0, n = Object.entries(n2); t < n.length; t++) {
        var a = n[t], i = a[0], l = a[1];
        if (r === l)
          return i;
      }
      return !1;
    }, e.prototype.toString = function(r) {
      var t = !!r;
      r = r != null ? r : this.format;
      var n = !1, a = this.a < 1 && this.a >= 0, i = !t && a && (r.startsWith("hex") || r === "name");
      return i ? r === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (r === "rgb" && (n = this.toRgbString()), r === "prgb" && (n = this.toPercentageRgbString()), (r === "hex" || r === "hex6") && (n = this.toHexString()), r === "hex3" && (n = this.toHexString(!0)), r === "hex4" && (n = this.toHex8String(!0)), r === "hex8" && (n = this.toHex8String()), r === "name" && (n = this.toName()), r === "hsl" && (n = this.toHslString()), r === "hsv" && (n = this.toHsvString()), n || this.toHexString());
    }, e.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    }, e.prototype.clone = function() {
      return new e(this.toString());
    }, e.prototype.lighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l += r / 100, t.l = Vh(t.l), new e(t);
    }, e.prototype.brighten = function(r) {
      r === void 0 && (r = 10);
      var t = this.toRgb();
      return t.r = Math.max(0, Math.min(255, t.r - Math.round(255 * -(r / 100)))), t.g = Math.max(0, Math.min(255, t.g - Math.round(255 * -(r / 100)))), t.b = Math.max(0, Math.min(255, t.b - Math.round(255 * -(r / 100)))), new e(t);
    }, e.prototype.darken = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.l -= r / 100, t.l = Vh(t.l), new e(t);
    }, e.prototype.tint = function(r) {
      return r === void 0 && (r = 10), this.mix("white", r);
    }, e.prototype.shade = function(r) {
      return r === void 0 && (r = 10), this.mix("black", r);
    }, e.prototype.desaturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s -= r / 100, t.s = Vh(t.s), new e(t);
    }, e.prototype.saturate = function(r) {
      r === void 0 && (r = 10);
      var t = this.toHsl();
      return t.s += r / 100, t.s = Vh(t.s), new e(t);
    }, e.prototype.greyscale = function() {
      return this.desaturate(100);
    }, e.prototype.spin = function(r) {
      var t = this.toHsl(), n = (t.h + r) % 360;
      return t.h = n < 0 ? 360 + n : n, new e(t);
    }, e.prototype.mix = function(r, t) {
      t === void 0 && (t = 50);
      var n = this.toRgb(), a = new e(r).toRgb(), i = t / 100, l = {
        r: (a.r - n.r) * i + n.r,
        g: (a.g - n.g) * i + n.g,
        b: (a.b - n.b) * i + n.b,
        a: (a.a - n.a) * i + n.a
      };
      return new e(l);
    }, e.prototype.analogous = function(r, t) {
      r === void 0 && (r = 6), t === void 0 && (t = 30);
      var n = this.toHsl(), a = 360 / t, i = [this];
      for (n.h = (n.h - (a * r >> 1) + 720) % 360; --r; )
        n.h = (n.h + a) % 360, i.push(new e(n));
      return i;
    }, e.prototype.complement = function() {
      var r = this.toHsl();
      return r.h = (r.h + 180) % 360, new e(r);
    }, e.prototype.monochromatic = function(r) {
      r === void 0 && (r = 6);
      for (var t = this.toHsv(), n = t.h, a = t.s, i = t.v, l = [], u = 1 / r; r--; )
        l.push(new e({ h: n, s: a, v: i })), i = (i + u) % 1;
      return l;
    }, e.prototype.splitcomplement = function() {
      var r = this.toHsl(), t = r.h;
      return [
        this,
        new e({ h: (t + 72) % 360, s: r.s, l: r.l }),
        new e({ h: (t + 216) % 360, s: r.s, l: r.l })
      ];
    }, e.prototype.onBackground = function(r) {
      var t = this.toRgb(), n = new e(r).toRgb(), a = t.a + n.a * (1 - t.a);
      return new e({
        r: (t.r * t.a + n.r * n.a * (1 - t.a)) / a,
        g: (t.g * t.a + n.g * n.a * (1 - t.a)) / a,
        b: (t.b * t.a + n.b * n.a * (1 - t.a)) / a,
        a
      });
    }, e.prototype.triad = function() {
      return this.polyad(3);
    }, e.prototype.tetrad = function() {
      return this.polyad(4);
    }, e.prototype.polyad = function(r) {
      for (var t = this.toHsl(), n = t.h, a = [this], i = 360 / r, l = 1; l < r; l++)
        a.push(new e({ h: (n + l * i) % 360, s: t.s, l: t.l }));
      return a;
    }, e.prototype.equals = function(r) {
      return this.toRgbString() === new e(r).toRgbString();
    }, e;
  }()
);
function I8(e) {
  if (e === void 0 && (e = {}), e.count !== void 0 && e.count !== null) {
    var r = e.count, t = [];
    for (e.count = void 0; r > t.length; )
      e.count = null, e.seed && (e.seed += 1), t.push(I8(e));
    return e.count = r, t;
  }
  var n = y$e(e.hue, e.seed), a = S$e(n, e), i = x$e(n, a, e), l = { h: n, s: a, v: i };
  return e.alpha !== void 0 && (l.a = e.alpha), new du(l);
}
function y$e(e, r) {
  var t = w$e(e), n = k0(t, r);
  return n < 0 && (n = 360 + n), n;
}
function S$e(e, r) {
  if (r.hue === "monochrome")
    return 0;
  if (r.luminosity === "random")
    return k0([0, 100], r.seed);
  var t = O8(e).saturationRange, n = t[0], a = t[1];
  switch (r.luminosity) {
    case "bright":
      n = 55;
      break;
    case "dark":
      n = a - 10;
      break;
    case "light":
      a = 55;
      break;
  }
  return k0([n, a], r.seed);
}
function x$e(e, r, t) {
  var n = $$e(e, r), a = 100;
  switch (t.luminosity) {
    case "dark":
      a = n + 20;
      break;
    case "light":
      n = (a + n) / 2;
      break;
    case "random":
      n = 0, a = 100;
      break;
  }
  return k0([n, a], t.seed);
}
function $$e(e, r) {
  for (var t = O8(e).lowerBounds, n = 0; n < t.length - 1; n++) {
    var a = t[n][0], i = t[n][1], l = t[n + 1][0], u = t[n + 1][1];
    if (r >= a && r <= l) {
      var c = (u - i) / (l - a), f = i - c * a;
      return c * r + f;
    }
  }
  return 0;
}
function w$e(e) {
  var r = parseInt(e, 10);
  if (!Number.isNaN(r) && r < 360 && r > 0)
    return [r, r];
  if (typeof e == "string") {
    var t = R8.find(function(l) {
      return l.name === e;
    });
    if (t) {
      var n = M8(t);
      if (n.hueRange)
        return n.hueRange;
    }
    var a = new du(e);
    if (a.isValid) {
      var i = a.toHsv().h;
      return [i, i];
    }
  }
  return [0, 360];
}
function O8(e) {
  e >= 334 && e <= 360 && (e -= 360);
  for (var r = 0, t = R8; r < t.length; r++) {
    var n = t[r], a = M8(n);
    if (a.hueRange && e >= a.hueRange[0] && e <= a.hueRange[1])
      return a;
  }
  throw Error("Color not found");
}
function k0(e, r) {
  if (r === void 0)
    return Math.floor(e[0] + Math.random() * (e[1] + 1 - e[0]));
  var t = e[1] || 1, n = e[0] || 0;
  r = (r * 9301 + 49297) % 233280;
  var a = r / 233280;
  return Math.floor(n + a * (t - n));
}
function M8(e) {
  var r = e.lowerBounds[0][0], t = e.lowerBounds[e.lowerBounds.length - 1][0], n = e.lowerBounds[e.lowerBounds.length - 1][1], a = e.lowerBounds[0][1];
  return {
    name: e.name,
    hueRange: e.hueRange,
    lowerBounds: e.lowerBounds,
    saturationRange: [r, t],
    brightnessRange: [n, a]
  };
}
var R8 = [
  {
    name: "monochrome",
    hueRange: null,
    lowerBounds: [
      [0, 0],
      [100, 0]
    ]
  },
  {
    name: "red",
    hueRange: [-26, 18],
    lowerBounds: [
      [20, 100],
      [30, 92],
      [40, 89],
      [50, 85],
      [60, 78],
      [70, 70],
      [80, 60],
      [90, 55],
      [100, 50]
    ]
  },
  {
    name: "orange",
    hueRange: [19, 46],
    lowerBounds: [
      [20, 100],
      [30, 93],
      [40, 88],
      [50, 86],
      [60, 85],
      [70, 70],
      [100, 70]
    ]
  },
  {
    name: "yellow",
    hueRange: [47, 62],
    lowerBounds: [
      [25, 100],
      [40, 94],
      [50, 89],
      [60, 86],
      [70, 84],
      [80, 82],
      [90, 80],
      [100, 75]
    ]
  },
  {
    name: "green",
    hueRange: [63, 178],
    lowerBounds: [
      [30, 100],
      [40, 90],
      [50, 85],
      [60, 81],
      [70, 74],
      [80, 64],
      [90, 50],
      [100, 40]
    ]
  },
  {
    name: "blue",
    hueRange: [179, 257],
    lowerBounds: [
      [20, 100],
      [30, 86],
      [40, 80],
      [50, 74],
      [60, 60],
      [70, 52],
      [80, 44],
      [90, 39],
      [100, 35]
    ]
  },
  {
    name: "purple",
    hueRange: [258, 282],
    lowerBounds: [
      [20, 100],
      [30, 87],
      [40, 79],
      [50, 70],
      [60, 65],
      [70, 59],
      [80, 52],
      [90, 45],
      [100, 42]
    ]
  },
  {
    name: "pink",
    hueRange: [283, 334],
    lowerBounds: [
      [20, 100],
      [30, 90],
      [40, 86],
      [60, 84],
      [80, 80],
      [90, 75],
      [100, 73]
    ]
  }
], He = function(r, t, n) {
  var a = s8(r, "colors." + t, t), i = new du(a), l = i.isValid;
  return l ? a : n;
}, _$e = function(r) {
  return function(t) {
    var n = He(t, r), a = new du(n).isDark();
    return a ? "dark" : "light";
  };
}, T$e = function(r) {
  return function(t) {
    return _$e(r)(t) === "dark";
  };
}, Ua = function(r, t) {
  return function(n) {
    var a = He(n, r);
    return new du(a).setAlpha(t).toRgbString();
  };
}, C$e = function(r, t) {
  return function(n) {
    var a = He(n, r);
    return new du(a).darken(t).toHexString();
  };
}, E$e = function(r, t) {
  return function(n) {
    return new du(He(n, r)).lighten(t).toHexString();
  };
};
function Y3(e, r) {
  return e === void 0 && (e = "1rem"), r === void 0 && (r = "rgba(255, 255, 255, 0.15)"), {
    backgroundImage: `linear-gradient(
    45deg,
    ` + r + ` 25%,
    transparent 25%,
    transparent 50%,
    ` + r + ` 50%,
    ` + r + ` 75%,
    transparent 75%,
    transparent
  )`,
    backgroundSize: e + " " + e
  };
}
function A$e(e) {
  var r = I8().toHexString();
  return !e || mxe(e) ? r : e.string && e.colors ? O$e(e.string, e.colors) : e.string && !e.colors ? I$e(e.string) : e.colors && !e.string ? M$e(e.colors) : r;
}
function I$e(e) {
  var r = 0;
  if (e.length === 0)
    return r.toString();
  for (var t = 0; t < e.length; t += 1)
    r = e.charCodeAt(t) + ((r << 5) - r), r = r & r;
  for (var n = "#", a = 0; a < 3; a += 1) {
    var i = r >> a * 8 & 255;
    n += ("00" + i.toString(16)).substr(-2);
  }
  return n;
}
function O$e(e, r) {
  var t = 0;
  if (e.length === 0)
    return r[0];
  for (var n = 0; n < e.length; n += 1)
    t = e.charCodeAt(n) + ((t << 5) - t), t = t & t;
  return t = (t % r.length + r.length) % r.length, r[t];
}
function M$e(e) {
  return e[Math.floor(Math.random() * e.length)];
}
function H(e, r) {
  return function(t) {
    return t.colorMode === "dark" ? r : e;
  };
}
function rv(e) {
  var r = e.orientation, t = e.vertical, n = e.horizontal;
  return r ? r === "vertical" ? t : n : {};
}
function a2() {
  return a2 = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, a2.apply(this, arguments);
}
var R$e = function(r) {
  return wxe({
    condition: !0,
    message: ["[chakra-ui]: createBreakpoints(...) will be deprecated pretty soon", "simply pass the breakpoints as an object. Remove the createBreakpoint(..) call"].join("")
  }), a2({
    base: "0em"
  }, r);
};
function K3(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function P$e(e, r, t) {
  return r && K3(e.prototype, r), t && K3(e, t), e;
}
var k$e = /* @__PURE__ */ function() {
  function e(r) {
    var t = this;
    this.map = {}, this.called = !1, this.assert = function() {
      if (!t.called) {
        t.called = !0;
        return;
      }
      throw new Error("[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?");
    }, this.parts = function() {
      t.assert();
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        t.map[c] = t.toPart(c);
      }
      return t;
    }, this.extend = function() {
      for (var n = arguments.length, a = new Array(n), i = 0; i < n; i++)
        a[i] = arguments[i];
      for (var l = 0, u = a; l < u.length; l++) {
        var c = u[l];
        c in t.map || (t.map[c] = t.toPart(c));
      }
      return t;
    }, this.toPart = function(n) {
      var a = ["container", "root"].includes(n != null ? n : "") ? [t.name] : [t.name, n], i = a.filter(Boolean).join("__"), l = "chakra-" + i, u = {
        className: l,
        selector: "." + l,
        toString: function() {
          return n;
        }
      };
      return u;
    }, this.__type = {};
  }
  return P$e(e, [{
    key: "selectors",
    get: (
      /**
       * Get all selectors for the component anatomy
       */
      function() {
        var t = Qx(Object.entries(this.map).map(function(n) {
          var a = n[0], i = n[1];
          return [a, i.selector];
        }));
        return t;
      }
    )
    /**
     * Get all classNames for the component anatomy
     */
  }, {
    key: "classNames",
    get: function() {
      var t = Qx(Object.entries(this.map).map(function(n) {
        var a = n[0], i = n[1];
        return [a, i.className];
      }));
      return t;
    }
    /**
     * Get all parts as array of string
     */
  }, {
    key: "keys",
    get: function() {
      return Object.keys(this.map);
    }
    /**
     * Creates the part object for the given part
     */
  }]), e;
}();
function Gr(e) {
  return new k$e(e);
}
function P8(e) {
  return ni(e) && e.reference ? e.reference : String(e);
}
var vm = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
    n[a - 1] = arguments[a];
  return n.map(P8).join(" " + r + " ").replace(/calc/g, "");
}, Z3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["+"].concat(t)) + ")";
}, q3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["-"].concat(t)) + ")";
}, o2 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["*"].concat(t)) + ")";
}, Q3 = function() {
  for (var r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  return "calc(" + vm.apply(void 0, ["/"].concat(t)) + ")";
}, X3 = function(r) {
  var t = P8(r);
  return t != null && !Number.isNaN(parseFloat(t)) ? String(t).startsWith("-") ? String(t).slice(1) : "-" + t : o2(t, -1);
}, So = Object.assign(function(e) {
  return {
    add: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return So(Z3.apply(void 0, [e].concat(n)));
    },
    subtract: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return So(q3.apply(void 0, [e].concat(n)));
    },
    multiply: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return So(o2.apply(void 0, [e].concat(n)));
    },
    divide: function() {
      for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
        n[a] = arguments[a];
      return So(Q3.apply(void 0, [e].concat(n)));
    },
    negate: function() {
      return So(X3(e));
    },
    toString: function() {
      return e.toString();
    }
  };
}, {
  add: Z3,
  subtract: q3,
  multiply: o2,
  divide: Q3,
  negate: X3
});
function j$e(e) {
  return !Number.isInteger(parseFloat(e.toString()));
}
function D$e(e, r) {
  return r === void 0 && (r = "-"), e.replace(/\s+/g, r);
}
function k8(e) {
  var r = D$e(e.toString());
  return r.includes("\\.") ? e : j$e(e) ? r.replace(".", "\\.") : e;
}
function N$e(e, r) {
  return r === void 0 && (r = ""), [r, k8(e)].filter(Boolean).join("-");
}
function L$e(e, r) {
  return "var(" + k8(e) + (r ? ", " + r : "") + ")";
}
function F$e(e, r) {
  return r === void 0 && (r = ""), "--" + N$e(e, r);
}
function $t(e, r) {
  var t = F$e(e, r == null ? void 0 : r.prefix);
  return {
    variable: t,
    reference: L$e(t, z$e(r == null ? void 0 : r.fallback))
  };
}
function z$e(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.reference;
}
var B$e = Gr("accordion").parts("root", "container", "button", "panel").extend("icon"), U$e = Gr("alert").parts("title", "description", "container").extend("icon"), V$e = Gr("avatar").parts("label", "badge", "container").extend("excessLabel", "group"), W$e = Gr("breadcrumb").parts("link", "item", "container").extend("separator");
Gr("button").parts();
var j8 = Gr("checkbox").parts("control", "icon", "container").extend("label");
Gr("progress").parts("track", "filledTrack").extend("label");
var H$e = Gr("drawer").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), G$e = Gr("editable").parts("preview", "input", "textarea"), Y$e = Gr("form").parts("container", "requiredIndicator", "helperText"), K$e = Gr("formError").parts("text", "icon"), D8 = Gr("input").parts("addon", "field", "element"), Z$e = Gr("list").parts("container", "item", "icon"), q$e = Gr("menu").parts("button", "list", "item").extend("groupTitle", "command", "divider"), N8 = Gr("modal").parts("overlay", "dialogContainer", "dialog").extend("header", "closeButton", "body", "footer"), Q$e = Gr("numberinput").parts("root", "field", "stepperGroup", "stepper");
Gr("pininput").parts("field");
var L8 = Gr("popover").parts("content", "header", "body", "footer").extend("popper", "arrow", "closeButton"), X$e = Gr("progress").parts("label", "filledTrack", "track"), F8 = Gr("radio").parts("container", "control", "label"), J$e = Gr("select").parts("field", "icon"), ewe = Gr("slider").parts("container", "track", "thumb", "filledTrack"), rwe = Gr("stat").parts("container", "label", "helpText", "number", "icon"), z8 = Gr("switch").parts("container", "track", "thumb"), twe = Gr("table").parts("table", "thead", "tbody", "tr", "th", "td", "tfoot", "caption"), nwe = Gr("tabs").parts("root", "tab", "tablist", "tabpanel", "tabpanels", "indicator"), awe = Gr("tag").parts("container", "label", "closeButton"), B8 = {
  letterSpacings: {
    tighter: "-0.05em",
    tight: "-0.025em",
    normal: "0",
    wide: "0.025em",
    wider: "0.05em",
    widest: "0.1em"
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    3: ".75rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  fonts: {
    heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
    "9xl": "8rem"
  }
}, owe = {
  borderTopWidth: "1px",
  borderColor: "inherit",
  _last: {
    borderBottomWidth: "1px"
  }
}, iwe = {
  transitionProperty: "common",
  transitionDuration: "normal",
  fontSize: "1rem",
  _focus: {
    boxShadow: "outline"
  },
  _hover: {
    bg: "blackAlpha.50"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed"
  },
  px: 4,
  py: 2
}, swe = {
  pt: 2,
  px: 4,
  pb: 5
}, lwe = {
  fontSize: "1.25em"
}, uwe = {
  root: {},
  container: owe,
  button: iwe,
  panel: swe,
  icon: lwe
}, cwe = {
  parts: B$e.keys,
  baseStyle: uwe
}, dwe = {
  container: {
    px: 4,
    py: 3
  },
  title: {
    fontWeight: "bold",
    lineHeight: 6,
    marginEnd: 2
  },
  description: {
    lineHeight: 6
  },
  icon: {
    flexShrink: 0,
    marginEnd: 3,
    w: 5,
    h: 6
  }
};
function u_(e) {
  var r = e.theme, t = e.colorScheme, n = He(r, t + ".100", t), a = Ua(t + ".200", 0.16)(r);
  return H(n, a)(e);
}
var fwe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: u_(r)
    },
    icon: {
      color: H(t + ".500", t + ".200")(r)
    }
  };
}, vwe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      paddingStart: 3,
      borderStartWidth: "4px",
      borderStartColor: H(t + ".500", t + ".200")(r),
      bg: u_(r)
    },
    icon: {
      color: H(t + ".500", t + ".200")(r)
    }
  };
}, hwe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      pt: 2,
      borderTopWidth: "4px",
      borderTopColor: H(t + ".500", t + ".200")(r),
      bg: u_(r)
    },
    icon: {
      color: H(t + ".500", t + ".200")(r)
    }
  };
}, pwe = function(r) {
  var t = r.colorScheme;
  return {
    container: {
      bg: H(t + ".500", t + ".200")(r),
      color: H("white", "gray.900")(r)
    }
  };
}, gwe = {
  subtle: fwe,
  "left-accent": vwe,
  "top-accent": hwe,
  solid: pwe
}, mwe = {
  variant: "subtle",
  colorScheme: "blue"
}, bwe = {
  parts: U$e.keys,
  baseStyle: dwe,
  variants: gwe,
  defaultProps: mwe
}, ywe = function(r) {
  return {
    transform: "translate(25%, 25%)",
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: H("white", "gray.800")(r)
  };
}, Swe = function(r) {
  return {
    bg: H("gray.200", "whiteAlpha.400")(r)
  };
}, xwe = function(r) {
  var t = r.name, n = r.theme, a = t ? A$e({
    string: t
  }) : "gray.400", i = T$e(a)(n), l = "white";
  i || (l = "gray.800");
  var u = H("white", "gray.800")(r);
  return {
    bg: a,
    color: l,
    borderColor: u,
    verticalAlign: "top"
  };
}, $we = function(r) {
  return {
    badge: ywe(r),
    excessLabel: Swe(r),
    container: xwe(r)
  };
};
function bs(e) {
  var r = E8[e];
  return {
    container: {
      width: e,
      height: e,
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)"
    },
    excessLabel: {
      width: e,
      height: e
    },
    label: {
      fontSize: "calc(" + (r != null ? r : e) + " / 2.5)",
      lineHeight: e !== "100%" ? r != null ? r : e : void 0
    }
  };
}
var wwe = {
  "2xs": bs("4"),
  xs: bs("6"),
  sm: bs("8"),
  md: bs("12"),
  lg: bs("16"),
  xl: bs("24"),
  "2xl": bs("32"),
  full: bs("100%")
}, _we = {
  size: "md"
}, Twe = {
  parts: V$e.keys,
  baseStyle: $we,
  sizes: wwe,
  defaultProps: _we
}, Cwe = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, Ewe = function(r) {
  var t = r.colorScheme, n = r.theme, a = Ua(t + ".500", 0.6)(n);
  return {
    bg: H(t + ".500", a)(r),
    color: H("white", "whiteAlpha.800")(r)
  };
}, Awe = function(r) {
  var t = r.colorScheme, n = r.theme, a = Ua(t + ".200", 0.16)(n);
  return {
    bg: H(t + ".100", a)(r),
    color: H(t + ".800", t + ".200")(r)
  };
}, Iwe = function(r) {
  var t = r.colorScheme, n = r.theme, a = Ua(t + ".200", 0.8)(n), i = He(n, t + ".500"), l = H(i, a)(r);
  return {
    color: l,
    boxShadow: "inset 0 0 0px 1px " + l
  };
}, Owe = {
  solid: Ewe,
  subtle: Awe,
  outline: Iwe
}, Mwe = {
  variant: "subtle",
  colorScheme: "gray"
}, fc = {
  baseStyle: Cwe,
  variants: Owe,
  defaultProps: Mwe
}, Rwe = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, Pwe = {
  link: Rwe
}, kwe = {
  parts: W$e.keys,
  baseStyle: Pwe
}, jwe = {
  lineHeight: "1.2",
  borderRadius: "md",
  fontWeight: "semibold",
  transitionProperty: "common",
  transitionDuration: "normal",
  _focus: {
    boxShadow: "outline"
  },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none"
  },
  _hover: {
    _disabled: {
      bg: "initial"
    }
  }
}, U8 = function(r) {
  var t = r.colorScheme, n = r.theme;
  if (t === "gray")
    return {
      color: H("inherit", "whiteAlpha.900")(r),
      _hover: {
        bg: H("gray.100", "whiteAlpha.200")(r)
      },
      _active: {
        bg: H("gray.200", "whiteAlpha.300")(r)
      }
    };
  var a = Ua(t + ".200", 0.12)(n), i = Ua(t + ".200", 0.24)(n);
  return {
    color: H(t + ".600", t + ".200")(r),
    bg: "transparent",
    _hover: {
      bg: H(t + ".50", a)(r)
    },
    _active: {
      bg: H(t + ".100", i)(r)
    }
  };
}, Dwe = function(r) {
  var t = r.colorScheme, n = H("gray.200", "whiteAlpha.300")(r);
  return Ot({
    border: "1px solid",
    borderColor: t === "gray" ? n : "currentColor"
  }, U8(r));
}, Nwe = {
  yellow: {
    bg: "yellow.400",
    color: "black",
    hoverBg: "yellow.500",
    activeBg: "yellow.600"
  },
  cyan: {
    bg: "cyan.400",
    color: "black",
    hoverBg: "cyan.500",
    activeBg: "cyan.600"
  }
}, Lwe = function(r) {
  var t, n = r.colorScheme;
  if (n === "gray") {
    var a = H("gray.100", "whiteAlpha.200")(r);
    return {
      bg: a,
      _hover: {
        bg: H("gray.200", "whiteAlpha.300")(r),
        _disabled: {
          bg: a
        }
      },
      _active: {
        bg: H("gray.300", "whiteAlpha.400")(r)
      }
    };
  }
  var i = (t = Nwe[n]) != null ? t : {}, l = i.bg, u = l === void 0 ? n + ".500" : l, c = i.color, f = c === void 0 ? "white" : c, h = i.hoverBg, p = h === void 0 ? n + ".600" : h, g = i.activeBg, y = g === void 0 ? n + ".700" : g, S = H(u, n + ".200")(r);
  return {
    bg: S,
    color: H(f, "gray.800")(r),
    _hover: {
      bg: H(p, n + ".300")(r),
      _disabled: {
        bg: S
      }
    },
    _active: {
      bg: H(y, n + ".400")(r)
    }
  };
}, Fwe = function(r) {
  var t = r.colorScheme;
  return {
    padding: 0,
    height: "auto",
    lineHeight: "normal",
    verticalAlign: "baseline",
    color: H(t + ".500", t + ".200")(r),
    _hover: {
      textDecoration: "underline",
      _disabled: {
        textDecoration: "none"
      }
    },
    _active: {
      color: H(t + ".700", t + ".500")(r)
    }
  };
}, zwe = {
  bg: "none",
  color: "inherit",
  display: "inline",
  lineHeight: "inherit",
  m: 0,
  p: 0
}, Bwe = {
  ghost: U8,
  outline: Dwe,
  solid: Lwe,
  link: Fwe,
  unstyled: zwe
}, Uwe = {
  lg: {
    h: 12,
    minW: 12,
    fontSize: "lg",
    px: 6
  },
  md: {
    h: 10,
    minW: 10,
    fontSize: "md",
    px: 4
  },
  sm: {
    h: 8,
    minW: 8,
    fontSize: "sm",
    px: 3
  },
  xs: {
    h: 6,
    minW: 6,
    fontSize: "xs",
    px: 2
  }
}, Vwe = {
  variant: "solid",
  size: "md",
  colorScheme: "gray"
}, Wwe = {
  baseStyle: jwe,
  variants: Bwe,
  sizes: Uwe,
  defaultProps: Vwe
}, Hwe = function(r) {
  var t = r.colorScheme;
  return {
    w: "100%",
    transitionProperty: "box-shadow",
    transitionDuration: "normal",
    border: "2px solid",
    borderRadius: "sm",
    borderColor: "inherit",
    color: "white",
    _checked: {
      bg: H(t + ".500", t + ".200")(r),
      borderColor: H(t + ".500", t + ".200")(r),
      color: H("white", "gray.900")(r),
      _hover: {
        bg: H(t + ".600", t + ".300")(r),
        borderColor: H(t + ".600", t + ".300")(r)
      },
      _disabled: {
        borderColor: H("gray.200", "transparent")(r),
        bg: H("gray.200", "whiteAlpha.300")(r),
        color: H("gray.500", "whiteAlpha.500")(r)
      }
    },
    _indeterminate: {
      bg: H(t + ".500", t + ".200")(r),
      borderColor: H(t + ".500", t + ".200")(r),
      color: H("white", "gray.900")(r)
    },
    _disabled: {
      bg: H("gray.100", "whiteAlpha.100")(r),
      borderColor: H("gray.100", "transparent")(r)
    },
    _focus: {
      boxShadow: "outline"
    },
    _invalid: {
      borderColor: H("red.500", "red.300")(r)
    }
  };
}, Gwe = {
  _disabled: {
    cursor: "not-allowed"
  }
}, Ywe = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, Kwe = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, Zwe = function(r) {
  return {
    icon: Kwe,
    container: Gwe,
    control: Hwe(r),
    label: Ywe
  };
}, qwe = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.45rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "0.625rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "0.625rem"
    }
  }
}, Qwe = {
  size: "md",
  colorScheme: "blue"
}, j0 = {
  parts: j8.keys,
  baseStyle: Zwe,
  sizes: qwe,
  defaultProps: Qwe
}, Hh, Gh, Yh, Hd = $t("close-button-size"), Xwe = function(r) {
  var t = H("blackAlpha.100", "whiteAlpha.100")(r), n = H("blackAlpha.200", "whiteAlpha.200")(r);
  return {
    w: [Hd.reference],
    h: [Hd.reference],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      bg: t
    },
    _active: {
      bg: n
    },
    _focus: {
      boxShadow: "outline"
    }
  };
}, Jwe = {
  lg: (Hh = {}, Hh[Hd.variable] = "40px", Hh.fontSize = "16px", Hh),
  md: (Gh = {}, Gh[Hd.variable] = "32px", Gh.fontSize = "12px", Gh),
  sm: (Yh = {}, Yh[Hd.variable] = "24px", Yh.fontSize = "10px", Yh)
}, e_e = {
  size: "md"
}, r_e = {
  baseStyle: Xwe,
  sizes: Jwe,
  defaultProps: e_e
}, t_e = fc.variants, n_e = fc.defaultProps, a_e = {
  fontFamily: "mono",
  fontSize: "sm",
  px: "0.2em",
  borderRadius: "sm"
}, o_e = {
  baseStyle: a_e,
  variants: t_e,
  defaultProps: n_e
}, i_e = {
  w: "100%",
  mx: "auto",
  maxW: "60ch",
  px: "1rem"
}, s_e = {
  baseStyle: i_e
}, l_e = {
  opacity: 0.6,
  borderColor: "inherit"
}, u_e = {
  borderStyle: "solid"
}, c_e = {
  borderStyle: "dashed"
}, d_e = {
  solid: u_e,
  dashed: c_e
}, f_e = {
  variant: "solid"
}, v_e = {
  baseStyle: l_e,
  variants: d_e,
  defaultProps: f_e
};
function Lu(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      h: "100vh"
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var h_e = {
  bg: "blackAlpha.600",
  zIndex: "overlay"
}, p_e = {
  display: "flex",
  zIndex: "modal",
  justifyContent: "center"
}, g_e = function(r) {
  var t = r.isFullHeight;
  return Ot({}, t && {
    height: "100vh"
  }, {
    zIndex: "modal",
    maxH: "100vh",
    bg: H("white", "gray.700")(r),
    color: "inherit",
    boxShadow: H("lg", "dark-lg")(r)
  });
}, m_e = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, b_e = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, y_e = {
  px: 6,
  py: 2,
  flex: 1,
  overflow: "auto"
}, S_e = {
  px: 6,
  py: 4
}, x_e = function(r) {
  return {
    overlay: h_e,
    dialogContainer: p_e,
    dialog: g_e(r),
    header: m_e,
    closeButton: b_e,
    body: y_e,
    footer: S_e
  };
}, $_e = {
  xs: Lu("xs"),
  sm: Lu("md"),
  md: Lu("lg"),
  lg: Lu("2xl"),
  xl: Lu("4xl"),
  full: Lu("full")
}, w_e = {
  size: "xs"
}, __e = {
  parts: H$e.keys,
  baseStyle: x_e,
  sizes: $_e,
  defaultProps: w_e
}, T_e = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal"
}, C_e = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, E_e = {
  borderRadius: "md",
  py: "3px",
  transitionProperty: "common",
  transitionDuration: "normal",
  width: "full",
  _focus: {
    boxShadow: "outline"
  },
  _placeholder: {
    opacity: 0.6
  }
}, A_e = {
  preview: T_e,
  input: C_e,
  textarea: E_e
}, I_e = {
  parts: G$e.keys,
  baseStyle: A_e
}, O_e = function(r) {
  return {
    marginStart: 1,
    color: H("red.500", "red.300")(r)
  };
}, M_e = function(r) {
  return {
    mt: 2,
    color: H("gray.500", "whiteAlpha.600")(r),
    lineHeight: "normal",
    fontSize: "sm"
  };
}, R_e = function(r) {
  return {
    container: {
      width: "100%",
      position: "relative"
    },
    requiredIndicator: O_e(r),
    helperText: M_e(r)
  };
}, P_e = {
  parts: Y$e.keys,
  baseStyle: R_e
}, k_e = function(r) {
  return {
    color: H("red.500", "red.300")(r),
    mt: 2,
    fontSize: "sm",
    lineHeight: "normal"
  };
}, j_e = function(r) {
  return {
    marginEnd: "0.5em",
    color: H("red.500", "red.300")(r)
  };
}, D_e = function(r) {
  return {
    text: k_e(r),
    icon: j_e(r)
  };
}, N_e = {
  parts: K$e.keys,
  baseStyle: D_e
}, L_e = {
  fontSize: "md",
  marginEnd: 3,
  mb: 2,
  fontWeight: "medium",
  transitionProperty: "common",
  transitionDuration: "normal",
  opacity: 1,
  _disabled: {
    opacity: 0.4
  }
}, F_e = {
  baseStyle: L_e
}, z_e = {
  fontFamily: "heading",
  fontWeight: "bold"
}, B_e = {
  "4xl": {
    fontSize: ["6xl", null, "7xl"],
    lineHeight: 1
  },
  "3xl": {
    fontSize: ["5xl", null, "6xl"],
    lineHeight: 1
  },
  "2xl": {
    fontSize: ["4xl", null, "5xl"],
    lineHeight: [1.2, null, 1]
  },
  xl: {
    fontSize: ["3xl", null, "4xl"],
    lineHeight: [1.33, null, 1.2]
  },
  lg: {
    fontSize: ["2xl", null, "3xl"],
    lineHeight: [1.33, null, 1.2]
  },
  md: {
    fontSize: "xl",
    lineHeight: 1.2
  },
  sm: {
    fontSize: "md",
    lineHeight: 1.2
  },
  xs: {
    fontSize: "sm",
    lineHeight: 1.2
  }
}, U_e = {
  size: "xl"
}, V_e = {
  baseStyle: z_e,
  sizes: B_e,
  defaultProps: U_e
}, W_e = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal"
  }
}, ys = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: 6,
    borderRadius: "sm"
  }
}, H_e = {
  lg: {
    field: ys.lg,
    addon: ys.lg
  },
  md: {
    field: ys.md,
    addon: ys.md
  },
  sm: {
    field: ys.sm,
    addon: ys.sm
  },
  xs: {
    field: ys.xs,
    addon: ys.xs
  }
};
function c_(e) {
  var r = e.focusBorderColor, t = e.errorBorderColor;
  return {
    focusBorderColor: r || H("blue.500", "blue.300")(e),
    errorBorderColor: t || H("red.500", "red.300")(e)
  };
}
var G_e = function(r) {
  var t = r.theme, n = c_(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "1px solid",
      borderColor: "inherit",
      bg: "inherit",
      _hover: {
        borderColor: H("gray.300", "whiteAlpha.400")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: He(t, i),
        boxShadow: "0 0 0 1px " + He(t, i)
      },
      _focus: {
        zIndex: 1,
        borderColor: He(t, a),
        boxShadow: "0 0 0 1px " + He(t, a)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: H("inherit", "whiteAlpha.50")(r),
      bg: H("gray.100", "whiteAlpha.300")(r)
    }
  };
}, Y_e = function(r) {
  var t = r.theme, n = c_(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      border: "2px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(r),
      _hover: {
        bg: H("gray.200", "whiteAlpha.100")(r)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _invalid: {
        borderColor: He(t, i)
      },
      _focus: {
        bg: "transparent",
        borderColor: He(t, a)
      }
    },
    addon: {
      border: "2px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(r)
    }
  };
}, K_e = function(r) {
  var t = r.theme, n = c_(r), a = n.focusBorderColor, i = n.errorBorderColor;
  return {
    field: {
      borderBottom: "1px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: He(t, i),
        boxShadow: "0px 1px 0px 0px " + He(t, i)
      },
      _focus: {
        borderColor: He(t, a),
        boxShadow: "0px 1px 0px 0px " + He(t, a)
      }
    },
    addon: {
      borderBottom: "2px solid",
      borderColor: "inherit",
      borderRadius: 0,
      px: 0,
      bg: "transparent"
    }
  };
}, Z_e = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto"
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, q_e = {
  outline: G_e,
  filled: Y_e,
  flushed: K_e,
  unstyled: Z_e
}, Q_e = {
  size: "md",
  variant: "outline"
}, ht = {
  parts: D8.keys,
  baseStyle: W_e,
  sizes: H_e,
  variants: q_e,
  defaultProps: Q_e
}, X_e = function(r) {
  return {
    bg: H("gray.100", "whiteAlpha")(r),
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
  };
}, J_e = {
  baseStyle: X_e
}, e5e = {
  transitionProperty: "common",
  transitionDuration: "fast",
  transitionTimingFunction: "ease-out",
  cursor: "pointer",
  textDecoration: "none",
  outline: "none",
  color: "inherit",
  _hover: {
    textDecoration: "underline"
  },
  _focus: {
    boxShadow: "outline"
  }
}, r5e = {
  baseStyle: e5e
}, t5e = {
  marginEnd: "0.5rem",
  display: "inline",
  verticalAlign: "text-bottom"
}, n5e = {
  container: {},
  item: {},
  icon: t5e
}, a5e = {
  parts: Z$e.keys,
  baseStyle: n5e
}, o5e = function(r) {
  return {
    bg: H("#fff", "gray.700")(r),
    boxShadow: H("sm", "dark-lg")(r),
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: 1,
    borderRadius: "md",
    borderWidth: "1px"
  };
}, i5e = function(r) {
  return {
    py: "0.4rem",
    px: "0.8rem",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
      bg: H("gray.100", "whiteAlpha.100")(r)
    },
    _active: {
      bg: H("gray.200", "whiteAlpha.200")(r)
    },
    _expanded: {
      bg: H("gray.100", "whiteAlpha.100")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, s5e = {
  mx: 4,
  my: 2,
  fontWeight: "semibold",
  fontSize: "sm"
}, l5e = {
  opacity: 0.6
}, u5e = {
  border: 0,
  borderBottom: "1px solid",
  borderColor: "inherit",
  my: "0.5rem",
  opacity: 0.6
}, c5e = {
  transitionProperty: "common",
  transitionDuration: "normal"
}, d5e = function(r) {
  return {
    button: c5e,
    list: o5e(r),
    item: i5e(r),
    groupTitle: s5e,
    command: l5e,
    divider: u5e
  };
}, f5e = {
  parts: q$e.keys,
  baseStyle: d5e
}, v5e = {
  bg: "blackAlpha.600",
  zIndex: "modal"
}, h5e = function(r) {
  var t = r.isCentered, n = r.scrollBehavior;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: t ? "center" : "flex-start",
    overflow: n === "inside" ? "hidden" : "auto"
  };
}, p5e = function(r) {
  var t = r.scrollBehavior;
  return {
    borderRadius: "md",
    bg: H("white", "gray.700")(r),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: t === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: H("lg", "dark-lg")(r)
  };
}, g5e = {
  px: 6,
  py: 4,
  fontSize: "xl",
  fontWeight: "semibold"
}, m5e = {
  position: "absolute",
  top: 2,
  insetEnd: 3
}, b5e = function(r) {
  var t = r.scrollBehavior;
  return {
    px: 6,
    py: 2,
    flex: 1,
    overflow: t === "inside" ? "auto" : void 0
  };
}, y5e = {
  px: 6,
  py: 4
}, S5e = function(r) {
  return {
    overlay: v5e,
    dialogContainer: h5e(r),
    dialog: p5e(r),
    header: g5e,
    closeButton: m5e,
    body: b5e(r),
    footer: y5e
  };
};
function lo(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
var x5e = {
  xs: lo("xs"),
  sm: lo("sm"),
  md: lo("md"),
  lg: lo("lg"),
  xl: lo("xl"),
  "2xl": lo("2xl"),
  "3xl": lo("3xl"),
  "4xl": lo("4xl"),
  "5xl": lo("5xl"),
  "6xl": lo("6xl"),
  full: lo("full")
}, $5e = {
  size: "md"
}, w5e = {
  parts: N8.keys,
  baseStyle: S5e,
  sizes: x5e,
  defaultProps: $5e
}, Kh, J3, eI, _5e = ht.variants, T5e = ht.defaultProps, d_ = $t("number-input-stepper-width"), V8 = $t("number-input-input-padding"), C5e = So(d_).add("0.5rem").toString(), E5e = (Kh = {}, Kh[d_.variable] = "24px", Kh[V8.variable] = C5e, Kh), A5e = (J3 = (eI = ht.baseStyle) == null ? void 0 : eI.field) != null ? J3 : {}, I5e = {
  width: [d_.reference]
}, O5e = function(r) {
  return {
    borderStart: "1px solid",
    borderStartColor: H("inherit", "whiteAlpha.300")(r),
    color: H("inherit", "whiteAlpha.800")(r),
    _active: {
      bg: H("gray.200", "whiteAlpha.300")(r)
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  };
}, M5e = function(r) {
  return {
    root: E5e,
    field: A5e,
    stepperGroup: I5e,
    stepper: O5e(r)
  };
};
function Zh(e) {
  var r, t, n = ht.sizes[e], a = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  }, i = (r = (t = n.field) == null ? void 0 : t.fontSize) != null ? r : "md", l = B8.fontSizes[i.toString()];
  return {
    field: Ot({}, n.field, {
      paddingInlineEnd: V8.reference,
      verticalAlign: "top"
    }),
    stepper: {
      fontSize: So(l).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: a[e]
      },
      _last: {
        borderBottomEndRadius: a[e],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  };
}
var R5e = {
  xs: Zh("xs"),
  sm: Zh("sm"),
  md: Zh("md"),
  lg: Zh("lg")
}, P5e = {
  parts: Q$e.keys,
  baseStyle: M5e,
  sizes: R5e,
  variants: _5e,
  defaultProps: T5e
}, rI, k5e = Ot({}, ht.baseStyle.field, {
  textAlign: "center"
}), j5e = {
  lg: {
    fontSize: "lg",
    w: 12,
    h: 12,
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    w: 10,
    h: 10,
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    w: 8,
    h: 8,
    borderRadius: "sm"
  },
  xs: {
    fontSize: "xs",
    w: 6,
    h: 6,
    borderRadius: "sm"
  }
}, D5e = {
  outline: function(r) {
    var t;
    return (t = ht.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = ht.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = ht.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (rI = ht.variants.unstyled.field) != null ? rI : {}
}, N5e = ht.defaultProps, L5e = {
  baseStyle: k5e,
  sizes: j5e,
  variants: D5e,
  defaultProps: N5e
}, Ly = $t("popper-bg"), F5e = $t("popper-arrow-bg"), z5e = $t("popper-arrow-shadow-color"), B5e = {
  zIndex: 10
}, U5e = function(r) {
  var t, n = H("white", "gray.700")(r), a = H("gray.200", "whiteAlpha.300")(r);
  return t = {}, t[Ly.variable] = "colors." + n, t.bg = Ly.reference, t[F5e.variable] = Ly.reference, t[z5e.variable] = "colors." + a, t.width = "xs", t.border = "1px solid", t.borderColor = "inherit", t.borderRadius = "md", t.boxShadow = "sm", t.zIndex = "inherit", t._focus = {
    outline: 0,
    boxShadow: "outline"
  }, t;
}, V5e = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}, W5e = {
  px: 3,
  py: 2
}, H5e = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, G5e = {
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}, Y5e = function(r) {
  return {
    popper: B5e,
    content: U5e(r),
    header: V5e,
    body: W5e,
    footer: H5e,
    arrow: {},
    closeButton: G5e
  };
}, K5e = {
  parts: L8.keys,
  baseStyle: Y5e
};
function Z5e(e) {
  var r = e.colorScheme, t = e.theme, n = e.isIndeterminate, a = e.hasStripe, i = H(Y3(), Y3("1rem", "rgba(0,0,0,0.1)"))(e), l = H(r + ".500", r + ".200")(e), u = `linear-gradient(
    to right,
    transparent 0%,
    ` + He(t, l) + ` 50%,
    transparent 100%
  )`, c = !n && a;
  return Ot({}, c && i, n ? {
    bgImage: u
  } : {
    bgColor: l
  });
}
var q5e = {
  lineHeight: "1",
  fontSize: "0.25em",
  fontWeight: "bold",
  color: "white"
}, Q5e = function(r) {
  return {
    bg: H("gray.100", "whiteAlpha.300")(r)
  };
}, X5e = function(r) {
  return Ot({
    transitionProperty: "common",
    transitionDuration: "slow"
  }, Z5e(r));
}, J5e = function(r) {
  return {
    label: q5e,
    filledTrack: X5e(r),
    track: Q5e(r)
  };
}, eTe = {
  xs: {
    track: {
      h: "0.25rem"
    }
  },
  sm: {
    track: {
      h: "0.5rem"
    }
  },
  md: {
    track: {
      h: "0.75rem"
    }
  },
  lg: {
    track: {
      h: "1rem"
    }
  }
}, rTe = {
  size: "md",
  colorScheme: "blue"
}, tTe = {
  parts: X$e.keys,
  sizes: eTe,
  baseStyle: J5e,
  defaultProps: rTe
}, nTe = function(r) {
  var t = j0.baseStyle(r), n = t.control, a = n === void 0 ? {} : n;
  return Ot({}, a, {
    borderRadius: "full",
    _checked: Ot({}, a._checked, {
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: "50%",
        h: "50%",
        borderRadius: "50%",
        bg: "currentColor"
      }
    })
  });
}, aTe = function(r) {
  return {
    label: j0.baseStyle(r).label,
    container: j0.baseStyle(r).container,
    control: nTe(r)
  };
}, oTe = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, iTe = {
  size: "md",
  colorScheme: "blue"
}, sTe = {
  parts: F8.keys,
  baseStyle: aTe,
  sizes: oTe,
  defaultProps: iTe
}, lTe = function(r) {
  return Ot({}, ht.baseStyle.field, {
    bg: H("white", "gray.700")(r),
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    "> option, > optgroup": {
      bg: H("white", "gray.700")(r)
    }
  });
}, uTe = {
  width: "1.5rem",
  height: "100%",
  insetEnd: "0.5rem",
  position: "relative",
  color: "currentColor",
  fontSize: "1.25rem",
  _disabled: {
    opacity: 0.5
  }
}, cTe = function(r) {
  return {
    field: lTe(r),
    icon: uTe
  };
}, qh = {
  paddingInlineEnd: "2rem"
}, dTe = Ms({}, ht.sizes, {
  lg: {
    field: qh
  },
  md: {
    field: qh
  },
  sm: {
    field: qh
  },
  xs: {
    field: qh,
    icon: {
      insetEnd: "0.25rem"
    }
  }
}), fTe = {
  parts: J$e.keys,
  baseStyle: cTe,
  sizes: dTe,
  variants: ht.variants,
  defaultProps: ht.defaultProps
}, vTe = function(r, t) {
  return pxe({
    from: {
      borderColor: r,
      background: r
    },
    to: {
      borderColor: t,
      background: t
    }
  });
}, hTe = function(r) {
  var t = H("gray.100", "gray.800")(r), n = H("gray.400", "gray.600")(r), a = r.startColor, i = a === void 0 ? t : a, l = r.endColor, u = l === void 0 ? n : l, c = r.speed, f = r.theme, h = He(f, i), p = He(f, u);
  return {
    opacity: 0.7,
    borderRadius: "2px",
    borderColor: h,
    background: p,
    animation: c + "s linear infinite alternate " + vTe(h, p)
  };
}, pTe = {
  baseStyle: hTe
}, gTe = function(r) {
  return {
    borderRadius: "md",
    fontWeight: "semibold",
    _focus: {
      boxShadow: "outline",
      padding: "1rem",
      position: "fixed",
      top: "1.5rem",
      insetStart: "1.5rem",
      bg: H("white", "gray.700")(r)
    }
  };
}, mTe = {
  baseStyle: gTe
};
function bTe(e) {
  return rv({
    orientation: e.orientation,
    vertical: {
      left: "50%",
      transform: "translateX(-50%)",
      _active: {
        transform: "translateX(-50%) scale(1.15)"
      }
    },
    horizontal: {
      top: "50%",
      transform: "translateY(-50%)",
      _active: {
        transform: "translateY(-50%) scale(1.15)"
      }
    }
  });
}
var yTe = function(r) {
  var t = r.orientation;
  return Ot({
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.6,
      cursor: "default",
      pointerEvents: "none"
    }
  }, rv({
    orientation: t,
    vertical: {
      h: "100%"
    },
    horizontal: {
      w: "100%"
    }
  }));
}, STe = function(r) {
  return {
    overflow: "hidden",
    borderRadius: "sm",
    bg: H("gray.200", "whiteAlpha.200")(r),
    _disabled: {
      bg: H("gray.300", "whiteAlpha.300")(r)
    }
  };
}, xTe = function(r) {
  return Ot({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "base",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      bg: "gray.300"
    }
  }, bTe(r));
}, $Te = function(r) {
  var t = r.colorScheme;
  return {
    width: "inherit",
    height: "inherit",
    bg: H(t + ".500", t + ".200")(r)
  };
}, wTe = function(r) {
  return {
    container: yTe(r),
    track: STe(r),
    thumb: xTe(r),
    filledTrack: $Te(r)
  };
}, _Te = function(r) {
  return {
    thumb: {
      w: "16px",
      h: "16px"
    },
    track: rv({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, TTe = function(r) {
  return {
    thumb: {
      w: "14px",
      h: "14px"
    },
    track: rv({
      orientation: r.orientation,
      horizontal: {
        h: "4px"
      },
      vertical: {
        w: "4px"
      }
    })
  };
}, CTe = function(r) {
  return {
    thumb: {
      w: "10px",
      h: "10px"
    },
    track: rv({
      orientation: r.orientation,
      horizontal: {
        h: "2px"
      },
      vertical: {
        w: "2px"
      }
    })
  };
}, ETe = {
  lg: _Te,
  md: TTe,
  sm: CTe
}, ATe = {
  size: "md",
  colorScheme: "blue"
}, ITe = {
  parts: ewe.keys,
  sizes: ETe,
  baseStyle: wTe,
  defaultProps: ATe
}, Fy, zy, By, Uy, Vy, kl = $t("spinner-size"), OTe = {
  width: [kl.reference],
  height: [kl.reference]
}, MTe = {
  xs: (Fy = {}, Fy[kl.variable] = "0.75rem", Fy),
  sm: (zy = {}, zy[kl.variable] = "1rem", zy),
  md: (By = {}, By[kl.variable] = "1.5rem", By),
  lg: (Uy = {}, Uy[kl.variable] = "2rem", Uy),
  xl: (Vy = {}, Vy[kl.variable] = "3rem", Vy)
}, RTe = {
  size: "md"
}, PTe = {
  baseStyle: OTe,
  sizes: MTe,
  defaultProps: RTe
}, kTe = {
  fontWeight: "medium"
}, jTe = {
  opacity: 0.8,
  marginBottom: 2
}, DTe = {
  verticalAlign: "baseline",
  fontWeight: "semibold"
}, NTe = {
  marginEnd: 1,
  w: "14px",
  h: "14px",
  verticalAlign: "middle"
}, LTe = {
  container: {},
  label: kTe,
  helpText: jTe,
  number: DTe,
  icon: NTe
}, FTe = {
  md: {
    label: {
      fontSize: "sm"
    },
    helpText: {
      fontSize: "sm"
    },
    number: {
      fontSize: "2xl"
    }
  }
}, zTe = {
  size: "md"
}, BTe = {
  parts: rwe.keys,
  baseStyle: LTe,
  sizes: FTe,
  defaultProps: zTe
}, Qh, Xh, Jh, Gd = $t("switch-track-width"), Xl = $t("switch-track-height"), Wy = $t("switch-track-diff"), UTe = So.subtract(Gd, Xl), i2 = $t("switch-thumb-x"), VTe = function(r) {
  var t = r.colorScheme;
  return {
    borderRadius: "full",
    p: "2px",
    width: [Gd.reference],
    height: [Xl.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: H("gray.300", "whiteAlpha.400")(r),
    _focus: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: H(t + ".500", t + ".200")(r)
    }
  };
}, WTe = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Xl.reference],
  height: [Xl.reference],
  _checked: {
    transform: "translateX(" + i2.reference + ")"
  }
}, HTe = function(r) {
  var t, n;
  return {
    container: (n = {}, n[Wy.variable] = UTe, n[i2.variable] = Wy.reference, n._rtl = (t = {}, t[i2.variable] = So(Wy).negate().toString(), t), n),
    track: VTe(r),
    thumb: WTe
  };
}, GTe = {
  sm: {
    container: (Qh = {}, Qh[Gd.variable] = "1.375rem", Qh[Xl.variable] = "0.75rem", Qh)
  },
  md: {
    container: (Xh = {}, Xh[Gd.variable] = "1.875rem", Xh[Xl.variable] = "1rem", Xh)
  },
  lg: {
    container: (Jh = {}, Jh[Gd.variable] = "2.875rem", Jh[Xl.variable] = "1.5rem", Jh)
  }
}, YTe = {
  size: "md",
  colorScheme: "blue"
}, KTe = {
  parts: z8.keys,
  baseStyle: HTe,
  sizes: GTe,
  defaultProps: YTe
}, ZTe = {
  table: {
    fontVariantNumeric: "lining-nums tabular-nums",
    borderCollapse: "collapse",
    width: "full"
  },
  th: {
    fontFamily: "heading",
    fontWeight: "bold",
    textTransform: "uppercase",
    letterSpacing: "wider",
    textAlign: "start"
  },
  td: {
    textAlign: "start"
  },
  caption: {
    mt: 4,
    fontFamily: "heading",
    textAlign: "center",
    fontWeight: "medium"
  }
}, D0 = {
  "&[data-is-numeric=true]": {
    textAlign: "end"
  }
}, qTe = function(r) {
  var t = r.colorScheme;
  return {
    th: Ot({
      color: H("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, D0),
    td: Ot({
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, D0),
    caption: {
      color: H("gray.600", "gray.100")(r)
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, QTe = function(r) {
  var t = r.colorScheme;
  return {
    th: Ot({
      color: H("gray.600", "gray.400")(r),
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, D0),
    td: Ot({
      borderBottom: "1px",
      borderColor: H(t + ".100", t + ".700")(r)
    }, D0),
    caption: {
      color: H("gray.600", "gray.100")(r)
    },
    tbody: {
      tr: {
        "&:nth-of-type(odd)": {
          "th, td": {
            borderBottomWidth: "1px",
            borderColor: H(t + ".100", t + ".700")(r)
          },
          td: {
            background: H(t + ".100", t + ".700")(r)
          }
        }
      }
    },
    tfoot: {
      tr: {
        "&:last-of-type": {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
}, XTe = {
  simple: qTe,
  striped: QTe,
  unstyled: {}
}, JTe = {
  sm: {
    th: {
      px: "4",
      py: "1",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "4",
      py: "2",
      fontSize: "sm",
      lineHeight: "4"
    },
    caption: {
      px: "4",
      py: "2",
      fontSize: "xs"
    }
  },
  md: {
    th: {
      px: "6",
      py: "3",
      lineHeight: "4",
      fontSize: "xs"
    },
    td: {
      px: "6",
      py: "4",
      lineHeight: "5"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "sm"
    }
  },
  lg: {
    th: {
      px: "8",
      py: "4",
      lineHeight: "5",
      fontSize: "sm"
    },
    td: {
      px: "8",
      py: "5",
      lineHeight: "6"
    },
    caption: {
      px: "6",
      py: "2",
      fontSize: "md"
    }
  }
}, eCe = {
  variant: "simple",
  size: "md",
  colorScheme: "gray"
}, rCe = {
  parts: twe.keys,
  baseStyle: ZTe,
  variants: XTe,
  sizes: JTe,
  defaultProps: eCe
}, tCe = function(r) {
  var t = r.orientation;
  return {
    display: t === "vertical" ? "flex" : "block"
  };
}, nCe = function(r) {
  var t = r.isFitted;
  return {
    flex: t ? 1 : void 0,
    transitionProperty: "common",
    transitionDuration: "normal",
    _focus: {
      zIndex: 1,
      boxShadow: "outline"
    }
  };
}, aCe = function(r) {
  var t = r.align, n = t === void 0 ? "start" : t, a = r.orientation, i = {
    end: "flex-end",
    center: "center",
    start: "flex-start"
  };
  return {
    justifyContent: i[n],
    flexDirection: a === "vertical" ? "column" : "row"
  };
}, oCe = {
  p: 4
}, iCe = function(r) {
  return {
    root: tCe(r),
    tab: nCe(r),
    tablist: aCe(r),
    tabpanel: oCe
  };
}, sCe = {
  sm: {
    tab: {
      py: 1,
      px: 4,
      fontSize: "sm"
    }
  },
  md: {
    tab: {
      fontSize: "md",
      py: 2,
      px: 4
    }
  },
  lg: {
    tab: {
      fontSize: "lg",
      py: 3,
      px: 4
    }
  }
}, lCe = function(r) {
  var t, n, a = r.colorScheme, i = r.orientation, l = i === "vertical", u = i === "vertical" ? "borderStart" : "borderBottom", c = l ? "marginStart" : "marginBottom";
  return {
    tablist: (t = {}, t[u] = "2px solid", t.borderColor = "inherit", t),
    tab: (n = {}, n[u] = "2px solid", n.borderColor = "transparent", n[c] = "-2px", n._selected = {
      color: H(a + ".600", a + ".300")(r),
      borderColor: "currentColor"
    }, n._active = {
      bg: H("gray.200", "whiteAlpha.300")(r)
    }, n._disabled = {
      opacity: 0.4,
      cursor: "not-allowed"
    }, n)
  };
}, uCe = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderTopRadius: "md",
      border: "1px solid",
      borderColor: "transparent",
      mb: "-1px",
      _selected: {
        color: H(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderBottomColor: H("white", "gray.800")(r)
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, cCe = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      border: "1px solid",
      borderColor: "inherit",
      bg: H("gray.50", "whiteAlpha.50")(r),
      mb: "-1px",
      _notLast: {
        marginEnd: "-1px"
      },
      _selected: {
        bg: H("#fff", "gray.800")(r),
        color: H(t + ".600", t + ".300")(r),
        borderColor: "inherit",
        borderTopColor: "currentColor",
        borderBottomColor: "transparent"
      }
    },
    tablist: {
      mb: "-1px",
      borderBottom: "1px solid",
      borderColor: "inherit"
    }
  };
}, dCe = function(r) {
  var t = r.colorScheme, n = r.theme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "gray.600",
      _selected: {
        color: He(n, t + ".700"),
        bg: He(n, t + ".100")
      }
    }
  };
}, fCe = function(r) {
  var t = r.colorScheme;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: H("gray.600", "inherit")(r),
      _selected: {
        color: H("#fff", "gray.800")(r),
        bg: H(t + ".600", t + ".300")(r)
      }
    }
  };
}, vCe = {}, hCe = {
  line: lCe,
  enclosed: uCe,
  "enclosed-colored": cCe,
  "soft-rounded": dCe,
  "solid-rounded": fCe,
  unstyled: vCe
}, pCe = {
  size: "md",
  variant: "line",
  colorScheme: "blue"
}, gCe = {
  parts: nwe.keys,
  baseStyle: iCe,
  sizes: sCe,
  variants: hCe,
  defaultProps: pCe
}, mCe = {
  fontWeight: "medium",
  lineHeight: 1.2,
  outline: 0,
  _focus: {
    boxShadow: "outline"
  }
}, bCe = {
  lineHeight: 1.2,
  overflow: "visible"
}, yCe = {
  fontSize: "18px",
  w: "1.25rem",
  h: "1.25rem",
  transitionProperty: "common",
  transitionDuration: "normal",
  borderRadius: "full",
  marginStart: "0.375rem",
  marginEnd: "-1",
  opacity: 0.5,
  _disabled: {
    opacity: 0.4
  },
  _focus: {
    boxShadow: "outline",
    bg: "rgba(0, 0, 0, 0.14)"
  },
  _hover: {
    opacity: 0.8
  },
  _active: {
    opacity: 1
  }
}, SCe = {
  container: mCe,
  label: bCe,
  closeButton: yCe
}, xCe = {
  sm: {
    container: {
      minH: "1.25rem",
      minW: "1.25rem",
      fontSize: "xs",
      px: 2,
      borderRadius: "md"
    },
    closeButton: {
      marginEnd: "-2px",
      marginStart: "0.35rem"
    }
  },
  md: {
    container: {
      minH: "1.5rem",
      minW: "1.5rem",
      fontSize: "sm",
      borderRadius: "md",
      px: 2
    }
  },
  lg: {
    container: {
      minH: 8,
      minW: 8,
      fontSize: "md",
      borderRadius: "md",
      px: 3
    }
  }
}, $Ce = {
  subtle: function(r) {
    return {
      container: fc.variants.subtle(r)
    };
  },
  solid: function(r) {
    return {
      container: fc.variants.solid(r)
    };
  },
  outline: function(r) {
    return {
      container: fc.variants.outline(r)
    };
  }
}, wCe = {
  size: "md",
  variant: "subtle",
  colorScheme: "gray"
}, _Ce = {
  parts: awe.keys,
  variants: $Ce,
  baseStyle: SCe,
  sizes: xCe,
  defaultProps: wCe
}, tI, nI, aI, oI, iI, TCe = Ot({}, ht.baseStyle.field, {
  paddingY: "8px",
  minHeight: "80px",
  lineHeight: "short",
  verticalAlign: "top"
}), CCe = {
  outline: function(r) {
    var t;
    return (t = ht.variants.outline(r).field) != null ? t : {};
  },
  flushed: function(r) {
    var t;
    return (t = ht.variants.flushed(r).field) != null ? t : {};
  },
  filled: function(r) {
    var t;
    return (t = ht.variants.filled(r).field) != null ? t : {};
  },
  unstyled: (tI = ht.variants.unstyled.field) != null ? tI : {}
}, ECe = {
  xs: (nI = ht.sizes.xs.field) != null ? nI : {},
  sm: (aI = ht.sizes.sm.field) != null ? aI : {},
  md: (oI = ht.sizes.md.field) != null ? oI : {},
  lg: (iI = ht.sizes.lg.field) != null ? iI : {}
}, ACe = {
  size: "md",
  variant: "outline"
}, ICe = {
  baseStyle: TCe,
  sizes: ECe,
  variants: CCe,
  defaultProps: ACe
}, Hy = $t("tooltip-bg"), OCe = $t("popper-arrow-bg"), MCe = function(r) {
  var t, n = H("gray.700", "gray.300")(r);
  return t = {}, t[Hy.variable] = "colors." + n, t.px = "8px", t.py = "2px", t.bg = [Hy.reference], t[OCe.variable] = [Hy.reference], t.color = H("whiteAlpha.900", "gray.900")(r), t.borderRadius = "sm", t.fontWeight = "medium", t.fontSize = "sm", t.boxShadow = "md", t.maxW = "320px", t.zIndex = "tooltip", t;
}, RCe = {
  baseStyle: MCe
}, PCe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Accordion: cwe,
  Alert: bwe,
  Avatar: Twe,
  Badge: fc,
  Breadcrumb: kwe,
  Button: Wwe,
  Checkbox: j0,
  CloseButton: r_e,
  Code: o_e,
  Container: s_e,
  Divider: v_e,
  Drawer: __e,
  Editable: I_e,
  Form: P_e,
  FormError: N_e,
  FormLabel: F_e,
  Heading: V_e,
  Input: ht,
  Kbd: J_e,
  Link: r5e,
  List: a5e,
  Menu: f5e,
  Modal: w5e,
  NumberInput: P5e,
  PinInput: L5e,
  Popover: K5e,
  Progress: tTe,
  Radio: sTe,
  Select: fTe,
  Skeleton: pTe,
  SkipLink: mTe,
  Slider: ITe,
  Spinner: PTe,
  Stat: BTe,
  Switch: KTe,
  Table: rCe,
  Tabs: gCe,
  Tag: _Ce,
  Textarea: ICe,
  Tooltip: RCe
}), kCe = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid",
  "8px": "8px solid"
}, jCe = R$e({
  sm: "30em",
  md: "48em",
  lg: "62em",
  xl: "80em",
  "2xl": "96em"
}), DCe = {
  transparent: "transparent",
  current: "currentColor",
  black: "#000000",
  white: "#FFFFFF",
  whiteAlpha: {
    50: "rgba(255, 255, 255, 0.04)",
    100: "rgba(255, 255, 255, 0.06)",
    200: "rgba(255, 255, 255, 0.08)",
    300: "rgba(255, 255, 255, 0.16)",
    400: "rgba(255, 255, 255, 0.24)",
    500: "rgba(255, 255, 255, 0.36)",
    600: "rgba(255, 255, 255, 0.48)",
    700: "rgba(255, 255, 255, 0.64)",
    800: "rgba(255, 255, 255, 0.80)",
    900: "rgba(255, 255, 255, 0.92)"
  },
  blackAlpha: {
    50: "rgba(0, 0, 0, 0.04)",
    100: "rgba(0, 0, 0, 0.06)",
    200: "rgba(0, 0, 0, 0.08)",
    300: "rgba(0, 0, 0, 0.16)",
    400: "rgba(0, 0, 0, 0.24)",
    500: "rgba(0, 0, 0, 0.36)",
    600: "rgba(0, 0, 0, 0.48)",
    700: "rgba(0, 0, 0, 0.64)",
    800: "rgba(0, 0, 0, 0.80)",
    900: "rgba(0, 0, 0, 0.92)"
  },
  gray: {
    50: "#F7FAFC",
    100: "#EDF2F7",
    200: "#E2E8F0",
    300: "#CBD5E0",
    400: "#A0AEC0",
    500: "#718096",
    600: "#4A5568",
    700: "#2D3748",
    800: "#1A202C",
    900: "#171923"
  },
  red: {
    50: "#FFF5F5",
    100: "#FED7D7",
    200: "#FEB2B2",
    300: "#FC8181",
    400: "#F56565",
    500: "#E53E3E",
    600: "#C53030",
    700: "#9B2C2C",
    800: "#822727",
    900: "#63171B"
  },
  orange: {
    50: "#FFFAF0",
    100: "#FEEBC8",
    200: "#FBD38D",
    300: "#F6AD55",
    400: "#ED8936",
    500: "#DD6B20",
    600: "#C05621",
    700: "#9C4221",
    800: "#7B341E",
    900: "#652B19"
  },
  yellow: {
    50: "#FFFFF0",
    100: "#FEFCBF",
    200: "#FAF089",
    300: "#F6E05E",
    400: "#ECC94B",
    500: "#D69E2E",
    600: "#B7791F",
    700: "#975A16",
    800: "#744210",
    900: "#5F370E"
  },
  green: {
    50: "#F0FFF4",
    100: "#C6F6D5",
    200: "#9AE6B4",
    300: "#68D391",
    400: "#48BB78",
    500: "#38A169",
    600: "#2F855A",
    700: "#276749",
    800: "#22543D",
    900: "#1C4532"
  },
  teal: {
    50: "#E6FFFA",
    100: "#B2F5EA",
    200: "#81E6D9",
    300: "#4FD1C5",
    400: "#38B2AC",
    500: "#319795",
    600: "#2C7A7B",
    700: "#285E61",
    800: "#234E52",
    900: "#1D4044"
  },
  blue: {
    50: "#ebf8ff",
    100: "#bee3f8",
    200: "#90cdf4",
    300: "#63b3ed",
    400: "#4299e1",
    500: "#3182ce",
    600: "#2b6cb0",
    700: "#2c5282",
    800: "#2a4365",
    900: "#1A365D"
  },
  cyan: {
    50: "#EDFDFD",
    100: "#C4F1F9",
    200: "#9DECF9",
    300: "#76E4F7",
    400: "#0BC5EA",
    500: "#00B5D8",
    600: "#00A3C4",
    700: "#0987A0",
    800: "#086F83",
    900: "#065666"
  },
  purple: {
    50: "#FAF5FF",
    100: "#E9D8FD",
    200: "#D6BCFA",
    300: "#B794F4",
    400: "#9F7AEA",
    500: "#805AD5",
    600: "#6B46C1",
    700: "#553C9A",
    800: "#44337A",
    900: "#322659"
  },
  pink: {
    50: "#FFF5F7",
    100: "#FED7E2",
    200: "#FBB6CE",
    300: "#F687B3",
    400: "#ED64A6",
    500: "#D53F8C",
    600: "#B83280",
    700: "#97266D",
    800: "#702459",
    900: "#521B41"
  },
  linkedin: {
    50: "#E8F4F9",
    100: "#CFEDFB",
    200: "#9BDAF3",
    300: "#68C7EC",
    400: "#34B3E4",
    500: "#00A0DC",
    600: "#008CC9",
    700: "#0077B5",
    800: "#005E93",
    900: "#004471"
  },
  facebook: {
    50: "#E8F4F9",
    100: "#D9DEE9",
    200: "#B7C2DA",
    300: "#6482C0",
    400: "#4267B2",
    500: "#385898",
    600: "#314E89",
    700: "#29487D",
    800: "#223B67",
    900: "#1E355B"
  },
  messenger: {
    50: "#D0E6FF",
    100: "#B9DAFF",
    200: "#A2CDFF",
    300: "#7AB8FF",
    400: "#2E90FF",
    500: "#0078FF",
    600: "#0063D1",
    700: "#0052AC",
    800: "#003C7E",
    900: "#002C5C"
  },
  whatsapp: {
    50: "#dffeec",
    100: "#b9f5d0",
    200: "#90edb3",
    300: "#65e495",
    400: "#3cdd78",
    500: "#22c35e",
    600: "#179848",
    700: "#0c6c33",
    800: "#01421c",
    900: "#001803"
  },
  twitter: {
    50: "#E5F4FD",
    100: "#C8E9FB",
    200: "#A8DCFA",
    300: "#83CDF7",
    400: "#57BBF5",
    500: "#1DA1F2",
    600: "#1A94DA",
    700: "#1681BF",
    800: "#136B9E",
    900: "#0D4D71"
  },
  telegram: {
    50: "#E3F2F9",
    100: "#C5E4F3",
    200: "#A2D4EC",
    300: "#7AC1E4",
    400: "#47A9DA",
    500: "#0088CC",
    600: "#007AB8",
    700: "#006BA1",
    800: "#005885",
    900: "#003F5E"
  }
}, NCe = {
  none: "0",
  sm: "0.125rem",
  base: "0.25rem",
  md: "0.375rem",
  lg: "0.5rem",
  xl: "0.75rem",
  "2xl": "1rem",
  "3xl": "1.5rem",
  full: "9999px"
}, LCe = {
  xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
  sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
  base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
  inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
  none: "none",
  "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
}, FCe = {
  common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
  colors: "background-color, border-color, color, fill, stroke",
  dimensions: "width, height",
  position: "left, right, top, bottom",
  background: "background-color, background-image, background-position"
}, zCe = {
  "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
  "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
  "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
}, BCe = {
  "ultra-fast": "50ms",
  faster: "100ms",
  fast: "150ms",
  normal: "200ms",
  slow: "300ms",
  slower: "400ms",
  "ultra-slow": "500ms"
}, UCe = {
  property: FCe,
  easing: zCe,
  duration: BCe
}, VCe = {
  hide: -1,
  auto: "auto",
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800
}, WCe = {
  none: 0,
  sm: "4px",
  base: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "40px",
  "3xl": "64px"
}, HCe = Ot({
  breakpoints: jCe,
  zIndices: VCe,
  radii: NCe,
  blur: WCe,
  colors: DCe
}, B8, {
  sizes: E8,
  shadows: LCe,
  space: C8,
  borders: kCe,
  transition: UCe
}), GCe = {
  global: function(r) {
    return {
      body: {
        fontFamily: "body",
        color: H("gray.800", "whiteAlpha.900")(r),
        bg: H("white", "gray.800")(r),
        transitionProperty: "background-color",
        transitionDuration: "normal",
        lineHeight: "base"
      },
      "*::placeholder": {
        color: H("gray.400", "whiteAlpha.400")(r)
      },
      "*, *::before, &::after": {
        borderColor: H("gray.200", "whiteAlpha.300")(r),
        wordWrap: "break-word"
      }
    };
  }
}, YCe = GCe, KCe = ["borders", "breakpoints", "colors", "components", "config", "direction", "fonts", "fontSizes", "fontWeights", "letterSpacings", "lineHeights", "radii", "shadows", "sizes", "space", "styles", "transition", "zIndices"];
function ZCe(e) {
  return ni(e) ? KCe.every(function(r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }) : !1;
}
var qCe = "ltr", QCe = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "chakra"
}, hm = Ot({
  direction: qCe
}, HCe, {
  components: PCe,
  styles: YCe,
  config: QCe
});
function XCe() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  var n = [].concat(r), a = r[r.length - 1];
  return ZCe(a) && // this ensures backward compatibility
  // previously only `extendTheme(override, baseTheme?)` was allowed
  n.length > 1 ? n = n.slice(0, n.length - 1) : a = hm, _xe.apply(void 0, n.map(function(i) {
    return function(l) {
      return Qu(i) ? i(l) : W8(l, i);
    };
  }))(a);
}
function W8() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return Ms.apply(void 0, [{}].concat(r, [H8]));
}
function H8(e, r, t, n) {
  if ((Qu(e) || Qu(r)) && Object.prototype.hasOwnProperty.call(n, t))
    return function() {
      var a = Qu(e) ? e.apply(void 0, arguments) : e, i = Qu(r) ? r.apply(void 0, arguments) : r;
      return Ms({}, a, i, H8);
    };
}
function JCe(e) {
  var r = e.colorScheme, t = e.components;
  return function(n) {
    var a = Object.keys(n.components || {});
    return Array.isArray(t) ? a = t : ni(t) && (a = Object.keys(t)), W8(n, {
      components: Qx(a.map(function(i) {
        var l = {
          defaultProps: {
            colorScheme: r
          }
        };
        return [i, l];
      }))
    });
  };
}
const e4e = {
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold"
}, r4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Ua(`${r}.500`, 0.6)(t);
  return {
    bg: H(`${r}.500`, n)(e),
    color: H("white", "whiteAlpha.800")(e)
  };
}, t4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Ua(`${r}.200`, 0.16)(t);
  return {
    bg: H(`${r}.100`, n)(e),
    color: H(`${r}.800`, `${r}.200`)(e)
  };
}, n4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Ua(`${r}.200`, 0.8)(t), a = He(t, `${r}.500`), i = H(a, n)(e);
  return {
    color: i,
    boxShadow: `inset 0 0 0px 1px ${i}`
  };
}, a4e = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e, n = Ua(`${r}.500`, 0.6)(t);
  return {
    bg: H(`${r}.500`, n)(e),
    color: H("white", "whiteAlpha.800")(e)
  };
}, o4e = {
  solid: r4e,
  subtle: t4e,
  outline: n4e,
  number: a4e
}, i4e = {
  variant: "subtle",
  colorScheme: "gray"
}, s4e = {
  baseStyle: e4e,
  variants: o4e,
  defaultProps: i4e
};
var G8 = {}, l4e = si, u4e = T6, c4e = Ws, d4e = uu, f4e = qf, v4e = j6;
G8.f = l4e && !u4e ? Object.defineProperties : function(r, t) {
  d4e(r);
  for (var n = f4e(t), a = v4e(t), i = a.length, l = 0, u; i > l; )
    c4e.f(r, u = a[l++], n[u]);
  return r;
};
var h4e = Mw, p4e = h4e("document", "documentElement"), g4e = uu, m4e = G8, sI = Uw, b4e = zw, y4e = p4e, S4e = Dw, x4e = Fw, lI = ">", uI = "<", s2 = "prototype", l2 = "script", Y8 = x4e("IE_PROTO"), Gy = function() {
}, K8 = function(e) {
  return uI + l2 + lI + e + uI + "/" + l2 + lI;
}, cI = function(e) {
  e.write(K8("")), e.close();
  var r = e.parentWindow.Object;
  return e = null, r;
}, $4e = function() {
  var e = S4e("iframe"), r = "java" + l2 + ":", t;
  return e.style.display = "none", y4e.appendChild(e), e.src = String(r), t = e.contentWindow.document, t.open(), t.write(K8("document.F=Object")), t.close(), t.F;
}, ep, Bp = function() {
  try {
    ep = new ActiveXObject("htmlfile");
  } catch (r) {
  }
  Bp = typeof document != "undefined" ? document.domain && ep ? cI(ep) : $4e() : cI(ep);
  for (var e = sI.length; e--; )
    delete Bp[s2][sI[e]];
  return Bp();
};
b4e[Y8] = !0;
var Z8 = Object.create || function(r, t) {
  var n;
  return r !== null ? (Gy[s2] = g4e(r), n = new Gy(), Gy[s2] = null, n[Y8] = r) : n = Bp(), t === void 0 ? n : m4e.f(n, t);
}, w4e = Vs, _4e = Z8, T4e = Ws.f, u2 = w4e("unscopables"), c2 = Array.prototype;
c2[u2] == null && T4e(c2, u2, {
  configurable: !0,
  value: _4e(null)
});
var q8 = function(e) {
  c2[u2][e] = !0;
}, C4e = Ww, E4e = P6.includes, A4e = $a, I4e = q8, O4e = A4e(function() {
  return !Array(1).includes();
});
C4e({ target: "Array", proto: !0, forced: O4e }, {
  includes: function(r) {
    return E4e(this, r, arguments.length > 1 ? arguments[1] : void 0);
  }
});
I4e("includes");
const M4e = {
  borderRadius: "5px",
  fontWeight: "bold",
  _focus: "none",
  _disabled: {
    // opacity: 0.4,
    cursor: "not-allowed",
    boxShadow: "none",
    border: "none",
    color: "gray.600",
    bg: "gray.300"
  },
  _hover: {
    _disabled: {
      color: "gray.600",
      bg: "gray.300"
    }
  }
}, Q8 = (e) => {
  const {
    colorScheme: r,
    theme: t
  } = e;
  if (r === "brand") {
    Ua(`${r}.500`, 0.12)(t);
    const n = Ua(`${r}.500`, 0.24)(t);
    return {
      fontWeight: "normal",
      color: H(`${r}.500`, `${r}.200`)(e),
      bg: "transparent",
      _disabled: {
        bg: "transparent"
      },
      _hover: {
        bg: H(`${r}.100`, "whiteAlpha.200")(e),
        _disabled: {
          bg: "transparent"
        }
      },
      _active: {
        color: H("white", `${r}.200`)(e),
        borderColor: H(`${r}.600`, n)(e),
        bg: H(`${r}.300`, n)(e)
      }
    };
  }
  return r === "secondary" ? {
    fontWeight: "normal",
    color: H("gray.700", "whiteAlpha.900")(e),
    bg: "transparent",
    _disabled: {
      bg: "transparent"
    },
    _hover: {
      bg: H("gray.100", "whiteAlpha.200")(e),
      _disabled: {
        bg: "transparent"
      }
    },
    _active: {
      bg: H("gray.300", "whiteAlpha.300")(e)
    }
  } : hm.components.Button.variants.ghost(e);
}, dI = {
  xs: 1,
  sm: 1.5,
  md: 2,
  xl: 2
}, R4e = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, n = H("gray.700", "whiteAlpha.300")(e), a = Q8(e);
  return Object.assign(Object.assign({
    fontWeight: "normal",
    border: `${dI[t] || 2}px solid`,
    borderColor: ["gray", "secondary"].includes(r) ? n : "currentColor"
  }, a), {
    color: ["secondary"].includes(r) ? n : a.color,
    _hover: {
      bg: ["secondary"].includes(r) ? "secondary.50" : a._hover.bg,
      _disabled: {
        bg: "gray.300"
      }
    },
    _active: {
      bg: ["secondary"].includes(r) ? "secondary.200" : a._active.bg
    },
    _disabled: {
      border: `${dI[t] || 2}px solid`,
      borderColor: "gray.500",
      _hover: {
        borderColor: "gray.500"
      }
    }
  });
}, P4e = (e) => {
  const {
    colorScheme: r
  } = e;
  return r === "brand" ? {
    bg: H(`${r}.500`, `${r}.200`)(e),
    color: H("white", "gray.800")(e),
    _hover: {
      bg: H(`${r}.700`, `${r}.300`)(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.300"
      }
    },
    _active: {
      bg: H(`${r}.900`, `${r}.400`)(e)
    }
  } : r === "secondary" ? {
    bg: H("secondary.800", "whiteAlpha.200")(e),
    color: "white",
    _hover: {
      bg: H(`${r}.600`, "whiteAlpha.300")(e),
      _disabled: {
        color: "gray.600",
        bg: "gray.100"
      }
    },
    _active: {
      bg: H(`${r}.900`, "whiteAlpha.400")(e)
    }
  } : hm.components.Button.variants.solid(e);
}, k4e = (e) => {
  const {
    colorScheme: r
  } = e, t = hm.components.Button.variants.link(e);
  let {
    color: n
  } = t;
  const {
    _active: a
  } = t;
  return t.textDecoration = "underline", t._disabled = Object.assign(Object.assign({}, t._disabled), {
    bg: "none"
  }), t._hover = Object.assign(Object.assign({}, t._hover), {
    fontWeight: "bold",
    _disabled: Object.assign(Object.assign({}, t._hover._disabled), {
      fontWeight: "normal",
      bg: "none",
      textDecoration: "underline"
    })
  }), r === "brand" && (t.fontWeight = "normal", n = H(`${r}.500`, `${r}.200`)(e), a.color = H(`${r}.600`, `${r}.400`)(e)), r === "secondary" && (t.fontWeight = "normal", n = H("gray.800", "whiteAlpha.900")(e), a.color = H("secondary.900", "whiteAlpha.300")(e)), Object.assign(Object.assign({}, t), {
    color: n,
    _active: Object.assign({}, a)
  });
}, j4e = {
  ghost: Q8,
  outline: R4e,
  solid: P4e,
  link: k4e
}, D4e = {
  lg: {
    h: "46px",
    minW: "46px",
    fontSize: "lg",
    px: 6
  },
  md: {
    h: "42px",
    minW: "42px",
    fontSize: "md",
    px: 5
  },
  sm: {
    h: "32px",
    minW: "32px",
    fontSize: "sm",
    px: 4
  },
  xs: {
    h: "26px",
    minW: "26px",
    fontSize: "xs",
    px: 3
  }
}, N4e = {
  variant: "solid",
  size: "md"
}, L4e = {
  baseStyle: M4e,
  sizes: D4e,
  variants: j4e,
  defaultProps: N4e
}, F4e = {
  display: "flex",
  flexDirection: "column",
  background: "white",
  alignItems: "center",
  gap: 6
}, z4e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "1rem",
  boxShadow: "base"
}, B4e = {
  padding: {
    base: 4,
    md: 5
  },
  borderRadius: "none",
  boxShadow: "none"
}, U4e = {
  flat: B4e,
  rounded: z4e
}, V4e = {
  variant: "flat"
}, W4e = {
  baseStyle: F4e,
  variants: U4e,
  defaultProps: V4e
};
var f_ = {}, H4e = $a, G4e = !H4e(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), Y4e = li, K4e = kn, Z4e = jw, q4e = Fw, Q4e = G4e, fI = q4e("IE_PROTO"), d2 = Object, X4e = d2.prototype, X8 = Q4e ? d2.getPrototypeOf : function(e) {
  var r = Z4e(e);
  if (Y4e(r, fI))
    return r[fI];
  var t = r.constructor;
  return K4e(t) && r instanceof t ? t.prototype : r instanceof d2 ? X4e : null;
}, J4e = $a, eEe = kn, rEe = Rc, vI = X8, tEe = qg, nEe = Vs, f2 = nEe("iterator"), J8 = !1, au, Yy, Ky;
[].keys && (Ky = [].keys(), "next" in Ky ? (Yy = vI(vI(Ky)), Yy !== Object.prototype && (au = Yy)) : J8 = !0);
var aEe = !rEe(au) || J4e(function() {
  var e = {};
  return au[f2].call(e) !== e;
});
aEe && (au = {});
eEe(au[f2]) || tEe(au, f2, function() {
  return this;
});
var eD = {
  IteratorPrototype: au,
  BUGGY_SAFARI_ITERATORS: J8
}, oEe = Ws.f, iEe = li, sEe = Vs, hI = sEe("toStringTag"), rD = function(e, r, t) {
  e && !t && (e = e.prototype), e && !iEe(e, hI) && oEe(e, hI, { configurable: !0, value: r });
}, lEe = eD.IteratorPrototype, uEe = Z8, cEe = Ow, dEe = rD, fEe = f_, vEe = function() {
  return this;
}, hEe = function(e, r, t, n) {
  var a = r + " Iterator";
  return e.prototype = uEe(lEe, { next: cEe(+!n, t) }), dEe(e, a, !1), fEe[a] = vEe, e;
}, pEe = _o, gEe = x6, mEe = function(e, r, t) {
  try {
    return pEe(gEe(Object.getOwnPropertyDescriptor(e, r)[t]));
  } catch (n) {
  }
}, bEe = kn, yEe = String, SEe = TypeError, xEe = function(e) {
  if (typeof e == "object" || bEe(e))
    return e;
  throw SEe("Can't set " + yEe(e) + " as a prototype");
}, $Ee = mEe, wEe = uu, _Ee = xEe, TEe = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, r = {}, t;
  try {
    t = $Ee(Object.prototype, "__proto__", "set"), t(r, []), e = r instanceof Array;
  } catch (n) {
  }
  return function(a, i) {
    return wEe(a), _Ee(i), e ? t(a, i) : a.__proto__ = i, a;
  };
}() : void 0), CEe = Ww, EEe = Mc, tD = Lw, AEe = kn, IEe = hEe, pI = X8, gI = TEe, OEe = rD, MEe = Zg, Zy = qg, REe = Vs, PEe = f_, nD = eD, kEe = tD.PROPER, jEe = tD.CONFIGURABLE, mI = nD.IteratorPrototype, rp = nD.BUGGY_SAFARI_ITERATORS, vd = REe("iterator"), bI = "keys", hd = "values", yI = "entries", DEe = function() {
  return this;
}, NEe = function(e, r, t, n, a, i, l) {
  IEe(t, r, n);
  var u = function(A) {
    if (A === a && g)
      return g;
    if (!rp && A in h)
      return h[A];
    switch (A) {
      case bI:
        return function() {
          return new t(this, A);
        };
      case hd:
        return function() {
          return new t(this, A);
        };
      case yI:
        return function() {
          return new t(this, A);
        };
    }
    return function() {
      return new t(this);
    };
  }, c = r + " Iterator", f = !1, h = e.prototype, p = h[vd] || h["@@iterator"] || a && h[a], g = !rp && p || u(a), y = r == "Array" && h.entries || p, S, x, _;
  if (y && (S = pI(y.call(new e())), S !== Object.prototype && S.next && (pI(S) !== mI && (gI ? gI(S, mI) : AEe(S[vd]) || Zy(S, vd, DEe)), OEe(S, c, !0))), kEe && a == hd && p && p.name !== hd && (jEe ? MEe(h, "name", hd) : (f = !0, g = function() {
    return EEe(p, this);
  })), a)
    if (x = {
      values: u(hd),
      keys: i ? g : u(bI),
      entries: u(yI)
    }, l)
      for (_ in x)
        (rp || f || !(_ in h)) && Zy(h, _, x[_]);
    else
      CEe({ target: r, proto: !0, forced: rp || f }, x);
  return h[vd] !== g && Zy(h, vd, g, { name: a }), PEe[r] = g, x;
}, LEe = function(e, r) {
  return { value: e, done: r };
}, FEe = qf, v_ = q8, SI = f_, aD = I6, zEe = Ws.f, BEe = NEe, tp = LEe, UEe = si, oD = "Array Iterator", VEe = aD.set, WEe = aD.getterFor(oD), HEe = BEe(Array, "Array", function(e, r) {
  VEe(this, {
    type: oD,
    target: FEe(e),
    // target
    index: 0,
    // next index
    kind: r
    // kind
  });
}, function() {
  var e = WEe(this), r = e.target, t = e.kind, n = e.index++;
  return !r || n >= r.length ? (e.target = void 0, tp(void 0, !0)) : t == "keys" ? tp(n, !1) : t == "values" ? tp(r[n], !1) : tp([n, r[n]], !1);
}, "values"), xI = SI.Arguments = SI.Array;
v_("keys");
v_("values");
v_("entries");
if (UEe && xI.name !== "values")
  try {
    zEe(xI, "name", { value: "values" });
  } catch (e) {
  }
var GEe = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, YEe = Dw, qy = YEe("span").classList, $I = qy && qy.constructor && qy.constructor.prototype, KEe = $I === Object.prototype ? void 0 : $I, wI = wo, iD = GEe, ZEe = KEe, $d = HEe, Qy = Zg, sD = Vs, Xy = sD("iterator"), _I = sD("toStringTag"), Jy = $d.values, lD = function(e, r) {
  if (e) {
    if (e[Xy] !== Jy)
      try {
        Qy(e, Xy, Jy);
      } catch (n) {
        e[Xy] = Jy;
      }
    if (e[_I] || Qy(e, _I, r), iD[r]) {
      for (var t in $d)
        if (e[t] !== $d[t])
          try {
            Qy(e, t, $d[t]);
          } catch (n) {
            e[t] = $d[t];
          }
    }
  }
};
for (var eS in iD)
  lD(wI[eS] && wI[eS].prototype, eS);
lD(ZEe, "DOMTokenList");
const qEe = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    w: "100%",
    border: "1px",
    borderRadius: "base",
    borderColor: "gray.300",
    _indeterminate: {
      bg: "white",
      borderColor: "gray.300",
      color: H(`${r}.500`, `${r}.200`)(e)
    },
    _disabled: {
      borderColor: "gray.300",
      bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)"
    },
    _focus: {
      boxShadow: "none"
    }
  };
}, QEe = {
  _disabled: {
    cursor: "not-allowed"
  }
}, XEe = {
  userSelect: "none",
  _disabled: {
    opacity: 0.4
  }
}, JEe = {
  transitionProperty: "transform",
  transitionDuration: "normal"
}, eAe = (e) => ({
  icon: JEe,
  container: QEe,
  control: qEe(e),
  label: XEe
}), rAe = {
  sm: {
    control: {
      h: 3,
      w: 3
    },
    label: {
      fontSize: "sm"
    },
    icon: {
      fontSize: "0.72rem"
    }
  },
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    },
    icon: {
      fontSize: "1rem"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    },
    icon: {
      fontSize: "1rem"
    }
  }
}, tAe = {
  size: "md",
  colorScheme: "brand"
}, N0 = {
  parts: j8.keys,
  baseStyle: eAe,
  sizes: rAe,
  defaultProps: tAe
}, nAe = {
  field: {
    width: "100%",
    minWidth: 0,
    outline: 0,
    position: "relative",
    appearance: "none",
    transitionProperty: "common",
    transitionDuration: "normal",
    _placeholder: {
      color: "gray.400"
    }
  }
}, Ss = {
  lg: {
    fontSize: "lg",
    px: 4,
    h: "50px",
    borderRadius: "md"
  },
  md: {
    fontSize: "md",
    px: 4,
    h: "44px",
    borderRadius: "md"
  },
  sm: {
    fontSize: "sm",
    px: 3,
    h: "32px",
    borderRadius: "md"
  },
  xs: {
    fontSize: "xs",
    px: 2,
    h: "24px",
    borderRadius: "md"
  }
}, aAe = {
  lg: {
    field: Ss.lg,
    addon: Ss.lg
  },
  md: {
    field: Ss.md,
    addon: Ss.md
  },
  sm: {
    field: Ss.sm,
    addon: Ss.sm
  },
  xs: {
    field: Ss.xs,
    addon: Ss.xs
  }
};
function h_(e) {
  const {
    focusBorderColor: r,
    errorBorderColor: t,
    fieldBorderColor: n,
    disabledColor: a
  } = e;
  return {
    focusBorderColor: r || H("secondary.700", "secondary.300")(e),
    errorBorderColor: t || H("#DB371F", "red.300")(e),
    fieldBorderColor: n || H("gray.400", "gray.200")(e),
    disabledColor: a || H("gray.300", "gray.100")(e)
  };
}
const oAe = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = h_(e);
  return {
    field: {
      border: "0.5px solid",
      borderColor: He(r, a),
      bg: "inherit",
      _hover: {
        borderColor: He(r, a)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        borderColor: He(r, i),
        boxShadow: `0 0 0 0.5px ${He(r, i)}`,
        _hover: {
          borderColor: He(r, i)
        },
        _placeholder: {
          color: He(r, i)
        }
      },
      _invalid: {
        borderColor: He(r, n),
        boxShadow: `0 0 0 0.5px ${He(r, n)}`
      },
      _focus: {
        zIndex: 1,
        borderColor: He(r, t),
        boxShadow: `0 0 0 0.5px ${He(r, t)}`
      }
    },
    addon: {
      border: "0.5px solid",
      borderColor: He(r, a),
      bg: H("gray.100", "whiteAlpha.300")(e)
    }
  };
}, iAe = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    disabledColor: a
  } = h_(e);
  return {
    field: {
      border: "1px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(e),
      _hover: {
        bg: H("gray.100", "whiteAlpha.50")(e)
      },
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed",
        bg: He(r, a),
        _placeholder: {
          color: H("gray.700", "whiteAlpha.100")(e)
        },
        _hover: {
          bg: He(r, a)
        }
      },
      _invalid: {
        borderColor: He(r, n)
      },
      _focus: {
        bg: "transparent",
        borderColor: He(r, t)
      }
    },
    addon: {
      border: "1px solid",
      borderColor: "transparent",
      bg: H("gray.100", "whiteAlpha.50")(e)
    }
  };
}, sAe = (e) => {
  const {
    theme: r
  } = e, {
    focusBorderColor: t,
    errorBorderColor: n,
    fieldBorderColor: a,
    disabledColor: i
  } = h_(e);
  return {
    field: {
      borderBottom: "0px solid",
      borderColor: He(r, a),
      borderRadius: 0,
      px: 0,
      boxShadow: `0px 1px 0px ${He(r, a)}`,
      bg: "transparent",
      _readOnly: {
        boxShadow: "none !important",
        userSelect: "all"
      },
      _invalid: {
        borderColor: He(r, n),
        boxShadow: `0px 1px 0px ${He(r, n)}`
      },
      _focus: {
        borderColor: He(r, t),
        boxShadow: `0px 1px 0px ${He(r, t)}`
      },
      _disabled: {
        borderColor: He(r, i),
        boxShadow: `0px 1px 0px ${He(r, i)}`,
        _placeholder: {
          color: He(r, i)
        }
      }
    },
    addon: {
      borderBottom: "0px solid",
      borderColor: He(r, a),
      boxShadow: `0px 1px 0px ${He(r, a)}`,
      borderRadius: 0,
      px: 0,
      pr: 2,
      bg: "transparent"
    }
  };
}, lAe = {
  field: {
    bg: "transparent",
    px: 0,
    height: "auto",
    _disabled: {
      _placeholder: {
        color: "gray.300"
      }
    }
  },
  addon: {
    bg: "transparent",
    px: 0,
    height: "auto"
  }
}, uAe = {
  outline: oAe,
  filled: iAe,
  flushed: sAe,
  unstyled: lAe
}, cAe = {
  size: "sm",
  variant: "flushed"
}, dAe = {
  parts: D8.keys,
  baseStyle: nAe,
  sizes: aAe,
  variants: uAe,
  defaultProps: cAe
}, fAe = {
  bg: "blackAlpha.400",
  zIndex: "modal"
}, vAe = (e) => {
  const {
    isCentered: r,
    scrollBehavior: t
  } = e;
  return {
    display: "flex",
    zIndex: "modal",
    justifyContent: "center",
    alignItems: r ? "center" : "flex-start",
    overflow: t === "inside" ? "hidden" : "auto",
    fontSize: "sm"
  };
}, hAe = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    borderRadius: "md",
    bg: H("white", "gray.700")(e),
    color: "inherit",
    my: "3.75rem",
    zIndex: "modal",
    maxH: r === "inside" ? "calc(100% - 7.5rem)" : void 0,
    boxShadow: H("lg", "dark-lg")(e)
  };
}, pAe = {
  px: 6,
  py: 3,
  fontSize: "md",
  fontWeight: "normal",
  borderBottom: "1px solid",
  borderBottomColor: "gray.100"
}, gAe = {
  position: "absolute",
  top: 2,
  insetEnd: 3,
  color: "gray.400"
}, mAe = (e) => {
  const {
    scrollBehavior: r
  } = e;
  return {
    px: 6,
    py: 6,
    flex: 1,
    overflow: r === "inside" ? "auto" : void 0,
    fontSize: "sm"
  };
}, bAe = (e) => ({
  px: 6,
  py: 3,
  bg: H("gray.100", "gray.700")(e),
  borderBottomRadius: "md"
}), yAe = (e) => ({
  overlay: fAe,
  dialogContainer: vAe(e),
  dialog: hAe(e),
  header: pAe,
  closeButton: gAe,
  body: mAe(e),
  footer: bAe(e)
});
function uo(e) {
  return e === "full" ? {
    dialog: {
      maxW: "100vw",
      minH: "100vh",
      "@supports(min-height: -webkit-fill-available)": {
        minH: "-webkit-fill-available"
      },
      my: 0
    }
  } : {
    dialog: {
      maxW: e
    }
  };
}
const SAe = {
  xs: uo("xs"),
  sm: uo("sm"),
  md: uo("md"),
  lg: uo("lg"),
  xl: uo("xl"),
  "2xl": uo("2xl"),
  "3xl": uo("3xl"),
  "4xl": uo("4xl"),
  "5xl": uo("5xl"),
  "6xl": uo("6xl"),
  full: uo("full")
}, xAe = {
  size: "md",
  autoFocus: !1
}, $Ae = {
  parts: N8.keys,
  baseStyle: yAe,
  sizes: SAe,
  defaultProps: xAe
}, rS = $t("popper-bg"), wAe = $t("popper-arrow-bg"), _Ae = $t("popper-arrow-shadow-color"), TAe = {
  zIndex: 10
}, CAe = (e) => {
  const r = H("white", "gray.700")(e), t = H("gray.200", "whiteAlpha.300")(e);
  return {
    [rS.variable]: `colors.${r}`,
    bg: rS.reference,
    [wAe.variable]: rS.reference,
    [_Ae.variable]: `colors.${t}`,
    width: "xs",
    border: "1px solid",
    borderColor: "gray.300",
    borderRadius: "base",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    zIndex: "inherit",
    _focus: {
      outline: 0,
      boxShadow: "node"
    }
  };
}, EAe = {
  px: 3,
  py: 2,
  borderBottomWidth: "1px",
  fontSize: "sm"
}, AAe = {
  fontSize: "xs",
  px: 3,
  py: 2
}, IAe = {
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}, OAe = {
  position: "absolute",
  borderRadius: "md",
  top: 2,
  insetEnd: 2,
  color: "gray.400"
}, MAe = (e) => ({
  popper: TAe,
  content: CAe(e),
  header: EAe,
  body: AAe,
  footer: IAe,
  arrow: {},
  closeButton: OAe
}), RAe = {
  parts: L8.keys,
  baseStyle: MAe
}, PAe = (e) => {
  const {
    colorScheme: r,
    size: t
  } = e, {
    control: n = {}
  } = N0.baseStyle(e);
  let a = "12px";
  return t === "md" ? a = "9px" : t === "sm" && (a = "6px"), Object.assign(Object.assign({}, n), {
    borderRadius: "full",
    _hover: {
      bg: "white",
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: H(`${r}.500`, `${r}.200`)(e)
      },
      _disabled: {
        bg: "linear-gradient(to top left, #FAFAFA, #FAFAFA 48%, #D1D1D1 48%, #D1D1D1 52%, #FAFAFA 52%, #FAFAFA)",
        _before: {
          bg: "none"
        }
      }
    },
    _checked: {
      bg: "white",
      borderColor: H(`${r}.500`, `${r}.200`)(e),
      _before: {
        content: '""',
        display: "inline-block",
        pos: "relative",
        w: a,
        h: a,
        borderRadius: "50%",
        bg: H(`${r}.500`, `${r}.200`)(e)
      },
      _hover: {
        _disabled: {
          bg: "gray.200",
          _before: {
            bg: "gray.500"
          }
        }
      },
      _disabled: {
        _before: {
          bg: "gray.500"
        }
      }
    },
    _active: {
      _before: {
        bg: H(`${r}.900`, `${r}.400`)(e)
      }
    }
  });
}, kAe = (e) => ({
  label: N0.baseStyle(e).label,
  container: N0.baseStyle(e).container,
  control: PAe(e)
}), jAe = {
  md: {
    control: {
      w: 4,
      h: 4
    },
    label: {
      fontSize: "md"
    }
  },
  lg: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: "lg"
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3
    },
    label: {
      fontSize: "sm"
    }
  }
}, DAe = {
  size: "md",
  colorScheme: "brand"
}, NAe = {
  parts: F8.keys,
  baseStyle: kAe,
  sizes: jAe,
  defaultProps: DAe
}, Yo = $t("spinner-size"), LAe = {
  width: [Yo.reference],
  height: [Yo.reference]
}, FAe = {
  xs: {
    [Yo.variable]: "0.75rem"
  },
  sm: {
    [Yo.variable]: "1rem"
  },
  md: {
    [Yo.variable]: "1.5rem"
  },
  lg: {
    [Yo.variable]: "2rem"
  },
  xl: {
    [Yo.variable]: "3rem"
  },
  "2xl": {
    [Yo.variable]: "4rem"
  },
  "3xl": {
    [Yo.variable]: "5rem"
  },
  "4xl": {
    [Yo.variable]: "6rem"
  }
}, zAe = {
  size: "md"
}, BAe = {
  baseStyle: LAe,
  sizes: FAe,
  defaultProps: zAe
}, UAe = Gr("steps").parts("connector", "description", "icon", "iconLabel", "label", "labelContainer", "step", "stepContainer", "stepIconContainer", "steps"), VAe = {
  strokeWidth: "2px"
}, TI = (e) => ({
  color: H("gray.800", "gray.100")(e),
  fontWeight: "medium",
  textAlign: "center",
  fontSize: "md",
  _activeStep: {
    color: "gray.900"
  }
}), WAe = (e) => ({
  color: H("gray.800", "gray.200")(e),
  marginTop: "-2px",
  textAlign: "center",
  fontSize: "sm"
}), HAe = (e) => {
  const {
    colorScheme: r
  } = e, t = H("gray.200", "gray.700")(e);
  let n = `${r}.500`;
  r === "secondary" && (n = `${r}.700`);
  const a = H(n, `${r}.200`)(e);
  return {
    flex: 1,
    display: "flex",
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "border-color",
    transitionDuration: "normal",
    _highlighted: {
      borderColor: a
    }
  };
}, GAe = (e) => {
  const {
    colorScheme: r
  } = e, t = H("gray.400", "gray.700")(e);
  let n = `${r}.500`;
  return r === "secondary" && (n = `${r}.700`), {
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    bg: t,
    borderStyle: "solid",
    borderColor: t,
    transitionProperty: "background, border-color",
    transitionDuration: "normal",
    _activeStep: {
      bg: H(C$e("white", 0.5), E$e(t, 0.5))(e),
      borderColor: n,
      _invalid: {
        bg: "red.500",
        borderColor: "red.500"
      }
    },
    _highlighted: {
      bg: n,
      borderColor: n
    },
    "&[data-clickable]:hover": {
      borderColor: n
    }
  };
}, YAe = (e) => {
  const {
    colorScheme: r
  } = e;
  let t = `${r}.500`;
  return r === "secondary" && (t = `${r}.700`), {
    connector: HAe(e),
    description: WAe(e),
    icon: VAe,
    iconLabel: TI(e),
    label: Object.assign(Object.assign({}, TI(e)), {
      _activeStep: {
        color: t
      }
    }),
    labelContainer: {
      display: "flex",
      flexDir: "column",
      justifyContent: "center"
    },
    step: {
      display: "flex",
      position: "relative"
    },
    stepContainer: {
      display: "flex",
      alignItems: "center"
    },
    stepIconContainer: GAe(e),
    steps: {
      fontFamily: "heading",
      textAlign: "center",
      width: "100%",
      display: "flex",
      flex: 1
    }
  };
}, KAe = {
  sm: {
    stepIconContainer: {
      width: "26px",
      height: "26px",
      borderWidth: "2px"
    },
    icon: {
      width: "14px",
      height: "14px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "sm"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "xs"
    }
  },
  md: {
    stepIconContainer: {
      width: "40px",
      height: "40px",
      borderWidth: "2px"
    },
    icon: {
      width: "18px",
      height: "18px"
    },
    label: {
      fontWeight: "semibold",
      textAlign: "center",
      fontSize: "md"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "sm"
    }
  },
  lg: {
    stepIconContainer: {
      width: "48px",
      height: "48px",
      borderWidth: "2px"
    },
    icon: {
      width: "22px",
      height: "22px"
    },
    label: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "lg"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "md"
    }
  }
}, ZAe = {
  size: "md",
  colorScheme: "brand"
}, qAe = {
  parts: UAe.keys,
  baseStyle: YAe,
  sizes: KAe,
  defaultProps: ZAe
};
var QAe = Vs, XAe = QAe("toStringTag"), uD = {};
uD[XAe] = "z";
var JAe = String(uD) === "[object z]", e3e = JAe, r3e = kn, Up = u6, t3e = Vs, n3e = t3e("toStringTag"), a3e = Object, o3e = Up(function() {
  return arguments;
}()) == "Arguments", i3e = function(e, r) {
  try {
    return e[r];
  } catch (t) {
  }
}, s3e = e3e ? Up : function(e) {
  var r, t, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = i3e(r = a3e(e), n3e)) == "string" ? t : o3e ? Up(r) : (n = Up(r)) == "Object" && r3e(r.callee) ? "Arguments" : n;
}, l3e = s3e, u3e = String, c3e = function(e) {
  if (l3e(e) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return u3e(e);
}, d3e = uu, f3e = function() {
  var e = d3e(this), r = "";
  return e.hasIndices && (r += "d"), e.global && (r += "g"), e.ignoreCase && (r += "i"), e.multiline && (r += "m"), e.dotAll && (r += "s"), e.unicode && (r += "u"), e.unicodeSets && (r += "v"), e.sticky && (r += "y"), r;
}, v3e = Mc, h3e = li, p3e = g6, g3e = f3e, CI = RegExp.prototype, m3e = function(e) {
  var r = e.flags;
  return r === void 0 && !("flags" in CI) && !h3e(e, "flags") && p3e(CI, e) ? v3e(g3e, e) : r;
}, b3e = Lw.PROPER, y3e = qg, S3e = uu, EI = c3e, x3e = $a, $3e = m3e, p_ = "toString", w3e = RegExp.prototype, cD = w3e[p_], _3e = x3e(function() {
  return cD.call({ source: "a", flags: "b" }) != "/a/b";
}), T3e = b3e && cD.name != p_;
(_3e || T3e) && y3e(RegExp.prototype, p_, function() {
  var r = S3e(this), t = EI(r.source), n = EI($3e(r));
  return "/" + t + "/" + n;
}, { unsafe: !0 });
const Yd = $t("switch-track-width"), Jl = $t("switch-track-height"), tS = $t("switch-track-diff"), C3e = So.subtract(Yd, Jl), v2 = $t("switch-thumb-x"), E3e = (e) => {
  const {
    colorScheme: r
  } = e;
  return {
    borderRadius: "full",
    p: "1px",
    width: [Yd.reference],
    height: [Jl.reference],
    transitionProperty: "common",
    transitionDuration: "fast",
    bg: H("gray.100", "whiteAlpha.400")(e),
    _focus: {
      boxShadow: "none"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    _checked: {
      bg: H(`${r}.500`, `${r}.200`)(e)
    }
  };
}, A3e = {
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [Jl.reference],
  height: [Jl.reference],
  _checked: {
    transform: `translateX(${v2.reference})`
  }
}, I3e = (e) => ({
  container: {
    [tS.variable]: C3e,
    [v2.variable]: tS.reference,
    _rtl: {
      [v2.variable]: So(tS).negate().toString()
    }
  },
  track: E3e(e),
  thumb: A3e
}), O3e = {
  sm: {
    container: {
      [Yd.variable]: "2.8rem",
      [Jl.variable]: "1.6rem"
    }
  },
  md: {
    container: {
      [Yd.variable]: "3.8rem",
      [Jl.variable]: "2.2rem"
    }
  },
  lg: {
    container: {
      // 50x30
      [Yd.variable]: "4.8rem",
      [Jl.variable]: "2.8rem"
    }
  }
}, M3e = {
  size: "md",
  colorScheme: "brand"
}, R3e = {
  parts: z8.keys,
  baseStyle: I3e,
  sizes: O3e,
  defaultProps: M3e
}, nS = $t("tooltip-bg"), P3e = $t("popper-arrow-bg"), k3e = (e) => {
  const r = H("white", "gray.700")(e);
  return {
    [nS.variable]: `colors.${r}`,
    bg: [nS.reference],
    [P3e.variable]: [nS.reference],
    color: H("gray", "white")(e),
    px: "8px",
    py: "2px",
    fontWeight: "normal",
    fontSize: "xs",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
    maxW: "320px",
    zIndex: "tooltip"
  };
}, j3e = {
  baseStyle: k3e
};
var D3e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Badge: s4e,
  Button: L4e,
  Card: W4e,
  Checkbox: N0,
  Input: dAe,
  Modal: $Ae,
  Popover: RAe,
  Radio: NAe,
  Spinner: BAe,
  Steps: qAe,
  Switch: R3e,
  Tooltip: j3e
});
const N3e = {
  base: "0px",
  xs: "320px",
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1440px"
}, L3e = {
  50: "#F2F9E5",
  100: "#DFEFBF",
  200: "#C9E595",
  300: "#B2DA68",
  400: "#A0D248",
  500: "#8FCA00",
  600: "#7DBA00",
  700: "#66A600",
  800: "#4F9200",
  900: "#1F7100"
}, AI = {
  50: "#F7F7F7",
  100: "#EEEEEE",
  200: "#E3E3E3",
  300: "#D1D1D1",
  400: "#ACACAC",
  500: "#8B8B8B",
  600: "#646464",
  700: "#515151",
  800: "#333333",
  900: "#131313"
}, F3e = {
  brand: L3e,
  secondary: AI,
  gray: AI
}, z3e = {
  none: "0",
  sm: "0.2rem",
  base: "0.4rem",
  md: "0.6rem",
  lg: "0.8rem",
  xl: "1.2rem",
  "2xl": "1.5rem",
  "3xl": "2.4rem",
  full: "9999px"
}, B3e = {
  // xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
  // sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  // base: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  // md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  // lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  // xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  // '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  // outline: '0 0 0 3px rgba(66, 153, 225, 0.6)',
  // 'outline-md': '0 0 10px rgba(0, 0, 0, 0.1)',
  // inner: 'inset 0 2px 4px 0 rgba(0,0,0,0.06)',
  // none: 'none',
  // 'dark-lg': 'rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px',
  base: "0px 2px 2px rgba(0, 0, 0, 0.1)",
  md: "0px 0px 10px rgba(0, 0, 0, 0.2)",
  lg: "0px 5px 20px rgba(0, 0, 0, 0.2)"
}, dD = {
  px: "1px",
  0.5: "0.2rem",
  1: "0.4rem",
  1.5: "0.6rem",
  2: "0.8rem",
  2.5: "1rem",
  3: "1.2rem",
  3.5: "1.4rem",
  4: "1.6rem",
  5: "2rem",
  6: "2.4rem",
  7: "2.8rem",
  8: "3.2rem",
  9: "3.6rem",
  10: "4rem",
  12: "4.8rem",
  14: "5.6rem",
  16: "6.4rem",
  20: "8rem",
  24: "9.6rem",
  28: "11.2rem",
  32: "12.8rem",
  36: "14.4rem",
  40: "16rem",
  44: "17.6rem",
  48: "19.2rem",
  52: "20.8rem",
  56: "22.4rem",
  60: "24rem",
  64: "25.6rem",
  72: "28.8rem",
  80: "32rem",
  96: "38.4rem"
}, U3e = {
  max: "max-content",
  min: "min-content",
  full: "100%",
  "3xs": "22.4rem",
  "2xs": "25.6rem",
  xs: "32rem",
  sm: "38.4rem",
  md: "44.8rem",
  lg: "51.2rem",
  xl: "57.6rem",
  "2xl": "67.2rem",
  "3xl": "76.8rem",
  "4xl": "89.6rem",
  "5xl": "102.4rem",
  "6xl": "115.2rem",
  "7xl": "128rem",
  "8xl": "144rem"
}, V3e = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px"
}, W3e = Object.assign(Object.assign(Object.assign({}, dD), U3e), {
  container: V3e
}), H3e = {
  fonts: {
    heading: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    body: 'Lato, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace'
  },
  fontSizes: {
    xxs: "1.3rem",
    xs: "1.4rem",
    sm: "1.6rem",
    md: "1.8rem",
    lg: "2rem",
    xl: "2.2rem",
    "2xl": "2.4rem",
    "3xl": "3.2rem",
    "4xl": "3.6rem",
    "5xl": "4.8rem",
    "6xl": "6rem",
    "7xl": "7.2rem",
    "8xl": "9.6rem",
    "9xl": "12.8rem"
  }
}, G3e = Object.assign(Object.assign({
  radii: z3e,
  colors: F3e
}, H3e), {
  sizes: W3e,
  space: dD,
  shadows: B3e,
  breakpoints: N3e
}), Y3e = {
  global: (e) => ({
    html: {
      fontSize: "10px"
    },
    "html, body, #__next": {
      height: "100vh",
      bg: H("white", "gray.800")(e)
    }
  })
}, K3e = {
  useSystemColorMode: !1,
  initialColorMode: "light",
  cssVarPrefix: "ds-falabella"
}, Z3e = XCe(Object.assign(Object.assign({}, G3e), {
  components: Object.assign({}, D3e),
  styles: Y3e,
  config: K3e
}), JCe({
  colorScheme: "brand"
})), q3e = (e, r = {}) => e === "" || !e ? Z3e : fP(r, Ime), Q3e = "https://falabella.scene7.com/is/image/Falabella", X3e = {
  apiBaseUrl: {
    staging: "https://stg.api.bazaarvoice.com/data",
    uat: "https://api.bazaarvoice.com/data",
    production: "https://api.bazaarvoice.com/data"
  },
  apiKey: {
    cl: {
      staging: "cahaotOSiLcdFM9ncSI3xsc0cL8Iso9z1cmSkcj5H66Hk",
      uat: "caL72ZXmzt8PKT4tz1PqWxtuWcN1fP5TTT1ZPsbFIse2Y",
      production: "caL72ZXmzt8PKT4tz1PqWxtuWcN1fP5TTT1ZPsbFIse2Y"
    },
    pe: {
      staging: "caLnidnPbPImRWgruNrOrMCJUPolMcWOFYwJ1IGMoXHZI",
      uat: "caA1SPlXPQxP0ls9JbfylYuAHLRhIoV3tsUaqUBh8bnKc",
      production: "caA1SPlXPQxP0ls9JbfylYuAHLRhIoV3tsUaqUBh8bnKc"
    },
    co: {
      staging: "caOMDwkt9652ivjJ7kqogJaafEHLQnoRmbaxruAMok1P0",
      uat: "cawmzx4wqbOCOeeD2FH1bZOhUGUqH7ecMjnyqmfUu2SaI",
      production: "cawmzx4wqbOCOeeD2FH1bZOhUGUqH7ecMjnyqmfUu2SaI"
    },
    mx: {
      staging: "caU4gVRJ2eme3GfR8tYf4QUheGK2m1XORAMzqGkuzbfWo",
      uat: "can9aOddZnegqsJ4xd4pfUGqS1e5NEiGvQbibE2LYIeP0",
      production: "can9aOddZnegqsJ4xd4pfUGqS1e5NEiGvQbibE2LYIeP0"
    }
  },
  apiVersion: "5.4",
  apiAction: process.env.SUBMITION_ACTION || "submit"
  /* Submit */
}, ai = {
  RATE_THIS_PRODUCT: "Califica este producto:",
  BE_THE_FIRST_TO_RATE: "Sé el primero en calificar este producto:",
  RECOMMENDATION_RATE_MESSAGE: "de los clientes recomiendan este producto.",
  COMMENT: "comentario",
  COMMENTS: "comentarios",
  SEE_COMMENTS_WITH_IMAGES: "Ver todos los comentarios con imagen",
  PEOPLE_FOUND_THIS_HELPFUL: "personas encuentran útil este comentario.",
  PERSON_FOUND_THIS_HELPFUL: "1 persona encuentra útil este comentario.",
  VIEW_MORE_COMMENTS: "Ver más comentarios"
}, II = {
  development: "dev",
  staging: "staging",
  production: "www",
  uat: "beta"
}, J3e = ({
  product: e,
  queryParams: r = "wid=100&hei=100&qlt=70"
}) => {
  var i;
  const t = `${Q3e}/${e.id}?${r}`;
  if (!e || !e.variants || e.variants.length === 0)
    return t;
  const n = (i = e.variants[0].medias) == null ? void 0 : i[0], a = n == null ? void 0 : n.url;
  return a ? `${a}?${r}` : t;
}, fD = (e) => function(t) {
  const l = t, { rebrandingModifier: n = "solar" } = l, a = Hv(l, ["rebrandingModifier"]), i = q3e(n);
  return /* @__PURE__ */ T.jsx(dP, { theme: i, children: /* @__PURE__ */ T.jsx(e, Xt({}, a)) });
}, OI = {
  "bv-write-review": "_bv-write-review_1r59d_1",
  "write-comment-label": "_write-comment-label_1r59d_1"
};
function eIe({ reviewAdapter: e }) {
  function r(c) {
    return Xr(this, arguments, function* ({
      productId: i,
      offset: l,
      fetchStats: u
    }) {
      return e.getReviews({ productId: i, offset: l, fetchStats: u });
    });
  }
  function t(i) {
    return Xr(this, null, function* () {
      return e.saveReview(i);
    });
  }
  function n(i) {
    return Xr(this, null, function* () {
      return e.submitReviewFeedback(i);
    });
  }
  function a(i) {
    return Xr(this, null, function* () {
      return e.uploadPhoto(i);
    });
  }
  return {
    getReviews: r,
    saveReview: t,
    submitReviewFeedback: n,
    uploadPhoto: a
  };
}
function wd(e, r) {
  return Xr(this, null, function* () {
    try {
      const t = yield fetch(e, r);
      return t.ok ? t.json() : Promise.resolve(
        `Error fetching data: ${t.statusText}`
      );
    } catch (t) {
      throw console.error("An error occurred:", t), t;
    }
  });
}
const { apiAction: rIe, apiBaseUrl: tIe, apiVersion: np, apiKey: nIe } = X3e;
function aIe({
  tenant: e,
  environment: r,
  fetchApiBaseUrl: t,
  enableEnglishReviews: n
}) {
  if (!e || !r)
    throw new Error("tenant and environment are required");
  const a = nIe[e][r], i = tIe[r];
  function l(y) {
    return Xr(this, arguments, function* ({
      productId: h,
      fetchStats: p,
      offset: g
    }) {
      const S = t ? `${t}?passKey=${a}&productId=${h}&offset=${g}&limit=9&fetchStats=${p}&multiLangReviews=${n}` : `${i}/reviews.json?apiversion=${np}&passkey=${a}&Filter=ProductId%3A${h}${n ? "" : "&Filter=ContentLocale:eq:es_*"}&Sort=Rating:desc,HasPhotos:desc&offset=${g}&limit=9${p ? "&Include=Products&FilteredStats=Reviews" : ""}`;
      return yield wd(S);
    });
  }
  function u(h) {
    return Xr(this, null, function* () {
      const p = `${i}/submitreview.json`, g = new Headers();
      g.append("Content-Type", "application/x-www-form-urlencoded");
      const y = new URLSearchParams();
      y.append("apiversion", np), y.append("passkey", a), y.append("action", rIe), y.append("agreedtotermsandconditions", "true"), Object.entries(h).forEach(([_, A]) => {
        y.append(_, String(A));
      });
      const S = {
        method: "POST",
        headers: g,
        body: y.toString()
      };
      return yield wd(p, S);
    });
  }
  function c(h) {
    return Xr(this, null, function* () {
      const p = `${i}/submitfeedback.json`, g = new Headers();
      g.append("Content-Type", "application/x-www-form-urlencoded");
      const y = new URLSearchParams();
      y.append("ApiVersion", np), y.append("ContentType", "review"), y.append("ContentId", h.reviewId), y.append("FeedbackType", "helpfulness"), y.append("Vote", h.vote), y.append("PassKey", a);
      const S = {
        method: "POST",
        headers: g,
        body: y.toString()
      };
      return yield wd(p, S);
    });
  }
  function f(h) {
    return Xr(this, null, function* () {
      const p = new FormData();
      p.append("photo", h, h.name), p.append("apiversion", np), p.append("contenttype", "Review"), p.append("passkey", a);
      const g = `${i}/uploadphoto.json`, y = {
        method: "POST",
        body: p
      };
      try {
        return yield wd(g, y);
      } catch (S) {
        throw console.error("An error occurred:", S), S;
      }
    });
  }
  return {
    getReviews: l,
    saveReview: u,
    submitReviewFeedback: c,
    uploadPhoto: f
  };
}
function g_({
  tenant: e,
  environment: r,
  fetchApiBaseUrl: t,
  enableEnglishReviews: n
}) {
  const a = aIe({
    tenant: e,
    environment: r,
    fetchApiBaseUrl: t,
    enableEnglishReviews: n
  }), i = eIe({
    reviewAdapter: a
  });
  function l(y) {
    return Xr(this, arguments, function* ({
      productId: h,
      offset: p,
      fetchStats: g
    }) {
      return i.getReviews({ productId: h, offset: p, fetchStats: g });
    });
  }
  function u(g) {
    return Xr(this, arguments, function* ({ product: h, values: p }) {
      const { photos: y } = p;
      let S = [];
      y && y.length && (S = yield f(y));
      const x = {};
      S && S.length && S.forEach((A, O) => {
        var P, j, k;
        x[`photourl_${O}`] = (k = (j = (P = A == null ? void 0 : A.Photo) == null ? void 0 : P.Sizes) == null ? void 0 : j.thumbnail) == null ? void 0 : k.Url;
      });
      const _ = Xt(wi(Xt({}, p), {
        productid: h.id
      }), x);
      return i.saveReview(_);
    });
  }
  function c(g) {
    return Xr(this, arguments, function* ({
      reviewId: h,
      vote: p
    }) {
      return i.submitReviewFeedback({ reviewId: h, vote: p });
    });
  }
  function f(h) {
    return Xr(this, null, function* () {
      const p = h.map((g) => i.uploadPhoto(g));
      return Promise.all(p);
    });
  }
  return {
    fetchReviews: l,
    saveReview: u,
    submitReviewFeedback: c
  };
}
const oIe = "_text_1ka41_10", iIe = "_options_1ka41_16", sIe = "_option_1ka41_16", lIe = "_checked_1ka41_41", uIe = "_line_1ka41_44", go = {
  "bv-dots-radio-buttons": "_bv-dots-radio-buttons_1ka41_2",
  text: oIe,
  options: iIe,
  option: sIe,
  "with-line": "_with-line_1ka41_26",
  "dot-radio-button": "_dot-radio-button_1ka41_29",
  "dot-button": "_dot-button_1ka41_36",
  checked: lIe,
  line: uIe
};
function cIe({ isChecked: e, onChange: r }) {
  return /* @__PURE__ */ T.jsxs(an, { className: go["dot-radio-button"], as: "label", children: [
    /* @__PURE__ */ T.jsx("input", { type: "radio", checked: e, onChange: r }),
    /* @__PURE__ */ T.jsx(
      an,
      {
        role: "dot-radio-button",
        className: `${go["dot-button"]} ${e ? go.checked : ""}`
      }
    )
  ] });
}
function dIe({
  options: e,
  selected: r,
  setSelected: t,
  fieldName: n
}) {
  return /* @__PURE__ */ T.jsxs("div", { className: go["bv-dots-radio-buttons"], children: [
    /* @__PURE__ */ T.jsx("div", { className: go.text, children: e[0] }),
    /* @__PURE__ */ T.jsx("div", { className: `${go.text} ${go.options}`, children: e.map((a, i) => {
      const l = e.indexOf(a) + 1;
      return /* @__PURE__ */ T.jsxs(
        "span",
        {
          className: `${go.option} ${i < e.length - 1 ? go["with-line"] : ""}`,
          children: [
            /* @__PURE__ */ T.jsx(
              cIe,
              {
                isChecked: r === l,
                onChange: () => t(n, l)
              },
              l
            ),
            Number(l) < e.length && /* @__PURE__ */ T.jsx("span", { className: go.line })
          ]
        },
        `radio-${i}`
      );
    }) }),
    /* @__PURE__ */ T.jsx("div", { className: go.text, children: e[e.length - 1] })
  ] });
}
const fIe = "data:image/svg+xml;base64,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", vIe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjkwNDI2MSAxLjM3Njg4TDcuMTU4MzEgNy45OTkyNEwwLjkwMzUwOCAxNC42MjE2QzAuNjA1NDA2IDE0LjkzNzMgMC42MDU0MDYgMTUuNDQ4MSAwLjkwMzUwOCAxNS43NjM4QzEuMjAxNjEgMTYuMDc4NyAxLjY4NDU4IDE2LjA3ODcgMS45ODI2OCAxNS43NjM4TDguNzc2MzYgOC41NzA3QzkuMDc0NDYgOC4yNTU3NyA5LjA3NDQ2IDcuNzQ0MjMgOC43NzYzNiA3LjQyOTI5TDEuOTgyNzUgMC4yMzYyMDFDMS42ODQ2NSAtMC4wNzg3MzM0IDEuMjAwOTIgLTAuMDc4NzMzNCAwLjkwMjgxOSAwLjIzNjIwMUMwLjYwNjE2IDAuNTUwMzQgMC42MDYxNiAxLjA2MTk0IDAuOTA0MjYxIDEuMzc2ODhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K", hIe = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imljb24vMjQvYmFzaWNzLWNsb3NlIj4KPHBhdGggaWQ9IlNoYXBlIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjIwNzIgMTQuNzkzTDkuNDE0MjEgOEw4IDkuNDE0MjFMMTQuNzkzIDE2LjIwNzJMOC4wMDAxNiAyM0w5LjQxNDM3IDI0LjQxNDJMMTYuMjA3MiAxNy42MjE0TDIzIDI0LjQxNDJMMjQuNDE0MiAyM0wxNy42MjE0IDE2LjIwNzJMMjQuNDE0NCA5LjQxNDIxTDIzLjAwMDIgOEwxNi4yMDcyIDE0Ljc5M1oiIGZpbGw9IiMzMzMzMzMiLz4KPC9nPgo8L3N2Zz4K", pIe = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMjAuODY2NCA0QzIxLjE1NjMgNCAyMS40NDYzIDQuMTEwOCAyMS42Njc5IDQuMzMxOTVDMjIuMTEwNyA0Ljc3NDIzIDIyLjExMDcgNS40OTIzOCAyMS42Njc5IDUuOTM1MTNMMTEuNjAzNCAxNS45OTk3TDIxLjY2NzkgMjYuMDY0OEMyMi4xMTA3IDI2LjUwNyAyMi4xMTA3IDI3LjIyNTIgMjEuNjY3OSAyNy42Njc5QzIxLjIyNTIgMjguMTEwNyAyMC41MDggMjguMTEwNyAyMC4wNjQ4IDI3LjY2NzlMOS4xOTg1OCAxNi44MDEzQzguNzU1ODQgMTYuMzU5IDguNzU1ODQgMTUuNjQwOSA5LjE5ODU4IDE1LjE5ODFMMjAuMDY0OCA0LjMzMTk1QzIwLjI4NjQgNC4xMTA4IDIwLjU3NjQgNCAyMC44NjY0IDRaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPg==", gIe = ({
  color: e,
  fill: r,
  width: t,
  height: n
}) => /* @__PURE__ */ T.jsxs(
  "svg",
  {
    width: t,
    height: n,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ T.jsx(
        "path",
        {
          d: "M96.4073 49.0001C96.4073 75.1824 75.1823 96.4075 48.9999 96.4075C22.8175 96.4075 1.59253 75.1824 1.59253 49.0001C1.59253 22.8177 22.8175 1.59265 48.9999 1.59265C75.1823 1.59265 96.4073 22.8177 96.4073 49.0001Z",
          fill: r
        }
      ),
      /* @__PURE__ */ T.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M49 2.70379C23.4312 2.70379 2.70367 23.4313 2.70367 49.0001C2.70367 74.5688 23.4312 95.2964 49 95.2964C74.5687 95.2964 95.2963 74.5688 95.2963 49.0001C95.2963 23.4313 74.5687 2.70379 49 2.70379ZM0.481445 49.0001C0.481445 22.2041 22.2039 0.481567 49 0.481567C75.796 0.481567 97.5185 22.2041 97.5185 49.0001C97.5185 75.7961 75.796 97.5186 49 97.5186C22.2039 97.5186 0.481445 75.7961 0.481445 49.0001Z",
          fill: e
        }
      ),
      /* @__PURE__ */ T.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M45.0154 71.9425C43.486 72.0787 41.9748 71.53 40.8891 70.4443L26.0743 55.6295C24.0493 53.6045 24.0493 50.3214 26.0743 48.2965C28.0992 46.2716 31.3823 46.2716 33.4072 48.2965L43.8389 58.7282L64.0027 29.7426C65.6381 27.3918 68.8695 26.8118 71.2204 28.4472C73.5712 30.0825 74.1512 33.314 72.5158 35.6648L48.8121 69.7389C47.9353 70.9993 46.5448 71.8064 45.0154 71.9425Z",
          fill: e
        }
      ),
      /* @__PURE__ */ T.jsx(
        "path",
        {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M44.8182 69.7291C43.9443 69.8069 43.0808 69.4933 42.4603 68.8729L27.6455 54.0581C26.4884 52.901 26.4884 51.0249 27.6455 49.8678C28.8026 48.7107 30.6787 48.7107 31.8358 49.8678L44.146 62.178L65.8269 31.0117C66.7614 29.6683 68.6079 29.3369 69.9512 30.2714C71.2946 31.2059 71.626 33.0524 70.6915 34.3957L46.9878 68.4698C46.4867 69.1901 45.6922 69.6513 44.8182 69.7291Z",
          fill: "white"
        }
      )
    ]
  }
), mIe = () => /* @__PURE__ */ T.jsx(an, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ T.jsx("img", { width: 32, height: 32, src: hIe, alt: "Close Modal Icon" }) }), bIe = () => /* @__PURE__ */ T.jsx(an, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ T.jsx("img", { width: 80, height: 80, src: fIe, alt: "Upload Image" }) }), yIe = () => /* @__PURE__ */ T.jsx(an, { width: "8px", height: "16px", children: /* @__PURE__ */ T.jsx("img", { width: 8, height: 16, src: vIe, alt: "right chevron" }) }), SIe = (e) => /* @__PURE__ */ T.jsx(an, wi(Xt({ width: "32px", height: "32px" }, e), { children: /* @__PURE__ */ T.jsx("img", { src: pIe, alt: "sample product image" }) })), aS = {
  "basic-modal-custom-header": "_basic-modal-custom-header_ejoga_2",
  "back-button": "_back-button_ejoga_6",
  "close-button": "_close-button_ejoga_18"
}, m_ = ({
  onClose: e,
  onBackClick: r,
  showBackButton: t
}) => /* @__PURE__ */ T.jsxs("div", { className: aS["basic-modal-custom-header"], children: [
  t && /* @__PURE__ */ T.jsx(SIe, { onClick: r, className: aS["back-button"] }),
  /* @__PURE__ */ T.jsx("button", { className: aS["close-button"], onClick: e, children: /* @__PURE__ */ T.jsx(mIe, {}) })
] }), jl = {
  "bv-modal-overlay": "_bv-modal-overlay_i7sfy_3",
  "bv-modal": "_bv-modal_i7sfy_3",
  "bv-modal-close": "_bv-modal-close_i7sfy_34",
  "bv-modal-body": "_bv-modal-body_i7sfy_41",
  "bv-modal-continue": "_bv-modal-continue_i7sfy_53"
}, b_ = (e, r, t) => {
  ar(() => {
    const n = (a) => {
      e.current && !e.current.contains(a.target) && window.innerWidth > 767 && t();
    };
    return r && document.addEventListener("mousedown", n), () => {
      document.removeEventListener("mousedown", n);
    };
  }, [r, t, e]);
}, xIe = ({
  children: e,
  onClose: r,
  onContinue: t
}) => {
  let n = null, a = null, i = null;
  xo.Children.forEach(e, (c) => {
    if (xo.isValidElement(c)) {
      const { slot: f } = c.props;
      f === "header" ? n = c : f === "footer" ? i = c : a = c;
    } else
      a = c;
  });
  const l = () => /* @__PURE__ */ T.jsx("button", { className: jl["bv-modal-close"], onClick: r, children: "X" }), u = () => /* @__PURE__ */ T.jsx(
    "button",
    {
      className: jl["bv-modal-continue"],
      onClick: t || r,
      children: "Continuar"
    }
  );
  return {
    headerChild: n || /* @__PURE__ */ T.jsx(l, {}),
    bodyChild: a || null,
    footerChild: i || /* @__PURE__ */ T.jsx(u, {})
  };
}, MI = (e) => {
  e ? document.body.classList.add("bvwr-modal-open") : document.body.classList.remove("bvwr-modal-open");
}, $Ie = (e) => {
  ar(() => (MI(e), () => {
    MI(!1);
  }), [e]);
}, y_ = ({
  isOpen: e,
  onClose: r,
  onContinue: t,
  children: n,
  isApp: a
}) => {
  const i = Qe(null);
  $Ie(e);
  const { headerChild: l, bodyChild: u, footerChild: c } = xIe({
    children: n,
    onClose: r,
    onContinue: t
  });
  return b_(i, e, r), e ? /* @__PURE__ */ T.jsx(an, { className: jl["bv-modal-overlay"], children: /* @__PURE__ */ T.jsxs(an, { className: jl["bv-modal"], ref: i, children: [
    !a && /* @__PURE__ */ T.jsx(an, { className: jl["bv-modal-header"], children: l }),
    /* @__PURE__ */ T.jsx(an, { className: jl["bv-modal-body"], pt: a ? "48px" : "0", children: u }),
    /* @__PURE__ */ T.jsx(an, { className: jl["modal-footer"], children: c })
  ] }) }) : null;
}, vD = (n) => {
  var a = n, {
    product: e,
    queryParams: r
  } = a, t = Hv(a, [
    "product",
    "queryParams"
  ]);
  return /* @__PURE__ */ T.jsx(
    Ple,
    Xt({
      src: J3e({ product: e, queryParams: r }),
      fallbackSrc: "/product-image-fallback.jpeg",
      alt: "Product image",
      boxSize: t.boxSize || "80px",
      objectFit: t.objectFit || "cover"
    }, t)
  );
}, wIe = "_filled_3a18v_8", _Ie = "_empty_3a18v_11", ap = {
  "bv-stars-section": "_bv-stars-section_3a18v_1",
  "star-icon": "_star-icon_3a18v_1",
  filled: wIe,
  empty: _Ie
}, S_ = ({
  handleRatingClickHook: e,
  rating: r,
  fieldName: t = "rating"
}) => {
  const n = (i) => {
    e && e(t, i);
  }, a = ({ rating: i, index: l }) => i === 0 || i === null ? "" : i > l ? ap.filled : ap.empty;
  return /* @__PURE__ */ T.jsx(ZS, { className: ap["bv-stars-section"], spacing: "8px", children: [...Array(5)].map((i, l) => /* @__PURE__ */ T.jsx(
    "span",
    {
      role: "star-icon",
      "data-testid": `star-icon-${l + 1}`,
      className: `${ap["star-icon"]} ${a({
        rating: r,
        index: l
      })}`,
      onClick: () => n(l + 1)
    },
    l
  )) });
}, TIe = {
  "bv-separator": "_bv-separator_1khcz_1"
};
function RI() {
  return /* @__PURE__ */ T.jsx("div", { className: TIe["bv-separator"] });
}
const hD = On(
  void 0
), CIe = ({
  initialProduct: e,
  isSecondaryRatingsFormEnabled: r = !0,
  isReviewValidationWithOrder: t = !1,
  children: n
}) => {
  const [a, i] = Ye(e);
  return /* @__PURE__ */ T.jsx(
    hD.Provider,
    {
      value: {
        product: a,
        isSecondaryRatingsFormEnabled: r,
        isReviewValidationWithOrder: t,
        setProduct: i
      },
      children: n
    }
  );
}, pm = () => {
  const e = zr(hD);
  if (!e)
    throw new Error("useProductContext must be used within a ProductProvider");
  return e;
}, pD = On(void 0), EIe = ({
  children: e,
  label: r = "Calificar",
  isLoggedIn: t = !0,
  openForm: n = !1,
  onClickSuccessButton: a,
  environment: i = "production",
  tenant: l = "cl",
  theme: u = { secondary_color: "#343E49" },
  recommendedThreshold: c = 80,
  isSodimacStandAlone: f = !1,
  fetchApiBaseUrl: h,
  enableEnglishReviews: p = !1
}) => /* @__PURE__ */ T.jsx(
  pD.Provider,
  {
    value: {
      label: r,
      isLoggedIn: t,
      openForm: n,
      onClickSuccessButton: a,
      environment: i,
      tenant: l,
      theme: u,
      recommendedThreshold: c,
      isSodimacStandAlone: f,
      fetchApiBaseUrl: h,
      enableEnglishReviews: p
    },
    children: e
  }
), Co = () => {
  const e = zr(pD);
  if (!e)
    throw new Error("useGlobalContext must be used within a GlobalProvider");
  return e;
}, gD = On(
  void 0
), AIe = ({
  children: e
}) => {
  const { product: r } = pm(), { tenant: t, environment: n, fetchApiBaseUrl: a, enableEnglishReviews: i } = Co(), l = g_({
    tenant: t,
    environment: n,
    fetchApiBaseUrl: a,
    enableEnglishReviews: i
  }), [u, c] = Ye(), [f, h] = Ye(), [p, g] = Ye(), [y, S] = Ye([]), [x, _] = Ye([]), [A, O] = Ye(), [P, j] = Ye(!1), [k, L] = Ye(), [M, W] = Ye(), [Z, oe] = Ye([]), [Ie, Te] = Ye(0), [Ee, Me] = Ye([]), Fe = (ce) => Number(ce.toFixed(1)), Ge = ({
    reviews: ce
  }) => ce.filter(
    (be) => {
      var ye;
      return ((ye = be == null ? void 0 : be.Photos) == null ? void 0 : ye.length) !== 0;
    }
  ), ze = () => Xr(void 0, null, function* () {
    const ce = yield l.fetchReviews({
      productId: r.id,
      offset: Ie + 9,
      fetchStats: !1
    });
    Te((ye) => ye + 9);
    const { Results: he, HasErrors: be } = ce;
    be || he && (oe((ye) => [...ye, ...he]), Me(
      (ye) => Ge({ reviews: [...ye, ...he] })
    ));
  }), le = ({
    reviewId: ce,
    type: he
  }) => {
    he === "helpful" && S((be) => [...be, ce]), he === "not_helpful" && _((be) => [...be, ce]);
  };
  return ar(() => {
    (() => Xr(void 0, null, function* () {
      var or;
      const he = yield l.fetchReviews({
        productId: r.id,
        offset: 0,
        fetchStats: !0
      }), {
        Results: be,
        Includes: {
          Products: {
            [r.id]: {
              FilteredReviewStatistics: {
                AverageOverallRating: ye,
                RatingDistribution: q,
                RecommendedCount: ae,
                SecondaryRatingsAverages: ue,
                SecondaryRatingsAveragesOrder: $e
              }
            }
          }
        },
        TotalResults: Ze,
        HasErrors: _e
      } = he;
      _e || !((or = he == null ? void 0 : he.Includes) != null && or.Products) || (ye && c(Fe(ye)), q && O(q), ae && g(ae), Object.keys(ue).length !== 0 && (L(ue), W($e), j(!0)), be && (oe(be), Me(Ge({ reviews: be }))), h(Ze));
    }))();
  }, [r.id]), ar(() => {
    (() => {
      const he = document == null ? void 0 : document.cookie.split(";"), be = [], ye = [];
      he.forEach((q) => {
        const [ae, ue] = q.trim().split("=");
        if (ae.startsWith("review_")) {
          const $e = ae.substring(7);
          ue === "helpful" ? be.push($e) : ue === "not_helpful" && ye.push($e);
        }
      }), S(be), _(ye);
    })();
  }, []), /* @__PURE__ */ T.jsx(
    gD.Provider,
    {
      value: {
        averageRating: u,
        totalComments: f,
        ratingDistribution: A,
        recommendedCount: p,
        hasSecondaryRatings: P,
        secondaryRatingsAverages: k,
        secondaryRatingsAveragesOrder: M,
        userReviews: Z,
        reviewsWithPhotos: Ee,
        offset: Ie,
        getMoreReviews: ze,
        helpfulIds: y,
        notHelpfulIds: x,
        updateFeedbackReviewsList: le
      },
      children: e
    }
  );
}, Ta = () => {
  const e = zr(gD);
  if (!e)
    throw new Error(
      "useReviewsStatsContext must be used within a ReviewsStatsProvider"
    );
  return e;
}, IIe = "_title_t0xbj_7", OIe = "_section_t0xbj_38", MIe = "_attributes_t0xbj_3", RIe = "_attribute_t0xbj_3", PIe = "_name_t0xbj_56", bn = {
  "attributes-by-category-form": "_attributes-by-category-form_t0xbj_3",
  title: IIe,
  "image-and-product-name": "_image-and-product-name_t0xbj_14",
  "product-name": "_product-name_t0xbj_24",
  "first-separator": "_first-separator_t0xbj_30",
  section: OIe,
  attributes: MIe,
  attribute: RIe,
  name: PIe,
  "dots-rating": "_dots-rating_t0xbj_62",
  "bv-dots-radio-buttons": "_bv-dots-radio-buttons_t0xbj_73",
  "footer-by-category-form": "_footer-by-category-form_t0xbj_78",
  "main-button-wrapper": "_main-button-wrapper_t0xbj_78",
  "back-button": "_back-button_t0xbj_88",
  "main-button": "_main-button_t0xbj_78"
};
var kIe = function(r) {
  return jIe(r) && !DIe(r);
};
function jIe(e) {
  return !!e && typeof e == "object";
}
function DIe(e) {
  var r = Object.prototype.toString.call(e);
  return r === "[object RegExp]" || r === "[object Date]" || FIe(e);
}
var NIe = typeof Symbol == "function" && Symbol.for, LIe = NIe ? Symbol.for("react.element") : 60103;
function FIe(e) {
  return e.$$typeof === LIe;
}
function zIe(e) {
  return Array.isArray(e) ? [] : {};
}
function L0(e, r) {
  return r.clone !== !1 && r.isMergeableObject(e) ? Cf(zIe(e), e, r) : e;
}
function BIe(e, r, t) {
  return e.concat(r).map(function(n) {
    return L0(n, t);
  });
}
function UIe(e, r, t) {
  var n = {};
  return t.isMergeableObject(e) && Object.keys(e).forEach(function(a) {
    n[a] = L0(e[a], t);
  }), Object.keys(r).forEach(function(a) {
    !t.isMergeableObject(r[a]) || !e[a] ? n[a] = L0(r[a], t) : n[a] = Cf(e[a], r[a], t);
  }), n;
}
function Cf(e, r, t) {
  t = t || {}, t.arrayMerge = t.arrayMerge || BIe, t.isMergeableObject = t.isMergeableObject || kIe;
  var n = Array.isArray(r), a = Array.isArray(e), i = n === a;
  return i ? n ? t.arrayMerge(e, r, t) : UIe(e, r, t) : L0(r, t);
}
Cf.all = function(r, t) {
  if (!Array.isArray(r))
    throw new Error("first argument should be an array");
  return r.reduce(function(n, a) {
    return Cf(n, a, t);
  }, {});
};
var h2 = Cf, VIe = typeof global == "object" && global && global.Object === Object && global;
const mD = VIe;
var WIe = typeof self == "object" && self && self.Object === Object && self, HIe = mD || WIe || Function("return this")();
const ui = HIe;
var GIe = ui.Symbol;
const Fs = GIe;
var bD = Object.prototype, YIe = bD.hasOwnProperty, KIe = bD.toString, pd = Fs ? Fs.toStringTag : void 0;
function ZIe(e) {
  var r = YIe.call(e, pd), t = e[pd];
  try {
    e[pd] = void 0;
    var n = !0;
  } catch (i) {
  }
  var a = KIe.call(e);
  return n && (r ? e[pd] = t : delete e[pd]), a;
}
var qIe = Object.prototype, QIe = qIe.toString;
function XIe(e) {
  return QIe.call(e);
}
var JIe = "[object Null]", eOe = "[object Undefined]", PI = Fs ? Fs.toStringTag : void 0;
function fu(e) {
  return e == null ? e === void 0 ? eOe : JIe : PI && PI in Object(e) ? ZIe(e) : XIe(e);
}
function yD(e, r) {
  return function(t) {
    return e(r(t));
  };
}
var rOe = yD(Object.getPrototypeOf, Object);
const x_ = rOe;
function vu(e) {
  return e != null && typeof e == "object";
}
var tOe = "[object Object]", nOe = Function.prototype, aOe = Object.prototype, SD = nOe.toString, oOe = aOe.hasOwnProperty, iOe = SD.call(Object);
function kI(e) {
  if (!vu(e) || fu(e) != tOe)
    return !1;
  var r = x_(e);
  if (r === null)
    return !0;
  var t = oOe.call(r, "constructor") && r.constructor;
  return typeof t == "function" && t instanceof t && SD.call(t) == iOe;
}
var jI = Array.isArray, DI = Object.keys, sOe = Object.prototype.hasOwnProperty, lOe = typeof Element != "undefined";
function p2(e, r) {
  if (e === r)
    return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    var t = jI(e), n = jI(r), a, i, l;
    if (t && n) {
      if (i = e.length, i != r.length)
        return !1;
      for (a = i; a-- !== 0; )
        if (!p2(e[a], r[a]))
          return !1;
      return !0;
    }
    if (t != n)
      return !1;
    var u = e instanceof Date, c = r instanceof Date;
    if (u != c)
      return !1;
    if (u && c)
      return e.getTime() == r.getTime();
    var f = e instanceof RegExp, h = r instanceof RegExp;
    if (f != h)
      return !1;
    if (f && h)
      return e.toString() == r.toString();
    var p = DI(e);
    if (i = p.length, i !== DI(r).length)
      return !1;
    for (a = i; a-- !== 0; )
      if (!sOe.call(r, p[a]))
        return !1;
    if (lOe && e instanceof Element && r instanceof Element)
      return e === r;
    for (a = i; a-- !== 0; )
      if (l = p[a], !(l === "_owner" && e.$$typeof) && !p2(e[l], r[l]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var uOe = function(r, t) {
  try {
    return p2(r, t);
  } catch (n) {
    if (n.message && n.message.match(/stack|recursion/i) || n.number === -2146828260)
      return console.warn("Warning: react-fast-compare does not handle circular references.", n.name, n.message), !1;
    throw n;
  }
};
const Al = /* @__PURE__ */ H0(uOe);
var cOe = !0;
function dOe(e, r) {
  if (!cOe) {
    if (e)
      return;
    var t = "Warning: " + r;
    typeof console != "undefined" && console.warn(t);
    try {
      throw Error(t);
    } catch (n) {
    }
  }
}
function fOe() {
  this.__data__ = [], this.size = 0;
}
function xD(e, r) {
  return e === r || e !== e && r !== r;
}
function gm(e, r) {
  for (var t = e.length; t--; )
    if (xD(e[t][0], r))
      return t;
  return -1;
}
var vOe = Array.prototype, hOe = vOe.splice;
function pOe(e) {
  var r = this.__data__, t = gm(r, e);
  if (t < 0)
    return !1;
  var n = r.length - 1;
  return t == n ? r.pop() : hOe.call(r, t, 1), --this.size, !0;
}
function gOe(e) {
  var r = this.__data__, t = gm(r, e);
  return t < 0 ? void 0 : r[t][1];
}
function mOe(e) {
  return gm(this.__data__, e) > -1;
}
function bOe(e, r) {
  var t = this.__data__, n = gm(t, e);
  return n < 0 ? (++this.size, t.push([e, r])) : t[n][1] = r, this;
}
function Ui(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Ui.prototype.clear = fOe;
Ui.prototype.delete = pOe;
Ui.prototype.get = gOe;
Ui.prototype.has = mOe;
Ui.prototype.set = bOe;
function yOe() {
  this.__data__ = new Ui(), this.size = 0;
}
function SOe(e) {
  var r = this.__data__, t = r.delete(e);
  return this.size = r.size, t;
}
function xOe(e) {
  return this.__data__.get(e);
}
function $Oe(e) {
  return this.__data__.has(e);
}
function tv(e) {
  var r = typeof e;
  return e != null && (r == "object" || r == "function");
}
var wOe = "[object AsyncFunction]", _Oe = "[object Function]", TOe = "[object GeneratorFunction]", COe = "[object Proxy]";
function $D(e) {
  if (!tv(e))
    return !1;
  var r = fu(e);
  return r == _Oe || r == TOe || r == wOe || r == COe;
}
var EOe = ui["__core-js_shared__"];
const oS = EOe;
var NI = function() {
  var e = /[^.]+$/.exec(oS && oS.keys && oS.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function AOe(e) {
  return !!NI && NI in e;
}
var IOe = Function.prototype, OOe = IOe.toString;
function hu(e) {
  if (e != null) {
    try {
      return OOe.call(e);
    } catch (r) {
    }
    try {
      return e + "";
    } catch (r) {
    }
  }
  return "";
}
var MOe = /[\\^$.*+?()[\]{}|]/g, ROe = /^\[object .+?Constructor\]$/, POe = Function.prototype, kOe = Object.prototype, jOe = POe.toString, DOe = kOe.hasOwnProperty, NOe = RegExp(
  "^" + jOe.call(DOe).replace(MOe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function LOe(e) {
  if (!tv(e) || AOe(e))
    return !1;
  var r = $D(e) ? NOe : ROe;
  return r.test(hu(e));
}
function FOe(e, r) {
  return e == null ? void 0 : e[r];
}
function pu(e, r) {
  var t = FOe(e, r);
  return LOe(t) ? t : void 0;
}
var zOe = pu(ui, "Map");
const Ef = zOe;
var BOe = pu(Object, "create");
const Af = BOe;
function UOe() {
  this.__data__ = Af ? Af(null) : {}, this.size = 0;
}
function VOe(e) {
  var r = this.has(e) && delete this.__data__[e];
  return this.size -= r ? 1 : 0, r;
}
var WOe = "__lodash_hash_undefined__", HOe = Object.prototype, GOe = HOe.hasOwnProperty;
function YOe(e) {
  var r = this.__data__;
  if (Af) {
    var t = r[e];
    return t === WOe ? void 0 : t;
  }
  return GOe.call(r, e) ? r[e] : void 0;
}
var KOe = Object.prototype, ZOe = KOe.hasOwnProperty;
function qOe(e) {
  var r = this.__data__;
  return Af ? r[e] !== void 0 : ZOe.call(r, e);
}
var QOe = "__lodash_hash_undefined__";
function XOe(e, r) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = Af && r === void 0 ? QOe : r, this;
}
function ou(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
ou.prototype.clear = UOe;
ou.prototype.delete = VOe;
ou.prototype.get = YOe;
ou.prototype.has = qOe;
ou.prototype.set = XOe;
function JOe() {
  this.size = 0, this.__data__ = {
    hash: new ou(),
    map: new (Ef || Ui)(),
    string: new ou()
  };
}
function eMe(e) {
  var r = typeof e;
  return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? e !== "__proto__" : e === null;
}
function mm(e, r) {
  var t = e.__data__;
  return eMe(r) ? t[typeof r == "string" ? "string" : "hash"] : t.map;
}
function rMe(e) {
  var r = mm(this, e).delete(e);
  return this.size -= r ? 1 : 0, r;
}
function tMe(e) {
  return mm(this, e).get(e);
}
function nMe(e) {
  return mm(this, e).has(e);
}
function aMe(e, r) {
  var t = mm(this, e), n = t.size;
  return t.set(e, r), this.size += t.size == n ? 0 : 1, this;
}
function Gs(e) {
  var r = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++r < t; ) {
    var n = e[r];
    this.set(n[0], n[1]);
  }
}
Gs.prototype.clear = JOe;
Gs.prototype.delete = rMe;
Gs.prototype.get = tMe;
Gs.prototype.has = nMe;
Gs.prototype.set = aMe;
var oMe = 200;
function iMe(e, r) {
  var t = this.__data__;
  if (t instanceof Ui) {
    var n = t.__data__;
    if (!Ef || n.length < oMe - 1)
      return n.push([e, r]), this.size = ++t.size, this;
    t = this.__data__ = new Gs(n);
  }
  return t.set(e, r), this.size = t.size, this;
}
function Nc(e) {
  var r = this.__data__ = new Ui(e);
  this.size = r.size;
}
Nc.prototype.clear = yOe;
Nc.prototype.delete = SOe;
Nc.prototype.get = xOe;
Nc.prototype.has = $Oe;
Nc.prototype.set = iMe;
function sMe(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length; ++t < n && r(e[t], t, e) !== !1; )
    ;
  return e;
}
var lMe = function() {
  try {
    var e = pu(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (r) {
  }
}();
const LI = lMe;
function wD(e, r, t) {
  r == "__proto__" && LI ? LI(e, r, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[r] = t;
}
var uMe = Object.prototype, cMe = uMe.hasOwnProperty;
function _D(e, r, t) {
  var n = e[r];
  (!(cMe.call(e, r) && xD(n, t)) || t === void 0 && !(r in e)) && wD(e, r, t);
}
function bm(e, r, t, n) {
  var a = !t;
  t || (t = {});
  for (var i = -1, l = r.length; ++i < l; ) {
    var u = r[i], c = n ? n(t[u], e[u], u, t, e) : void 0;
    c === void 0 && (c = e[u]), a ? wD(t, u, c) : _D(t, u, c);
  }
  return t;
}
function dMe(e, r) {
  for (var t = -1, n = Array(e); ++t < e; )
    n[t] = r(t);
  return n;
}
var fMe = "[object Arguments]";
function FI(e) {
  return vu(e) && fu(e) == fMe;
}
var TD = Object.prototype, vMe = TD.hasOwnProperty, hMe = TD.propertyIsEnumerable, pMe = FI(function() {
  return arguments;
}()) ? FI : function(e) {
  return vu(e) && vMe.call(e, "callee") && !hMe.call(e, "callee");
};
const gMe = pMe;
var mMe = Array.isArray;
const nv = mMe;
function bMe() {
  return !1;
}
var CD = typeof exports == "object" && exports && !exports.nodeType && exports, zI = CD && typeof module == "object" && module && !module.nodeType && module, yMe = zI && zI.exports === CD, BI = yMe ? ui.Buffer : void 0, SMe = BI ? BI.isBuffer : void 0, xMe = SMe || bMe;
const ED = xMe;
var $Me = 9007199254740991, wMe = /^(?:0|[1-9]\d*)$/;
function _Me(e, r) {
  var t = typeof e;
  return r = r == null ? $Me : r, !!r && (t == "number" || t != "symbol" && wMe.test(e)) && e > -1 && e % 1 == 0 && e < r;
}
var TMe = 9007199254740991;
function AD(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= TMe;
}
var CMe = "[object Arguments]", EMe = "[object Array]", AMe = "[object Boolean]", IMe = "[object Date]", OMe = "[object Error]", MMe = "[object Function]", RMe = "[object Map]", PMe = "[object Number]", kMe = "[object Object]", jMe = "[object RegExp]", DMe = "[object Set]", NMe = "[object String]", LMe = "[object WeakMap]", FMe = "[object ArrayBuffer]", zMe = "[object DataView]", BMe = "[object Float32Array]", UMe = "[object Float64Array]", VMe = "[object Int8Array]", WMe = "[object Int16Array]", HMe = "[object Int32Array]", GMe = "[object Uint8Array]", YMe = "[object Uint8ClampedArray]", KMe = "[object Uint16Array]", ZMe = "[object Uint32Array]", ut = {};
ut[BMe] = ut[UMe] = ut[VMe] = ut[WMe] = ut[HMe] = ut[GMe] = ut[YMe] = ut[KMe] = ut[ZMe] = !0;
ut[CMe] = ut[EMe] = ut[FMe] = ut[AMe] = ut[zMe] = ut[IMe] = ut[OMe] = ut[MMe] = ut[RMe] = ut[PMe] = ut[kMe] = ut[jMe] = ut[DMe] = ut[NMe] = ut[LMe] = !1;
function qMe(e) {
  return vu(e) && AD(e.length) && !!ut[fu(e)];
}
function $_(e) {
  return function(r) {
    return e(r);
  };
}
var ID = typeof exports == "object" && exports && !exports.nodeType && exports, Kd = ID && typeof module == "object" && module && !module.nodeType && module, QMe = Kd && Kd.exports === ID, iS = QMe && mD.process, XMe = function() {
  try {
    var e = Kd && Kd.require && Kd.require("util").types;
    return e || iS && iS.binding && iS.binding("util");
  } catch (r) {
  }
}();
const xc = XMe;
var UI = xc && xc.isTypedArray, JMe = UI ? $_(UI) : qMe;
const eRe = JMe;
var rRe = Object.prototype, tRe = rRe.hasOwnProperty;
function OD(e, r) {
  var t = nv(e), n = !t && gMe(e), a = !t && !n && ED(e), i = !t && !n && !a && eRe(e), l = t || n || a || i, u = l ? dMe(e.length, String) : [], c = u.length;
  for (var f in e)
    (r || tRe.call(e, f)) && !(l && // Safari 9 has enumerable `arguments.length` in strict mode.
    (f == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    a && (f == "offset" || f == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (f == "buffer" || f == "byteLength" || f == "byteOffset") || // Skip index properties.
    _Me(f, c))) && u.push(f);
  return u;
}
var nRe = Object.prototype;
function w_(e) {
  var r = e && e.constructor, t = typeof r == "function" && r.prototype || nRe;
  return e === t;
}
var aRe = yD(Object.keys, Object);
const oRe = aRe;
var iRe = Object.prototype, sRe = iRe.hasOwnProperty;
function lRe(e) {
  if (!w_(e))
    return oRe(e);
  var r = [];
  for (var t in Object(e))
    sRe.call(e, t) && t != "constructor" && r.push(t);
  return r;
}
function MD(e) {
  return e != null && AD(e.length) && !$D(e);
}
function __(e) {
  return MD(e) ? OD(e) : lRe(e);
}
function uRe(e, r) {
  return e && bm(r, __(r), e);
}
function cRe(e) {
  var r = [];
  if (e != null)
    for (var t in Object(e))
      r.push(t);
  return r;
}
var dRe = Object.prototype, fRe = dRe.hasOwnProperty;
function vRe(e) {
  if (!tv(e))
    return cRe(e);
  var r = w_(e), t = [];
  for (var n in e)
    n == "constructor" && (r || !fRe.call(e, n)) || t.push(n);
  return t;
}
function T_(e) {
  return MD(e) ? OD(e, !0) : vRe(e);
}
function hRe(e, r) {
  return e && bm(r, T_(r), e);
}
var RD = typeof exports == "object" && exports && !exports.nodeType && exports, VI = RD && typeof module == "object" && module && !module.nodeType && module, pRe = VI && VI.exports === RD, WI = pRe ? ui.Buffer : void 0, HI = WI ? WI.allocUnsafe : void 0;
function gRe(e, r) {
  if (r)
    return e.slice();
  var t = e.length, n = HI ? HI(t) : new e.constructor(t);
  return e.copy(n), n;
}
function PD(e, r) {
  var t = -1, n = e.length;
  for (r || (r = Array(n)); ++t < n; )
    r[t] = e[t];
  return r;
}
function mRe(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = 0, i = []; ++t < n; ) {
    var l = e[t];
    r(l, t, e) && (i[a++] = l);
  }
  return i;
}
function kD() {
  return [];
}
var bRe = Object.prototype, yRe = bRe.propertyIsEnumerable, GI = Object.getOwnPropertySymbols, SRe = GI ? function(e) {
  return e == null ? [] : (e = Object(e), mRe(GI(e), function(r) {
    return yRe.call(e, r);
  }));
} : kD;
const C_ = SRe;
function xRe(e, r) {
  return bm(e, C_(e), r);
}
function jD(e, r) {
  for (var t = -1, n = r.length, a = e.length; ++t < n; )
    e[a + t] = r[t];
  return e;
}
var $Re = Object.getOwnPropertySymbols, wRe = $Re ? function(e) {
  for (var r = []; e; )
    jD(r, C_(e)), e = x_(e);
  return r;
} : kD;
const DD = wRe;
function _Re(e, r) {
  return bm(e, DD(e), r);
}
function ND(e, r, t) {
  var n = r(e);
  return nv(e) ? n : jD(n, t(e));
}
function TRe(e) {
  return ND(e, __, C_);
}
function CRe(e) {
  return ND(e, T_, DD);
}
var ERe = pu(ui, "DataView");
const g2 = ERe;
var ARe = pu(ui, "Promise");
const m2 = ARe;
var IRe = pu(ui, "Set");
const b2 = IRe;
var ORe = pu(ui, "WeakMap");
const y2 = ORe;
var YI = "[object Map]", MRe = "[object Object]", KI = "[object Promise]", ZI = "[object Set]", qI = "[object WeakMap]", QI = "[object DataView]", RRe = hu(g2), PRe = hu(Ef), kRe = hu(m2), jRe = hu(b2), DRe = hu(y2), Il = fu;
(g2 && Il(new g2(new ArrayBuffer(1))) != QI || Ef && Il(new Ef()) != YI || m2 && Il(m2.resolve()) != KI || b2 && Il(new b2()) != ZI || y2 && Il(new y2()) != qI) && (Il = function(e) {
  var r = fu(e), t = r == MRe ? e.constructor : void 0, n = t ? hu(t) : "";
  if (n)
    switch (n) {
      case RRe:
        return QI;
      case PRe:
        return YI;
      case kRe:
        return KI;
      case jRe:
        return ZI;
      case DRe:
        return qI;
    }
  return r;
});
const E_ = Il;
var NRe = Object.prototype, LRe = NRe.hasOwnProperty;
function FRe(e) {
  var r = e.length, t = new e.constructor(r);
  return r && typeof e[0] == "string" && LRe.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var zRe = ui.Uint8Array;
const XI = zRe;
function A_(e) {
  var r = new e.constructor(e.byteLength);
  return new XI(r).set(new XI(e)), r;
}
function BRe(e, r) {
  var t = r ? A_(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var URe = /\w*$/;
function VRe(e) {
  var r = new e.constructor(e.source, URe.exec(e));
  return r.lastIndex = e.lastIndex, r;
}
var JI = Fs ? Fs.prototype : void 0, eO = JI ? JI.valueOf : void 0;
function WRe(e) {
  return eO ? Object(eO.call(e)) : {};
}
function HRe(e, r) {
  var t = r ? A_(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var GRe = "[object Boolean]", YRe = "[object Date]", KRe = "[object Map]", ZRe = "[object Number]", qRe = "[object RegExp]", QRe = "[object Set]", XRe = "[object String]", JRe = "[object Symbol]", ePe = "[object ArrayBuffer]", rPe = "[object DataView]", tPe = "[object Float32Array]", nPe = "[object Float64Array]", aPe = "[object Int8Array]", oPe = "[object Int16Array]", iPe = "[object Int32Array]", sPe = "[object Uint8Array]", lPe = "[object Uint8ClampedArray]", uPe = "[object Uint16Array]", cPe = "[object Uint32Array]";
function dPe(e, r, t) {
  var n = e.constructor;
  switch (r) {
    case ePe:
      return A_(e);
    case GRe:
    case YRe:
      return new n(+e);
    case rPe:
      return BRe(e, t);
    case tPe:
    case nPe:
    case aPe:
    case oPe:
    case iPe:
    case sPe:
    case lPe:
    case uPe:
    case cPe:
      return HRe(e, t);
    case KRe:
      return new n();
    case ZRe:
    case XRe:
      return new n(e);
    case qRe:
      return VRe(e);
    case QRe:
      return new n();
    case JRe:
      return WRe(e);
  }
}
var rO = Object.create, fPe = function() {
  function e() {
  }
  return function(r) {
    if (!tv(r))
      return {};
    if (rO)
      return rO(r);
    e.prototype = r;
    var t = new e();
    return e.prototype = void 0, t;
  };
}();
const vPe = fPe;
function hPe(e) {
  return typeof e.constructor == "function" && !w_(e) ? vPe(x_(e)) : {};
}
var pPe = "[object Map]";
function gPe(e) {
  return vu(e) && E_(e) == pPe;
}
var tO = xc && xc.isMap, mPe = tO ? $_(tO) : gPe;
const bPe = mPe;
var yPe = "[object Set]";
function SPe(e) {
  return vu(e) && E_(e) == yPe;
}
var nO = xc && xc.isSet, xPe = nO ? $_(nO) : SPe;
const $Pe = xPe;
var wPe = 1, _Pe = 2, TPe = 4, LD = "[object Arguments]", CPe = "[object Array]", EPe = "[object Boolean]", APe = "[object Date]", IPe = "[object Error]", FD = "[object Function]", OPe = "[object GeneratorFunction]", MPe = "[object Map]", RPe = "[object Number]", zD = "[object Object]", PPe = "[object RegExp]", kPe = "[object Set]", jPe = "[object String]", DPe = "[object Symbol]", NPe = "[object WeakMap]", LPe = "[object ArrayBuffer]", FPe = "[object DataView]", zPe = "[object Float32Array]", BPe = "[object Float64Array]", UPe = "[object Int8Array]", VPe = "[object Int16Array]", WPe = "[object Int32Array]", HPe = "[object Uint8Array]", GPe = "[object Uint8ClampedArray]", YPe = "[object Uint16Array]", KPe = "[object Uint32Array]", tt = {};
tt[LD] = tt[CPe] = tt[LPe] = tt[FPe] = tt[EPe] = tt[APe] = tt[zPe] = tt[BPe] = tt[UPe] = tt[VPe] = tt[WPe] = tt[MPe] = tt[RPe] = tt[zD] = tt[PPe] = tt[kPe] = tt[jPe] = tt[DPe] = tt[HPe] = tt[GPe] = tt[YPe] = tt[KPe] = !0;
tt[IPe] = tt[FD] = tt[NPe] = !1;
function Vp(e, r, t, n, a, i) {
  var l, u = r & wPe, c = r & _Pe, f = r & TPe;
  if (t && (l = a ? t(e, n, a, i) : t(e)), l !== void 0)
    return l;
  if (!tv(e))
    return e;
  var h = nv(e);
  if (h) {
    if (l = FRe(e), !u)
      return PD(e, l);
  } else {
    var p = E_(e), g = p == FD || p == OPe;
    if (ED(e))
      return gRe(e, u);
    if (p == zD || p == LD || g && !a) {
      if (l = c || g ? {} : hPe(e), !u)
        return c ? _Re(e, hRe(l, e)) : xRe(e, uRe(l, e));
    } else {
      if (!tt[p])
        return a ? e : {};
      l = dPe(e, p, u);
    }
  }
  i || (i = new Nc());
  var y = i.get(e);
  if (y)
    return y;
  i.set(e, l), $Pe(e) ? e.forEach(function(_) {
    l.add(Vp(_, r, t, _, e, i));
  }) : bPe(e) && e.forEach(function(_, A) {
    l.set(A, Vp(_, r, t, A, e, i));
  });
  var S = f ? c ? CRe : TRe : c ? T_ : __, x = h ? void 0 : S(e);
  return sMe(x || e, function(_, A) {
    x && (A = _, _ = e[A]), _D(l, A, Vp(_, r, t, A, e, i));
  }), l;
}
var ZPe = 4;
function aO(e) {
  return Vp(e, ZPe);
}
function BD(e, r) {
  for (var t = -1, n = e == null ? 0 : e.length, a = Array(n); ++t < n; )
    a[t] = r(e[t], t, e);
  return a;
}
var qPe = "[object Symbol]";
function I_(e) {
  return typeof e == "symbol" || vu(e) && fu(e) == qPe;
}
var QPe = "Expected a function";
function O_(e, r) {
  if (typeof e != "function" || r != null && typeof r != "function")
    throw new TypeError(QPe);
  var t = function() {
    var n = arguments, a = r ? r.apply(this, n) : n[0], i = t.cache;
    if (i.has(a))
      return i.get(a);
    var l = e.apply(this, n);
    return t.cache = i.set(a, l) || i, l;
  };
  return t.cache = new (O_.Cache || Gs)(), t;
}
O_.Cache = Gs;
var XPe = 500;
function JPe(e) {
  var r = O_(e, function(n) {
    return t.size === XPe && t.clear(), n;
  }), t = r.cache;
  return r;
}
var eke = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, rke = /\\(\\)?/g, tke = JPe(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(eke, function(t, n, a, i) {
    r.push(a ? i.replace(rke, "$1") : n || t);
  }), r;
});
const nke = tke;
var ake = 1 / 0;
function oke(e) {
  if (typeof e == "string" || I_(e))
    return e;
  var r = e + "";
  return r == "0" && 1 / e == -ake ? "-0" : r;
}
var ike = 1 / 0, oO = Fs ? Fs.prototype : void 0, iO = oO ? oO.toString : void 0;
function UD(e) {
  if (typeof e == "string")
    return e;
  if (nv(e))
    return BD(e, UD) + "";
  if (I_(e))
    return iO ? iO.call(e) : "";
  var r = e + "";
  return r == "0" && 1 / e == -ike ? "-0" : r;
}
function ske(e) {
  return e == null ? "" : UD(e);
}
function VD(e) {
  return nv(e) ? BD(e, oke) : I_(e) ? [e] : PD(nke(ske(e)));
}
function Ht() {
  return Ht = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ht.apply(this, arguments);
}
function WD(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var ym = /* @__PURE__ */ On(void 0);
ym.displayName = "FormikContext";
ym.Provider;
ym.Consumer;
function lke() {
  var e = zr(ym);
  return e || dOe(!1), e;
}
var ho = function(r) {
  return typeof r == "function";
}, Sm = function(r) {
  return r !== null && typeof r == "object";
}, uke = function(r) {
  return String(Math.floor(Number(r))) === r;
}, sS = function(r) {
  return Object.prototype.toString.call(r) === "[object String]";
}, lS = function(r) {
  return Sm(r) && ho(r.then);
};
function fa(e, r, t, n) {
  n === void 0 && (n = 0);
  for (var a = VD(r); e && n < a.length; )
    e = e[a[n++]];
  return n !== a.length && !e || e === void 0 ? t : e;
}
function eu(e, r, t) {
  for (var n = aO(e), a = n, i = 0, l = VD(r); i < l.length - 1; i++) {
    var u = l[i], c = fa(e, l.slice(0, i + 1));
    if (c && (Sm(c) || Array.isArray(c)))
      a = a[u] = aO(c);
    else {
      var f = l[i + 1];
      a = a[u] = uke(f) && Number(f) >= 0 ? [] : {};
    }
  }
  return (i === 0 ? e : a)[l[i]] === t ? e : (t === void 0 ? delete a[l[i]] : a[l[i]] = t, i === 0 && t === void 0 && delete n[l[i]], n);
}
function HD(e, r, t, n) {
  t === void 0 && (t = /* @__PURE__ */ new WeakMap()), n === void 0 && (n = {});
  for (var a = 0, i = Object.keys(e); a < i.length; a++) {
    var l = i[a], u = e[l];
    Sm(u) ? t.get(u) || (t.set(u, !0), n[l] = Array.isArray(u) ? [] : {}, HD(u, r, t, n[l])) : n[l] = r;
  }
  return n;
}
function cke(e, r) {
  switch (r.type) {
    case "SET_VALUES":
      return Ht({}, e, {
        values: r.payload
      });
    case "SET_TOUCHED":
      return Ht({}, e, {
        touched: r.payload
      });
    case "SET_ERRORS":
      return Al(e.errors, r.payload) ? e : Ht({}, e, {
        errors: r.payload
      });
    case "SET_STATUS":
      return Ht({}, e, {
        status: r.payload
      });
    case "SET_ISSUBMITTING":
      return Ht({}, e, {
        isSubmitting: r.payload
      });
    case "SET_ISVALIDATING":
      return Ht({}, e, {
        isValidating: r.payload
      });
    case "SET_FIELD_VALUE":
      return Ht({}, e, {
        values: eu(e.values, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return Ht({}, e, {
        touched: eu(e.touched, r.payload.field, r.payload.value)
      });
    case "SET_FIELD_ERROR":
      return Ht({}, e, {
        errors: eu(e.errors, r.payload.field, r.payload.value)
      });
    case "RESET_FORM":
      return Ht({}, e, r.payload);
    case "SET_FORMIK_STATE":
      return r.payload(e);
    case "SUBMIT_ATTEMPT":
      return Ht({}, e, {
        touched: HD(e.values, !0),
        isSubmitting: !0,
        submitCount: e.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return Ht({}, e, {
        isSubmitting: !1
      });
    case "SUBMIT_SUCCESS":
      return Ht({}, e, {
        isSubmitting: !1
      });
    default:
      return e;
  }
}
var Cl = {}, op = {};
function GD(e) {
  var r = e.validateOnChange, t = r === void 0 ? !0 : r, n = e.validateOnBlur, a = n === void 0 ? !0 : n, i = e.validateOnMount, l = i === void 0 ? !1 : i, u = e.isInitialValid, c = e.enableReinitialize, f = c === void 0 ? !1 : c, h = e.onSubmit, p = WD(e, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]), g = Ht({
    validateOnChange: t,
    validateOnBlur: a,
    validateOnMount: l,
    onSubmit: h
  }, p), y = Qe(g.initialValues), S = Qe(g.initialErrors || Cl), x = Qe(g.initialTouched || op), _ = Qe(g.initialStatus), A = Qe(!1), O = Qe({});
  ar(function() {
    return A.current = !0, function() {
      A.current = !1;
    };
  }, []);
  var P = Ye(0), j = P[1], k = Qe({
    values: g.initialValues,
    errors: g.initialErrors || Cl,
    touched: g.initialTouched || op,
    status: g.initialStatus,
    isSubmitting: !1,
    isValidating: !1,
    submitCount: 0
  }), L = k.current, M = Ne(function(G) {
    var te = k.current;
    k.current = cke(te, G), te !== k.current && j(function(Y) {
      return Y + 1;
    });
  }, []), W = Ne(function(G, te) {
    return new Promise(function(Y, Q) {
      var Ce = g.validate(G, te);
      Ce == null ? Y(Cl) : lS(Ce) ? Ce.then(function(me) {
        Y(me || Cl);
      }, function(me) {
        Q(me);
      }) : Y(Ce);
    });
  }, [g.validate]), Z = Ne(function(G, te) {
    var Y = g.validationSchema, Q = ho(Y) ? Y(te) : Y, Ce = te && Q.validateAt ? Q.validateAt(te, G) : fke(G, Q);
    return new Promise(function(me, Re) {
      Ce.then(function() {
        me(Cl);
      }, function(ur) {
        ur.name === "ValidationError" ? me(dke(ur)) : Re(ur);
      });
    });
  }, [g.validationSchema]), oe = Ne(function(G, te) {
    return new Promise(function(Y) {
      return Y(O.current[G].validate(te));
    });
  }, []), Ie = Ne(function(G) {
    var te = Object.keys(O.current).filter(function(Q) {
      return ho(O.current[Q].validate);
    }), Y = te.length > 0 ? te.map(function(Q) {
      return oe(Q, fa(G, Q));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(Y).then(function(Q) {
      return Q.reduce(function(Ce, me, Re) {
        return me === "DO_NOT_DELETE_YOU_WILL_BE_FIRED" || me && (Ce = eu(Ce, te[Re], me)), Ce;
      }, {});
    });
  }, [oe]), Te = Ne(function(G) {
    return Promise.all([Ie(G), g.validationSchema ? Z(G) : {}, g.validate ? W(G) : {}]).then(function(te) {
      var Y = te[0], Q = te[1], Ce = te[2], me = h2.all([Y, Q, Ce], {
        arrayMerge: vke
      });
      return me;
    });
  }, [g.validate, g.validationSchema, Ie, W, Z]), Ee = ka(function(G) {
    return G === void 0 && (G = L.values), M({
      type: "SET_ISVALIDATING",
      payload: !0
    }), Te(G).then(function(te) {
      return A.current && (M({
        type: "SET_ISVALIDATING",
        payload: !1
      }), M({
        type: "SET_ERRORS",
        payload: te
      })), te;
    });
  });
  ar(function() {
    l && A.current === !0 && Al(y.current, g.initialValues) && Ee(y.current);
  }, [l, Ee]);
  var Me = Ne(function(G) {
    var te = G && G.values ? G.values : y.current, Y = G && G.errors ? G.errors : S.current ? S.current : g.initialErrors || {}, Q = G && G.touched ? G.touched : x.current ? x.current : g.initialTouched || {}, Ce = G && G.status ? G.status : _.current ? _.current : g.initialStatus;
    y.current = te, S.current = Y, x.current = Q, _.current = Ce;
    var me = function() {
      M({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!G && !!G.isSubmitting,
          errors: Y,
          touched: Q,
          status: Ce,
          values: te,
          isValidating: !!G && !!G.isValidating,
          submitCount: G && G.submitCount && typeof G.submitCount == "number" ? G.submitCount : 0
        }
      });
    };
    if (g.onReset) {
      var Re = g.onReset(L.values, Je);
      lS(Re) ? Re.then(me) : me();
    } else
      me();
  }, [g.initialErrors, g.initialStatus, g.initialTouched, g.onReset]);
  ar(function() {
    A.current === !0 && !Al(y.current, g.initialValues) && f && (y.current = g.initialValues, Me(), l && Ee(y.current));
  }, [f, g.initialValues, Me, l, Ee]), ar(function() {
    f && A.current === !0 && !Al(S.current, g.initialErrors) && (S.current = g.initialErrors || Cl, M({
      type: "SET_ERRORS",
      payload: g.initialErrors || Cl
    }));
  }, [f, g.initialErrors]), ar(function() {
    f && A.current === !0 && !Al(x.current, g.initialTouched) && (x.current = g.initialTouched || op, M({
      type: "SET_TOUCHED",
      payload: g.initialTouched || op
    }));
  }, [f, g.initialTouched]), ar(function() {
    f && A.current === !0 && !Al(_.current, g.initialStatus) && (_.current = g.initialStatus, M({
      type: "SET_STATUS",
      payload: g.initialStatus
    }));
  }, [f, g.initialStatus, g.initialTouched]);
  var Fe = ka(function(G) {
    if (O.current[G] && ho(O.current[G].validate)) {
      var te = fa(L.values, G), Y = O.current[G].validate(te);
      return lS(Y) ? (M({
        type: "SET_ISVALIDATING",
        payload: !0
      }), Y.then(function(Q) {
        return Q;
      }).then(function(Q) {
        M({
          type: "SET_FIELD_ERROR",
          payload: {
            field: G,
            value: Q
          }
        }), M({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      })) : (M({
        type: "SET_FIELD_ERROR",
        payload: {
          field: G,
          value: Y
        }
      }), Promise.resolve(Y));
    } else if (g.validationSchema)
      return M({
        type: "SET_ISVALIDATING",
        payload: !0
      }), Z(L.values, G).then(function(Q) {
        return Q;
      }).then(function(Q) {
        M({
          type: "SET_FIELD_ERROR",
          payload: {
            field: G,
            value: fa(Q, G)
          }
        }), M({
          type: "SET_ISVALIDATING",
          payload: !1
        });
      });
    return Promise.resolve();
  }), Ge = Ne(function(G, te) {
    var Y = te.validate;
    O.current[G] = {
      validate: Y
    };
  }, []), ze = Ne(function(G) {
    delete O.current[G];
  }, []), le = ka(function(G, te) {
    M({
      type: "SET_TOUCHED",
      payload: G
    });
    var Y = te === void 0 ? a : te;
    return Y ? Ee(L.values) : Promise.resolve();
  }), ce = Ne(function(G) {
    M({
      type: "SET_ERRORS",
      payload: G
    });
  }, []), he = ka(function(G, te) {
    var Y = ho(G) ? G(L.values) : G;
    M({
      type: "SET_VALUES",
      payload: Y
    });
    var Q = te === void 0 ? t : te;
    return Q ? Ee(Y) : Promise.resolve();
  }), be = Ne(function(G, te) {
    M({
      type: "SET_FIELD_ERROR",
      payload: {
        field: G,
        value: te
      }
    });
  }, []), ye = ka(function(G, te, Y) {
    M({
      type: "SET_FIELD_VALUE",
      payload: {
        field: G,
        value: te
      }
    });
    var Q = Y === void 0 ? t : Y;
    return Q ? Ee(eu(L.values, G, te)) : Promise.resolve();
  }), q = Ne(function(G, te) {
    var Y = te, Q = G, Ce;
    if (!sS(G)) {
      G.persist && G.persist();
      var me = G.target ? G.target : G.currentTarget, Re = me.type, ur = me.name, Sr = me.id, lr = me.value, ct = me.checked, at = me.outerHTML, mt = me.options, Ct = me.multiple;
      Y = te || ur || Sr, Q = /number|range/.test(Re) ? (Ce = parseFloat(lr), isNaN(Ce) ? "" : Ce) : /checkbox/.test(Re) ? pke(fa(L.values, Y), ct, lr) : mt && Ct ? hke(mt) : lr;
    }
    Y && ye(Y, Q);
  }, [ye, L.values]), ae = ka(function(G) {
    if (sS(G))
      return function(te) {
        return q(te, G);
      };
    q(G);
  }), ue = ka(function(G, te, Y) {
    te === void 0 && (te = !0), M({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field: G,
        value: te
      }
    });
    var Q = Y === void 0 ? a : Y;
    return Q ? Ee(L.values) : Promise.resolve();
  }), $e = Ne(function(G, te) {
    G.persist && G.persist();
    var Y = G.target, Q = Y.name, Ce = Y.id, me = Y.outerHTML, Re = te || Q || Ce;
    ue(Re, !0);
  }, [ue]), Ze = ka(function(G) {
    if (sS(G))
      return function(te) {
        return $e(te, G);
      };
    $e(G);
  }), _e = Ne(function(G) {
    ho(G) ? M({
      type: "SET_FORMIK_STATE",
      payload: G
    }) : M({
      type: "SET_FORMIK_STATE",
      payload: function() {
        return G;
      }
    });
  }, []), or = Ne(function(G) {
    M({
      type: "SET_STATUS",
      payload: G
    });
  }, []), Yr = Ne(function(G) {
    M({
      type: "SET_ISSUBMITTING",
      payload: G
    });
  }, []), mr = ka(function() {
    return M({
      type: "SUBMIT_ATTEMPT"
    }), Ee().then(function(G) {
      var te = G instanceof Error, Y = !te && Object.keys(G).length === 0;
      if (Y) {
        var Q;
        try {
          if (Q = Ir(), Q === void 0)
            return;
        } catch (Ce) {
          throw Ce;
        }
        return Promise.resolve(Q).then(function(Ce) {
          return A.current && M({
            type: "SUBMIT_SUCCESS"
          }), Ce;
        }).catch(function(Ce) {
          if (A.current)
            throw M({
              type: "SUBMIT_FAILURE"
            }), Ce;
        });
      } else if (A.current && (M({
        type: "SUBMIT_FAILURE"
      }), te))
        throw G;
    });
  }), rt = ka(function(G) {
    G && G.preventDefault && ho(G.preventDefault) && G.preventDefault(), G && G.stopPropagation && ho(G.stopPropagation) && G.stopPropagation(), mr().catch(function(te) {
      console.warn("Warning: An unhandled error was caught from submitForm()", te);
    });
  }), Je = {
    resetForm: Me,
    validateForm: Ee,
    validateField: Fe,
    setErrors: ce,
    setFieldError: be,
    setFieldTouched: ue,
    setFieldValue: ye,
    setStatus: or,
    setSubmitting: Yr,
    setTouched: le,
    setValues: he,
    setFormikState: _e,
    submitForm: mr
  }, Ir = ka(function() {
    return h(L.values, Je);
  }), wt = ka(function(G) {
    G && G.preventDefault && ho(G.preventDefault) && G.preventDefault(), G && G.stopPropagation && ho(G.stopPropagation) && G.stopPropagation(), Me();
  }), Kr = Ne(function(G) {
    return {
      value: fa(L.values, G),
      error: fa(L.errors, G),
      touched: !!fa(L.touched, G),
      initialValue: fa(y.current, G),
      initialTouched: !!fa(x.current, G),
      initialError: fa(S.current, G)
    };
  }, [L.errors, L.touched, L.values]), jr = Ne(function(G) {
    return {
      setValue: function(Y, Q) {
        return ye(G, Y, Q);
      },
      setTouched: function(Y, Q) {
        return ue(G, Y, Q);
      },
      setError: function(Y) {
        return be(G, Y);
      }
    };
  }, [ye, ue, be]), jt = Ne(function(G) {
    var te = Sm(G), Y = te ? G.name : G, Q = fa(L.values, Y), Ce = {
      name: Y,
      value: Q,
      onChange: ae,
      onBlur: Ze
    };
    if (te) {
      var me = G.type, Re = G.value, ur = G.as, Sr = G.multiple;
      me === "checkbox" ? Re === void 0 ? Ce.checked = !!Q : (Ce.checked = !!(Array.isArray(Q) && ~Q.indexOf(Re)), Ce.value = Re) : me === "radio" ? (Ce.checked = Q === Re, Ce.value = Re) : ur === "select" && Sr && (Ce.value = Ce.value || [], Ce.multiple = !0);
    }
    return Ce;
  }, [Ze, ae, L.values]), gt = Rt(function() {
    return !Al(y.current, L.values);
  }, [y.current, L.values]), pr = Rt(function() {
    return typeof u != "undefined" ? gt ? L.errors && Object.keys(L.errors).length === 0 : u !== !1 && ho(u) ? u(g) : u : L.errors && Object.keys(L.errors).length === 0;
  }, [u, gt, L.errors, g]), br = Ht({}, L, {
    initialValues: y.current,
    initialErrors: S.current,
    initialTouched: x.current,
    initialStatus: _.current,
    handleBlur: Ze,
    handleChange: ae,
    handleReset: wt,
    handleSubmit: rt,
    resetForm: Me,
    setErrors: ce,
    setFormikState: _e,
    setFieldTouched: ue,
    setFieldValue: ye,
    setFieldError: be,
    setStatus: or,
    setSubmitting: Yr,
    setTouched: le,
    setValues: he,
    submitForm: mr,
    validateForm: Ee,
    validateField: Fe,
    isValid: pr,
    dirty: gt,
    unregisterField: ze,
    registerField: Ge,
    getFieldProps: jt,
    getFieldMeta: Kr,
    getFieldHelpers: jr,
    validateOnBlur: a,
    validateOnChange: t,
    validateOnMount: l
  });
  return br;
}
function dke(e) {
  var r = {};
  if (e.inner) {
    if (e.inner.length === 0)
      return eu(r, e.path, e.message);
    for (var a = e.inner, t = Array.isArray(a), n = 0, a = t ? a : a[Symbol.iterator](); ; ) {
      var i;
      if (t) {
        if (n >= a.length)
          break;
        i = a[n++];
      } else {
        if (n = a.next(), n.done)
          break;
        i = n.value;
      }
      var l = i;
      fa(r, l.path) || (r = eu(r, l.path, l.message));
    }
  }
  return r;
}
function fke(e, r, t, n) {
  t === void 0 && (t = !1);
  var a = S2(e);
  return r[t ? "validateSync" : "validate"](a, {
    abortEarly: !1,
    context: n || a
  });
}
function S2(e) {
  var r = Array.isArray(e) ? [] : {};
  for (var t in e)
    if (Object.prototype.hasOwnProperty.call(e, t)) {
      var n = String(t);
      Array.isArray(e[n]) === !0 ? r[n] = e[n].map(function(a) {
        return Array.isArray(a) === !0 || kI(a) ? S2(a) : a !== "" ? a : void 0;
      }) : kI(e[n]) ? r[n] = S2(e[n]) : r[n] = e[n] !== "" ? e[n] : void 0;
    }
  return r;
}
function vke(e, r, t) {
  var n = e.slice();
  return r.forEach(function(i, l) {
    if (typeof n[l] == "undefined") {
      var u = t.clone !== !1, c = u && t.isMergeableObject(i);
      n[l] = c ? h2(Array.isArray(i) ? [] : {}, i, t) : i;
    } else
      t.isMergeableObject(i) ? n[l] = h2(e[l], i, t) : e.indexOf(i) === -1 && n.push(i);
  }), n;
}
function hke(e) {
  return Array.from(e).filter(function(r) {
    return r.selected;
  }).map(function(r) {
    return r.value;
  });
}
function pke(e, r, t) {
  if (typeof e == "boolean")
    return !!r;
  var n = [], a = !1, i = -1;
  if (Array.isArray(e))
    n = e, i = e.indexOf(t), a = i >= 0;
  else if (!t || t == "true" || t == "false")
    return !!r;
  return r && t && !a ? n.concat(t) : a ? n.slice(0, i).concat(n.slice(i + 1)) : n;
}
var gke = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? $O : ar;
function ka(e) {
  var r = Qe(e);
  return gke(function() {
    r.current = e;
  }), Ne(function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return r.current.apply(void 0, n);
  }, []);
}
var mke = /* @__PURE__ */ W0(function(e, r) {
  var t = e.action, n = WD(e, ["action"]), a = t != null ? t : "#", i = lke(), l = i.handleReset, u = i.handleSubmit;
  return ji("form", Ht({
    onSubmit: u,
    ref: r,
    onReset: l,
    action: a
  }, n));
});
mke.displayName = "Form";
const YD = On(void 0), bke = ({ firstName: e, children: r }) => {
  const t = {
    rating: 0,
    title: "",
    reviewtext: "",
    usernickname: e ? e.replace(/%[0-9]+/g, " ") : "",
    isrecommended: "",
    photos: []
  }, [n, a] = Ye(t), [i, l] = Ye(!1), [u, c] = Ye(!1), f = () => {
    a(t), c(!0);
  };
  return ar(() => {
    a((h) => wi(Xt({}, h), { usernickname: e }));
  }, [e]), ar(() => {
    u && c(!1);
  }, [u]), /* @__PURE__ */ T.jsx(
    YD.Provider,
    {
      value: {
        data: n,
        setData: a,
        requestInProgress: i,
        setRequestInProgress: l,
        resetData: f
      },
      children: u ? "" : r
    }
  );
}, xm = () => {
  const e = zr(YD);
  if (!e)
    throw new Error("useDataContext must be used within a ContextProvider");
  return e;
}, yke = "_enabled_1cdzs_14", ip = {
  "main-button-wrapper": "_main-button-wrapper_1cdzs_2",
  "main-button": "_main-button_1cdzs_2",
  enabled: yke,
  "so-com": "_so-com_1cdzs_18"
}, KD = ({
  handleButtonClick: e,
  label: r = "Continuar",
  disabled: t = !1
}) => {
  const { requestInProgress: n } = xm(), { theme: a, isSodimacStandAlone: i = !1 } = Co();
  return /* @__PURE__ */ T.jsx(an, { className: ip["main-button-wrapper"], children: /* @__PURE__ */ T.jsx(
    Sg,
    {
      size: "lg",
      className: `${ip["main-button"]} ${t ? "" : ip.enabled} ${i ? ip["so-com"] : ""}`,
      disabled: n,
      onClick: e,
      style: { backgroundColor: t ? "" : a.secondary_color },
      children: r
    }
  ) });
};
function sO(e) {
  return e.reduce((r, t) => (r[t.Id] = 0, r), {});
}
const lO = (e, r) => e ? Object.values(e).filter(
  (t) => t.DisplayType === r
) : [], Ske = (e) => {
  const { isOpen: r, onClose: t, onSubmit: n, onBackClick: a, isApp: i } = e, { product: l } = pm(), { data: u, setData: c, requestInProgress: f } = xm(), { secondaryRatingsAverages: h = {} } = Ta(), p = lO(
    h,
    "NORMAL"
  ), g = lO(
    h,
    "SLIDER"
  ), y = sO(p), S = sO(g), x = Xt(Xt({}, S), y), _ = GD({
    initialValues: x,
    onSubmit: (L) => Xr(void 0, null, function* () {
      const M = Xt(Xt({}, u), L);
      c(M), n(M);
    })
  }), { activeModal: A } = R_(), O = () => {
    _.handleSubmit();
  };
  function P(L) {
    return Array.isArray(L) && L.length > 0;
  }
  const j = P(p), k = P(g);
  return /* @__PURE__ */ T.jsxs(y_, { isOpen: r, onClose: t, isApp: i, children: [
    /* @__PURE__ */ T.jsx("div", { slot: "header", children: /* @__PURE__ */ T.jsx(
      m_,
      {
        showBackButton: A === Of.AttributesByCategory,
        onBackClick: a,
        onClose: t
      }
    ) }),
    /* @__PURE__ */ T.jsxs(
      "div",
      {
        className: `${bn["attributes-by-category-form"]} ${bn.content}`,
        children: [
          /* @__PURE__ */ T.jsxs("div", { className: bn["image-and-product-name"], children: [
            /* @__PURE__ */ T.jsx(vD, { product: l, boxSize: "40px", borderRadius: "2px" }),
            /* @__PURE__ */ T.jsx(
              gc,
              {
                className: bn["product-name"],
                children: `${l.brandName} - ${l.name}`
              }
            )
          ] }),
          /* @__PURE__ */ T.jsx("div", { className: bn["first-separator"], children: /* @__PURE__ */ T.jsx(RI, {}) }),
          /* @__PURE__ */ T.jsxs("div", { className: bn.section, children: [
            /* @__PURE__ */ T.jsx(gc, { className: bn.title, children: "¿Cómo evaluarías los siguientes puntos?" }),
            /* @__PURE__ */ T.jsx("div", { className: bn.attributes, children: p && p.length > 0 && p.map((L, M) => /* @__PURE__ */ T.jsxs("div", { className: bn.attribute, children: [
              /* @__PURE__ */ T.jsx("div", { className: bn.name, children: L.Label }),
              /* @__PURE__ */ T.jsx(
                S_,
                {
                  handleRatingClickHook: _.setFieldValue,
                  rating: _.values[L.Id] || 0,
                  fieldName: L.Id
                }
              )
            ] }, M)) })
          ] }),
          j && k && /* @__PURE__ */ T.jsx("div", { style: { margin: "24px 0" }, children: /* @__PURE__ */ T.jsx(RI, {}) }),
          /* @__PURE__ */ T.jsx(T.Fragment, { children: g && g.length > 0 && g.map(
            (L, M) => L.ValueLabel && /* @__PURE__ */ T.jsxs(
              "div",
              {
                className: `${bn.section} ${bn["dots-rating"]}`,
                children: [
                  /* @__PURE__ */ T.jsx("div", { className: bn.title, children: L.Label }),
                  /* @__PURE__ */ T.jsx(
                    dIe,
                    {
                      options: L.ValueLabel,
                      selected: _.values[L.Id],
                      setSelected: _.setFieldValue,
                      fieldName: L.Id
                    }
                  )
                ]
              },
              M
            )
          ) })
        ]
      }
    ),
    /* @__PURE__ */ T.jsx("div", { slot: "footer", children: /* @__PURE__ */ T.jsxs(
      an,
      {
        className: `${bn["footer-by-category-form"]} ${bn["main-button-wrapper"]}`,
        children: [
          /* @__PURE__ */ T.jsx(
            Sg,
            {
              onClick: a,
              className: bn["back-button"],
              variant: "link",
              children: "Volver"
            }
          ),
          /* @__PURE__ */ T.jsx(
            KD,
            {
              handleButtonClick: O,
              label: "Finalizar",
              disabled: f
            }
          )
        ]
      }
    ) })
  ] });
}, xke = "_title_5dey0_13", $ke = "_label_5dey0_67", wke = "_input_5dey0_81", _ke = "_textarea_5dey0_89", Tke = "_warning_5dey0_113", Cke = "_success_5dey0_116", ft = {
  "review-form": "_review-form_5dey0_2",
  "form-header": "_form-header_5dey0_10",
  title: xke,
  "main-header": "_main-header_5dey0_19",
  "title-and-rating": "_title-and-rating_5dey0_34",
  "product-name": "_product-name_5dey0_43",
  "rating-form-control": "_rating-form-control_5dey0_48",
  "form-body": "_form-body_5dey0_58",
  label: $ke,
  input: wke,
  textarea: _ke,
  warning: Tke,
  success: Cke,
  "form-error-message": "_form-error-message_5dey0_119",
  "field-error": "_field-error_5dey0_123",
  "helper-text": "_helper-text_5dey0_126",
  "write-review-custom-footer": "_write-review-custom-footer_5dey0_138",
  "footer-button-wrapper": "_footer-button-wrapper_5dey0_146"
}, Eke = "_checked_h17jf_28", uS = {
  "bv-custom-radio-button": "_bv-custom-radio-button_h17jf_2",
  "bv-recommendation-button": "_bv-recommendation-button_h17jf_14",
  checked: Eke
};
function Ake({
  text: e,
  icon: r,
  isChecked: t,
  onChange: n
}) {
  return /* @__PURE__ */ T.jsxs(an, { className: uS["bv-custom-radio-button"], as: "label", children: [
    /* @__PURE__ */ T.jsx(
      "input",
      {
        type: "radio",
        checked: t,
        onChange: n,
        role: "recommendation-radio-button"
      }
    ),
    /* @__PURE__ */ T.jsxs(
      an,
      {
        className: `${uS["bv-recommendation-button"]} ${t ? uS.checked : ""}`,
        children: [
          e,
          " ",
          t && /* @__PURE__ */ T.jsx("span", { children: r })
        ]
      }
    )
  ] });
}
const Ike = "_wrapper_1o079_1", Oke = {
  wrapper: Ike
};
function Mke({
  value: e,
  setValue: r,
  options: t
}) {
  const n = (a) => {
    r("isrecommended", a);
  };
  return /* @__PURE__ */ T.jsx("div", { className: Oke.wrapper, children: t.map((a) => /* @__PURE__ */ T.jsx(
    Ake,
    {
      text: a.text,
      icon: a.icon,
      isChecked: e === a.value,
      onChange: () => n(a.value)
    },
    a.text
  )) });
}
var Rke = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function av(e, r) {
  var t = Pke(e);
  if (typeof t.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(t, "path", {
      value: typeof r == "string" ? r : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function Pke(e) {
  var r = e.name, t = r && r.lastIndexOf(".") !== -1;
  if (t && !e.type) {
    var n = r.split(".").pop().toLowerCase(), a = Rke.get(n);
    a && Object.defineProperty(e, "type", {
      value: a,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var kke = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function jke(e) {
  return Cc(this, void 0, void 0, function() {
    return Ec(this, function(r) {
      return F0(e) && Dke(e.dataTransfer) ? [2, zke(e.dataTransfer, e.type)] : Nke(e) ? [2, Lke(e)] : Array.isArray(e) && e.every(function(t) {
        return "getFile" in t && typeof t.getFile == "function";
      }) ? [2, Fke(e)] : [2, []];
    });
  });
}
function Dke(e) {
  return F0(e);
}
function Nke(e) {
  return F0(e) && F0(e.target);
}
function F0(e) {
  return typeof e == "object" && e !== null;
}
function Lke(e) {
  return x2(e.target.files).map(function(r) {
    return av(r);
  });
}
function Fke(e) {
  return Cc(this, void 0, void 0, function() {
    var r;
    return Ec(this, function(t) {
      switch (t.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return r = t.sent(), [2, r.map(function(n) {
            return av(n);
          })];
      }
    });
  });
}
function zke(e, r) {
  return Cc(this, void 0, void 0, function() {
    var t, n;
    return Ec(this, function(a) {
      switch (a.label) {
        case 0:
          return e.items ? (t = x2(e.items).filter(function(i) {
            return i.kind === "file";
          }), r !== "drop" ? [2, t] : [4, Promise.all(t.map(Bke))]) : [3, 2];
        case 1:
          return n = a.sent(), [2, uO(ZD(n))];
        case 2:
          return [2, uO(x2(e.files).map(function(i) {
            return av(i);
          }))];
      }
    });
  });
}
function uO(e) {
  return e.filter(function(r) {
    return kke.indexOf(r.name) === -1;
  });
}
function x2(e) {
  if (e === null)
    return [];
  for (var r = [], t = 0; t < e.length; t++) {
    var n = e[t];
    r.push(n);
  }
  return r;
}
function Bke(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return cO(e);
  var r = e.webkitGetAsEntry();
  return r && r.isDirectory ? qD(r) : cO(e);
}
function ZD(e) {
  return e.reduce(function(r, t) {
    return pa(pa([], pt(r), !1), pt(Array.isArray(t) ? ZD(t) : [t]), !1);
  }, []);
}
function cO(e) {
  var r = e.getAsFile();
  if (!r)
    return Promise.reject("".concat(e, " is not a File"));
  var t = av(r);
  return Promise.resolve(t);
}
function Uke(e) {
  return Cc(this, void 0, void 0, function() {
    return Ec(this, function(r) {
      return [2, e.isDirectory ? qD(e) : Vke(e)];
    });
  });
}
function qD(e) {
  var r = e.createReader();
  return new Promise(function(t, n) {
    var a = [];
    function i() {
      var l = this;
      r.readEntries(function(u) {
        return Cc(l, void 0, void 0, function() {
          var c, f, h;
          return Ec(this, function(p) {
            switch (p.label) {
              case 0:
                if (u.length)
                  return [3, 5];
                p.label = 1;
              case 1:
                return p.trys.push([1, 3, , 4]), [4, Promise.all(a)];
              case 2:
                return c = p.sent(), t(c), [3, 4];
              case 3:
                return f = p.sent(), n(f), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                h = Promise.all(u.map(Uke)), a.push(h), i(), p.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(u) {
        n(u);
      });
    }
    i();
  });
}
function Vke(e) {
  return Cc(this, void 0, void 0, function() {
    return Ec(this, function(r) {
      return [2, new Promise(function(t, n) {
        e.file(function(a) {
          var i = av(a, e.fullPath);
          t(i);
        }, function(a) {
          n(a);
        });
      })];
    });
  });
}
var Wke = function(e, r) {
  if (e && r) {
    var t = Array.isArray(r) ? r : r.split(","), n = e.name || "", a = (e.type || "").toLowerCase(), i = a.replace(/\/.*$/, "");
    return t.some(function(l) {
      var u = l.trim().toLowerCase();
      return u.charAt(0) === "." ? n.toLowerCase().endsWith(u) : u.endsWith("/*") ? i === u.replace(/\/.*$/, "") : a === u;
    });
  }
  return !0;
};
function dO(e) {
  return Yke(e) || Gke(e) || XD(e) || Hke();
}
function Hke() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gke(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Yke(e) {
  if (Array.isArray(e))
    return $2(e);
}
function fO(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function vO(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? fO(Object(t), !0).forEach(function(n) {
      QD(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : fO(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function QD(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function If(e, r) {
  return qke(e) || Zke(e, r) || XD(e, r) || Kke();
}
function Kke() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XD(e, r) {
  if (e) {
    if (typeof e == "string")
      return $2(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return $2(e, r);
  }
}
function $2(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function Zke(e, r) {
  var t = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], a = !0, i = !1, l, u;
    try {
      for (t = t.call(e); !(a = (l = t.next()).done) && (n.push(l.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      i = !0, u = c;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function qke(e) {
  if (Array.isArray(e))
    return e;
}
var Qke = "file-invalid-type", Xke = "file-too-large", Jke = "file-too-small", eje = "too-many-files", rje = function(r) {
  r = Array.isArray(r) && r.length === 1 ? r[0] : r;
  var t = Array.isArray(r) ? "one of ".concat(r.join(", ")) : r;
  return {
    code: Qke,
    message: "File type must be ".concat(t)
  };
}, hO = function(r) {
  return {
    code: Xke,
    message: "File is larger than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, pO = function(r) {
  return {
    code: Jke,
    message: "File is smaller than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, tje = {
  code: eje,
  message: "Too many files"
};
function JD(e, r) {
  var t = e.type === "application/x-moz-file" || Wke(e, r);
  return [t, t ? null : rje(r)];
}
function eN(e, r, t) {
  if (Dl(e.size))
    if (Dl(r) && Dl(t)) {
      if (e.size > t)
        return [!1, hO(t)];
      if (e.size < r)
        return [!1, pO(r)];
    } else {
      if (Dl(r) && e.size < r)
        return [!1, pO(r)];
      if (Dl(t) && e.size > t)
        return [!1, hO(t)];
    }
  return [!0, null];
}
function Dl(e) {
  return e != null;
}
function nje(e) {
  var r = e.files, t = e.accept, n = e.minSize, a = e.maxSize, i = e.multiple, l = e.maxFiles, u = e.validator;
  return !i && r.length > 1 || i && l >= 1 && r.length > l ? !1 : r.every(function(c) {
    var f = JD(c, t), h = If(f, 1), p = h[0], g = eN(c, n, a), y = If(g, 1), S = y[0], x = u ? u(c) : null;
    return p && S && !x;
  });
}
function z0(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble != "undefined" ? e.cancelBubble : !1;
}
function sp(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(r) {
    return r === "Files" || r === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function gO(e) {
  e.preventDefault();
}
function aje(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function oje(e) {
  return e.indexOf("Edge/") !== -1;
}
function ije() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return aje(e) || oje(e);
}
function Vo() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), l = 1; l < a; l++)
      i[l - 1] = arguments[l];
    return r.some(function(u) {
      return !z0(n) && u && u.apply(void 0, [n].concat(i)), z0(n);
    });
  };
}
function sje() {
  return "showOpenFilePicker" in window;
}
function lje(e) {
  if (Dl(e)) {
    var r = Object.entries(e).filter(function(t) {
      var n = If(t, 2), a = n[0], i = n[1], l = !0;
      return rN(a) || (console.warn('Skipped "'.concat(a, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), l = !1), (!Array.isArray(i) || !i.every(tN)) && (console.warn('Skipped "'.concat(a, '" because an invalid file extension was provided.')), l = !1), l;
    }).reduce(function(t, n) {
      var a = If(n, 2), i = a[0], l = a[1];
      return vO(vO({}, t), {}, QD({}, i, l));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: r
    }];
  }
  return e;
}
function uje(e) {
  if (Dl(e))
    return Object.entries(e).reduce(function(r, t) {
      var n = If(t, 2), a = n[0], i = n[1];
      return [].concat(dO(r), [a], dO(i));
    }, []).filter(function(r) {
      return rN(r) || tN(r);
    }).join(",");
}
function cje(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function dje(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function rN(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function tN(e) {
  return /^.*\.[\w]+$/.test(e);
}
var fje = ["children"], vje = ["open"], hje = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], pje = ["refKey", "onChange", "onClick"];
function gje(e) {
  return yje(e) || bje(e) || nN(e) || mje();
}
function mje() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bje(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function yje(e) {
  if (Array.isArray(e))
    return w2(e);
}
function cS(e, r) {
  return $je(e) || xje(e, r) || nN(e, r) || Sje();
}
function Sje() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nN(e, r) {
  if (e) {
    if (typeof e == "string")
      return w2(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return w2(e, r);
  }
}
function w2(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function xje(e, r) {
  var t = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], a = !0, i = !1, l, u;
    try {
      for (t = t.call(e); !(a = (l = t.next()).done) && (n.push(l.value), !(r && n.length === r)); a = !0)
        ;
    } catch (c) {
      i = !0, u = c;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (i)
          throw u;
      }
    }
    return n;
  }
}
function $je(e) {
  if (Array.isArray(e))
    return e;
}
function mO(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function xt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? mO(Object(t), !0).forEach(function(n) {
      _2(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : mO(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function _2(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function B0(e, r) {
  if (e == null)
    return {};
  var t = wje(e, r), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function wje(e, r) {
  if (e == null)
    return {};
  var t = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(r.indexOf(a) >= 0) && (t[a] = e[a]);
  return t;
}
var M_ = /* @__PURE__ */ W0(function(e, r) {
  var t = e.children, n = B0(e, fje), a = oN(n), i = a.open, l = B0(a, vje);
  return tU(r, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ xo.createElement(M2, null, t(xt(xt({}, l), {}, {
    open: i
  })));
});
M_.displayName = "Dropzone";
var aN = {
  disabled: !1,
  getFilesFromEvent: jke,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
M_.defaultProps = aN;
M_.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Jr.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: Jr.objectOf(Jr.arrayOf(Jr.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Jr.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Jr.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Jr.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Jr.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Jr.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Jr.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Jr.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Jr.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Jr.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Jr.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Jr.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Jr.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Jr.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Jr.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: Jr.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Jr.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Jr.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Jr.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Jr.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Jr.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Jr.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: Jr.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: Jr.func
};
var T2 = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function oN() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = xt(xt({}, aN), e), t = r.accept, n = r.disabled, a = r.getFilesFromEvent, i = r.maxSize, l = r.minSize, u = r.multiple, c = r.maxFiles, f = r.onDragEnter, h = r.onDragLeave, p = r.onDragOver, g = r.onDrop, y = r.onDropAccepted, S = r.onDropRejected, x = r.onFileDialogCancel, _ = r.onFileDialogOpen, A = r.useFsAccessApi, O = r.autoFocus, P = r.preventDropOnDocument, j = r.noClick, k = r.noKeyboard, L = r.noDrag, M = r.noDragEventsBubbling, W = r.onError, Z = r.validator, oe = Rt(function() {
    return uje(t);
  }, [t]), Ie = Rt(function() {
    return lje(t);
  }, [t]), Te = Rt(function() {
    return typeof _ == "function" ? _ : bO;
  }, [_]), Ee = Rt(function() {
    return typeof x == "function" ? x : bO;
  }, [x]), Me = Qe(null), Fe = Qe(null), Ge = rU(_je, T2), ze = cS(Ge, 2), le = ze[0], ce = ze[1], he = le.isFocused, be = le.isFileDialogActive, ye = Qe(typeof window != "undefined" && window.isSecureContext && A && sje()), q = function() {
    !ye.current && be && setTimeout(function() {
      if (Fe.current) {
        var Q = Fe.current.files;
        Q.length || (ce({
          type: "closeDialog"
        }), Ee());
      }
    }, 300);
  };
  ar(function() {
    return window.addEventListener("focus", q, !1), function() {
      window.removeEventListener("focus", q, !1);
    };
  }, [Fe, be, Ee, ye]);
  var ae = Qe([]), ue = function(Q) {
    Me.current && Me.current.contains(Q.target) || (Q.preventDefault(), ae.current = []);
  };
  ar(function() {
    return P && (document.addEventListener("dragover", gO, !1), document.addEventListener("drop", ue, !1)), function() {
      P && (document.removeEventListener("dragover", gO), document.removeEventListener("drop", ue));
    };
  }, [Me, P]), ar(function() {
    return !n && O && Me.current && Me.current.focus(), function() {
    };
  }, [Me, O, n]);
  var $e = Ne(function(Y) {
    W ? W(Y) : console.error(Y);
  }, [W]), Ze = Ne(function(Y) {
    Y.preventDefault(), Y.persist(), pr(Y), ae.current = [].concat(gje(ae.current), [Y.target]), sp(Y) && Promise.resolve(a(Y)).then(function(Q) {
      if (!(z0(Y) && !M)) {
        var Ce = Q.length, me = Ce > 0 && nje({
          files: Q,
          accept: oe,
          minSize: l,
          maxSize: i,
          multiple: u,
          maxFiles: c,
          validator: Z
        }), Re = Ce > 0 && !me;
        ce({
          isDragAccept: me,
          isDragReject: Re,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), f && f(Y);
      }
    }).catch(function(Q) {
      return $e(Q);
    });
  }, [a, f, $e, M, oe, l, i, u, c, Z]), _e = Ne(function(Y) {
    Y.preventDefault(), Y.persist(), pr(Y);
    var Q = sp(Y);
    if (Q && Y.dataTransfer)
      try {
        Y.dataTransfer.dropEffect = "copy";
      } catch (Ce) {
      }
    return Q && p && p(Y), !1;
  }, [p, M]), or = Ne(function(Y) {
    Y.preventDefault(), Y.persist(), pr(Y);
    var Q = ae.current.filter(function(me) {
      return Me.current && Me.current.contains(me);
    }), Ce = Q.indexOf(Y.target);
    Ce !== -1 && Q.splice(Ce, 1), ae.current = Q, !(Q.length > 0) && (ce({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), sp(Y) && h && h(Y));
  }, [Me, h, M]), Yr = Ne(function(Y, Q) {
    var Ce = [], me = [];
    Y.forEach(function(Re) {
      var ur = JD(Re, oe), Sr = cS(ur, 2), lr = Sr[0], ct = Sr[1], at = eN(Re, l, i), mt = cS(at, 2), Ct = mt[0], dr = mt[1], Zr = Z ? Z(Re) : null;
      if (lr && Ct && !Zr)
        Ce.push(Re);
      else {
        var cn = [ct, dr];
        Zr && (cn = cn.concat(Zr)), me.push({
          file: Re,
          errors: cn.filter(function(dn) {
            return dn;
          })
        });
      }
    }), (!u && Ce.length > 1 || u && c >= 1 && Ce.length > c) && (Ce.forEach(function(Re) {
      me.push({
        file: Re,
        errors: [tje]
      });
    }), Ce.splice(0)), ce({
      acceptedFiles: Ce,
      fileRejections: me,
      type: "setFiles"
    }), g && g(Ce, me, Q), me.length > 0 && S && S(me, Q), Ce.length > 0 && y && y(Ce, Q);
  }, [ce, u, oe, l, i, c, g, y, S, Z]), mr = Ne(function(Y) {
    Y.preventDefault(), Y.persist(), pr(Y), ae.current = [], sp(Y) && Promise.resolve(a(Y)).then(function(Q) {
      z0(Y) && !M || Yr(Q, Y);
    }).catch(function(Q) {
      return $e(Q);
    }), ce({
      type: "reset"
    });
  }, [a, Yr, $e, M]), rt = Ne(function() {
    if (ye.current) {
      ce({
        type: "openDialog"
      }), Te();
      var Y = {
        multiple: u,
        types: Ie
      };
      window.showOpenFilePicker(Y).then(function(Q) {
        return a(Q);
      }).then(function(Q) {
        Yr(Q, null), ce({
          type: "closeDialog"
        });
      }).catch(function(Q) {
        cje(Q) ? (Ee(Q), ce({
          type: "closeDialog"
        })) : dje(Q) ? (ye.current = !1, Fe.current ? (Fe.current.value = null, Fe.current.click()) : $e(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : $e(Q);
      });
      return;
    }
    Fe.current && (ce({
      type: "openDialog"
    }), Te(), Fe.current.value = null, Fe.current.click());
  }, [ce, Te, Ee, A, Yr, $e, Ie, u]), Je = Ne(function(Y) {
    !Me.current || !Me.current.isEqualNode(Y.target) || (Y.key === " " || Y.key === "Enter" || Y.keyCode === 32 || Y.keyCode === 13) && (Y.preventDefault(), rt());
  }, [Me, rt]), Ir = Ne(function() {
    ce({
      type: "focus"
    });
  }, []), wt = Ne(function() {
    ce({
      type: "blur"
    });
  }, []), Kr = Ne(function() {
    j || (ije() ? setTimeout(rt, 0) : rt());
  }, [j, rt]), jr = function(Q) {
    return n ? null : Q;
  }, jt = function(Q) {
    return k ? null : jr(Q);
  }, gt = function(Q) {
    return L ? null : jr(Q);
  }, pr = function(Q) {
    M && Q.stopPropagation();
  }, br = Rt(function() {
    return function() {
      var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Q = Y.refKey, Ce = Q === void 0 ? "ref" : Q, me = Y.role, Re = Y.onKeyDown, ur = Y.onFocus, Sr = Y.onBlur, lr = Y.onClick, ct = Y.onDragEnter, at = Y.onDragOver, mt = Y.onDragLeave, Ct = Y.onDrop, dr = B0(Y, hje);
      return xt(xt(_2({
        onKeyDown: jt(Vo(Re, Je)),
        onFocus: jt(Vo(ur, Ir)),
        onBlur: jt(Vo(Sr, wt)),
        onClick: jr(Vo(lr, Kr)),
        onDragEnter: gt(Vo(ct, Ze)),
        onDragOver: gt(Vo(at, _e)),
        onDragLeave: gt(Vo(mt, or)),
        onDrop: gt(Vo(Ct, mr)),
        role: typeof me == "string" && me !== "" ? me : "presentation"
      }, Ce, Me), !n && !k ? {
        tabIndex: 0
      } : {}), dr);
    };
  }, [Me, Je, Ir, wt, Kr, Ze, _e, or, mr, k, L, n]), G = Ne(function(Y) {
    Y.stopPropagation();
  }, []), te = Rt(function() {
    return function() {
      var Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Q = Y.refKey, Ce = Q === void 0 ? "ref" : Q, me = Y.onChange, Re = Y.onClick, ur = B0(Y, pje), Sr = _2({
        accept: oe,
        multiple: u,
        type: "file",
        style: {
          display: "none"
        },
        onChange: jr(Vo(me, mr)),
        onClick: jr(Vo(Re, G)),
        tabIndex: -1
      }, Ce, Fe);
      return xt(xt({}, Sr), ur);
    };
  }, [Fe, t, u, mr, n]);
  return xt(xt({}, le), {}, {
    isFocused: he && !n,
    getRootProps: br,
    getInputProps: te,
    rootRef: Me,
    inputRef: Fe,
    open: jr(rt)
  });
}
function _je(e, r) {
  switch (r.type) {
    case "focus":
      return xt(xt({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return xt(xt({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return xt(xt({}, T2), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return xt(xt({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return xt(xt({}, e), {}, {
        isDragActive: r.isDragActive,
        isDragAccept: r.isDragAccept,
        isDragReject: r.isDragReject
      });
    case "setFiles":
      return xt(xt({}, e), {}, {
        acceptedFiles: r.acceptedFiles,
        fileRejections: r.fileRejections
      });
    case "reset":
      return xt({}, T2);
    default:
      return e;
  }
}
function bO() {
}
const Tje = "_thumb_1ha40_2", Cje = "_img_1ha40_34", gd = {
  "thumbs-container": "_thumbs-container_1ha40_2",
  thumb: Tje,
  "thumb-inner": "_thumb-inner_1ha40_26",
  img: Cje,
  "delete-button": "_delete-button_1ha40_41"
}, Eje = ({ files: e, handleDelete: r }) => {
  const t = e.map((n) => /* @__PURE__ */ T.jsxs("div", { className: gd.thumb, children: [
    /* @__PURE__ */ T.jsx("div", { className: gd["thumb-inner"], children: /* @__PURE__ */ T.jsx("img", { src: n.preview, className: gd.img, alt: "Preview" }) }),
    /* @__PURE__ */ T.jsx(
      "button",
      {
        onClick: () => r(n.name),
        className: gd["delete-button"],
        children: /* @__PURE__ */ T.jsx("span", {})
      }
    )
  ] }, n.name));
  return /* @__PURE__ */ T.jsx("aside", { className: gd["thumbs-container"], children: t });
}, Aje = "_dropzone_1dofu_13", El = {
  "bv-multiple-image-uploader": "_bv-multiple-image-uploader_1dofu_1",
  "has-files": "_has-files_1dofu_9",
  "dropzone-container": "_dropzone-container_1dofu_13",
  dropzone: Aje,
  "text-info": "_text-info_1dofu_22",
  "dropzone-button": "_dropzone-button_1dofu_29",
  "so-com": "_so-com_1dofu_39"
}, C2 = {
  default: "Puedes subir hasta 6 archivos de hasta 5 MB.",
  "too-many-files": "Intentaste subir mas de 6 archivos permitidos.",
  "file-too-large": "El archivo es demasiado grande. Maximo de 5 MB.",
  "file-invalid-type": "Solo se admiten imagenes (.jpg, .jpeg, .png)"
}, Ije = (e) => {
  const r = e[0].errors[0].code;
  return C2[r] || C2.default;
}, Oje = ({
  files: e,
  error: r
}) => r || (e.length === 6 ? "Alcanzaste el máximo de 6 archivos." : "Puedes subir hasta 6 archivos de hasta 5 MB."), Mje = ({
  handlePhotoUploadHook: e,
  photos: r
}) => {
  const { theme: t, isSodimacStandAlone: n = !1 } = Co(), [a, i] = Ye([]), [l, u] = Ye(""), c = (p) => {
    i((g) => g.filter((y) => y.name !== p));
  }, { getRootProps: f, getInputProps: h } = oN({
    accept: {
      "image/jpg": [],
      "image/jpeg": [],
      "image/png": []
    },
    maxFiles: 6,
    maxSize: 5 * 1024 * 1024,
    // 5MB
    onDrop: (p, g) => {
      if (g.length > 0) {
        const x = Ije(g);
        u(x);
        return;
      }
      const y = p.map(
        (x) => Object.assign(x, { preview: URL.createObjectURL(x) })
      ), S = [...r, ...y];
      if (S.length > 6) {
        const x = C2["too-many-files"];
        u(x);
        return;
      }
      u(""), i(S);
    },
    disabled: r.length >= 6
  });
  return ar(() => {
    e("photos", a);
  }, [a, e]), ar(() => {
    r.length && i(r);
  }, [r]), /* @__PURE__ */ T.jsxs(
    an,
    {
      className: `${El["bv-multiple-image-uploader"]} ${a.length > 0 ? El["has-files"] : ""}`,
      borderColor: t.secondary_color,
      children: [
        a.length === 0 ? /* @__PURE__ */ T.jsx(bIe, {}) : /* @__PURE__ */ T.jsx(Eje, { files: a, handleDelete: c }),
        /* @__PURE__ */ T.jsx("section", { className: El["dropzone-container"], children: /* @__PURE__ */ T.jsxs(
          "div",
          wi(Xt({
            "data-testid": "dropzone"
          }, f({ className: El.dropzone })), {
            children: [
              /* @__PURE__ */ T.jsx("input", Xt({}, h())),
              /* @__PURE__ */ T.jsx(gc, { className: El["text-info"], children: Oje({ files: a, error: l }) }),
              a.length === 6 ? null : /* @__PURE__ */ T.jsx(
                Sg,
                {
                  className: `${El["dropzone-button"]} ${n ? El["so-com"] : ""}`,
                  color: "secondary",
                  variant: "outline",
                  bg: "secondary",
                  children: "Seleccionar Archivos"
                }
              )
            ]
          })
        ) })
      ]
    }
  );
}, Rje = (e) => {
  const r = {};
  return e.indexOf("?") === -1 || e.substring(e.indexOf("?") + 1).split("&").filter((t) => t).filter((t) => !!t).forEach((t) => {
    const [n, a] = t.split("=");
    r[n] = a || "";
  }), r;
}, E2 = () => {
  const { href: e } = window.location;
  return Rje(e).orderNumberForReview;
}, Pje = () => {
  const e = new URL(window.location.href);
  e.searchParams.delete("orderNumberForReview"), window.history.replaceState({}, document.title, e.toString());
}, kje = () => {
  var r, t;
  const e = (r = document.cookie) == null ? void 0 : r.split("; ");
  return (t = e == null ? void 0 : e.find((n) => n == null ? void 0 : n.startsWith("sid="))) == null ? void 0 : t.split("=")[1];
}, jje = (e) => {
  const r = new Headers();
  return r.set("Country", e), r.set("Authorization", kje()), r;
}, Dje = (e, r) => {
  const t = e == null ? void 0 : e.toLocaleLowerCase();
  return t !== "cl" ? `https://${II[r]}.falabella.com.${t}` : `https://${II[r]}.falabella.com`;
}, Nje = ({
  orderNumber: e,
  productId: r,
  tenant: t,
  environment: n
}) => `${Dje(
  t,
  n
)}/s/bff-orders/orders/${e}/item/${r}`, iN = (a) => Xr(void 0, [a], function* ({
  orderNumber: e,
  productId: r,
  tenant: t,
  environment: n
}) {
  const i = Nje({
    orderNumber: e,
    productId: r,
    tenant: t,
    environment: n
  });
  return yield wd(i, {
    headers: jje(t)
  });
}), Lje = (e) => {
  const r = {};
  return e.usernickname || (r.usernickname = "Nombre es requerido"), e.rating || (r.rating = "Rating es requerido"), r;
}, sN = (e, r, t) => e.length ? e.length >= r && e.length < t ? {
  text: "¡Sigue así! Cuéntanos más detalles 😉."
} : {
  className: ft.success,
  text: "¡Bien hecho! 🎉"
} : { className: "", text: null }, lp = (e) => sN(e, 1, 30).className, Fje = (e) => sN(e, 1, 30).text;
function zje(e) {
  const {
    product: r,
    isSecondaryRatingsFormEnabled: t,
    isReviewValidationWithOrder: n
  } = pm(), { hasSecondaryRatings: a } = Ta(), { theme: i, tenant: l, environment: u } = Co(), { isOpen: c, onClose: f, onSubmit: h, isApp: p } = e, { data: g, requestInProgress: y, setRequestInProgress: S } = xm(), x = () => {
    _.handleSubmit();
  }, _ = GD({
    initialValues: g,
    validate: Lje,
    onSubmit: (j) => Xr(this, null, function* () {
      h(j);
    })
  }), A = /* @__PURE__ */ T.jsxs("form", { className: ft["review-form"], onSubmit: _.handleSubmit, children: [
    /* @__PURE__ */ T.jsxs("div", { className: ft["form-header"], children: [
      /* @__PURE__ */ T.jsx(gc, { className: ft.title, children: "¿Cómo calificarías este producto?" }),
      /* @__PURE__ */ T.jsxs("div", { className: ft["main-header"], children: [
        /* @__PURE__ */ T.jsx(vD, { product: r }),
        /* @__PURE__ */ T.jsxs("div", { className: ft["title-and-rating"], children: [
          /* @__PURE__ */ T.jsx(
            gc,
            {
              className: ft["product-name"],
              children: `${r.brandName} - ${r.name}`
            }
          ),
          /* @__PURE__ */ T.jsx("div", { className: ft["rating-form-control"], children: /* @__PURE__ */ T.jsxs(oP, { direction: "column", alignItems: "center", children: [
            /* @__PURE__ */ T.jsx(
              S_,
              {
                rating: _.values.rating,
                handleRatingClickHook: _.setFieldValue
              }
            ),
            /* @__PURE__ */ T.jsx(
              "div",
              {
                className: `${ft["form-error-message"]} ${_.errors.rating ? ft["field-error"] : ""}`,
                children: _.errors.rating
              }
            )
          ] }) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ T.jsx("div", { className: ft["form-body"], children: /* @__PURE__ */ T.jsxs(iP, { spacing: "32px", children: [
      /* @__PURE__ */ T.jsxs("div", { children: [
        /* @__PURE__ */ T.jsx("label", { className: ft.label, children: "Describe tu calificación en una frase" }),
        /* @__PURE__ */ T.jsx(
          YS,
          {
            id: "title",
            name: "title",
            className: ft.input,
            placeholder: "¿Qué es lo que más destacas del producto?",
            onChange: _.handleChange,
            value: _.values.title
          }
        )
      ] }),
      /* @__PURE__ */ T.jsxs("div", { children: [
        /* @__PURE__ */ T.jsx("label", { className: ft.label, children: "¿Qué te gustaría decir acerca de este producto?" }),
        /* @__PURE__ */ T.jsx(
          "textarea",
          {
            id: "reviewtext",
            name: "reviewtext",
            className: `${ft.textarea} ${lp(
              _.values.reviewtext
            )}`,
            placeholder: "Comparte tu experiencia con el producto. ¿Es lo que esperabas? ¿Qué fue lo que más te gustó?",
            onChange: _.handleChange,
            value: _.values.reviewtext,
            style: { borderColor: i.secondary_color }
          }
        ),
        _.values.reviewtext.length > 0 && /* @__PURE__ */ T.jsx(
          "div",
          {
            className: `${ft["helper-text"]} ${lp(_.values.reviewtext) ? lp(_.values.reviewtext) : ""}`,
            style: {
              color: lp(_.values.reviewtext) ? "" : i.secondary_color
            },
            children: Fje(_.values.reviewtext)
          }
        )
      ] }),
      /* @__PURE__ */ T.jsxs("div", { children: [
        /* @__PURE__ */ T.jsx("label", { className: ft.label, children: "Comparte tus fotos del producto" }),
        /* @__PURE__ */ T.jsx(
          Mje,
          {
            photos: _.values.photos,
            handlePhotoUploadHook: _.setFieldValue
          }
        )
      ] }),
      /* @__PURE__ */ T.jsxs("div", { children: [
        /* @__PURE__ */ T.jsx("label", { className: ft.label, children: "Déjanos tu nombre (*)" }),
        /* @__PURE__ */ T.jsx(
          YS,
          {
            id: "usernickname",
            name: "usernickname",
            placeholder: "¿Cuál es tu nombre?",
            className: ft.input,
            onChange: _.handleChange,
            value: _.values.usernickname
          }
        ),
        /* @__PURE__ */ T.jsx(
          "div",
          {
            className: `${ft["form-error-message"]} ${_.errors.usernickname ? ft["field-error"] : ""}`,
            children: _.errors.usernickname
          }
        )
      ] }),
      /* @__PURE__ */ T.jsxs("div", { children: [
        /* @__PURE__ */ T.jsx("label", { className: ft.label, children: "¿Recomiendas este producto?" }),
        /* @__PURE__ */ T.jsx(
          Mke,
          {
            value: _.values.isrecommended,
            setValue: _.setFieldValue,
            options: [
              { text: "Sí", icon: "😀", value: "true" },
              { text: "No", icon: "😕", value: "false" }
            ]
          }
        )
      ] })
    ] }) })
  ] }), O = ({
    errors: j,
    values: k,
    requestInProgress: L = !1
  }) => {
    const M = !Object.keys(j).length, W = !!k.usernickname && !!k.rating;
    return M && W && !L;
  }, P = ({ formik: j }) => {
    const k = () => Xr(this, null, function* () {
      try {
        S(!0);
        const L = E2();
        L && n ? (yield iN({
          orderNumber: L,
          productId: r.id,
          tenant: l,
          environment: u
        })).success ? j.handleSubmit() : f() : j.handleSubmit(), S(!1);
      } catch (L) {
        S(!1), f();
      }
    });
    return /* @__PURE__ */ T.jsx("div", { className: ft["write-review-custom-footer"], children: /* @__PURE__ */ T.jsx("div", { className: ft["footer-button-wrapper"], children: /* @__PURE__ */ T.jsx(
      KD,
      {
        disabled: !O({
          errors: j.errors,
          values: j.values,
          requestInProgress: y
        }),
        label: t && a ? "Continuar" : "Finalizar",
        handleButtonClick: k
      }
    ) }) });
  };
  return /* @__PURE__ */ T.jsxs(
    y_,
    {
      onContinue: x,
      isOpen: c,
      onClose: f,
      isApp: p,
      children: [
        /* @__PURE__ */ T.jsx("div", { slot: "header", children: /* @__PURE__ */ T.jsx(m_, { onClose: f }) }),
        A,
        /* @__PURE__ */ T.jsx("div", { slot: "footer", children: /* @__PURE__ */ T.jsx(P, { formik: _ }) })
      ]
    }
  );
}
const Bje = "_heading_yn98b_21", Uje = "_text_yn98b_25", xs = {
  "review-sent-modal": "_review-sent-modal_yn98b_2",
  "modal-body": "_modal-body_yn98b_11",
  "circle-icon": "_circle-icon_yn98b_18",
  heading: Bje,
  text: Uje,
  "custom-footer-wrapper": "_custom-footer-wrapper_yn98b_30",
  "sent-button": "_sent-button_yn98b_36",
  "so-com": "_so-com_yn98b_39"
}, Vje = (e) => {
  const { payloadFunction: r, onClose: t, isOpen: n, isApp: a } = e, { theme: i, isSodimacStandAlone: l = !1 } = Co(), u = ({
    onContinue: c,
    onClose: f
  }) => /* @__PURE__ */ T.jsx("div", { className: xs["custom-footer-wrapper"], children: /* @__PURE__ */ T.jsx(
    Sg,
    {
      className: `${xs["sent-button"]} ${l ? xs["so-com"] : ""}`,
      onClick: () => {
        f(), c && c();
      },
      style: { backgroundColor: i.secondary_color },
      size: "lg",
      rightIcon: /* @__PURE__ */ T.jsx(yIe, {}),
      children: "Seguir navegando"
    }
  ) });
  return /* @__PURE__ */ T.jsxs(
    y_,
    {
      isOpen: n,
      onClose: t,
      onContinue: r,
      isApp: a,
      children: [
        /* @__PURE__ */ T.jsx("div", { slot: "header", children: /* @__PURE__ */ T.jsx(m_, { onClose: t }) }),
        /* @__PURE__ */ T.jsx("div", { className: xs["review-sent-modal"], children: /* @__PURE__ */ T.jsxs("div", { className: xs["modal-body"], children: [
          /* @__PURE__ */ T.jsx(an, { className: xs["circle-icon"], children: /* @__PURE__ */ T.jsx(
            gIe,
            {
              color: i.secondary_color,
              fill: "#D3D7DB",
              width: "97px",
              height: "97px"
            }
          ) }),
          /* @__PURE__ */ T.jsx("div", { className: xs.heading, children: "¡Gracias! Tu comentario ya se publicó." }),
          /* @__PURE__ */ T.jsx(gc, { className: xs.text, children: "Con tu opinión estás ayudando a otros clientes a mejorar su experiencia de compra." })
        ] }) }),
        /* @__PURE__ */ T.jsx("div", { slot: "footer", children: /* @__PURE__ */ T.jsx(u, { onContinue: r, onClose: t }) })
      ]
    }
  );
}, lN = On(void 0);
var Of = /* @__PURE__ */ ((e) => (e.MainForm = "MainForm", e.AttributesByCategory = "AttributesByCategory", e.SentReview = "SentReview", e))(Of || {});
const Wje = ({ children: e }) => {
  const { onClickSuccessButton: r, tenant: t, environment: n, isLoggedIn: a } = Co(), [i, l] = Ye(null), { product: u, isSecondaryRatingsFormEnabled: c } = pm(), { hasSecondaryRatings: f } = Ta(), { setData: h, setRequestInProgress: p, resetData: g } = xm(), y = g_({ tenant: t, environment: n }), [S, x] = Ye(!1), _ = () => {
    const { protocol: W, host: Z } = window.location;
    window.location.href = `${W}//${Z}`;
  }, A = (W) => Xr(void 0, null, function* () {
    try {
      p(!0), yield y.saveReview({ values: W, product: u }), p(!1), l(
        "SentReview"
        /* SentReview */
      );
    } catch (Z) {
      console.log(Z);
    }
  }), O = () => {
    const W = E2();
    return !r && !W ? _() : (W && Pje(), r && r());
  }, P = () => {
    l(null);
  }, j = () => {
    const W = new URLSearchParams(window.location.search);
    if (W.get("bvcampaign") === "PUSH_APP" && !W.has("sent")) {
      let oe = window.location.href;
      oe.includes("?") ? oe += "&sent" : oe += "?sent", window.history.pushState({}, "", oe);
    }
  }, k = (W) => Xr(void 0, null, function* () {
    try {
      c && f ? (h(W), l(
        "AttributesByCategory"
        /* AttributesByCategory */
      )) : (p(!0), yield y.saveReview({ values: W, product: u }), p(!1), l(
        "SentReview"
        /* SentReview */
      ));
    } catch (Z) {
      console.log(Z);
    }
  });
  ar(() => {
    const Z = new URLSearchParams(window.location.search).get("bvcampaign");
    x(Z === "PUSH_APP");
  }, []);
  const L = Qe(n), M = Qe(t);
  return ar(() => {
    (() => Xr(void 0, null, function* () {
      try {
        const Z = E2();
        if (Z) {
          const oe = yield iN({
            orderNumber: Z,
            productId: u.id,
            environment: L.current,
            tenant: M.current
          });
          console.log({ response: oe }), oe.success && a && (console.log({ isLoggedIn: a }), l(
            "MainForm"
            /* MainForm */
          ));
        }
      } catch (Z) {
        console.error("Error validating order:", Z);
      }
    }))();
  }, [u.id, a]), /* @__PURE__ */ T.jsxs(lN.Provider, { value: { activeModal: i, setActiveModal: l, isApp: S }, children: [
    e,
    /* @__PURE__ */ T.jsx(
      zje,
      {
        isApp: S,
        isOpen: i === "MainForm",
        onClose: P,
        onSubmit: k
      }
    ),
    /* @__PURE__ */ T.jsx(
      Ske,
      {
        isApp: S,
        isOpen: i === "AttributesByCategory",
        onBackClick: () => {
          P(), l(
            "MainForm"
            /* MainForm */
          );
        },
        onClose: P,
        onSubmit: A
      }
    ),
    /* @__PURE__ */ T.jsx(
      Vje,
      {
        isApp: S,
        isOpen: i === "SentReview",
        onClose: () => {
          P(), g(), j();
        },
        payloadFunction: O
      }
    )
  ] });
}, R_ = () => {
  const e = zr(lN);
  if (!e)
    throw new Error("useModalsContext must be used within a ModalsProvider");
  return e;
}, Hje = fD(Wje);
function Gje() {
  const { label: e, isLoggedIn: r, openForm: t } = Co(), { setActiveModal: n } = R_(), a = () => {
    r && n(Of.MainForm);
  };
  return ar(() => {
    new URLSearchParams(window.location.search).has("sent") || n(t ? Of.MainForm : null);
  }, [n, t]), /* @__PURE__ */ T.jsx("div", { className: OI["bv-write-review"], children: /* @__PURE__ */ T.jsxs("label", { onClick: a, className: OI["write-comment-label"], children: [
    " ",
    e,
    " "
  ] }) });
}
const p8e = fD(Gje), g8e = (t) => {
  var n = t, { children: e } = n, r = Hv(n, ["children"]);
  const {
    product: a,
    firstName: i,
    isSecondaryRatingsFormEnabled: l,
    isReviewValidationWithOrder: u
  } = r;
  return /* @__PURE__ */ T.jsx(EIe, wi(Xt({}, r), { children: /* @__PURE__ */ T.jsx(bke, { firstName: i, children: /* @__PURE__ */ T.jsx(
    CIe,
    {
      initialProduct: a,
      isSecondaryRatingsFormEnabled: l,
      isReviewValidationWithOrder: u,
      children: /* @__PURE__ */ T.jsx(AIe, { children: /* @__PURE__ */ T.jsxs(Hje, { children: [
        e,
        " "
      ] }) })
    }
  ) }) }));
}, Wo = {
  "bv-stars-non-editable": "_bv-stars-non-editable_10acl_1",
  "star-icon": "_star-icon_10acl_1",
  "star-empty": "_star-empty_10acl_7",
  "star-full": "_star-full_10acl_10",
  "star-1": "_star-1_10acl_13",
  "star-2": "_star-2_10acl_16",
  "star-3": "_star-3_10acl_19",
  "star-4": "_star-4_10acl_22",
  "star-5": "_star-5_10acl_25",
  "star-6": "_star-6_10acl_28",
  "star-7": "_star-7_10acl_31",
  "star-8": "_star-8_10acl_34",
  "star-9": "_star-9_10acl_37"
}, Yje = (e) => parseInt((e % 1).toFixed(1).slice(2)), Kje = (e) => {
  const r = `star-${e}`;
  return Wo[r];
}, P_ = ({ rating: e }) => {
  if (!e)
    return /* @__PURE__ */ T.jsx(ZS, { className: Wo["bv-stars-non-editable"], spacing: "4px", children: [...Array(5)].map((a, i) => /* @__PURE__ */ T.jsx(
      "span",
      {
        role: "star-icon",
        "data-testid": `star-icon-${i + 1}`,
        className: Wo["star-icon"] + " " + Wo["star-empty"]
      },
      i
    )) });
  const r = e > 5 ? 5 : Math.floor(e), t = e % 1 !== 0 && e <= 5, n = 5 - r - (t ? 1 : 0);
  return /* @__PURE__ */ T.jsxs(ZS, { className: Wo["bv-stars-non-editable"], spacing: "4px", children: [
    [...Array(r)].map((a, i) => /* @__PURE__ */ T.jsx(
      "span",
      {
        role: "star-icon",
        className: `${Wo["star-icon"]} ${Wo["star-full"]}`
      },
      i
    )),
    t && /* @__PURE__ */ T.jsx(
      "span",
      {
        role: "star-icon",
        className: `${Wo["star-icon"]} ${Kje(
          Yje(e)
        )}`
      }
    ),
    n > 0 && [...Array(n)].map((a, i) => /* @__PURE__ */ T.jsx(
      "span",
      {
        role: "star-icon",
        className: `${Wo["star-icon"]} ${Wo["star-empty"]}`
      },
      i
    ))
  ] });
}, Zje = "_text_i8pye_5", up = {
  "bv-summary-rating": "_bv-summary-rating_i8pye_1",
  text: Zje,
  "comparative-table-reviews": "_comparative-table-reviews_i8pye_14"
}, m8e = ({ isComparativeTable: e }) => {
  const { averageRating: r = 0, totalComments: t = 0 } = Ta(), n = e ? `${up.text} ${up["comparative-table-reviews"]}` : up.text;
  return e && (r === 0 || t === 0) ? null : /* @__PURE__ */ T.jsxs("div", { className: up["bv-summary-rating"], children: [
    /* @__PURE__ */ T.jsx(P_, { rating: r }),
    r && t ? /* @__PURE__ */ T.jsx("span", { className: n, children: e ? `(${t})` : `${r} (${t})` }) : /* @__PURE__ */ T.jsx("span", { className: n, children: "(0)" })
  ] });
}, Ps = {
  "rating-distribution": "_rating-distribution_1wk2j_2",
  "rating-count-wrapper": "_rating-count-wrapper_1wk2j_7",
  "dark-star": "_dark-star_1wk2j_13",
  "rating-value": "_rating-value_1wk2j_24",
  "rating-count": "_rating-count_1wk2j_7",
  "distribution-bar": "_distribution-bar_1wk2j_37",
  "bar-inner": "_bar-inner_1wk2j_42",
  "bar-fill": "_bar-fill_1wk2j_56"
}, qje = ({ widthPercent: e }) => /* @__PURE__ */ T.jsx("div", { className: Ps["distribution-bar"], "data-testid": "distribution-bar", children: /* @__PURE__ */ T.jsx("div", { className: Ps["bar-inner"], children: /* @__PURE__ */ T.jsx(
  "div",
  {
    className: Ps["bar-fill"],
    style: { width: e },
    "data-testid": "bar-fill"
  }
) }) }), Qje = ({
  index: e,
  ratingDistribution: r,
  totalComments: t
}) => {
  const n = r.find(
    ({ RatingValue: l }) => l === e
  ) || { RatingValue: 0, Count: 0 }, { Count: a } = n, i = t ? a / t * 100 : 0;
  return /* @__PURE__ */ T.jsxs("div", { className: Ps["rating-count-wrapper"], children: [
    /* @__PURE__ */ T.jsx("div", { className: Ps["rating-value"], children: e }),
    /* @__PURE__ */ T.jsx("div", { className: Ps["dark-star"] }),
    /* @__PURE__ */ T.jsx(qje, { widthPercent: `${i}%` }),
    t > 0 && /* @__PURE__ */ T.jsx("div", { className: Ps["rating-count"], children: a })
  ] }, e);
}, Xje = () => {
  const { totalComments: e = 0, ratingDistribution: r = [] } = Ta();
  return /* @__PURE__ */ T.jsx("div", { className: Ps["rating-distribution"], children: /* @__PURE__ */ T.jsx(T.Fragment, { children: [...Array(5)].map((t, n) => /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx(
    Qje,
    {
      index: n + 1,
      ratingDistribution: r,
      totalComments: e
    }
  ) }, n)) }) });
}, Jje = "_numerator_7vdzo_22", e6e = "_denominator_7vdzo_27", md = {
  "summary-tile": "_summary-tile_7vdzo_2",
  "rating-fraction": "_rating-fraction_7vdzo_16",
  numerator: Jje,
  denominator: e6e,
  "total-comments-text": "_total-comments-text_7vdzo_33"
}, r6e = () => {
  const { averageRating: e = 0, totalComments: r = 0 } = Ta(), t = r === 1 ? ai.COMMENT : ai.COMMENTS;
  return /* @__PURE__ */ T.jsxs("div", { className: md["summary-tile"], children: [
    r ? /* @__PURE__ */ T.jsxs("div", { className: md["rating-fraction"], children: [
      /* @__PURE__ */ T.jsx("div", { className: md.numerator, children: e }),
      /* @__PURE__ */ T.jsx("div", { className: md.denominator, children: "/5" })
    ] }) : null,
    /* @__PURE__ */ T.jsx(P_, { rating: e }),
    /* @__PURE__ */ T.jsxs("div", { className: md["total-comments-text"], children: [
      r,
      " ",
      t
    ] })
  ] });
}, dS = {
  "recommendation-rate-wrapper": "_recommendation-rate-wrapper_sib66_2",
  "recommended-percentage": "_recommended-percentage_sib66_20",
  "recommended-percentage-text": "_recommended-percentage-text_sib66_27"
}, t6e = () => {
  const { totalComments: e = 0, recommendedCount: r = 0 } = Ta(), { recommendedThreshold: t = 80 } = Co(), n = Math.round(
    r / e * 100
  ), a = n >= t;
  return e && a ? /* @__PURE__ */ T.jsxs("div", { className: dS["recommendation-rate-wrapper"], children: [
    /* @__PURE__ */ T.jsxs("div", { className: dS["recommended-percentage"], children: [
      /* @__PURE__ */ T.jsx("span", { children: e ? n : 0 }),
      /* @__PURE__ */ T.jsx("span", { children: "% " })
    ] }),
    /* @__PURE__ */ T.jsx("div", { className: dS["recommended-percentage-text"], children: ai.RECOMMENDATION_RATE_MESSAGE })
  ] }) : null;
}, n6e = "_label_1on7v_27", a6e = "_rating_1on7v_37", o6e = "_stars_1on7v_43", i6e = "_value_1on7v_48", s6e = "_bar_1on7v_114", Yn = {
  "secondary-ratings-divider": "_secondary-ratings-divider_1on7v_2",
  "normal-secondary-ratings-wrapper": "_normal-secondary-ratings-wrapper_1on7v_7",
  "secondary-rating": "_secondary-rating_1on7v_2",
  label: n6e,
  rating: a6e,
  stars: o6e,
  value: i6e,
  "slider-secondary-ratings-wrapper": "_slider-secondary-ratings-wrapper_1on7v_56",
  "slider-ratings": "_slider-ratings_1on7v_67",
  "rating-label": "_rating-label_1on7v_73",
  "rounded-bars-wrapper": "_rounded-bars-wrapper_1on7v_79",
  "rating-value": "_rating-value_1on7v_86",
  "minmax-labels": "_minmax-labels_1on7v_92",
  "render-stars-and-bars": "_render-stars-and-bars_1on7v_100",
  "filled-star": "_filled-star_1on7v_104",
  "empty-star": "_empty-star_1on7v_109",
  bar: s6e,
  "highlighted-bar": "_highlighted-bar_1on7v_121"
}, Zd = ({ count: e, type: r }) => e > 0 ? /* @__PURE__ */ T.jsx("div", { className: Yn["render-stars-and-bars"], children: [...Array(e)].map((t) => e && /* @__PURE__ */ T.jsx("div", { className: Yn[r], "data-testid": r }, t)) }) : null, l6e = ({
  normalRatings: e
}) => /* @__PURE__ */ T.jsx(
  "div",
  {
    className: Yn["normal-secondary-ratings-wrapper"],
    "data-testid": "normal-secondary-ratings",
    children: Object.keys(e).map((r) => {
      const { AverageRating: t = 0, Label: n } = e[r], a = Math.round(t);
      return /* @__PURE__ */ T.jsxs("div", { className: Yn["secondary-rating"], children: [
        /* @__PURE__ */ T.jsx("div", { className: Yn.label, children: n }),
        /* @__PURE__ */ T.jsxs("div", { className: Yn.rating, children: [
          /* @__PURE__ */ T.jsxs("div", { className: Yn.stars, children: [
            /* @__PURE__ */ T.jsx(Zd, { count: a, type: "filled-star" }),
            /* @__PURE__ */ T.jsx(Zd, { count: 5 - a, type: "empty-star" })
          ] }),
          /* @__PURE__ */ T.jsx("div", { className: Yn.value, children: t.toFixed(1) })
        ] })
      ] }, r);
    })
  }
), u6e = ({
  sliderRatings: e
}) => /* @__PURE__ */ T.jsx(
  "div",
  {
    className: Yn["slider-secondary-ratings-wrapper"],
    "data-testid": "slider-secondary-ratings",
    children: Object.keys(e).map((r) => {
      const t = e[r], n = Math.round(
        e[r].AverageRating / e[r].ValueRange * 10
      );
      return /* @__PURE__ */ T.jsxs("div", { className: Yn["slider-ratings"], children: [
        /* @__PURE__ */ T.jsx("div", { className: Yn["rating-label"], children: t.Label }),
        /* @__PURE__ */ T.jsxs("div", { children: [
          /* @__PURE__ */ T.jsxs("div", { className: Yn["rounded-bars-wrapper"], children: [
            /* @__PURE__ */ T.jsx(Zd, { count: n - 1, type: "bar" }),
            /* @__PURE__ */ T.jsx(Zd, { count: 1, type: "highlighted-bar" }),
            /* @__PURE__ */ T.jsx(Zd, { count: 10 - n, type: "bar" })
          ] }),
          /* @__PURE__ */ T.jsxs("div", { className: Yn["minmax-labels"], children: [
            /* @__PURE__ */ T.jsx("div", { children: t.MinLabel }),
            /* @__PURE__ */ T.jsx("div", { children: t.MaxLabel })
          ] })
        ] })
      ] }, r);
    })
  }
), c6e = () => {
  const { secondaryRatingsAverages: e = {}, secondaryRatingsAveragesOrder: r = [] } = Ta(), t = {}, n = {};
  r.map((l) => {
    const u = e[l];
    u.DisplayType === "SLIDER" ? n[l] = u : t[l] = u;
  });
  const a = Object.keys(t).length > 0, i = Object.keys(n).length > 0;
  return /* @__PURE__ */ T.jsxs("div", { children: [
    a && /* @__PURE__ */ T.jsx(l6e, { normalRatings: t }),
    a && i && /* @__PURE__ */ T.jsx("div", { className: Yn["secondary-ratings-divider"] }),
    i && /* @__PURE__ */ T.jsx(u6e, { sliderRatings: n })
  ] });
}, d6e = "_divider_1bl9j_14", $s = {
  "review-section-top": "_review-section-top_1bl9j_2",
  divider: d6e,
  "desktop-divider": "_desktop-divider_1bl9j_24",
  "review-section-top-wrapper": "_review-section-top-wrapper_1bl9j_31",
  "rating-stats": "_rating-stats_1bl9j_46",
  "recommendation-rate": "_recommendation-rate_1bl9j_60"
}, b8e = () => {
  const { secondaryRatingsAveragesOrder: e = [], totalComments: r = 0 } = Ta();
  return /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsxs(
      "div",
      {
        className: $s["review-section-top"],
        "data-testid": "review-section-top",
        children: [
          /* @__PURE__ */ T.jsx("div", { className: $s["review-section-top-wrapper"], children: /* @__PURE__ */ T.jsxs("div", { className: $s["rating-stats"], "data-testid": "rating-stats", children: [
            /* @__PURE__ */ T.jsx(r6e, {}),
            /* @__PURE__ */ T.jsx(Xje, {})
          ] }) }),
          /* @__PURE__ */ T.jsx("div", { className: $s.divider }),
          e.length > 0 && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
            /* @__PURE__ */ T.jsx(
              "div",
              {
                className: $s["review-section-top-wrapper"],
                "data-testid": "secondary-ratings",
                children: /* @__PURE__ */ T.jsx(c6e, {})
              }
            ),
            /* @__PURE__ */ T.jsx("div", { className: $s.divider })
          ] }),
          /* @__PURE__ */ T.jsx(
            "div",
            {
              "data-testid": "recommendation-rate",
              className: $s["recommendation-rate"],
              children: /* @__PURE__ */ T.jsx(t6e, {})
            }
          )
        ]
      }
    ),
    r > 0 && /* @__PURE__ */ T.jsx("div", { className: $s["desktop-divider"] })
  ] });
}, yO = {
  "write-comment-section": "_write-comment-section_1fxc9_2",
  "give-rating-label": "_give-rating-label_1fxc9_20",
  "give-rating-stars": "_give-rating-stars_1fxc9_32"
}, y8e = () => {
  const { totalComments: e = 0 } = Ta(), { setActiveModal: r } = R_(), { isLoggedIn: t } = Co(), n = e > 0 ? ai.RATE_THIS_PRODUCT : ai.BE_THE_FIRST_TO_RATE, a = () => {
    t && r(Of.MainForm);
  };
  return /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: yO["write-comment-section"],
      onClick: a,
      id: "give-rating-button",
      children: [
        /* @__PURE__ */ T.jsx("div", { className: yO["give-rating-label"], children: n }),
        /* @__PURE__ */ T.jsx(S_, { rating: null })
      ]
    }
  );
}, f6e = "_modal_xpeer_13", v6e = "_header_xpeer_21", h6e = "_rating_xpeer_50", p6e = "_close_xpeer_61", g6e = "_footer_xpeer_82", m6e = "_helpfull_xpeer_101", yn = {
  "review-card": "_review-card_xpeer_2",
  modal: f6e,
  header: v6e,
  "review-modal": "_review-modal_xpeer_28",
  "user-name": "_user-name_xpeer_31",
  "review-title": "_review-title_xpeer_37",
  rating: h6e,
  "time-since": "_time-since_xpeer_55",
  close: p6e,
  "review-text": "_review-text_xpeer_69",
  "syndication-source": "_syndication-source_xpeer_76",
  footer: g6e,
  "review-helpfulness": "_review-helpfulness_xpeer_87",
  "review-helpfulness-clicked": "_review-helpfulness-clicked_xpeer_88",
  "review-helpfulness-disable": "_review-helpfulness-disable_xpeer_89",
  helpfull: m6e,
  "not-helpfull": "_not-helpfull_xpeer_108",
  "helpfulness-text": "_helpfulness-text_xpeer_124",
  "rating-close": "_rating-close_xpeer_132"
}, b6e = "_modal_mk17y_2", y6e = "_close_mk17y_34", cp = {
  modal: b6e,
  "modal-content": "_modal-content_mk17y_15",
  "photo-review-card": "_photo-review-card_mk17y_29",
  close: y6e
}, S6e = "_next_191xw_28", x6e = "_prev_191xw_49", $6e = "_close_191xw_69", w6e = "_dot_191xw_80", _6e = "_active_191xw_101", Fu = {
  "modal-photo-slider": "_modal-photo-slider_191xw_2",
  "modal-photo": "_modal-photo_191xw_2",
  next: S6e,
  "next-arrow": "_next-arrow_191xw_41",
  prev: x6e,
  "prev-arrow": "_prev-arrow_191xw_62",
  close: $6e,
  "dots-container": "_dots-container_191xw_80",
  dot: w6e,
  active: _6e
};
var U0 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
U0.exports;
(function(e, r) {
  (function() {
    var t, n = "4.17.21", a = 200, i = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", u = "Invalid `variable` option passed into `_.template`", c = "__lodash_hash_undefined__", f = 500, h = "__lodash_placeholder__", p = 1, g = 2, y = 4, S = 1, x = 2, _ = 1, A = 2, O = 4, P = 8, j = 16, k = 32, L = 64, M = 128, W = 256, Z = 512, oe = 30, Ie = "...", Te = 800, Ee = 16, Me = 1, Fe = 2, Ge = 3, ze = 1 / 0, le = 9007199254740991, ce = 17976931348623157e292, he = 0 / 0, be = 4294967295, ye = be - 1, q = be >>> 1, ae = [
      ["ary", M],
      ["bind", _],
      ["bindKey", A],
      ["curry", P],
      ["curryRight", j],
      ["flip", Z],
      ["partial", k],
      ["partialRight", L],
      ["rearg", W]
    ], ue = "[object Arguments]", $e = "[object Array]", Ze = "[object AsyncFunction]", _e = "[object Boolean]", or = "[object Date]", Yr = "[object DOMException]", mr = "[object Error]", rt = "[object Function]", Je = "[object GeneratorFunction]", Ir = "[object Map]", wt = "[object Number]", Kr = "[object Null]", jr = "[object Object]", jt = "[object Promise]", gt = "[object Proxy]", pr = "[object RegExp]", br = "[object Set]", G = "[object String]", te = "[object Symbol]", Y = "[object Undefined]", Q = "[object WeakMap]", Ce = "[object WeakSet]", me = "[object ArrayBuffer]", Re = "[object DataView]", ur = "[object Float32Array]", Sr = "[object Float64Array]", lr = "[object Int8Array]", ct = "[object Int16Array]", at = "[object Int32Array]", mt = "[object Uint8Array]", Ct = "[object Uint8ClampedArray]", dr = "[object Uint16Array]", Zr = "[object Uint32Array]", cn = /\b__p \+= '';/g, dn = /\b(__p \+=) '' \+/g, Ka = /(__e\(.*?\)|\b__t\)) \+\n'';/g, wn = /&(?:amp|lt|gt|quot|#39);/g, pe = /[&<>"']/g, je = RegExp(wn.source), er = RegExp(pe.source), Dt = /<%-([\s\S]+?)%>/g, ot = /<%([\s\S]+?)%>/g, Dn = /<%=([\s\S]+?)%>/g, xe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ae = /^\w*$/, Se = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Pe = /[\\^$.*+?()[\]{}|]/g, rr = RegExp(Pe.source), Vr = /^\s+/, Zt = /\s/, qt = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Or = /\{\n\/\* \[wrapped with (.+)\] \*/, Za = /,? & /, Ys = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Ks = /[()=,{}\[\]\/\s]/, Zs = /\\(\\)?/g, qs = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, bt = /\w*$/, Qs = /^[-+]0x[0-9a-f]+$/i, Xs = /^0b[01]+$/i, Js = /^\[object .+?Constructor\]$/, el = /^0o[0-7]+$/i, rl = /^(?:0|[1-9]\d*)$/, tl = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, fn = /($^)/, nl = /['\n\r\u2028\u2029\\]/g, Nt = "\\ud800-\\udfff", Xn = "\\u0300-\\u036f", al = "\\ufe20-\\ufe2f", vn = "\\u20d0-\\u20ff", qa = Xn + al + vn, Vi = "\\u2700-\\u27bf", Wi = "a-z\\xdf-\\xf6\\xf8-\\xff", ol = "\\xac\\xb1\\xd7\\xf7", Eo = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", il = "\\u2000-\\u206f", sl = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Hi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Gi = "\\ufe0e\\ufe0f", Yi = ol + Eo + il + sl, ci = "['’]", ll = "[" + Nt + "]", Ki = "[" + Yi + "]", Ao = "[" + qa + "]", Zi = "\\d+", hn = "[" + Vi + "]", Nn = "[" + Wi + "]", qi = "[^" + Nt + Yi + Zi + Vi + Wi + Hi + "]", di = "\\ud83c[\\udffb-\\udfff]", Io = "(?:" + Ao + "|" + di + ")", Qi = "[^" + Nt + "]", fi = "(?:\\ud83c[\\udde6-\\uddff]){2}", vi = "[\\ud800-\\udbff][\\udc00-\\udfff]", _n = "[" + Hi + "]", Xi = "\\u200d", Ji = "(?:" + Nn + "|" + qi + ")", ul = "(?:" + _n + "|" + qi + ")", Ln = "(?:" + ci + "(?:d|ll|m|re|s|t|ve))?", es = "(?:" + ci + "(?:D|LL|M|RE|S|T|VE))?", rs = Io + "?", ts = "[" + Gi + "]?", pn = "(?:" + Xi + "(?:" + [Qi, fi, vi].join("|") + ")" + ts + rs + ")*", Jn = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", ea = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Fn = ts + rs + pn, cl = "(?:" + [hn, fi, vi].join("|") + ")" + Fn, Oo = "(?:" + [Qi + Ao + "?", Ao, fi, vi, ll].join("|") + ")", ra = RegExp(ci, "g"), Mo = RegExp(Ao, "g"), qr = RegExp(di + "(?=" + di + ")|" + Oo + Fn, "g"), Lt = RegExp([
      _n + "?" + Nn + "+" + Ln + "(?=" + [Ki, _n, "$"].join("|") + ")",
      ul + "+" + es + "(?=" + [Ki, _n + Ji, "$"].join("|") + ")",
      _n + "?" + Ji + "+" + Ln,
      _n + "+" + es,
      ea,
      Jn,
      Zi,
      cl
    ].join("|"), "g"), dl = RegExp("[" + Xi + Nt + qa + Gi + "]"), Ro = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, fl = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Po = -1, xr = {};
    xr[ur] = xr[Sr] = xr[lr] = xr[ct] = xr[at] = xr[mt] = xr[Ct] = xr[dr] = xr[Zr] = !0, xr[ue] = xr[$e] = xr[me] = xr[_e] = xr[Re] = xr[or] = xr[mr] = xr[rt] = xr[Ir] = xr[wt] = xr[jr] = xr[pr] = xr[br] = xr[G] = xr[Q] = !1;
    var yr = {};
    yr[ue] = yr[$e] = yr[me] = yr[Re] = yr[_e] = yr[or] = yr[ur] = yr[Sr] = yr[lr] = yr[ct] = yr[at] = yr[Ir] = yr[wt] = yr[jr] = yr[pr] = yr[br] = yr[G] = yr[te] = yr[mt] = yr[Ct] = yr[dr] = yr[Zr] = !0, yr[mr] = yr[rt] = yr[Q] = !1;
    var ko = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, vl = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, v = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, b = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, $ = parseFloat, N = parseInt, ie = typeof Ri == "object" && Ri && Ri.Object === Object && Ri, ve = typeof self == "object" && self && self.Object === Object && self, de = ie || ve || Function("return this")(), ne = r && !r.nodeType && r, ge = ne && !0 && e && !e.nodeType && e, tr = ge && ge.exports === ne, Ke = tr && ie.process, Mr = function() {
      try {
        var U = ge && ge.require && ge.require("util").types;
        return U || Ke && Ke.binding && Ke.binding("util");
      } catch (X) {
      }
    }(), zn = Mr && Mr.isArrayBuffer, Bn = Mr && Mr.isDate, Qa = Mr && Mr.isMap, F_ = Mr && Mr.isRegExp, z_ = Mr && Mr.isSet, B_ = Mr && Mr.isTypedArray;
    function ta(U, X, K) {
      switch (K.length) {
        case 0:
          return U.call(X);
        case 1:
          return U.call(X, K[0]);
        case 2:
          return U.call(X, K[0], K[1]);
        case 3:
          return U.call(X, K[0], K[1], K[2]);
      }
      return U.apply(X, K);
    }
    function mN(U, X, K, Oe) {
      for (var qe = -1, $r = U == null ? 0 : U.length; ++qe < $r; ) {
        var Ft = U[qe];
        X(Oe, Ft, K(Ft), U);
      }
      return Oe;
    }
    function Ca(U, X) {
      for (var K = -1, Oe = U == null ? 0 : U.length; ++K < Oe && X(U[K], K, U) !== !1; )
        ;
      return U;
    }
    function bN(U, X) {
      for (var K = U == null ? 0 : U.length; K-- && X(U[K], K, U) !== !1; )
        ;
      return U;
    }
    function U_(U, X) {
      for (var K = -1, Oe = U == null ? 0 : U.length; ++K < Oe; )
        if (!X(U[K], K, U))
          return !1;
      return !0;
    }
    function ns(U, X) {
      for (var K = -1, Oe = U == null ? 0 : U.length, qe = 0, $r = []; ++K < Oe; ) {
        var Ft = U[K];
        X(Ft, K, U) && ($r[qe++] = Ft);
      }
      return $r;
    }
    function ov(U, X) {
      var K = U == null ? 0 : U.length;
      return !!K && gu(U, X, 0) > -1;
    }
    function Tm(U, X, K) {
      for (var Oe = -1, qe = U == null ? 0 : U.length; ++Oe < qe; )
        if (K(X, U[Oe]))
          return !0;
      return !1;
    }
    function dt(U, X) {
      for (var K = -1, Oe = U == null ? 0 : U.length, qe = Array(Oe); ++K < Oe; )
        qe[K] = X(U[K], K, U);
      return qe;
    }
    function as(U, X) {
      for (var K = -1, Oe = X.length, qe = U.length; ++K < Oe; )
        U[qe + K] = X[K];
      return U;
    }
    function Cm(U, X, K, Oe) {
      var qe = -1, $r = U == null ? 0 : U.length;
      for (Oe && $r && (K = U[++qe]); ++qe < $r; )
        K = X(K, U[qe], qe, U);
      return K;
    }
    function yN(U, X, K, Oe) {
      var qe = U == null ? 0 : U.length;
      for (Oe && qe && (K = U[--qe]); qe--; )
        K = X(K, U[qe], qe, U);
      return K;
    }
    function Em(U, X) {
      for (var K = -1, Oe = U == null ? 0 : U.length; ++K < Oe; )
        if (X(U[K], K, U))
          return !0;
      return !1;
    }
    var SN = Am("length");
    function xN(U) {
      return U.split("");
    }
    function $N(U) {
      return U.match(Ys) || [];
    }
    function V_(U, X, K) {
      var Oe;
      return K(U, function(qe, $r, Ft) {
        if (X(qe, $r, Ft))
          return Oe = $r, !1;
      }), Oe;
    }
    function iv(U, X, K, Oe) {
      for (var qe = U.length, $r = K + (Oe ? 1 : -1); Oe ? $r-- : ++$r < qe; )
        if (X(U[$r], $r, U))
          return $r;
      return -1;
    }
    function gu(U, X, K) {
      return X === X ? kN(U, X, K) : iv(U, W_, K);
    }
    function wN(U, X, K, Oe) {
      for (var qe = K - 1, $r = U.length; ++qe < $r; )
        if (Oe(U[qe], X))
          return qe;
      return -1;
    }
    function W_(U) {
      return U !== U;
    }
    function H_(U, X) {
      var K = U == null ? 0 : U.length;
      return K ? Om(U, X) / K : he;
    }
    function Am(U) {
      return function(X) {
        return X == null ? t : X[U];
      };
    }
    function Im(U) {
      return function(X) {
        return U == null ? t : U[X];
      };
    }
    function G_(U, X, K, Oe, qe) {
      return qe(U, function($r, Ft, Qr) {
        K = Oe ? (Oe = !1, $r) : X(K, $r, Ft, Qr);
      }), K;
    }
    function _N(U, X) {
      var K = U.length;
      for (U.sort(X); K--; )
        U[K] = U[K].value;
      return U;
    }
    function Om(U, X) {
      for (var K, Oe = -1, qe = U.length; ++Oe < qe; ) {
        var $r = X(U[Oe]);
        $r !== t && (K = K === t ? $r : K + $r);
      }
      return K;
    }
    function Mm(U, X) {
      for (var K = -1, Oe = Array(U); ++K < U; )
        Oe[K] = X(K);
      return Oe;
    }
    function TN(U, X) {
      return dt(X, function(K) {
        return [K, U[K]];
      });
    }
    function Y_(U) {
      return U && U.slice(0, Q_(U) + 1).replace(Vr, "");
    }
    function na(U) {
      return function(X) {
        return U(X);
      };
    }
    function Rm(U, X) {
      return dt(X, function(K) {
        return U[K];
      });
    }
    function Fc(U, X) {
      return U.has(X);
    }
    function K_(U, X) {
      for (var K = -1, Oe = U.length; ++K < Oe && gu(X, U[K], 0) > -1; )
        ;
      return K;
    }
    function Z_(U, X) {
      for (var K = U.length; K-- && gu(X, U[K], 0) > -1; )
        ;
      return K;
    }
    function CN(U, X) {
      for (var K = U.length, Oe = 0; K--; )
        U[K] === X && ++Oe;
      return Oe;
    }
    var EN = Im(ko), AN = Im(vl);
    function IN(U) {
      return "\\" + b[U];
    }
    function ON(U, X) {
      return U == null ? t : U[X];
    }
    function mu(U) {
      return dl.test(U);
    }
    function MN(U) {
      return Ro.test(U);
    }
    function RN(U) {
      for (var X, K = []; !(X = U.next()).done; )
        K.push(X.value);
      return K;
    }
    function Pm(U) {
      var X = -1, K = Array(U.size);
      return U.forEach(function(Oe, qe) {
        K[++X] = [qe, Oe];
      }), K;
    }
    function q_(U, X) {
      return function(K) {
        return U(X(K));
      };
    }
    function os(U, X) {
      for (var K = -1, Oe = U.length, qe = 0, $r = []; ++K < Oe; ) {
        var Ft = U[K];
        (Ft === X || Ft === h) && (U[K] = h, $r[qe++] = K);
      }
      return $r;
    }
    function sv(U) {
      var X = -1, K = Array(U.size);
      return U.forEach(function(Oe) {
        K[++X] = Oe;
      }), K;
    }
    function PN(U) {
      var X = -1, K = Array(U.size);
      return U.forEach(function(Oe) {
        K[++X] = [Oe, Oe];
      }), K;
    }
    function kN(U, X, K) {
      for (var Oe = K - 1, qe = U.length; ++Oe < qe; )
        if (U[Oe] === X)
          return Oe;
      return -1;
    }
    function jN(U, X, K) {
      for (var Oe = K + 1; Oe--; )
        if (U[Oe] === X)
          return Oe;
      return Oe;
    }
    function bu(U) {
      return mu(U) ? NN(U) : SN(U);
    }
    function Xa(U) {
      return mu(U) ? LN(U) : xN(U);
    }
    function Q_(U) {
      for (var X = U.length; X-- && Zt.test(U.charAt(X)); )
        ;
      return X;
    }
    var DN = Im(v);
    function NN(U) {
      for (var X = qr.lastIndex = 0; qr.test(U); )
        ++X;
      return X;
    }
    function LN(U) {
      return U.match(qr) || [];
    }
    function FN(U) {
      return U.match(Lt) || [];
    }
    var zN = function U(X) {
      X = X == null ? de : yu.defaults(de.Object(), X, yu.pick(de, fl));
      var K = X.Array, Oe = X.Date, qe = X.Error, $r = X.Function, Ft = X.Math, Qr = X.Object, km = X.RegExp, BN = X.String, Ea = X.TypeError, lv = K.prototype, UN = $r.prototype, Su = Qr.prototype, uv = X["__core-js_shared__"], cv = UN.toString, Dr = Su.hasOwnProperty, VN = 0, X_ = function() {
        var o = /[^.]+$/.exec(uv && uv.keys && uv.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), dv = Su.toString, WN = cv.call(Qr), HN = de._, GN = km(
        "^" + cv.call(Dr).replace(Pe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), fv = tr ? X.Buffer : t, is = X.Symbol, vv = X.Uint8Array, J_ = fv ? fv.allocUnsafe : t, hv = q_(Qr.getPrototypeOf, Qr), e5 = Qr.create, r5 = Su.propertyIsEnumerable, pv = lv.splice, t5 = is ? is.isConcatSpreadable : t, zc = is ? is.iterator : t, hl = is ? is.toStringTag : t, gv = function() {
        try {
          var o = yl(Qr, "defineProperty");
          return o({}, "", {}), o;
        } catch (s) {
        }
      }(), YN = X.clearTimeout !== de.clearTimeout && X.clearTimeout, KN = Oe && Oe.now !== de.Date.now && Oe.now, ZN = X.setTimeout !== de.setTimeout && X.setTimeout, mv = Ft.ceil, bv = Ft.floor, jm = Qr.getOwnPropertySymbols, qN = fv ? fv.isBuffer : t, n5 = X.isFinite, QN = lv.join, XN = q_(Qr.keys, Qr), zt = Ft.max, gn = Ft.min, JN = Oe.now, eL = X.parseInt, a5 = Ft.random, rL = lv.reverse, Dm = yl(X, "DataView"), Bc = yl(X, "Map"), Nm = yl(X, "Promise"), xu = yl(X, "Set"), Uc = yl(X, "WeakMap"), Vc = yl(Qr, "create"), yv = Uc && new Uc(), $u = {}, tL = Sl(Dm), nL = Sl(Bc), aL = Sl(Nm), oL = Sl(xu), iL = Sl(Uc), Sv = is ? is.prototype : t, Wc = Sv ? Sv.valueOf : t, o5 = Sv ? Sv.toString : t;
      function C(o) {
        if (_t(o) && !Xe(o) && !(o instanceof fr)) {
          if (o instanceof Aa)
            return o;
          if (Dr.call(o, "__wrapped__"))
            return iT(o);
        }
        return new Aa(o);
      }
      var wu = function() {
        function o() {
        }
        return function(s) {
          if (!yt(s))
            return {};
          if (e5)
            return e5(s);
          o.prototype = s;
          var d = new o();
          return o.prototype = t, d;
        };
      }();
      function xv() {
      }
      function Aa(o, s) {
        this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!s, this.__index__ = 0, this.__values__ = t;
      }
      C.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Dt,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: ot,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Dn,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: C
        }
      }, C.prototype = xv.prototype, C.prototype.constructor = C, Aa.prototype = wu(xv.prototype), Aa.prototype.constructor = Aa;
      function fr(o) {
        this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = be, this.__views__ = [];
      }
      function sL() {
        var o = new fr(this.__wrapped__);
        return o.__actions__ = Un(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = Un(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = Un(this.__views__), o;
      }
      function lL() {
        if (this.__filtered__) {
          var o = new fr(this);
          o.__dir__ = -1, o.__filtered__ = !0;
        } else
          o = this.clone(), o.__dir__ *= -1;
        return o;
      }
      function uL() {
        var o = this.__wrapped__.value(), s = this.__dir__, d = Xe(o), m = s < 0, w = d ? o.length : 0, E = x9(0, w, this.__views__), R = E.start, D = E.end, V = D - R, J = m ? D : R - 1, ee = this.__iteratees__, se = ee.length, we = 0, ke = gn(V, this.__takeCount__);
        if (!d || !m && w == V && ke == V)
          return I5(o, this.__actions__);
        var Ue = [];
        e:
          for (; V-- && we < ke; ) {
            J += s;
            for (var ir = -1, Ve = o[J]; ++ir < se; ) {
              var cr = ee[ir], hr = cr.iteratee, ia = cr.type, En = hr(Ve);
              if (ia == Fe)
                Ve = En;
              else if (!En) {
                if (ia == Me)
                  continue e;
                break e;
              }
            }
            Ue[we++] = Ve;
          }
        return Ue;
      }
      fr.prototype = wu(xv.prototype), fr.prototype.constructor = fr;
      function pl(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++s < d; ) {
          var m = o[s];
          this.set(m[0], m[1]);
        }
      }
      function cL() {
        this.__data__ = Vc ? Vc(null) : {}, this.size = 0;
      }
      function dL(o) {
        var s = this.has(o) && delete this.__data__[o];
        return this.size -= s ? 1 : 0, s;
      }
      function fL(o) {
        var s = this.__data__;
        if (Vc) {
          var d = s[o];
          return d === c ? t : d;
        }
        return Dr.call(s, o) ? s[o] : t;
      }
      function vL(o) {
        var s = this.__data__;
        return Vc ? s[o] !== t : Dr.call(s, o);
      }
      function hL(o, s) {
        var d = this.__data__;
        return this.size += this.has(o) ? 0 : 1, d[o] = Vc && s === t ? c : s, this;
      }
      pl.prototype.clear = cL, pl.prototype.delete = dL, pl.prototype.get = fL, pl.prototype.has = vL, pl.prototype.set = hL;
      function hi(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++s < d; ) {
          var m = o[s];
          this.set(m[0], m[1]);
        }
      }
      function pL() {
        this.__data__ = [], this.size = 0;
      }
      function gL(o) {
        var s = this.__data__, d = $v(s, o);
        if (d < 0)
          return !1;
        var m = s.length - 1;
        return d == m ? s.pop() : pv.call(s, d, 1), --this.size, !0;
      }
      function mL(o) {
        var s = this.__data__, d = $v(s, o);
        return d < 0 ? t : s[d][1];
      }
      function bL(o) {
        return $v(this.__data__, o) > -1;
      }
      function yL(o, s) {
        var d = this.__data__, m = $v(d, o);
        return m < 0 ? (++this.size, d.push([o, s])) : d[m][1] = s, this;
      }
      hi.prototype.clear = pL, hi.prototype.delete = gL, hi.prototype.get = mL, hi.prototype.has = bL, hi.prototype.set = yL;
      function pi(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.clear(); ++s < d; ) {
          var m = o[s];
          this.set(m[0], m[1]);
        }
      }
      function SL() {
        this.size = 0, this.__data__ = {
          hash: new pl(),
          map: new (Bc || hi)(),
          string: new pl()
        };
      }
      function xL(o) {
        var s = kv(this, o).delete(o);
        return this.size -= s ? 1 : 0, s;
      }
      function $L(o) {
        return kv(this, o).get(o);
      }
      function wL(o) {
        return kv(this, o).has(o);
      }
      function _L(o, s) {
        var d = kv(this, o), m = d.size;
        return d.set(o, s), this.size += d.size == m ? 0 : 1, this;
      }
      pi.prototype.clear = SL, pi.prototype.delete = xL, pi.prototype.get = $L, pi.prototype.has = wL, pi.prototype.set = _L;
      function gl(o) {
        var s = -1, d = o == null ? 0 : o.length;
        for (this.__data__ = new pi(); ++s < d; )
          this.add(o[s]);
      }
      function TL(o) {
        return this.__data__.set(o, c), this;
      }
      function CL(o) {
        return this.__data__.has(o);
      }
      gl.prototype.add = gl.prototype.push = TL, gl.prototype.has = CL;
      function Ja(o) {
        var s = this.__data__ = new hi(o);
        this.size = s.size;
      }
      function EL() {
        this.__data__ = new hi(), this.size = 0;
      }
      function AL(o) {
        var s = this.__data__, d = s.delete(o);
        return this.size = s.size, d;
      }
      function IL(o) {
        return this.__data__.get(o);
      }
      function OL(o) {
        return this.__data__.has(o);
      }
      function ML(o, s) {
        var d = this.__data__;
        if (d instanceof hi) {
          var m = d.__data__;
          if (!Bc || m.length < a - 1)
            return m.push([o, s]), this.size = ++d.size, this;
          d = this.__data__ = new pi(m);
        }
        return d.set(o, s), this.size = d.size, this;
      }
      Ja.prototype.clear = EL, Ja.prototype.delete = AL, Ja.prototype.get = IL, Ja.prototype.has = OL, Ja.prototype.set = ML;
      function i5(o, s) {
        var d = Xe(o), m = !d && xl(o), w = !d && !m && ds(o), E = !d && !m && !w && Eu(o), R = d || m || w || E, D = R ? Mm(o.length, BN) : [], V = D.length;
        for (var J in o)
          (s || Dr.call(o, J)) && !(R && // Safari 9 has enumerable `arguments.length` in strict mode.
          (J == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          w && (J == "offset" || J == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          E && (J == "buffer" || J == "byteLength" || J == "byteOffset") || // Skip index properties.
          yi(J, V))) && D.push(J);
        return D;
      }
      function s5(o) {
        var s = o.length;
        return s ? o[Km(0, s - 1)] : t;
      }
      function RL(o, s) {
        return jv(Un(o), ml(s, 0, o.length));
      }
      function PL(o) {
        return jv(Un(o));
      }
      function Lm(o, s, d) {
        (d !== t && !eo(o[s], d) || d === t && !(s in o)) && gi(o, s, d);
      }
      function Hc(o, s, d) {
        var m = o[s];
        (!(Dr.call(o, s) && eo(m, d)) || d === t && !(s in o)) && gi(o, s, d);
      }
      function $v(o, s) {
        for (var d = o.length; d--; )
          if (eo(o[d][0], s))
            return d;
        return -1;
      }
      function kL(o, s, d, m) {
        return ss(o, function(w, E, R) {
          s(m, w, d(w), R);
        }), m;
      }
      function l5(o, s) {
        return o && Do(s, Wt(s), o);
      }
      function jL(o, s) {
        return o && Do(s, Wn(s), o);
      }
      function gi(o, s, d) {
        s == "__proto__" && gv ? gv(o, s, {
          configurable: !0,
          enumerable: !0,
          value: d,
          writable: !0
        }) : o[s] = d;
      }
      function Fm(o, s) {
        for (var d = -1, m = s.length, w = K(m), E = o == null; ++d < m; )
          w[d] = E ? t : yb(o, s[d]);
        return w;
      }
      function ml(o, s, d) {
        return o === o && (d !== t && (o = o <= d ? o : d), s !== t && (o = o >= s ? o : s)), o;
      }
      function Ia(o, s, d, m, w, E) {
        var R, D = s & p, V = s & g, J = s & y;
        if (d && (R = w ? d(o, m, w, E) : d(o)), R !== t)
          return R;
        if (!yt(o))
          return o;
        var ee = Xe(o);
        if (ee) {
          if (R = w9(o), !D)
            return Un(o, R);
        } else {
          var se = mn(o), we = se == rt || se == Je;
          if (ds(o))
            return R5(o, D);
          if (se == jr || se == ue || we && !w) {
            if (R = V || we ? {} : Q5(o), !D)
              return V ? f9(o, jL(R, o)) : d9(o, l5(R, o));
          } else {
            if (!yr[se])
              return w ? o : {};
            R = _9(o, se, D);
          }
        }
        E || (E = new Ja());
        var ke = E.get(o);
        if (ke)
          return ke;
        E.set(o, R), CT(o) ? o.forEach(function(Ve) {
          R.add(Ia(Ve, s, d, Ve, o, E));
        }) : _T(o) && o.forEach(function(Ve, cr) {
          R.set(cr, Ia(Ve, s, d, cr, o, E));
        });
        var Ue = J ? V ? ob : ab : V ? Wn : Wt, ir = ee ? t : Ue(o);
        return Ca(ir || o, function(Ve, cr) {
          ir && (cr = Ve, Ve = o[cr]), Hc(R, cr, Ia(Ve, s, d, cr, o, E));
        }), R;
      }
      function DL(o) {
        var s = Wt(o);
        return function(d) {
          return u5(d, o, s);
        };
      }
      function u5(o, s, d) {
        var m = d.length;
        if (o == null)
          return !m;
        for (o = Qr(o); m--; ) {
          var w = d[m], E = s[w], R = o[w];
          if (R === t && !(w in o) || !E(R))
            return !1;
        }
        return !0;
      }
      function c5(o, s, d) {
        if (typeof o != "function")
          throw new Ea(l);
        return Xc(function() {
          o.apply(t, d);
        }, s);
      }
      function Gc(o, s, d, m) {
        var w = -1, E = ov, R = !0, D = o.length, V = [], J = s.length;
        if (!D)
          return V;
        d && (s = dt(s, na(d))), m ? (E = Tm, R = !1) : s.length >= a && (E = Fc, R = !1, s = new gl(s));
        e:
          for (; ++w < D; ) {
            var ee = o[w], se = d == null ? ee : d(ee);
            if (ee = m || ee !== 0 ? ee : 0, R && se === se) {
              for (var we = J; we--; )
                if (s[we] === se)
                  continue e;
              V.push(ee);
            } else
              E(s, se, m) || V.push(ee);
          }
        return V;
      }
      var ss = N5(jo), d5 = N5(Bm, !0);
      function NL(o, s) {
        var d = !0;
        return ss(o, function(m, w, E) {
          return d = !!s(m, w, E), d;
        }), d;
      }
      function wv(o, s, d) {
        for (var m = -1, w = o.length; ++m < w; ) {
          var E = o[m], R = s(E);
          if (R != null && (D === t ? R === R && !oa(R) : d(R, D)))
            var D = R, V = E;
        }
        return V;
      }
      function LL(o, s, d, m) {
        var w = o.length;
        for (d = nr(d), d < 0 && (d = -d > w ? 0 : w + d), m = m === t || m > w ? w : nr(m), m < 0 && (m += w), m = d > m ? 0 : AT(m); d < m; )
          o[d++] = s;
        return o;
      }
      function f5(o, s) {
        var d = [];
        return ss(o, function(m, w, E) {
          s(m, w, E) && d.push(m);
        }), d;
      }
      function Qt(o, s, d, m, w) {
        var E = -1, R = o.length;
        for (d || (d = C9), w || (w = []); ++E < R; ) {
          var D = o[E];
          s > 0 && d(D) ? s > 1 ? Qt(D, s - 1, d, m, w) : as(w, D) : m || (w[w.length] = D);
        }
        return w;
      }
      var zm = L5(), v5 = L5(!0);
      function jo(o, s) {
        return o && zm(o, s, Wt);
      }
      function Bm(o, s) {
        return o && v5(o, s, Wt);
      }
      function _v(o, s) {
        return ns(s, function(d) {
          return Si(o[d]);
        });
      }
      function bl(o, s) {
        s = us(s, o);
        for (var d = 0, m = s.length; o != null && d < m; )
          o = o[No(s[d++])];
        return d && d == m ? o : t;
      }
      function h5(o, s, d) {
        var m = s(o);
        return Xe(o) ? m : as(m, d(o));
      }
      function Tn(o) {
        return o == null ? o === t ? Y : Kr : hl && hl in Qr(o) ? S9(o) : P9(o);
      }
      function Um(o, s) {
        return o > s;
      }
      function FL(o, s) {
        return o != null && Dr.call(o, s);
      }
      function zL(o, s) {
        return o != null && s in Qr(o);
      }
      function BL(o, s, d) {
        return o >= gn(s, d) && o < zt(s, d);
      }
      function Vm(o, s, d) {
        for (var m = d ? Tm : ov, w = o[0].length, E = o.length, R = E, D = K(E), V = 1 / 0, J = []; R--; ) {
          var ee = o[R];
          R && s && (ee = dt(ee, na(s))), V = gn(ee.length, V), D[R] = !d && (s || w >= 120 && ee.length >= 120) ? new gl(R && ee) : t;
        }
        ee = o[0];
        var se = -1, we = D[0];
        e:
          for (; ++se < w && J.length < V; ) {
            var ke = ee[se], Ue = s ? s(ke) : ke;
            if (ke = d || ke !== 0 ? ke : 0, !(we ? Fc(we, Ue) : m(J, Ue, d))) {
              for (R = E; --R; ) {
                var ir = D[R];
                if (!(ir ? Fc(ir, Ue) : m(o[R], Ue, d)))
                  continue e;
              }
              we && we.push(Ue), J.push(ke);
            }
          }
        return J;
      }
      function UL(o, s, d, m) {
        return jo(o, function(w, E, R) {
          s(m, d(w), E, R);
        }), m;
      }
      function Yc(o, s, d) {
        s = us(s, o), o = rT(o, s);
        var m = o == null ? o : o[No(Ma(s))];
        return m == null ? t : ta(m, o, d);
      }
      function p5(o) {
        return _t(o) && Tn(o) == ue;
      }
      function VL(o) {
        return _t(o) && Tn(o) == me;
      }
      function WL(o) {
        return _t(o) && Tn(o) == or;
      }
      function Kc(o, s, d, m, w) {
        return o === s ? !0 : o == null || s == null || !_t(o) && !_t(s) ? o !== o && s !== s : HL(o, s, d, m, Kc, w);
      }
      function HL(o, s, d, m, w, E) {
        var R = Xe(o), D = Xe(s), V = R ? $e : mn(o), J = D ? $e : mn(s);
        V = V == ue ? jr : V, J = J == ue ? jr : J;
        var ee = V == jr, se = J == jr, we = V == J;
        if (we && ds(o)) {
          if (!ds(s))
            return !1;
          R = !0, ee = !1;
        }
        if (we && !ee)
          return E || (E = new Ja()), R || Eu(o) ? K5(o, s, d, m, w, E) : b9(o, s, V, d, m, w, E);
        if (!(d & S)) {
          var ke = ee && Dr.call(o, "__wrapped__"), Ue = se && Dr.call(s, "__wrapped__");
          if (ke || Ue) {
            var ir = ke ? o.value() : o, Ve = Ue ? s.value() : s;
            return E || (E = new Ja()), w(ir, Ve, d, m, E);
          }
        }
        return we ? (E || (E = new Ja()), y9(o, s, d, m, w, E)) : !1;
      }
      function GL(o) {
        return _t(o) && mn(o) == Ir;
      }
      function Wm(o, s, d, m) {
        var w = d.length, E = w, R = !m;
        if (o == null)
          return !E;
        for (o = Qr(o); w--; ) {
          var D = d[w];
          if (R && D[2] ? D[1] !== o[D[0]] : !(D[0] in o))
            return !1;
        }
        for (; ++w < E; ) {
          D = d[w];
          var V = D[0], J = o[V], ee = D[1];
          if (R && D[2]) {
            if (J === t && !(V in o))
              return !1;
          } else {
            var se = new Ja();
            if (m)
              var we = m(J, ee, V, o, s, se);
            if (!(we === t ? Kc(ee, J, S | x, m, se) : we))
              return !1;
          }
        }
        return !0;
      }
      function g5(o) {
        if (!yt(o) || A9(o))
          return !1;
        var s = Si(o) ? GN : Js;
        return s.test(Sl(o));
      }
      function YL(o) {
        return _t(o) && Tn(o) == pr;
      }
      function KL(o) {
        return _t(o) && mn(o) == br;
      }
      function ZL(o) {
        return _t(o) && Bv(o.length) && !!xr[Tn(o)];
      }
      function m5(o) {
        return typeof o == "function" ? o : o == null ? Hn : typeof o == "object" ? Xe(o) ? S5(o[0], o[1]) : y5(o) : FT(o);
      }
      function Hm(o) {
        if (!Qc(o))
          return XN(o);
        var s = [];
        for (var d in Qr(o))
          Dr.call(o, d) && d != "constructor" && s.push(d);
        return s;
      }
      function qL(o) {
        if (!yt(o))
          return R9(o);
        var s = Qc(o), d = [];
        for (var m in o)
          m == "constructor" && (s || !Dr.call(o, m)) || d.push(m);
        return d;
      }
      function Gm(o, s) {
        return o < s;
      }
      function b5(o, s) {
        var d = -1, m = Vn(o) ? K(o.length) : [];
        return ss(o, function(w, E, R) {
          m[++d] = s(w, E, R);
        }), m;
      }
      function y5(o) {
        var s = sb(o);
        return s.length == 1 && s[0][2] ? J5(s[0][0], s[0][1]) : function(d) {
          return d === o || Wm(d, o, s);
        };
      }
      function S5(o, s) {
        return ub(o) && X5(s) ? J5(No(o), s) : function(d) {
          var m = yb(d, o);
          return m === t && m === s ? Sb(d, o) : Kc(s, m, S | x);
        };
      }
      function Tv(o, s, d, m, w) {
        o !== s && zm(s, function(E, R) {
          if (w || (w = new Ja()), yt(E))
            QL(o, s, R, d, Tv, m, w);
          else {
            var D = m ? m(db(o, R), E, R + "", o, s, w) : t;
            D === t && (D = E), Lm(o, R, D);
          }
        }, Wn);
      }
      function QL(o, s, d, m, w, E, R) {
        var D = db(o, d), V = db(s, d), J = R.get(V);
        if (J) {
          Lm(o, d, J);
          return;
        }
        var ee = E ? E(D, V, d + "", o, s, R) : t, se = ee === t;
        if (se) {
          var we = Xe(V), ke = !we && ds(V), Ue = !we && !ke && Eu(V);
          ee = V, we || ke || Ue ? Xe(D) ? ee = D : Et(D) ? ee = Un(D) : ke ? (se = !1, ee = R5(V, !0)) : Ue ? (se = !1, ee = P5(V, !0)) : ee = [] : Jc(V) || xl(V) ? (ee = D, xl(D) ? ee = IT(D) : (!yt(D) || Si(D)) && (ee = Q5(V))) : se = !1;
        }
        se && (R.set(V, ee), w(ee, V, m, E, R), R.delete(V)), Lm(o, d, ee);
      }
      function x5(o, s) {
        var d = o.length;
        if (d)
          return s += s < 0 ? d : 0, yi(s, d) ? o[s] : t;
      }
      function $5(o, s, d) {
        s.length ? s = dt(s, function(E) {
          return Xe(E) ? function(R) {
            return bl(R, E.length === 1 ? E[0] : E);
          } : E;
        }) : s = [Hn];
        var m = -1;
        s = dt(s, na(Be()));
        var w = b5(o, function(E, R, D) {
          var V = dt(s, function(J) {
            return J(E);
          });
          return { criteria: V, index: ++m, value: E };
        });
        return _N(w, function(E, R) {
          return c9(E, R, d);
        });
      }
      function XL(o, s) {
        return w5(o, s, function(d, m) {
          return Sb(o, m);
        });
      }
      function w5(o, s, d) {
        for (var m = -1, w = s.length, E = {}; ++m < w; ) {
          var R = s[m], D = bl(o, R);
          d(D, R) && Zc(E, us(R, o), D);
        }
        return E;
      }
      function JL(o) {
        return function(s) {
          return bl(s, o);
        };
      }
      function Ym(o, s, d, m) {
        var w = m ? wN : gu, E = -1, R = s.length, D = o;
        for (o === s && (s = Un(s)), d && (D = dt(o, na(d))); ++E < R; )
          for (var V = 0, J = s[E], ee = d ? d(J) : J; (V = w(D, ee, V, m)) > -1; )
            D !== o && pv.call(D, V, 1), pv.call(o, V, 1);
        return o;
      }
      function _5(o, s) {
        for (var d = o ? s.length : 0, m = d - 1; d--; ) {
          var w = s[d];
          if (d == m || w !== E) {
            var E = w;
            yi(w) ? pv.call(o, w, 1) : Qm(o, w);
          }
        }
        return o;
      }
      function Km(o, s) {
        return o + bv(a5() * (s - o + 1));
      }
      function e9(o, s, d, m) {
        for (var w = -1, E = zt(mv((s - o) / (d || 1)), 0), R = K(E); E--; )
          R[m ? E : ++w] = o, o += d;
        return R;
      }
      function Zm(o, s) {
        var d = "";
        if (!o || s < 1 || s > le)
          return d;
        do
          s % 2 && (d += o), s = bv(s / 2), s && (o += o);
        while (s);
        return d;
      }
      function sr(o, s) {
        return fb(eT(o, s, Hn), o + "");
      }
      function r9(o) {
        return s5(Au(o));
      }
      function t9(o, s) {
        var d = Au(o);
        return jv(d, ml(s, 0, d.length));
      }
      function Zc(o, s, d, m) {
        if (!yt(o))
          return o;
        s = us(s, o);
        for (var w = -1, E = s.length, R = E - 1, D = o; D != null && ++w < E; ) {
          var V = No(s[w]), J = d;
          if (V === "__proto__" || V === "constructor" || V === "prototype")
            return o;
          if (w != R) {
            var ee = D[V];
            J = m ? m(ee, V, D) : t, J === t && (J = yt(ee) ? ee : yi(s[w + 1]) ? [] : {});
          }
          Hc(D, V, J), D = D[V];
        }
        return o;
      }
      var T5 = yv ? function(o, s) {
        return yv.set(o, s), o;
      } : Hn, n9 = gv ? function(o, s) {
        return gv(o, "toString", {
          configurable: !0,
          enumerable: !1,
          value: $b(s),
          writable: !0
        });
      } : Hn;
      function a9(o) {
        return jv(Au(o));
      }
      function Oa(o, s, d) {
        var m = -1, w = o.length;
        s < 0 && (s = -s > w ? 0 : w + s), d = d > w ? w : d, d < 0 && (d += w), w = s > d ? 0 : d - s >>> 0, s >>>= 0;
        for (var E = K(w); ++m < w; )
          E[m] = o[m + s];
        return E;
      }
      function o9(o, s) {
        var d;
        return ss(o, function(m, w, E) {
          return d = s(m, w, E), !d;
        }), !!d;
      }
      function Cv(o, s, d) {
        var m = 0, w = o == null ? m : o.length;
        if (typeof s == "number" && s === s && w <= q) {
          for (; m < w; ) {
            var E = m + w >>> 1, R = o[E];
            R !== null && !oa(R) && (d ? R <= s : R < s) ? m = E + 1 : w = E;
          }
          return w;
        }
        return qm(o, s, Hn, d);
      }
      function qm(o, s, d, m) {
        var w = 0, E = o == null ? 0 : o.length;
        if (E === 0)
          return 0;
        s = d(s);
        for (var R = s !== s, D = s === null, V = oa(s), J = s === t; w < E; ) {
          var ee = bv((w + E) / 2), se = d(o[ee]), we = se !== t, ke = se === null, Ue = se === se, ir = oa(se);
          if (R)
            var Ve = m || Ue;
          else
            J ? Ve = Ue && (m || we) : D ? Ve = Ue && we && (m || !ke) : V ? Ve = Ue && we && !ke && (m || !ir) : ke || ir ? Ve = !1 : Ve = m ? se <= s : se < s;
          Ve ? w = ee + 1 : E = ee;
        }
        return gn(E, ye);
      }
      function C5(o, s) {
        for (var d = -1, m = o.length, w = 0, E = []; ++d < m; ) {
          var R = o[d], D = s ? s(R) : R;
          if (!d || !eo(D, V)) {
            var V = D;
            E[w++] = R === 0 ? 0 : R;
          }
        }
        return E;
      }
      function E5(o) {
        return typeof o == "number" ? o : oa(o) ? he : +o;
      }
      function aa(o) {
        if (typeof o == "string")
          return o;
        if (Xe(o))
          return dt(o, aa) + "";
        if (oa(o))
          return o5 ? o5.call(o) : "";
        var s = o + "";
        return s == "0" && 1 / o == -ze ? "-0" : s;
      }
      function ls(o, s, d) {
        var m = -1, w = ov, E = o.length, R = !0, D = [], V = D;
        if (d)
          R = !1, w = Tm;
        else if (E >= a) {
          var J = s ? null : g9(o);
          if (J)
            return sv(J);
          R = !1, w = Fc, V = new gl();
        } else
          V = s ? [] : D;
        e:
          for (; ++m < E; ) {
            var ee = o[m], se = s ? s(ee) : ee;
            if (ee = d || ee !== 0 ? ee : 0, R && se === se) {
              for (var we = V.length; we--; )
                if (V[we] === se)
                  continue e;
              s && V.push(se), D.push(ee);
            } else
              w(V, se, d) || (V !== D && V.push(se), D.push(ee));
          }
        return D;
      }
      function Qm(o, s) {
        return s = us(s, o), o = rT(o, s), o == null || delete o[No(Ma(s))];
      }
      function A5(o, s, d, m) {
        return Zc(o, s, d(bl(o, s)), m);
      }
      function Ev(o, s, d, m) {
        for (var w = o.length, E = m ? w : -1; (m ? E-- : ++E < w) && s(o[E], E, o); )
          ;
        return d ? Oa(o, m ? 0 : E, m ? E + 1 : w) : Oa(o, m ? E + 1 : 0, m ? w : E);
      }
      function I5(o, s) {
        var d = o;
        return d instanceof fr && (d = d.value()), Cm(s, function(m, w) {
          return w.func.apply(w.thisArg, as([m], w.args));
        }, d);
      }
      function Xm(o, s, d) {
        var m = o.length;
        if (m < 2)
          return m ? ls(o[0]) : [];
        for (var w = -1, E = K(m); ++w < m; )
          for (var R = o[w], D = -1; ++D < m; )
            D != w && (E[w] = Gc(E[w] || R, o[D], s, d));
        return ls(Qt(E, 1), s, d);
      }
      function O5(o, s, d) {
        for (var m = -1, w = o.length, E = s.length, R = {}; ++m < w; ) {
          var D = m < E ? s[m] : t;
          d(R, o[m], D);
        }
        return R;
      }
      function Jm(o) {
        return Et(o) ? o : [];
      }
      function eb(o) {
        return typeof o == "function" ? o : Hn;
      }
      function us(o, s) {
        return Xe(o) ? o : ub(o, s) ? [o] : oT(Rr(o));
      }
      var i9 = sr;
      function cs(o, s, d) {
        var m = o.length;
        return d = d === t ? m : d, !s && d >= m ? o : Oa(o, s, d);
      }
      var M5 = YN || function(o) {
        return de.clearTimeout(o);
      };
      function R5(o, s) {
        if (s)
          return o.slice();
        var d = o.length, m = J_ ? J_(d) : new o.constructor(d);
        return o.copy(m), m;
      }
      function rb(o) {
        var s = new o.constructor(o.byteLength);
        return new vv(s).set(new vv(o)), s;
      }
      function s9(o, s) {
        var d = s ? rb(o.buffer) : o.buffer;
        return new o.constructor(d, o.byteOffset, o.byteLength);
      }
      function l9(o) {
        var s = new o.constructor(o.source, bt.exec(o));
        return s.lastIndex = o.lastIndex, s;
      }
      function u9(o) {
        return Wc ? Qr(Wc.call(o)) : {};
      }
      function P5(o, s) {
        var d = s ? rb(o.buffer) : o.buffer;
        return new o.constructor(d, o.byteOffset, o.length);
      }
      function k5(o, s) {
        if (o !== s) {
          var d = o !== t, m = o === null, w = o === o, E = oa(o), R = s !== t, D = s === null, V = s === s, J = oa(s);
          if (!D && !J && !E && o > s || E && R && V && !D && !J || m && R && V || !d && V || !w)
            return 1;
          if (!m && !E && !J && o < s || J && d && w && !m && !E || D && d && w || !R && w || !V)
            return -1;
        }
        return 0;
      }
      function c9(o, s, d) {
        for (var m = -1, w = o.criteria, E = s.criteria, R = w.length, D = d.length; ++m < R; ) {
          var V = k5(w[m], E[m]);
          if (V) {
            if (m >= D)
              return V;
            var J = d[m];
            return V * (J == "desc" ? -1 : 1);
          }
        }
        return o.index - s.index;
      }
      function j5(o, s, d, m) {
        for (var w = -1, E = o.length, R = d.length, D = -1, V = s.length, J = zt(E - R, 0), ee = K(V + J), se = !m; ++D < V; )
          ee[D] = s[D];
        for (; ++w < R; )
          (se || w < E) && (ee[d[w]] = o[w]);
        for (; J--; )
          ee[D++] = o[w++];
        return ee;
      }
      function D5(o, s, d, m) {
        for (var w = -1, E = o.length, R = -1, D = d.length, V = -1, J = s.length, ee = zt(E - D, 0), se = K(ee + J), we = !m; ++w < ee; )
          se[w] = o[w];
        for (var ke = w; ++V < J; )
          se[ke + V] = s[V];
        for (; ++R < D; )
          (we || w < E) && (se[ke + d[R]] = o[w++]);
        return se;
      }
      function Un(o, s) {
        var d = -1, m = o.length;
        for (s || (s = K(m)); ++d < m; )
          s[d] = o[d];
        return s;
      }
      function Do(o, s, d, m) {
        var w = !d;
        d || (d = {});
        for (var E = -1, R = s.length; ++E < R; ) {
          var D = s[E], V = m ? m(d[D], o[D], D, d, o) : t;
          V === t && (V = o[D]), w ? gi(d, D, V) : Hc(d, D, V);
        }
        return d;
      }
      function d9(o, s) {
        return Do(o, lb(o), s);
      }
      function f9(o, s) {
        return Do(o, Z5(o), s);
      }
      function Av(o, s) {
        return function(d, m) {
          var w = Xe(d) ? mN : kL, E = s ? s() : {};
          return w(d, o, Be(m, 2), E);
        };
      }
      function _u(o) {
        return sr(function(s, d) {
          var m = -1, w = d.length, E = w > 1 ? d[w - 1] : t, R = w > 2 ? d[2] : t;
          for (E = o.length > 3 && typeof E == "function" ? (w--, E) : t, R && Cn(d[0], d[1], R) && (E = w < 3 ? t : E, w = 1), s = Qr(s); ++m < w; ) {
            var D = d[m];
            D && o(s, D, m, E);
          }
          return s;
        });
      }
      function N5(o, s) {
        return function(d, m) {
          if (d == null)
            return d;
          if (!Vn(d))
            return o(d, m);
          for (var w = d.length, E = s ? w : -1, R = Qr(d); (s ? E-- : ++E < w) && m(R[E], E, R) !== !1; )
            ;
          return d;
        };
      }
      function L5(o) {
        return function(s, d, m) {
          for (var w = -1, E = Qr(s), R = m(s), D = R.length; D--; ) {
            var V = R[o ? D : ++w];
            if (d(E[V], V, E) === !1)
              break;
          }
          return s;
        };
      }
      function v9(o, s, d) {
        var m = s & _, w = qc(o);
        function E() {
          var R = this && this !== de && this instanceof E ? w : o;
          return R.apply(m ? d : this, arguments);
        }
        return E;
      }
      function F5(o) {
        return function(s) {
          s = Rr(s);
          var d = mu(s) ? Xa(s) : t, m = d ? d[0] : s.charAt(0), w = d ? cs(d, 1).join("") : s.slice(1);
          return m[o]() + w;
        };
      }
      function Tu(o) {
        return function(s) {
          return Cm(NT(DT(s).replace(ra, "")), o, "");
        };
      }
      function qc(o) {
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return new o();
            case 1:
              return new o(s[0]);
            case 2:
              return new o(s[0], s[1]);
            case 3:
              return new o(s[0], s[1], s[2]);
            case 4:
              return new o(s[0], s[1], s[2], s[3]);
            case 5:
              return new o(s[0], s[1], s[2], s[3], s[4]);
            case 6:
              return new o(s[0], s[1], s[2], s[3], s[4], s[5]);
            case 7:
              return new o(s[0], s[1], s[2], s[3], s[4], s[5], s[6]);
          }
          var d = wu(o.prototype), m = o.apply(d, s);
          return yt(m) ? m : d;
        };
      }
      function h9(o, s, d) {
        var m = qc(o);
        function w() {
          for (var E = arguments.length, R = K(E), D = E, V = Cu(w); D--; )
            R[D] = arguments[D];
          var J = E < 3 && R[0] !== V && R[E - 1] !== V ? [] : os(R, V);
          if (E -= J.length, E < d)
            return W5(
              o,
              s,
              Iv,
              w.placeholder,
              t,
              R,
              J,
              t,
              t,
              d - E
            );
          var ee = this && this !== de && this instanceof w ? m : o;
          return ta(ee, this, R);
        }
        return w;
      }
      function z5(o) {
        return function(s, d, m) {
          var w = Qr(s);
          if (!Vn(s)) {
            var E = Be(d, 3);
            s = Wt(s), d = function(D) {
              return E(w[D], D, w);
            };
          }
          var R = o(s, d, m);
          return R > -1 ? w[E ? s[R] : R] : t;
        };
      }
      function B5(o) {
        return bi(function(s) {
          var d = s.length, m = d, w = Aa.prototype.thru;
          for (o && s.reverse(); m--; ) {
            var E = s[m];
            if (typeof E != "function")
              throw new Ea(l);
            if (w && !R && Pv(E) == "wrapper")
              var R = new Aa([], !0);
          }
          for (m = R ? m : d; ++m < d; ) {
            E = s[m];
            var D = Pv(E), V = D == "wrapper" ? ib(E) : t;
            V && cb(V[0]) && V[1] == (M | P | k | W) && !V[4].length && V[9] == 1 ? R = R[Pv(V[0])].apply(R, V[3]) : R = E.length == 1 && cb(E) ? R[D]() : R.thru(E);
          }
          return function() {
            var J = arguments, ee = J[0];
            if (R && J.length == 1 && Xe(ee))
              return R.plant(ee).value();
            for (var se = 0, we = d ? s[se].apply(this, J) : ee; ++se < d; )
              we = s[se].call(this, we);
            return we;
          };
        });
      }
      function Iv(o, s, d, m, w, E, R, D, V, J) {
        var ee = s & M, se = s & _, we = s & A, ke = s & (P | j), Ue = s & Z, ir = we ? t : qc(o);
        function Ve() {
          for (var cr = arguments.length, hr = K(cr), ia = cr; ia--; )
            hr[ia] = arguments[ia];
          if (ke)
            var En = Cu(Ve), sa = CN(hr, En);
          if (m && (hr = j5(hr, m, w, ke)), E && (hr = D5(hr, E, R, ke)), cr -= sa, ke && cr < J) {
            var At = os(hr, En);
            return W5(
              o,
              s,
              Iv,
              Ve.placeholder,
              d,
              hr,
              At,
              D,
              V,
              J - cr
            );
          }
          var ro = se ? d : this, $i = we ? ro[o] : o;
          return cr = hr.length, D ? hr = k9(hr, D) : Ue && cr > 1 && hr.reverse(), ee && V < cr && (hr.length = V), this && this !== de && this instanceof Ve && ($i = ir || qc($i)), $i.apply(ro, hr);
        }
        return Ve;
      }
      function U5(o, s) {
        return function(d, m) {
          return UL(d, o, s(m), {});
        };
      }
      function Ov(o, s) {
        return function(d, m) {
          var w;
          if (d === t && m === t)
            return s;
          if (d !== t && (w = d), m !== t) {
            if (w === t)
              return m;
            typeof d == "string" || typeof m == "string" ? (d = aa(d), m = aa(m)) : (d = E5(d), m = E5(m)), w = o(d, m);
          }
          return w;
        };
      }
      function tb(o) {
        return bi(function(s) {
          return s = dt(s, na(Be())), sr(function(d) {
            var m = this;
            return o(s, function(w) {
              return ta(w, m, d);
            });
          });
        });
      }
      function Mv(o, s) {
        s = s === t ? " " : aa(s);
        var d = s.length;
        if (d < 2)
          return d ? Zm(s, o) : s;
        var m = Zm(s, mv(o / bu(s)));
        return mu(s) ? cs(Xa(m), 0, o).join("") : m.slice(0, o);
      }
      function p9(o, s, d, m) {
        var w = s & _, E = qc(o);
        function R() {
          for (var D = -1, V = arguments.length, J = -1, ee = m.length, se = K(ee + V), we = this && this !== de && this instanceof R ? E : o; ++J < ee; )
            se[J] = m[J];
          for (; V--; )
            se[J++] = arguments[++D];
          return ta(we, w ? d : this, se);
        }
        return R;
      }
      function V5(o) {
        return function(s, d, m) {
          return m && typeof m != "number" && Cn(s, d, m) && (d = m = t), s = xi(s), d === t ? (d = s, s = 0) : d = xi(d), m = m === t ? s < d ? 1 : -1 : xi(m), e9(s, d, m, o);
        };
      }
      function Rv(o) {
        return function(s, d) {
          return typeof s == "string" && typeof d == "string" || (s = Ra(s), d = Ra(d)), o(s, d);
        };
      }
      function W5(o, s, d, m, w, E, R, D, V, J) {
        var ee = s & P, se = ee ? R : t, we = ee ? t : R, ke = ee ? E : t, Ue = ee ? t : E;
        s |= ee ? k : L, s &= ~(ee ? L : k), s & O || (s &= ~(_ | A));
        var ir = [
          o,
          s,
          w,
          ke,
          se,
          Ue,
          we,
          D,
          V,
          J
        ], Ve = d.apply(t, ir);
        return cb(o) && tT(Ve, ir), Ve.placeholder = m, nT(Ve, o, s);
      }
      function nb(o) {
        var s = Ft[o];
        return function(d, m) {
          if (d = Ra(d), m = m == null ? 0 : gn(nr(m), 292), m && n5(d)) {
            var w = (Rr(d) + "e").split("e"), E = s(w[0] + "e" + (+w[1] + m));
            return w = (Rr(E) + "e").split("e"), +(w[0] + "e" + (+w[1] - m));
          }
          return s(d);
        };
      }
      var g9 = xu && 1 / sv(new xu([, -0]))[1] == ze ? function(o) {
        return new xu(o);
      } : Tb;
      function H5(o) {
        return function(s) {
          var d = mn(s);
          return d == Ir ? Pm(s) : d == br ? PN(s) : TN(s, o(s));
        };
      }
      function mi(o, s, d, m, w, E, R, D) {
        var V = s & A;
        if (!V && typeof o != "function")
          throw new Ea(l);
        var J = m ? m.length : 0;
        if (J || (s &= ~(k | L), m = w = t), R = R === t ? R : zt(nr(R), 0), D = D === t ? D : nr(D), J -= w ? w.length : 0, s & L) {
          var ee = m, se = w;
          m = w = t;
        }
        var we = V ? t : ib(o), ke = [
          o,
          s,
          d,
          m,
          w,
          ee,
          se,
          E,
          R,
          D
        ];
        if (we && M9(ke, we), o = ke[0], s = ke[1], d = ke[2], m = ke[3], w = ke[4], D = ke[9] = ke[9] === t ? V ? 0 : o.length : zt(ke[9] - J, 0), !D && s & (P | j) && (s &= ~(P | j)), !s || s == _)
          var Ue = v9(o, s, d);
        else
          s == P || s == j ? Ue = h9(o, s, D) : (s == k || s == (_ | k)) && !w.length ? Ue = p9(o, s, d, m) : Ue = Iv.apply(t, ke);
        var ir = we ? T5 : tT;
        return nT(ir(Ue, ke), o, s);
      }
      function G5(o, s, d, m) {
        return o === t || eo(o, Su[d]) && !Dr.call(m, d) ? s : o;
      }
      function Y5(o, s, d, m, w, E) {
        return yt(o) && yt(s) && (E.set(s, o), Tv(o, s, t, Y5, E), E.delete(s)), o;
      }
      function m9(o) {
        return Jc(o) ? t : o;
      }
      function K5(o, s, d, m, w, E) {
        var R = d & S, D = o.length, V = s.length;
        if (D != V && !(R && V > D))
          return !1;
        var J = E.get(o), ee = E.get(s);
        if (J && ee)
          return J == s && ee == o;
        var se = -1, we = !0, ke = d & x ? new gl() : t;
        for (E.set(o, s), E.set(s, o); ++se < D; ) {
          var Ue = o[se], ir = s[se];
          if (m)
            var Ve = R ? m(ir, Ue, se, s, o, E) : m(Ue, ir, se, o, s, E);
          if (Ve !== t) {
            if (Ve)
              continue;
            we = !1;
            break;
          }
          if (ke) {
            if (!Em(s, function(cr, hr) {
              if (!Fc(ke, hr) && (Ue === cr || w(Ue, cr, d, m, E)))
                return ke.push(hr);
            })) {
              we = !1;
              break;
            }
          } else if (!(Ue === ir || w(Ue, ir, d, m, E))) {
            we = !1;
            break;
          }
        }
        return E.delete(o), E.delete(s), we;
      }
      function b9(o, s, d, m, w, E, R) {
        switch (d) {
          case Re:
            if (o.byteLength != s.byteLength || o.byteOffset != s.byteOffset)
              return !1;
            o = o.buffer, s = s.buffer;
          case me:
            return !(o.byteLength != s.byteLength || !E(new vv(o), new vv(s)));
          case _e:
          case or:
          case wt:
            return eo(+o, +s);
          case mr:
            return o.name == s.name && o.message == s.message;
          case pr:
          case G:
            return o == s + "";
          case Ir:
            var D = Pm;
          case br:
            var V = m & S;
            if (D || (D = sv), o.size != s.size && !V)
              return !1;
            var J = R.get(o);
            if (J)
              return J == s;
            m |= x, R.set(o, s);
            var ee = K5(D(o), D(s), m, w, E, R);
            return R.delete(o), ee;
          case te:
            if (Wc)
              return Wc.call(o) == Wc.call(s);
        }
        return !1;
      }
      function y9(o, s, d, m, w, E) {
        var R = d & S, D = ab(o), V = D.length, J = ab(s), ee = J.length;
        if (V != ee && !R)
          return !1;
        for (var se = V; se--; ) {
          var we = D[se];
          if (!(R ? we in s : Dr.call(s, we)))
            return !1;
        }
        var ke = E.get(o), Ue = E.get(s);
        if (ke && Ue)
          return ke == s && Ue == o;
        var ir = !0;
        E.set(o, s), E.set(s, o);
        for (var Ve = R; ++se < V; ) {
          we = D[se];
          var cr = o[we], hr = s[we];
          if (m)
            var ia = R ? m(hr, cr, we, s, o, E) : m(cr, hr, we, o, s, E);
          if (!(ia === t ? cr === hr || w(cr, hr, d, m, E) : ia)) {
            ir = !1;
            break;
          }
          Ve || (Ve = we == "constructor");
        }
        if (ir && !Ve) {
          var En = o.constructor, sa = s.constructor;
          En != sa && "constructor" in o && "constructor" in s && !(typeof En == "function" && En instanceof En && typeof sa == "function" && sa instanceof sa) && (ir = !1);
        }
        return E.delete(o), E.delete(s), ir;
      }
      function bi(o) {
        return fb(eT(o, t, uT), o + "");
      }
      function ab(o) {
        return h5(o, Wt, lb);
      }
      function ob(o) {
        return h5(o, Wn, Z5);
      }
      var ib = yv ? function(o) {
        return yv.get(o);
      } : Tb;
      function Pv(o) {
        for (var s = o.name + "", d = $u[s], m = Dr.call($u, s) ? d.length : 0; m--; ) {
          var w = d[m], E = w.func;
          if (E == null || E == o)
            return w.name;
        }
        return s;
      }
      function Cu(o) {
        var s = Dr.call(C, "placeholder") ? C : o;
        return s.placeholder;
      }
      function Be() {
        var o = C.iteratee || wb;
        return o = o === wb ? m5 : o, arguments.length ? o(arguments[0], arguments[1]) : o;
      }
      function kv(o, s) {
        var d = o.__data__;
        return E9(s) ? d[typeof s == "string" ? "string" : "hash"] : d.map;
      }
      function sb(o) {
        for (var s = Wt(o), d = s.length; d--; ) {
          var m = s[d], w = o[m];
          s[d] = [m, w, X5(w)];
        }
        return s;
      }
      function yl(o, s) {
        var d = ON(o, s);
        return g5(d) ? d : t;
      }
      function S9(o) {
        var s = Dr.call(o, hl), d = o[hl];
        try {
          o[hl] = t;
          var m = !0;
        } catch (E) {
        }
        var w = dv.call(o);
        return m && (s ? o[hl] = d : delete o[hl]), w;
      }
      var lb = jm ? function(o) {
        return o == null ? [] : (o = Qr(o), ns(jm(o), function(s) {
          return r5.call(o, s);
        }));
      } : Cb, Z5 = jm ? function(o) {
        for (var s = []; o; )
          as(s, lb(o)), o = hv(o);
        return s;
      } : Cb, mn = Tn;
      (Dm && mn(new Dm(new ArrayBuffer(1))) != Re || Bc && mn(new Bc()) != Ir || Nm && mn(Nm.resolve()) != jt || xu && mn(new xu()) != br || Uc && mn(new Uc()) != Q) && (mn = function(o) {
        var s = Tn(o), d = s == jr ? o.constructor : t, m = d ? Sl(d) : "";
        if (m)
          switch (m) {
            case tL:
              return Re;
            case nL:
              return Ir;
            case aL:
              return jt;
            case oL:
              return br;
            case iL:
              return Q;
          }
        return s;
      });
      function x9(o, s, d) {
        for (var m = -1, w = d.length; ++m < w; ) {
          var E = d[m], R = E.size;
          switch (E.type) {
            case "drop":
              o += R;
              break;
            case "dropRight":
              s -= R;
              break;
            case "take":
              s = gn(s, o + R);
              break;
            case "takeRight":
              o = zt(o, s - R);
              break;
          }
        }
        return { start: o, end: s };
      }
      function $9(o) {
        var s = o.match(Or);
        return s ? s[1].split(Za) : [];
      }
      function q5(o, s, d) {
        s = us(s, o);
        for (var m = -1, w = s.length, E = !1; ++m < w; ) {
          var R = No(s[m]);
          if (!(E = o != null && d(o, R)))
            break;
          o = o[R];
        }
        return E || ++m != w ? E : (w = o == null ? 0 : o.length, !!w && Bv(w) && yi(R, w) && (Xe(o) || xl(o)));
      }
      function w9(o) {
        var s = o.length, d = new o.constructor(s);
        return s && typeof o[0] == "string" && Dr.call(o, "index") && (d.index = o.index, d.input = o.input), d;
      }
      function Q5(o) {
        return typeof o.constructor == "function" && !Qc(o) ? wu(hv(o)) : {};
      }
      function _9(o, s, d) {
        var m = o.constructor;
        switch (s) {
          case me:
            return rb(o);
          case _e:
          case or:
            return new m(+o);
          case Re:
            return s9(o, d);
          case ur:
          case Sr:
          case lr:
          case ct:
          case at:
          case mt:
          case Ct:
          case dr:
          case Zr:
            return P5(o, d);
          case Ir:
            return new m();
          case wt:
          case G:
            return new m(o);
          case pr:
            return l9(o);
          case br:
            return new m();
          case te:
            return u9(o);
        }
      }
      function T9(o, s) {
        var d = s.length;
        if (!d)
          return o;
        var m = d - 1;
        return s[m] = (d > 1 ? "& " : "") + s[m], s = s.join(d > 2 ? ", " : " "), o.replace(qt, `{
/* [wrapped with ` + s + `] */
`);
      }
      function C9(o) {
        return Xe(o) || xl(o) || !!(t5 && o && o[t5]);
      }
      function yi(o, s) {
        var d = typeof o;
        return s = s == null ? le : s, !!s && (d == "number" || d != "symbol" && rl.test(o)) && o > -1 && o % 1 == 0 && o < s;
      }
      function Cn(o, s, d) {
        if (!yt(d))
          return !1;
        var m = typeof s;
        return (m == "number" ? Vn(d) && yi(s, d.length) : m == "string" && s in d) ? eo(d[s], o) : !1;
      }
      function ub(o, s) {
        if (Xe(o))
          return !1;
        var d = typeof o;
        return d == "number" || d == "symbol" || d == "boolean" || o == null || oa(o) ? !0 : Ae.test(o) || !xe.test(o) || s != null && o in Qr(s);
      }
      function E9(o) {
        var s = typeof o;
        return s == "string" || s == "number" || s == "symbol" || s == "boolean" ? o !== "__proto__" : o === null;
      }
      function cb(o) {
        var s = Pv(o), d = C[s];
        if (typeof d != "function" || !(s in fr.prototype))
          return !1;
        if (o === d)
          return !0;
        var m = ib(d);
        return !!m && o === m[0];
      }
      function A9(o) {
        return !!X_ && X_ in o;
      }
      var I9 = uv ? Si : Eb;
      function Qc(o) {
        var s = o && o.constructor, d = typeof s == "function" && s.prototype || Su;
        return o === d;
      }
      function X5(o) {
        return o === o && !yt(o);
      }
      function J5(o, s) {
        return function(d) {
          return d == null ? !1 : d[o] === s && (s !== t || o in Qr(d));
        };
      }
      function O9(o) {
        var s = Fv(o, function(m) {
          return d.size === f && d.clear(), m;
        }), d = s.cache;
        return s;
      }
      function M9(o, s) {
        var d = o[1], m = s[1], w = d | m, E = w < (_ | A | M), R = m == M && d == P || m == M && d == W && o[7].length <= s[8] || m == (M | W) && s[7].length <= s[8] && d == P;
        if (!(E || R))
          return o;
        m & _ && (o[2] = s[2], w |= d & _ ? 0 : O);
        var D = s[3];
        if (D) {
          var V = o[3];
          o[3] = V ? j5(V, D, s[4]) : D, o[4] = V ? os(o[3], h) : s[4];
        }
        return D = s[5], D && (V = o[5], o[5] = V ? D5(V, D, s[6]) : D, o[6] = V ? os(o[5], h) : s[6]), D = s[7], D && (o[7] = D), m & M && (o[8] = o[8] == null ? s[8] : gn(o[8], s[8])), o[9] == null && (o[9] = s[9]), o[0] = s[0], o[1] = w, o;
      }
      function R9(o) {
        var s = [];
        if (o != null)
          for (var d in Qr(o))
            s.push(d);
        return s;
      }
      function P9(o) {
        return dv.call(o);
      }
      function eT(o, s, d) {
        return s = zt(s === t ? o.length - 1 : s, 0), function() {
          for (var m = arguments, w = -1, E = zt(m.length - s, 0), R = K(E); ++w < E; )
            R[w] = m[s + w];
          w = -1;
          for (var D = K(s + 1); ++w < s; )
            D[w] = m[w];
          return D[s] = d(R), ta(o, this, D);
        };
      }
      function rT(o, s) {
        return s.length < 2 ? o : bl(o, Oa(s, 0, -1));
      }
      function k9(o, s) {
        for (var d = o.length, m = gn(s.length, d), w = Un(o); m--; ) {
          var E = s[m];
          o[m] = yi(E, d) ? w[E] : t;
        }
        return o;
      }
      function db(o, s) {
        if (!(s === "constructor" && typeof o[s] == "function") && s != "__proto__")
          return o[s];
      }
      var tT = aT(T5), Xc = ZN || function(o, s) {
        return de.setTimeout(o, s);
      }, fb = aT(n9);
      function nT(o, s, d) {
        var m = s + "";
        return fb(o, T9(m, j9($9(m), d)));
      }
      function aT(o) {
        var s = 0, d = 0;
        return function() {
          var m = JN(), w = Ee - (m - d);
          if (d = m, w > 0) {
            if (++s >= Te)
              return arguments[0];
          } else
            s = 0;
          return o.apply(t, arguments);
        };
      }
      function jv(o, s) {
        var d = -1, m = o.length, w = m - 1;
        for (s = s === t ? m : s; ++d < s; ) {
          var E = Km(d, w), R = o[E];
          o[E] = o[d], o[d] = R;
        }
        return o.length = s, o;
      }
      var oT = O9(function(o) {
        var s = [];
        return o.charCodeAt(0) === 46 && s.push(""), o.replace(Se, function(d, m, w, E) {
          s.push(w ? E.replace(Zs, "$1") : m || d);
        }), s;
      });
      function No(o) {
        if (typeof o == "string" || oa(o))
          return o;
        var s = o + "";
        return s == "0" && 1 / o == -ze ? "-0" : s;
      }
      function Sl(o) {
        if (o != null) {
          try {
            return cv.call(o);
          } catch (s) {
          }
          try {
            return o + "";
          } catch (s) {
          }
        }
        return "";
      }
      function j9(o, s) {
        return Ca(ae, function(d) {
          var m = "_." + d[0];
          s & d[1] && !ov(o, m) && o.push(m);
        }), o.sort();
      }
      function iT(o) {
        if (o instanceof fr)
          return o.clone();
        var s = new Aa(o.__wrapped__, o.__chain__);
        return s.__actions__ = Un(o.__actions__), s.__index__ = o.__index__, s.__values__ = o.__values__, s;
      }
      function D9(o, s, d) {
        (d ? Cn(o, s, d) : s === t) ? s = 1 : s = zt(nr(s), 0);
        var m = o == null ? 0 : o.length;
        if (!m || s < 1)
          return [];
        for (var w = 0, E = 0, R = K(mv(m / s)); w < m; )
          R[E++] = Oa(o, w, w += s);
        return R;
      }
      function N9(o) {
        for (var s = -1, d = o == null ? 0 : o.length, m = 0, w = []; ++s < d; ) {
          var E = o[s];
          E && (w[m++] = E);
        }
        return w;
      }
      function L9() {
        var o = arguments.length;
        if (!o)
          return [];
        for (var s = K(o - 1), d = arguments[0], m = o; m--; )
          s[m - 1] = arguments[m];
        return as(Xe(d) ? Un(d) : [d], Qt(s, 1));
      }
      var F9 = sr(function(o, s) {
        return Et(o) ? Gc(o, Qt(s, 1, Et, !0)) : [];
      }), z9 = sr(function(o, s) {
        var d = Ma(s);
        return Et(d) && (d = t), Et(o) ? Gc(o, Qt(s, 1, Et, !0), Be(d, 2)) : [];
      }), B9 = sr(function(o, s) {
        var d = Ma(s);
        return Et(d) && (d = t), Et(o) ? Gc(o, Qt(s, 1, Et, !0), t, d) : [];
      });
      function U9(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (s = d || s === t ? 1 : nr(s), Oa(o, s < 0 ? 0 : s, m)) : [];
      }
      function V9(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (s = d || s === t ? 1 : nr(s), s = m - s, Oa(o, 0, s < 0 ? 0 : s)) : [];
      }
      function W9(o, s) {
        return o && o.length ? Ev(o, Be(s, 3), !0, !0) : [];
      }
      function H9(o, s) {
        return o && o.length ? Ev(o, Be(s, 3), !0) : [];
      }
      function G9(o, s, d, m) {
        var w = o == null ? 0 : o.length;
        return w ? (d && typeof d != "number" && Cn(o, s, d) && (d = 0, m = w), LL(o, s, d, m)) : [];
      }
      function sT(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = d == null ? 0 : nr(d);
        return w < 0 && (w = zt(m + w, 0)), iv(o, Be(s, 3), w);
      }
      function lT(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = m - 1;
        return d !== t && (w = nr(d), w = d < 0 ? zt(m + w, 0) : gn(w, m - 1)), iv(o, Be(s, 3), w, !0);
      }
      function uT(o) {
        var s = o == null ? 0 : o.length;
        return s ? Qt(o, 1) : [];
      }
      function Y9(o) {
        var s = o == null ? 0 : o.length;
        return s ? Qt(o, ze) : [];
      }
      function K9(o, s) {
        var d = o == null ? 0 : o.length;
        return d ? (s = s === t ? 1 : nr(s), Qt(o, s)) : [];
      }
      function Z9(o) {
        for (var s = -1, d = o == null ? 0 : o.length, m = {}; ++s < d; ) {
          var w = o[s];
          m[w[0]] = w[1];
        }
        return m;
      }
      function cT(o) {
        return o && o.length ? o[0] : t;
      }
      function q9(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = d == null ? 0 : nr(d);
        return w < 0 && (w = zt(m + w, 0)), gu(o, s, w);
      }
      function Q9(o) {
        var s = o == null ? 0 : o.length;
        return s ? Oa(o, 0, -1) : [];
      }
      var X9 = sr(function(o) {
        var s = dt(o, Jm);
        return s.length && s[0] === o[0] ? Vm(s) : [];
      }), J9 = sr(function(o) {
        var s = Ma(o), d = dt(o, Jm);
        return s === Ma(d) ? s = t : d.pop(), d.length && d[0] === o[0] ? Vm(d, Be(s, 2)) : [];
      }), e7 = sr(function(o) {
        var s = Ma(o), d = dt(o, Jm);
        return s = typeof s == "function" ? s : t, s && d.pop(), d.length && d[0] === o[0] ? Vm(d, t, s) : [];
      });
      function r7(o, s) {
        return o == null ? "" : QN.call(o, s);
      }
      function Ma(o) {
        var s = o == null ? 0 : o.length;
        return s ? o[s - 1] : t;
      }
      function t7(o, s, d) {
        var m = o == null ? 0 : o.length;
        if (!m)
          return -1;
        var w = m;
        return d !== t && (w = nr(d), w = w < 0 ? zt(m + w, 0) : gn(w, m - 1)), s === s ? jN(o, s, w) : iv(o, W_, w, !0);
      }
      function n7(o, s) {
        return o && o.length ? x5(o, nr(s)) : t;
      }
      var a7 = sr(dT);
      function dT(o, s) {
        return o && o.length && s && s.length ? Ym(o, s) : o;
      }
      function o7(o, s, d) {
        return o && o.length && s && s.length ? Ym(o, s, Be(d, 2)) : o;
      }
      function i7(o, s, d) {
        return o && o.length && s && s.length ? Ym(o, s, t, d) : o;
      }
      var s7 = bi(function(o, s) {
        var d = o == null ? 0 : o.length, m = Fm(o, s);
        return _5(o, dt(s, function(w) {
          return yi(w, d) ? +w : w;
        }).sort(k5)), m;
      });
      function l7(o, s) {
        var d = [];
        if (!(o && o.length))
          return d;
        var m = -1, w = [], E = o.length;
        for (s = Be(s, 3); ++m < E; ) {
          var R = o[m];
          s(R, m, o) && (d.push(R), w.push(m));
        }
        return _5(o, w), d;
      }
      function vb(o) {
        return o == null ? o : rL.call(o);
      }
      function u7(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (d && typeof d != "number" && Cn(o, s, d) ? (s = 0, d = m) : (s = s == null ? 0 : nr(s), d = d === t ? m : nr(d)), Oa(o, s, d)) : [];
      }
      function c7(o, s) {
        return Cv(o, s);
      }
      function d7(o, s, d) {
        return qm(o, s, Be(d, 2));
      }
      function f7(o, s) {
        var d = o == null ? 0 : o.length;
        if (d) {
          var m = Cv(o, s);
          if (m < d && eo(o[m], s))
            return m;
        }
        return -1;
      }
      function v7(o, s) {
        return Cv(o, s, !0);
      }
      function h7(o, s, d) {
        return qm(o, s, Be(d, 2), !0);
      }
      function p7(o, s) {
        var d = o == null ? 0 : o.length;
        if (d) {
          var m = Cv(o, s, !0) - 1;
          if (eo(o[m], s))
            return m;
        }
        return -1;
      }
      function g7(o) {
        return o && o.length ? C5(o) : [];
      }
      function m7(o, s) {
        return o && o.length ? C5(o, Be(s, 2)) : [];
      }
      function b7(o) {
        var s = o == null ? 0 : o.length;
        return s ? Oa(o, 1, s) : [];
      }
      function y7(o, s, d) {
        return o && o.length ? (s = d || s === t ? 1 : nr(s), Oa(o, 0, s < 0 ? 0 : s)) : [];
      }
      function S7(o, s, d) {
        var m = o == null ? 0 : o.length;
        return m ? (s = d || s === t ? 1 : nr(s), s = m - s, Oa(o, s < 0 ? 0 : s, m)) : [];
      }
      function x7(o, s) {
        return o && o.length ? Ev(o, Be(s, 3), !1, !0) : [];
      }
      function $7(o, s) {
        return o && o.length ? Ev(o, Be(s, 3)) : [];
      }
      var w7 = sr(function(o) {
        return ls(Qt(o, 1, Et, !0));
      }), _7 = sr(function(o) {
        var s = Ma(o);
        return Et(s) && (s = t), ls(Qt(o, 1, Et, !0), Be(s, 2));
      }), T7 = sr(function(o) {
        var s = Ma(o);
        return s = typeof s == "function" ? s : t, ls(Qt(o, 1, Et, !0), t, s);
      });
      function C7(o) {
        return o && o.length ? ls(o) : [];
      }
      function E7(o, s) {
        return o && o.length ? ls(o, Be(s, 2)) : [];
      }
      function A7(o, s) {
        return s = typeof s == "function" ? s : t, o && o.length ? ls(o, t, s) : [];
      }
      function hb(o) {
        if (!(o && o.length))
          return [];
        var s = 0;
        return o = ns(o, function(d) {
          if (Et(d))
            return s = zt(d.length, s), !0;
        }), Mm(s, function(d) {
          return dt(o, Am(d));
        });
      }
      function fT(o, s) {
        if (!(o && o.length))
          return [];
        var d = hb(o);
        return s == null ? d : dt(d, function(m) {
          return ta(s, t, m);
        });
      }
      var I7 = sr(function(o, s) {
        return Et(o) ? Gc(o, s) : [];
      }), O7 = sr(function(o) {
        return Xm(ns(o, Et));
      }), M7 = sr(function(o) {
        var s = Ma(o);
        return Et(s) && (s = t), Xm(ns(o, Et), Be(s, 2));
      }), R7 = sr(function(o) {
        var s = Ma(o);
        return s = typeof s == "function" ? s : t, Xm(ns(o, Et), t, s);
      }), P7 = sr(hb);
      function k7(o, s) {
        return O5(o || [], s || [], Hc);
      }
      function j7(o, s) {
        return O5(o || [], s || [], Zc);
      }
      var D7 = sr(function(o) {
        var s = o.length, d = s > 1 ? o[s - 1] : t;
        return d = typeof d == "function" ? (o.pop(), d) : t, fT(o, d);
      });
      function vT(o) {
        var s = C(o);
        return s.__chain__ = !0, s;
      }
      function N7(o, s) {
        return s(o), o;
      }
      function Dv(o, s) {
        return s(o);
      }
      var L7 = bi(function(o) {
        var s = o.length, d = s ? o[0] : 0, m = this.__wrapped__, w = function(E) {
          return Fm(E, o);
        };
        return s > 1 || this.__actions__.length || !(m instanceof fr) || !yi(d) ? this.thru(w) : (m = m.slice(d, +d + (s ? 1 : 0)), m.__actions__.push({
          func: Dv,
          args: [w],
          thisArg: t
        }), new Aa(m, this.__chain__).thru(function(E) {
          return s && !E.length && E.push(t), E;
        }));
      });
      function F7() {
        return vT(this);
      }
      function z7() {
        return new Aa(this.value(), this.__chain__);
      }
      function B7() {
        this.__values__ === t && (this.__values__ = ET(this.value()));
        var o = this.__index__ >= this.__values__.length, s = o ? t : this.__values__[this.__index__++];
        return { done: o, value: s };
      }
      function U7() {
        return this;
      }
      function V7(o) {
        for (var s, d = this; d instanceof xv; ) {
          var m = iT(d);
          m.__index__ = 0, m.__values__ = t, s ? w.__wrapped__ = m : s = m;
          var w = m;
          d = d.__wrapped__;
        }
        return w.__wrapped__ = o, s;
      }
      function W7() {
        var o = this.__wrapped__;
        if (o instanceof fr) {
          var s = o;
          return this.__actions__.length && (s = new fr(this)), s = s.reverse(), s.__actions__.push({
            func: Dv,
            args: [vb],
            thisArg: t
          }), new Aa(s, this.__chain__);
        }
        return this.thru(vb);
      }
      function H7() {
        return I5(this.__wrapped__, this.__actions__);
      }
      var G7 = Av(function(o, s, d) {
        Dr.call(o, d) ? ++o[d] : gi(o, d, 1);
      });
      function Y7(o, s, d) {
        var m = Xe(o) ? U_ : NL;
        return d && Cn(o, s, d) && (s = t), m(o, Be(s, 3));
      }
      function K7(o, s) {
        var d = Xe(o) ? ns : f5;
        return d(o, Be(s, 3));
      }
      var Z7 = z5(sT), q7 = z5(lT);
      function Q7(o, s) {
        return Qt(Nv(o, s), 1);
      }
      function X7(o, s) {
        return Qt(Nv(o, s), ze);
      }
      function J7(o, s, d) {
        return d = d === t ? 1 : nr(d), Qt(Nv(o, s), d);
      }
      function hT(o, s) {
        var d = Xe(o) ? Ca : ss;
        return d(o, Be(s, 3));
      }
      function pT(o, s) {
        var d = Xe(o) ? bN : d5;
        return d(o, Be(s, 3));
      }
      var eF = Av(function(o, s, d) {
        Dr.call(o, d) ? o[d].push(s) : gi(o, d, [s]);
      });
      function rF(o, s, d, m) {
        o = Vn(o) ? o : Au(o), d = d && !m ? nr(d) : 0;
        var w = o.length;
        return d < 0 && (d = zt(w + d, 0)), Uv(o) ? d <= w && o.indexOf(s, d) > -1 : !!w && gu(o, s, d) > -1;
      }
      var tF = sr(function(o, s, d) {
        var m = -1, w = typeof s == "function", E = Vn(o) ? K(o.length) : [];
        return ss(o, function(R) {
          E[++m] = w ? ta(s, R, d) : Yc(R, s, d);
        }), E;
      }), nF = Av(function(o, s, d) {
        gi(o, d, s);
      });
      function Nv(o, s) {
        var d = Xe(o) ? dt : b5;
        return d(o, Be(s, 3));
      }
      function aF(o, s, d, m) {
        return o == null ? [] : (Xe(s) || (s = s == null ? [] : [s]), d = m ? t : d, Xe(d) || (d = d == null ? [] : [d]), $5(o, s, d));
      }
      var oF = Av(function(o, s, d) {
        o[d ? 0 : 1].push(s);
      }, function() {
        return [[], []];
      });
      function iF(o, s, d) {
        var m = Xe(o) ? Cm : G_, w = arguments.length < 3;
        return m(o, Be(s, 4), d, w, ss);
      }
      function sF(o, s, d) {
        var m = Xe(o) ? yN : G_, w = arguments.length < 3;
        return m(o, Be(s, 4), d, w, d5);
      }
      function lF(o, s) {
        var d = Xe(o) ? ns : f5;
        return d(o, zv(Be(s, 3)));
      }
      function uF(o) {
        var s = Xe(o) ? s5 : r9;
        return s(o);
      }
      function cF(o, s, d) {
        (d ? Cn(o, s, d) : s === t) ? s = 1 : s = nr(s);
        var m = Xe(o) ? RL : t9;
        return m(o, s);
      }
      function dF(o) {
        var s = Xe(o) ? PL : a9;
        return s(o);
      }
      function fF(o) {
        if (o == null)
          return 0;
        if (Vn(o))
          return Uv(o) ? bu(o) : o.length;
        var s = mn(o);
        return s == Ir || s == br ? o.size : Hm(o).length;
      }
      function vF(o, s, d) {
        var m = Xe(o) ? Em : o9;
        return d && Cn(o, s, d) && (s = t), m(o, Be(s, 3));
      }
      var hF = sr(function(o, s) {
        if (o == null)
          return [];
        var d = s.length;
        return d > 1 && Cn(o, s[0], s[1]) ? s = [] : d > 2 && Cn(s[0], s[1], s[2]) && (s = [s[0]]), $5(o, Qt(s, 1), []);
      }), Lv = KN || function() {
        return de.Date.now();
      };
      function pF(o, s) {
        if (typeof s != "function")
          throw new Ea(l);
        return o = nr(o), function() {
          if (--o < 1)
            return s.apply(this, arguments);
        };
      }
      function gT(o, s, d) {
        return s = d ? t : s, s = o && s == null ? o.length : s, mi(o, M, t, t, t, t, s);
      }
      function mT(o, s) {
        var d;
        if (typeof s != "function")
          throw new Ea(l);
        return o = nr(o), function() {
          return --o > 0 && (d = s.apply(this, arguments)), o <= 1 && (s = t), d;
        };
      }
      var pb = sr(function(o, s, d) {
        var m = _;
        if (d.length) {
          var w = os(d, Cu(pb));
          m |= k;
        }
        return mi(o, m, s, d, w);
      }), bT = sr(function(o, s, d) {
        var m = _ | A;
        if (d.length) {
          var w = os(d, Cu(bT));
          m |= k;
        }
        return mi(s, m, o, d, w);
      });
      function yT(o, s, d) {
        s = d ? t : s;
        var m = mi(o, P, t, t, t, t, t, s);
        return m.placeholder = yT.placeholder, m;
      }
      function ST(o, s, d) {
        s = d ? t : s;
        var m = mi(o, j, t, t, t, t, t, s);
        return m.placeholder = ST.placeholder, m;
      }
      function xT(o, s, d) {
        var m, w, E, R, D, V, J = 0, ee = !1, se = !1, we = !0;
        if (typeof o != "function")
          throw new Ea(l);
        s = Ra(s) || 0, yt(d) && (ee = !!d.leading, se = "maxWait" in d, E = se ? zt(Ra(d.maxWait) || 0, s) : E, we = "trailing" in d ? !!d.trailing : we);
        function ke(At) {
          var ro = m, $i = w;
          return m = w = t, J = At, R = o.apply($i, ro), R;
        }
        function Ue(At) {
          return J = At, D = Xc(cr, s), ee ? ke(At) : R;
        }
        function ir(At) {
          var ro = At - V, $i = At - J, zT = s - ro;
          return se ? gn(zT, E - $i) : zT;
        }
        function Ve(At) {
          var ro = At - V, $i = At - J;
          return V === t || ro >= s || ro < 0 || se && $i >= E;
        }
        function cr() {
          var At = Lv();
          if (Ve(At))
            return hr(At);
          D = Xc(cr, ir(At));
        }
        function hr(At) {
          return D = t, we && m ? ke(At) : (m = w = t, R);
        }
        function ia() {
          D !== t && M5(D), J = 0, m = V = w = D = t;
        }
        function En() {
          return D === t ? R : hr(Lv());
        }
        function sa() {
          var At = Lv(), ro = Ve(At);
          if (m = arguments, w = this, V = At, ro) {
            if (D === t)
              return Ue(V);
            if (se)
              return M5(D), D = Xc(cr, s), ke(V);
          }
          return D === t && (D = Xc(cr, s)), R;
        }
        return sa.cancel = ia, sa.flush = En, sa;
      }
      var gF = sr(function(o, s) {
        return c5(o, 1, s);
      }), mF = sr(function(o, s, d) {
        return c5(o, Ra(s) || 0, d);
      });
      function bF(o) {
        return mi(o, Z);
      }
      function Fv(o, s) {
        if (typeof o != "function" || s != null && typeof s != "function")
          throw new Ea(l);
        var d = function() {
          var m = arguments, w = s ? s.apply(this, m) : m[0], E = d.cache;
          if (E.has(w))
            return E.get(w);
          var R = o.apply(this, m);
          return d.cache = E.set(w, R) || E, R;
        };
        return d.cache = new (Fv.Cache || pi)(), d;
      }
      Fv.Cache = pi;
      function zv(o) {
        if (typeof o != "function")
          throw new Ea(l);
        return function() {
          var s = arguments;
          switch (s.length) {
            case 0:
              return !o.call(this);
            case 1:
              return !o.call(this, s[0]);
            case 2:
              return !o.call(this, s[0], s[1]);
            case 3:
              return !o.call(this, s[0], s[1], s[2]);
          }
          return !o.apply(this, s);
        };
      }
      function yF(o) {
        return mT(2, o);
      }
      var SF = i9(function(o, s) {
        s = s.length == 1 && Xe(s[0]) ? dt(s[0], na(Be())) : dt(Qt(s, 1), na(Be()));
        var d = s.length;
        return sr(function(m) {
          for (var w = -1, E = gn(m.length, d); ++w < E; )
            m[w] = s[w].call(this, m[w]);
          return ta(o, this, m);
        });
      }), gb = sr(function(o, s) {
        var d = os(s, Cu(gb));
        return mi(o, k, t, s, d);
      }), $T = sr(function(o, s) {
        var d = os(s, Cu($T));
        return mi(o, L, t, s, d);
      }), xF = bi(function(o, s) {
        return mi(o, W, t, t, t, s);
      });
      function $F(o, s) {
        if (typeof o != "function")
          throw new Ea(l);
        return s = s === t ? s : nr(s), sr(o, s);
      }
      function wF(o, s) {
        if (typeof o != "function")
          throw new Ea(l);
        return s = s == null ? 0 : zt(nr(s), 0), sr(function(d) {
          var m = d[s], w = cs(d, 0, s);
          return m && as(w, m), ta(o, this, w);
        });
      }
      function _F(o, s, d) {
        var m = !0, w = !0;
        if (typeof o != "function")
          throw new Ea(l);
        return yt(d) && (m = "leading" in d ? !!d.leading : m, w = "trailing" in d ? !!d.trailing : w), xT(o, s, {
          leading: m,
          maxWait: s,
          trailing: w
        });
      }
      function TF(o) {
        return gT(o, 1);
      }
      function CF(o, s) {
        return gb(eb(s), o);
      }
      function EF() {
        if (!arguments.length)
          return [];
        var o = arguments[0];
        return Xe(o) ? o : [o];
      }
      function AF(o) {
        return Ia(o, y);
      }
      function IF(o, s) {
        return s = typeof s == "function" ? s : t, Ia(o, y, s);
      }
      function OF(o) {
        return Ia(o, p | y);
      }
      function MF(o, s) {
        return s = typeof s == "function" ? s : t, Ia(o, p | y, s);
      }
      function RF(o, s) {
        return s == null || u5(o, s, Wt(s));
      }
      function eo(o, s) {
        return o === s || o !== o && s !== s;
      }
      var PF = Rv(Um), kF = Rv(function(o, s) {
        return o >= s;
      }), xl = p5(function() {
        return arguments;
      }()) ? p5 : function(o) {
        return _t(o) && Dr.call(o, "callee") && !r5.call(o, "callee");
      }, Xe = K.isArray, jF = zn ? na(zn) : VL;
      function Vn(o) {
        return o != null && Bv(o.length) && !Si(o);
      }
      function Et(o) {
        return _t(o) && Vn(o);
      }
      function DF(o) {
        return o === !0 || o === !1 || _t(o) && Tn(o) == _e;
      }
      var ds = qN || Eb, NF = Bn ? na(Bn) : WL;
      function LF(o) {
        return _t(o) && o.nodeType === 1 && !Jc(o);
      }
      function FF(o) {
        if (o == null)
          return !0;
        if (Vn(o) && (Xe(o) || typeof o == "string" || typeof o.splice == "function" || ds(o) || Eu(o) || xl(o)))
          return !o.length;
        var s = mn(o);
        if (s == Ir || s == br)
          return !o.size;
        if (Qc(o))
          return !Hm(o).length;
        for (var d in o)
          if (Dr.call(o, d))
            return !1;
        return !0;
      }
      function zF(o, s) {
        return Kc(o, s);
      }
      function BF(o, s, d) {
        d = typeof d == "function" ? d : t;
        var m = d ? d(o, s) : t;
        return m === t ? Kc(o, s, t, d) : !!m;
      }
      function mb(o) {
        if (!_t(o))
          return !1;
        var s = Tn(o);
        return s == mr || s == Yr || typeof o.message == "string" && typeof o.name == "string" && !Jc(o);
      }
      function UF(o) {
        return typeof o == "number" && n5(o);
      }
      function Si(o) {
        if (!yt(o))
          return !1;
        var s = Tn(o);
        return s == rt || s == Je || s == Ze || s == gt;
      }
      function wT(o) {
        return typeof o == "number" && o == nr(o);
      }
      function Bv(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= le;
      }
      function yt(o) {
        var s = typeof o;
        return o != null && (s == "object" || s == "function");
      }
      function _t(o) {
        return o != null && typeof o == "object";
      }
      var _T = Qa ? na(Qa) : GL;
      function VF(o, s) {
        return o === s || Wm(o, s, sb(s));
      }
      function WF(o, s, d) {
        return d = typeof d == "function" ? d : t, Wm(o, s, sb(s), d);
      }
      function HF(o) {
        return TT(o) && o != +o;
      }
      function GF(o) {
        if (I9(o))
          throw new qe(i);
        return g5(o);
      }
      function YF(o) {
        return o === null;
      }
      function KF(o) {
        return o == null;
      }
      function TT(o) {
        return typeof o == "number" || _t(o) && Tn(o) == wt;
      }
      function Jc(o) {
        if (!_t(o) || Tn(o) != jr)
          return !1;
        var s = hv(o);
        if (s === null)
          return !0;
        var d = Dr.call(s, "constructor") && s.constructor;
        return typeof d == "function" && d instanceof d && cv.call(d) == WN;
      }
      var bb = F_ ? na(F_) : YL;
      function ZF(o) {
        return wT(o) && o >= -le && o <= le;
      }
      var CT = z_ ? na(z_) : KL;
      function Uv(o) {
        return typeof o == "string" || !Xe(o) && _t(o) && Tn(o) == G;
      }
      function oa(o) {
        return typeof o == "symbol" || _t(o) && Tn(o) == te;
      }
      var Eu = B_ ? na(B_) : ZL;
      function qF(o) {
        return o === t;
      }
      function QF(o) {
        return _t(o) && mn(o) == Q;
      }
      function XF(o) {
        return _t(o) && Tn(o) == Ce;
      }
      var JF = Rv(Gm), ez = Rv(function(o, s) {
        return o <= s;
      });
      function ET(o) {
        if (!o)
          return [];
        if (Vn(o))
          return Uv(o) ? Xa(o) : Un(o);
        if (zc && o[zc])
          return RN(o[zc]());
        var s = mn(o), d = s == Ir ? Pm : s == br ? sv : Au;
        return d(o);
      }
      function xi(o) {
        if (!o)
          return o === 0 ? o : 0;
        if (o = Ra(o), o === ze || o === -ze) {
          var s = o < 0 ? -1 : 1;
          return s * ce;
        }
        return o === o ? o : 0;
      }
      function nr(o) {
        var s = xi(o), d = s % 1;
        return s === s ? d ? s - d : s : 0;
      }
      function AT(o) {
        return o ? ml(nr(o), 0, be) : 0;
      }
      function Ra(o) {
        if (typeof o == "number")
          return o;
        if (oa(o))
          return he;
        if (yt(o)) {
          var s = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = yt(s) ? s + "" : s;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = Y_(o);
        var d = Xs.test(o);
        return d || el.test(o) ? N(o.slice(2), d ? 2 : 8) : Qs.test(o) ? he : +o;
      }
      function IT(o) {
        return Do(o, Wn(o));
      }
      function rz(o) {
        return o ? ml(nr(o), -le, le) : o === 0 ? o : 0;
      }
      function Rr(o) {
        return o == null ? "" : aa(o);
      }
      var tz = _u(function(o, s) {
        if (Qc(s) || Vn(s)) {
          Do(s, Wt(s), o);
          return;
        }
        for (var d in s)
          Dr.call(s, d) && Hc(o, d, s[d]);
      }), OT = _u(function(o, s) {
        Do(s, Wn(s), o);
      }), Vv = _u(function(o, s, d, m) {
        Do(s, Wn(s), o, m);
      }), nz = _u(function(o, s, d, m) {
        Do(s, Wt(s), o, m);
      }), az = bi(Fm);
      function oz(o, s) {
        var d = wu(o);
        return s == null ? d : l5(d, s);
      }
      var iz = sr(function(o, s) {
        o = Qr(o);
        var d = -1, m = s.length, w = m > 2 ? s[2] : t;
        for (w && Cn(s[0], s[1], w) && (m = 1); ++d < m; )
          for (var E = s[d], R = Wn(E), D = -1, V = R.length; ++D < V; ) {
            var J = R[D], ee = o[J];
            (ee === t || eo(ee, Su[J]) && !Dr.call(o, J)) && (o[J] = E[J]);
          }
        return o;
      }), sz = sr(function(o) {
        return o.push(t, Y5), ta(MT, t, o);
      });
      function lz(o, s) {
        return V_(o, Be(s, 3), jo);
      }
      function uz(o, s) {
        return V_(o, Be(s, 3), Bm);
      }
      function cz(o, s) {
        return o == null ? o : zm(o, Be(s, 3), Wn);
      }
      function dz(o, s) {
        return o == null ? o : v5(o, Be(s, 3), Wn);
      }
      function fz(o, s) {
        return o && jo(o, Be(s, 3));
      }
      function vz(o, s) {
        return o && Bm(o, Be(s, 3));
      }
      function hz(o) {
        return o == null ? [] : _v(o, Wt(o));
      }
      function pz(o) {
        return o == null ? [] : _v(o, Wn(o));
      }
      function yb(o, s, d) {
        var m = o == null ? t : bl(o, s);
        return m === t ? d : m;
      }
      function gz(o, s) {
        return o != null && q5(o, s, FL);
      }
      function Sb(o, s) {
        return o != null && q5(o, s, zL);
      }
      var mz = U5(function(o, s, d) {
        s != null && typeof s.toString != "function" && (s = dv.call(s)), o[s] = d;
      }, $b(Hn)), bz = U5(function(o, s, d) {
        s != null && typeof s.toString != "function" && (s = dv.call(s)), Dr.call(o, s) ? o[s].push(d) : o[s] = [d];
      }, Be), yz = sr(Yc);
      function Wt(o) {
        return Vn(o) ? i5(o) : Hm(o);
      }
      function Wn(o) {
        return Vn(o) ? i5(o, !0) : qL(o);
      }
      function Sz(o, s) {
        var d = {};
        return s = Be(s, 3), jo(o, function(m, w, E) {
          gi(d, s(m, w, E), m);
        }), d;
      }
      function xz(o, s) {
        var d = {};
        return s = Be(s, 3), jo(o, function(m, w, E) {
          gi(d, w, s(m, w, E));
        }), d;
      }
      var $z = _u(function(o, s, d) {
        Tv(o, s, d);
      }), MT = _u(function(o, s, d, m) {
        Tv(o, s, d, m);
      }), wz = bi(function(o, s) {
        var d = {};
        if (o == null)
          return d;
        var m = !1;
        s = dt(s, function(E) {
          return E = us(E, o), m || (m = E.length > 1), E;
        }), Do(o, ob(o), d), m && (d = Ia(d, p | g | y, m9));
        for (var w = s.length; w--; )
          Qm(d, s[w]);
        return d;
      });
      function _z(o, s) {
        return RT(o, zv(Be(s)));
      }
      var Tz = bi(function(o, s) {
        return o == null ? {} : XL(o, s);
      });
      function RT(o, s) {
        if (o == null)
          return {};
        var d = dt(ob(o), function(m) {
          return [m];
        });
        return s = Be(s), w5(o, d, function(m, w) {
          return s(m, w[0]);
        });
      }
      function Cz(o, s, d) {
        s = us(s, o);
        var m = -1, w = s.length;
        for (w || (w = 1, o = t); ++m < w; ) {
          var E = o == null ? t : o[No(s[m])];
          E === t && (m = w, E = d), o = Si(E) ? E.call(o) : E;
        }
        return o;
      }
      function Ez(o, s, d) {
        return o == null ? o : Zc(o, s, d);
      }
      function Az(o, s, d, m) {
        return m = typeof m == "function" ? m : t, o == null ? o : Zc(o, s, d, m);
      }
      var PT = H5(Wt), kT = H5(Wn);
      function Iz(o, s, d) {
        var m = Xe(o), w = m || ds(o) || Eu(o);
        if (s = Be(s, 4), d == null) {
          var E = o && o.constructor;
          w ? d = m ? new E() : [] : yt(o) ? d = Si(E) ? wu(hv(o)) : {} : d = {};
        }
        return (w ? Ca : jo)(o, function(R, D, V) {
          return s(d, R, D, V);
        }), d;
      }
      function Oz(o, s) {
        return o == null ? !0 : Qm(o, s);
      }
      function Mz(o, s, d) {
        return o == null ? o : A5(o, s, eb(d));
      }
      function Rz(o, s, d, m) {
        return m = typeof m == "function" ? m : t, o == null ? o : A5(o, s, eb(d), m);
      }
      function Au(o) {
        return o == null ? [] : Rm(o, Wt(o));
      }
      function Pz(o) {
        return o == null ? [] : Rm(o, Wn(o));
      }
      function kz(o, s, d) {
        return d === t && (d = s, s = t), d !== t && (d = Ra(d), d = d === d ? d : 0), s !== t && (s = Ra(s), s = s === s ? s : 0), ml(Ra(o), s, d);
      }
      function jz(o, s, d) {
        return s = xi(s), d === t ? (d = s, s = 0) : d = xi(d), o = Ra(o), BL(o, s, d);
      }
      function Dz(o, s, d) {
        if (d && typeof d != "boolean" && Cn(o, s, d) && (s = d = t), d === t && (typeof s == "boolean" ? (d = s, s = t) : typeof o == "boolean" && (d = o, o = t)), o === t && s === t ? (o = 0, s = 1) : (o = xi(o), s === t ? (s = o, o = 0) : s = xi(s)), o > s) {
          var m = o;
          o = s, s = m;
        }
        if (d || o % 1 || s % 1) {
          var w = a5();
          return gn(o + w * (s - o + $("1e-" + ((w + "").length - 1))), s);
        }
        return Km(o, s);
      }
      var Nz = Tu(function(o, s, d) {
        return s = s.toLowerCase(), o + (d ? jT(s) : s);
      });
      function jT(o) {
        return xb(Rr(o).toLowerCase());
      }
      function DT(o) {
        return o = Rr(o), o && o.replace(tl, EN).replace(Mo, "");
      }
      function Lz(o, s, d) {
        o = Rr(o), s = aa(s);
        var m = o.length;
        d = d === t ? m : ml(nr(d), 0, m);
        var w = d;
        return d -= s.length, d >= 0 && o.slice(d, w) == s;
      }
      function Fz(o) {
        return o = Rr(o), o && er.test(o) ? o.replace(pe, AN) : o;
      }
      function zz(o) {
        return o = Rr(o), o && rr.test(o) ? o.replace(Pe, "\\$&") : o;
      }
      var Bz = Tu(function(o, s, d) {
        return o + (d ? "-" : "") + s.toLowerCase();
      }), Uz = Tu(function(o, s, d) {
        return o + (d ? " " : "") + s.toLowerCase();
      }), Vz = F5("toLowerCase");
      function Wz(o, s, d) {
        o = Rr(o), s = nr(s);
        var m = s ? bu(o) : 0;
        if (!s || m >= s)
          return o;
        var w = (s - m) / 2;
        return Mv(bv(w), d) + o + Mv(mv(w), d);
      }
      function Hz(o, s, d) {
        o = Rr(o), s = nr(s);
        var m = s ? bu(o) : 0;
        return s && m < s ? o + Mv(s - m, d) : o;
      }
      function Gz(o, s, d) {
        o = Rr(o), s = nr(s);
        var m = s ? bu(o) : 0;
        return s && m < s ? Mv(s - m, d) + o : o;
      }
      function Yz(o, s, d) {
        return d || s == null ? s = 0 : s && (s = +s), eL(Rr(o).replace(Vr, ""), s || 0);
      }
      function Kz(o, s, d) {
        return (d ? Cn(o, s, d) : s === t) ? s = 1 : s = nr(s), Zm(Rr(o), s);
      }
      function Zz() {
        var o = arguments, s = Rr(o[0]);
        return o.length < 3 ? s : s.replace(o[1], o[2]);
      }
      var qz = Tu(function(o, s, d) {
        return o + (d ? "_" : "") + s.toLowerCase();
      });
      function Qz(o, s, d) {
        return d && typeof d != "number" && Cn(o, s, d) && (s = d = t), d = d === t ? be : d >>> 0, d ? (o = Rr(o), o && (typeof s == "string" || s != null && !bb(s)) && (s = aa(s), !s && mu(o)) ? cs(Xa(o), 0, d) : o.split(s, d)) : [];
      }
      var Xz = Tu(function(o, s, d) {
        return o + (d ? " " : "") + xb(s);
      });
      function Jz(o, s, d) {
        return o = Rr(o), d = d == null ? 0 : ml(nr(d), 0, o.length), s = aa(s), o.slice(d, d + s.length) == s;
      }
      function eB(o, s, d) {
        var m = C.templateSettings;
        d && Cn(o, s, d) && (s = t), o = Rr(o), s = Vv({}, s, m, G5);
        var w = Vv({}, s.imports, m.imports, G5), E = Wt(w), R = Rm(w, E), D, V, J = 0, ee = s.interpolate || fn, se = "__p += '", we = km(
          (s.escape || fn).source + "|" + ee.source + "|" + (ee === Dn ? qs : fn).source + "|" + (s.evaluate || fn).source + "|$",
          "g"
        ), ke = "//# sourceURL=" + (Dr.call(s, "sourceURL") ? (s.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Po + "]") + `
`;
        o.replace(we, function(Ve, cr, hr, ia, En, sa) {
          return hr || (hr = ia), se += o.slice(J, sa).replace(nl, IN), cr && (D = !0, se += `' +
__e(` + cr + `) +
'`), En && (V = !0, se += `';
` + En + `;
__p += '`), hr && (se += `' +
((__t = (` + hr + `)) == null ? '' : __t) +
'`), J = sa + Ve.length, Ve;
        }), se += `';
`;
        var Ue = Dr.call(s, "variable") && s.variable;
        if (!Ue)
          se = `with (obj) {
` + se + `
}
`;
        else if (Ks.test(Ue))
          throw new qe(u);
        se = (V ? se.replace(cn, "") : se).replace(dn, "$1").replace(Ka, "$1;"), se = "function(" + (Ue || "obj") + `) {
` + (Ue ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (D ? ", __e = _.escape" : "") + (V ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + se + `return __p
}`;
        var ir = LT(function() {
          return $r(E, ke + "return " + se).apply(t, R);
        });
        if (ir.source = se, mb(ir))
          throw ir;
        return ir;
      }
      function rB(o) {
        return Rr(o).toLowerCase();
      }
      function tB(o) {
        return Rr(o).toUpperCase();
      }
      function nB(o, s, d) {
        if (o = Rr(o), o && (d || s === t))
          return Y_(o);
        if (!o || !(s = aa(s)))
          return o;
        var m = Xa(o), w = Xa(s), E = K_(m, w), R = Z_(m, w) + 1;
        return cs(m, E, R).join("");
      }
      function aB(o, s, d) {
        if (o = Rr(o), o && (d || s === t))
          return o.slice(0, Q_(o) + 1);
        if (!o || !(s = aa(s)))
          return o;
        var m = Xa(o), w = Z_(m, Xa(s)) + 1;
        return cs(m, 0, w).join("");
      }
      function oB(o, s, d) {
        if (o = Rr(o), o && (d || s === t))
          return o.replace(Vr, "");
        if (!o || !(s = aa(s)))
          return o;
        var m = Xa(o), w = K_(m, Xa(s));
        return cs(m, w).join("");
      }
      function iB(o, s) {
        var d = oe, m = Ie;
        if (yt(s)) {
          var w = "separator" in s ? s.separator : w;
          d = "length" in s ? nr(s.length) : d, m = "omission" in s ? aa(s.omission) : m;
        }
        o = Rr(o);
        var E = o.length;
        if (mu(o)) {
          var R = Xa(o);
          E = R.length;
        }
        if (d >= E)
          return o;
        var D = d - bu(m);
        if (D < 1)
          return m;
        var V = R ? cs(R, 0, D).join("") : o.slice(0, D);
        if (w === t)
          return V + m;
        if (R && (D += V.length - D), bb(w)) {
          if (o.slice(D).search(w)) {
            var J, ee = V;
            for (w.global || (w = km(w.source, Rr(bt.exec(w)) + "g")), w.lastIndex = 0; J = w.exec(ee); )
              var se = J.index;
            V = V.slice(0, se === t ? D : se);
          }
        } else if (o.indexOf(aa(w), D) != D) {
          var we = V.lastIndexOf(w);
          we > -1 && (V = V.slice(0, we));
        }
        return V + m;
      }
      function sB(o) {
        return o = Rr(o), o && je.test(o) ? o.replace(wn, DN) : o;
      }
      var lB = Tu(function(o, s, d) {
        return o + (d ? " " : "") + s.toUpperCase();
      }), xb = F5("toUpperCase");
      function NT(o, s, d) {
        return o = Rr(o), s = d ? t : s, s === t ? MN(o) ? FN(o) : $N(o) : o.match(s) || [];
      }
      var LT = sr(function(o, s) {
        try {
          return ta(o, t, s);
        } catch (d) {
          return mb(d) ? d : new qe(d);
        }
      }), uB = bi(function(o, s) {
        return Ca(s, function(d) {
          d = No(d), gi(o, d, pb(o[d], o));
        }), o;
      });
      function cB(o) {
        var s = o == null ? 0 : o.length, d = Be();
        return o = s ? dt(o, function(m) {
          if (typeof m[1] != "function")
            throw new Ea(l);
          return [d(m[0]), m[1]];
        }) : [], sr(function(m) {
          for (var w = -1; ++w < s; ) {
            var E = o[w];
            if (ta(E[0], this, m))
              return ta(E[1], this, m);
          }
        });
      }
      function dB(o) {
        return DL(Ia(o, p));
      }
      function $b(o) {
        return function() {
          return o;
        };
      }
      function fB(o, s) {
        return o == null || o !== o ? s : o;
      }
      var vB = B5(), hB = B5(!0);
      function Hn(o) {
        return o;
      }
      function wb(o) {
        return m5(typeof o == "function" ? o : Ia(o, p));
      }
      function pB(o) {
        return y5(Ia(o, p));
      }
      function gB(o, s) {
        return S5(o, Ia(s, p));
      }
      var mB = sr(function(o, s) {
        return function(d) {
          return Yc(d, o, s);
        };
      }), bB = sr(function(o, s) {
        return function(d) {
          return Yc(o, d, s);
        };
      });
      function _b(o, s, d) {
        var m = Wt(s), w = _v(s, m);
        d == null && !(yt(s) && (w.length || !m.length)) && (d = s, s = o, o = this, w = _v(s, Wt(s)));
        var E = !(yt(d) && "chain" in d) || !!d.chain, R = Si(o);
        return Ca(w, function(D) {
          var V = s[D];
          o[D] = V, R && (o.prototype[D] = function() {
            var J = this.__chain__;
            if (E || J) {
              var ee = o(this.__wrapped__), se = ee.__actions__ = Un(this.__actions__);
              return se.push({ func: V, args: arguments, thisArg: o }), ee.__chain__ = J, ee;
            }
            return V.apply(o, as([this.value()], arguments));
          });
        }), o;
      }
      function yB() {
        return de._ === this && (de._ = HN), this;
      }
      function Tb() {
      }
      function SB(o) {
        return o = nr(o), sr(function(s) {
          return x5(s, o);
        });
      }
      var xB = tb(dt), $B = tb(U_), wB = tb(Em);
      function FT(o) {
        return ub(o) ? Am(No(o)) : JL(o);
      }
      function _B(o) {
        return function(s) {
          return o == null ? t : bl(o, s);
        };
      }
      var TB = V5(), CB = V5(!0);
      function Cb() {
        return [];
      }
      function Eb() {
        return !1;
      }
      function EB() {
        return {};
      }
      function AB() {
        return "";
      }
      function IB() {
        return !0;
      }
      function OB(o, s) {
        if (o = nr(o), o < 1 || o > le)
          return [];
        var d = be, m = gn(o, be);
        s = Be(s), o -= be;
        for (var w = Mm(m, s); ++d < o; )
          s(d);
        return w;
      }
      function MB(o) {
        return Xe(o) ? dt(o, No) : oa(o) ? [o] : Un(oT(Rr(o)));
      }
      function RB(o) {
        var s = ++VN;
        return Rr(o) + s;
      }
      var PB = Ov(function(o, s) {
        return o + s;
      }, 0), kB = nb("ceil"), jB = Ov(function(o, s) {
        return o / s;
      }, 1), DB = nb("floor");
      function NB(o) {
        return o && o.length ? wv(o, Hn, Um) : t;
      }
      function LB(o, s) {
        return o && o.length ? wv(o, Be(s, 2), Um) : t;
      }
      function FB(o) {
        return H_(o, Hn);
      }
      function zB(o, s) {
        return H_(o, Be(s, 2));
      }
      function BB(o) {
        return o && o.length ? wv(o, Hn, Gm) : t;
      }
      function UB(o, s) {
        return o && o.length ? wv(o, Be(s, 2), Gm) : t;
      }
      var VB = Ov(function(o, s) {
        return o * s;
      }, 1), WB = nb("round"), HB = Ov(function(o, s) {
        return o - s;
      }, 0);
      function GB(o) {
        return o && o.length ? Om(o, Hn) : 0;
      }
      function YB(o, s) {
        return o && o.length ? Om(o, Be(s, 2)) : 0;
      }
      return C.after = pF, C.ary = gT, C.assign = tz, C.assignIn = OT, C.assignInWith = Vv, C.assignWith = nz, C.at = az, C.before = mT, C.bind = pb, C.bindAll = uB, C.bindKey = bT, C.castArray = EF, C.chain = vT, C.chunk = D9, C.compact = N9, C.concat = L9, C.cond = cB, C.conforms = dB, C.constant = $b, C.countBy = G7, C.create = oz, C.curry = yT, C.curryRight = ST, C.debounce = xT, C.defaults = iz, C.defaultsDeep = sz, C.defer = gF, C.delay = mF, C.difference = F9, C.differenceBy = z9, C.differenceWith = B9, C.drop = U9, C.dropRight = V9, C.dropRightWhile = W9, C.dropWhile = H9, C.fill = G9, C.filter = K7, C.flatMap = Q7, C.flatMapDeep = X7, C.flatMapDepth = J7, C.flatten = uT, C.flattenDeep = Y9, C.flattenDepth = K9, C.flip = bF, C.flow = vB, C.flowRight = hB, C.fromPairs = Z9, C.functions = hz, C.functionsIn = pz, C.groupBy = eF, C.initial = Q9, C.intersection = X9, C.intersectionBy = J9, C.intersectionWith = e7, C.invert = mz, C.invertBy = bz, C.invokeMap = tF, C.iteratee = wb, C.keyBy = nF, C.keys = Wt, C.keysIn = Wn, C.map = Nv, C.mapKeys = Sz, C.mapValues = xz, C.matches = pB, C.matchesProperty = gB, C.memoize = Fv, C.merge = $z, C.mergeWith = MT, C.method = mB, C.methodOf = bB, C.mixin = _b, C.negate = zv, C.nthArg = SB, C.omit = wz, C.omitBy = _z, C.once = yF, C.orderBy = aF, C.over = xB, C.overArgs = SF, C.overEvery = $B, C.overSome = wB, C.partial = gb, C.partialRight = $T, C.partition = oF, C.pick = Tz, C.pickBy = RT, C.property = FT, C.propertyOf = _B, C.pull = a7, C.pullAll = dT, C.pullAllBy = o7, C.pullAllWith = i7, C.pullAt = s7, C.range = TB, C.rangeRight = CB, C.rearg = xF, C.reject = lF, C.remove = l7, C.rest = $F, C.reverse = vb, C.sampleSize = cF, C.set = Ez, C.setWith = Az, C.shuffle = dF, C.slice = u7, C.sortBy = hF, C.sortedUniq = g7, C.sortedUniqBy = m7, C.split = Qz, C.spread = wF, C.tail = b7, C.take = y7, C.takeRight = S7, C.takeRightWhile = x7, C.takeWhile = $7, C.tap = N7, C.throttle = _F, C.thru = Dv, C.toArray = ET, C.toPairs = PT, C.toPairsIn = kT, C.toPath = MB, C.toPlainObject = IT, C.transform = Iz, C.unary = TF, C.union = w7, C.unionBy = _7, C.unionWith = T7, C.uniq = C7, C.uniqBy = E7, C.uniqWith = A7, C.unset = Oz, C.unzip = hb, C.unzipWith = fT, C.update = Mz, C.updateWith = Rz, C.values = Au, C.valuesIn = Pz, C.without = I7, C.words = NT, C.wrap = CF, C.xor = O7, C.xorBy = M7, C.xorWith = R7, C.zip = P7, C.zipObject = k7, C.zipObjectDeep = j7, C.zipWith = D7, C.entries = PT, C.entriesIn = kT, C.extend = OT, C.extendWith = Vv, _b(C, C), C.add = PB, C.attempt = LT, C.camelCase = Nz, C.capitalize = jT, C.ceil = kB, C.clamp = kz, C.clone = AF, C.cloneDeep = OF, C.cloneDeepWith = MF, C.cloneWith = IF, C.conformsTo = RF, C.deburr = DT, C.defaultTo = fB, C.divide = jB, C.endsWith = Lz, C.eq = eo, C.escape = Fz, C.escapeRegExp = zz, C.every = Y7, C.find = Z7, C.findIndex = sT, C.findKey = lz, C.findLast = q7, C.findLastIndex = lT, C.findLastKey = uz, C.floor = DB, C.forEach = hT, C.forEachRight = pT, C.forIn = cz, C.forInRight = dz, C.forOwn = fz, C.forOwnRight = vz, C.get = yb, C.gt = PF, C.gte = kF, C.has = gz, C.hasIn = Sb, C.head = cT, C.identity = Hn, C.includes = rF, C.indexOf = q9, C.inRange = jz, C.invoke = yz, C.isArguments = xl, C.isArray = Xe, C.isArrayBuffer = jF, C.isArrayLike = Vn, C.isArrayLikeObject = Et, C.isBoolean = DF, C.isBuffer = ds, C.isDate = NF, C.isElement = LF, C.isEmpty = FF, C.isEqual = zF, C.isEqualWith = BF, C.isError = mb, C.isFinite = UF, C.isFunction = Si, C.isInteger = wT, C.isLength = Bv, C.isMap = _T, C.isMatch = VF, C.isMatchWith = WF, C.isNaN = HF, C.isNative = GF, C.isNil = KF, C.isNull = YF, C.isNumber = TT, C.isObject = yt, C.isObjectLike = _t, C.isPlainObject = Jc, C.isRegExp = bb, C.isSafeInteger = ZF, C.isSet = CT, C.isString = Uv, C.isSymbol = oa, C.isTypedArray = Eu, C.isUndefined = qF, C.isWeakMap = QF, C.isWeakSet = XF, C.join = r7, C.kebabCase = Bz, C.last = Ma, C.lastIndexOf = t7, C.lowerCase = Uz, C.lowerFirst = Vz, C.lt = JF, C.lte = ez, C.max = NB, C.maxBy = LB, C.mean = FB, C.meanBy = zB, C.min = BB, C.minBy = UB, C.stubArray = Cb, C.stubFalse = Eb, C.stubObject = EB, C.stubString = AB, C.stubTrue = IB, C.multiply = VB, C.nth = n7, C.noConflict = yB, C.noop = Tb, C.now = Lv, C.pad = Wz, C.padEnd = Hz, C.padStart = Gz, C.parseInt = Yz, C.random = Dz, C.reduce = iF, C.reduceRight = sF, C.repeat = Kz, C.replace = Zz, C.result = Cz, C.round = WB, C.runInContext = U, C.sample = uF, C.size = fF, C.snakeCase = qz, C.some = vF, C.sortedIndex = c7, C.sortedIndexBy = d7, C.sortedIndexOf = f7, C.sortedLastIndex = v7, C.sortedLastIndexBy = h7, C.sortedLastIndexOf = p7, C.startCase = Xz, C.startsWith = Jz, C.subtract = HB, C.sum = GB, C.sumBy = YB, C.template = eB, C.times = OB, C.toFinite = xi, C.toInteger = nr, C.toLength = AT, C.toLower = rB, C.toNumber = Ra, C.toSafeInteger = rz, C.toString = Rr, C.toUpper = tB, C.trim = nB, C.trimEnd = aB, C.trimStart = oB, C.truncate = iB, C.unescape = sB, C.uniqueId = RB, C.upperCase = lB, C.upperFirst = xb, C.each = hT, C.eachRight = pT, C.first = cT, _b(C, function() {
        var o = {};
        return jo(C, function(s, d) {
          Dr.call(C.prototype, d) || (o[d] = s);
        }), o;
      }(), { chain: !1 }), C.VERSION = n, Ca(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
        C[o].placeholder = C;
      }), Ca(["drop", "take"], function(o, s) {
        fr.prototype[o] = function(d) {
          d = d === t ? 1 : zt(nr(d), 0);
          var m = this.__filtered__ && !s ? new fr(this) : this.clone();
          return m.__filtered__ ? m.__takeCount__ = gn(d, m.__takeCount__) : m.__views__.push({
            size: gn(d, be),
            type: o + (m.__dir__ < 0 ? "Right" : "")
          }), m;
        }, fr.prototype[o + "Right"] = function(d) {
          return this.reverse()[o](d).reverse();
        };
      }), Ca(["filter", "map", "takeWhile"], function(o, s) {
        var d = s + 1, m = d == Me || d == Ge;
        fr.prototype[o] = function(w) {
          var E = this.clone();
          return E.__iteratees__.push({
            iteratee: Be(w, 3),
            type: d
          }), E.__filtered__ = E.__filtered__ || m, E;
        };
      }), Ca(["head", "last"], function(o, s) {
        var d = "take" + (s ? "Right" : "");
        fr.prototype[o] = function() {
          return this[d](1).value()[0];
        };
      }), Ca(["initial", "tail"], function(o, s) {
        var d = "drop" + (s ? "" : "Right");
        fr.prototype[o] = function() {
          return this.__filtered__ ? new fr(this) : this[d](1);
        };
      }), fr.prototype.compact = function() {
        return this.filter(Hn);
      }, fr.prototype.find = function(o) {
        return this.filter(o).head();
      }, fr.prototype.findLast = function(o) {
        return this.reverse().find(o);
      }, fr.prototype.invokeMap = sr(function(o, s) {
        return typeof o == "function" ? new fr(this) : this.map(function(d) {
          return Yc(d, o, s);
        });
      }), fr.prototype.reject = function(o) {
        return this.filter(zv(Be(o)));
      }, fr.prototype.slice = function(o, s) {
        o = nr(o);
        var d = this;
        return d.__filtered__ && (o > 0 || s < 0) ? new fr(d) : (o < 0 ? d = d.takeRight(-o) : o && (d = d.drop(o)), s !== t && (s = nr(s), d = s < 0 ? d.dropRight(-s) : d.take(s - o)), d);
      }, fr.prototype.takeRightWhile = function(o) {
        return this.reverse().takeWhile(o).reverse();
      }, fr.prototype.toArray = function() {
        return this.take(be);
      }, jo(fr.prototype, function(o, s) {
        var d = /^(?:filter|find|map|reject)|While$/.test(s), m = /^(?:head|last)$/.test(s), w = C[m ? "take" + (s == "last" ? "Right" : "") : s], E = m || /^find/.test(s);
        w && (C.prototype[s] = function() {
          var R = this.__wrapped__, D = m ? [1] : arguments, V = R instanceof fr, J = D[0], ee = V || Xe(R), se = function(cr) {
            var hr = w.apply(C, as([cr], D));
            return m && we ? hr[0] : hr;
          };
          ee && d && typeof J == "function" && J.length != 1 && (V = ee = !1);
          var we = this.__chain__, ke = !!this.__actions__.length, Ue = E && !we, ir = V && !ke;
          if (!E && ee) {
            R = ir ? R : new fr(this);
            var Ve = o.apply(R, D);
            return Ve.__actions__.push({ func: Dv, args: [se], thisArg: t }), new Aa(Ve, we);
          }
          return Ue && ir ? o.apply(this, D) : (Ve = this.thru(se), Ue ? m ? Ve.value()[0] : Ve.value() : Ve);
        });
      }), Ca(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
        var s = lv[o], d = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", m = /^(?:pop|shift)$/.test(o);
        C.prototype[o] = function() {
          var w = arguments;
          if (m && !this.__chain__) {
            var E = this.value();
            return s.apply(Xe(E) ? E : [], w);
          }
          return this[d](function(R) {
            return s.apply(Xe(R) ? R : [], w);
          });
        };
      }), jo(fr.prototype, function(o, s) {
        var d = C[s];
        if (d) {
          var m = d.name + "";
          Dr.call($u, m) || ($u[m] = []), $u[m].push({ name: s, func: d });
        }
      }), $u[Iv(t, A).name] = [{
        name: "wrapper",
        func: t
      }], fr.prototype.clone = sL, fr.prototype.reverse = lL, fr.prototype.value = uL, C.prototype.at = L7, C.prototype.chain = F7, C.prototype.commit = z7, C.prototype.next = B7, C.prototype.plant = V7, C.prototype.reverse = W7, C.prototype.toJSON = C.prototype.valueOf = C.prototype.value = H7, C.prototype.first = C.prototype.head, zc && (C.prototype[zc] = U7), C;
    }, yu = zN();
    ge ? ((ge.exports = yu)._ = yu, ne._ = yu) : de._ = yu;
  }).call(Ri);
})(U0, U0.exports);
var T6e = U0.exports;
const C6e = "_dot_oe0wo_1", E6e = "_active_oe0wo_24", A6e = "_full_oe0wo_29", dp = {
  "dot-container": "_dot-container_oe0wo_1",
  dot: C6e,
  "slide-in-from-left": "_slide-in-from-left_oe0wo_1",
  active: E6e,
  full: A6e
}, I6e = ({
  maxDots: e,
  selectedIndex: r,
  allDots: t,
  onDotClick: n
}) => {
  const [a, i] = Ye([]), [l, u] = Ye(r), c = Ne(
    (p, g, y, S) => {
      const x = p.slice(0, g), _ = p.slice(g + 1);
      for (; x.length + _.length >= y; )
        S === "r" ? _.length > 1 ? _.pop() : x.shift() : x.length > 1 ? x.shift() : _.pop();
      return [
        ...x,
        p[g],
        ..._
      ];
    },
    [e, r, t]
  ), f = Rt(() => r > t.length - 1 ? 0 : r < 0 ? t.length - 1 : r, [r, t]), h = (p) => l ? ![...a].slice(1, a.length - 1).some((y) => y === p) : !0;
  return ar(() => {
    const p = l && r >= l ? "r" : "l";
    if (h(f)) {
      const y = (h(f) ? c(t, f, e, p) : a).map((S) => S);
      i(y);
    }
    l !== r && u(f);
  }, [r, t]), /* @__PURE__ */ T.jsx("div", { children: /* @__PURE__ */ T.jsx("div", { className: dp["dot-container"], children: a.map((p) => {
    const g = `${dp.dot} ${t.length > e && f !== p && p !== 0 && p !== t.length - 1 ? dp.full : ""} 
            ${f === p ? dp.active : ""}`;
    return /* @__PURE__ */ T.jsx(
      "div",
      {
        role: "button",
        tabIndex: p,
        className: g,
        onClick: () => n(p),
        onKeyDown: T6e.noop,
        "data-testid": `dot${t.length > e && f !== p && p !== 0 && p !== t.length - 1 ? " full" : ""}${f === p ? " active" : ""}`
      },
      p
    );
  }) }) });
}, O6e = "_shimmer_kn4by_1", fp = {
  "modal-photo": "_modal-photo_kn4by_2",
  "img-container": "_img-container_kn4by_12",
  "skeleton-placeholder": "_skeleton-placeholder_kn4by_17",
  "skeleton-box": "_skeleton-box_kn4by_38",
  shimmer: O6e
};
var $c = {}, $m = {};
Object.defineProperty($m, "__esModule", {
  value: !0
});
$m.on = M6e;
$m.off = R6e;
function M6e(e, r, t, n) {
  n = n || !1, e.addEventListener ? e.addEventListener(r, t, n) : e.attachEvent && e.attachEvent("on" + r, function(a) {
    t.call(e, a || window.event);
  });
}
function R6e(e, r, t, n) {
  n = n || !1, e.removeEventListener ? e.removeEventListener(r, t, n) : e.detachEvent && e.detachEvent("on" + r, t);
}
var k_ = {};
Object.defineProperty(k_, "__esModule", {
  value: !0
});
k_.default = function(e) {
  if (!(e instanceof HTMLElement))
    return document.documentElement;
  for (var r = e.style.position === "absolute", t = /(scroll|auto)/, n = e; n; ) {
    if (!n.parentNode)
      return e.ownerDocument || document.documentElement;
    var a = window.getComputedStyle(n), i = a.position, l = a.overflow, u = a["overflow-x"], c = a["overflow-y"];
    if (i === "static" && r) {
      n = n.parentNode;
      continue;
    }
    if (t.test(l) && t.test(u) && t.test(c))
      return n;
    n = n.parentNode;
  }
  return e.ownerDocument || e.documentElement || document.documentElement;
};
var j_ = {};
Object.defineProperty(j_, "__esModule", {
  value: !0
});
j_.default = P6e;
function P6e(e, r, t) {
  var n = void 0, a = void 0, i = void 0, l = void 0, u = void 0, c = function f() {
    var h = +/* @__PURE__ */ new Date() - l;
    h < r && h >= 0 ? n = setTimeout(f, r - h) : (n = null, t || (u = e.apply(i, a), n || (i = null, a = null)));
  };
  return function() {
    i = this, a = arguments, l = +/* @__PURE__ */ new Date();
    var h = t && !n;
    return n || (n = setTimeout(c, r)), h && (u = e.apply(i, a), i = null, a = null), u;
  };
}
var D_ = {};
Object.defineProperty(D_, "__esModule", {
  value: !0
});
D_.default = k6e;
function k6e(e, r, t) {
  r || (r = 250);
  var n, a;
  return function() {
    var i = t || this, l = +/* @__PURE__ */ new Date(), u = arguments;
    n && l < n + r ? (clearTimeout(a), a = setTimeout(function() {
      n = l, e.apply(i, u);
    }, r)) : (n = l, e.apply(i, u));
  };
}
Object.defineProperty($c, "__esModule", {
  value: !0
});
$c.forceCheck = $c.lazyload = void 0;
var uN = function() {
  function e(r, t) {
    for (var n = 0; n < t.length; n++) {
      var a = t[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(r, a.key, a);
    }
  }
  return function(r, t, n) {
    return t && e(r.prototype, t), n && e(r, n), r;
  };
}(), N_ = xo, A2 = Lc(N_), j6e = nU, Mf = Lc(j6e), D6e = cP, St = Lc(D6e), zu = $m, N6e = k_, I2 = Lc(N6e), L6e = j_, F6e = Lc(L6e), z6e = D_, B6e = Lc(z6e);
function Lc(e) {
  return e && e.__esModule ? e : { default: e };
}
function cN(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function dN(e, r) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return r && (typeof r == "object" || typeof r == "function") ? r : e;
}
function fN(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof r);
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
}
var ec = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 }, bd = "data-lazyload-listened", ki = [], O2 = [], vN = !1;
try {
  var U6e = Object.defineProperty({}, "passive", {
    get: function() {
      vN = !0;
    }
  });
  window.addEventListener("test", null, U6e);
} catch (e) {
}
var ws = vN ? { capture: !1, passive: !0 } : !1, V6e = function(r, t) {
  var n = Mf.default.findDOMNode(r), a = void 0, i = void 0;
  try {
    var l = t.getBoundingClientRect();
    a = l.top, i = l.height;
  } catch (x) {
    a = ec.top, i = ec.height;
  }
  var u = window.innerHeight || document.documentElement.clientHeight, c = Math.max(a, 0), f = Math.min(u, a + i) - c, h = void 0, p = void 0;
  try {
    var g = n.getBoundingClientRect();
    h = g.top, p = g.height;
  } catch (x) {
    h = ec.top, p = ec.height;
  }
  var y = h - c, S = Array.isArray(r.props.offset) ? r.props.offset : [r.props.offset, r.props.offset];
  return y - S[0] <= f && y + p + S[1] >= 0;
}, W6e = function(r) {
  var t = Mf.default.findDOMNode(r);
  if (!(t.offsetWidth || t.offsetHeight || t.getClientRects().length))
    return !1;
  var n = void 0, a = void 0;
  try {
    var i = t.getBoundingClientRect();
    n = i.top, a = i.height;
  } catch (c) {
    n = ec.top, a = ec.height;
  }
  var l = window.innerHeight || document.documentElement.clientHeight, u = Array.isArray(r.props.offset) ? r.props.offset : [r.props.offset, r.props.offset];
  return n - u[0] <= l && n + a + u[1] >= 0;
}, hN = function(r) {
  var t = Mf.default.findDOMNode(r);
  if (t instanceof HTMLElement) {
    var n = (0, I2.default)(t), a = r.props.overflow && n !== t.ownerDocument && n !== document && n !== document.documentElement, i = a ? V6e(r, n) : W6e(r);
    i ? r.visible || (r.props.once && O2.push(r), r.visible = !0, r.forceUpdate()) : r.props.once && r.visible || (r.visible = !1, r.props.unmountIfInvisible && r.forceUpdate());
  }
}, H6e = function() {
  O2.forEach(function(r) {
    var t = ki.indexOf(r);
    t !== -1 && ki.splice(t, 1);
  }), O2 = [];
}, Wp = function() {
  for (var r = 0; r < ki.length; ++r) {
    var t = ki[r];
    hN(t);
  }
  H6e();
}, vp = void 0, la = null, G6e = function(r) {
  return typeof r == "string";
}, wm = function(e) {
  fN(r, e);
  function r(t) {
    cN(this, r);
    var n = dN(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, t));
    return n.visible = !1, n;
  }
  return uN(r, [{
    key: "componentDidMount",
    value: function() {
      var n = window, a = this.props.scrollContainer;
      a && G6e(a) && (n = n.document.querySelector(a));
      var i = this.props.debounce !== void 0 && vp === "throttle" || vp === "debounce" && this.props.debounce === void 0;
      if (i && ((0, zu.off)(n, "scroll", la, ws), (0, zu.off)(window, "resize", la, ws), la = null), la || (this.props.debounce !== void 0 ? (la = (0, F6e.default)(Wp, typeof this.props.debounce == "number" ? this.props.debounce : 300), vp = "debounce") : this.props.throttle !== void 0 ? (la = (0, B6e.default)(Wp, typeof this.props.throttle == "number" ? this.props.throttle : 300), vp = "throttle") : la = Wp), this.props.overflow) {
        var l = (0, I2.default)(Mf.default.findDOMNode(this));
        if (l && typeof l.getAttribute == "function") {
          var u = 1 + +l.getAttribute(bd);
          u === 1 && l.addEventListener("scroll", la, ws), l.setAttribute(bd, u);
        }
      } else if (ki.length === 0 || i) {
        var c = this.props, f = c.scroll, h = c.resize;
        f && (0, zu.on)(n, "scroll", la, ws), h && (0, zu.on)(window, "resize", la, ws);
      }
      ki.push(this), hN(this);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function() {
      return this.visible;
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (this.props.overflow) {
        var n = (0, I2.default)(Mf.default.findDOMNode(this));
        if (n && typeof n.getAttribute == "function") {
          var a = +n.getAttribute(bd) - 1;
          a === 0 ? (n.removeEventListener("scroll", la, ws), n.removeAttribute(bd)) : n.setAttribute(bd, a);
        }
      }
      var i = ki.indexOf(this);
      i !== -1 && ki.splice(i, 1), ki.length === 0 && typeof window != "undefined" && ((0, zu.off)(window, "resize", la, ws), (0, zu.off)(window, "scroll", la, ws));
    }
  }, {
    key: "render",
    value: function() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : A2.default.createElement("div", { style: { height: this.props.height }, className: "lazyload-placeholder" });
    }
  }]), r;
}(N_.Component);
wm.propTypes = {
  once: St.default.bool,
  height: St.default.oneOfType([St.default.number, St.default.string]),
  offset: St.default.oneOfType([St.default.number, St.default.arrayOf(St.default.number)]),
  overflow: St.default.bool,
  resize: St.default.bool,
  scroll: St.default.bool,
  children: St.default.node,
  throttle: St.default.oneOfType([St.default.number, St.default.bool]),
  debounce: St.default.oneOfType([St.default.number, St.default.bool]),
  placeholder: St.default.node,
  scrollContainer: St.default.oneOfType([St.default.string, St.default.object]),
  unmountIfInvisible: St.default.bool
};
wm.defaultProps = {
  once: !1,
  offset: 0,
  overflow: !1,
  resize: !1,
  scroll: !0,
  unmountIfInvisible: !1
};
var Y6e = function(r) {
  return r.displayName || r.name || "Component";
}, K6e = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return function(n) {
    return function(a) {
      fN(i, a);
      function i() {
        cN(this, i);
        var l = dN(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this));
        return l.displayName = "LazyLoad" + Y6e(n), l;
      }
      return uN(i, [{
        key: "render",
        value: function() {
          return A2.default.createElement(
            wm,
            r,
            A2.default.createElement(n, this.props)
          );
        }
      }]), i;
    }(N_.Component);
  };
};
$c.lazyload = K6e;
var L_ = $c.default = wm;
$c.forceCheck = Wp;
const Z6e = ({ src: e, alt: r }) => {
  const [t, n] = Ye(!1), a = () => /* @__PURE__ */ T.jsx("div", { style: { height: "100%" }, className: fp["img-container"], children: /* @__PURE__ */ T.jsx("div", { className: fp["skeleton-placeholder"], children: /* @__PURE__ */ T.jsx("div", { className: fp["skeleton-box"] }) }) });
  return /* @__PURE__ */ T.jsx(L_, { children: t ? /* @__PURE__ */ T.jsx(
    "img",
    {
      className: fp["modal-photo"],
      alt: r,
      onLoad: () => n(!0),
      src: e
    }
  ) : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      "img",
      {
        alt: r,
        onLoad: () => n(!0),
        src: e,
        style: { display: "none" }
      }
    ),
    a()
  ] }) });
}, q6e = ({
  selectedIndex: e,
  photosWithReviewIndices: r,
  nextPhoto: t,
  prevPhoto: n,
  setPhoto: a
}) => {
  const i = Qe(null), l = Qe(null), u = (h) => {
    i.current = h.targetTouches[0].clientX;
  }, c = (h) => {
    l.current = h.targetTouches[0].clientX;
  }, f = () => {
    if (l.current && i.current) {
      const h = i.current - l.current;
      h > 0 ? t() : h < 0 && n();
    }
    i.current = null, l.current = null;
  };
  return /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: Fu["modal-photo-slider"],
      onTouchStart: u,
      onTouchMove: c,
      onTouchEnd: f,
      "data-testid": "modal-photo-slider",
      children: [
        /* @__PURE__ */ T.jsx(
          Z6e,
          {
            src: r[e].Sizes.large.Url,
            alt: `modal-photo-${e}`
          }
        ),
        r.length >= 2 && /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
          /* @__PURE__ */ T.jsx(
            "div",
            {
              className: Fu.next,
              "data-testid": "next-button",
              onClick: t,
              children: /* @__PURE__ */ T.jsx("i", { className: Fu["next-arrow"] })
            }
          ),
          /* @__PURE__ */ T.jsx(
            "div",
            {
              className: Fu.prev,
              "data-testid": "prev-button",
              onClick: n,
              children: /* @__PURE__ */ T.jsx("i", { className: Fu["prev-arrow"] })
            }
          )
        ] }),
        r.length > 1 && /* @__PURE__ */ T.jsx("div", { className: Fu["dots-container"], children: /* @__PURE__ */ T.jsx(
          I6e,
          {
            maxDots: 5,
            selectedIndex: e,
            allDots: [...Array(r == null ? void 0 : r.length).keys()],
            onDotClick: a
          }
        ) })
      ]
    }
  );
}, V0 = ({
  reviewsWithPhotos: e,
  setModalOpen: r,
  photoIndex: t
}) => {
  const n = e.flatMap(
    (p, g) => p.Photos.map((y) => wi(Xt({}, y), { reviewIndex: g }))
  );
  ar(() => {
    (() => Xr(void 0, null, function* () {
      const g = e.flatMap(
        (y) => y.Photos.map((S) => {
          var x, _;
          return (_ = (x = S == null ? void 0 : S.Sizes) == null ? void 0 : x.large) == null ? void 0 : _.Url;
        })
      );
      yield Promise.all(
        g.map((y) => {
          const S = new Image();
          return S.src = y, new Promise((x) => {
            S.onload = x;
          });
        })
      );
    }))();
  }, [e]);
  const [a, i] = Ye(t), l = Qe(null), u = () => {
    r(!1), document.body.classList.remove("photo-modal-open");
  }, c = (p) => {
    i(p);
  }, f = () => {
    a < n.length - 1 ? i((p) => p + 1) : i(0);
  }, h = () => {
    a >= 1 ? i((p) => p - 1) : i(n.length - 1);
  };
  return b_(l, !0, u), /* @__PURE__ */ T.jsx("div", { className: cp.modal, children: /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: cp["modal-content"],
      ref: l,
      "data-testid": "photo-modal-content",
      children: [
        /* @__PURE__ */ T.jsx(
          "span",
          {
            className: cp.close,
            "data-testid": "close-button",
            onClick: u
          }
        ),
        n && /* @__PURE__ */ T.jsx(
          q6e,
          {
            photosWithReviewIndices: n,
            selectedIndex: a,
            nextPhoto: f,
            prevPhoto: h,
            setPhoto: c
          }
        ),
        /* @__PURE__ */ T.jsx("div", { className: cp["photo-review-card"], children: /* @__PURE__ */ T.jsx(
          _m,
          {
            review: e[n[a].reviewIndex],
            type: "photos-modal"
          }
        ) })
      ]
    }
  ) });
}, Q6e = "_modal_1perd_2", X6e = "_close_1perd_15", hp = {
  modal: Q6e,
  close: X6e,
  "modal-content": "_modal-content_1perd_27",
  "review-card": "_review-card_1perd_40"
}, J6e = ({ review: e, setModalOpen: r }) => {
  const t = Qe(null), n = () => {
    r(!1), document.body.classList.remove("review-modal-open");
  };
  return b_(t, !0, n), /* @__PURE__ */ T.jsx("div", { className: hp.modal, children: /* @__PURE__ */ T.jsx(
    "div",
    {
      className: hp["modal-content"],
      ref: t,
      "data-testid": "review-modal-content",
      children: /* @__PURE__ */ T.jsxs("div", { className: hp["review-card"], children: [
        /* @__PURE__ */ T.jsx(
          "div",
          {
            className: hp.close,
            "data-testid": "close-button",
            onClick: n
          }
        ),
        /* @__PURE__ */ T.jsx(_m, { review: e, type: "review-modal" })
      ] })
    }
  ) });
}, e8e = (e) => !!(e && e.scrollHeight > e.clientHeight), SO = {
  "clamped-text": "_clamped-text_6ekn9_1",
  "read-more": "_read-more_6ekn9_9"
}, r8e = ({
  children: e,
  clampLineCount: r,
  onClampedClick: t
}) => {
  const n = Qe(null), [a, i] = Ye(!1);
  return ar(() => {
    const l = n.current;
    i(e8e(l));
  }, []), /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      "div",
      {
        ref: n,
        className: SO["clamped-text"],
        style: { WebkitLineClamp: r },
        children: e
      }
    ),
    a && /* @__PURE__ */ T.jsx(
      "div",
      {
        className: SO["read-more"],
        "data-testId": "read-more",
        onClick: t,
        children: "Leer más"
      }
    )
  ] });
}, pp = {
  "review-text": "_review-text_aud9j_2",
  "translate-button": "_translate-button_aud9j_9",
  "translate-button-container": "_translate-button-container_aud9j_21"
}, t8e = ({ review: e, type: r }) => {
  var j;
  const [t, n] = Ye(null), [a, i] = Ye(!1), [l, u] = Ye(!1), [c, f] = Ye(!0), [h, p] = Ye(!1), [g, y] = Ye(!1), S = ((j = e.Photos) == null ? void 0 : j.length) > 0, { ReviewText: x } = e;
  ar(() => {
    var k;
    i(
      ((k = e == null ? void 0 : e.ContentLocale) == null ? void 0 : k.split("_")[0]) === "en" || (e == null ? void 0 : e.ContentLocale) === "en"
    ), f(!1);
  }, [e]);
  const _ = () => Xr(void 0, null, function* () {
    var k, L;
    if (p(!0), l) {
      const M = new CustomEvent("DDPDPOriginalReview", {
        bubbles: !0,
        detail: 1
      });
      window.dispatchEvent(M), u(!1);
    } else {
      if (!t)
        try {
          const W = yield (yield fetch(
            `https://api.mymemory.translated.net/get?q=${encodeURIComponent(
              x
            )}&langpair=en|es`
          )).json();
          if ((W == null ? void 0 : W.responseStatus) !== 200 || !((k = W == null ? void 0 : W.responseData) != null && k.translatedText))
            throw new Error(
              `Primary translation failed: ${(W == null ? void 0 : W.responseDetails) || "No text returned from MyMemory API"}`
            );
          n((L = W == null ? void 0 : W.responseData) == null ? void 0 : L.translatedText);
        } catch (M) {
          console.error(
            "TranslationError -> Primary MyMemory API Error : ",
            M
          );
          try {
            const W = (yield import("./index.min-40a99571.mjs")).default, Z = yield W(x, {
              from: "en",
              to: "es"
            });
            if (!Z || typeof Z != "string")
              throw new Error("Secondary translation failed");
            n(Z);
          } catch (W) {
            console.error(
              "TranslationError -> Secondary Translate Library Error : ",
              W
            ), n(x);
          }
        } finally {
          const M = new CustomEvent("DDPDPTranslateReview", {
            bubbles: !0,
            detail: 1
          });
          window.dispatchEvent(M);
        }
      u(!0);
    }
    p(!1);
  }), A = () => {
    S ? document.body.classList.add("photo-modal-open") : document.body.classList.add("review-modal-open"), y(!0);
  }, O = S ? 6 : 10, P = a && l ? t : x;
  return r === "photos-modal" || r === "review-modal" ? /* @__PURE__ */ T.jsx("div", { className: pp["review-text"], children: P }) : /* @__PURE__ */ T.jsxs(T.Fragment, { children: [
    /* @__PURE__ */ T.jsx(
      r8e,
      {
        onClampedClick: A,
        clampLineCount: O,
        children: /* @__PURE__ */ T.jsx("div", { className: pp["review-text"], children: P })
      }
    ),
    g && (S ? /* @__PURE__ */ T.jsx(
      V0,
      {
        reviewsWithPhotos: [e],
        setModalOpen: y,
        photoIndex: 0
      }
    ) : /* @__PURE__ */ T.jsx(J6e, { review: e, setModalOpen: y })),
    !c && a && /* @__PURE__ */ T.jsx("div", { className: pp["translate-button-container"], children: /* @__PURE__ */ T.jsx(
      "button",
      {
        className: pp["translate-button"],
        onClick: _,
        disabled: h,
        id: "ratings_review_translation",
        children: h ? "Traduciendo..." : l ? "Mostrar original" : "Mostrar traducción"
      }
    ) })
  ] });
}, n8e = (e) => {
  const r = new Date(e).getTime(), n = (/* @__PURE__ */ new Date()).getTime() - r, a = Math.floor(n / 1e3), i = Math.floor(a / 60), l = Math.floor(i / 60), u = Math.floor(l / 24), c = Math.floor(u / 7), f = Math.floor(c / 4), h = Math.floor(f / 12);
  let p;
  return l < 24 ? p = "hoy" : u < 7 ? p = `hace ${u} dias` : c === 1 ? p = "hace 1 semana" : c < 4 ? p = `hace ${c} semanas` : f === 1 ? p = "hace 1 mes" : f < 12 ? p = `hace ${f} meses` : h === 1 ? p = "hace 1 año" : p = `hace ${h} años`, p;
}, a8e = "_photo_21myc_2", o8e = "_text_21myc_42", yd = {
  "photos-chain": "_photos-chain_21myc_2",
  "photo-chain-component": "_photo-chain-component_21myc_9",
  "photo-wrapper": "_photo-wrapper_21myc_14",
  photo: a8e,
  text: o8e
}, pN = ({ reviewsWithPhotos: e, limit: r, type: t }) => {
  const n = e.flatMap(
    (f, h) => f.Photos.map((p) => wi(Xt({}, p), { reviewIndex: h }))
  ), [a, i] = Ye(!1), [l, u] = Ye(0);
  if (n.length === 0)
    return null;
  const c = (f) => {
    u(f), document.body.classList.add("photo-modal-open"), i(!0);
  };
  return /* @__PURE__ */ T.jsxs("div", { className: yd["photo-chain-component"], children: [
    /* @__PURE__ */ T.jsx("div", { className: yd["photos-chain"], "data-testid": "photos-chain", children: n.slice(0, r).map((f, h) => {
      var p, g;
      return /* @__PURE__ */ T.jsx(
        "div",
        {
          className: yd["photo-wrapper"],
          onClick: () => c(h),
          children: /* @__PURE__ */ T.jsx(L_, { children: /* @__PURE__ */ T.jsx(
            "img",
            {
              className: yd.photo,
              src: (g = (p = f == null ? void 0 : f.Sizes) == null ? void 0 : p.normal) == null ? void 0 : g.Url,
              id: `${t}-photo-${h + 1}`,
              "data-testid": `photo-${h}`
            }
          ) })
        },
        h
      );
    }) }),
    t === "top-photos" && n.length > 4 && /* @__PURE__ */ T.jsx(
      "button",
      {
        className: yd.text,
        onClick: () => c(0),
        id: "open-photos-modal",
        children: ai.SEE_COMMENTS_WITH_IMAGES
      }
    ),
    a && /* @__PURE__ */ T.jsx(
      V0,
      {
        reviewsWithPhotos: e,
        setModalOpen: i,
        photoIndex: l
      }
    )
  ] });
}, xO = ({ reviewId: e, value: r }) => {
  const n = /* @__PURE__ */ new Date();
  n.setTime(n.getTime() + 2 * 60 * 60 * 1e3), document.cookie = `review_${e}=${r};expires=${n.toUTCString()};path=/; Priority=High`;
}, _m = ({ review: e, type: r }) => {
  const {
    Id: t,
    Title: n,
    Rating: a,
    ReviewText: i,
    TotalPositiveFeedbackCount: l,
    UserNickname: u,
    Photos: c,
    SyndicationSource: f,
    SubmissionTime: h
  } = e, { helpfulIds: p, notHelpfulIds: g, updateFeedbackReviewsList: y } = Ta(), S = n8e(h);
  let x = u !== null ? u : "Anónimo";
  x = n ? `por ${x}` : x;
  const [_, A] = Ye(l), [O, P] = Ye(!1), [j, k] = Ye(!1), { tenant: L, environment: M, fetchApiBaseUrl: W } = Co(), Z = g_({
    tenant: L,
    environment: M,
    fetchApiBaseUrl: W
  });
  ar(() => {
    if (p.includes(t)) {
      P(!0), A(l + 1);
      return;
    } else if (g.includes(t)) {
      k(!0);
      return;
    }
    P(!1), k(!1), A(l);
  }, [e, p, g]);
  const oe = () => Xr(void 0, null, function* () {
    P(!0);
    const Te = yield Z.submitReviewFeedback({
      reviewId: t,
      vote: "positive"
    });
    if (!Te || Te.HasErrors) {
      P(!1);
      return;
    }
    A((Ee) => Ee + 1), xO({ reviewId: e.Id, value: "helpful" }), y({ reviewId: t, type: "helpful" });
  }), Ie = () => Xr(void 0, null, function* () {
    k(!0);
    const Te = yield Z.submitReviewFeedback({
      reviewId: t,
      vote: "negative"
    });
    if (!Te || Te.HasErrors) {
      k(!1);
      return;
    }
    xO({ reviewId: e.Id, value: "not_helpful" }), y({ reviewId: t, type: "not_helpful" });
  });
  return /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: `
        ${yn["review-card"]}  ${yn[`${r === "photos-modal" || r === "review-modal" ? "modal" : ""}`]}
      `,
      children: [
        /* @__PURE__ */ T.jsxs(
          "div",
          {
            className: `${yn.header} ${yn[`${r === "review-modal" ? "review-modal" : ""}`]}`,
            children: [
              /* @__PURE__ */ T.jsxs("div", { children: [
                n && /* @__PURE__ */ T.jsx("div", { className: yn["review-title"], "data-testid": "title", children: n }),
                /* @__PURE__ */ T.jsx("div", { className: yn["user-name"], "data-testid": "user-name", children: x })
              ] }),
              /* @__PURE__ */ T.jsxs("div", { children: [
                /* @__PURE__ */ T.jsx("div", { className: yn.rating, "data-testid": "rating", children: /* @__PURE__ */ T.jsx(P_, { rating: a }) }),
                /* @__PURE__ */ T.jsx("div", { className: yn["time-since"], "data-testid": "time-since", children: S })
              ] })
            ]
          }
        ),
        r !== "photos-modal" && c.length > 0 && /* @__PURE__ */ T.jsx(
          pN,
          {
            reviewsWithPhotos: [e],
            type: "review-card",
            limit: 3
          }
        ),
        i && /* @__PURE__ */ T.jsx("div", { className: yn["review-text"], children: /* @__PURE__ */ T.jsx(t8e, { review: e, type: r }) }),
        f != null && f.Name ? /* @__PURE__ */ T.jsxs(
          "div",
          {
            className: yn["syndication-source"],
            "data-testid": "syndication-source",
            children: [
              "Publicado originalmente en ",
              f.Name
            ]
          }
        ) : /* @__PURE__ */ T.jsxs("div", { className: yn.footer, children: [
          /* @__PURE__ */ T.jsx(
            "div",
            {
              className: yn[`review-helpfulness${O ? "-clicked" : j ? "-disable" : ""}`],
              "data-testid": `like${O || j ? "-disable" : ""}`,
              id: "review-helpful",
              onClick: oe,
              children: /* @__PURE__ */ T.jsx("div", { className: yn.helpfull })
            }
          ),
          /* @__PURE__ */ T.jsx(
            "div",
            {
              className: yn[`review-helpfulness${j ? "-clicked" : O ? "-disable" : ""}`],
              id: "review-not-helpful",
              onClick: Ie,
              "data-testid": `dislike${O || j ? "-disable" : ""}`,
              children: /* @__PURE__ */ T.jsx("div", { className: yn["not-helpfull"] })
            }
          ),
          _ > 0 ? /* @__PURE__ */ T.jsx(
            "div",
            {
              className: yn["helpfulness-text"],
              "data-testid": "helpfulness-text",
              children: _ === 1 ? ai.PERSON_FOUND_THIS_HELPFUL : `${_} ${ai.PEOPLE_FOUND_THIS_HELPFUL}`
            }
          ) : null
        ] })
      ]
    }
  );
}, i8e = "_column_1lnif_26", s8e = "_text_1lnif_50", po = {
  "user-reviews-container": "_user-reviews-container_1lnif_2",
  "user-reviews": "_user-reviews_1lnif_2",
  column: i8e,
  "more-comments-button": "_more-comments-button_1lnif_33",
  "so-com": "_so-com_1lnif_47",
  text: s8e
}, gN = () => {
  const e = window.innerWidth;
  return e < 768 ? "Mobile" : e >= 768 && e < 1024 ? "Tablet" : "Desktop";
}, l8e = (e) => {
  const r = {
    0: [],
    1: [],
    2: []
  };
  for (let n = 0; n < e.length; n++) {
    const a = n % 3;
    r[a].push(e[n]);
  }
  const t = [];
  for (let n = 0; n < 3; n++) {
    const a = r[n], i = /* @__PURE__ */ T.jsx("div", { className: po.column, "data-testid": "column", children: a.map((l, u) => /* @__PURE__ */ T.jsx("div", { "data-testid": "review", children: /* @__PURE__ */ T.jsx(_m, { review: l, type: "reviews-container" }) }, u)) });
    t.push(i);
  }
  return /* @__PURE__ */ T.jsx("div", { className: po["user-reviews"], children: t });
}, S8e = () => {
  const {
    userReviews: e,
    getMoreReviews: r,
    offset: t,
    totalComments: n = 0
  } = Ta(), { isSodimacStandAlone: a = !1 } = Co(), i = gN();
  return n > 0 ? i === "Desktop" ? /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: po["user-reviews-container"],
      "data-testid": "user-reviews-container",
      children: [
        e.length > 0 && l8e(e),
        n > 0 && t + 9 < n && /* @__PURE__ */ T.jsx(
          "button",
          {
            className: `${po["more-comments-button"]} ${a ? po["so-com"] : ""}`,
            "data-testid": "more-comments-button",
            id: "more-comments-button",
            onClick: r,
            children: /* @__PURE__ */ T.jsxs("div", { className: po.text, children: [
              " ",
              ai.VIEW_MORE_COMMENTS,
              " "
            ] })
          }
        )
      ]
    }
  ) : /* @__PURE__ */ T.jsxs(
    "div",
    {
      className: po["user-reviews-container"],
      "data-testid": "user-reviews-container",
      children: [
        e.length > 0 && /* @__PURE__ */ T.jsx("div", { className: po["user-reviews"], children: e.map((l) => /* @__PURE__ */ T.jsx(
          _m,
          {
            review: l,
            type: "reviews-container",
            "data-testid": "review"
          }
        )) }),
        n > 0 && t + 9 < n && /* @__PURE__ */ T.jsx(
          "div",
          {
            className: `${po["more-comments-button"]} ${a ? po["so-com"] : ""}`,
            "data-testid": "more-comments-button",
            onClick: r,
            children: /* @__PURE__ */ T.jsx("div", { className: po.text, children: ai.VIEW_MORE_COMMENTS })
          }
        )
      ]
    }
  ) : null;
}, u8e = "_photo_zwm6x_2", c8e = "_text_zwm6x_76", Gn = {
  "photos-chain": "_photos-chain_zwm6x_2",
  "photo-column": "_photo-column_zwm6x_9",
  "photo-wrapper": "_photo-wrapper_zwm6x_21",
  "photo-wrapper-even": "_photo-wrapper-even_zwm6x_38",
  "photo-wrapper-odd": "_photo-wrapper-odd_zwm6x_54",
  photo: u8e,
  text: c8e
}, d8e = ({ reviewsWithPhotos: e }) => {
  const r = e.flatMap(
    (u, c) => u.Photos.map((f) => wi(Xt({}, f), { reviewIndex: c }))
  ), [t, n] = Ye(!1), [a, i] = Ye(0), l = (u) => {
    i(u), document.body.classList.add("photo-modal-open"), n(!0);
  };
  return r.length <= 3 ? /* @__PURE__ */ T.jsx("div", { className: Gn["photos-chain"], "data-testid": "photos-chain-mosaic", children: /* @__PURE__ */ T.jsxs("div", { className: Gn["photo-column"], children: [
    r.map((u, c) => {
      var f, h;
      return /* @__PURE__ */ T.jsx(
        "div",
        {
          className: Gn["photo-wrapper"],
          onClick: () => l(c),
          id: `top-photos-photo-${c + 1}`,
          "data-testid": `no-mosaic-photo-${c}`,
          children: /* @__PURE__ */ T.jsx(L_, { children: /* @__PURE__ */ T.jsx(
            "img",
            {
              className: Gn.photo,
              loading: "lazy",
              src: (h = (f = u == null ? void 0 : u.Sizes) == null ? void 0 : f.normal) == null ? void 0 : h.Url
            }
          ) })
        },
        c
      );
    }),
    t && /* @__PURE__ */ T.jsx(
      V0,
      {
        reviewsWithPhotos: e,
        setModalOpen: n,
        photoIndex: a
      }
    )
  ] }) }) : /* @__PURE__ */ T.jsxs("div", { className: Gn["photos-chain"], "data-testid": "photos-chain-mosaic", children: [
    /* @__PURE__ */ T.jsx("div", { className: Gn["photo-column"], children: r.map((u, c) => {
      var f;
      if (c % 3 === 0)
        return /* @__PURE__ */ T.jsx("div", { className: Gn["photo-wrapper-odd"], children: /* @__PURE__ */ T.jsx(
          "div",
          {
            className: Gn["photo-wrapper"],
            onClick: () => l(c),
            id: `top-photos-photo-${c + 1}`,
            "data-testid": `mosaic-photo-${c}`,
            children: /* @__PURE__ */ T.jsx(
              "img",
              {
                className: Gn.photo,
                src: u.Sizes.normal.Url
              }
            )
          },
          c
        ) });
      if (c % 3 !== 2)
        return /* @__PURE__ */ T.jsxs("div", { className: Gn["photo-wrapper-even"], children: [
          /* @__PURE__ */ T.jsx(
            "div",
            {
              className: Gn["photo-wrapper"],
              onClick: () => l(c),
              id: `top-photos-photo-${c + 1}`,
              "data-testid": `mosaic-photo-${c}`,
              children: /* @__PURE__ */ T.jsx(
                "img",
                {
                  className: Gn.photo,
                  src: u == null ? void 0 : u.Sizes.normal.Url
                }
              )
            },
            c
          ),
          c + 1 < r.length && /* @__PURE__ */ T.jsx(
            "div",
            {
              className: Gn["photo-wrapper"],
              onClick: () => l(c + 1),
              id: `top-photos-photo-${c + 2}`,
              "data-testid": `mosaic-photo-${c + 1}`,
              children: /* @__PURE__ */ T.jsx(
                "img",
                {
                  className: Gn.photo,
                  src: (f = r[c + 1]) == null ? void 0 : f.Sizes.normal.Url
                }
              )
            },
            c
          )
        ] });
    }) }),
    t && /* @__PURE__ */ T.jsx(
      V0,
      {
        reviewsWithPhotos: e,
        setModalOpen: n,
        photoIndex: a
      }
    )
  ] });
}, x8e = () => {
  const { reviewsWithPhotos: e } = Ta();
  return e.length === 0 ? null : gN() === "Mobile" ? /* @__PURE__ */ T.jsx(T.Fragment, { children: /* @__PURE__ */ T.jsx(d8e, { reviewsWithPhotos: e }) }) : /* @__PURE__ */ T.jsx(T.Fragment, { children: /* @__PURE__ */ T.jsx(
    pN,
    {
      reviewsWithPhotos: e,
      limit: 4,
      type: "top-photos"
    }
  ) });
};
export {
  y8e as GiveRating,
  p8e as LabelToComment,
  g8e as RRProvider,
  m8e as RatingStars,
  b8e as ReviewMetricsPanel,
  S8e as Reviews,
  x8e as TopPhotos
};
